// @__NO_SIDE_EFFECTS__
function Zo(i) {
  const e = /* @__PURE__ */ Object.create(null);
  for (const t of i.split(",")) e[t] = 1;
  return (t) => t in e;
}
const Ge = {}, Dn = [], ji = () => {
}, Xm = () => !1, Wr = (i) => i.charCodeAt(0) === 111 && i.charCodeAt(1) === 110 && // uppercase letter
(i.charCodeAt(2) > 122 || i.charCodeAt(2) < 97), Qo = (i) => i.startsWith("onUpdate:"), mt = Object.assign, _u = (i, e) => {
  const t = i.indexOf(e);
  t > -1 && i.splice(t, 1);
}, Zm = Object.prototype.hasOwnProperty, Oe = (i, e) => Zm.call(i, e), ke = Array.isArray, Nn = (i) => Ns(i) === "[object Map]", qr = (i) => Ns(i) === "[object Set]", Xl = (i) => Ns(i) === "[object Date]", Ue = (i) => typeof i == "function", ot = (i) => typeof i == "string", ii = (i) => typeof i == "symbol", Ze = (i) => i !== null && typeof i == "object", Au = (i) => (Ze(i) || Ue(i)) && Ue(i.then) && Ue(i.catch), wu = Object.prototype.toString, Ns = (i) => wu.call(i), Qm = (i) => Ns(i).slice(8, -1), Yr = (i) => Ns(i) === "[object Object]", Jo = (i) => ot(i) && i !== "NaN" && i[0] !== "-" && "" + parseInt(i, 10) === i, ss = /* @__PURE__ */ Zo(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), Xr = (i) => {
  const e = /* @__PURE__ */ Object.create(null);
  return (t) => e[t] || (e[t] = i(t));
}, Jm = /-(\w)/g, _t = Xr(
  (i) => i.replace(Jm, (e, t) => t ? t.toUpperCase() : "")
), ep = /\B([A-Z])/g, qt = Xr(
  (i) => i.replace(ep, "-$1").toLowerCase()
), Zr = Xr((i) => i.charAt(0).toUpperCase() + i.slice(1)), Sa = Xr(
  (i) => i ? `on${Zr(i)}` : ""
), Wi = (i, e) => !Object.is(i, e), rr = (i, ...e) => {
  for (let t = 0; t < i.length; t++)
    i[t](...e);
}, co = (i, e, t, n = !1) => {
  Object.defineProperty(i, e, {
    configurable: !0,
    enumerable: !1,
    writable: n,
    value: t
  });
}, uo = (i) => {
  const e = parseFloat(i);
  return isNaN(e) ? i : e;
}, fo = (i) => {
  const e = ot(i) ? Number(i) : NaN;
  return isNaN(e) ? i : e;
};
let Zl;
const Qr = () => Zl || (Zl = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function We(i) {
  if (ke(i)) {
    const e = {};
    for (let t = 0; t < i.length; t++) {
      const n = i[t], s = ot(n) ? sp(n) : We(n);
      if (s)
        for (const r in s)
          e[r] = s[r];
    }
    return e;
  } else if (ot(i) || Ze(i))
    return i;
}
const tp = /;(?![^(]*\))/g, ip = /:([^]+)/, np = /\/\*[^]*?\*\//g;
function sp(i) {
  const e = {};
  return i.replace(np, "").split(tp).forEach((t) => {
    if (t) {
      const n = t.split(ip);
      n.length > 1 && (e[n[0].trim()] = n[1].trim());
    }
  }), e;
}
function Ke(i) {
  let e = "";
  if (ot(i))
    e = i;
  else if (ke(i))
    for (let t = 0; t < i.length; t++) {
      const n = Ke(i[t]);
      n && (e += n + " ");
    }
  else if (Ze(i))
    for (const t in i)
      i[t] && (e += t + " ");
  return e.trim();
}
const rp = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", ap = /* @__PURE__ */ Zo(rp);
function Lu(i) {
  return !!i || i === "";
}
function op(i, e) {
  if (i.length !== e.length) return !1;
  let t = !0;
  for (let n = 0; t && n < i.length; n++)
    t = Jr(i[n], e[n]);
  return t;
}
function Jr(i, e) {
  if (i === e) return !0;
  let t = Xl(i), n = Xl(e);
  if (t || n)
    return t && n ? i.getTime() === e.getTime() : !1;
  if (t = ii(i), n = ii(e), t || n)
    return i === e;
  if (t = ke(i), n = ke(e), t || n)
    return t && n ? op(i, e) : !1;
  if (t = Ze(i), n = Ze(e), t || n) {
    if (!t || !n)
      return !1;
    const s = Object.keys(i).length, r = Object.keys(e).length;
    if (s !== r)
      return !1;
    for (const a in i) {
      const o = i.hasOwnProperty(a), l = e.hasOwnProperty(a);
      if (o && !l || !o && l || !Jr(i[a], e[a]))
        return !1;
    }
  }
  return String(i) === String(e);
}
function Iu(i, e) {
  return i.findIndex((t) => Jr(t, e));
}
const Cu = (i) => !!(i && i.__v_isRef === !0), ie = (i) => ot(i) ? i : i == null ? "" : ke(i) || Ze(i) && (i.toString === wu || !Ue(i.toString)) ? Cu(i) ? ie(i.value) : JSON.stringify(i, Ru, 2) : String(i), Ru = (i, e) => Cu(e) ? Ru(i, e.value) : Nn(e) ? {
  [`Map(${e.size})`]: [...e.entries()].reduce(
    (t, [n, s], r) => (t[ka(n, r) + " =>"] = s, t),
    {}
  )
} : qr(e) ? {
  [`Set(${e.size})`]: [...e.values()].map((t) => ka(t))
} : ii(e) ? ka(e) : Ze(e) && !ke(e) && !Yr(e) ? String(e) : e, ka = (i, e = "") => {
  var t;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    ii(i) ? `Symbol(${(t = i.description) != null ? t : e})` : i
  );
};
let Ct;
class lp {
  constructor(e = !1) {
    this.detached = e, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = Ct, !e && Ct && (this.index = (Ct.scopes || (Ct.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let e, t;
      if (this.scopes)
        for (e = 0, t = this.scopes.length; e < t; e++)
          this.scopes[e].pause();
      for (e = 0, t = this.effects.length; e < t; e++)
        this.effects[e].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let e, t;
      if (this.scopes)
        for (e = 0, t = this.scopes.length; e < t; e++)
          this.scopes[e].resume();
      for (e = 0, t = this.effects.length; e < t; e++)
        this.effects[e].resume();
    }
  }
  run(e) {
    if (this._active) {
      const t = Ct;
      try {
        return Ct = this, e();
      } finally {
        Ct = t;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    ++this._on === 1 && (this.prevScope = Ct, Ct = this);
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    this._on > 0 && --this._on === 0 && (Ct = this.prevScope, this.prevScope = void 0);
  }
  stop(e) {
    if (this._active) {
      this._active = !1;
      let t, n;
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].stop();
      for (this.effects.length = 0, t = 0, n = this.cleanups.length; t < n; t++)
        this.cleanups[t]();
      if (this.cleanups.length = 0, this.scopes) {
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !e) {
        const s = this.parent.scopes.pop();
        s && s !== this && (this.parent.scopes[this.index] = s, s.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function dp() {
  return Ct;
}
let je;
const Ta = /* @__PURE__ */ new WeakSet();
class Pu {
  constructor(e) {
    this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, Ct && Ct.active && Ct.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, Ta.has(this) && (Ta.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || Nu(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, Ql(this), Mu(this);
    const e = je, t = ti;
    je = this, ti = !0;
    try {
      return this.fn();
    } finally {
      Ou(this), je = e, ti = t, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let e = this.deps; e; e = e.nextDep)
        il(e);
      this.deps = this.depsTail = void 0, Ql(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? Ta.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    ho(this) && this.run();
  }
  get dirty() {
    return ho(this);
  }
}
let Du = 0, rs, as;
function Nu(i, e = !1) {
  if (i.flags |= 8, e) {
    i.next = as, as = i;
    return;
  }
  i.next = rs, rs = i;
}
function el() {
  Du++;
}
function tl() {
  if (--Du > 0)
    return;
  if (as) {
    let e = as;
    for (as = void 0; e; ) {
      const t = e.next;
      e.next = void 0, e.flags &= -9, e = t;
    }
  }
  let i;
  for (; rs; ) {
    let e = rs;
    for (rs = void 0; e; ) {
      const t = e.next;
      if (e.next = void 0, e.flags &= -9, e.flags & 1)
        try {
          e.trigger();
        } catch (n) {
          i || (i = n);
        }
      e = t;
    }
  }
  if (i) throw i;
}
function Mu(i) {
  for (let e = i.deps; e; e = e.nextDep)
    e.version = -1, e.prevActiveLink = e.dep.activeLink, e.dep.activeLink = e;
}
function Ou(i) {
  let e, t = i.depsTail, n = t;
  for (; n; ) {
    const s = n.prevDep;
    n.version === -1 ? (n === t && (t = s), il(n), cp(n)) : e = n, n.dep.activeLink = n.prevActiveLink, n.prevActiveLink = void 0, n = s;
  }
  i.deps = e, i.depsTail = t;
}
function ho(i) {
  for (let e = i.deps; e; e = e.nextDep)
    if (e.dep.version !== e.version || e.dep.computed && (Fu(e.dep.computed) || e.dep.version !== e.version))
      return !0;
  return !!i._dirty;
}
function Fu(i) {
  if (i.flags & 4 && !(i.flags & 16) || (i.flags &= -17, i.globalVersion === ps) || (i.globalVersion = ps, !i.isSSR && i.flags & 128 && (!i.deps && !i._dirty || !ho(i))))
    return;
  i.flags |= 2;
  const e = i.dep, t = je, n = ti;
  je = i, ti = !0;
  try {
    Mu(i);
    const s = i.fn(i._value);
    (e.version === 0 || Wi(s, i._value)) && (i.flags |= 128, i._value = s, e.version++);
  } catch (s) {
    throw e.version++, s;
  } finally {
    je = t, ti = n, Ou(i), i.flags &= -3;
  }
}
function il(i, e = !1) {
  const { dep: t, prevSub: n, nextSub: s } = i;
  if (n && (n.nextSub = s, i.prevSub = void 0), s && (s.prevSub = n, i.nextSub = void 0), t.subs === i && (t.subs = n, !n && t.computed)) {
    t.computed.flags &= -5;
    for (let r = t.computed.deps; r; r = r.nextDep)
      il(r, !0);
  }
  !e && !--t.sc && t.map && t.map.delete(t.key);
}
function cp(i) {
  const { prevDep: e, nextDep: t } = i;
  e && (e.nextDep = t, i.prevDep = void 0), t && (t.prevDep = e, i.nextDep = void 0);
}
let ti = !0;
const $u = [];
function Yi() {
  $u.push(ti), ti = !1;
}
function Xi() {
  const i = $u.pop();
  ti = i === void 0 ? !0 : i;
}
function Ql(i) {
  const { cleanup: e } = i;
  if (i.cleanup = void 0, e) {
    const t = je;
    je = void 0;
    try {
      e();
    } finally {
      je = t;
    }
  }
}
let ps = 0;
class up {
  constructor(e, t) {
    this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class nl {
  // TODO isolatedDeclarations "__v_skip"
  constructor(e) {
    this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0;
  }
  track(e) {
    if (!je || !ti || je === this.computed)
      return;
    let t = this.activeLink;
    if (t === void 0 || t.sub !== je)
      t = this.activeLink = new up(je, this), je.deps ? (t.prevDep = je.depsTail, je.depsTail.nextDep = t, je.depsTail = t) : je.deps = je.depsTail = t, Bu(t);
    else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
      const n = t.nextDep;
      n.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = n), t.prevDep = je.depsTail, t.nextDep = void 0, je.depsTail.nextDep = t, je.depsTail = t, je.deps === t && (je.deps = n);
    }
    return t;
  }
  trigger(e) {
    this.version++, ps++, this.notify(e);
  }
  notify(e) {
    el();
    try {
      for (let t = this.subs; t; t = t.prevSub)
        t.sub.notify() && t.sub.dep.notify();
    } finally {
      tl();
    }
  }
}
function Bu(i) {
  if (i.dep.sc++, i.sub.flags & 4) {
    const e = i.dep.computed;
    if (e && !i.dep.subs) {
      e.flags |= 20;
      for (let n = e.deps; n; n = n.nextDep)
        Bu(n);
    }
    const t = i.dep.subs;
    t !== i && (i.prevSub = t, t && (t.nextSub = i)), i.dep.subs = i;
  }
}
const mo = /* @__PURE__ */ new WeakMap(), vn = Symbol(
  ""
), po = Symbol(
  ""
), gs = Symbol(
  ""
);
function yt(i, e, t) {
  if (ti && je) {
    let n = mo.get(i);
    n || mo.set(i, n = /* @__PURE__ */ new Map());
    let s = n.get(t);
    s || (n.set(t, s = new nl()), s.map = n, s.key = t), s.track();
  }
}
function Ci(i, e, t, n, s, r) {
  const a = mo.get(i);
  if (!a) {
    ps++;
    return;
  }
  const o = (l) => {
    l && l.trigger();
  };
  if (el(), e === "clear")
    a.forEach(o);
  else {
    const l = ke(i), d = l && Jo(t);
    if (l && t === "length") {
      const c = Number(n);
      a.forEach((u, f) => {
        (f === "length" || f === gs || !ii(f) && f >= c) && o(u);
      });
    } else
      switch ((t !== void 0 || a.has(void 0)) && o(a.get(t)), d && o(a.get(gs)), e) {
        case "add":
          l ? d && o(a.get("length")) : (o(a.get(vn)), Nn(i) && o(a.get(po)));
          break;
        case "delete":
          l || (o(a.get(vn)), Nn(i) && o(a.get(po)));
          break;
        case "set":
          Nn(i) && o(a.get(vn));
          break;
      }
  }
  tl();
}
function xn(i) {
  const e = Me(i);
  return e === i ? e : (yt(e, "iterate", gs), Xt(i) ? e : e.map(ht));
}
function ea(i) {
  return yt(i = Me(i), "iterate", gs), i;
}
const fp = {
  __proto__: null,
  [Symbol.iterator]() {
    return Ea(this, Symbol.iterator, ht);
  },
  concat(...i) {
    return xn(this).concat(
      ...i.map((e) => ke(e) ? xn(e) : e)
    );
  },
  entries() {
    return Ea(this, "entries", (i) => (i[1] = ht(i[1]), i));
  },
  every(i, e) {
    return Si(this, "every", i, e, void 0, arguments);
  },
  filter(i, e) {
    return Si(this, "filter", i, e, (t) => t.map(ht), arguments);
  },
  find(i, e) {
    return Si(this, "find", i, e, ht, arguments);
  },
  findIndex(i, e) {
    return Si(this, "findIndex", i, e, void 0, arguments);
  },
  findLast(i, e) {
    return Si(this, "findLast", i, e, ht, arguments);
  },
  findLastIndex(i, e) {
    return Si(this, "findLastIndex", i, e, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(i, e) {
    return Si(this, "forEach", i, e, void 0, arguments);
  },
  includes(...i) {
    return xa(this, "includes", i);
  },
  indexOf(...i) {
    return xa(this, "indexOf", i);
  },
  join(i) {
    return xn(this).join(i);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...i) {
    return xa(this, "lastIndexOf", i);
  },
  map(i, e) {
    return Si(this, "map", i, e, void 0, arguments);
  },
  pop() {
    return Xn(this, "pop");
  },
  push(...i) {
    return Xn(this, "push", i);
  },
  reduce(i, ...e) {
    return Jl(this, "reduce", i, e);
  },
  reduceRight(i, ...e) {
    return Jl(this, "reduceRight", i, e);
  },
  shift() {
    return Xn(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(i, e) {
    return Si(this, "some", i, e, void 0, arguments);
  },
  splice(...i) {
    return Xn(this, "splice", i);
  },
  toReversed() {
    return xn(this).toReversed();
  },
  toSorted(i) {
    return xn(this).toSorted(i);
  },
  toSpliced(...i) {
    return xn(this).toSpliced(...i);
  },
  unshift(...i) {
    return Xn(this, "unshift", i);
  },
  values() {
    return Ea(this, "values", ht);
  }
};
function Ea(i, e, t) {
  const n = ea(i), s = n[e]();
  return n !== i && !Xt(i) && (s._next = s.next, s.next = () => {
    const r = s._next();
    return r.value && (r.value = t(r.value)), r;
  }), s;
}
const hp = Array.prototype;
function Si(i, e, t, n, s, r) {
  const a = ea(i), o = a !== i && !Xt(i), l = a[e];
  if (l !== hp[e]) {
    const u = l.apply(i, r);
    return o ? ht(u) : u;
  }
  let d = t;
  a !== i && (o ? d = function(u, f) {
    return t.call(this, ht(u), f, i);
  } : t.length > 2 && (d = function(u, f) {
    return t.call(this, u, f, i);
  }));
  const c = l.call(a, d, n);
  return o && s ? s(c) : c;
}
function Jl(i, e, t, n) {
  const s = ea(i);
  let r = t;
  return s !== i && (Xt(i) ? t.length > 3 && (r = function(a, o, l) {
    return t.call(this, a, o, l, i);
  }) : r = function(a, o, l) {
    return t.call(this, a, ht(o), l, i);
  }), s[e](r, ...n);
}
function xa(i, e, t) {
  const n = Me(i);
  yt(n, "iterate", gs);
  const s = n[e](...t);
  return (s === -1 || s === !1) && al(t[0]) ? (t[0] = Me(t[0]), n[e](...t)) : s;
}
function Xn(i, e, t = []) {
  Yi(), el();
  const n = Me(i)[e].apply(i, t);
  return tl(), Xi(), n;
}
const mp = /* @__PURE__ */ Zo("__proto__,__v_isRef,__isVue"), Uu = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((i) => i !== "arguments" && i !== "caller").map((i) => Symbol[i]).filter(ii)
);
function pp(i) {
  ii(i) || (i = String(i));
  const e = Me(this);
  return yt(e, "has", i), e.hasOwnProperty(i);
}
class Vu {
  constructor(e = !1, t = !1) {
    this._isReadonly = e, this._isShallow = t;
  }
  get(e, t, n) {
    if (t === "__v_skip") return e.__v_skip;
    const s = this._isReadonly, r = this._isShallow;
    if (t === "__v_isReactive")
      return !s;
    if (t === "__v_isReadonly")
      return s;
    if (t === "__v_isShallow")
      return r;
    if (t === "__v_raw")
      return n === (s ? r ? _p : Ku : r ? zu : Hu).get(e) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(e) === Object.getPrototypeOf(n) ? e : void 0;
    const a = ke(e);
    if (!s) {
      let l;
      if (a && (l = fp[t]))
        return l;
      if (t === "hasOwnProperty")
        return pp;
    }
    const o = Reflect.get(
      e,
      t,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      At(e) ? e : n
    );
    return (ii(t) ? Uu.has(t) : mp(t)) || (s || yt(e, "get", t), r) ? o : At(o) ? a && Jo(t) ? o : o.value : Ze(o) ? s ? ju(o) : Zi(o) : o;
  }
}
class Gu extends Vu {
  constructor(e = !1) {
    super(!1, e);
  }
  set(e, t, n, s) {
    let r = e[t];
    if (!this._isShallow) {
      const l = Qi(r);
      if (!Xt(n) && !Qi(n) && (r = Me(r), n = Me(n)), !ke(e) && At(r) && !At(n))
        return l ? !1 : (r.value = n, !0);
    }
    const a = ke(e) && Jo(t) ? Number(t) < e.length : Oe(e, t), o = Reflect.set(
      e,
      t,
      n,
      At(e) ? e : s
    );
    return e === Me(s) && (a ? Wi(n, r) && Ci(e, "set", t, n) : Ci(e, "add", t, n)), o;
  }
  deleteProperty(e, t) {
    const n = Oe(e, t), s = Reflect.deleteProperty(e, t);
    return s && n && Ci(e, "delete", t, void 0), s;
  }
  has(e, t) {
    const n = Reflect.has(e, t);
    return (!ii(t) || !Uu.has(t)) && yt(e, "has", t), n;
  }
  ownKeys(e) {
    return yt(
      e,
      "iterate",
      ke(e) ? "length" : vn
    ), Reflect.ownKeys(e);
  }
}
class gp extends Vu {
  constructor(e = !1) {
    super(!0, e);
  }
  set(e, t) {
    return !0;
  }
  deleteProperty(e, t) {
    return !0;
  }
}
const vp = /* @__PURE__ */ new Gu(), yp = /* @__PURE__ */ new gp(), bp = /* @__PURE__ */ new Gu(!0), go = (i) => i, Bs = (i) => Reflect.getPrototypeOf(i);
function Sp(i, e, t) {
  return function(...n) {
    const s = this.__v_raw, r = Me(s), a = Nn(r), o = i === "entries" || i === Symbol.iterator && a, l = i === "keys" && a, d = s[i](...n), c = t ? go : e ? br : ht;
    return !e && yt(
      r,
      "iterate",
      l ? po : vn
    ), {
      // iterator protocol
      next() {
        const { value: u, done: f } = d.next();
        return f ? { value: u, done: f } : {
          value: o ? [c(u[0]), c(u[1])] : c(u),
          done: f
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function Us(i) {
  return function(...e) {
    return i === "delete" ? !1 : i === "clear" ? void 0 : this;
  };
}
function kp(i, e) {
  const t = {
    get(s) {
      const r = this.__v_raw, a = Me(r), o = Me(s);
      i || (Wi(s, o) && yt(a, "get", s), yt(a, "get", o));
      const { has: l } = Bs(a), d = e ? go : i ? br : ht;
      if (l.call(a, s))
        return d(r.get(s));
      if (l.call(a, o))
        return d(r.get(o));
      r !== a && r.get(s);
    },
    get size() {
      const s = this.__v_raw;
      return !i && yt(Me(s), "iterate", vn), Reflect.get(s, "size", s);
    },
    has(s) {
      const r = this.__v_raw, a = Me(r), o = Me(s);
      return i || (Wi(s, o) && yt(a, "has", s), yt(a, "has", o)), s === o ? r.has(s) : r.has(s) || r.has(o);
    },
    forEach(s, r) {
      const a = this, o = a.__v_raw, l = Me(o), d = e ? go : i ? br : ht;
      return !i && yt(l, "iterate", vn), o.forEach((c, u) => s.call(r, d(c), d(u), a));
    }
  };
  return mt(
    t,
    i ? {
      add: Us("add"),
      set: Us("set"),
      delete: Us("delete"),
      clear: Us("clear")
    } : {
      add(s) {
        !e && !Xt(s) && !Qi(s) && (s = Me(s));
        const r = Me(this);
        return Bs(r).has.call(r, s) || (r.add(s), Ci(r, "add", s, s)), this;
      },
      set(s, r) {
        !e && !Xt(r) && !Qi(r) && (r = Me(r));
        const a = Me(this), { has: o, get: l } = Bs(a);
        let d = o.call(a, s);
        d || (s = Me(s), d = o.call(a, s));
        const c = l.call(a, s);
        return a.set(s, r), d ? Wi(r, c) && Ci(a, "set", s, r) : Ci(a, "add", s, r), this;
      },
      delete(s) {
        const r = Me(this), { has: a, get: o } = Bs(r);
        let l = a.call(r, s);
        l || (s = Me(s), l = a.call(r, s)), o && o.call(r, s);
        const d = r.delete(s);
        return l && Ci(r, "delete", s, void 0), d;
      },
      clear() {
        const s = Me(this), r = s.size !== 0, a = s.clear();
        return r && Ci(
          s,
          "clear",
          void 0,
          void 0
        ), a;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((s) => {
    t[s] = Sp(s, i, e);
  }), t;
}
function sl(i, e) {
  const t = kp(i, e);
  return (n, s, r) => s === "__v_isReactive" ? !i : s === "__v_isReadonly" ? i : s === "__v_raw" ? n : Reflect.get(
    Oe(t, s) && s in n ? t : n,
    s,
    r
  );
}
const Tp = {
  get: /* @__PURE__ */ sl(!1, !1)
}, Ep = {
  get: /* @__PURE__ */ sl(!1, !0)
}, xp = {
  get: /* @__PURE__ */ sl(!0, !1)
}, Hu = /* @__PURE__ */ new WeakMap(), zu = /* @__PURE__ */ new WeakMap(), Ku = /* @__PURE__ */ new WeakMap(), _p = /* @__PURE__ */ new WeakMap();
function Ap(i) {
  switch (i) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function wp(i) {
  return i.__v_skip || !Object.isExtensible(i) ? 0 : Ap(Qm(i));
}
function Zi(i) {
  return Qi(i) ? i : rl(
    i,
    !1,
    vp,
    Tp,
    Hu
  );
}
function Lp(i) {
  return rl(
    i,
    !1,
    bp,
    Ep,
    zu
  );
}
function ju(i) {
  return rl(
    i,
    !0,
    yp,
    xp,
    Ku
  );
}
function rl(i, e, t, n, s) {
  if (!Ze(i) || i.__v_raw && !(e && i.__v_isReactive))
    return i;
  const r = wp(i);
  if (r === 0)
    return i;
  const a = s.get(i);
  if (a)
    return a;
  const o = new Proxy(
    i,
    r === 2 ? n : t
  );
  return s.set(i, o), o;
}
function Mn(i) {
  return Qi(i) ? Mn(i.__v_raw) : !!(i && i.__v_isReactive);
}
function Qi(i) {
  return !!(i && i.__v_isReadonly);
}
function Xt(i) {
  return !!(i && i.__v_isShallow);
}
function al(i) {
  return i ? !!i.__v_raw : !1;
}
function Me(i) {
  const e = i && i.__v_raw;
  return e ? Me(e) : i;
}
function Ip(i) {
  return !Oe(i, "__v_skip") && Object.isExtensible(i) && co(i, "__v_skip", !0), i;
}
const ht = (i) => Ze(i) ? Zi(i) : i, br = (i) => Ze(i) ? ju(i) : i;
function At(i) {
  return i ? i.__v_isRef === !0 : !1;
}
function ge(i) {
  return Wu(i, !1);
}
function Cp(i) {
  return Wu(i, !0);
}
function Wu(i, e) {
  return At(i) ? i : new Rp(i, e);
}
class Rp {
  constructor(e, t) {
    this.dep = new nl(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = t ? e : Me(e), this._value = t ? e : ht(e), this.__v_isShallow = t;
  }
  get value() {
    return this.dep.track(), this._value;
  }
  set value(e) {
    const t = this._rawValue, n = this.__v_isShallow || Xt(e) || Qi(e);
    e = n ? e : Me(e), Wi(e, t) && (this._rawValue = e, this._value = n ? e : ht(e), this.dep.trigger());
  }
}
function L(i) {
  return At(i) ? i.value : i;
}
const Pp = {
  get: (i, e, t) => e === "__v_raw" ? i : L(Reflect.get(i, e, t)),
  set: (i, e, t, n) => {
    const s = i[e];
    return At(s) && !At(t) ? (s.value = t, !0) : Reflect.set(i, e, t, n);
  }
};
function qu(i) {
  return Mn(i) ? i : new Proxy(i, Pp);
}
class Dp {
  constructor(e, t, n) {
    this.fn = e, this.setter = t, this._value = void 0, this.dep = new nl(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = ps - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !t, this.isSSR = n;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    je !== this)
      return Nu(this, !0), !0;
  }
  get value() {
    const e = this.dep.track();
    return Fu(this), e && (e.version = this.dep.version), this._value;
  }
  set value(e) {
    this.setter && this.setter(e);
  }
}
function Np(i, e, t = !1) {
  let n, s;
  return Ue(i) ? n = i : (n = i.get, s = i.set), new Dp(n, s, t);
}
const Vs = {}, Sr = /* @__PURE__ */ new WeakMap();
let fn;
function Mp(i, e = !1, t = fn) {
  if (t) {
    let n = Sr.get(t);
    n || Sr.set(t, n = []), n.push(i);
  }
}
function Op(i, e, t = Ge) {
  const { immediate: n, deep: s, once: r, scheduler: a, augmentJob: o, call: l } = t, d = (k) => s ? k : Xt(k) || s === !1 || s === 0 ? Ri(k, 1) : Ri(k);
  let c, u, f, h, m = !1, g = !1;
  if (At(i) ? (u = () => i.value, m = Xt(i)) : Mn(i) ? (u = () => d(i), m = !0) : ke(i) ? (g = !0, m = i.some((k) => Mn(k) || Xt(k)), u = () => i.map((k) => {
    if (At(k))
      return k.value;
    if (Mn(k))
      return d(k);
    if (Ue(k))
      return l ? l(k, 2) : k();
  })) : Ue(i) ? e ? u = l ? () => l(i, 2) : i : u = () => {
    if (f) {
      Yi();
      try {
        f();
      } finally {
        Xi();
      }
    }
    const k = fn;
    fn = c;
    try {
      return l ? l(i, 3, [h]) : i(h);
    } finally {
      fn = k;
    }
  } : u = ji, e && s) {
    const k = u, T = s === !0 ? 1 / 0 : s;
    u = () => Ri(k(), T);
  }
  const v = dp(), p = () => {
    c.stop(), v && v.active && _u(v.effects, c);
  };
  if (r && e) {
    const k = e;
    e = (...T) => {
      k(...T), p();
    };
  }
  let y = g ? new Array(i.length).fill(Vs) : Vs;
  const b = (k) => {
    if (!(!(c.flags & 1) || !c.dirty && !k))
      if (e) {
        const T = c.run();
        if (s || m || (g ? T.some((I, x) => Wi(I, y[x])) : Wi(T, y))) {
          f && f();
          const I = fn;
          fn = c;
          try {
            const x = [
              T,
              // pass undefined as the old value when it's changed for the first time
              y === Vs ? void 0 : g && y[0] === Vs ? [] : y,
              h
            ];
            y = T, l ? l(e, 3, x) : (
              // @ts-expect-error
              e(...x)
            );
          } finally {
            fn = I;
          }
        }
      } else
        c.run();
  };
  return o && o(b), c = new Pu(u), c.scheduler = a ? () => a(b, !1) : b, h = (k) => Mp(k, !1, c), f = c.onStop = () => {
    const k = Sr.get(c);
    if (k) {
      if (l)
        l(k, 4);
      else
        for (const T of k) T();
      Sr.delete(c);
    }
  }, e ? n ? b(!0) : y = c.run() : a ? a(b.bind(null, !0), !0) : c.run(), p.pause = c.pause.bind(c), p.resume = c.resume.bind(c), p.stop = p, p;
}
function Ri(i, e = 1 / 0, t) {
  if (e <= 0 || !Ze(i) || i.__v_skip || (t = t || /* @__PURE__ */ new Set(), t.has(i)))
    return i;
  if (t.add(i), e--, At(i))
    Ri(i.value, e, t);
  else if (ke(i))
    for (let n = 0; n < i.length; n++)
      Ri(i[n], e, t);
  else if (qr(i) || Nn(i))
    i.forEach((n) => {
      Ri(n, e, t);
    });
  else if (Yr(i)) {
    for (const n in i)
      Ri(i[n], e, t);
    for (const n of Object.getOwnPropertySymbols(i))
      Object.prototype.propertyIsEnumerable.call(i, n) && Ri(i[n], e, t);
  }
  return i;
}
function Ms(i, e, t, n) {
  try {
    return n ? i(...n) : i();
  } catch (s) {
    ta(s, e, t);
  }
}
function gi(i, e, t, n) {
  if (Ue(i)) {
    const s = Ms(i, e, t, n);
    return s && Au(s) && s.catch((r) => {
      ta(r, e, t);
    }), s;
  }
  if (ke(i)) {
    const s = [];
    for (let r = 0; r < i.length; r++)
      s.push(gi(i[r], e, t, n));
    return s;
  }
}
function ta(i, e, t, n = !0) {
  const s = e ? e.vnode : null, { errorHandler: r, throwUnhandledErrorInProduction: a } = e && e.appContext.config || Ge;
  if (e) {
    let o = e.parent;
    const l = e.proxy, d = `https://vuejs.org/error-reference/#runtime-${t}`;
    for (; o; ) {
      const c = o.ec;
      if (c) {
        for (let u = 0; u < c.length; u++)
          if (c[u](i, l, d) === !1)
            return;
      }
      o = o.parent;
    }
    if (r) {
      Yi(), Ms(r, null, 10, [
        i,
        l,
        d
      ]), Xi();
      return;
    }
  }
  Fp(i, t, s, n, a);
}
function Fp(i, e, t, n = !0, s = !1) {
  if (s)
    throw i;
  console.error(i);
}
const Et = [];
let li = -1;
const On = [];
let Bi = null, In = 0;
const Yu = /* @__PURE__ */ Promise.resolve();
let kr = null;
function Gt(i) {
  const e = kr || Yu;
  return i ? e.then(this ? i.bind(this) : i) : e;
}
function $p(i) {
  let e = li + 1, t = Et.length;
  for (; e < t; ) {
    const n = e + t >>> 1, s = Et[n], r = vs(s);
    r < i || r === i && s.flags & 2 ? e = n + 1 : t = n;
  }
  return e;
}
function ol(i) {
  if (!(i.flags & 1)) {
    const e = vs(i), t = Et[Et.length - 1];
    !t || // fast path when the job id is larger than the tail
    !(i.flags & 2) && e >= vs(t) ? Et.push(i) : Et.splice($p(e), 0, i), i.flags |= 1, Xu();
  }
}
function Xu() {
  kr || (kr = Yu.then(Ju));
}
function Zu(i) {
  ke(i) ? On.push(...i) : Bi && i.id === -1 ? Bi.splice(In + 1, 0, i) : i.flags & 1 || (On.push(i), i.flags |= 1), Xu();
}
function ed(i, e, t = li + 1) {
  for (; t < Et.length; t++) {
    const n = Et[t];
    if (n && n.flags & 2) {
      if (i && n.id !== i.uid)
        continue;
      Et.splice(t, 1), t--, n.flags & 4 && (n.flags &= -2), n(), n.flags & 4 || (n.flags &= -2);
    }
  }
}
function Qu(i) {
  if (On.length) {
    const e = [...new Set(On)].sort(
      (t, n) => vs(t) - vs(n)
    );
    if (On.length = 0, Bi) {
      Bi.push(...e);
      return;
    }
    for (Bi = e, In = 0; In < Bi.length; In++) {
      const t = Bi[In];
      t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2;
    }
    Bi = null, In = 0;
  }
}
const vs = (i) => i.id == null ? i.flags & 2 ? -1 : 1 / 0 : i.id;
function Ju(i) {
  try {
    for (li = 0; li < Et.length; li++) {
      const e = Et[li];
      e && !(e.flags & 8) && (e.flags & 4 && (e.flags &= -2), Ms(
        e,
        e.i,
        e.i ? 15 : 14
      ), e.flags & 4 || (e.flags &= -2));
    }
  } finally {
    for (; li < Et.length; li++) {
      const e = Et[li];
      e && (e.flags &= -2);
    }
    li = -1, Et.length = 0, Qu(), kr = null, (Et.length || On.length) && Ju();
  }
}
let ft = null, ef = null;
function Tr(i) {
  const e = ft;
  return ft = i, ef = i && i.type.__scopeId || null, e;
}
function Xe(i, e = ft, t) {
  if (!e || i._n)
    return i;
  const n = (...s) => {
    n._d && od(-1);
    const r = Tr(e);
    let a;
    try {
      a = i(...s);
    } finally {
      Tr(r), n._d && od(1);
    }
    return a;
  };
  return n._n = !0, n._c = !0, n._d = !0, n;
}
function ar(i, e) {
  if (ft === null)
    return i;
  const t = aa(ft), n = i.dirs || (i.dirs = []);
  for (let s = 0; s < e.length; s++) {
    let [r, a, o, l = Ge] = e[s];
    r && (Ue(r) && (r = {
      mounted: r,
      updated: r
    }), r.deep && Ri(a), n.push({
      dir: r,
      instance: t,
      value: a,
      oldValue: void 0,
      arg: o,
      modifiers: l
    }));
  }
  return i;
}
function an(i, e, t, n) {
  const s = i.dirs, r = e && e.dirs;
  for (let a = 0; a < s.length; a++) {
    const o = s[a];
    r && (o.oldValue = r[a].value);
    let l = o.dir[n];
    l && (Yi(), gi(l, t, 8, [
      i.el,
      o,
      i,
      e
    ]), Xi());
  }
}
const Bp = Symbol("_vte"), tf = (i) => i.__isTeleport, Ui = Symbol("_leaveCb"), Gs = Symbol("_enterCb");
function Up() {
  const i = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return wt(() => {
    i.isMounted = !0;
  }), Fs(() => {
    i.isUnmounting = !0;
  }), i;
}
const zt = [Function, Array], nf = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: zt,
  onEnter: zt,
  onAfterEnter: zt,
  onEnterCancelled: zt,
  // leave
  onBeforeLeave: zt,
  onLeave: zt,
  onAfterLeave: zt,
  onLeaveCancelled: zt,
  // appear
  onBeforeAppear: zt,
  onAppear: zt,
  onAfterAppear: zt,
  onAppearCancelled: zt
}, sf = (i) => {
  const e = i.subTree;
  return e.component ? sf(e.component) : e;
}, Vp = {
  name: "BaseTransition",
  props: nf,
  setup(i, { slots: e }) {
    const t = fl(), n = Up();
    return () => {
      const s = e.default && of(e.default(), !0);
      if (!s || !s.length)
        return;
      const r = rf(s), a = Me(i), { mode: o } = a;
      if (n.isLeaving)
        return _a(r);
      const l = td(r);
      if (!l)
        return _a(r);
      let d = vo(
        l,
        a,
        n,
        t,
        // #11061, ensure enterHooks is fresh after clone
        (u) => d = u
      );
      l.type !== bt && ys(l, d);
      let c = t.subTree && td(t.subTree);
      if (c && c.type !== bt && !mn(l, c) && sf(t).type !== bt) {
        let u = vo(
          c,
          a,
          n,
          t
        );
        if (ys(c, u), o === "out-in" && l.type !== bt)
          return n.isLeaving = !0, u.afterLeave = () => {
            n.isLeaving = !1, t.job.flags & 8 || t.update(), delete u.afterLeave, c = void 0;
          }, _a(r);
        o === "in-out" && l.type !== bt ? u.delayLeave = (f, h, m) => {
          const g = af(
            n,
            c
          );
          g[String(c.key)] = c, f[Ui] = () => {
            h(), f[Ui] = void 0, delete d.delayedLeave, c = void 0;
          }, d.delayedLeave = () => {
            m(), delete d.delayedLeave, c = void 0;
          };
        } : c = void 0;
      } else c && (c = void 0);
      return r;
    };
  }
};
function rf(i) {
  let e = i[0];
  if (i.length > 1) {
    for (const t of i)
      if (t.type !== bt) {
        e = t;
        break;
      }
  }
  return e;
}
const Gp = Vp;
function af(i, e) {
  const { leavingVNodes: t } = i;
  let n = t.get(e.type);
  return n || (n = /* @__PURE__ */ Object.create(null), t.set(e.type, n)), n;
}
function vo(i, e, t, n, s) {
  const {
    appear: r,
    mode: a,
    persisted: o = !1,
    onBeforeEnter: l,
    onEnter: d,
    onAfterEnter: c,
    onEnterCancelled: u,
    onBeforeLeave: f,
    onLeave: h,
    onAfterLeave: m,
    onLeaveCancelled: g,
    onBeforeAppear: v,
    onAppear: p,
    onAfterAppear: y,
    onAppearCancelled: b
  } = e, k = String(i.key), T = af(t, i), I = (R, A) => {
    R && gi(
      R,
      n,
      9,
      A
    );
  }, x = (R, A) => {
    const _ = A[1];
    I(R, A), ke(R) ? R.every((C) => C.length <= 1) && _() : R.length <= 1 && _();
  }, E = {
    mode: a,
    persisted: o,
    beforeEnter(R) {
      let A = l;
      if (!t.isMounted)
        if (r)
          A = v || l;
        else
          return;
      R[Ui] && R[Ui](
        !0
        /* cancelled */
      );
      const _ = T[k];
      _ && mn(i, _) && _.el[Ui] && _.el[Ui](), I(A, [R]);
    },
    enter(R) {
      let A = d, _ = c, C = u;
      if (!t.isMounted)
        if (r)
          A = p || d, _ = y || c, C = b || u;
        else
          return;
      let O = !1;
      const V = R[Gs] = (j) => {
        O || (O = !0, j ? I(C, [R]) : I(_, [R]), E.delayedLeave && E.delayedLeave(), R[Gs] = void 0);
      };
      A ? x(A, [R, V]) : V();
    },
    leave(R, A) {
      const _ = String(i.key);
      if (R[Gs] && R[Gs](
        !0
        /* cancelled */
      ), t.isUnmounting)
        return A();
      I(f, [R]);
      let C = !1;
      const O = R[Ui] = (V) => {
        C || (C = !0, A(), V ? I(g, [R]) : I(m, [R]), R[Ui] = void 0, T[_] === i && delete T[_]);
      };
      T[_] = i, h ? x(h, [R, O]) : O();
    },
    clone(R) {
      const A = vo(
        R,
        e,
        t,
        n,
        s
      );
      return s && s(A), A;
    }
  };
  return E;
}
function _a(i) {
  if (ll(i))
    return i = Ji(i), i.children = null, i;
}
function td(i) {
  if (!ll(i))
    return tf(i.type) && i.children ? rf(i.children) : i;
  if (i.component)
    return i.component.subTree;
  const { shapeFlag: e, children: t } = i;
  if (t) {
    if (e & 16)
      return t[0];
    if (e & 32 && Ue(t.default))
      return t.default();
  }
}
function ys(i, e) {
  i.shapeFlag & 6 && i.component ? (i.transition = e, ys(i.component.subTree, e)) : i.shapeFlag & 128 ? (i.ssContent.transition = e.clone(i.ssContent), i.ssFallback.transition = e.clone(i.ssFallback)) : i.transition = e;
}
function of(i, e = !1, t) {
  let n = [], s = 0;
  for (let r = 0; r < i.length; r++) {
    let a = i[r];
    const o = t == null ? a.key : String(t) + String(a.key != null ? a.key : r);
    a.type === ve ? (a.patchFlag & 128 && s++, n = n.concat(
      of(a.children, e, o)
    )) : (e || a.type !== bt) && n.push(o != null ? Ji(a, { key: o }) : a);
  }
  if (s > 1)
    for (let r = 0; r < n.length; r++)
      n[r].patchFlag = -2;
  return n;
}
// @__NO_SIDE_EFFECTS__
function Re(i, e) {
  return Ue(i) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    mt({ name: i.name }, e, { setup: i })
  ) : i;
}
function Hp(i) {
  i.ids = [i.ids[0] + i.ids[2]++ + "-", 0, 0];
}
function bs(i) {
  const e = fl(), t = Cp(null);
  if (e) {
    const s = e.refs === Ge ? e.refs = {} : e.refs;
    Object.defineProperty(s, i, {
      enumerable: !0,
      get: () => t.value,
      set: (r) => t.value = r
    });
  }
  return t;
}
function os(i, e, t, n, s = !1) {
  if (ke(i)) {
    i.forEach(
      (m, g) => os(
        m,
        e && (ke(e) ? e[g] : e),
        t,
        n,
        s
      )
    );
    return;
  }
  if (Fn(n) && !s) {
    n.shapeFlag & 512 && n.type.__asyncResolved && n.component.subTree.component && os(i, e, t, n.component.subTree);
    return;
  }
  const r = n.shapeFlag & 4 ? aa(n.component) : n.el, a = s ? null : r, { i: o, r: l } = i, d = e && e.r, c = o.refs === Ge ? o.refs = {} : o.refs, u = o.setupState, f = Me(u), h = u === Ge ? () => !1 : (m) => Oe(f, m);
  if (d != null && d !== l && (ot(d) ? (c[d] = null, h(d) && (u[d] = null)) : At(d) && (d.value = null)), Ue(l))
    Ms(l, o, 12, [a, c]);
  else {
    const m = ot(l), g = At(l);
    if (m || g) {
      const v = () => {
        if (i.f) {
          const p = m ? h(l) ? u[l] : c[l] : l.value;
          s ? ke(p) && _u(p, r) : ke(p) ? p.includes(r) || p.push(r) : m ? (c[l] = [r], h(l) && (u[l] = c[l])) : (l.value = [r], i.k && (c[i.k] = l.value));
        } else m ? (c[l] = a, h(l) && (u[l] = a)) : g && (l.value = a, i.k && (c[i.k] = a));
      };
      a ? (v.id = -1, Ot(v, t)) : v();
    }
  }
}
Qr().requestIdleCallback;
Qr().cancelIdleCallback;
const Fn = (i) => !!i.type.__asyncLoader, ll = (i) => i.type.__isKeepAlive;
function zp(i, e, t = xt, n = !1) {
  if (t) {
    const s = t[i] || (t[i] = []), r = e.__weh || (e.__weh = (...a) => {
      Yi();
      const o = hl(t), l = gi(e, t, i, a);
      return o(), Xi(), l;
    });
    return n ? s.unshift(r) : s.push(r), r;
  }
}
const Os = (i) => (e, t = xt) => {
  (!Ts || i === "sp") && zp(i, (...n) => e(...n), t);
}, wt = Os("m"), lf = Os(
  "bu"
), df = Os("u"), Fs = Os(
  "bum"
), ia = Os("um"), Kp = "components";
function cf(i, e) {
  return Wp(Kp, i, !0, e) || i;
}
const jp = Symbol.for("v-ndc");
function Wp(i, e, t = !0, n = !1) {
  const s = ft || xt;
  if (s) {
    const r = s.type;
    {
      const o = Cg(
        r,
        !1
      );
      if (o && (o === e || o === _t(e) || o === Zr(_t(e))))
        return r;
    }
    const a = (
      // local registration
      // check instance[type] first which is resolved for options API
      id(s[i] || r[i], e) || // global registration
      id(s.appContext[i], e)
    );
    return !a && n ? r : a;
  }
}
function id(i, e) {
  return i && (i[e] || i[_t(e)] || i[Zr(_t(e))]);
}
function pt(i, e, t, n) {
  let s;
  const r = t, a = ke(i);
  if (a || ot(i)) {
    const o = a && Mn(i);
    let l = !1, d = !1;
    o && (l = !Xt(i), d = Qi(i), i = ea(i)), s = new Array(i.length);
    for (let c = 0, u = i.length; c < u; c++)
      s[c] = e(
        l ? d ? br(ht(i[c])) : ht(i[c]) : i[c],
        c,
        void 0,
        r
      );
  } else if (typeof i == "number") {
    s = new Array(i);
    for (let o = 0; o < i; o++)
      s[o] = e(o + 1, o, void 0, r);
  } else if (Ze(i))
    if (i[Symbol.iterator])
      s = Array.from(
        i,
        (o, l) => e(o, l, void 0, r)
      );
    else {
      const o = Object.keys(i);
      s = new Array(o.length);
      for (let l = 0, d = o.length; l < d; l++) {
        const c = o[l];
        s[l] = e(i[c], c, l, r);
      }
    }
  else
    s = [];
  return s;
}
function na(i, e, t = {}, n, s) {
  if (ft.ce || ft.parent && Fn(ft.parent) && ft.parent.ce)
    return e !== "default" && (t.name = e), P(), Ie(
      ve,
      null,
      [de("slot", t, n)],
      64
    );
  let r = i[e];
  r && r._c && (r._d = !1), P();
  const a = r && uf(r(t)), o = t.key || // slot content array of a dynamic conditional slot may have a branch
  // key attached in the `createSlots` helper, respect that
  a && a.key, l = Ie(
    ve,
    {
      key: (o && !ii(o) ? o : `_${e}`) + // #7256 force differentiate fallback content from actual content
      ""
    },
    a || [],
    a && i._ === 1 ? 64 : -2
  );
  return !s && l.scopeId && (l.slotScopeIds = [l.scopeId + "-s"]), r && r._c && (r._d = !0), l;
}
function uf(i) {
  return i.some((e) => ks(e) ? !(e.type === bt || e.type === ve && !uf(e.children)) : !0) ? i : null;
}
const yo = (i) => i ? wf(i) ? aa(i) : yo(i.parent) : null, ls = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ mt(/* @__PURE__ */ Object.create(null), {
    $: (i) => i,
    $el: (i) => i.vnode.el,
    $data: (i) => i.data,
    $props: (i) => i.props,
    $attrs: (i) => i.attrs,
    $slots: (i) => i.slots,
    $refs: (i) => i.refs,
    $parent: (i) => yo(i.parent),
    $root: (i) => yo(i.root),
    $host: (i) => i.ce,
    $emit: (i) => i.emit,
    $options: (i) => i.type,
    $forceUpdate: (i) => i.f || (i.f = () => {
      ol(i.update);
    }),
    $nextTick: (i) => i.n || (i.n = Gt.bind(i.proxy)),
    $watch: (i) => ji
  })
), Aa = (i, e) => i !== Ge && !i.__isScriptSetup && Oe(i, e), qp = {
  get({ _: i }, e) {
    if (e === "__v_skip")
      return !0;
    const { ctx: t, setupState: n, data: s, props: r, accessCache: a, type: o, appContext: l } = i;
    let d;
    if (e[0] !== "$") {
      const h = a[e];
      if (h !== void 0)
        switch (h) {
          case 1:
            return n[e];
          case 2:
            return s[e];
          case 4:
            return t[e];
          case 3:
            return r[e];
        }
      else {
        if (Aa(n, e))
          return a[e] = 1, n[e];
        if (s !== Ge && Oe(s, e))
          return a[e] = 2, s[e];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (d = i.propsOptions[0]) && Oe(d, e)
        )
          return a[e] = 3, r[e];
        if (t !== Ge && Oe(t, e))
          return a[e] = 4, t[e];
        a[e] = 0;
      }
    }
    const c = ls[e];
    let u, f;
    if (c)
      return e === "$attrs" && yt(i.attrs, "get", ""), c(i);
    if (
      // css module (injected by vue-loader)
      (u = o.__cssModules) && (u = u[e])
    )
      return u;
    if (t !== Ge && Oe(t, e))
      return a[e] = 4, t[e];
    if (
      // global properties
      f = l.config.globalProperties, Oe(f, e)
    )
      return f[e];
  },
  set({ _: i }, e, t) {
    const { data: n, setupState: s, ctx: r } = i;
    return Aa(s, e) ? (s[e] = t, !0) : n !== Ge && Oe(n, e) ? (n[e] = t, !0) : Oe(i.props, e) || e[0] === "$" && e.slice(1) in i ? !1 : (r[e] = t, !0);
  },
  has({
    _: { data: i, setupState: e, accessCache: t, ctx: n, appContext: s, propsOptions: r }
  }, a) {
    let o;
    return !!t[a] || i !== Ge && Oe(i, a) || Aa(e, a) || (o = r[0]) && Oe(o, a) || Oe(n, a) || Oe(ls, a) || Oe(s.config.globalProperties, a);
  },
  defineProperty(i, e, t) {
    return t.get != null ? i._.accessCache[e] = 0 : Oe(t, "value") && this.set(i, e, t.value, null), Reflect.defineProperty(i, e, t);
  }
};
function ff() {
  return {
    app: null,
    config: {
      isNativeTag: Xm,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let Yp = 0;
function Xp(i, e) {
  return function(n, s = null) {
    Ue(n) || (n = mt({}, n)), s != null && !Ze(s) && (s = null);
    const r = ff(), a = /* @__PURE__ */ new WeakSet(), o = [];
    let l = !1;
    const d = r.app = {
      _uid: Yp++,
      _component: n,
      _props: s,
      _container: null,
      _context: r,
      _instance: null,
      version: Pg,
      get config() {
        return r.config;
      },
      set config(c) {
      },
      use(c, ...u) {
        return a.has(c) || (c && Ue(c.install) ? (a.add(c), c.install(d, ...u)) : Ue(c) && (a.add(c), c(d, ...u))), d;
      },
      mixin(c) {
        return d;
      },
      component(c, u) {
        return u ? (r.components[c] = u, d) : r.components[c];
      },
      directive(c, u) {
        return u ? (r.directives[c] = u, d) : r.directives[c];
      },
      mount(c, u, f) {
        if (!l) {
          const h = d._ceVNode || de(n, s);
          return h.appContext = r, f === !0 ? f = "svg" : f === !1 && (f = void 0), i(h, c, f), l = !0, d._container = c, c.__vue_app__ = d, aa(h.component);
        }
      },
      onUnmount(c) {
        o.push(c);
      },
      unmount() {
        l && (gi(
          o,
          d._instance,
          16
        ), i(null, d._container), delete d._container.__vue_app__);
      },
      provide(c, u) {
        return r.provides[c] = u, d;
      },
      runWithContext(c) {
        const u = $n;
        $n = d;
        try {
          return c();
        } finally {
          $n = u;
        }
      }
    };
    return d;
  };
}
let $n = null;
function hf(i, e) {
  if (xt) {
    let t = xt.provides;
    const n = xt.parent && xt.parent.provides;
    n === t && (t = xt.provides = Object.create(n)), t[i] = e;
  }
}
function Zp(i, e, t = !1) {
  const n = xt || ft;
  if (n || $n) {
    let s = $n ? $n._context.provides : n ? n.parent == null || n.ce ? n.vnode.appContext && n.vnode.appContext.provides : n.parent.provides : void 0;
    if (s && i in s)
      return s[i];
    if (arguments.length > 1)
      return t && Ue(e) ? e.call(n && n.proxy) : e;
  }
}
const mf = {}, pf = () => Object.create(mf), gf = (i) => Object.getPrototypeOf(i) === mf;
function Qp(i, e, t, n = !1) {
  const s = {}, r = pf();
  i.propsDefaults = /* @__PURE__ */ Object.create(null), vf(i, e, s, r);
  for (const a in i.propsOptions[0])
    a in s || (s[a] = void 0);
  t ? i.props = n ? s : Lp(s) : i.type.props ? i.props = s : i.props = r, i.attrs = r;
}
function Jp(i, e, t, n) {
  const {
    props: s,
    attrs: r,
    vnode: { patchFlag: a }
  } = i, o = Me(s), [l] = i.propsOptions;
  let d = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (n || a > 0) && !(a & 16)
  ) {
    if (a & 8) {
      const c = i.vnode.dynamicProps;
      for (let u = 0; u < c.length; u++) {
        let f = c[u];
        if (sa(i.emitsOptions, f))
          continue;
        const h = e[f];
        if (l)
          if (Oe(r, f))
            h !== r[f] && (r[f] = h, d = !0);
          else {
            const m = _t(f);
            s[m] = bo(
              l,
              o,
              m,
              h,
              i,
              !1
            );
          }
        else
          h !== r[f] && (r[f] = h, d = !0);
      }
    }
  } else {
    vf(i, e, s, r) && (d = !0);
    let c;
    for (const u in o)
      (!e || // for camelCase
      !Oe(e, u) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((c = qt(u)) === u || !Oe(e, c))) && (l ? t && // for camelCase
      (t[u] !== void 0 || // for kebab-case
      t[c] !== void 0) && (s[u] = bo(
        l,
        o,
        u,
        void 0,
        i,
        !0
      )) : delete s[u]);
    if (r !== o)
      for (const u in r)
        (!e || !Oe(e, u)) && (delete r[u], d = !0);
  }
  d && Ci(i.attrs, "set", "");
}
function vf(i, e, t, n) {
  const [s, r] = i.propsOptions;
  let a = !1, o;
  if (e)
    for (let l in e) {
      if (ss(l))
        continue;
      const d = e[l];
      let c;
      s && Oe(s, c = _t(l)) ? !r || !r.includes(c) ? t[c] = d : (o || (o = {}))[c] = d : sa(i.emitsOptions, l) || (!(l in n) || d !== n[l]) && (n[l] = d, a = !0);
    }
  if (r) {
    const l = Me(t), d = o || Ge;
    for (let c = 0; c < r.length; c++) {
      const u = r[c];
      t[u] = bo(
        s,
        l,
        u,
        d[u],
        i,
        !Oe(d, u)
      );
    }
  }
  return a;
}
function bo(i, e, t, n, s, r) {
  const a = i[t];
  if (a != null) {
    const o = Oe(a, "default");
    if (o && n === void 0) {
      const l = a.default;
      if (a.type !== Function && !a.skipFactory && Ue(l)) {
        const { propsDefaults: d } = s;
        if (t in d)
          n = d[t];
        else {
          const c = hl(s);
          n = d[t] = l.call(
            null,
            e
          ), c();
        }
      } else
        n = l;
      s.ce && s.ce._setProp(t, n);
    }
    a[
      0
      /* shouldCast */
    ] && (r && !o ? n = !1 : a[
      1
      /* shouldCastTrue */
    ] && (n === "" || n === qt(t)) && (n = !0));
  }
  return n;
}
function eg(i, e, t = !1) {
  const n = e.propsCache, s = n.get(i);
  if (s)
    return s;
  const r = i.props, a = {}, o = [];
  if (!r)
    return Ze(i) && n.set(i, Dn), Dn;
  if (ke(r))
    for (let d = 0; d < r.length; d++) {
      const c = _t(r[d]);
      nd(c) && (a[c] = Ge);
    }
  else if (r)
    for (const d in r) {
      const c = _t(d);
      if (nd(c)) {
        const u = r[d], f = a[c] = ke(u) || Ue(u) ? { type: u } : mt({}, u), h = f.type;
        let m = !1, g = !0;
        if (ke(h))
          for (let v = 0; v < h.length; ++v) {
            const p = h[v], y = Ue(p) && p.name;
            if (y === "Boolean") {
              m = !0;
              break;
            } else y === "String" && (g = !1);
          }
        else
          m = Ue(h) && h.name === "Boolean";
        f[
          0
          /* shouldCast */
        ] = m, f[
          1
          /* shouldCastTrue */
        ] = g, (m || Oe(f, "default")) && o.push(c);
      }
    }
  const l = [a, o];
  return Ze(i) && n.set(i, l), l;
}
function nd(i) {
  return i[0] !== "$" && !ss(i);
}
const dl = (i) => i[0] === "_" || i === "$stable", cl = (i) => ke(i) ? i.map(ci) : [ci(i)], tg = (i, e, t) => {
  if (e._n)
    return e;
  const n = Xe((...s) => cl(e(...s)), t);
  return n._c = !1, n;
}, yf = (i, e, t) => {
  const n = i._ctx;
  for (const s in i) {
    if (dl(s)) continue;
    const r = i[s];
    if (Ue(r))
      e[s] = tg(s, r, n);
    else if (r != null) {
      const a = cl(r);
      e[s] = () => a;
    }
  }
}, bf = (i, e) => {
  const t = cl(e);
  i.slots.default = () => t;
}, Sf = (i, e, t) => {
  for (const n in e)
    (t || !dl(n)) && (i[n] = e[n]);
}, ig = (i, e, t) => {
  const n = i.slots = pf();
  if (i.vnode.shapeFlag & 32) {
    const s = e.__;
    s && co(n, "__", s, !0);
    const r = e._;
    r ? (Sf(n, e, t), t && co(n, "_", r, !0)) : yf(e, n);
  } else e && bf(i, e);
}, ng = (i, e, t) => {
  const { vnode: n, slots: s } = i;
  let r = !0, a = Ge;
  if (n.shapeFlag & 32) {
    const o = e._;
    o ? t && o === 1 ? r = !1 : Sf(s, e, t) : (r = !e.$stable, yf(e, s)), a = e;
  } else e && (bf(i, e), a = { default: 1 });
  if (r)
    for (const o in s)
      !dl(o) && a[o] == null && delete s[o];
}, Ot = yg;
function sg(i) {
  return rg(i);
}
function rg(i, e) {
  const t = Qr();
  t.__VUE__ = !0;
  const {
    insert: n,
    remove: s,
    patchProp: r,
    createElement: a,
    createText: o,
    createComment: l,
    setText: d,
    setElementText: c,
    parentNode: u,
    nextSibling: f,
    setScopeId: h = ji,
    insertStaticContent: m
  } = i, g = (D, M, H, J = null, G = null, W = null, ne = void 0, se = null, ee = !!M.dynamicChildren) => {
    if (D === M)
      return;
    D && !mn(D, M) && (J = tt(D), te(D, G, W, !0), D = null), M.patchFlag === -2 && (ee = !1, M.dynamicChildren = null);
    const { type: Y, ref: me, shapeFlag: re } = M;
    switch (Y) {
      case ra:
        v(D, M, H, J);
        break;
      case bt:
        p(D, M, H, J);
        break;
      case ds:
        D == null && y(M, H, J, ne);
        break;
      case ve:
        C(
          D,
          M,
          H,
          J,
          G,
          W,
          ne,
          se,
          ee
        );
        break;
      default:
        re & 1 ? T(
          D,
          M,
          H,
          J,
          G,
          W,
          ne,
          se,
          ee
        ) : re & 6 ? O(
          D,
          M,
          H,
          J,
          G,
          W,
          ne,
          se,
          ee
        ) : (re & 64 || re & 128) && Y.process(
          D,
          M,
          H,
          J,
          G,
          W,
          ne,
          se,
          ee,
          gt
        );
    }
    me != null && G ? os(me, D && D.ref, W, M || D, !M) : me == null && D && D.ref != null && os(D.ref, null, W, D, !0);
  }, v = (D, M, H, J) => {
    if (D == null)
      n(
        M.el = o(M.children),
        H,
        J
      );
    else {
      const G = M.el = D.el;
      M.children !== D.children && d(G, M.children);
    }
  }, p = (D, M, H, J) => {
    D == null ? n(
      M.el = l(M.children || ""),
      H,
      J
    ) : M.el = D.el;
  }, y = (D, M, H, J) => {
    [D.el, D.anchor] = m(
      D.children,
      M,
      H,
      J,
      D.el,
      D.anchor
    );
  }, b = ({ el: D, anchor: M }, H, J) => {
    let G;
    for (; D && D !== M; )
      G = f(D), n(D, H, J), D = G;
    n(M, H, J);
  }, k = ({ el: D, anchor: M }) => {
    let H;
    for (; D && D !== M; )
      H = f(D), s(D), D = H;
    s(M);
  }, T = (D, M, H, J, G, W, ne, se, ee) => {
    M.type === "svg" ? ne = "svg" : M.type === "math" && (ne = "mathml"), D == null ? I(
      M,
      H,
      J,
      G,
      W,
      ne,
      se,
      ee
    ) : R(
      D,
      M,
      G,
      W,
      ne,
      se,
      ee
    );
  }, I = (D, M, H, J, G, W, ne, se) => {
    let ee, Y;
    const { props: me, shapeFlag: re, transition: ue, dirs: Se } = D;
    if (ee = D.el = a(
      D.type,
      W,
      me && me.is,
      me
    ), re & 8 ? c(ee, D.children) : re & 16 && E(
      D.children,
      ee,
      null,
      J,
      G,
      wa(D, W),
      ne,
      se
    ), Se && an(D, null, J, "created"), x(ee, D, D.scopeId, ne, J), me) {
      for (const Ne in me)
        Ne !== "value" && !ss(Ne) && r(ee, Ne, null, me[Ne], W, J);
      "value" in me && r(ee, "value", null, me.value, W), (Y = me.onVnodeBeforeMount) && ri(Y, J, D);
    }
    Se && an(D, null, J, "beforeMount");
    const _e = ag(G, ue);
    _e && ue.beforeEnter(ee), n(ee, M, H), ((Y = me && me.onVnodeMounted) || _e || Se) && Ot(() => {
      Y && ri(Y, J, D), _e && ue.enter(ee), Se && an(D, null, J, "mounted");
    }, G);
  }, x = (D, M, H, J, G) => {
    if (H && h(D, H), J)
      for (let W = 0; W < J.length; W++)
        h(D, J[W]);
    if (G) {
      let W = G.subTree;
      if (M === W || Ef(W.type) && (W.ssContent === M || W.ssFallback === M)) {
        const ne = G.vnode;
        x(
          D,
          ne,
          ne.scopeId,
          ne.slotScopeIds,
          G.parent
        );
      }
    }
  }, E = (D, M, H, J, G, W, ne, se, ee = 0) => {
    for (let Y = ee; Y < D.length; Y++) {
      const me = D[Y] = se ? Vi(D[Y]) : ci(D[Y]);
      g(
        null,
        me,
        M,
        H,
        J,
        G,
        W,
        ne,
        se
      );
    }
  }, R = (D, M, H, J, G, W, ne) => {
    const se = M.el = D.el;
    let { patchFlag: ee, dynamicChildren: Y, dirs: me } = M;
    ee |= D.patchFlag & 16;
    const re = D.props || Ge, ue = M.props || Ge;
    let Se;
    if (H && on(H, !1), (Se = ue.onVnodeBeforeUpdate) && ri(Se, H, M, D), me && an(M, D, H, "beforeUpdate"), H && on(H, !0), (re.innerHTML && ue.innerHTML == null || re.textContent && ue.textContent == null) && c(se, ""), Y ? A(
      D.dynamicChildren,
      Y,
      se,
      H,
      J,
      wa(M, G),
      W
    ) : ne || z(
      D,
      M,
      se,
      null,
      H,
      J,
      wa(M, G),
      W,
      !1
    ), ee > 0) {
      if (ee & 16)
        _(se, re, ue, H, G);
      else if (ee & 2 && re.class !== ue.class && r(se, "class", null, ue.class, G), ee & 4 && r(se, "style", re.style, ue.style, G), ee & 8) {
        const _e = M.dynamicProps;
        for (let Ne = 0; Ne < _e.length; Ne++) {
          const $e = _e[Ne], Tt = re[$e], lt = ue[$e];
          (lt !== Tt || $e === "value") && r(se, $e, Tt, lt, G, H);
        }
      }
      ee & 1 && D.children !== M.children && c(se, M.children);
    } else !ne && Y == null && _(se, re, ue, H, G);
    ((Se = ue.onVnodeUpdated) || me) && Ot(() => {
      Se && ri(Se, H, M, D), me && an(M, D, H, "updated");
    }, J);
  }, A = (D, M, H, J, G, W, ne) => {
    for (let se = 0; se < M.length; se++) {
      const ee = D[se], Y = M[se], me = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        ee.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (ee.type === ve || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !mn(ee, Y) || // - In the case of a component, it could contain anything.
        ee.shapeFlag & 198) ? u(ee.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          H
        )
      );
      g(
        ee,
        Y,
        me,
        null,
        J,
        G,
        W,
        ne,
        !0
      );
    }
  }, _ = (D, M, H, J, G) => {
    if (M !== H) {
      if (M !== Ge)
        for (const W in M)
          !ss(W) && !(W in H) && r(
            D,
            W,
            M[W],
            null,
            G,
            J
          );
      for (const W in H) {
        if (ss(W)) continue;
        const ne = H[W], se = M[W];
        ne !== se && W !== "value" && r(D, W, se, ne, G, J);
      }
      "value" in H && r(D, "value", M.value, H.value, G);
    }
  }, C = (D, M, H, J, G, W, ne, se, ee) => {
    const Y = M.el = D ? D.el : o(""), me = M.anchor = D ? D.anchor : o("");
    let { patchFlag: re, dynamicChildren: ue, slotScopeIds: Se } = M;
    Se && (se = se ? se.concat(Se) : Se), D == null ? (n(Y, H, J), n(me, H, J), E(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      M.children || [],
      H,
      me,
      G,
      W,
      ne,
      se,
      ee
    )) : re > 0 && re & 64 && ue && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    D.dynamicChildren ? (A(
      D.dynamicChildren,
      ue,
      H,
      G,
      W,
      ne,
      se
    ), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (M.key != null || G && M === G.subTree) && kf(
      D,
      M,
      !0
      /* shallow */
    )) : z(
      D,
      M,
      H,
      me,
      G,
      W,
      ne,
      se,
      ee
    );
  }, O = (D, M, H, J, G, W, ne, se, ee) => {
    M.slotScopeIds = se, D == null ? M.shapeFlag & 512 ? G.ctx.activate(
      M,
      H,
      J,
      ne,
      ee
    ) : V(
      M,
      H,
      J,
      G,
      W,
      ne,
      ee
    ) : j(D, M, ee);
  }, V = (D, M, H, J, G, W, ne) => {
    const se = D.component = _g(
      D,
      J,
      G
    );
    if (ll(D) && (se.ctx.renderer = gt), Ag(se, !1, ne), se.asyncDep) {
      if (G && G.registerDep(se, X, ne), !D.el) {
        const ee = se.subTree = de(bt);
        p(null, ee, M, H);
      }
    } else
      X(
        se,
        D,
        M,
        H,
        G,
        W,
        ne
      );
  }, j = (D, M, H) => {
    const J = M.component = D.component;
    if (gg(D, M, H))
      if (J.asyncDep && !J.asyncResolved) {
        q(J, M, H);
        return;
      } else
        J.next = M, J.update();
    else
      M.el = D.el, J.vnode = M;
  }, X = (D, M, H, J, G, W, ne) => {
    const se = () => {
      if (D.isMounted) {
        let { next: re, bu: ue, u: Se, parent: _e, vnode: Ne } = D;
        {
          const qn = Tf(D);
          if (qn) {
            re && (re.el = Ne.el, q(D, re, ne)), qn.asyncDep.then(() => {
              D.isUnmounted || se();
            });
            return;
          }
        }
        let $e = re, Tt;
        on(D, !1), re ? (re.el = Ne.el, q(D, re, ne)) : re = Ne, ue && rr(ue), (Tt = re.props && re.props.onVnodeBeforeUpdate) && ri(Tt, _e, re, Ne), on(D, !0);
        const lt = rd(D), dt = D.subTree;
        D.subTree = lt, g(
          dt,
          lt,
          // parent may have changed if it's in a teleport
          u(dt.el),
          // anchor may have changed if it's in a fragment
          tt(dt),
          D,
          G,
          W
        ), re.el = lt.el, $e === null && vg(D, lt.el), Se && Ot(Se, G), (Tt = re.props && re.props.onVnodeUpdated) && Ot(
          () => ri(Tt, _e, re, Ne),
          G
        );
      } else {
        let re;
        const { props: ue } = M, { bm: Se, m: _e, parent: Ne, root: $e, type: Tt } = D, lt = Fn(M);
        on(D, !1), Se && rr(Se), !lt && (re = ue && ue.onVnodeBeforeMount) && ri(re, Ne, M), on(D, !0);
        {
          $e.ce && // @ts-expect-error _def is private
          $e.ce._def.shadowRoot !== !1 && $e.ce._injectChildStyle(Tt);
          const dt = D.subTree = rd(D);
          g(
            null,
            dt,
            H,
            J,
            D,
            G,
            W
          ), M.el = dt.el;
        }
        if (_e && Ot(_e, G), !lt && (re = ue && ue.onVnodeMounted)) {
          const dt = M;
          Ot(
            () => ri(re, Ne, dt),
            G
          );
        }
        (M.shapeFlag & 256 || Ne && Fn(Ne.vnode) && Ne.vnode.shapeFlag & 256) && D.a && Ot(D.a, G), D.isMounted = !0, M = H = J = null;
      }
    };
    D.scope.on();
    const ee = D.effect = new Pu(se);
    D.scope.off();
    const Y = D.update = ee.run.bind(ee), me = D.job = ee.runIfDirty.bind(ee);
    me.i = D, me.id = D.uid, ee.scheduler = () => ol(me), on(D, !0), Y();
  }, q = (D, M, H) => {
    M.component = D;
    const J = D.vnode.props;
    D.vnode = M, D.next = null, Jp(D, M.props, J, H), ng(D, M.children, H), Yi(), ed(D), Xi();
  }, z = (D, M, H, J, G, W, ne, se, ee = !1) => {
    const Y = D && D.children, me = D ? D.shapeFlag : 0, re = M.children, { patchFlag: ue, shapeFlag: Se } = M;
    if (ue > 0) {
      if (ue & 128) {
        oe(
          Y,
          re,
          H,
          J,
          G,
          W,
          ne,
          se,
          ee
        );
        return;
      } else if (ue & 256) {
        Q(
          Y,
          re,
          H,
          J,
          G,
          W,
          ne,
          se,
          ee
        );
        return;
      }
    }
    Se & 8 ? (me & 16 && Ae(Y, G, W), re !== Y && c(H, re)) : me & 16 ? Se & 16 ? oe(
      Y,
      re,
      H,
      J,
      G,
      W,
      ne,
      se,
      ee
    ) : Ae(Y, G, W, !0) : (me & 8 && c(H, ""), Se & 16 && E(
      re,
      H,
      J,
      G,
      W,
      ne,
      se,
      ee
    ));
  }, Q = (D, M, H, J, G, W, ne, se, ee) => {
    D = D || Dn, M = M || Dn;
    const Y = D.length, me = M.length, re = Math.min(Y, me);
    let ue;
    for (ue = 0; ue < re; ue++) {
      const Se = M[ue] = ee ? Vi(M[ue]) : ci(M[ue]);
      g(
        D[ue],
        Se,
        H,
        null,
        G,
        W,
        ne,
        se,
        ee
      );
    }
    Y > me ? Ae(
      D,
      G,
      W,
      !0,
      !1,
      re
    ) : E(
      M,
      H,
      J,
      G,
      W,
      ne,
      se,
      ee,
      re
    );
  }, oe = (D, M, H, J, G, W, ne, se, ee) => {
    let Y = 0;
    const me = M.length;
    let re = D.length - 1, ue = me - 1;
    for (; Y <= re && Y <= ue; ) {
      const Se = D[Y], _e = M[Y] = ee ? Vi(M[Y]) : ci(M[Y]);
      if (mn(Se, _e))
        g(
          Se,
          _e,
          H,
          null,
          G,
          W,
          ne,
          se,
          ee
        );
      else
        break;
      Y++;
    }
    for (; Y <= re && Y <= ue; ) {
      const Se = D[re], _e = M[ue] = ee ? Vi(M[ue]) : ci(M[ue]);
      if (mn(Se, _e))
        g(
          Se,
          _e,
          H,
          null,
          G,
          W,
          ne,
          se,
          ee
        );
      else
        break;
      re--, ue--;
    }
    if (Y > re) {
      if (Y <= ue) {
        const Se = ue + 1, _e = Se < me ? M[Se].el : J;
        for (; Y <= ue; )
          g(
            null,
            M[Y] = ee ? Vi(M[Y]) : ci(M[Y]),
            H,
            _e,
            G,
            W,
            ne,
            se,
            ee
          ), Y++;
      }
    } else if (Y > ue)
      for (; Y <= re; )
        te(D[Y], G, W, !0), Y++;
    else {
      const Se = Y, _e = Y, Ne = /* @__PURE__ */ new Map();
      for (Y = _e; Y <= ue; Y++) {
        const Mt = M[Y] = ee ? Vi(M[Y]) : ci(M[Y]);
        Mt.key != null && Ne.set(Mt.key, Y);
      }
      let $e, Tt = 0;
      const lt = ue - _e + 1;
      let dt = !1, qn = 0;
      const Yn = new Array(lt);
      for (Y = 0; Y < lt; Y++) Yn[Y] = 0;
      for (Y = Se; Y <= re; Y++) {
        const Mt = D[Y];
        if (Tt >= lt) {
          te(Mt, G, W, !0);
          continue;
        }
        let si;
        if (Mt.key != null)
          si = Ne.get(Mt.key);
        else
          for ($e = _e; $e <= ue; $e++)
            if (Yn[$e - _e] === 0 && mn(Mt, M[$e])) {
              si = $e;
              break;
            }
        si === void 0 ? te(Mt, G, W, !0) : (Yn[si - _e] = Y + 1, si >= qn ? qn = si : dt = !0, g(
          Mt,
          M[si],
          H,
          null,
          G,
          W,
          ne,
          se,
          ee
        ), Tt++);
      }
      const ql = dt ? og(Yn) : Dn;
      for ($e = ql.length - 1, Y = lt - 1; Y >= 0; Y--) {
        const Mt = _e + Y, si = M[Mt], Yl = Mt + 1 < me ? M[Mt + 1].el : J;
        Yn[Y] === 0 ? g(
          null,
          si,
          H,
          Yl,
          G,
          W,
          ne,
          se,
          ee
        ) : dt && ($e < 0 || Y !== ql[$e] ? Z(si, H, Yl, 2) : $e--);
      }
    }
  }, Z = (D, M, H, J, G = null) => {
    const { el: W, type: ne, transition: se, children: ee, shapeFlag: Y } = D;
    if (Y & 6) {
      Z(D.component.subTree, M, H, J);
      return;
    }
    if (Y & 128) {
      D.suspense.move(M, H, J);
      return;
    }
    if (Y & 64) {
      ne.move(D, M, H, gt);
      return;
    }
    if (ne === ve) {
      n(W, M, H);
      for (let re = 0; re < ee.length; re++)
        Z(ee[re], M, H, J);
      n(D.anchor, M, H);
      return;
    }
    if (ne === ds) {
      b(D, M, H);
      return;
    }
    if (J !== 2 && Y & 1 && se)
      if (J === 0)
        se.beforeEnter(W), n(W, M, H), Ot(() => se.enter(W), G);
      else {
        const { leave: re, delayLeave: ue, afterLeave: Se } = se, _e = () => {
          D.ctx.isUnmounted ? s(W) : n(W, M, H);
        }, Ne = () => {
          re(W, () => {
            _e(), Se && Se();
          });
        };
        ue ? ue(W, _e, Ne) : Ne();
      }
    else
      n(W, M, H);
  }, te = (D, M, H, J = !1, G = !1) => {
    const {
      type: W,
      props: ne,
      ref: se,
      children: ee,
      dynamicChildren: Y,
      shapeFlag: me,
      patchFlag: re,
      dirs: ue,
      cacheIndex: Se
    } = D;
    if (re === -2 && (G = !1), se != null && (Yi(), os(se, null, H, D, !0), Xi()), Se != null && (M.renderCache[Se] = void 0), me & 256) {
      M.ctx.deactivate(D);
      return;
    }
    const _e = me & 1 && ue, Ne = !Fn(D);
    let $e;
    if (Ne && ($e = ne && ne.onVnodeBeforeUnmount) && ri($e, M, D), me & 6)
      xe(D.component, H, J);
    else {
      if (me & 128) {
        D.suspense.unmount(H, J);
        return;
      }
      _e && an(D, null, M, "beforeUnmount"), me & 64 ? D.type.remove(
        D,
        M,
        H,
        gt,
        J
      ) : Y && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !Y.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (W !== ve || re > 0 && re & 64) ? Ae(
        Y,
        M,
        H,
        !1,
        !0
      ) : (W === ve && re & 384 || !G && me & 16) && Ae(ee, M, H), J && Ee(D);
    }
    (Ne && ($e = ne && ne.onVnodeUnmounted) || _e) && Ot(() => {
      $e && ri($e, M, D), _e && an(D, null, M, "unmounted");
    }, H);
  }, Ee = (D) => {
    const { type: M, el: H, anchor: J, transition: G } = D;
    if (M === ve) {
      De(H, J);
      return;
    }
    if (M === ds) {
      k(D);
      return;
    }
    const W = () => {
      s(H), G && !G.persisted && G.afterLeave && G.afterLeave();
    };
    if (D.shapeFlag & 1 && G && !G.persisted) {
      const { leave: ne, delayLeave: se } = G, ee = () => ne(H, W);
      se ? se(D.el, W, ee) : ee();
    } else
      W();
  }, De = (D, M) => {
    let H;
    for (; D !== M; )
      H = f(D), s(D), D = H;
    s(M);
  }, xe = (D, M, H) => {
    const {
      bum: J,
      scope: G,
      job: W,
      subTree: ne,
      um: se,
      m: ee,
      a: Y,
      parent: me,
      slots: { __: re }
    } = D;
    sd(ee), sd(Y), J && rr(J), me && ke(re) && re.forEach((ue) => {
      me.renderCache[ue] = void 0;
    }), G.stop(), W && (W.flags |= 8, te(ne, D, M, H)), se && Ot(se, M), Ot(() => {
      D.isUnmounted = !0;
    }, M), M && M.pendingBranch && !M.isUnmounted && D.asyncDep && !D.asyncResolved && D.suspenseId === M.pendingId && (M.deps--, M.deps === 0 && M.resolve());
  }, Ae = (D, M, H, J = !1, G = !1, W = 0) => {
    for (let ne = W; ne < D.length; ne++)
      te(D[ne], M, H, J, G);
  }, tt = (D) => {
    if (D.shapeFlag & 6)
      return tt(D.component.subTree);
    if (D.shapeFlag & 128)
      return D.suspense.next();
    const M = f(D.anchor || D.el), H = M && M[Bp];
    return H ? f(H) : M;
  };
  let it = !1;
  const kt = (D, M, H) => {
    D == null ? M._vnode && te(M._vnode, null, null, !0) : g(
      M._vnode || null,
      D,
      M,
      null,
      null,
      null,
      H
    ), M._vnode = D, it || (it = !0, ed(), Qu(), it = !1);
  }, gt = {
    p: g,
    um: te,
    m: Z,
    r: Ee,
    mt: V,
    mc: E,
    pc: z,
    pbc: A,
    n: tt,
    o: i
  };
  return {
    render: kt,
    hydrate: void 0,
    createApp: Xp(kt)
  };
}
function wa({ type: i, props: e }, t) {
  return t === "svg" && i === "foreignObject" || t === "mathml" && i === "annotation-xml" && e && e.encoding && e.encoding.includes("html") ? void 0 : t;
}
function on({ effect: i, job: e }, t) {
  t ? (i.flags |= 32, e.flags |= 4) : (i.flags &= -33, e.flags &= -5);
}
function ag(i, e) {
  return (!i || i && !i.pendingBranch) && e && !e.persisted;
}
function kf(i, e, t = !1) {
  const n = i.children, s = e.children;
  if (ke(n) && ke(s))
    for (let r = 0; r < n.length; r++) {
      const a = n[r];
      let o = s[r];
      o.shapeFlag & 1 && !o.dynamicChildren && ((o.patchFlag <= 0 || o.patchFlag === 32) && (o = s[r] = Vi(s[r]), o.el = a.el), !t && o.patchFlag !== -2 && kf(a, o)), o.type === ra && (o.el = a.el), o.type === bt && !o.el && (o.el = a.el);
    }
}
function og(i) {
  const e = i.slice(), t = [0];
  let n, s, r, a, o;
  const l = i.length;
  for (n = 0; n < l; n++) {
    const d = i[n];
    if (d !== 0) {
      if (s = t[t.length - 1], i[s] < d) {
        e[n] = s, t.push(n);
        continue;
      }
      for (r = 0, a = t.length - 1; r < a; )
        o = r + a >> 1, i[t[o]] < d ? r = o + 1 : a = o;
      d < i[t[r]] && (r > 0 && (e[n] = t[r - 1]), t[r] = n);
    }
  }
  for (r = t.length, a = t[r - 1]; r-- > 0; )
    t[r] = a, a = e[a];
  return t;
}
function Tf(i) {
  const e = i.subTree.component;
  if (e)
    return e.asyncDep && !e.asyncResolved ? e : Tf(e);
}
function sd(i) {
  if (i)
    for (let e = 0; e < i.length; e++)
      i[e].flags |= 8;
}
const lg = Symbol.for("v-scx"), dg = () => Zp(lg);
function Dt(i, e, t) {
  return cg(i, e, t);
}
function cg(i, e, t = Ge) {
  const { immediate: n, flush: s } = t, r = mt({}, t), a = e && n || !e && s !== "post";
  let o;
  if (Ts) {
    if (s === "sync") {
      const u = dg();
      o = u.__watcherHandles || (u.__watcherHandles = []);
    } else if (!a) {
      const u = () => {
      };
      return u.stop = ji, u.resume = ji, u.pause = ji, u;
    }
  }
  const l = xt;
  r.call = (u, f, h) => gi(u, l, f, h);
  let d = !1;
  s === "post" ? r.scheduler = (u) => {
    Ot(u, l && l.suspense);
  } : s !== "sync" && (d = !0, r.scheduler = (u, f) => {
    f ? u() : ol(u);
  }), r.augmentJob = (u) => {
    e && (u.flags |= 4), d && (u.flags |= 2, l && (u.id = l.uid, u.i = l));
  };
  const c = Op(i, e, r);
  return Ts && (o ? o.push(c) : a && c()), c;
}
const ug = (i, e) => e === "modelValue" || e === "model-value" ? i.modelModifiers : i[`${e}Modifiers`] || i[`${_t(e)}Modifiers`] || i[`${qt(e)}Modifiers`];
function fg(i, e, ...t) {
  if (i.isUnmounted) return;
  const n = i.vnode.props || Ge;
  let s = t;
  const r = e.startsWith("update:"), a = r && ug(n, e.slice(7));
  a && (a.trim && (s = t.map((c) => ot(c) ? c.trim() : c)), a.number && (s = t.map(uo)));
  let o, l = n[o = Sa(e)] || // also try camelCase event handler (#2249)
  n[o = Sa(_t(e))];
  !l && r && (l = n[o = Sa(qt(e))]), l && gi(
    l,
    i,
    6,
    s
  );
  const d = n[o + "Once"];
  if (d) {
    if (!i.emitted)
      i.emitted = {};
    else if (i.emitted[o])
      return;
    i.emitted[o] = !0, gi(
      d,
      i,
      6,
      s
    );
  }
}
function hg(i, e, t = !1) {
  const n = e.emitsCache, s = n.get(i);
  if (s !== void 0)
    return s;
  const r = i.emits;
  let a = {};
  return r ? (ke(r) ? r.forEach((o) => a[o] = null) : mt(a, r), Ze(i) && n.set(i, a), a) : (Ze(i) && n.set(i, null), null);
}
function sa(i, e) {
  return !i || !Wr(e) ? !1 : (e = e.slice(2).replace(/Once$/, ""), Oe(i, e[0].toLowerCase() + e.slice(1)) || Oe(i, qt(e)) || Oe(i, e));
}
function rd(i) {
  const {
    type: e,
    vnode: t,
    proxy: n,
    withProxy: s,
    propsOptions: [r],
    slots: a,
    attrs: o,
    emit: l,
    render: d,
    renderCache: c,
    props: u,
    data: f,
    setupState: h,
    ctx: m,
    inheritAttrs: g
  } = i, v = Tr(i);
  let p, y;
  try {
    if (t.shapeFlag & 4) {
      const k = s || n, T = k;
      p = ci(
        d.call(
          T,
          k,
          c,
          u,
          h,
          f,
          m
        )
      ), y = o;
    } else {
      const k = e;
      p = ci(
        k.length > 1 ? k(
          u,
          { attrs: o, slots: a, emit: l }
        ) : k(
          u,
          null
        )
      ), y = e.props ? o : mg(o);
    }
  } catch (k) {
    cs.length = 0, ta(k, i, 1), p = de(bt);
  }
  let b = p;
  if (y && g !== !1) {
    const k = Object.keys(y), { shapeFlag: T } = b;
    k.length && T & 7 && (r && k.some(Qo) && (y = pg(
      y,
      r
    )), b = Ji(b, y, !1, !0));
  }
  return t.dirs && (b = Ji(b, null, !1, !0), b.dirs = b.dirs ? b.dirs.concat(t.dirs) : t.dirs), t.transition && ys(b, t.transition), p = b, Tr(v), p;
}
const mg = (i) => {
  let e;
  for (const t in i)
    (t === "class" || t === "style" || Wr(t)) && ((e || (e = {}))[t] = i[t]);
  return e;
}, pg = (i, e) => {
  const t = {};
  for (const n in i)
    (!Qo(n) || !(n.slice(9) in e)) && (t[n] = i[n]);
  return t;
};
function gg(i, e, t) {
  const { props: n, children: s, component: r } = i, { props: a, children: o, patchFlag: l } = e, d = r.emitsOptions;
  if (e.dirs || e.transition)
    return !0;
  if (t && l >= 0) {
    if (l & 1024)
      return !0;
    if (l & 16)
      return n ? ad(n, a, d) : !!a;
    if (l & 8) {
      const c = e.dynamicProps;
      for (let u = 0; u < c.length; u++) {
        const f = c[u];
        if (a[f] !== n[f] && !sa(d, f))
          return !0;
      }
    }
  } else
    return (s || o) && (!o || !o.$stable) ? !0 : n === a ? !1 : n ? a ? ad(n, a, d) : !0 : !!a;
  return !1;
}
function ad(i, e, t) {
  const n = Object.keys(e);
  if (n.length !== Object.keys(i).length)
    return !0;
  for (let s = 0; s < n.length; s++) {
    const r = n[s];
    if (e[r] !== i[r] && !sa(t, r))
      return !0;
  }
  return !1;
}
function vg({ vnode: i, parent: e }, t) {
  for (; e; ) {
    const n = e.subTree;
    if (n.suspense && n.suspense.activeBranch === i && (n.el = i.el), n === i)
      (i = e.vnode).el = t, e = e.parent;
    else
      break;
  }
}
const Ef = (i) => i.__isSuspense;
function yg(i, e) {
  e && e.pendingBranch ? ke(i) ? e.effects.push(...i) : e.effects.push(i) : Zu(i);
}
const ve = Symbol.for("v-fgt"), ra = Symbol.for("v-txt"), bt = Symbol.for("v-cmt"), ds = Symbol.for("v-stc"), cs = [];
let Ut = null;
function P(i = !1) {
  cs.push(Ut = i ? null : []);
}
function bg() {
  cs.pop(), Ut = cs[cs.length - 1] || null;
}
let Ss = 1;
function od(i, e = !1) {
  Ss += i, i < 0 && Ut && e && (Ut.hasOnce = !0);
}
function xf(i) {
  return i.dynamicChildren = Ss > 0 ? Ut || Dn : null, bg(), Ss > 0 && Ut && Ut.push(i), i;
}
function N(i, e, t, n, s, r) {
  return xf(
    w(
      i,
      e,
      t,
      n,
      s,
      r,
      !0
    )
  );
}
function Ie(i, e, t, n, s) {
  return xf(
    de(
      i,
      e,
      t,
      n,
      s,
      !0
    )
  );
}
function ks(i) {
  return i ? i.__v_isVNode === !0 : !1;
}
function mn(i, e) {
  return i.type === e.type && i.key === e.key;
}
const _f = ({ key: i }) => i ?? null, or = ({
  ref: i,
  ref_key: e,
  ref_for: t
}) => (typeof i == "number" && (i = "" + i), i != null ? ot(i) || At(i) || Ue(i) ? { i: ft, r: i, k: e, f: !!t } : i : null);
function w(i, e = null, t = null, n = 0, s = null, r = i === ve ? 0 : 1, a = !1, o = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: i,
    props: e,
    key: e && _f(e),
    ref: e && or(e),
    scopeId: ef,
    slotScopeIds: null,
    children: t,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: r,
    patchFlag: n,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: ft
  };
  return o ? (ul(l, t), r & 128 && i.normalize(l)) : t && (l.shapeFlag |= ot(t) ? 8 : 16), Ss > 0 && // avoid a block node from tracking itself
  !a && // has current parent block
  Ut && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (l.patchFlag > 0 || r & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  l.patchFlag !== 32 && Ut.push(l), l;
}
const de = Sg;
function Sg(i, e = null, t = null, n = 0, s = null, r = !1) {
  if ((!i || i === jp) && (i = bt), ks(i)) {
    const o = Ji(
      i,
      e,
      !0
      /* mergeRef: true */
    );
    return t && ul(o, t), Ss > 0 && !r && Ut && (o.shapeFlag & 6 ? Ut[Ut.indexOf(i)] = o : Ut.push(o)), o.patchFlag = -2, o;
  }
  if (Rg(i) && (i = i.__vccOpts), e) {
    e = kg(e);
    let { class: o, style: l } = e;
    o && !ot(o) && (e.class = Ke(o)), Ze(l) && (al(l) && !ke(l) && (l = mt({}, l)), e.style = We(l));
  }
  const a = ot(i) ? 1 : Ef(i) ? 128 : tf(i) ? 64 : Ze(i) ? 4 : Ue(i) ? 2 : 0;
  return w(
    i,
    e,
    t,
    n,
    s,
    a,
    r,
    !0
  );
}
function kg(i) {
  return i ? al(i) || gf(i) ? mt({}, i) : i : null;
}
function Ji(i, e, t = !1, n = !1) {
  const { props: s, ref: r, patchFlag: a, children: o, transition: l } = i, d = e ? Tg(s || {}, e) : s, c = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: i.type,
    props: d,
    key: d && _f(d),
    ref: e && e.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      t && r ? ke(r) ? r.concat(or(e)) : [r, or(e)] : or(e)
    ) : r,
    scopeId: i.scopeId,
    slotScopeIds: i.slotScopeIds,
    children: o,
    target: i.target,
    targetStart: i.targetStart,
    targetAnchor: i.targetAnchor,
    staticCount: i.staticCount,
    shapeFlag: i.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: e && i.type !== ve ? a === -1 ? 16 : a | 16 : a,
    dynamicProps: i.dynamicProps,
    dynamicChildren: i.dynamicChildren,
    appContext: i.appContext,
    dirs: i.dirs,
    transition: l,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: i.component,
    suspense: i.suspense,
    ssContent: i.ssContent && Ji(i.ssContent),
    ssFallback: i.ssFallback && Ji(i.ssFallback),
    el: i.el,
    anchor: i.anchor,
    ctx: i.ctx,
    ce: i.ce
  };
  return l && n && ys(
    c,
    l.clone(c)
  ), c;
}
function sn(i = " ", e = 0) {
  return de(ra, null, i, e);
}
function Af(i, e) {
  const t = de(ds, null, i);
  return t.staticCount = e, t;
}
function U(i = "", e = !1) {
  return e ? (P(), Ie(bt, null, i)) : de(bt, null, i);
}
function ci(i) {
  return i == null || typeof i == "boolean" ? de(bt) : ke(i) ? de(
    ve,
    null,
    // #3666, avoid reference pollution when reusing vnode
    i.slice()
  ) : ks(i) ? Vi(i) : de(ra, null, String(i));
}
function Vi(i) {
  return i.el === null && i.patchFlag !== -1 || i.memo ? i : Ji(i);
}
function ul(i, e) {
  let t = 0;
  const { shapeFlag: n } = i;
  if (e == null)
    e = null;
  else if (ke(e))
    t = 16;
  else if (typeof e == "object")
    if (n & 65) {
      const s = e.default;
      s && (s._c && (s._d = !1), ul(i, s()), s._c && (s._d = !0));
      return;
    } else {
      t = 32;
      const s = e._;
      !s && !gf(e) ? e._ctx = ft : s === 3 && ft && (ft.slots._ === 1 ? e._ = 1 : (e._ = 2, i.patchFlag |= 1024));
    }
  else Ue(e) ? (e = { default: e, _ctx: ft }, t = 32) : (e = String(e), n & 64 ? (t = 16, e = [sn(e)]) : t = 8);
  i.children = e, i.shapeFlag |= t;
}
function Tg(...i) {
  const e = {};
  for (let t = 0; t < i.length; t++) {
    const n = i[t];
    for (const s in n)
      if (s === "class")
        e.class !== n.class && (e.class = Ke([e.class, n.class]));
      else if (s === "style")
        e.style = We([e.style, n.style]);
      else if (Wr(s)) {
        const r = e[s], a = n[s];
        a && r !== a && !(ke(r) && r.includes(a)) && (e[s] = r ? [].concat(r, a) : a);
      } else s !== "" && (e[s] = n[s]);
  }
  return e;
}
function ri(i, e, t, n = null) {
  gi(i, e, 7, [
    t,
    n
  ]);
}
const Eg = ff();
let xg = 0;
function _g(i, e, t) {
  const n = i.type, s = (e ? e.appContext : i.appContext) || Eg, r = {
    uid: xg++,
    vnode: i,
    type: n,
    parent: e,
    appContext: s,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new lp(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: e ? e.provides : Object.create(s.provides),
    ids: e ? e.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: eg(n, s),
    emitsOptions: hg(n, s),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: Ge,
    // inheritAttrs
    inheritAttrs: n.inheritAttrs,
    // state
    ctx: Ge,
    data: Ge,
    props: Ge,
    attrs: Ge,
    slots: Ge,
    refs: Ge,
    setupState: Ge,
    setupContext: null,
    // suspense related
    suspense: t,
    suspenseId: t ? t.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return r.ctx = { _: r }, r.root = e ? e.root : r, r.emit = fg.bind(null, r), i.ce && i.ce(r), r;
}
let xt = null;
const fl = () => xt || ft;
let Er, So;
{
  const i = Qr(), e = (t, n) => {
    let s;
    return (s = i[t]) || (s = i[t] = []), s.push(n), (r) => {
      s.length > 1 ? s.forEach((a) => a(r)) : s[0](r);
    };
  };
  Er = e(
    "__VUE_INSTANCE_SETTERS__",
    (t) => xt = t
  ), So = e(
    "__VUE_SSR_SETTERS__",
    (t) => Ts = t
  );
}
const hl = (i) => {
  const e = xt;
  return Er(i), i.scope.on(), () => {
    i.scope.off(), Er(e);
  };
}, ld = () => {
  xt && xt.scope.off(), Er(null);
};
function wf(i) {
  return i.vnode.shapeFlag & 4;
}
let Ts = !1;
function Ag(i, e = !1, t = !1) {
  e && So(e);
  const { props: n, children: s } = i.vnode, r = wf(i);
  Qp(i, n, r, e), ig(i, s, t || e);
  const a = r ? wg(i, e) : void 0;
  return e && So(!1), a;
}
function wg(i, e) {
  const t = i.type;
  i.accessCache = /* @__PURE__ */ Object.create(null), i.proxy = new Proxy(i.ctx, qp);
  const { setup: n } = t;
  if (n) {
    Yi();
    const s = i.setupContext = n.length > 1 ? Ig(i) : null, r = hl(i), a = Ms(
      n,
      i,
      0,
      [
        i.props,
        s
      ]
    ), o = Au(a);
    if (Xi(), r(), (o || i.sp) && !Fn(i) && Hp(i), o) {
      if (a.then(ld, ld), e)
        return a.then((l) => {
          dd(i, l, e);
        }).catch((l) => {
          ta(l, i, 0);
        });
      i.asyncDep = a;
    } else
      dd(i, a, e);
  } else
    Lf(i, e);
}
function dd(i, e, t) {
  Ue(e) ? i.type.__ssrInlineRender ? i.ssrRender = e : i.render = e : Ze(e) && (i.setupState = qu(e)), Lf(i, t);
}
let cd;
function Lf(i, e, t) {
  const n = i.type;
  if (!i.render) {
    if (!e && cd && !n.render) {
      const s = n.template || !1;
      if (s) {
        const { isCustomElement: r, compilerOptions: a } = i.appContext.config, { delimiters: o, compilerOptions: l } = n, d = mt(
          mt(
            {
              isCustomElement: r,
              delimiters: o
            },
            a
          ),
          l
        );
        n.render = cd(s, d);
      }
    }
    i.render = n.render || ji;
  }
}
const Lg = {
  get(i, e) {
    return yt(i, "get", ""), i[e];
  }
};
function Ig(i) {
  const e = (t) => {
    i.exposed = t || {};
  };
  return {
    attrs: new Proxy(i.attrs, Lg),
    slots: i.slots,
    emit: i.emit,
    expose: e
  };
}
function aa(i) {
  return i.exposed ? i.exposeProxy || (i.exposeProxy = new Proxy(qu(Ip(i.exposed)), {
    get(e, t) {
      if (t in e)
        return e[t];
      if (t in ls)
        return ls[t](i);
    },
    has(e, t) {
      return t in e || t in ls;
    }
  })) : i.proxy;
}
function Cg(i, e = !0) {
  return Ue(i) ? i.displayName || i.name : i.name || e && i.__name;
}
function Rg(i) {
  return Ue(i) && "__vccOpts" in i;
}
const le = (i, e) => Np(i, e, Ts);
function $t(i, e, t) {
  const n = arguments.length;
  return n === 2 ? Ze(e) && !ke(e) ? ks(e) ? de(i, null, [e]) : de(i, e) : de(i, null, e) : (n > 3 ? t = Array.prototype.slice.call(arguments, 2) : n === 3 && ks(t) && (t = [t]), de(i, e, t));
}
const Pg = "3.5.17";
let ko;
const ud = typeof window < "u" && window.trustedTypes;
if (ud)
  try {
    ko = /* @__PURE__ */ ud.createPolicy("vue", {
      createHTML: (i) => i
    });
  } catch {
  }
const If = ko ? (i) => ko.createHTML(i) : (i) => i, Dg = "http://www.w3.org/2000/svg", Ng = "http://www.w3.org/1998/Math/MathML", Ai = typeof document < "u" ? document : null, fd = Ai && /* @__PURE__ */ Ai.createElement("template"), Mg = {
  insert: (i, e, t) => {
    e.insertBefore(i, t || null);
  },
  remove: (i) => {
    const e = i.parentNode;
    e && e.removeChild(i);
  },
  createElement: (i, e, t, n) => {
    const s = e === "svg" ? Ai.createElementNS(Dg, i) : e === "mathml" ? Ai.createElementNS(Ng, i) : t ? Ai.createElement(i, { is: t }) : Ai.createElement(i);
    return i === "select" && n && n.multiple != null && s.setAttribute("multiple", n.multiple), s;
  },
  createText: (i) => Ai.createTextNode(i),
  createComment: (i) => Ai.createComment(i),
  setText: (i, e) => {
    i.nodeValue = e;
  },
  setElementText: (i, e) => {
    i.textContent = e;
  },
  parentNode: (i) => i.parentNode,
  nextSibling: (i) => i.nextSibling,
  querySelector: (i) => Ai.querySelector(i),
  setScopeId(i, e) {
    i.setAttribute(e, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(i, e, t, n, s, r) {
    const a = t ? t.previousSibling : e.lastChild;
    if (s && (s === r || s.nextSibling))
      for (; e.insertBefore(s.cloneNode(!0), t), !(s === r || !(s = s.nextSibling)); )
        ;
    else {
      fd.innerHTML = If(
        n === "svg" ? `<svg>${i}</svg>` : n === "mathml" ? `<math>${i}</math>` : i
      );
      const o = fd.content;
      if (n === "svg" || n === "mathml") {
        const l = o.firstChild;
        for (; l.firstChild; )
          o.appendChild(l.firstChild);
        o.removeChild(l);
      }
      e.insertBefore(o, t);
    }
    return [
      // first
      a ? a.nextSibling : e.firstChild,
      // last
      t ? t.previousSibling : e.lastChild
    ];
  }
}, Oi = "transition", Zn = "animation", Es = Symbol("_vtc"), Cf = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, Og = /* @__PURE__ */ mt(
  {},
  nf,
  Cf
), Fg = (i) => (i.displayName = "Transition", i.props = Og, i), Rf = /* @__PURE__ */ Fg(
  (i, { slots: e }) => $t(Gp, $g(i), e)
), ln = (i, e = []) => {
  ke(i) ? i.forEach((t) => t(...e)) : i && i(...e);
}, hd = (i) => i ? ke(i) ? i.some((e) => e.length > 1) : i.length > 1 : !1;
function $g(i) {
  const e = {};
  for (const C in i)
    C in Cf || (e[C] = i[C]);
  if (i.css === !1)
    return e;
  const {
    name: t = "v",
    type: n,
    duration: s,
    enterFromClass: r = `${t}-enter-from`,
    enterActiveClass: a = `${t}-enter-active`,
    enterToClass: o = `${t}-enter-to`,
    appearFromClass: l = r,
    appearActiveClass: d = a,
    appearToClass: c = o,
    leaveFromClass: u = `${t}-leave-from`,
    leaveActiveClass: f = `${t}-leave-active`,
    leaveToClass: h = `${t}-leave-to`
  } = i, m = Bg(s), g = m && m[0], v = m && m[1], {
    onBeforeEnter: p,
    onEnter: y,
    onEnterCancelled: b,
    onLeave: k,
    onLeaveCancelled: T,
    onBeforeAppear: I = p,
    onAppear: x = y,
    onAppearCancelled: E = b
  } = e, R = (C, O, V, j) => {
    C._enterCancelled = j, dn(C, O ? c : o), dn(C, O ? d : a), V && V();
  }, A = (C, O) => {
    C._isLeaving = !1, dn(C, u), dn(C, h), dn(C, f), O && O();
  }, _ = (C) => (O, V) => {
    const j = C ? x : y, X = () => R(O, C, V);
    ln(j, [O, X]), md(() => {
      dn(O, C ? l : r), ki(O, C ? c : o), hd(j) || pd(O, n, g, X);
    });
  };
  return mt(e, {
    onBeforeEnter(C) {
      ln(p, [C]), ki(C, r), ki(C, a);
    },
    onBeforeAppear(C) {
      ln(I, [C]), ki(C, l), ki(C, d);
    },
    onEnter: _(!1),
    onAppear: _(!0),
    onLeave(C, O) {
      C._isLeaving = !0;
      const V = () => A(C, O);
      ki(C, u), C._enterCancelled, ki(C, f), md(() => {
        C._isLeaving && (dn(C, u), ki(C, h), hd(k) || pd(C, n, v, V));
      }), ln(k, [C, V]);
    },
    onEnterCancelled(C) {
      R(C, !1, void 0, !0), ln(b, [C]);
    },
    onAppearCancelled(C) {
      R(C, !0, void 0, !0), ln(E, [C]);
    },
    onLeaveCancelled(C) {
      A(C), ln(T, [C]);
    }
  });
}
function Bg(i) {
  if (i == null)
    return null;
  if (Ze(i))
    return [La(i.enter), La(i.leave)];
  {
    const e = La(i);
    return [e, e];
  }
}
function La(i) {
  return fo(i);
}
function ki(i, e) {
  e.split(/\s+/).forEach((t) => t && i.classList.add(t)), (i[Es] || (i[Es] = /* @__PURE__ */ new Set())).add(e);
}
function dn(i, e) {
  e.split(/\s+/).forEach((n) => n && i.classList.remove(n));
  const t = i[Es];
  t && (t.delete(e), t.size || (i[Es] = void 0));
}
function md(i) {
  requestAnimationFrame(() => {
    requestAnimationFrame(i);
  });
}
let Ug = 0;
function pd(i, e, t, n) {
  const s = i._endId = ++Ug, r = () => {
    s === i._endId && n();
  };
  if (t != null)
    return setTimeout(r, t);
  const { type: a, timeout: o, propCount: l } = Vg(i, e);
  if (!a)
    return n();
  const d = a + "end";
  let c = 0;
  const u = () => {
    i.removeEventListener(d, f), r();
  }, f = (h) => {
    h.target === i && ++c >= l && u();
  };
  setTimeout(() => {
    c < l && u();
  }, o + 1), i.addEventListener(d, f);
}
function Vg(i, e) {
  const t = window.getComputedStyle(i), n = (m) => (t[m] || "").split(", "), s = n(`${Oi}Delay`), r = n(`${Oi}Duration`), a = gd(s, r), o = n(`${Zn}Delay`), l = n(`${Zn}Duration`), d = gd(o, l);
  let c = null, u = 0, f = 0;
  e === Oi ? a > 0 && (c = Oi, u = a, f = r.length) : e === Zn ? d > 0 && (c = Zn, u = d, f = l.length) : (u = Math.max(a, d), c = u > 0 ? a > d ? Oi : Zn : null, f = c ? c === Oi ? r.length : l.length : 0);
  const h = c === Oi && /\b(transform|all)(,|$)/.test(
    n(`${Oi}Property`).toString()
  );
  return {
    type: c,
    timeout: u,
    propCount: f,
    hasTransform: h
  };
}
function gd(i, e) {
  for (; i.length < e.length; )
    i = i.concat(i);
  return Math.max(...e.map((t, n) => vd(t) + vd(i[n])));
}
function vd(i) {
  return i === "auto" ? 0 : Number(i.slice(0, -1).replace(",", ".")) * 1e3;
}
function Gg(i, e, t) {
  const n = i[Es];
  n && (e = (e ? [e, ...n] : [...n]).join(" ")), e == null ? i.removeAttribute("class") : t ? i.setAttribute("class", e) : i.className = e;
}
const xr = Symbol("_vod"), Pf = Symbol("_vsh"), Hg = {
  beforeMount(i, { value: e }, { transition: t }) {
    i[xr] = i.style.display === "none" ? "" : i.style.display, t && e ? t.beforeEnter(i) : Qn(i, e);
  },
  mounted(i, { value: e }, { transition: t }) {
    t && e && t.enter(i);
  },
  updated(i, { value: e, oldValue: t }, { transition: n }) {
    !e != !t && (n ? e ? (n.beforeEnter(i), Qn(i, !0), n.enter(i)) : n.leave(i, () => {
      Qn(i, !1);
    }) : Qn(i, e));
  },
  beforeUnmount(i, { value: e }) {
    Qn(i, e);
  }
};
function Qn(i, e) {
  i.style.display = e ? i[xr] : "none", i[Pf] = !e;
}
const Df = Symbol("");
function Nt(i) {
  const e = fl();
  if (!e)
    return;
  const t = e.ut = (s = i(e.proxy)) => {
    Array.from(
      document.querySelectorAll(`[data-v-owner="${e.uid}"]`)
    ).forEach((r) => _r(r, s));
  }, n = () => {
    const s = i(e.proxy);
    e.ce ? _r(e.ce, s) : To(e.subTree, s), t(s);
  };
  lf(() => {
    Zu(n);
  }), wt(() => {
    Dt(n, ji, { flush: "post" });
    const s = new MutationObserver(n);
    s.observe(e.subTree.el.parentNode, { childList: !0 }), ia(() => s.disconnect());
  });
}
function To(i, e) {
  if (i.shapeFlag & 128) {
    const t = i.suspense;
    i = t.activeBranch, t.pendingBranch && !t.isHydrating && t.effects.push(() => {
      To(t.activeBranch, e);
    });
  }
  for (; i.component; )
    i = i.component.subTree;
  if (i.shapeFlag & 1 && i.el)
    _r(i.el, e);
  else if (i.type === ve)
    i.children.forEach((t) => To(t, e));
  else if (i.type === ds) {
    let { el: t, anchor: n } = i;
    for (; t && (_r(t, e), t !== n); )
      t = t.nextSibling;
  }
}
function _r(i, e) {
  if (i.nodeType === 1) {
    const t = i.style;
    let n = "";
    for (const s in e)
      t.setProperty(`--${s}`, e[s]), n += `--${s}: ${e[s]};`;
    t[Df] = n;
  }
}
const zg = /(^|;)\s*display\s*:/;
function Kg(i, e, t) {
  const n = i.style, s = ot(t);
  let r = !1;
  if (t && !s) {
    if (e)
      if (ot(e))
        for (const a of e.split(";")) {
          const o = a.slice(0, a.indexOf(":")).trim();
          t[o] == null && lr(n, o, "");
        }
      else
        for (const a in e)
          t[a] == null && lr(n, a, "");
    for (const a in t)
      a === "display" && (r = !0), lr(n, a, t[a]);
  } else if (s) {
    if (e !== t) {
      const a = n[Df];
      a && (t += ";" + a), n.cssText = t, r = zg.test(t);
    }
  } else e && i.removeAttribute("style");
  xr in i && (i[xr] = r ? n.display : "", i[Pf] && (n.display = "none"));
}
const yd = /\s*!important$/;
function lr(i, e, t) {
  if (ke(t))
    t.forEach((n) => lr(i, e, n));
  else if (t == null && (t = ""), e.startsWith("--"))
    i.setProperty(e, t);
  else {
    const n = jg(i, e);
    yd.test(t) ? i.setProperty(
      qt(n),
      t.replace(yd, ""),
      "important"
    ) : i[n] = t;
  }
}
const bd = ["Webkit", "Moz", "ms"], Ia = {};
function jg(i, e) {
  const t = Ia[e];
  if (t)
    return t;
  let n = _t(e);
  if (n !== "filter" && n in i)
    return Ia[e] = n;
  n = Zr(n);
  for (let s = 0; s < bd.length; s++) {
    const r = bd[s] + n;
    if (r in i)
      return Ia[e] = r;
  }
  return e;
}
const Sd = "http://www.w3.org/1999/xlink";
function kd(i, e, t, n, s, r = ap(e)) {
  n && e.startsWith("xlink:") ? t == null ? i.removeAttributeNS(Sd, e.slice(6, e.length)) : i.setAttributeNS(Sd, e, t) : t == null || r && !Lu(t) ? i.removeAttribute(e) : i.setAttribute(
    e,
    r ? "" : ii(t) ? String(t) : t
  );
}
function Td(i, e, t, n, s) {
  if (e === "innerHTML" || e === "textContent") {
    t != null && (i[e] = e === "innerHTML" ? If(t) : t);
    return;
  }
  const r = i.tagName;
  if (e === "value" && r !== "PROGRESS" && // custom elements may use _value internally
  !r.includes("-")) {
    const o = r === "OPTION" ? i.getAttribute("value") || "" : i.value, l = t == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      i.type === "checkbox" ? "on" : ""
    ) : String(t);
    (o !== l || !("_value" in i)) && (i.value = l), t == null && i.removeAttribute(e), i._value = t;
    return;
  }
  let a = !1;
  if (t === "" || t == null) {
    const o = typeof i[e];
    o === "boolean" ? t = Lu(t) : t == null && o === "string" ? (t = "", a = !0) : o === "number" && (t = 0, a = !0);
  }
  try {
    i[e] = t;
  } catch {
  }
  a && i.removeAttribute(s || e);
}
function pn(i, e, t, n) {
  i.addEventListener(e, t, n);
}
function Wg(i, e, t, n) {
  i.removeEventListener(e, t, n);
}
const Ed = Symbol("_vei");
function qg(i, e, t, n, s = null) {
  const r = i[Ed] || (i[Ed] = {}), a = r[e];
  if (n && a)
    a.value = n;
  else {
    const [o, l] = Yg(e);
    if (n) {
      const d = r[e] = Qg(
        n,
        s
      );
      pn(i, o, d, l);
    } else a && (Wg(i, o, a, l), r[e] = void 0);
  }
}
const xd = /(?:Once|Passive|Capture)$/;
function Yg(i) {
  let e;
  if (xd.test(i)) {
    e = {};
    let n;
    for (; n = i.match(xd); )
      i = i.slice(0, i.length - n[0].length), e[n[0].toLowerCase()] = !0;
  }
  return [i[2] === ":" ? i.slice(3) : qt(i.slice(2)), e];
}
let Ca = 0;
const Xg = /* @__PURE__ */ Promise.resolve(), Zg = () => Ca || (Xg.then(() => Ca = 0), Ca = Date.now());
function Qg(i, e) {
  const t = (n) => {
    if (!n._vts)
      n._vts = Date.now();
    else if (n._vts <= t.attached)
      return;
    gi(
      Jg(n, t.value),
      e,
      5,
      [n]
    );
  };
  return t.value = i, t.attached = Zg(), t;
}
function Jg(i, e) {
  if (ke(e)) {
    const t = i.stopImmediatePropagation;
    return i.stopImmediatePropagation = () => {
      t.call(i), i._stopped = !0;
    }, e.map(
      (n) => (s) => !s._stopped && n && n(s)
    );
  } else
    return e;
}
const _d = (i) => i.charCodeAt(0) === 111 && i.charCodeAt(1) === 110 && // lowercase letter
i.charCodeAt(2) > 96 && i.charCodeAt(2) < 123, e0 = (i, e, t, n, s, r) => {
  const a = s === "svg";
  e === "class" ? Gg(i, n, a) : e === "style" ? Kg(i, t, n) : Wr(e) ? Qo(e) || qg(i, e, t, n, r) : (e[0] === "." ? (e = e.slice(1), !0) : e[0] === "^" ? (e = e.slice(1), !1) : t0(i, e, n, a)) ? (Td(i, e, n), !i.tagName.includes("-") && (e === "value" || e === "checked" || e === "selected") && kd(i, e, n, a, r, e !== "value")) : /* #11081 force set props for possible async custom element */ i._isVueCE && (/[A-Z]/.test(e) || !ot(n)) ? Td(i, _t(e), n, r, e) : (e === "true-value" ? i._trueValue = n : e === "false-value" && (i._falseValue = n), kd(i, e, n, a));
};
function t0(i, e, t, n) {
  if (n)
    return !!(e === "innerHTML" || e === "textContent" || e in i && _d(e) && Ue(t));
  if (e === "spellcheck" || e === "draggable" || e === "translate" || e === "autocorrect" || e === "form" || e === "list" && i.tagName === "INPUT" || e === "type" && i.tagName === "TEXTAREA")
    return !1;
  if (e === "width" || e === "height") {
    const s = i.tagName;
    if (s === "IMG" || s === "VIDEO" || s === "CANVAS" || s === "SOURCE")
      return !1;
  }
  return _d(e) && ot(t) ? !1 : e in i;
}
const Ad = {};
// @__NO_SIDE_EFFECTS__
function jn(i, e, t) {
  const n = /* @__PURE__ */ Re(i, e);
  Yr(n) && mt(n, e);
  class s extends ml {
    constructor(a) {
      super(n, a, t);
    }
  }
  return s.def = n, s;
}
const i0 = typeof HTMLElement < "u" ? HTMLElement : class {
};
class ml extends i0 {
  constructor(e, t = {}, n = Rd) {
    super(), this._def = e, this._props = t, this._createApp = n, this._isVueCE = !0, this._instance = null, this._app = null, this._nonce = this._def.nonce, this._connected = !1, this._resolved = !1, this._numberProps = null, this._styleChildren = /* @__PURE__ */ new WeakSet(), this._ob = null, this.shadowRoot && n !== Rd ? this._root = this.shadowRoot : e.shadowRoot !== !1 ? (this.attachShadow({ mode: "open" }), this._root = this.shadowRoot) : this._root = this;
  }
  connectedCallback() {
    if (!this.isConnected) return;
    !this.shadowRoot && !this._resolved && this._parseSlots(), this._connected = !0;
    let e = this;
    for (; e = e && (e.parentNode || e.host); )
      if (e instanceof ml) {
        this._parent = e;
        break;
      }
    this._instance || (this._resolved ? this._mount(this._def) : e && e._pendingResolve ? this._pendingResolve = e._pendingResolve.then(() => {
      this._pendingResolve = void 0, this._resolveDef();
    }) : this._resolveDef());
  }
  _setParent(e = this._parent) {
    e && (this._instance.parent = e._instance, this._inheritParentContext(e));
  }
  _inheritParentContext(e = this._parent) {
    e && this._app && Object.setPrototypeOf(
      this._app._context.provides,
      e._instance.provides
    );
  }
  disconnectedCallback() {
    this._connected = !1, Gt(() => {
      this._connected || (this._ob && (this._ob.disconnect(), this._ob = null), this._app && this._app.unmount(), this._instance && (this._instance.ce = void 0), this._app = this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    if (this._pendingResolve)
      return;
    for (let n = 0; n < this.attributes.length; n++)
      this._setAttr(this.attributes[n].name);
    this._ob = new MutationObserver((n) => {
      for (const s of n)
        this._setAttr(s.attributeName);
    }), this._ob.observe(this, { attributes: !0 });
    const e = (n, s = !1) => {
      this._resolved = !0, this._pendingResolve = void 0;
      const { props: r, styles: a } = n;
      let o;
      if (r && !ke(r))
        for (const l in r) {
          const d = r[l];
          (d === Number || d && d.type === Number) && (l in this._props && (this._props[l] = fo(this._props[l])), (o || (o = /* @__PURE__ */ Object.create(null)))[_t(l)] = !0);
        }
      this._numberProps = o, this._resolveProps(n), this.shadowRoot && this._applyStyles(a), this._mount(n);
    }, t = this._def.__asyncLoader;
    t ? this._pendingResolve = t().then((n) => {
      n.configureApp = this._def.configureApp, e(this._def = n, !0);
    }) : e(this._def);
  }
  _mount(e) {
    this._app = this._createApp(e), this._inheritParentContext(), e.configureApp && e.configureApp(this._app), this._app._ceVNode = this._createVNode(), this._app.mount(this._root);
    const t = this._instance && this._instance.exposed;
    if (t)
      for (const n in t)
        Oe(this, n) || Object.defineProperty(this, n, {
          // unwrap ref to be consistent with public instance behavior
          get: () => L(t[n])
        });
  }
  _resolveProps(e) {
    const { props: t } = e, n = ke(t) ? t : Object.keys(t || {});
    for (const s of Object.keys(this))
      s[0] !== "_" && n.includes(s) && this._setProp(s, this[s]);
    for (const s of n.map(_t))
      Object.defineProperty(this, s, {
        get() {
          return this._getProp(s);
        },
        set(r) {
          this._setProp(s, r, !0, !0);
        }
      });
  }
  _setAttr(e) {
    if (e.startsWith("data-v-")) return;
    const t = this.hasAttribute(e);
    let n = t ? this.getAttribute(e) : Ad;
    const s = _t(e);
    t && this._numberProps && this._numberProps[s] && (n = fo(n)), this._setProp(s, n, !1, !0);
  }
  /**
   * @internal
   */
  _getProp(e) {
    return this._props[e];
  }
  /**
   * @internal
   */
  _setProp(e, t, n = !0, s = !1) {
    if (t !== this._props[e] && (t === Ad ? delete this._props[e] : (this._props[e] = t, e === "key" && this._app && (this._app._ceVNode.key = t)), s && this._instance && this._update(), n)) {
      const r = this._ob;
      r && r.disconnect(), t === !0 ? this.setAttribute(qt(e), "") : typeof t == "string" || typeof t == "number" ? this.setAttribute(qt(e), t + "") : t || this.removeAttribute(qt(e)), r && r.observe(this, { attributes: !0 });
    }
  }
  _update() {
    const e = this._createVNode();
    this._app && (e.appContext = this._app._context), d0(e, this._root);
  }
  _createVNode() {
    const e = {};
    this.shadowRoot || (e.onVnodeMounted = e.onVnodeUpdated = this._renderSlots.bind(this));
    const t = de(this._def, mt(e, this._props));
    return this._instance || (t.ce = (n) => {
      this._instance = n, n.ce = this, n.isCE = !0;
      const s = (r, a) => {
        this.dispatchEvent(
          new CustomEvent(
            r,
            Yr(a[0]) ? mt({ detail: a }, a[0]) : { detail: a }
          )
        );
      };
      n.emit = (r, ...a) => {
        s(r, a), qt(r) !== r && s(qt(r), a);
      }, this._setParent();
    }), t;
  }
  _applyStyles(e, t) {
    if (!e) return;
    if (t) {
      if (t === this._def || this._styleChildren.has(t))
        return;
      this._styleChildren.add(t);
    }
    const n = this._nonce;
    for (let s = e.length - 1; s >= 0; s--) {
      const r = document.createElement("style");
      n && r.setAttribute("nonce", n), r.textContent = e[s], this.shadowRoot.prepend(r);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _parseSlots() {
    const e = this._slots = {};
    let t;
    for (; t = this.firstChild; ) {
      const n = t.nodeType === 1 && t.getAttribute("slot") || "default";
      (e[n] || (e[n] = [])).push(t), this.removeChild(t);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _renderSlots() {
    const e = (this._teleportTarget || this).querySelectorAll("slot"), t = this._instance.type.__scopeId;
    for (let n = 0; n < e.length; n++) {
      const s = e[n], r = s.getAttribute("name") || "default", a = this._slots[r], o = s.parentNode;
      if (a)
        for (const l of a) {
          if (t && l.nodeType === 1) {
            const d = t + "-s", c = document.createTreeWalker(l, 1);
            l.setAttribute(d, "");
            let u;
            for (; u = c.nextNode(); )
              u.setAttribute(d, "");
          }
          o.insertBefore(l, s);
        }
      else
        for (; s.firstChild; ) o.insertBefore(s.firstChild, s);
      o.removeChild(s);
    }
  }
  /**
   * @internal
   */
  _injectChildStyle(e) {
    this._applyStyles(e.styles, e);
  }
  /**
   * @internal
   */
  _removeChildStyle(e) {
  }
}
const Ar = (i) => {
  const e = i.props["onUpdate:modelValue"] || !1;
  return ke(e) ? (t) => rr(e, t) : e;
};
function n0(i) {
  i.target.composing = !0;
}
function wd(i) {
  const e = i.target;
  e.composing && (e.composing = !1, e.dispatchEvent(new Event("input")));
}
const Bn = Symbol("_assign"), s0 = {
  created(i, { modifiers: { lazy: e, trim: t, number: n } }, s) {
    i[Bn] = Ar(s);
    const r = n || s.props && s.props.type === "number";
    pn(i, e ? "change" : "input", (a) => {
      if (a.target.composing) return;
      let o = i.value;
      t && (o = o.trim()), r && (o = uo(o)), i[Bn](o);
    }), t && pn(i, "change", () => {
      i.value = i.value.trim();
    }), e || (pn(i, "compositionstart", n0), pn(i, "compositionend", wd), pn(i, "change", wd));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(i, { value: e }) {
    i.value = e ?? "";
  },
  beforeUpdate(i, { value: e, oldValue: t, modifiers: { lazy: n, trim: s, number: r } }, a) {
    if (i[Bn] = Ar(a), i.composing) return;
    const o = (r || i.type === "number") && !/^0\d/.test(i.value) ? uo(i.value) : i.value, l = e ?? "";
    o !== l && (document.activeElement === i && i.type !== "range" && (n && e === t || s && i.value.trim() === l) || (i.value = l));
  }
}, Ld = {
  // #4096 array checkboxes need to be deep traversed
  deep: !0,
  created(i, e, t) {
    i[Bn] = Ar(t), pn(i, "change", () => {
      const n = i._modelValue, s = r0(i), r = i.checked, a = i[Bn];
      if (ke(n)) {
        const o = Iu(n, s), l = o !== -1;
        if (r && !l)
          a(n.concat(s));
        else if (!r && l) {
          const d = [...n];
          d.splice(o, 1), a(d);
        }
      } else if (qr(n)) {
        const o = new Set(n);
        r ? o.add(s) : o.delete(s), a(o);
      } else
        a(Nf(i, r));
    });
  },
  // set initial checked on mount to wait for true-value/false-value
  mounted: Id,
  beforeUpdate(i, e, t) {
    i[Bn] = Ar(t), Id(i, e, t);
  }
};
function Id(i, { value: e, oldValue: t }, n) {
  i._modelValue = e;
  let s;
  if (ke(e))
    s = Iu(e, n.props.value) > -1;
  else if (qr(e))
    s = e.has(n.props.value);
  else {
    if (e === t) return;
    s = Jr(e, Nf(i, !0));
  }
  i.checked !== s && (i.checked = s);
}
function r0(i) {
  return "_value" in i ? i._value : i.value;
}
function Nf(i, e) {
  const t = e ? "_trueValue" : "_falseValue";
  return t in i ? i[t] : e;
}
const a0 = ["ctrl", "shift", "alt", "meta"], o0 = {
  stop: (i) => i.stopPropagation(),
  prevent: (i) => i.preventDefault(),
  self: (i) => i.target !== i.currentTarget,
  ctrl: (i) => !i.ctrlKey,
  shift: (i) => !i.shiftKey,
  alt: (i) => !i.altKey,
  meta: (i) => !i.metaKey,
  left: (i) => "button" in i && i.button !== 0,
  middle: (i) => "button" in i && i.button !== 1,
  right: (i) => "button" in i && i.button !== 2,
  exact: (i, e) => a0.some((t) => i[`${t}Key`] && !e.includes(t))
}, oa = (i, e) => {
  const t = i._withMods || (i._withMods = {}), n = e.join(".");
  return t[n] || (t[n] = (s, ...r) => {
    for (let a = 0; a < e.length; a++) {
      const o = o0[e[a]];
      if (o && o(s, e)) return;
    }
    return i(s, ...r);
  });
}, l0 = /* @__PURE__ */ mt({ patchProp: e0 }, Mg);
let Cd;
function Mf() {
  return Cd || (Cd = sg(l0));
}
const d0 = (...i) => {
  Mf().render(...i);
}, Rd = (...i) => {
  const e = Mf().createApp(...i), { mount: t } = e;
  return e.mount = (n) => {
    const s = u0(n);
    if (!s) return;
    const r = e._component;
    !Ue(r) && !r.render && !r.template && (r.template = s.innerHTML), s.nodeType === 1 && (s.textContent = "");
    const a = t(s, !1, c0(s));
    return s instanceof Element && (s.removeAttribute("v-cloak"), s.setAttribute("data-v-app", "")), a;
  }, e;
};
function c0(i) {
  if (i instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && i instanceof MathMLElement)
    return "mathml";
}
function u0(i) {
  return ot(i) ? document.querySelector(i) : i;
}
function f0(i, e) {
  if (!!!i)
    throw new Error(e);
}
const Of = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, h0 = new Set(Object.keys(Of));
function Pd(i) {
  const e = i?.kind;
  return typeof e == "string" && h0.has(e);
}
var Dd;
(function(i) {
  i.QUERY = "query", i.MUTATION = "mutation", i.SUBSCRIPTION = "subscription";
})(Dd || (Dd = {}));
var Eo;
(function(i) {
  i.NAME = "Name", i.DOCUMENT = "Document", i.OPERATION_DEFINITION = "OperationDefinition", i.VARIABLE_DEFINITION = "VariableDefinition", i.SELECTION_SET = "SelectionSet", i.FIELD = "Field", i.ARGUMENT = "Argument", i.FRAGMENT_SPREAD = "FragmentSpread", i.INLINE_FRAGMENT = "InlineFragment", i.FRAGMENT_DEFINITION = "FragmentDefinition", i.VARIABLE = "Variable", i.INT = "IntValue", i.FLOAT = "FloatValue", i.STRING = "StringValue", i.BOOLEAN = "BooleanValue", i.NULL = "NullValue", i.ENUM = "EnumValue", i.LIST = "ListValue", i.OBJECT = "ObjectValue", i.OBJECT_FIELD = "ObjectField", i.DIRECTIVE = "Directive", i.NAMED_TYPE = "NamedType", i.LIST_TYPE = "ListType", i.NON_NULL_TYPE = "NonNullType", i.SCHEMA_DEFINITION = "SchemaDefinition", i.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", i.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", i.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", i.FIELD_DEFINITION = "FieldDefinition", i.INPUT_VALUE_DEFINITION = "InputValueDefinition", i.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", i.UNION_TYPE_DEFINITION = "UnionTypeDefinition", i.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", i.ENUM_VALUE_DEFINITION = "EnumValueDefinition", i.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", i.DIRECTIVE_DEFINITION = "DirectiveDefinition", i.SCHEMA_EXTENSION = "SchemaExtension", i.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", i.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", i.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", i.UNION_TYPE_EXTENSION = "UnionTypeExtension", i.ENUM_TYPE_EXTENSION = "EnumTypeExtension", i.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(Eo || (Eo = {}));
function Nd(i) {
  return i === 9 || i === 32;
}
function m0(i, e) {
  const t = i.replace(/"""/g, '\\"""'), n = t.split(/\r\n|[\n\r]/g), s = n.length === 1, r = n.length > 1 && n.slice(1).every((h) => h.length === 0 || Nd(h.charCodeAt(0))), a = t.endsWith('\\"""'), o = i.endsWith('"') && !a, l = i.endsWith("\\"), d = o || l, c = (
    // add leading and trailing new lines only if it improves readability
    !s || i.length > 70 || d || r || a
  );
  let u = "";
  const f = s && Nd(i.charCodeAt(0));
  return (c && !f || r) && (u += `
`), u += t, (c || d) && (u += `
`), '"""' + u + '"""';
}
const p0 = 10, Ff = 2;
function g0(i) {
  return la(i, []);
}
function la(i, e) {
  switch (typeof i) {
    case "string":
      return JSON.stringify(i);
    case "function":
      return i.name ? `[function ${i.name}]` : "[function]";
    case "object":
      return v0(i, e);
    default:
      return String(i);
  }
}
function v0(i, e) {
  if (i === null)
    return "null";
  if (e.includes(i))
    return "[Circular]";
  const t = [...e, i];
  if (y0(i)) {
    const n = i.toJSON();
    if (n !== i)
      return typeof n == "string" ? n : la(n, t);
  } else if (Array.isArray(i))
    return S0(i, t);
  return b0(i, t);
}
function y0(i) {
  return typeof i.toJSON == "function";
}
function b0(i, e) {
  const t = Object.entries(i);
  return t.length === 0 ? "{}" : e.length > Ff ? "[" + k0(i) + "]" : "{ " + t.map(
    ([s, r]) => s + ": " + la(r, e)
  ).join(", ") + " }";
}
function S0(i, e) {
  if (i.length === 0)
    return "[]";
  if (e.length > Ff)
    return "[Array]";
  const t = Math.min(p0, i.length), n = i.length - t, s = [];
  for (let r = 0; r < t; ++r)
    s.push(la(i[r], e));
  return n === 1 ? s.push("... 1 more item") : n > 1 && s.push(`... ${n} more items`), "[" + s.join(", ") + "]";
}
function k0(i) {
  const e = Object.prototype.toString.call(i).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof i.constructor == "function") {
    const t = i.constructor.name;
    if (typeof t == "string" && t !== "")
      return t;
  }
  return e;
}
function T0(i) {
  return `"${i.replace(E0, x0)}"`;
}
const E0 = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function x0(i) {
  return _0[i.charCodeAt(0)];
}
const _0 = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], A0 = Object.freeze({});
function w0(i, e, t = Of) {
  const n = /* @__PURE__ */ new Map();
  for (const p of Object.values(Eo))
    n.set(p, L0(e, p));
  let s, r = Array.isArray(i), a = [i], o = -1, l = [], d = i, c, u;
  const f = [], h = [];
  do {
    o++;
    const p = o === a.length, y = p && l.length !== 0;
    if (p) {
      if (c = h.length === 0 ? void 0 : f[f.length - 1], d = u, u = h.pop(), y)
        if (r) {
          d = d.slice();
          let k = 0;
          for (const [T, I] of l) {
            const x = T - k;
            I === null ? (d.splice(x, 1), k++) : d[x] = I;
          }
        } else {
          d = { ...d };
          for (const [k, T] of l)
            d[k] = T;
        }
      o = s.index, a = s.keys, l = s.edits, r = s.inArray, s = s.prev;
    } else if (u) {
      if (c = r ? o : a[o], d = u[c], d == null)
        continue;
      f.push(c);
    }
    let b;
    if (!Array.isArray(d)) {
      var m, g;
      Pd(d) || f0(!1, `Invalid AST Node: ${g0(d)}.`);
      const k = p ? (m = n.get(d.kind)) === null || m === void 0 ? void 0 : m.leave : (g = n.get(d.kind)) === null || g === void 0 ? void 0 : g.enter;
      if (b = k?.call(e, d, c, u, f, h), b === A0)
        break;
      if (b === !1) {
        if (!p) {
          f.pop();
          continue;
        }
      } else if (b !== void 0 && (l.push([c, b]), !p))
        if (Pd(b))
          d = b;
        else {
          f.pop();
          continue;
        }
    }
    if (b === void 0 && y && l.push([c, d]), p)
      f.pop();
    else {
      var v;
      s = {
        inArray: r,
        index: o,
        keys: a,
        edits: l,
        prev: s
      }, r = Array.isArray(d), a = r ? d : (v = t[d.kind]) !== null && v !== void 0 ? v : [], o = -1, l = [], u && h.push(u), u = d;
    }
  } while (s !== void 0);
  return l.length !== 0 ? l[l.length - 1][1] : i;
}
function L0(i, e) {
  const t = i[e];
  return typeof t == "object" ? t : typeof t == "function" ? {
    enter: t,
    leave: void 0
  } : {
    enter: i.enter,
    leave: i.leave
  };
}
function da(i) {
  return w0(i, C0);
}
const I0 = 80, C0 = {
  Name: {
    leave: (i) => i.value
  },
  Variable: {
    leave: (i) => "$" + i.name
  },
  // Document
  Document: {
    leave: (i) => fe(i.definitions, `

`)
  },
  OperationDefinition: {
    leave(i) {
      const e = Ce("(", fe(i.variableDefinitions, ", "), ")"), t = fe(
        [
          i.operation,
          fe([i.name, e]),
          fe(i.directives, " ")
        ],
        " "
      );
      return (t === "query" ? "" : t + " ") + i.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: i, type: e, defaultValue: t, directives: n }) => i + ": " + e + Ce(" = ", t) + Ce(" ", fe(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: i }) => Qt(i)
  },
  Field: {
    leave({ alias: i, name: e, arguments: t, directives: n, selectionSet: s }) {
      const r = Ce("", i, ": ") + e;
      let a = r + Ce("(", fe(t, ", "), ")");
      return a.length > I0 && (a = r + Ce(`(
`, dr(fe(t, `
`)), `
)`)), fe([a, fe(n, " "), s], " ");
    }
  },
  Argument: {
    leave: ({ name: i, value: e }) => i + ": " + e
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: i, directives: e }) => "..." + i + Ce(" ", fe(e, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: i, directives: e, selectionSet: t }) => fe(
      [
        "...",
        Ce("on ", i),
        fe(e, " "),
        t
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: i, typeCondition: e, variableDefinitions: t, directives: n, selectionSet: s }) => (
      // or removed in the future.
      `fragment ${i}${Ce("(", fe(t, ", "), ")")} on ${e} ${Ce("", fe(n, " "), " ")}` + s
    )
  },
  // Value
  IntValue: {
    leave: ({ value: i }) => i
  },
  FloatValue: {
    leave: ({ value: i }) => i
  },
  StringValue: {
    leave: ({ value: i, block: e }) => e ? m0(i) : T0(i)
  },
  BooleanValue: {
    leave: ({ value: i }) => i ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: i }) => i
  },
  ListValue: {
    leave: ({ values: i }) => "[" + fe(i, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: i }) => "{" + fe(i, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: i, value: e }) => i + ": " + e
  },
  // Directive
  Directive: {
    leave: ({ name: i, arguments: e }) => "@" + i + Ce("(", fe(e, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: i }) => i
  },
  ListType: {
    leave: ({ type: i }) => "[" + i + "]"
  },
  NonNullType: {
    leave: ({ type: i }) => i + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: i, directives: e, operationTypes: t }) => Ce("", i, `
`) + fe(["schema", fe(e, " "), Qt(t)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: i, type: e }) => i + ": " + e
  },
  ScalarTypeDefinition: {
    leave: ({ description: i, name: e, directives: t }) => Ce("", i, `
`) + fe(["scalar", e, fe(t, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: i, name: e, interfaces: t, directives: n, fields: s }) => Ce("", i, `
`) + fe(
      [
        "type",
        e,
        Ce("implements ", fe(t, " & ")),
        fe(n, " "),
        Qt(s)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: i, name: e, arguments: t, type: n, directives: s }) => Ce("", i, `
`) + e + (Md(t) ? Ce(`(
`, dr(fe(t, `
`)), `
)`) : Ce("(", fe(t, ", "), ")")) + ": " + n + Ce(" ", fe(s, " "))
  },
  InputValueDefinition: {
    leave: ({ description: i, name: e, type: t, defaultValue: n, directives: s }) => Ce("", i, `
`) + fe(
      [e + ": " + t, Ce("= ", n), fe(s, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: i, name: e, interfaces: t, directives: n, fields: s }) => Ce("", i, `
`) + fe(
      [
        "interface",
        e,
        Ce("implements ", fe(t, " & ")),
        fe(n, " "),
        Qt(s)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: i, name: e, directives: t, types: n }) => Ce("", i, `
`) + fe(
      ["union", e, fe(t, " "), Ce("= ", fe(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: i, name: e, directives: t, values: n }) => Ce("", i, `
`) + fe(["enum", e, fe(t, " "), Qt(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: i, name: e, directives: t }) => Ce("", i, `
`) + fe([e, fe(t, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: i, name: e, directives: t, fields: n }) => Ce("", i, `
`) + fe(["input", e, fe(t, " "), Qt(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: i, name: e, arguments: t, repeatable: n, locations: s }) => Ce("", i, `
`) + "directive @" + e + (Md(t) ? Ce(`(
`, dr(fe(t, `
`)), `
)`) : Ce("(", fe(t, ", "), ")")) + (n ? " repeatable" : "") + " on " + fe(s, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: i, operationTypes: e }) => fe(
      ["extend schema", fe(i, " "), Qt(e)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: i, directives: e }) => fe(["extend scalar", i, fe(e, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: i, interfaces: e, directives: t, fields: n }) => fe(
      [
        "extend type",
        i,
        Ce("implements ", fe(e, " & ")),
        fe(t, " "),
        Qt(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: i, interfaces: e, directives: t, fields: n }) => fe(
      [
        "extend interface",
        i,
        Ce("implements ", fe(e, " & ")),
        fe(t, " "),
        Qt(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: i, directives: e, types: t }) => fe(
      [
        "extend union",
        i,
        fe(e, " "),
        Ce("= ", fe(t, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: i, directives: e, values: t }) => fe(["extend enum", i, fe(e, " "), Qt(t)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: i, directives: e, fields: t }) => fe(["extend input", i, fe(e, " "), Qt(t)], " ")
  }
};
function fe(i, e = "") {
  var t;
  return (t = i?.filter((n) => n).join(e)) !== null && t !== void 0 ? t : "";
}
function Qt(i) {
  return Ce(`{
`, dr(fe(i, `
`)), `
}`);
}
function Ce(i, e, t = "") {
  return e != null && e !== "" ? i + e + t : "";
}
function dr(i) {
  return Ce("  ", i.replace(/\n/g, `
  `));
}
function Md(i) {
  var e;
  return (e = i?.some((t) => t.includes(`
`))) !== null && e !== void 0 ? e : !1;
}
const F = Zi({
  permanentShopDomain: window.Shopify?.shop,
  locale: window.Shopify?.locale,
  localizationCountry: window.Shopify?.country,
  currencyIsoCode: window.Shopify?.currency?.active,
  mobileBreakpoint: 749,
  tabletBreakpoint: 1249,
  desktopBreakpoint: 1280,
  wishlist: [],
  productView: {
    product: null,
    selectedVariant: {
      variant: null,
      get isPreorder() {
        return !!this.variant?.preorderMetafield?.value;
      }
    },
    get targetVariant() {
      return this.selectedVariant.variant || this.product?.variants?.nodes[0] || null;
    }
  }
}), ca = "GraphQL Client", Od = 0, Fd = 3, $f = "An error occurred while fetching from the API. Review 'graphQLErrors' for details.", Bf = "Response returned unexpected Content-Type:", Uf = "An unknown error has occurred. The API did not return a data object or any errors in its response.", xo = {
  json: "application/json",
  multipart: "multipart/mixed"
}, $d = "X-SDK-Variant", Bd = "X-SDK-Version", R0 = "shopify-graphql-client", P0 = "1.4.0", Vf = 1e3, D0 = [429, 503], Gf = /@(defer)\b/i, Ud = `\r
`, N0 = /boundary="?([^=";]+)"?/i, Vd = Ud + Ud;
function qi(i, e = ca) {
  return i.startsWith(`${e}`) ? i : `${e}: ${i}`;
}
function Wn(i) {
  return i instanceof Error ? i.message : JSON.stringify(i);
}
function Hf(i) {
  return i instanceof Error && i.cause ? i.cause : void 0;
}
function zf(i) {
  return i.flatMap(({ errors: e }) => e ?? []);
}
function Kf({ client: i, retries: e }) {
  if (e !== void 0 && (typeof e != "number" || e < Od || e > Fd))
    throw new Error(`${i}: The provided "retries" value (${e}) is invalid - it cannot be less than ${Od} or greater than ${Fd}`);
}
function Pt(i, e) {
  return e && (typeof e != "object" || Array.isArray(e) || typeof e == "object" && Object.keys(e).length > 0) ? { [i]: e } : {};
}
function jf(i, e) {
  if (i.length === 0)
    return e;
  const n = {
    [i.pop()]: e
  };
  return i.length === 0 ? n : jf(i, n);
}
function Wf(i, e) {
  return Object.keys(e || {}).reduce((t, n) => (typeof e[n] == "object" || Array.isArray(e[n])) && i[n] ? (t[n] = Wf(i[n], e[n]), t) : (t[n] = e[n], t), Array.isArray(i) ? [...i] : { ...i });
}
function qf([i, ...e]) {
  return e.reduce(Wf, { ...i });
}
function M0({ clientLogger: i, customFetchApi: e = fetch, client: t = ca, defaultRetryWaitTime: n = Vf, retriableCodes: s = D0 }) {
  const r = async (a, o, l) => {
    const d = o + 1, c = l + 1;
    let u;
    try {
      if (u = await e(...a), i({
        type: "HTTP-Response",
        content: {
          requestParams: a,
          response: u
        }
      }), !u.ok && s.includes(u.status) && d <= c)
        throw new Error();
      const f = u?.headers.get("X-Shopify-API-Deprecated-Reason") || "";
      return f && i({
        type: "HTTP-Response-GraphQL-Deprecation-Notice",
        content: {
          requestParams: a,
          deprecationNotice: f
        }
      }), u;
    } catch (f) {
      if (d <= c) {
        const h = u?.headers.get("Retry-After");
        return await O0(h ? parseInt(h, 10) : n), i({
          type: "HTTP-Retry",
          content: {
            requestParams: a,
            lastResponse: u,
            retryAttempt: o,
            maxRetries: l
          }
        }), r(a, d, l);
      }
      throw new Error(qi(`${l > 0 ? `Attempted maximum number of ${l} network retries. Last message - ` : ""}${Wn(f)}`, t));
    }
  };
  return r;
}
async function O0(i) {
  return new Promise((e) => setTimeout(e, i));
}
function F0({ headers: i, url: e, customFetchApi: t = fetch, retries: n = 0, logger: s }) {
  Kf({ client: ca, retries: n });
  const r = {
    headers: i,
    url: e,
    retries: n
  }, a = $0(s), o = M0({
    customFetchApi: t,
    clientLogger: a,
    defaultRetryWaitTime: Vf
  }), l = B0(o, r), d = U0(l), c = W0(l);
  return {
    config: r,
    fetch: l,
    request: d,
    requestStream: c
  };
}
function $0(i) {
  return (e) => {
    i && i(e);
  };
}
async function Yf(i) {
  const { errors: e, data: t, extensions: n } = await i.json();
  return {
    ...Pt("data", t),
    ...Pt("extensions", n),
    headers: i.headers,
    ...e || !t ? {
      errors: {
        networkStatusCode: i.status,
        message: qi(e ? $f : Uf),
        ...Pt("graphQLErrors", e),
        response: i
      }
    } : {}
  };
}
function B0(i, { url: e, headers: t, retries: n }) {
  return async (s, r = {}) => {
    const { variables: a, headers: o, url: l, retries: d, keepalive: c, signal: u } = r, f = JSON.stringify({
      query: s,
      variables: a
    });
    Kf({ client: ca, retries: d });
    const h = Object.entries({
      ...t,
      ...o
    }).reduce((g, [v, p]) => (g[v] = Array.isArray(p) ? p.join(", ") : p.toString(), g), {});
    return !h[$d] && !h[Bd] && (h[$d] = R0, h[Bd] = P0), i([
      l ?? e,
      {
        method: "POST",
        headers: h,
        body: f,
        signal: u,
        keepalive: c
      }
    ], 1, d ?? n);
  };
}
function U0(i) {
  return async (...e) => {
    if (Gf.test(e[0]))
      throw new Error(qi("This operation will result in a streamable response - use requestStream() instead."));
    try {
      const t = await i(...e), { status: n, statusText: s } = t, r = t.headers.get("content-type") || "";
      return t.ok ? r.includes(xo.json) ? Yf(t) : {
        errors: {
          networkStatusCode: n,
          message: qi(`${Bf} ${r}`),
          response: t
        }
      } : {
        errors: {
          networkStatusCode: n,
          message: qi(s),
          response: t
        }
      };
    } catch (t) {
      return {
        errors: {
          message: Wn(t)
        }
      };
    }
  };
}
async function* V0(i) {
  const e = new TextDecoder();
  if (i.body[Symbol.asyncIterator])
    for await (const t of i.body)
      yield e.decode(t);
  else {
    const t = i.body.getReader();
    let n;
    try {
      for (; !(n = await t.read()).done; )
        yield e.decode(n.value);
    } finally {
      t.cancel();
    }
  }
}
function G0(i, e) {
  return {
    async *[Symbol.asyncIterator]() {
      try {
        let t = "";
        for await (const n of i)
          if (t += n, t.indexOf(e) > -1) {
            const s = t.lastIndexOf(e), a = t.slice(0, s).split(e).filter((o) => o.trim().length > 0).map((o) => o.slice(o.indexOf(Vd) + Vd.length).trim());
            a.length > 0 && (yield a), t = t.slice(s + e.length), t.trim() === "--" && (t = "");
          }
      } catch (t) {
        throw new Error(`Error occured while processing stream payload - ${Wn(t)}`);
      }
    }
  };
}
function H0(i) {
  return {
    async *[Symbol.asyncIterator]() {
      yield {
        ...await Yf(i),
        hasNext: !1
      };
    }
  };
}
function z0(i) {
  return i.map((e) => {
    try {
      return JSON.parse(e);
    } catch (t) {
      throw new Error(`Error in parsing multipart response - ${Wn(t)}`);
    }
  }).map((e) => {
    const { data: t, incremental: n, hasNext: s, extensions: r, errors: a } = e;
    if (!n)
      return {
        data: t || {},
        ...Pt("errors", a),
        ...Pt("extensions", r),
        hasNext: s
      };
    const o = n.map(({ data: l, path: d, errors: c }) => ({
      data: l && d ? jf(d, l) : {},
      ...Pt("errors", c)
    }));
    return {
      data: o.length === 1 ? o[0].data : qf([
        ...o.map(({ data: l }) => l)
      ]),
      ...Pt("errors", zf(o)),
      hasNext: s
    };
  });
}
function K0(i, e) {
  if (i.length > 0)
    throw new Error($f, {
      cause: {
        graphQLErrors: i
      }
    });
  if (Object.keys(e).length === 0)
    throw new Error(Uf);
}
function j0(i, e) {
  const t = (e ?? "").match(N0), n = `--${t ? t[1] : "-"}`;
  if (!i.body?.getReader && !i.body?.[Symbol.asyncIterator])
    throw new Error("API multipart response did not return an iterable body", {
      cause: i
    });
  const s = V0(i);
  let r = {}, a;
  return {
    async *[Symbol.asyncIterator]() {
      try {
        let o = !0;
        for await (const l of G0(s, n)) {
          const d = z0(l);
          a = d.find((u) => u.extensions)?.extensions ?? a;
          const c = zf(d);
          r = qf([
            r,
            ...d.map(({ data: u }) => u)
          ]), o = d.slice(-1)[0].hasNext, K0(c, r), yield {
            ...Pt("data", r),
            ...Pt("extensions", a),
            hasNext: o
          };
        }
        if (o)
          throw new Error("Response stream terminated unexpectedly");
      } catch (o) {
        const l = Hf(o);
        yield {
          ...Pt("data", r),
          ...Pt("extensions", a),
          errors: {
            message: qi(Wn(o)),
            networkStatusCode: i.status,
            ...Pt("graphQLErrors", l?.graphQLErrors),
            response: i
          },
          hasNext: !1
        };
      }
    }
  };
}
function W0(i) {
  return async (...e) => {
    if (!Gf.test(e[0]))
      throw new Error(qi("This operation does not result in a streamable response - use request() instead."));
    try {
      const t = await i(...e), { statusText: n } = t;
      if (!t.ok)
        throw new Error(n, { cause: t });
      const s = t.headers.get("content-type") || "";
      switch (!0) {
        case s.includes(xo.json):
          return H0(t);
        case s.includes(xo.multipart):
          return j0(t, s);
        default:
          throw new Error(`${Bf} ${s}`, { cause: t });
      }
    } catch (t) {
      return {
        async *[Symbol.asyncIterator]() {
          const n = Hf(t);
          yield {
            errors: {
              message: qi(Wn(t)),
              ...Pt("networkStatusCode", n?.status),
              ...Pt("response", n)
            },
            hasNext: !1
          };
        }
      };
    }
  };
}
function q0({ client: i, storeDomain: e }) {
  try {
    if (!e || typeof e != "string")
      throw new Error();
    const t = e.trim(), n = t.match(/^https?:/) ? t : `https://${t}`, s = new URL(n);
    return s.protocol = "https", s.origin;
  } catch (t) {
    throw new Error(`${i}: a valid store domain ("${e}") must be provided`, { cause: t });
  }
}
function Xf({ client: i, currentSupportedApiVersions: e, apiVersion: t, logger: n }) {
  const s = `${i}: the provided apiVersion ("${t}")`, r = `Currently supported API versions: ${e.join(", ")}`;
  if (!t || typeof t != "string")
    throw new Error(`${s} is invalid. ${r}`);
  const a = t.trim();
  e.includes(a) || (n ? n({
    type: "Unsupported_Api_Version",
    content: {
      apiVersion: t,
      supportedApiVersions: e
    }
  }) : console.warn(`${s} is likely deprecated or not supported. ${r}`));
}
function wr(i) {
  const e = i * 3 - 2;
  return e === 10 ? e : `0${e}`;
}
function Ra(i, e, t) {
  const n = e - t;
  return n <= 0 ? `${i - 1}-${wr(n + 4)}` : `${i}-${wr(n)}`;
}
function Y0() {
  const i = /* @__PURE__ */ new Date(), e = i.getUTCMonth(), t = i.getUTCFullYear(), n = Math.floor(e / 3 + 1);
  return {
    year: t,
    quarter: n,
    version: `${t}-${wr(n)}`
  };
}
function X0() {
  const { year: i, quarter: e, version: t } = Y0(), n = e === 4 ? `${i + 1}-01` : `${i}-${wr(e + 1)}`;
  return [
    Ra(i, e, 3),
    Ra(i, e, 2),
    Ra(i, e, 1),
    t,
    n,
    "unstable"
  ];
}
function Z0(i) {
  return (e) => ({ ...e ?? {}, ...i.headers });
}
function Q0({ getHeaders: i, getApiUrl: e }) {
  return (t, n) => {
    const s = [t];
    if (n && Object.keys(n).length > 0) {
      const { variables: r, apiVersion: a, headers: o, retries: l } = n;
      s.push({
        ...r ? { variables: r } : {},
        ...o ? { headers: i(o) } : {},
        ...a ? { url: e(a) } : {},
        ...l ? { retries: l } : {}
      });
    }
    return s;
  };
}
const Gd = "application/json", J0 = "storefront-api-client", ev = "1.0.8", tv = "X-Shopify-Storefront-Access-Token", iv = "Shopify-Storefront-Private-Token", nv = "X-SDK-Variant", sv = "X-SDK-Version", rv = "X-SDK-Variant-Source", xs = "Storefront API Client";
function av(i) {
  if (i && typeof window < "u")
    throw new Error(`${xs}: private access tokens and headers should only be used in a server-to-server implementation. Use the public API access token in nonserver environments.`);
}
function ov(i, e) {
  if (!i && !e)
    throw new Error(`${xs}: a public or private access token must be provided`);
  if (i && e)
    throw new Error(`${xs}: only provide either a public or private access token`);
}
function lv({ storeDomain: i, apiVersion: e, publicAccessToken: t, privateAccessToken: n, clientName: s, retries: r = 0, customFetchApi: a, logger: o }) {
  const l = X0(), d = q0({
    client: xs,
    storeDomain: i
  }), c = {
    client: xs,
    currentSupportedApiVersions: l,
    logger: o
  };
  Xf({ ...c, apiVersion: e }), ov(t, n), av(n);
  const u = dv(d, e, c), f = {
    storeDomain: d,
    apiVersion: e,
    ...t ? { publicAccessToken: t } : {
      privateAccessToken: n
    },
    headers: {
      "Content-Type": Gd,
      Accept: Gd,
      [nv]: J0,
      [sv]: ev,
      ...s ? { [rv]: s } : {},
      ...t ? { [tv]: t } : { [iv]: n }
    },
    apiUrl: u(),
    clientName: s
  }, h = F0({
    headers: f.headers,
    url: f.apiUrl,
    retries: r,
    customFetchApi: a,
    logger: o
  }), m = Z0(f), g = cv(f, u), v = Q0({
    getHeaders: m,
    getApiUrl: g
  });
  return Object.freeze({
    config: f,
    getHeaders: m,
    getApiUrl: g,
    fetch: (...y) => h.fetch(...v(...y)),
    request: (...y) => h.request(...v(...y)),
    requestStream: (...y) => h.requestStream(...v(...y))
  });
}
function dv(i, e, t) {
  return (n) => {
    n && Xf({
      ...t,
      apiVersion: n
    });
    const s = (n ?? e).trim();
    return `${i}/api/${s}/graphql.json`;
  };
}
function cv(i, e) {
  return (t) => t ? e(t) : i.apiUrl;
}
var Hd;
(function(i) {
  i[i.Error = 0] = "Error", i[i.Warning = 1] = "Warning", i[i.Info = 2] = "Info", i[i.Debug = 3] = "Debug";
})(Hd || (Hd = {}));
var _o;
(function(i) {
  i.October22 = "2022-10", i.January23 = "2023-01", i.April23 = "2023-04", i.July23 = "2023-07", i.October23 = "2023-10", i.January24 = "2024-01", i.April24 = "2024-04", i.July24 = "2024-07", i.October24 = "2024-10", i.January25 = "2025-01", i.April25 = "2025-04", i.July25 = "2025-07", i.Unstable = "unstable";
})(_o || (_o = {}));
const uv = _o.April25;
var zd;
(function(i) {
  i.AccessToken = "X-Shopify-Access-Token", i.ApiVersion = "X-Shopify-API-Version", i.Domain = "X-Shopify-Shop-Domain", i.Hmac = "X-Shopify-Hmac-Sha256", i.Topic = "X-Shopify-Topic", i.SubTopic = "X-Shopify-Sub-Topic", i.WebhookId = "X-Shopify-Webhook-Id", i.StorefrontPrivateToken = "Shopify-Storefront-Private-Token", i.StorefrontSDKVariant = "X-SDK-Variant", i.StorefrontSDKVersion = "X-SDK-Version";
})(zd || (zd = {}));
var Kd;
(function(i) {
  i.Rest = "rest", i.Graphql = "graphql";
})(Kd || (Kd = {}));
var jd;
(function(i) {
  i.OneTime = "ONE_TIME", i.Every30Days = "EVERY_30_DAYS", i.Annual = "ANNUAL", i.Usage = "USAGE";
})(jd || (jd = {}));
var Wd;
(function(i) {
  i.ApplyImmediately = "APPLY_IMMEDIATELY", i.ApplyOnNextBillingCycle = "APPLY_ON_NEXT_BILLING_CYCLE", i.Standard = "STANDARD";
})(Wd || (Wd = {}));
const fv = {
  "pccha.myshopify.com": "e938b01a32921fe5816fc7cf9887156b",
  "pccha-eu.myshopify.com": "0eb8481950fc6a0c1c7426a70b376611",
  "polo-club-uk.myshopify.com": "1a913cea4c3bd8865edb3b2c8489f6e4",
  "polo-club-test.myshopify.com": "a25f914d823485e25ae528c6d794c92b"
}, ua = () => {
  const { permanentShopDomain: i } = F;
  if (!i)
    throw new Error("Shop domain is required");
  const e = fv[i] || null;
  if (!e)
    throw new Error(`Storefront access token is not configured for shop domain: ${i}`);
  return lv({
    storeDomain: i,
    apiVersion: uv,
    publicAccessToken: e
  });
}, hv = { definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ProductViewFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Product" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "handle" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "title" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "description" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "tags" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "vendor" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "productType" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "locMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "loc", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "colorMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "color", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "filterColorMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "filters", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "color", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "relatedProductsCollection" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "related", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "collection", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "promotionDateMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "promo", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "date", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reference" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Metaobject" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "initDate" }, name: { kind: "Name", value: "field" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "init_date", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "endDate" }, name: { kind: "Name", value: "field" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "end_date", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "cutMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "cut", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "compositionMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "composition", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "productActionMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "product_action", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "modelMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "model", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "modelSizeMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "model_size", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "backInStockMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "extra", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "back_in_stock", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "careInfoMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "care", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "info", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "careIconsMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "care", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "icons", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "productLabelsMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "extra", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "label", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "showProductSizeWarning" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "custom", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "product_size_warning", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "returnsSpecialConditions" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "returns", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "productCategory" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "category", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "caresInfoMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "care", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "references" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxCares" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Metaobject" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "icon" }, name: { kind: "Name", value: "field" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "file", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reference" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MediaImage" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "altText" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "url" }, arguments: [], directives: [] }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "description" }, name: { kind: "Name", value: "field" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "description", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "selectedOrFirstAvailableVariant" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "title" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "price" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "currencyCode" }, arguments: [], directives: [] }] } }, { kind: "Field", name: { kind: "Name", value: "compareAtPrice" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "currencyCode" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "highlightedPriceMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "price", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "highlighted", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "privatePriceMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "private", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "price", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "privateFontColorMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "private", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "font_color", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "privateBgColorMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "private", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "background_color", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }] } }, { kind: "Field", name: { kind: "Name", value: "featuredImage" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "altText" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "url" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "desktop" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "800" } }] } }], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "tablet" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "700" } }] } }], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "mobile" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "500" } }] } }], directives: [] }, { kind: "Field", name: { kind: "Name", value: "width" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "height" }, arguments: [], directives: [] }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxMedia" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "previewImage" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "altText" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "url" }, arguments: [], directives: [] }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MediaImage" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "altText" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "url" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "desktop" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "800" } }] } }], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "tablet" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "700" } }] } }], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "mobile" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "500" } }] } }], directives: [] }, { kind: "Field", name: { kind: "Name", value: "width" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "height" }, arguments: [], directives: [] }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Video" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sources" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "format" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "width" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "height" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "mimeType" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "url" }, arguments: [], directives: [] }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "colorsMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "related", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "colors", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "references" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxColors" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Product" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableForSale" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "title" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "tags" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "colorMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "color", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", name: { kind: "Name", value: "images" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxMedia" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "altText" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "url" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "desktop" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "800" } }] } }], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "tablet" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "700" } }] } }], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "mobile" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "500" } }] } }], directives: [] }, { kind: "Field", name: { kind: "Name", value: "width" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "height" }, arguments: [], directives: [] }] } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "variants" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxVariants" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "title" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "availableForSale" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "quantityAvailable" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "sku" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "price" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "currencyCode" }, arguments: [], directives: [] }] } }, { kind: "Field", name: { kind: "Name", value: "compareAtPrice" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "currencyCode" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "highlightedPriceMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "price", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "highlighted", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "privateFontColorMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "private", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "font_color", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "privatePriceMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "markets", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "private_price_default", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "privatePriceMetafieldPolonia" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "markets", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "private_price_polonia", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "middlePriceMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "markets", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "middle_price_default", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "middlePriceMetafieldPolonia" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "markets", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "middle_price_polonia", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "privateBgColorMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "private", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "background_color", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "envio5_7_diasMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "envio", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "envio5_a_7_dias", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "backInStockMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "extra", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "back_in_stock", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "lastUnitsMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "extra", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "last_units", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "showSimilarMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "extra", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "show_similar", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "mainStockMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "stock", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "main", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "reserveStockMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "stock", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "reserve", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "preorderMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "extra", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "preorder", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "reference" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Metaobject" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "date" }, name: { kind: "Name", value: "field" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "date", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "previewText" }, name: { kind: "Name", value: "field" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "preview_text", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "text" }, name: { kind: "Name", value: "field" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "text", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "partialShipping" }, name: { kind: "Name", value: "field" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "partial_shipping", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }] } }] } }] } }] } }] } }] } }] }, mv = `#import "./fragments/productViewFields.graphql"

query GetProductView(
  $productGid: ID
  $productHandle: String!
  $useGid: Boolean!
  $useHandle: Boolean!
  $country: CountryCode!
  $locale: LanguageCode!
  $maxVariants: Int!
  $maxMedia: Int!
  $maxColors: Int!
  $maxCares: Int!
) @inContext(country: $country, language: $locale) {
  productById: product(id: $productGid) @include(if: $useGid) {
    ...ProductViewFields
  }
  productByHandle: productByHandle(handle: $productHandle) @include(if: $useHandle) {
    ...ProductViewFields
  }
} `, Lr = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "GetProductView" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productGid" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productHandle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "useGid" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "useHandle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "country" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CountryCode" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LanguageCode" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxVariants" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxMedia" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxColors" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxCares" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }], directives: [{ kind: "Directive", name: { kind: "Name", value: "inContext" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "country" }, value: { kind: "Variable", name: { kind: "Name", value: "country" } } }, { kind: "Argument", name: { kind: "Name", value: "language" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "productById" }, name: { kind: "Name", value: "product" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "productGid" } } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "useGid" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProductViewFields" }, directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "productByHandle" }, name: { kind: "Name", value: "productByHandle" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "handle" }, value: { kind: "Variable", name: { kind: "Name", value: "productHandle" } } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "useHandle" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProductViewFields" }, directives: [] }] } }] } }], loc: { start: 0, end: 585, source: { name: "GraphQL request", locationOffset: { line: 1, column: 1 }, body: mv } } }, pv = (i) => {
  const e = {};
  return i.filter(function(t) {
    if (t.kind !== "FragmentDefinition")
      return !0;
    const n = t.name.value;
    return e[n] ? !1 : (e[n] = !0, !0);
  });
};
Lr.definitions = pv(Lr.definitions.concat(hv.definitions));
const gv = (i, e) => {
  const t = (c, u) => {
    if (c.kind === "FragmentSpread")
      u.add(c.name.value);
    else if (c.kind === "VariableDefinition") {
      const f = c.type;
      f.kind === "NamedType" && u.add(f.name.value);
    }
    return c && "selectionSet" in c && c.selectionSet && c.selectionSet.selections.forEach((f) => {
      t(f, u);
    }), c && "variableDefinitions" in c && c.variableDefinitions && c.variableDefinitions.forEach((f) => {
      t(f, u);
    }), c && "definitions" in c && c.definitions && c.definitions.forEach((f) => {
      t(f, u);
    }), u;
  }, n = (c) => {
    const u = {};
    return c.definitions.forEach(function(f) {
      "name" in f && f.name && (u[f.name.value] = t(f, /* @__PURE__ */ new Set()));
    }), u;
  }, s = (c, u) => {
    for (let f = 0; f < c.definitions.length; f++) {
      const h = c.definitions[f];
      if (h && "name" in h && h.name && h.name.value == u)
        return h;
    }
  }, r = n(i), a = Object.assign({}, i, {
    definitions: [s(i, e)]
  }), o = r[e] || /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set();
  let d = /* @__PURE__ */ new Set();
  for (o.forEach((c) => {
    d.add(c);
  }); d.size > 0; ) {
    const c = d;
    d = /* @__PURE__ */ new Set(), c.forEach((u) => {
      l.has(u) || (l.add(u), (r[u] || /* @__PURE__ */ new Set()).forEach((h) => {
        d.add(h);
      }));
    });
  }
  return l.forEach((c) => {
    const u = s(i, c);
    u && a.definitions.push(u);
  }), a;
};
gv(Lr, "GetProductView");
const vv = 50, yv = 25, bv = 50, Sv = 5, pl = async ({
  productIdentifier: i
}) => {
  if (!i) return null;
  const e = ua();
  if (!e) throw new Error("Shopify client not initialized");
  const t = typeof i == "string" && i.startsWith("gid://"), n = {
    productGid: t ? i : void 0,
    productHandle: t ? "" : i,
    useGid: t,
    useHandle: !t,
    country: F.localizationCountry,
    locale: F.locale.replace(/-/g, "_").toUpperCase(),
    maxVariants: vv,
    maxMedia: yv,
    maxColors: bv,
    maxCares: Sv,
    maxRelatedProducts: 12
  };
  try {
    const s = da(Lr), r = await e.request(
      s,
      {
        variables: n
      }
    ), a = r.data?.productById || r.data?.productByHandle;
    return Array.isArray(r.errors?.graphQLErrors) && r.errors.graphQLErrors.length > 0 && console.error("GraphQL errors:", r.errors.graphQLErrors), a || (console.warn(`Product with identifier ${i} not found`), null);
  } catch (s) {
    return console.error(`Error fetching product ${i}:`, s), null;
  }
}, qd = document.querySelector("#poloclub-shop"), kv = qd ? JSON.parse(qd.textContent || "{}") : {}, Yd = document.querySelector("#poloclub-template"), yn = Yd ? JSON.parse(Yd.textContent || "{}") : {}, Xd = document.querySelector("#poloclub-settings"), he = Xd ? JSON.parse(Xd.textContent || "{}") : {}, Zd = document.querySelector("#poloclub-customer"), St = Zd ? JSON.parse(Zd.textContent || "{}") : {}, Qd = document.querySelector("#product-gid"), Tv = Qd ? JSON.parse(Qd.textContent || "{}") : {}, Jd = document.querySelector("#poloclub-translations"), Je = Jd ? JSON.parse(Jd.textContent || "{}") : {}, Zf = async (i = Tv) => {
  try {
    const e = await pl({
      productIdentifier: i
    });
    if (e)
      return F.productView.product = e, e;
  } catch (e) {
    console.error("Error updating store with product:", e);
  }
}, Ev = () => {
  if (typeof window > "u") return "";
  const e = window.location.pathname.split("/")[1]?.toLowerCase() || "";
  return /^[a-z]{2}(-[a-z]{2})?$/.test(e) ? `/${e}` : "";
}, Qf = (i, e) => {
  const { absoluteWhenNoLocale: t = !0 } = e || {}, n = Ev();
  if (n)
    return `${n}${i}`;
  if (t && typeof window < "u")
    try {
      return new URL(i, window.location.origin).href;
    } catch {
      return i;
    }
  return i;
}, fa = (i = {}) => {
  const e = (i.basePath ?? "/products").replace(/\/+$/, ""), t = i.sectionSelectors ?? [".collection-look-section"];
  let n = null, s = !1, r = null;
  const a = history.pushState.bind(history), o = history.replaceState.bind(history), l = () => typeof window < "u" && typeof document < "u", d = (k) => {
    const T = k.replace(/\/+$/, "");
    if (!T.startsWith(e + "/")) return null;
    const I = T.split("/");
    return I[I.length - 1] || null;
  }, c = (k) => {
    const T = `${e}/${encodeURIComponent(k)}`;
    return Qf(T);
  }, u = (k) => d(window.location.pathname) === k, f = () => {
    const k = /* @__PURE__ */ new Set();
    for (const T of t) {
      const I = document.querySelector(T);
      if (!I) continue;
      const x = I.id?.startsWith("shopify-section-") ? I.id.replace("shopify-section-", "") : null;
      x && k.add(x);
    }
    return Array.from(k);
  }, h = async () => {
    if (!l()) return;
    const k = f();
    if (k.length === 0) return;
    r && r.abort(), r = new AbortController();
    const T = window.location.pathname, I = new URL(T, window.location.origin);
    for (const x of k) I.searchParams.append("section_id", x);
    try {
      const x = await fetch(I.toString(), { signal: r.signal });
      if (!x.ok) throw new Error(`HTTP ${x.status}`);
      const E = await x.text(), R = document.createElement("div");
      R.innerHTML = E;
      for (const A of k) {
        const _ = R.querySelector(`#shopify-section-${A}`), C = document.querySelector(`#shopify-section-${A}`);
        C && _ ? C.innerHTML = _.innerHTML : C && !_ ? C.remove() : !C && _ && document.body.appendChild(_);
      }
    } catch (x) {
      x?.name !== "AbortError" && console.error("[useProductNavigation] updateSections error:", x);
    }
  }, m = async (k) => {
    if (!(!k || !l()))
      try {
        const T = await Zf(k);
        if (T?.handle && (n = T.handle, !u(T.handle))) {
          s = !0;
          const I = c(T.handle);
          a({ __internalProductNav: !0, path: I }, "", I), window.dispatchEvent(new Event("custom-route-change")), queueMicrotask(() => {
            s = !1;
          });
        }
      } catch (T) {
        console.error("[useProductNavigation] setProduct error:", T);
      }
  }, g = async () => {
    if (!l() || s) return;
    const k = d(window.location.pathname);
    k && (k !== n && (n = k, await m(k)), await h());
  }, v = () => {
    history.pushState = function(k, T, I) {
      a(k, T, I), window.dispatchEvent(new Event("custom-route-change"));
    }, history.replaceState = function(k, T, I) {
      o(k, T, I), window.dispatchEvent(new Event("custom-route-change"));
    };
  }, p = () => {
    window.addEventListener("popstate", g), window.addEventListener("custom-route-change", g);
  }, y = () => {
    l() && (n = d(window.location.pathname));
  };
  return {
    setProduct: m,
    initializeNavigation: () => {
      l() && (y(), v(), p(), g());
    }
  };
}, Pe = (i, e) => {
  const t = i.__vccOpts || i;
  for (const [n, s] of e)
    t[n] = s;
  return t;
}, xv = {}, _v = {
  "aria-hidden": "true",
  focusable: "false",
  role: "presentation",
  class: "icon icon-plus",
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Av(i, e) {
  return P(), N("svg", _v, e[0] || (e[0] = [
    w("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.66724 7.93978C4.66655 7.66364 4.88984 7.43922 5.16598 7.43853L10.6996 7.42464C10.9758 7.42395 11.2002 7.64724 11.2009 7.92339C11.2016 8.19953 10.9783 8.42395 10.7021 8.42464L5.16849 8.43852C4.89235 8.43922 4.66793 8.21592 4.66724 7.93978Z",
      fill: "currentColor"
    }, null, -1),
    w("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.92576 4.66463C8.2019 4.66394 8.42632 4.88723 8.42702 5.16337L8.4409 10.697C8.44159 10.9732 8.2183 11.1976 7.94215 11.1983C7.66601 11.199 7.44159 10.9757 7.4409 10.6995L7.42702 5.16588C7.42633 4.88974 7.64962 4.66532 7.92576 4.66463Z",
      fill: "currentColor"
    }, null, -1),
    w("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.8324 3.03011C10.1255 0.323296 5.73693 0.323296 3.03011 3.03011C0.323296 5.73693 0.323296 10.1256 3.03011 12.8324C5.73693 15.5392 10.1255 15.5392 12.8324 12.8324C15.5392 10.1256 15.5392 5.73693 12.8324 3.03011ZM2.32301 2.32301C5.42035 -0.774336 10.4421 -0.774336 13.5395 2.32301C16.6101 5.39361 16.6366 10.3556 13.619 13.4588L18.2473 18.0871C18.4426 18.2824 18.4426 18.599 18.2473 18.7943C18.0521 18.9895 17.7355 18.9895 17.5402 18.7943L12.8778 14.1318C9.76383 16.6223 5.20839 16.4249 2.32301 13.5395C-0.774335 10.4421 -0.774335 5.42035 2.32301 2.32301Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const wv = /* @__PURE__ */ Pe(xv, [["render", Av]]), Lv = {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  role: "presentation",
  class: "icon icon-close",
  fill: "none",
  viewBox: "0 0 18 17"
}, Iv = /* @__PURE__ */ Re({
  __name: "PoloclubCloseIcon.ce",
  props: {
    width: { type: String }
  },
  setup(i) {
    return Nt((e) => ({
      eaa081de: e.width
    })), (e, t) => (P(), N("svg", Lv, t[0] || (t[0] = [
      w("path", {
        d: "M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z",
        fill: "#000000"
      }, null, -1)
    ])));
  }
}), Cv = "[data-v-259da3ed],[data-v-259da3ed]:before,[data-v-259da3ed]:after{box-sizing:border-box}p[data-v-259da3ed],[data-v-259da3ed] p{margin:0;padding:0}h1[data-v-259da3ed],h2[data-v-259da3ed]{margin:0}[data-v-259da3ed]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.icon[data-v-259da3ed]{width:var(--eaa081de);cursor:pointer}", Jf = /* @__PURE__ */ Pe(Iv, [["styles", [Cv]], ["__scopeId", "data-v-259da3ed"]]), Rv = ["fill", "stroke"], Pv = /* @__PURE__ */ Re({
  __name: "PoloclubWishlistIcon.ce",
  props: {
    fillColor: { type: String },
    strokeColor: { type: String },
    loading: { type: Boolean }
  },
  setup(i) {
    return (e, t) => (P(), N("svg", {
      class: Ke({ loading: e.loading }),
      xmlns: "http://www.w3.org/2000/svg",
      id: "wish",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, [
      w("path", {
        id: "WISH-2",
        "data-name": "WISH",
        d: "M1810.563,66.679h14v18l-7.165-3.6-6.835,3.6Z",
        transform: "translate(-1805.563 -63.679)",
        fill: e.fillColor,
        stroke: e.strokeColor,
        "stroke-width": "1"
      }, null, 8, Rv),
      t[0] || (t[0] = w("path", {
        id: "Vector",
        d: "M0,0H24V24H0Z",
        fill: "none"
      }, null, -1))
    ], 2));
  }
}), Dv = "svg[data-v-8da20af3]{cursor:pointer}.loading[data-v-8da20af3]{pointer-events:none;animation:pulse-8da20af3 1s infinite}@keyframes pulse-8da20af3{0%{scale:1}50%{scale:.8}to{scale:1}}", Nv = /* @__PURE__ */ Pe(Pv, [["styles", [Dv]], ["__scopeId", "data-v-8da20af3"]]), Mv = /* @__PURE__ */ Re({
  __name: "PoloclubWishlistBtn.ce",
  props: {
    type: { type: String },
    productId: { type: null }
  },
  setup(i) {
    const e = i, t = ge(!1), n = le(() => {
      switch (e.type) {
        case "product-view":
          return F.productView.product?.id || "";
        case "product-card":
          return e.productId || "";
      }
    }), s = le(() => e.type === "main" ? F.wishlist.length > 0 ? "white" : "transparent" : e.type === "product-view" ? F.wishlist.includes(F.productView.product?.id || "") ? "black" : "transparent" : e.type === "product-card" && F.wishlist.includes(n.value || "") ? "black" : "transparent"), r = le(() => e.type === "main" ? "white" : "black"), a = async () => {
      if (e.type === "main") {
        window.location.href = he.wishlist_page;
        return;
      }
      if (e.type === "product-view" || e.type === "product-card") {
        const c = n.value;
        if (!c) return;
        F.wishlist.includes(c) ? await o("DELETE", c) : await o("POST", c);
      }
    }, o = async (c, u) => {
      t.value = !0;
      try {
        St.hasAccount && await l(c, u), d(c, u);
      } finally {
        t.value = !1;
      }
    }, l = async (c, u) => {
      try {
        const f = "https://poloclub-wishlist.vercel.app/", h = JSON.stringify({
          shop_name: F.permanentShopDomain,
          customer_id: St.id,
          product_id: u.split("/").pop()
        }), m = await fetch(f, {
          method: c,
          headers: { "Content-Type": "application/json" },
          body: h
        });
        if (m.ok) {
          const g = await m.json();
          F.wishlist = g.map((v) => `gid://shopify/Product/${v}` || "");
        } else
          console.error("Error in server response:", m.statusText);
      } catch (f) {
        console.error(`Error managing wishlist on server: ${f}`);
      }
    }, d = (c, u) => {
      let f = JSON.parse(localStorage.getItem("wishlistProducts") || "[]");
      c === "POST" && !f.includes(u) ? (f.unshift(u), f.unshift(u.split("/").pop() || "")) : c === "DELETE" && f.includes(u) && (f = f.filter((h) => h !== u), f = f.filter((h) => h !== u.split("/").pop() || "")), localStorage.setItem("wishlistProducts", JSON.stringify(f)), St.hasAccount || (F.wishlist = f);
    };
    return (c, u) => L(he).enable_wishlist ? (P(), Ie(Nv, {
      key: 0,
      "fill-color": s.value,
      "stroke-color": r.value,
      loading: t.value,
      onClick: a
    }, null, 8, ["fill-color", "stroke-color", "loading"])) : U("", !0);
  }
}), Ov = ".loading[data-v-6ac42484]{opacity:.6;pointer-events:none}", ha = /* @__PURE__ */ Pe(Mv, [["styles", [Ov]], ["__scopeId", "data-v-6ac42484"]]), Fv = (i, e) => {
  const t = le(() => e || (i === "product-view" ? F.productView.selectedVariant.variant ?? F.productView.targetVariant : F.productView.selectedVariant.variant ?? void 0)), n = le(() => {
    if (!he.enable_product_discount) return "";
    const a = t.value;
    if (!a?.price?.amount || !a?.compareAtPrice?.amount) return "";
    const o = Number(a.price.amount), l = Number(a.compareAtPrice.amount);
    if (!Number.isFinite(o) || !Number.isFinite(l) || l <= 0 || l <= o) return "";
    const d = Math.round((l - o) / l * 100);
    return d > 0 ? `-${d}%` : "";
  }), s = le(() => he.product_discount_label_color), r = le(() => he.product_discount_label_background_color);
  return {
    percentageDiscount: n,
    percentageDiscountColor: s,
    percentageDiscountBgColor: r
  };
}, $v = {
  key: 0,
  class: "product-labels-container"
}, Bv = /* @__PURE__ */ Re({
  __name: "PoloclubProductLabels.ce",
  props: {
    type: { type: String },
    product: { type: null },
    variant: { type: null },
    isLogged: { type: Boolean }
  },
  setup(i) {
    Nt((h) => ({
      "452d11b4": h.type === "product-view" ? "column" : "column-reverse",
      a4b51172: h.type === "product-view" ? "1.4rem" : "1.2rem",
      "27eeff34": L(e),
      "71c99b3e": L(t)
    }));
    const { percentageDiscountColor: e, percentageDiscountBgColor: t } = Fv(i.type, i.variant), n = le(() => {
      const h = i.product?.productLabelsMetafield?.value ?? "[]";
      try {
        return JSON.parse(h).map((m) => {
          const g = m.split("/");
          return {
            text: g[0],
            backgroundColor: g[1],
            color: g[2]
          };
        });
      } catch {
        return [];
      }
    }), s = (h) => h?.split(",").map((m) => m.trim().toLowerCase()).filter(Boolean) ?? [], r = he.no_labels, a = s(he.no_labels_list), o = he.no_labels_loggued, l = s(he.no_labels_loggued_list);
    s(he.labels_loggued_list);
    const d = he.no_labels_not_loggued, c = s(he.no_labels_not_loggued_list), u = le(() => {
      const h = n.value;
      if (r && o)
        return a.length > 0 && l.length > 0 ? i.isLogged ? h.filter((m) => !a.includes(m.text.trim().toLowerCase())).filter((m) => !l.includes(m.text.trim().toLowerCase())) : d ? h.filter((m) => !a.includes(m.text.trim().toLowerCase())).filter((m) => !c.includes(m.text.trim().toLowerCase())) : h.filter((m) => !a.includes(m.text.trim().toLowerCase())) : h;
      if (r && d)
        return a.length > 0 && c.length > 0 ? i.isLogged ? h.filter((m) => !a.includes(m.text.trim().toLowerCase())) : h.filter((m) => !a.includes(m.text.trim().toLowerCase())).filter((m) => !c.includes(m.text.trim().toLowerCase())) : h;
      if (d && o)
        return c.length > 0 && l.length > 0 ? i.isLogged ? h.filter((m) => !l.includes(m.text.trim().toLowerCase())) : h.filter((m) => !c.includes(m.text.trim().toLowerCase())) : h;
      if (r)
        return a.length > 0 ? h.filter(
          (m) => !a.includes(m.text.trim().toLowerCase())
        ) : h;
      if (i.isLogged) {
        if (o)
          return l.length > 0 ? h.filter(
            (m) => !l.includes(m.text.trim().toLowerCase())
          ) : h;
      } else if (d)
        return c.length > 0 ? h.filter(
          (m) => !c.includes(m.text.trim().toLowerCase())
        ) : h;
      return h;
    }), f = (h) => ({
      Pack: { color: he.label_pack_text_color, backgroundColor: he.label_pack_background_color },
      New: { color: he.label_new_text_color, backgroundColor: he.label_new_background_color },
      Organics: { color: he.label_organics_text_color, backgroundColor: he.label_organics_background_color },
      Neutral: { color: he.label_neutral_text_color, backgroundColor: he.label_neutral_background_color },
      Outlet: { color: he.label_neutral_text_color, backgroundColor: he.label_neutral_background_color }
    })[h.text] || {
      backgroundColor: h.backgroundColor,
      color: h.color
    };
    return (h, m) => u.value.length ? (P(), N("div", $v, [
      (P(!0), N(ve, null, pt(u.value, (g, v) => (P(), N("div", {
        key: v,
        class: "label",
        style: We(f(g))
      }, ie(g.text), 5))), 128))
    ])) : U("", !0);
  }
}), Uv = ".product-labels-container[data-v-e95022fc]{display:flex;flex-direction:var(--452d11b4);gap:6px}.label[data-v-e95022fc]{width:fit-content;padding:4px 8px;font-size:var(--a4b51172)}.discount-label[data-v-e95022fc]{color:var(--27eeff34);background-color:var(--71c99b3e)}@media (width >= 768px){.product-labels-container[data-v-e95022fc]{gap:10px}}", gl = /* @__PURE__ */ Pe(Bv, [["styles", [Uv]], ["__scopeId", "data-v-e95022fc"]]), ae = Number.isFinite || function(i) {
  return typeof i == "number" && isFinite(i);
}, Vv = Number.isSafeInteger || function(i) {
  return typeof i == "number" && Math.abs(i) <= Gv;
}, Gv = Number.MAX_SAFE_INTEGER || 9007199254740991;
let pe = /* @__PURE__ */ function(i) {
  return i.NETWORK_ERROR = "networkError", i.MEDIA_ERROR = "mediaError", i.KEY_SYSTEM_ERROR = "keySystemError", i.MUX_ERROR = "muxError", i.OTHER_ERROR = "otherError", i;
}({}), B = /* @__PURE__ */ function(i) {
  return i.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys", i.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess", i.KEY_SYSTEM_NO_SESSION = "keySystemNoSession", i.KEY_SYSTEM_NO_CONFIGURED_LICENSE = "keySystemNoConfiguredLicense", i.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed", i.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED = "keySystemServerCertificateRequestFailed", i.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED = "keySystemServerCertificateUpdateFailed", i.KEY_SYSTEM_SESSION_UPDATE_FAILED = "keySystemSessionUpdateFailed", i.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED = "keySystemStatusOutputRestricted", i.KEY_SYSTEM_STATUS_INTERNAL_ERROR = "keySystemStatusInternalError", i.KEY_SYSTEM_DESTROY_MEDIA_KEYS_ERROR = "keySystemDestroyMediaKeysError", i.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR = "keySystemDestroyCloseSessionError", i.KEY_SYSTEM_DESTROY_REMOVE_SESSION_ERROR = "keySystemDestroyRemoveSessionError", i.MANIFEST_LOAD_ERROR = "manifestLoadError", i.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut", i.MANIFEST_PARSING_ERROR = "manifestParsingError", i.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError", i.LEVEL_EMPTY_ERROR = "levelEmptyError", i.LEVEL_LOAD_ERROR = "levelLoadError", i.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut", i.LEVEL_PARSING_ERROR = "levelParsingError", i.LEVEL_SWITCH_ERROR = "levelSwitchError", i.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError", i.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut", i.SUBTITLE_LOAD_ERROR = "subtitleTrackLoadError", i.SUBTITLE_TRACK_LOAD_TIMEOUT = "subtitleTrackLoadTimeOut", i.FRAG_LOAD_ERROR = "fragLoadError", i.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut", i.FRAG_DECRYPT_ERROR = "fragDecryptError", i.FRAG_PARSING_ERROR = "fragParsingError", i.FRAG_GAP = "fragGap", i.REMUX_ALLOC_ERROR = "remuxAllocError", i.KEY_LOAD_ERROR = "keyLoadError", i.KEY_LOAD_TIMEOUT = "keyLoadTimeOut", i.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError", i.BUFFER_INCOMPATIBLE_CODECS_ERROR = "bufferIncompatibleCodecsError", i.BUFFER_APPEND_ERROR = "bufferAppendError", i.BUFFER_APPENDING_ERROR = "bufferAppendingError", i.BUFFER_STALLED_ERROR = "bufferStalledError", i.BUFFER_FULL_ERROR = "bufferFullError", i.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole", i.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall", i.ASSET_LIST_LOAD_ERROR = "assetListLoadError", i.ASSET_LIST_LOAD_TIMEOUT = "assetListLoadTimeout", i.ASSET_LIST_PARSING_ERROR = "assetListParsingError", i.INTERSTITIAL_ASSET_ITEM_ERROR = "interstitialAssetItemError", i.INTERNAL_EXCEPTION = "internalException", i.INTERNAL_ABORTED = "aborted", i.ATTACH_MEDIA_ERROR = "attachMediaError", i.UNKNOWN = "unknown", i;
}({}), S = /* @__PURE__ */ function(i) {
  return i.MEDIA_ATTACHING = "hlsMediaAttaching", i.MEDIA_ATTACHED = "hlsMediaAttached", i.MEDIA_DETACHING = "hlsMediaDetaching", i.MEDIA_DETACHED = "hlsMediaDetached", i.MEDIA_ENDED = "hlsMediaEnded", i.STALL_RESOLVED = "hlsStallResolved", i.BUFFER_RESET = "hlsBufferReset", i.BUFFER_CODECS = "hlsBufferCodecs", i.BUFFER_CREATED = "hlsBufferCreated", i.BUFFER_APPENDING = "hlsBufferAppending", i.BUFFER_APPENDED = "hlsBufferAppended", i.BUFFER_EOS = "hlsBufferEos", i.BUFFERED_TO_END = "hlsBufferedToEnd", i.BUFFER_FLUSHING = "hlsBufferFlushing", i.BUFFER_FLUSHED = "hlsBufferFlushed", i.MANIFEST_LOADING = "hlsManifestLoading", i.MANIFEST_LOADED = "hlsManifestLoaded", i.MANIFEST_PARSED = "hlsManifestParsed", i.LEVEL_SWITCHING = "hlsLevelSwitching", i.LEVEL_SWITCHED = "hlsLevelSwitched", i.LEVEL_LOADING = "hlsLevelLoading", i.LEVEL_LOADED = "hlsLevelLoaded", i.LEVEL_UPDATED = "hlsLevelUpdated", i.LEVEL_PTS_UPDATED = "hlsLevelPtsUpdated", i.LEVELS_UPDATED = "hlsLevelsUpdated", i.AUDIO_TRACKS_UPDATED = "hlsAudioTracksUpdated", i.AUDIO_TRACK_SWITCHING = "hlsAudioTrackSwitching", i.AUDIO_TRACK_SWITCHED = "hlsAudioTrackSwitched", i.AUDIO_TRACK_LOADING = "hlsAudioTrackLoading", i.AUDIO_TRACK_LOADED = "hlsAudioTrackLoaded", i.AUDIO_TRACK_UPDATED = "hlsAudioTrackUpdated", i.SUBTITLE_TRACKS_UPDATED = "hlsSubtitleTracksUpdated", i.SUBTITLE_TRACKS_CLEARED = "hlsSubtitleTracksCleared", i.SUBTITLE_TRACK_SWITCH = "hlsSubtitleTrackSwitch", i.SUBTITLE_TRACK_LOADING = "hlsSubtitleTrackLoading", i.SUBTITLE_TRACK_LOADED = "hlsSubtitleTrackLoaded", i.SUBTITLE_TRACK_UPDATED = "hlsSubtitleTrackUpdated", i.SUBTITLE_FRAG_PROCESSED = "hlsSubtitleFragProcessed", i.CUES_PARSED = "hlsCuesParsed", i.NON_NATIVE_TEXT_TRACKS_FOUND = "hlsNonNativeTextTracksFound", i.INIT_PTS_FOUND = "hlsInitPtsFound", i.FRAG_LOADING = "hlsFragLoading", i.FRAG_LOAD_EMERGENCY_ABORTED = "hlsFragLoadEmergencyAborted", i.FRAG_LOADED = "hlsFragLoaded", i.FRAG_DECRYPTED = "hlsFragDecrypted", i.FRAG_PARSING_INIT_SEGMENT = "hlsFragParsingInitSegment", i.FRAG_PARSING_USERDATA = "hlsFragParsingUserdata", i.FRAG_PARSING_METADATA = "hlsFragParsingMetadata", i.FRAG_PARSED = "hlsFragParsed", i.FRAG_BUFFERED = "hlsFragBuffered", i.FRAG_CHANGED = "hlsFragChanged", i.FPS_DROP = "hlsFpsDrop", i.FPS_DROP_LEVEL_CAPPING = "hlsFpsDropLevelCapping", i.MAX_AUTO_LEVEL_UPDATED = "hlsMaxAutoLevelUpdated", i.ERROR = "hlsError", i.DESTROYING = "hlsDestroying", i.KEY_LOADING = "hlsKeyLoading", i.KEY_LOADED = "hlsKeyLoaded", i.LIVE_BACK_BUFFER_REACHED = "hlsLiveBackBufferReached", i.BACK_BUFFER_REACHED = "hlsBackBufferReached", i.STEERING_MANIFEST_LOADED = "hlsSteeringManifestLoaded", i.ASSET_LIST_LOADING = "hlsAssetListLoading", i.ASSET_LIST_LOADED = "hlsAssetListLoaded", i.INTERSTITIALS_UPDATED = "hlsInterstitialsUpdated", i.INTERSTITIALS_BUFFERED_TO_BOUNDARY = "hlsInterstitialsBufferedToBoundary", i.INTERSTITIAL_ASSET_PLAYER_CREATED = "hlsInterstitialAssetPlayerCreated", i.INTERSTITIAL_STARTED = "hlsInterstitialStarted", i.INTERSTITIAL_ASSET_STARTED = "hlsInterstitialAssetStarted", i.INTERSTITIAL_ASSET_ENDED = "hlsInterstitialAssetEnded", i.INTERSTITIAL_ASSET_ERROR = "hlsInterstitialAssetError", i.INTERSTITIAL_ENDED = "hlsInterstitialEnded", i.INTERSTITIALS_PRIMARY_RESUMED = "hlsInterstitialsPrimaryResumed", i.PLAYOUT_LIMIT_REACHED = "hlsPlayoutLimitReached", i.EVENT_CUE_ENTER = "hlsEventCueEnter", i;
}({});
var Le = {
  MANIFEST: "manifest",
  LEVEL: "level",
  AUDIO_TRACK: "audioTrack",
  SUBTITLE_TRACK: "subtitleTrack"
}, ce = {
  MAIN: "main",
  AUDIO: "audio",
  SUBTITLE: "subtitle"
};
class _n {
  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  constructor(e, t = 0, n = 0) {
    this.halfLife = void 0, this.alpha_ = void 0, this.estimate_ = void 0, this.totalWeight_ = void 0, this.halfLife = e, this.alpha_ = e ? Math.exp(Math.log(0.5) / e) : 0, this.estimate_ = t, this.totalWeight_ = n;
  }
  sample(e, t) {
    const n = Math.pow(this.alpha_, e);
    this.estimate_ = t * (1 - n) + n * this.estimate_, this.totalWeight_ += e;
  }
  getTotalWeight() {
    return this.totalWeight_;
  }
  getEstimate() {
    if (this.alpha_) {
      const e = 1 - Math.pow(this.alpha_, this.totalWeight_);
      if (e)
        return this.estimate_ / e;
    }
    return this.estimate_;
  }
}
class Hv {
  constructor(e, t, n, s = 100) {
    this.defaultEstimate_ = void 0, this.minWeight_ = void 0, this.minDelayMs_ = void 0, this.slow_ = void 0, this.fast_ = void 0, this.defaultTTFB_ = void 0, this.ttfb_ = void 0, this.defaultEstimate_ = n, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new _n(e), this.fast_ = new _n(t), this.defaultTTFB_ = s, this.ttfb_ = new _n(e);
  }
  update(e, t) {
    const {
      slow_: n,
      fast_: s,
      ttfb_: r
    } = this;
    n.halfLife !== e && (this.slow_ = new _n(e, n.getEstimate(), n.getTotalWeight())), s.halfLife !== t && (this.fast_ = new _n(t, s.getEstimate(), s.getTotalWeight())), r.halfLife !== e && (this.ttfb_ = new _n(e, r.getEstimate(), r.getTotalWeight()));
  }
  sample(e, t) {
    e = Math.max(e, this.minDelayMs_);
    const n = 8 * t, s = e / 1e3, r = n / s;
    this.fast_.sample(s, r), this.slow_.sample(s, r);
  }
  sampleTTFB(e) {
    const t = e / 1e3, n = Math.sqrt(2) * Math.exp(-Math.pow(t, 2) / 2);
    this.ttfb_.sample(n, Math.max(e, 5));
  }
  canEstimate() {
    return this.fast_.getTotalWeight() >= this.minWeight_;
  }
  getEstimate() {
    return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
  }
  getEstimateTTFB() {
    return this.ttfb_.getTotalWeight() >= this.minWeight_ ? this.ttfb_.getEstimate() : this.defaultTTFB_;
  }
  get defaultEstimate() {
    return this.defaultEstimate_;
  }
  destroy() {
  }
}
function zv(i, e, t) {
  return (e = jv(e)) in i ? Object.defineProperty(i, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[e] = t, i;
}
function He() {
  return He = Object.assign ? Object.assign.bind() : function(i) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t) ({}).hasOwnProperty.call(t, n) && (i[n] = t[n]);
    }
    return i;
  }, He.apply(null, arguments);
}
function ec(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(i);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(i, s).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Ve(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ec(Object(t), !0).forEach(function(n) {
      zv(i, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : ec(Object(t)).forEach(function(n) {
      Object.defineProperty(i, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return i;
}
function Kv(i, e) {
  if (typeof i != "object" || !i) return i;
  var t = i[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(i, e);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(i);
}
function jv(i) {
  var e = Kv(i, "string");
  return typeof e == "symbol" ? e : e + "";
}
class ni {
  constructor(e, t) {
    this.trace = void 0, this.debug = void 0, this.log = void 0, this.warn = void 0, this.info = void 0, this.error = void 0;
    const n = `[${e}]:`;
    this.trace = Gi, this.debug = t.debug.bind(null, n), this.log = t.log.bind(null, n), this.warn = t.warn.bind(null, n), this.info = t.info.bind(null, n), this.error = t.error.bind(null, n);
  }
}
const Gi = function() {
}, Wv = {
  trace: Gi,
  debug: Gi,
  log: Gi,
  warn: Gi,
  info: Gi,
  error: Gi
};
function Ao() {
  return He({}, Wv);
}
function qv(i, e) {
  const t = self.console[i];
  return t ? t.bind(self.console, `${e ? "[" + e + "] " : ""}[${i}] >`) : Gi;
}
function tc(i, e, t) {
  return e[i] ? e[i].bind(e) : qv(i, t);
}
const wo = Ao();
function Yv(i, e, t) {
  const n = Ao();
  if (typeof console == "object" && i === !0 || typeof i == "object") {
    const s = [
      // Remove out from list here to hard-disable a log-level
      // 'trace',
      "debug",
      "log",
      "info",
      "warn",
      "error"
    ];
    s.forEach((r) => {
      n[r] = tc(r, i, t);
    });
    try {
      n.log(`Debug logs enabled for "${e}" in hls.js version 1.6.10`);
    } catch {
      return Ao();
    }
    s.forEach((r) => {
      wo[r] = tc(r, i);
    });
  } else
    He(wo, n);
  return n;
}
const Be = wo;
function en(i = !0) {
  return typeof self > "u" ? void 0 : (i || !self.MediaSource) && self.ManagedMediaSource || self.MediaSource || self.WebKitMediaSource;
}
function Xv(i) {
  return typeof self < "u" && i === self.ManagedMediaSource;
}
function eh(i, e) {
  const t = Object.keys(i), n = Object.keys(e), s = t.length, r = n.length;
  return !s || !r || s === r && !t.some((a) => n.indexOf(a) === -1);
}
function Ht(i, e = !1) {
  if (typeof TextDecoder < "u") {
    const d = new TextDecoder("utf-8").decode(i);
    if (e) {
      const c = d.indexOf("\0");
      return c !== -1 ? d.substring(0, c) : d;
    }
    return d.replace(/\0/g, "");
  }
  const t = i.length;
  let n, s, r, a = "", o = 0;
  for (; o < t; ) {
    if (n = i[o++], n === 0 && e)
      return a;
    if (n === 0 || n === 3)
      continue;
    switch (n >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        a += String.fromCharCode(n);
        break;
      case 12:
      case 13:
        s = i[o++], a += String.fromCharCode((n & 31) << 6 | s & 63);
        break;
      case 14:
        s = i[o++], r = i[o++], a += String.fromCharCode((n & 15) << 12 | (s & 63) << 6 | (r & 63) << 0);
        break;
    }
  }
  return a;
}
const wi = {
  hexDump: function(i) {
    let e = "";
    for (let t = 0; t < i.length; t++) {
      let n = i[t].toString(16);
      n.length < 2 && (n = "0" + n), e += n;
    }
    return e;
  }
};
function th(i) {
  return Uint8Array.from(i.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer;
}
function Zv(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
var Pa = { exports: {} }, ic;
function Qv() {
  return ic || (ic = 1, function(i, e) {
    (function(t) {
      var n = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, s = /^(?=([^\/?#]*))\1([^]*)$/, r = /(?:\/|^)\.(?=\/)/g, a = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, o = {
        // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
        // E.g
        // With opts.alwaysNormalize = false (default, spec compliant)
        // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
        // With opts.alwaysNormalize = true (not spec compliant)
        // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
        buildAbsoluteURL: function(l, d, c) {
          if (c = c || {}, l = l.trim(), d = d.trim(), !d) {
            if (!c.alwaysNormalize)
              return l;
            var u = o.parseURL(l);
            if (!u)
              throw new Error("Error trying to parse base URL.");
            return u.path = o.normalizePath(
              u.path
            ), o.buildURLFromParts(u);
          }
          var f = o.parseURL(d);
          if (!f)
            throw new Error("Error trying to parse relative URL.");
          if (f.scheme)
            return c.alwaysNormalize ? (f.path = o.normalizePath(f.path), o.buildURLFromParts(f)) : d;
          var h = o.parseURL(l);
          if (!h)
            throw new Error("Error trying to parse base URL.");
          if (!h.netLoc && h.path && h.path[0] !== "/") {
            var m = s.exec(h.path);
            h.netLoc = m[1], h.path = m[2];
          }
          h.netLoc && !h.path && (h.path = "/");
          var g = {
            // 2c) Otherwise, the embedded URL inherits the scheme of
            // the base URL.
            scheme: h.scheme,
            netLoc: f.netLoc,
            path: null,
            params: f.params,
            query: f.query,
            fragment: f.fragment
          };
          if (!f.netLoc && (g.netLoc = h.netLoc, f.path[0] !== "/"))
            if (!f.path)
              g.path = h.path, f.params || (g.params = h.params, f.query || (g.query = h.query));
            else {
              var v = h.path, p = v.substring(0, v.lastIndexOf("/") + 1) + f.path;
              g.path = o.normalizePath(p);
            }
          return g.path === null && (g.path = c.alwaysNormalize ? o.normalizePath(f.path) : f.path), o.buildURLFromParts(g);
        },
        parseURL: function(l) {
          var d = n.exec(l);
          return d ? {
            scheme: d[1] || "",
            netLoc: d[2] || "",
            path: d[3] || "",
            params: d[4] || "",
            query: d[5] || "",
            fragment: d[6] || ""
          } : null;
        },
        normalizePath: function(l) {
          for (l = l.split("").reverse().join("").replace(r, ""); l.length !== (l = l.replace(a, "")).length; )
            ;
          return l.split("").reverse().join("");
        },
        buildURLFromParts: function(l) {
          return l.scheme + l.netLoc + l.path + l.params + l.query + l.fragment;
        }
      };
      i.exports = o;
    })();
  }(Pa)), Pa.exports;
}
var vl = Qv();
class yl {
  constructor() {
    this.aborted = !1, this.loaded = 0, this.retry = 0, this.total = 0, this.chunkCount = 0, this.bwEstimate = 0, this.loading = {
      start: 0,
      first: 0,
      end: 0
    }, this.parsing = {
      start: 0,
      end: 0
    }, this.buffering = {
      start: 0,
      first: 0,
      end: 0
    };
  }
}
var ze = {
  AUDIO: "audio",
  VIDEO: "video",
  AUDIOVIDEO: "audiovideo"
};
class ih {
  constructor(e) {
    this._byteRange = null, this._url = null, this._stats = null, this._streams = null, this.base = void 0, this.relurl = void 0, typeof e == "string" && (e = {
      url: e
    }), this.base = e, e1(this, "stats");
  }
  // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
  setByteRange(e, t) {
    const n = e.split("@", 2);
    let s;
    n.length === 1 ? s = t?.byteRangeEndOffset || 0 : s = parseInt(n[1]), this._byteRange = [s, parseInt(n[0]) + s];
  }
  get baseurl() {
    return this.base.url;
  }
  get byteRange() {
    return this._byteRange === null ? [] : this._byteRange;
  }
  get byteRangeStartOffset() {
    return this.byteRange[0];
  }
  get byteRangeEndOffset() {
    return this.byteRange[1];
  }
  get elementaryStreams() {
    return this._streams === null && (this._streams = {
      [ze.AUDIO]: null,
      [ze.VIDEO]: null,
      [ze.AUDIOVIDEO]: null
    }), this._streams;
  }
  set elementaryStreams(e) {
    this._streams = e;
  }
  get hasStats() {
    return this._stats !== null;
  }
  get hasStreams() {
    return this._streams !== null;
  }
  get stats() {
    return this._stats === null && (this._stats = new yl()), this._stats;
  }
  set stats(e) {
    this._stats = e;
  }
  get url() {
    return !this._url && this.baseurl && this.relurl && (this._url = vl.buildAbsoluteURL(this.baseurl, this.relurl, {
      alwaysNormalize: !0
    })), this._url || "";
  }
  set url(e) {
    this._url = e;
  }
  clearElementaryStreamInfo() {
    const {
      elementaryStreams: e
    } = this;
    e[ze.AUDIO] = null, e[ze.VIDEO] = null, e[ze.AUDIOVIDEO] = null;
  }
}
function st(i) {
  return i.sn !== "initSegment";
}
class Da extends ih {
  constructor(e, t) {
    super(t), this._decryptdata = null, this._programDateTime = null, this._ref = null, this._bitrate = void 0, this.rawProgramDateTime = null, this.tagList = [], this.duration = 0, this.sn = 0, this.levelkeys = void 0, this.type = void 0, this.loader = null, this.keyLoader = null, this.level = -1, this.cc = 0, this.startPTS = void 0, this.endPTS = void 0, this.startDTS = void 0, this.endDTS = void 0, this.start = 0, this.playlistOffset = 0, this.deltaPTS = void 0, this.maxStartPTS = void 0, this.minEndPTS = void 0, this.data = void 0, this.bitrateTest = !1, this.title = null, this.initSegment = null, this.endList = void 0, this.gap = void 0, this.urlId = 0, this.type = e;
  }
  get byteLength() {
    if (this.hasStats) {
      const e = this.stats.total;
      if (e)
        return e;
    }
    if (this.byteRange.length) {
      const e = this.byteRange[0], t = this.byteRange[1];
      if (ae(e) && ae(t))
        return t - e;
    }
    return null;
  }
  get bitrate() {
    return this.byteLength ? this.byteLength * 8 / this.duration : this._bitrate ? this._bitrate : null;
  }
  set bitrate(e) {
    this._bitrate = e;
  }
  get decryptdata() {
    const {
      levelkeys: e
    } = this;
    if (!e && !this._decryptdata)
      return null;
    if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
      const t = this.levelkeys.identity;
      if (t)
        this._decryptdata = t.getDecryptData(this.sn);
      else {
        const n = Object.keys(this.levelkeys);
        if (n.length === 1) {
          const s = this._decryptdata = this.levelkeys[n[0]] || null;
          if (s)
            return s.getDecryptData(this.sn);
        }
      }
    }
    return this._decryptdata;
  }
  get end() {
    return this.start + this.duration;
  }
  get endProgramDateTime() {
    if (this.programDateTime === null)
      return null;
    const e = ae(this.duration) ? this.duration : 0;
    return this.programDateTime + e * 1e3;
  }
  get encrypted() {
    var e;
    if ((e = this._decryptdata) != null && e.encrypted)
      return !0;
    if (this.levelkeys) {
      var t;
      const n = Object.keys(this.levelkeys), s = n.length;
      if (s > 1 || s === 1 && (t = this.levelkeys[n[0]]) != null && t.encrypted)
        return !0;
    }
    return !1;
  }
  get programDateTime() {
    return this._programDateTime === null && this.rawProgramDateTime && (this.programDateTime = Date.parse(this.rawProgramDateTime)), this._programDateTime;
  }
  set programDateTime(e) {
    if (!ae(e)) {
      this._programDateTime = this.rawProgramDateTime = null;
      return;
    }
    this._programDateTime = e;
  }
  get ref() {
    return st(this) ? (this._ref || (this._ref = {
      base: this.base,
      start: this.start,
      duration: this.duration,
      sn: this.sn,
      programDateTime: this.programDateTime
    }), this._ref) : null;
  }
  addStart(e) {
    this.setStart(this.start + e);
  }
  setStart(e) {
    this.start = e, this._ref && (this._ref.start = e);
  }
  setDuration(e) {
    this.duration = e, this._ref && (this._ref.duration = e);
  }
  setKeyFormat(e) {
    if (this.levelkeys) {
      const t = this.levelkeys[e];
      t && !this._decryptdata && (this._decryptdata = t.getDecryptData(this.sn));
    }
  }
  abortRequests() {
    var e, t;
    (e = this.loader) == null || e.abort(), (t = this.keyLoader) == null || t.abort();
  }
  setElementaryStreamInfo(e, t, n, s, r, a = !1) {
    const {
      elementaryStreams: o
    } = this, l = o[e];
    if (!l) {
      o[e] = {
        startPTS: t,
        endPTS: n,
        startDTS: s,
        endDTS: r,
        partial: a
      };
      return;
    }
    l.startPTS = Math.min(l.startPTS, t), l.endPTS = Math.max(l.endPTS, n), l.startDTS = Math.min(l.startDTS, s), l.endDTS = Math.max(l.endDTS, r);
  }
}
class Jv extends ih {
  constructor(e, t, n, s, r) {
    super(n), this.fragOffset = 0, this.duration = 0, this.gap = !1, this.independent = !1, this.relurl = void 0, this.fragment = void 0, this.index = void 0, this.duration = e.decimalFloatingPoint("DURATION"), this.gap = e.bool("GAP"), this.independent = e.bool("INDEPENDENT"), this.relurl = e.enumeratedString("URI"), this.fragment = t, this.index = s;
    const a = e.enumeratedString("BYTERANGE");
    a && this.setByteRange(a, r), r && (this.fragOffset = r.fragOffset + r.duration);
  }
  get start() {
    return this.fragment.start + this.fragOffset;
  }
  get end() {
    return this.start + this.duration;
  }
  get loaded() {
    const {
      elementaryStreams: e
    } = this;
    return !!(e.audio || e.video || e.audiovideo);
  }
}
function nh(i, e) {
  const t = Object.getPrototypeOf(i);
  if (t) {
    const n = Object.getOwnPropertyDescriptor(t, e);
    return n || nh(t, e);
  }
}
function e1(i, e) {
  const t = nh(i, e);
  t && (t.enumerable = !0, Object.defineProperty(i, e, t));
}
const nc = Math.pow(2, 32) - 1, t1 = [].push, sh = {
  video: 1,
  audio: 2,
  id3: 3,
  text: 4
};
function rt(i) {
  return String.fromCharCode.apply(null, i);
}
function rh(i, e) {
  const t = i[e] << 8 | i[e + 1];
  return t < 0 ? 65536 + t : t;
}
function be(i, e) {
  const t = ah(i, e);
  return t < 0 ? 4294967296 + t : t;
}
function sc(i, e) {
  let t = be(i, e);
  return t *= Math.pow(2, 32), t += be(i, e + 4), t;
}
function ah(i, e) {
  return i[e] << 24 | i[e + 1] << 16 | i[e + 2] << 8 | i[e + 3];
}
function i1(i) {
  const e = i.byteLength;
  for (let t = 0; t < e; ) {
    const n = be(i, t);
    if (n > 8 && i[t + 4] === 109 && i[t + 5] === 111 && i[t + 6] === 111 && i[t + 7] === 102)
      return !0;
    t = n > 1 ? t + n : e;
  }
  return !1;
}
function we(i, e) {
  const t = [];
  if (!e.length)
    return t;
  const n = i.byteLength;
  for (let s = 0; s < n; ) {
    const r = be(i, s), a = rt(i.subarray(s + 4, s + 8)), o = r > 1 ? s + r : n;
    if (a === e[0])
      if (e.length === 1)
        t.push(i.subarray(s + 8, o));
      else {
        const l = we(i.subarray(s + 8, o), e.slice(1));
        l.length && t1.apply(t, l);
      }
    s = o;
  }
  return t;
}
function n1(i) {
  const e = [], t = i[0];
  let n = 8;
  const s = be(i, n);
  n += 4;
  let r = 0, a = 0;
  t === 0 ? (r = be(i, n), a = be(i, n + 4), n += 8) : (r = sc(i, n), a = sc(i, n + 8), n += 16), n += 2;
  let o = i.length + a;
  const l = rh(i, n);
  n += 2;
  for (let d = 0; d < l; d++) {
    let c = n;
    const u = be(i, c);
    c += 4;
    const f = u & 2147483647;
    if ((u & 2147483648) >>> 31 === 1)
      return Be.warn("SIDX has hierarchical references (not supported)"), null;
    const m = be(i, c);
    c += 4, e.push({
      referenceSize: f,
      subsegmentDuration: m,
      // unscaled
      info: {
        duration: m / s,
        start: o,
        end: o + f - 1
      }
    }), o += f, c += 4, n = c;
  }
  return {
    earliestPresentationTime: r,
    timescale: s,
    version: t,
    referencesCount: l,
    references: e
  };
}
function oh(i) {
  const e = [], t = we(i, ["moov", "trak"]);
  for (let s = 0; s < t.length; s++) {
    const r = t[s], a = we(r, ["tkhd"])[0];
    if (a) {
      let o = a[0];
      const l = be(a, o === 0 ? 12 : 20), d = we(r, ["mdia", "mdhd"])[0];
      if (d) {
        o = d[0];
        const c = be(d, o === 0 ? 12 : 20), u = we(r, ["mdia", "hdlr"])[0];
        if (u) {
          const f = rt(u.subarray(8, 12)), h = {
            soun: ze.AUDIO,
            vide: ze.VIDEO
          }[f], m = we(r, ["mdia", "minf", "stbl", "stsd"])[0], g = s1(m);
          h ? (e[l] = {
            timescale: c,
            type: h,
            stsd: g
          }, e[h] = Ve({
            timescale: c,
            id: l
          }, g)) : e[l] = {
            timescale: c,
            type: f,
            stsd: g
          };
        }
      }
    }
  }
  return we(i, ["moov", "mvex", "trex"]).forEach((s) => {
    const r = be(s, 4), a = e[r];
    a && (a.default = {
      duration: be(s, 12),
      flags: be(s, 20)
    });
  }), e;
}
function s1(i) {
  const e = i.subarray(8), t = e.subarray(86), n = rt(e.subarray(4, 8));
  let s = n, r;
  const a = n === "enca" || n === "encv";
  if (a) {
    const d = we(e, [n])[0].subarray(n === "enca" ? 28 : 78);
    we(d, ["sinf"]).forEach((u) => {
      const f = we(u, ["schm"])[0];
      if (f) {
        const h = rt(f.subarray(4, 8));
        if (h === "cbcs" || h === "cenc") {
          const m = we(u, ["frma"])[0];
          m && (s = rt(m));
        }
      }
    });
  }
  const o = s;
  switch (s) {
    case "avc1":
    case "avc2":
    case "avc3":
    case "avc4": {
      const l = we(t, ["avcC"])[0];
      l && l.length > 3 && (s += "." + zs(l[1]) + zs(l[2]) + zs(l[3]), r = Hs(o === "avc1" ? "dva1" : "dvav", t));
      break;
    }
    case "mp4a": {
      const l = we(e, [n])[0], d = we(l.subarray(28), ["esds"])[0];
      if (d && d.length > 7) {
        let c = 4;
        if (d[c++] !== 3)
          break;
        c = Na(d, c), c += 2;
        const u = d[c++];
        if (u & 128 && (c += 2), u & 64 && (c += d[c++]), d[c++] !== 4)
          break;
        c = Na(d, c);
        const f = d[c++];
        if (f === 64)
          s += "." + zs(f);
        else
          break;
        if (c += 12, d[c++] !== 5)
          break;
        c = Na(d, c);
        const h = d[c++];
        let m = (h & 248) >> 3;
        m === 31 && (m += 1 + ((h & 7) << 3) + ((d[c] & 224) >> 5)), s += "." + m;
      }
      break;
    }
    case "hvc1":
    case "hev1": {
      const l = we(t, ["hvcC"])[0];
      if (l && l.length > 12) {
        const d = l[1], c = ["", "A", "B", "C"][d >> 6], u = d & 31, f = be(l, 2), h = (d & 32) >> 5 ? "H" : "L", m = l[12], g = l.subarray(6, 12);
        s += "." + c + u, s += "." + r1(f).toString(16).toUpperCase(), s += "." + h + m;
        let v = "";
        for (let p = g.length; p--; ) {
          const y = g[p];
          (y || v) && (v = "." + y.toString(16).toUpperCase() + v);
        }
        s += v;
      }
      r = Hs(o == "hev1" ? "dvhe" : "dvh1", t);
      break;
    }
    case "dvh1":
    case "dvhe":
    case "dvav":
    case "dva1":
    case "dav1": {
      s = Hs(s, t) || s;
      break;
    }
    case "vp09": {
      const l = we(t, ["vpcC"])[0];
      if (l && l.length > 6) {
        const d = l[4], c = l[5], u = l[6] >> 4 & 15;
        s += "." + di(d) + "." + di(c) + "." + di(u);
      }
      break;
    }
    case "av01": {
      const l = we(t, ["av1C"])[0];
      if (l && l.length > 2) {
        const d = l[1] >>> 5, c = l[1] & 31, u = l[2] >>> 7 ? "H" : "M", f = (l[2] & 64) >> 6, h = (l[2] & 32) >> 5, m = d === 2 && f ? h ? 12 : 10 : f ? 10 : 8, g = (l[2] & 16) >> 4, v = (l[2] & 8) >> 3, p = (l[2] & 4) >> 2, y = l[2] & 3;
        s += "." + d + "." + di(c) + u + "." + di(m) + "." + g + "." + v + p + y + "." + di(1) + "." + di(1) + "." + di(1) + "." + 0, r = Hs("dav1", t);
      }
      break;
    }
  }
  return {
    codec: s,
    encrypted: a,
    supplemental: r
  };
}
function Hs(i, e) {
  const t = we(e, ["dvvC"]), n = t.length ? t[0] : we(e, ["dvcC"])[0];
  if (n) {
    const s = n[2] >> 1 & 127, r = n[2] << 5 & 32 | n[3] >> 3 & 31;
    return i + "." + di(s) + "." + di(r);
  }
}
function r1(i) {
  let e = 0;
  for (let t = 0; t < 32; t++)
    e |= (i >> t & 1) << 31 - t;
  return e >>> 0;
}
function Na(i, e) {
  const t = e + 5;
  for (; i[e++] & 128 && e < t; )
    ;
  return e;
}
function zs(i) {
  return ("0" + i.toString(16).toUpperCase()).slice(-2);
}
function di(i) {
  return (i < 10 ? "0" : "") + i;
}
function a1(i, e) {
  if (!i || !e)
    return;
  const t = e.keyId;
  t && e.isCommonEncryption && we(i, ["moov", "trak"]).forEach((s) => {
    const a = we(s, ["mdia", "minf", "stbl", "stsd"])[0].subarray(8);
    let o = we(a, ["enca"]);
    const l = o.length > 0;
    l || (o = we(a, ["encv"])), o.forEach((d) => {
      const c = l ? d.subarray(28) : d.subarray(78);
      we(c, ["sinf"]).forEach((f) => {
        const h = lh(f);
        if (h) {
          const m = h.subarray(8, 24);
          m.some((g) => g !== 0) || (Be.log(`[eme] Patching keyId in 'enc${l ? "a" : "v"}>sinf>>tenc' box: ${wi.hexDump(m)} -> ${wi.hexDump(t)}`), h.set(t, 8));
        }
      });
    });
  });
}
function lh(i) {
  const e = we(i, ["schm"])[0];
  if (e) {
    const t = rt(e.subarray(4, 8));
    if (t === "cbcs" || t === "cenc")
      return we(i, ["schi", "tenc"])[0];
  }
  return null;
}
function o1(i, e, t) {
  const n = {}, s = we(i, ["moof", "traf"]);
  for (let r = 0; r < s.length; r++) {
    const a = s[r], o = we(a, ["tfhd"])[0], l = be(o, 4), d = e[l];
    if (!d)
      continue;
    n[l] || (n[l] = {
      start: NaN,
      duration: 0,
      sampleCount: 0,
      timescale: d.timescale,
      type: d.type
    });
    const c = n[l], u = we(a, ["tfdt"])[0];
    if (u) {
      const b = u[0];
      let k = be(u, 4);
      b === 1 && (k === nc ? t.warn("[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time") : (k *= nc + 1, k += be(u, 8))), ae(k) && (!ae(c.start) || k < c.start) && (c.start = k);
    }
    const f = d.default, h = be(o, 0) | f?.flags;
    let m = f?.duration || 0;
    h & 8 && (h & 2 ? m = be(o, 12) : m = be(o, 8));
    const g = we(a, ["trun"]);
    let v = c.start || 0, p = 0, y = m;
    for (let b = 0; b < g.length; b++) {
      const k = g[b], T = be(k, 4), I = c.sampleCount;
      c.sampleCount += T;
      const x = k[3] & 1, E = k[3] & 4, R = k[2] & 1, A = k[2] & 2, _ = k[2] & 4, C = k[2] & 8;
      let O = 8, V = T;
      for (x && (O += 4), E && T && (!(k[O + 1] & 1) && c.keyFrameIndex === void 0 && (c.keyFrameIndex = I), O += 4, R ? (y = be(k, O), O += 4) : y = m, A && (O += 4), C && (O += 4), v += y, p += y, V--); V--; )
        R ? (y = be(k, O), O += 4) : y = m, A && (O += 4), _ && (k[O + 1] & 1 || c.keyFrameIndex === void 0 && (c.keyFrameIndex = c.sampleCount - (V + 1), c.keyFrameStart = v), O += 4), C && (O += 4), v += y, p += y;
      !p && m && (p += m * T);
    }
    c.duration += p;
  }
  if (!Object.keys(n).some((r) => n[r].duration)) {
    let r = 0;
    const a = we(i, ["sidx"]);
    for (let o = 0; o < a.length; o++) {
      const l = n1(a[o]);
      if (l != null && l.references) {
        const d = l.references.reduce((c, u) => c + u.info.duration || 0, 0);
        r = Math.max(r, d + l.earliestPresentationTime / l.timescale);
      }
    }
    r && ae(r) && Object.keys(n).forEach((o) => {
      n[o].duration || (n[o].duration = r * n[o].timescale - n[o].start);
    });
  }
  return n;
}
function l1(i) {
  const e = {
    valid: null,
    remainder: null
  }, t = we(i, ["moof"]);
  if (t.length < 2)
    return e.remainder = i, e;
  const n = t[t.length - 1];
  return e.valid = i.slice(0, n.byteOffset - 8), e.remainder = i.slice(n.byteOffset - 8), e;
}
function Zt(i, e) {
  const t = new Uint8Array(i.length + e.length);
  return t.set(i), t.set(e, i.length), t;
}
function rc(i, e) {
  const t = [], n = e.samples, s = e.timescale, r = e.id;
  let a = !1;
  return we(n, ["moof"]).map((l) => {
    const d = l.byteOffset - 8;
    we(l, ["traf"]).map((u) => {
      const f = we(u, ["tfdt"]).map((h) => {
        const m = h[0];
        let g = be(h, 4);
        return m === 1 && (g *= Math.pow(2, 32), g += be(h, 8)), g / s;
      })[0];
      return f !== void 0 && (i = f), we(u, ["tfhd"]).map((h) => {
        const m = be(h, 4), g = be(h, 0) & 16777215, v = (g & 1) !== 0, p = (g & 2) !== 0, y = (g & 8) !== 0;
        let b = 0;
        const k = (g & 16) !== 0;
        let T = 0;
        const I = (g & 32) !== 0;
        let x = 8;
        m === r && (v && (x += 8), p && (x += 4), y && (b = be(h, x), x += 4), k && (T = be(h, x), x += 4), I && (x += 4), e.type === "video" && (a = ma(e.codec)), we(u, ["trun"]).map((E) => {
          const R = E[0], A = be(E, 0) & 16777215, _ = (A & 1) !== 0;
          let C = 0;
          const O = (A & 4) !== 0, V = (A & 256) !== 0;
          let j = 0;
          const X = (A & 512) !== 0;
          let q = 0;
          const z = (A & 1024) !== 0, Q = (A & 2048) !== 0;
          let oe = 0;
          const Z = be(E, 4);
          let te = 8;
          _ && (C = be(E, te), te += 4), O && (te += 4);
          let Ee = C + d;
          for (let De = 0; De < Z; De++) {
            if (V ? (j = be(E, te), te += 4) : j = b, X ? (q = be(E, te), te += 4) : q = T, z && (te += 4), Q && (R === 0 ? oe = be(E, te) : oe = ah(E, te), te += 4), e.type === ze.VIDEO) {
              let xe = 0;
              for (; xe < q; ) {
                const Ae = be(n, Ee);
                if (Ee += 4, d1(a, n[Ee])) {
                  const tt = n.subarray(Ee, Ee + Ae);
                  bl(tt, a ? 2 : 1, i + oe / s, t);
                }
                Ee += Ae, xe += Ae + 4;
              }
            }
            i += j / s;
          }
        }));
      });
    });
  }), t;
}
function ma(i) {
  if (!i)
    return !1;
  const e = i.substring(0, 4);
  return e === "hvc1" || e === "hev1" || // Dolby Vision
  e === "dvh1" || e === "dvhe";
}
function d1(i, e) {
  if (i) {
    const t = e >> 1 & 63;
    return t === 39 || t === 40;
  } else
    return (e & 31) === 6;
}
function bl(i, e, t, n) {
  const s = dh(i);
  let r = 0;
  r += e;
  let a = 0, o = 0, l = 0;
  for (; r < s.length; ) {
    a = 0;
    do {
      if (r >= s.length)
        break;
      l = s[r++], a += l;
    } while (l === 255);
    o = 0;
    do {
      if (r >= s.length)
        break;
      l = s[r++], o += l;
    } while (l === 255);
    const d = s.length - r;
    let c = r;
    if (o < d)
      r += o;
    else if (o > d) {
      Be.error(`Malformed SEI payload. ${o} is too small, only ${d} bytes left to parse.`);
      break;
    }
    if (a === 4) {
      if (s[c++] === 181) {
        const f = rh(s, c);
        if (c += 2, f === 49) {
          const h = be(s, c);
          if (c += 4, h === 1195456820) {
            const m = s[c++];
            if (m === 3) {
              const g = s[c++], v = 31 & g, p = 64 & g, y = p ? 2 + v * 3 : 0, b = new Uint8Array(y);
              if (p) {
                b[0] = g;
                for (let k = 1; k < y; k++)
                  b[k] = s[c++];
              }
              n.push({
                type: m,
                payloadType: a,
                pts: t,
                bytes: b
              });
            }
          }
        }
      }
    } else if (a === 5 && o > 16) {
      const u = [];
      for (let m = 0; m < 16; m++) {
        const g = s[c++].toString(16);
        u.push(g.length == 1 ? "0" + g : g), (m === 3 || m === 5 || m === 7 || m === 9) && u.push("-");
      }
      const f = o - 16, h = new Uint8Array(f);
      for (let m = 0; m < f; m++)
        h[m] = s[c++];
      n.push({
        payloadType: a,
        pts: t,
        uuid: u.join(""),
        userData: Ht(h),
        userDataBytes: h
      });
    }
  }
}
function dh(i) {
  const e = i.byteLength, t = [];
  let n = 1;
  for (; n < e - 2; )
    i[n] === 0 && i[n + 1] === 0 && i[n + 2] === 3 ? (t.push(n + 2), n += 2) : n++;
  if (t.length === 0)
    return i;
  const s = e - t.length, r = new Uint8Array(s);
  let a = 0;
  for (n = 0; n < s; a++, n++)
    a === t[0] && (a++, t.shift()), r[n] = i[a];
  return r;
}
function c1(i) {
  const e = i[0];
  let t = "", n = "", s = 0, r = 0, a = 0, o = 0, l = 0, d = 0;
  if (e === 0) {
    for (; rt(i.subarray(d, d + 1)) !== "\0"; )
      t += rt(i.subarray(d, d + 1)), d += 1;
    for (t += rt(i.subarray(d, d + 1)), d += 1; rt(i.subarray(d, d + 1)) !== "\0"; )
      n += rt(i.subarray(d, d + 1)), d += 1;
    n += rt(i.subarray(d, d + 1)), d += 1, s = be(i, 12), r = be(i, 16), o = be(i, 20), l = be(i, 24), d = 28;
  } else if (e === 1) {
    d += 4, s = be(i, d), d += 4;
    const u = be(i, d);
    d += 4;
    const f = be(i, d);
    for (d += 4, a = 2 ** 32 * u + f, Vv(a) || (a = Number.MAX_SAFE_INTEGER, Be.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box")), o = be(i, d), d += 4, l = be(i, d), d += 4; rt(i.subarray(d, d + 1)) !== "\0"; )
      t += rt(i.subarray(d, d + 1)), d += 1;
    for (t += rt(i.subarray(d, d + 1)), d += 1; rt(i.subarray(d, d + 1)) !== "\0"; )
      n += rt(i.subarray(d, d + 1)), d += 1;
    n += rt(i.subarray(d, d + 1)), d += 1;
  }
  const c = i.subarray(d, i.byteLength);
  return {
    schemeIdUri: t,
    value: n,
    timeScale: s,
    presentationTime: a,
    presentationTimeDelta: r,
    eventDuration: o,
    id: l,
    payload: c
  };
}
function u1(i, ...e) {
  const t = e.length;
  let n = 8, s = t;
  for (; s--; )
    n += e[s].byteLength;
  const r = new Uint8Array(n);
  for (r[0] = n >> 24 & 255, r[1] = n >> 16 & 255, r[2] = n >> 8 & 255, r[3] = n & 255, r.set(i, 4), s = 0, n = 8; s < t; s++)
    r.set(e[s], n), n += e[s].byteLength;
  return r;
}
function f1(i, e, t) {
  if (i.byteLength !== 16)
    throw new RangeError("Invalid system id");
  let n, s;
  n = 0, s = new Uint8Array();
  let r;
  n > 0 ? (r = new Uint8Array(4), e.length > 0 && new DataView(r.buffer).setUint32(0, e.length, !1)) : r = new Uint8Array();
  const a = new Uint8Array(4);
  return t.byteLength > 0 && new DataView(a.buffer).setUint32(0, t.byteLength, !1), u1(
    [112, 115, 115, 104],
    new Uint8Array([
      n,
      0,
      0,
      0
      // Flags
    ]),
    i,
    // 16 bytes
    r,
    s,
    a,
    t
  );
}
const ch = () => /\(Windows.+Firefox\//i.test(navigator.userAgent), zn = {
  audio: {
    a3ds: 1,
    "ac-3": 0.95,
    "ac-4": 1,
    alac: 0.9,
    alaw: 1,
    dra1: 1,
    "dts+": 1,
    "dts-": 1,
    dtsc: 1,
    dtse: 1,
    dtsh: 1,
    "ec-3": 0.9,
    enca: 1,
    fLaC: 0.9,
    // MP4-RA listed codec entry for FLAC
    flac: 0.9,
    // legacy browser codec name for FLAC
    FLAC: 0.9,
    // some manifests may list "FLAC" with Apple's tools
    g719: 1,
    g726: 1,
    m4ae: 1,
    mha1: 1,
    mha2: 1,
    mhm1: 1,
    mhm2: 1,
    mlpa: 1,
    mp4a: 1,
    "raw ": 1,
    Opus: 1,
    opus: 1,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: 1,
    sawb: 1,
    sawp: 1,
    sevc: 1,
    sqcp: 1,
    ssmv: 1,
    twos: 1,
    ulaw: 1
  },
  video: {
    avc1: 1,
    avc2: 1,
    avc3: 1,
    avc4: 1,
    avcp: 1,
    av01: 0.8,
    dav1: 0.8,
    drac: 1,
    dva1: 1,
    dvav: 1,
    dvh1: 0.7,
    dvhe: 0.7,
    encv: 1,
    hev1: 0.75,
    hvc1: 0.75,
    mjp2: 1,
    mp4v: 1,
    mvc1: 1,
    mvc2: 1,
    mvc3: 1,
    mvc4: 1,
    resv: 1,
    rv60: 1,
    s263: 1,
    svc1: 1,
    svc2: 1,
    "vc-1": 1,
    vp08: 1,
    vp09: 0.9
  },
  text: {
    stpp: 1,
    wvtt: 1
  }
};
function Sl(i, e) {
  const t = zn[e];
  return !!t && !!t[i.slice(0, 4)];
}
function Lo(i, e, t = !0) {
  return !i.split(",").some((n) => !kl(n, e, t));
}
function kl(i, e, t = !0) {
  var n;
  const s = en(t);
  return (n = s?.isTypeSupported(_s(i, e))) != null ? n : !1;
}
function _s(i, e) {
  return `${e}/mp4;codecs=${i}`;
}
function ac(i) {
  if (i) {
    const e = i.substring(0, 4);
    return zn.video[e];
  }
  return 2;
}
function Ir(i) {
  const e = ch();
  return i.split(",").reduce((t, n) => {
    const r = e && ma(n) ? 9 : zn.video[n];
    return r ? (r * 2 + t) / (t ? 3 : 2) : (zn.audio[n] + t) / (t ? 2 : 1);
  }, 0);
}
const Ma = {};
function h1(i, e = !0) {
  if (Ma[i])
    return Ma[i];
  const t = {
    // Idealy fLaC and Opus would be first (spec-compliant) but
    // some browsers will report that fLaC is supported then fail.
    // see: https://bugs.chromium.org/p/chromium/issues/detail?id=1422728
    flac: ["flac", "fLaC", "FLAC"],
    opus: ["opus", "Opus"],
    // Replace audio codec info if browser does not support mp4a.40.34,
    // and demuxer can fallback to 'audio/mpeg' or 'audio/mp4;codecs="mp3"'
    "mp4a.40.34": ["mp3"]
  }[i];
  for (let s = 0; s < t.length; s++) {
    var n;
    if (kl(t[s], "audio", e))
      return Ma[i] = t[s], t[s];
    if (t[s] === "mp3" && (n = en(e)) != null && n.isTypeSupported("audio/mpeg"))
      return "";
  }
  return i;
}
const m1 = /flac|opus|mp4a\.40\.34/i;
function Cr(i, e = !0) {
  return i.replace(m1, (t) => h1(t.toLowerCase(), e));
}
function p1(i, e) {
  const t = [];
  if (i) {
    const n = i.split(",");
    for (let s = 0; s < n.length; s++)
      Sl(n[s], "video") || t.push(n[s]);
  }
  return e && t.push(e), t.join(",");
}
function cr(i, e) {
  if (i && (i.length > 4 || ["ac-3", "ec-3", "alac", "fLaC", "Opus"].indexOf(i) !== -1) && (oc(i, "audio") || oc(i, "video")))
    return i;
  if (e) {
    const t = e.split(",");
    if (t.length > 1) {
      if (i) {
        for (let n = t.length; n--; )
          if (t[n].substring(0, 4) === i.substring(0, 4))
            return t[n];
      }
      return t[0];
    }
  }
  return e || i;
}
function oc(i, e) {
  return Sl(i, e) && kl(i, e);
}
function g1(i) {
  const e = i.split(",");
  for (let t = 0; t < e.length; t++) {
    const n = e[t].split(".");
    n.length > 2 && n[0] === "avc1" && (e[t] = `avc1.${parseInt(n[1]).toString(16)}${("000" + parseInt(n[2]).toString(16)).slice(-4)}`);
  }
  return e.join(",");
}
function v1(i) {
  if (i.startsWith("av01.")) {
    const e = i.split("."), t = ["0", "111", "01", "01", "01", "0"];
    for (let n = e.length; n > 4 && n < 10; n++)
      e[n] = t[n - 4];
    return e.join(".");
  }
  return i;
}
function lc(i) {
  const e = en(i) || {
    isTypeSupported: () => !1
  };
  return {
    mpeg: e.isTypeSupported("audio/mpeg"),
    mp3: e.isTypeSupported('audio/mp4; codecs="mp3"'),
    ac3: e.isTypeSupported('audio/mp4; codecs="ac-3"')
  };
}
function Io(i) {
  return i.replace(/^.+codecs=["']?([^"']+).*$/, "$1");
}
const uh = {
  supported: !0,
  configurations: [],
  decodingInfoResults: [{
    supported: !0,
    powerEfficient: !0,
    smooth: !0
  }]
};
function fh(i, e) {
  return {
    supported: !1,
    configurations: e,
    decodingInfoResults: [{
      supported: !1,
      smooth: !1,
      powerEfficient: !1
    }],
    error: i
  };
}
function y1(i, e, t, n, s, r) {
  const a = i.videoCodec, o = i.audioCodec ? i.audioGroups : null, l = r?.audioCodec, d = r?.channels, c = d ? parseInt(d) : l ? 1 / 0 : 2;
  let u = null;
  if (o != null && o.length)
    try {
      o.length === 1 && o[0] ? u = e.groups[o[0]].channels : u = o.reduce((f, h) => {
        if (h) {
          const m = e.groups[h];
          if (!m)
            throw new Error(`Audio track group ${h} not found`);
          Object.keys(m.channels).forEach((g) => {
            f[g] = (f[g] || 0) + m.channels[g];
          });
        }
        return f;
      }, {
        2: 0
      });
    } catch {
      return !0;
    }
  return a !== void 0 && // Force media capabilities check for HEVC to avoid failure on Windows
  (a.split(",").some((f) => ma(f)) || i.width > 1920 && i.height > 1088 || i.height > 1920 && i.width > 1088 || i.frameRate > Math.max(n, 30) || i.videoRange !== "SDR" && i.videoRange !== t || i.bitrate > Math.max(s, 8e6)) || !!u && ae(c) && Object.keys(u).some((f) => parseInt(f) > c);
}
function hh(i, e, t, n = {}) {
  const s = i.videoCodec;
  if (!s && !i.audioCodec || !t)
    return Promise.resolve(uh);
  const r = [], a = b1(i), o = a.length, l = S1(i, e, o > 0), d = l.length;
  for (let c = o || 1 * d || 1; c--; ) {
    const u = {
      type: "media-source"
    };
    if (o && (u.video = a[c % o]), d) {
      u.audio = l[c % d];
      const f = u.audio.bitrate;
      u.video && f && (u.video.bitrate -= f);
    }
    r.push(u);
  }
  if (s) {
    const c = navigator.userAgent;
    if (s.split(",").some((u) => ma(u)) && ch())
      return Promise.resolve(fh(new Error(`Overriding Windows Firefox HEVC MediaCapabilities result based on user-agent string: (${c})`), r));
  }
  return Promise.all(r.map((c) => {
    const u = T1(c);
    return n[u] || (n[u] = t.decodingInfo(c));
  })).then((c) => ({
    supported: !c.some((u) => !u.supported),
    configurations: r,
    decodingInfoResults: c
  })).catch((c) => ({
    supported: !1,
    configurations: r,
    decodingInfoResults: [],
    error: c
  }));
}
function b1(i) {
  var e;
  const t = (e = i.videoCodec) == null ? void 0 : e.split(","), n = mh(i), s = i.width || 640, r = i.height || 480, a = i.frameRate || 30, o = i.videoRange.toLowerCase();
  return t ? t.map((l) => {
    const d = {
      contentType: _s(v1(l), "video"),
      width: s,
      height: r,
      bitrate: n,
      framerate: a
    };
    return o !== "sdr" && (d.transferFunction = o), d;
  }) : [];
}
function S1(i, e, t) {
  var n;
  const s = (n = i.audioCodec) == null ? void 0 : n.split(","), r = mh(i);
  return s && i.audioGroups ? i.audioGroups.reduce((a, o) => {
    var l;
    const d = o ? (l = e.groups[o]) == null ? void 0 : l.tracks : null;
    return d ? d.reduce((c, u) => {
      if (u.groupId === o) {
        const f = parseFloat(u.channels || "");
        s.forEach((h) => {
          const m = {
            contentType: _s(h, "audio"),
            bitrate: t ? k1(h, r) : r
          };
          f && (m.channels = "" + f), c.push(m);
        });
      }
      return c;
    }, a) : a;
  }, []) : [];
}
function k1(i, e) {
  if (e <= 1)
    return 1;
  let t = 128e3;
  return i === "ec-3" ? t = 768e3 : i === "ac-3" && (t = 64e4), Math.min(e / 2, t);
}
function mh(i) {
  return Math.ceil(Math.max(i.bitrate * 0.9, i.averageBitrate) / 1e3) * 1e3 || 1;
}
function T1(i) {
  let e = "";
  const {
    audio: t,
    video: n
  } = i;
  if (n) {
    const s = Io(n.contentType);
    e += `${s}_r${n.height}x${n.width}f${Math.ceil(n.framerate)}${n.transferFunction || "sd"}_${Math.ceil(n.bitrate / 1e5)}`;
  }
  if (t) {
    const s = Io(t.contentType);
    e += `${n ? "_" : ""}${s}_c${t.channels}`;
  }
  return e;
}
const Co = ["NONE", "TYPE-0", "TYPE-1", null];
function E1(i) {
  return Co.indexOf(i) > -1;
}
const Rr = ["SDR", "PQ", "HLG"];
function x1(i) {
  return !!i && Rr.indexOf(i) > -1;
}
var ur = {
  No: "",
  Yes: "YES",
  v2: "v2"
};
function dc(i) {
  const {
    canSkipUntil: e,
    canSkipDateRanges: t,
    age: n
  } = i, s = n < e / 2;
  return e && s ? t ? ur.v2 : ur.Yes : ur.No;
}
class cc {
  constructor(e, t, n) {
    this.msn = void 0, this.part = void 0, this.skip = void 0, this.msn = e, this.part = t, this.skip = n;
  }
  addDirectives(e) {
    const t = new self.URL(e);
    return this.msn !== void 0 && t.searchParams.set("_HLS_msn", this.msn.toString()), this.part !== void 0 && t.searchParams.set("_HLS_part", this.part.toString()), this.skip && t.searchParams.set("_HLS_skip", this.skip), t.href;
  }
}
class As {
  constructor(e) {
    if (this._attrs = void 0, this.audioCodec = void 0, this.bitrate = void 0, this.codecSet = void 0, this.url = void 0, this.frameRate = void 0, this.height = void 0, this.id = void 0, this.name = void 0, this.supplemental = void 0, this.videoCodec = void 0, this.width = void 0, this.details = void 0, this.fragmentError = 0, this.loadError = 0, this.loaded = void 0, this.realBitrate = 0, this.supportedPromise = void 0, this.supportedResult = void 0, this._avgBitrate = 0, this._audioGroups = void 0, this._subtitleGroups = void 0, this._urlId = 0, this.url = [e.url], this._attrs = [e.attrs], this.bitrate = e.bitrate, e.details && (this.details = e.details), this.id = e.id || 0, this.name = e.name, this.width = e.width || 0, this.height = e.height || 0, this.frameRate = e.attrs.optionalFloat("FRAME-RATE", 0), this._avgBitrate = e.attrs.decimalInteger("AVERAGE-BANDWIDTH"), this.audioCodec = e.audioCodec, this.videoCodec = e.videoCodec, this.codecSet = [e.videoCodec, e.audioCodec].filter((n) => !!n).map((n) => n.substring(0, 4)).join(","), "supplemental" in e) {
      var t;
      this.supplemental = e.supplemental;
      const n = (t = e.supplemental) == null ? void 0 : t.videoCodec;
      n && n !== e.videoCodec && (this.codecSet += `,${n.substring(0, 4)}`);
    }
    this.addGroupId("audio", e.attrs.AUDIO), this.addGroupId("text", e.attrs.SUBTITLES);
  }
  get maxBitrate() {
    return Math.max(this.realBitrate, this.bitrate);
  }
  get averageBitrate() {
    return this._avgBitrate || this.realBitrate || this.bitrate;
  }
  get attrs() {
    return this._attrs[0];
  }
  get codecs() {
    return this.attrs.CODECS || "";
  }
  get pathwayId() {
    return this.attrs["PATHWAY-ID"] || ".";
  }
  get videoRange() {
    return this.attrs["VIDEO-RANGE"] || "SDR";
  }
  get score() {
    return this.attrs.optionalFloat("SCORE", 0);
  }
  get uri() {
    return this.url[0] || "";
  }
  hasAudioGroup(e) {
    return uc(this._audioGroups, e);
  }
  hasSubtitleGroup(e) {
    return uc(this._subtitleGroups, e);
  }
  get audioGroups() {
    return this._audioGroups;
  }
  get subtitleGroups() {
    return this._subtitleGroups;
  }
  addGroupId(e, t) {
    if (t) {
      if (e === "audio") {
        let n = this._audioGroups;
        n || (n = this._audioGroups = []), n.indexOf(t) === -1 && n.push(t);
      } else if (e === "text") {
        let n = this._subtitleGroups;
        n || (n = this._subtitleGroups = []), n.indexOf(t) === -1 && n.push(t);
      }
    }
  }
  // Deprecated methods (retained for backwards compatibility)
  get urlId() {
    return 0;
  }
  set urlId(e) {
  }
  get audioGroupIds() {
    return this.audioGroups ? [this.audioGroupId] : void 0;
  }
  get textGroupIds() {
    return this.subtitleGroups ? [this.textGroupId] : void 0;
  }
  get audioGroupId() {
    var e;
    return (e = this.audioGroups) == null ? void 0 : e[0];
  }
  get textGroupId() {
    var e;
    return (e = this.subtitleGroups) == null ? void 0 : e[0];
  }
  addFallback() {
  }
}
function uc(i, e) {
  return !e || !i ? !1 : i.indexOf(e) !== -1;
}
function _1() {
  if (typeof matchMedia == "function") {
    const i = matchMedia("(dynamic-range: high)"), e = matchMedia("bad query");
    if (i.media !== e.media)
      return i.matches === !0;
  }
  return !1;
}
function A1(i, e) {
  let t = !1, n = [];
  if (i && (t = i !== "SDR", n = [i]), e) {
    n = e.allowedVideoRanges || Rr.slice(0);
    const s = n.join("") !== "SDR" && !e.videoCodec;
    t = e.preferHDR !== void 0 ? e.preferHDR : s && _1(), t || (n = ["SDR"]);
  }
  return {
    preferHDR: t,
    allowedVideoRanges: n
  };
}
const w1 = (i) => {
  const e = /* @__PURE__ */ new WeakSet();
  return (t, n) => {
    if (i && (n = i(t, n)), typeof n == "object" && n !== null) {
      if (e.has(n))
        return;
      e.add(n);
    }
    return n;
  };
}, qe = (i, e) => JSON.stringify(i, w1(e));
function L1(i, e, t, n, s) {
  const r = Object.keys(i), a = n?.channels, o = n?.audioCodec, l = s?.videoCodec, d = a && parseInt(a) === 2;
  let c = !1, u = !1, f = 1 / 0, h = 1 / 0, m = 1 / 0, g = 1 / 0, v = 0, p = [];
  const {
    preferHDR: y,
    allowedVideoRanges: b
  } = A1(e, s);
  for (let E = r.length; E--; ) {
    const R = i[r[E]];
    c || (c = R.channels[2] > 0), f = Math.min(f, R.minHeight), h = Math.min(h, R.minFramerate), m = Math.min(m, R.minBitrate), b.filter((_) => R.videoRanges[_] > 0).length > 0 && (u = !0);
  }
  f = ae(f) ? f : 0, h = ae(h) ? h : 0;
  const k = Math.max(1080, f), T = Math.max(30, h);
  m = ae(m) ? m : t, t = Math.max(m, t), u || (e = void 0);
  const I = r.length > 1;
  return {
    codecSet: r.reduce((E, R) => {
      const A = i[R];
      if (R === E)
        return E;
      if (p = u ? b.filter((_) => A.videoRanges[_] > 0) : [], I) {
        if (A.minBitrate > t)
          return ai(R, `min bitrate of ${A.minBitrate} > current estimate of ${t}`), E;
        if (!A.hasDefaultAudio)
          return ai(R, "no renditions with default or auto-select sound found"), E;
        if (o && R.indexOf(o.substring(0, 4)) % 5 !== 0)
          return ai(R, `audio codec preference "${o}" not found`), E;
        if (a && !d) {
          if (!A.channels[a])
            return ai(R, `no renditions with ${a} channel sound found (channels options: ${Object.keys(A.channels)})`), E;
        } else if ((!o || d) && c && A.channels[2] === 0)
          return ai(R, "no renditions with stereo sound found"), E;
        if (A.minHeight > k)
          return ai(R, `min resolution of ${A.minHeight} > maximum of ${k}`), E;
        if (A.minFramerate > T)
          return ai(R, `min framerate of ${A.minFramerate} > maximum of ${T}`), E;
        if (!p.some((_) => A.videoRanges[_] > 0))
          return ai(R, `no variants with VIDEO-RANGE of ${qe(p)} found`), E;
        if (l && R.indexOf(l.substring(0, 4)) % 5 !== 0)
          return ai(R, `video codec preference "${l}" not found`), E;
        if (A.maxScore < v)
          return ai(R, `max score of ${A.maxScore} < selected max of ${v}`), E;
      }
      return E && (Ir(R) >= Ir(E) || A.fragmentError > i[E].fragmentError) ? E : (g = A.minIndex, v = A.maxScore, R);
    }, void 0),
    videoRanges: p,
    preferHDR: y,
    minFramerate: h,
    minBitrate: m,
    minIndex: g
  };
}
function ai(i, e) {
  Be.log(`[abr] start candidates with "${i}" ignored because ${e}`);
}
function ph(i) {
  return i.reduce((e, t) => {
    let n = e.groups[t.groupId];
    n || (n = e.groups[t.groupId] = {
      tracks: [],
      channels: {
        2: 0
      },
      hasDefault: !1,
      hasAutoSelect: !1
    }), n.tracks.push(t);
    const s = t.channels || "2";
    return n.channels[s] = (n.channels[s] || 0) + 1, n.hasDefault = n.hasDefault || t.default, n.hasAutoSelect = n.hasAutoSelect || t.autoselect, n.hasDefault && (e.hasDefaultAudio = !0), n.hasAutoSelect && (e.hasAutoSelectAudio = !0), e;
  }, {
    hasDefaultAudio: !1,
    hasAutoSelectAudio: !1,
    groups: {}
  });
}
function I1(i, e, t, n) {
  return i.slice(t, n + 1).reduce((s, r, a) => {
    if (!r.codecSet)
      return s;
    const o = r.audioGroups;
    let l = s[r.codecSet];
    l || (s[r.codecSet] = l = {
      minBitrate: 1 / 0,
      minHeight: 1 / 0,
      minFramerate: 1 / 0,
      minIndex: a,
      maxScore: 0,
      videoRanges: {
        SDR: 0
      },
      channels: {
        2: 0
      },
      hasDefaultAudio: !o,
      fragmentError: 0
    }), l.minBitrate = Math.min(l.minBitrate, r.bitrate);
    const d = Math.min(r.height, r.width);
    return l.minHeight = Math.min(l.minHeight, d), l.minFramerate = Math.min(l.minFramerate, r.frameRate), l.minIndex = Math.min(l.minIndex, a), l.maxScore = Math.max(l.maxScore, r.score), l.fragmentError += r.fragmentError, l.videoRanges[r.videoRange] = (l.videoRanges[r.videoRange] || 0) + 1, o && o.forEach((c) => {
      if (!c)
        return;
      const u = e.groups[c];
      u && (l.hasDefaultAudio = l.hasDefaultAudio || e.hasDefaultAudio ? u.hasDefault : u.hasAutoSelect || !e.hasDefaultAudio && !e.hasAutoSelectAudio, Object.keys(u.channels).forEach((f) => {
        l.channels[f] = (l.channels[f] || 0) + u.channels[f];
      }));
    }), s;
  }, {});
}
function fc(i) {
  if (!i)
    return i;
  const {
    lang: e,
    assocLang: t,
    characteristics: n,
    channels: s,
    audioCodec: r
  } = i;
  return {
    lang: e,
    assocLang: t,
    characteristics: n,
    channels: s,
    audioCodec: r
  };
}
function fi(i, e, t) {
  if ("attrs" in i) {
    const n = e.indexOf(i);
    if (n !== -1)
      return n;
  }
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    if (bn(i, s, t))
      return n;
  }
  return -1;
}
function bn(i, e, t) {
  const {
    groupId: n,
    name: s,
    lang: r,
    assocLang: a,
    default: o
  } = i, l = i.forced;
  return (n === void 0 || e.groupId === n) && (s === void 0 || e.name === s) && (r === void 0 || C1(r, e.lang)) && (r === void 0 || e.assocLang === a) && (o === void 0 || e.default === o) && (l === void 0 || e.forced === l) && (!("characteristics" in i) || R1(i.characteristics || "", e.characteristics)) && (t === void 0 || t(i, e));
}
function C1(i, e = "--") {
  return i.length === e.length ? i === e : i.startsWith(e) || e.startsWith(i);
}
function R1(i, e = "") {
  const t = i.split(","), n = e.split(",");
  return t.length === n.length && !t.some((s) => n.indexOf(s) === -1);
}
function hn(i, e) {
  const {
    audioCodec: t,
    channels: n
  } = i;
  return (t === void 0 || (e.audioCodec || "").substring(0, 4) === t.substring(0, 4)) && (n === void 0 || n === (e.channels || "2"));
}
function P1(i, e, t, n, s) {
  const r = e[n], o = e.reduce((f, h, m) => {
    const g = h.uri;
    return (f[g] || (f[g] = [])).push(m), f;
  }, {})[r.uri];
  o.length > 1 && (n = Math.max.apply(Math, o));
  const l = r.videoRange, d = r.frameRate, c = r.codecSet.substring(0, 4), u = hc(e, n, (f) => {
    if (f.videoRange !== l || f.frameRate !== d || f.codecSet.substring(0, 4) !== c)
      return !1;
    const h = f.audioGroups, m = t.filter((g) => !h || h.indexOf(g.groupId) !== -1);
    return fi(i, m, s) > -1;
  });
  return u > -1 ? u : hc(e, n, (f) => {
    const h = f.audioGroups, m = t.filter((g) => !h || h.indexOf(g.groupId) !== -1);
    return fi(i, m, s) > -1;
  });
}
function hc(i, e, t) {
  for (let n = e; n > -1; n--)
    if (t(i[n]))
      return n;
  for (let n = e + 1; n < i.length; n++)
    if (t(i[n]))
      return n;
  return -1;
}
function Pr(i, e) {
  var t;
  return !!i && i !== ((t = e.loadLevelObj) == null ? void 0 : t.uri);
}
class D1 extends ni {
  constructor(e) {
    super("abr", e.logger), this.hls = void 0, this.lastLevelLoadSec = 0, this.lastLoadedFragLevel = -1, this.firstSelection = -1, this._nextAutoLevel = -1, this.nextAutoLevelKey = "", this.audioTracksByGroup = null, this.codecTiers = null, this.timer = -1, this.fragCurrent = null, this.partCurrent = null, this.bitrateTestDelay = 0, this.rebufferNotice = -1, this.supportedCache = {}, this.bwEstimator = void 0, this._abandonRulesCheck = (t) => {
      var n;
      const {
        fragCurrent: s,
        partCurrent: r,
        hls: a
      } = this, {
        autoLevelEnabled: o,
        media: l
      } = a;
      if (!s || !l)
        return;
      const d = performance.now(), c = r ? r.stats : s.stats, u = r ? r.duration : s.duration, f = d - c.loading.start, h = a.minAutoLevel, m = s.level, g = this._nextAutoLevel;
      if (c.aborted || c.loaded && c.loaded === c.total || m <= h) {
        this.clearTimer(), this._nextAutoLevel = -1;
        return;
      }
      if (!o)
        return;
      const v = g > -1 && g !== m, p = !!t || v;
      if (!p && (l.paused || !l.playbackRate || !l.readyState))
        return;
      const y = a.mainForwardBufferInfo;
      if (!p && y === null)
        return;
      const b = this.bwEstimator.getEstimateTTFB(), k = Math.abs(l.playbackRate);
      if (f <= Math.max(b, 1e3 * (u / (k * 2))))
        return;
      const T = y ? y.len / k : 0, I = c.loading.first ? c.loading.first - c.loading.start : -1, x = c.loaded && I > -1, E = this.getBwEstimate(), R = a.levels, A = R[m], _ = Math.max(c.loaded, Math.round(u * (s.bitrate || A.averageBitrate) / 8));
      let C = x ? f - I : f;
      C < 1 && x && (C = Math.min(f, c.loaded * 8 / E));
      const O = x ? c.loaded * 1e3 / C : 0, V = b / 1e3, j = O ? (_ - c.loaded) / O : _ * 8 / E + V;
      if (j <= T)
        return;
      const X = O ? O * 8 : E, q = ((n = t?.details || this.hls.latestLevelDetails) == null ? void 0 : n.live) === !0, z = this.hls.config.abrBandWidthUpFactor;
      let Q = Number.POSITIVE_INFINITY, oe;
      for (oe = m - 1; oe > h; oe--) {
        const De = R[oe].maxBitrate, xe = !R[oe].details || q;
        if (Q = this.getTimeToLoadFrag(V, X, u * De, xe), Q < Math.min(T, u + V))
          break;
      }
      if (Q >= j || Q > u * 10)
        return;
      x ? this.bwEstimator.sample(f - Math.min(b, I), c.loaded) : this.bwEstimator.sampleTTFB(f);
      const Z = R[oe].maxBitrate;
      this.getBwEstimate() * z > Z && this.resetEstimator(Z);
      const te = this.findBestLevel(Z, h, oe, 0, T, 1, 1);
      te > -1 && (oe = te), this.warn(`Fragment ${s.sn}${r ? " part " + r.index : ""} of level ${m} is loading too slowly;
      Fragment duration: ${s.duration.toFixed(3)}
      Time to underbuffer: ${T.toFixed(3)} s
      Estimated load time for current fragment: ${j.toFixed(3)} s
      Estimated load time for down switch fragment: ${Q.toFixed(3)} s
      TTFB estimate: ${I | 0} ms
      Current BW estimate: ${ae(E) ? E | 0 : "Unknown"} bps
      New BW estimate: ${this.getBwEstimate() | 0} bps
      Switching to level ${oe} @ ${Z | 0} bps`), a.nextLoadLevel = a.nextAutoLevel = oe, this.clearTimer();
      const Ee = () => {
        if (this.clearTimer(), this.fragCurrent === s && this.hls.loadLevel === oe && oe > 0) {
          const De = this.getStarvationDelay();
          if (this.warn(`Aborting inflight request ${oe > 0 ? "and switching down" : ""}
      Fragment duration: ${s.duration.toFixed(3)} s
      Time to underbuffer: ${De.toFixed(3)} s`), s.abortRequests(), this.fragCurrent = this.partCurrent = null, oe > h) {
            let xe = this.findBestLevel(this.hls.levels[h].bitrate, h, oe, 0, De, 1, 1);
            xe === -1 && (xe = h), this.hls.nextLoadLevel = this.hls.nextAutoLevel = xe, this.resetEstimator(this.hls.levels[xe].bitrate);
          }
        }
      };
      v || j > Q * 2 ? Ee() : this.timer = self.setInterval(Ee, Q * 1e3), a.trigger(S.FRAG_LOAD_EMERGENCY_ABORTED, {
        frag: s,
        part: r,
        stats: c
      });
    }, this.hls = e, this.bwEstimator = this.initEstimator(), this.registerListeners();
  }
  resetEstimator(e) {
    e && (this.log(`setting initial bwe to ${e}`), this.hls.config.abrEwmaDefaultEstimate = e), this.firstSelection = -1, this.bwEstimator = this.initEstimator();
  }
  initEstimator() {
    const e = this.hls.config;
    return new Hv(e.abrEwmaSlowVoD, e.abrEwmaFastVoD, e.abrEwmaDefaultEstimate);
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(S.MANIFEST_LOADING, this.onManifestLoading, this), e.on(S.FRAG_LOADING, this.onFragLoading, this), e.on(S.FRAG_LOADED, this.onFragLoaded, this), e.on(S.FRAG_BUFFERED, this.onFragBuffered, this), e.on(S.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(S.LEVEL_LOADED, this.onLevelLoaded, this), e.on(S.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(S.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this), e.on(S.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(S.MANIFEST_LOADING, this.onManifestLoading, this), e.off(S.FRAG_LOADING, this.onFragLoading, this), e.off(S.FRAG_LOADED, this.onFragLoaded, this), e.off(S.FRAG_BUFFERED, this.onFragBuffered, this), e.off(S.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(S.LEVEL_LOADED, this.onLevelLoaded, this), e.off(S.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(S.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this), e.off(S.ERROR, this.onError, this));
  }
  destroy() {
    this.unregisterListeners(), this.clearTimer(), this.hls = this._abandonRulesCheck = this.supportedCache = null, this.fragCurrent = this.partCurrent = null;
  }
  onManifestLoading(e, t) {
    this.lastLoadedFragLevel = -1, this.firstSelection = -1, this.lastLevelLoadSec = 0, this.supportedCache = {}, this.fragCurrent = this.partCurrent = null, this.onLevelsUpdated(), this.clearTimer();
  }
  onLevelsUpdated() {
    this.lastLoadedFragLevel > -1 && this.fragCurrent && (this.lastLoadedFragLevel = this.fragCurrent.level), this._nextAutoLevel = -1, this.onMaxAutoLevelUpdated(), this.codecTiers = null, this.audioTracksByGroup = null;
  }
  onMaxAutoLevelUpdated() {
    this.firstSelection = -1, this.nextAutoLevelKey = "";
  }
  onFragLoading(e, t) {
    const n = t.frag;
    if (!this.ignoreFragment(n)) {
      if (!n.bitrateTest) {
        var s;
        this.fragCurrent = n, this.partCurrent = (s = t.part) != null ? s : null;
      }
      this.clearTimer(), this.timer = self.setInterval(this._abandonRulesCheck, 100);
    }
  }
  onLevelSwitching(e, t) {
    this.clearTimer();
  }
  onError(e, t) {
    if (!t.fatal)
      switch (t.details) {
        case B.BUFFER_ADD_CODEC_ERROR:
        case B.BUFFER_APPEND_ERROR:
          this.lastLoadedFragLevel = -1, this.firstSelection = -1;
          break;
        case B.FRAG_LOAD_TIMEOUT: {
          const n = t.frag, {
            fragCurrent: s,
            partCurrent: r
          } = this;
          if (n && s && n.sn === s.sn && n.level === s.level) {
            const a = performance.now(), o = r ? r.stats : n.stats, l = a - o.loading.start, d = o.loading.first ? o.loading.first - o.loading.start : -1;
            if (o.loaded && d > -1) {
              const u = this.bwEstimator.getEstimateTTFB();
              this.bwEstimator.sample(l - Math.min(u, d), o.loaded);
            } else
              this.bwEstimator.sampleTTFB(l);
          }
          break;
        }
      }
  }
  getTimeToLoadFrag(e, t, n, s) {
    const r = e + n / t, a = s ? e + this.lastLevelLoadSec : 0;
    return r + a;
  }
  onLevelLoaded(e, t) {
    const n = this.hls.config, {
      loading: s
    } = t.stats, r = s.end - s.first;
    ae(r) && (this.lastLevelLoadSec = r / 1e3), t.details.live ? this.bwEstimator.update(n.abrEwmaSlowLive, n.abrEwmaFastLive) : this.bwEstimator.update(n.abrEwmaSlowVoD, n.abrEwmaFastVoD), this.timer > -1 && this._abandonRulesCheck(t.levelInfo);
  }
  onFragLoaded(e, {
    frag: t,
    part: n
  }) {
    const s = n ? n.stats : t.stats;
    if (t.type === ce.MAIN && this.bwEstimator.sampleTTFB(s.loading.first - s.loading.start), !this.ignoreFragment(t)) {
      if (this.clearTimer(), t.level === this._nextAutoLevel && (this._nextAutoLevel = -1), this.firstSelection = -1, this.hls.config.abrMaxWithRealBitrate) {
        const r = n ? n.duration : t.duration, a = this.hls.levels[t.level], o = (a.loaded ? a.loaded.bytes : 0) + s.loaded, l = (a.loaded ? a.loaded.duration : 0) + r;
        a.loaded = {
          bytes: o,
          duration: l
        }, a.realBitrate = Math.round(8 * o / l);
      }
      if (t.bitrateTest) {
        const r = {
          stats: s,
          frag: t,
          part: n,
          id: t.type
        };
        this.onFragBuffered(S.FRAG_BUFFERED, r), t.bitrateTest = !1;
      } else
        this.lastLoadedFragLevel = t.level;
    }
  }
  onFragBuffered(e, t) {
    const {
      frag: n,
      part: s
    } = t, r = s != null && s.stats.loaded ? s.stats : n.stats;
    if (r.aborted || this.ignoreFragment(n))
      return;
    const a = r.parsing.end - r.loading.start - Math.min(r.loading.first - r.loading.start, this.bwEstimator.getEstimateTTFB());
    this.bwEstimator.sample(a, r.loaded), r.bwEstimate = this.getBwEstimate(), n.bitrateTest ? this.bitrateTestDelay = a / 1e3 : this.bitrateTestDelay = 0;
  }
  ignoreFragment(e) {
    return e.type !== ce.MAIN || e.sn === "initSegment";
  }
  clearTimer() {
    this.timer > -1 && (self.clearInterval(this.timer), this.timer = -1);
  }
  get firstAutoLevel() {
    const {
      maxAutoLevel: e,
      minAutoLevel: t
    } = this.hls, n = this.getBwEstimate(), s = this.hls.config.maxStarvationDelay, r = this.findBestLevel(n, t, e, 0, s, 1, 1);
    if (r > -1)
      return r;
    const a = this.hls.firstLevel, o = Math.min(Math.max(a, t), e);
    return this.warn(`Could not find best starting auto level. Defaulting to first in playlist ${a} clamped to ${o}`), o;
  }
  get forcedAutoLevel() {
    return this.nextAutoLevelKey ? -1 : this._nextAutoLevel;
  }
  // return next auto level
  get nextAutoLevel() {
    const e = this.forcedAutoLevel, n = this.bwEstimator.canEstimate(), s = this.lastLoadedFragLevel > -1;
    if (e !== -1 && (!n || !s || this.nextAutoLevelKey === this.getAutoLevelKey()))
      return e;
    const r = n && s ? this.getNextABRAutoLevel() : this.firstAutoLevel;
    if (e !== -1) {
      const a = this.hls.levels;
      if (a.length > Math.max(e, r) && a[e].loadError <= a[r].loadError)
        return e;
    }
    return this._nextAutoLevel = r, this.nextAutoLevelKey = this.getAutoLevelKey(), r;
  }
  getAutoLevelKey() {
    return `${this.getBwEstimate()}_${this.getStarvationDelay().toFixed(2)}`;
  }
  getNextABRAutoLevel() {
    const {
      fragCurrent: e,
      partCurrent: t,
      hls: n
    } = this;
    if (n.levels.length <= 1)
      return n.loadLevel;
    const {
      maxAutoLevel: s,
      config: r,
      minAutoLevel: a
    } = n, o = t ? t.duration : e ? e.duration : 0, l = this.getBwEstimate(), d = this.getStarvationDelay();
    let c = r.abrBandWidthFactor, u = r.abrBandWidthUpFactor;
    if (d) {
      const v = this.findBestLevel(l, a, s, d, 0, c, u);
      if (v >= 0)
        return this.rebufferNotice = -1, v;
    }
    let f = o ? Math.min(o, r.maxStarvationDelay) : r.maxStarvationDelay;
    if (!d) {
      const v = this.bitrateTestDelay;
      v && (f = (o ? Math.min(o, r.maxLoadingDelay) : r.maxLoadingDelay) - v, this.info(`bitrate test took ${Math.round(1e3 * v)}ms, set first fragment max fetchDuration to ${Math.round(1e3 * f)} ms`), c = u = 1);
    }
    const h = this.findBestLevel(l, a, s, d, f, c, u);
    if (this.rebufferNotice !== h && (this.rebufferNotice = h, this.info(`${d ? "rebuffering expected" : "buffer is empty"}, optimal quality level ${h}`)), h > -1)
      return h;
    const m = n.levels[a], g = n.loadLevelObj;
    return g && m?.bitrate < g.bitrate ? a : n.loadLevel;
  }
  getStarvationDelay() {
    const e = this.hls, t = e.media;
    if (!t)
      return 1 / 0;
    const n = t && t.playbackRate !== 0 ? Math.abs(t.playbackRate) : 1, s = e.mainForwardBufferInfo;
    return (s ? s.len : 0) / n;
  }
  getBwEstimate() {
    return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
  }
  findBestLevel(e, t, n, s, r, a, o) {
    var l;
    const d = s + r, c = this.lastLoadedFragLevel, u = c === -1 ? this.hls.firstLevel : c, {
      fragCurrent: f,
      partCurrent: h
    } = this, {
      levels: m,
      allAudioTracks: g,
      loadLevel: v,
      config: p
    } = this.hls;
    if (m.length === 1)
      return 0;
    const y = m[u], b = !!((l = this.hls.latestLevelDetails) != null && l.live), k = v === -1 || c === -1;
    let T, I = "SDR", x = y?.frameRate || 0;
    const {
      audioPreference: E,
      videoPreference: R
    } = p, A = this.audioTracksByGroup || (this.audioTracksByGroup = ph(g));
    let _ = -1;
    if (k) {
      if (this.firstSelection !== -1)
        return this.firstSelection;
      const X = this.codecTiers || (this.codecTiers = I1(m, A, t, n)), q = L1(X, I, e, E, R), {
        codecSet: z,
        videoRanges: Q,
        minFramerate: oe,
        minBitrate: Z,
        minIndex: te,
        preferHDR: Ee
      } = q;
      _ = te, T = z, I = Ee ? Q[Q.length - 1] : Q[0], x = oe, e = Math.max(e, Z), this.log(`picked start tier ${qe(q)}`);
    } else
      T = y?.codecSet, I = y?.videoRange;
    const C = h ? h.duration : f ? f.duration : 0, O = this.bwEstimator.getEstimateTTFB() / 1e3, V = [];
    for (let X = n; X >= t; X--) {
      var j;
      const q = m[X], z = X > u;
      if (!q)
        continue;
      if (p.useMediaCapabilities && !q.supportedResult && !q.supportedPromise) {
        const xe = navigator.mediaCapabilities;
        typeof xe?.decodingInfo == "function" && y1(q, A, I, x, e, E) ? (q.supportedPromise = hh(q, A, xe, this.supportedCache), q.supportedPromise.then((Ae) => {
          if (!this.hls)
            return;
          q.supportedResult = Ae;
          const tt = this.hls.levels, it = tt.indexOf(q);
          Ae.error ? this.warn(`MediaCapabilities decodingInfo error: "${Ae.error}" for level ${it} ${qe(Ae)}`) : Ae.supported ? Ae.decodingInfoResults.some((kt) => kt.smooth === !1 || kt.powerEfficient === !1) && this.log(`MediaCapabilities decodingInfo for level ${it} not smooth or powerEfficient: ${qe(Ae)}`) : (this.warn(`Unsupported MediaCapabilities decodingInfo result for level ${it} ${qe(Ae)}`), it > -1 && tt.length > 1 && (this.log(`Removing unsupported level ${it}`), this.hls.removeLevel(it), this.hls.loadLevel === -1 && (this.hls.nextLoadLevel = 0)));
        })) : q.supportedResult = uh;
      }
      if ((T && q.codecSet !== T || I && q.videoRange !== I || z && x > q.frameRate || !z && x > 0 && x < q.frameRate || (j = q.supportedResult) != null && (j = j.decodingInfoResults) != null && j.some((xe) => xe.smooth === !1)) && (!k || X !== _)) {
        V.push(X);
        continue;
      }
      const Q = q.details, oe = (h ? Q?.partTarget : Q?.averagetargetduration) || C;
      let Z;
      z ? Z = o * e : Z = a * e;
      const te = C && s >= C * 2 && r === 0 ? q.averageBitrate : q.maxBitrate, Ee = this.getTimeToLoadFrag(O, Z, te * oe, Q === void 0);
      if (
        // if adjusted bw is greater than level bitrate AND
        Z >= te && // no level change, or new level has no error history
        (X === c || q.loadError === 0 && q.fragmentError === 0) && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
        // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
        // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
        (Ee <= O || !ae(Ee) || b && !this.bitrateTestDelay || Ee < d)
      ) {
        const xe = this.forcedAutoLevel;
        return X !== v && (xe === -1 || xe !== v) && (V.length && this.trace(`Skipped level(s) ${V.join(",")} of ${n} max with CODECS and VIDEO-RANGE:"${m[V[0]].codecs}" ${m[V[0]].videoRange}; not compatible with "${T}" ${I}`), this.info(`switch candidate:${u}->${X} adjustedbw(${Math.round(Z)})-bitrate=${Math.round(Z - te)} ttfb:${O.toFixed(1)} avgDuration:${oe.toFixed(1)} maxFetchDuration:${d.toFixed(1)} fetchDuration:${Ee.toFixed(1)} firstSelection:${k} codecSet:${q.codecSet} videoRange:${q.videoRange} hls.loadLevel:${v}`)), k && (this.firstSelection = X), X;
      }
    }
    return -1;
  }
  set nextAutoLevel(e) {
    const t = this.deriveNextAutoLevel(e);
    this._nextAutoLevel !== t && (this.nextAutoLevelKey = "", this._nextAutoLevel = t);
  }
  deriveNextAutoLevel(e) {
    const {
      maxAutoLevel: t,
      minAutoLevel: n
    } = this.hls;
    return Math.min(Math.max(e, n), t);
  }
}
const gh = {
  /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */
  search: function(i, e) {
    let t = 0, n = i.length - 1, s = null, r = null;
    for (; t <= n; ) {
      s = (t + n) / 2 | 0, r = i[s];
      const a = e(r);
      if (a > 0)
        t = s + 1;
      else if (a < 0)
        n = s - 1;
      else
        return r;
    }
    return null;
  }
};
function N1(i, e, t) {
  if (e === null || !Array.isArray(i) || !i.length || !ae(e))
    return null;
  const n = i[0].programDateTime;
  if (e < (n || 0))
    return null;
  const s = i[i.length - 1].endProgramDateTime;
  if (e >= (s || 0))
    return null;
  for (let r = 0; r < i.length; ++r) {
    const a = i[r];
    if (O1(e, t, a))
      return a;
  }
  return null;
}
function Sn(i, e, t = 0, n = 0, s = 5e-3) {
  let r = null;
  if (i) {
    r = e[1 + i.sn - e[0].sn] || null;
    const o = i.endDTS - t;
    o > 0 && o < 15e-7 && (t += 15e-7), r && i.level !== r.level && r.end <= i.end && (r = e[2 + i.sn - e[0].sn] || null);
  } else t === 0 && e[0].start === 0 && (r = e[0]);
  if (r && ((!i || i.level === r.level) && mc(t, n, r) === 0 || M1(r, i, Math.min(s, n))))
    return r;
  const a = gh.search(e, mc.bind(null, t, n));
  return a && (a !== i || !r) ? a : r;
}
function M1(i, e, t) {
  if (e && e.start === 0 && e.level < i.level && (e.endPTS || 0) > 0) {
    const n = e.tagList.reduce((s, r) => (r[0] === "INF" && (s += parseFloat(r[1])), s), t);
    return i.start <= n;
  }
  return !1;
}
function mc(i = 0, e = 0, t) {
  if (t.start <= i && t.start + t.duration > i)
    return 0;
  const n = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0));
  return t.start + t.duration - n <= i ? 1 : t.start - n > i && t.start ? -1 : 0;
}
function O1(i, e, t) {
  const n = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0)) * 1e3;
  return (t.endProgramDateTime || 0) - n > i;
}
function vh(i, e, t) {
  if (i && i.startCC <= e && i.endCC >= e) {
    let n = i.fragments;
    const {
      fragmentHint: s
    } = i;
    s && (n = n.concat(s));
    let r;
    return gh.search(n, (a) => a.cc < e ? 1 : a.cc > e ? -1 : (r = a, a.end <= t ? 1 : a.start > t ? -1 : 0)), r || null;
  }
  return null;
}
function Dr(i) {
  switch (i.details) {
    case B.FRAG_LOAD_TIMEOUT:
    case B.KEY_LOAD_TIMEOUT:
    case B.LEVEL_LOAD_TIMEOUT:
    case B.MANIFEST_LOAD_TIMEOUT:
      return !0;
  }
  return !1;
}
function pc(i, e) {
  const t = Dr(e);
  return i.default[`${t ? "timeout" : "error"}Retry`];
}
function Tl(i, e) {
  const t = i.backoff === "linear" ? 1 : Math.pow(2, e);
  return Math.min(t * i.retryDelayMs, i.maxRetryDelayMs);
}
function gc(i) {
  return Ve(Ve({}, i), {
    errorRetry: null,
    timeoutRetry: null
  });
}
function Nr(i, e, t, n) {
  if (!i)
    return !1;
  const s = n?.code, r = e < i.maxNumRetry && (F1(s) || !!t);
  return i.shouldRetry ? i.shouldRetry(i, e, t, n, r) : r;
}
function F1(i) {
  return i === 0 && navigator.onLine === !1 || !!i && (i < 400 || i > 499);
}
var vt = {
  DoNothing: 0,
  SendAlternateToPenaltyBox: 2,
  RemoveAlternatePermanently: 3,
  RetryRequest: 5
}, ei = {
  None: 0,
  MoveAllAlternatesMatchingHost: 1,
  MoveAllAlternatesMatchingHDCP: 2
};
class $1 extends ni {
  constructor(e) {
    super("error-controller", e.logger), this.hls = void 0, this.playlistError = 0, this.penalizedRenditions = {}, this.hls = e, this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(S.ERROR, this.onError, this), e.on(S.MANIFEST_LOADING, this.onManifestLoading, this), e.on(S.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(S.ERROR, this.onError, this), e.off(S.ERROR, this.onErrorOut, this), e.off(S.MANIFEST_LOADING, this.onManifestLoading, this), e.off(S.LEVEL_UPDATED, this.onLevelUpdated, this));
  }
  destroy() {
    this.unregisterListeners(), this.hls = null, this.penalizedRenditions = {};
  }
  startLoad(e) {
  }
  stopLoad() {
    this.playlistError = 0;
  }
  getVariantLevelIndex(e) {
    return e?.type === ce.MAIN ? e.level : this.hls.loadLevel;
  }
  onManifestLoading() {
    this.playlistError = 0, this.penalizedRenditions = {};
  }
  onLevelUpdated() {
    this.playlistError = 0;
  }
  onError(e, t) {
    var n;
    if (t.fatal)
      return;
    const s = this.hls, r = t.context;
    switch (t.details) {
      case B.FRAG_LOAD_ERROR:
      case B.FRAG_LOAD_TIMEOUT:
      case B.KEY_LOAD_ERROR:
      case B.KEY_LOAD_TIMEOUT:
        t.errorAction = this.getFragRetryOrSwitchAction(t);
        return;
      case B.FRAG_PARSING_ERROR:
        if ((n = t.frag) != null && n.gap) {
          t.errorAction = ws();
          return;
        }
      // falls through
      case B.FRAG_GAP:
      case B.FRAG_DECRYPT_ERROR: {
        t.errorAction = this.getFragRetryOrSwitchAction(t), t.errorAction.action = vt.SendAlternateToPenaltyBox;
        return;
      }
      case B.LEVEL_EMPTY_ERROR:
      case B.LEVEL_PARSING_ERROR:
        {
          var a;
          const l = t.parent === ce.MAIN ? t.level : s.loadLevel;
          t.details === B.LEVEL_EMPTY_ERROR && ((a = t.context) != null && (a = a.levelDetails) != null && a.live) ? t.errorAction = this.getPlaylistRetryOrSwitchAction(t, l) : (t.levelRetry = !1, t.errorAction = this.getLevelSwitchAction(t, l));
        }
        return;
      case B.LEVEL_LOAD_ERROR:
      case B.LEVEL_LOAD_TIMEOUT:
        typeof r?.level == "number" && (t.errorAction = this.getPlaylistRetryOrSwitchAction(t, r.level));
        return;
      case B.AUDIO_TRACK_LOAD_ERROR:
      case B.AUDIO_TRACK_LOAD_TIMEOUT:
      case B.SUBTITLE_LOAD_ERROR:
      case B.SUBTITLE_TRACK_LOAD_TIMEOUT:
        if (r) {
          const l = s.loadLevelObj;
          if (l && (r.type === Le.AUDIO_TRACK && l.hasAudioGroup(r.groupId) || r.type === Le.SUBTITLE_TRACK && l.hasSubtitleGroup(r.groupId))) {
            t.errorAction = this.getPlaylistRetryOrSwitchAction(t, s.loadLevel), t.errorAction.action = vt.SendAlternateToPenaltyBox, t.errorAction.flags = ei.MoveAllAlternatesMatchingHost;
            return;
          }
        }
        return;
      case B.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
        {
          const l = s.loadLevelObj, d = l?.attrs["HDCP-LEVEL"];
          d ? t.errorAction = {
            action: vt.SendAlternateToPenaltyBox,
            flags: ei.MoveAllAlternatesMatchingHDCP,
            hdcpLevel: d
          } : this.keySystemError(t);
        }
        return;
      case B.BUFFER_ADD_CODEC_ERROR:
      case B.REMUX_ALLOC_ERROR:
      case B.BUFFER_APPEND_ERROR:
        if (!t.errorAction) {
          var o;
          t.errorAction = this.getLevelSwitchAction(t, (o = t.level) != null ? o : s.loadLevel);
        }
        return;
      case B.INTERNAL_EXCEPTION:
      case B.BUFFER_APPENDING_ERROR:
      case B.BUFFER_FULL_ERROR:
      case B.LEVEL_SWITCH_ERROR:
      case B.BUFFER_STALLED_ERROR:
      case B.BUFFER_SEEK_OVER_HOLE:
      case B.BUFFER_NUDGE_ON_STALL:
        t.errorAction = ws();
        return;
    }
    t.type === pe.KEY_SYSTEM_ERROR && this.keySystemError(t);
  }
  keySystemError(e) {
    const t = this.getVariantLevelIndex(e.frag);
    e.levelRetry = !1, e.errorAction = this.getLevelSwitchAction(e, t);
  }
  getPlaylistRetryOrSwitchAction(e, t) {
    const n = this.hls, s = pc(n.config.playlistLoadPolicy, e), r = this.playlistError++;
    if (Nr(s, r, Dr(e), e.response))
      return {
        action: vt.RetryRequest,
        flags: ei.None,
        retryConfig: s,
        retryCount: r
      };
    const o = this.getLevelSwitchAction(e, t);
    return s && (o.retryConfig = s, o.retryCount = r), o;
  }
  getFragRetryOrSwitchAction(e) {
    const t = this.hls, n = this.getVariantLevelIndex(e.frag), s = t.levels[n], {
      fragLoadPolicy: r,
      keyLoadPolicy: a
    } = t.config, o = pc(e.details.startsWith("key") ? a : r, e), l = t.levels.reduce((c, u) => c + u.fragmentError, 0);
    if (s && (e.details !== B.FRAG_GAP && s.fragmentError++, Nr(o, l, Dr(e), e.response)))
      return {
        action: vt.RetryRequest,
        flags: ei.None,
        retryConfig: o,
        retryCount: l
      };
    const d = this.getLevelSwitchAction(e, n);
    return o && (d.retryConfig = o, d.retryCount = l), d;
  }
  getLevelSwitchAction(e, t) {
    const n = this.hls;
    t == null && (t = n.loadLevel);
    const s = this.hls.levels[t];
    if (s) {
      var r, a;
      const d = e.details;
      s.loadError++, d === B.BUFFER_APPEND_ERROR && s.fragmentError++;
      let c = -1;
      const {
        levels: u,
        loadLevel: f,
        minAutoLevel: h,
        maxAutoLevel: m
      } = n;
      !n.autoLevelEnabled && !n.config.preserveManualLevelOnError && (n.loadLevel = -1);
      const g = (r = e.frag) == null ? void 0 : r.type, p = (g === ce.AUDIO && d === B.FRAG_PARSING_ERROR || e.sourceBufferName === "audio" && (d === B.BUFFER_ADD_CODEC_ERROR || d === B.BUFFER_APPEND_ERROR)) && u.some(({
        audioCodec: I
      }) => s.audioCodec !== I), b = e.sourceBufferName === "video" && (d === B.BUFFER_ADD_CODEC_ERROR || d === B.BUFFER_APPEND_ERROR) && u.some(({
        codecSet: I,
        audioCodec: x
      }) => s.codecSet !== I && s.audioCodec === x), {
        type: k,
        groupId: T
      } = (a = e.context) != null ? a : {};
      for (let I = u.length; I--; ) {
        const x = (I + f) % u.length;
        if (x !== f && x >= h && x <= m && u[x].loadError === 0) {
          var o, l;
          const E = u[x];
          if (d === B.FRAG_GAP && g === ce.MAIN && e.frag) {
            const R = u[x].details;
            if (R) {
              const A = Sn(e.frag, R.fragments, e.frag.start);
              if (A != null && A.gap)
                continue;
            }
          } else {
            if (k === Le.AUDIO_TRACK && E.hasAudioGroup(T) || k === Le.SUBTITLE_TRACK && E.hasSubtitleGroup(T))
              continue;
            if (g === ce.AUDIO && (o = s.audioGroups) != null && o.some((R) => E.hasAudioGroup(R)) || g === ce.SUBTITLE && (l = s.subtitleGroups) != null && l.some((R) => E.hasSubtitleGroup(R)) || p && s.audioCodec === E.audioCodec || b && s.codecSet === E.codecSet || !p && s.codecSet !== E.codecSet)
              continue;
          }
          c = x;
          break;
        }
      }
      if (c > -1 && n.loadLevel !== c)
        return e.levelRetry = !0, this.playlistError = 0, {
          action: vt.SendAlternateToPenaltyBox,
          flags: ei.None,
          nextAutoLevel: c
        };
    }
    return {
      action: vt.SendAlternateToPenaltyBox,
      flags: ei.MoveAllAlternatesMatchingHost
    };
  }
  onErrorOut(e, t) {
    var n;
    switch ((n = t.errorAction) == null ? void 0 : n.action) {
      case vt.DoNothing:
        break;
      case vt.SendAlternateToPenaltyBox:
        this.sendAlternateToPenaltyBox(t), !t.errorAction.resolved && t.details !== B.FRAG_GAP ? t.fatal = !0 : /MediaSource readyState: ended/.test(t.error.message) && (this.warn(`MediaSource ended after "${t.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`), this.hls.recoverMediaError());
        break;
    }
    if (t.fatal) {
      this.hls.stopLoad();
      return;
    }
  }
  sendAlternateToPenaltyBox(e) {
    const t = this.hls, n = e.errorAction;
    if (!n)
      return;
    const {
      flags: s,
      hdcpLevel: r,
      nextAutoLevel: a
    } = n;
    switch (s) {
      case ei.None:
        this.switchLevel(e, a);
        break;
      case ei.MoveAllAlternatesMatchingHDCP:
        r && (t.maxHdcpLevel = Co[Co.indexOf(r) - 1], n.resolved = !0), this.warn(`Restricting playback to HDCP-LEVEL of "${t.maxHdcpLevel}" or lower`);
        break;
    }
    n.resolved || this.switchLevel(e, a);
  }
  switchLevel(e, t) {
    if (t !== void 0 && e.errorAction && (this.warn(`switching to level ${t} after ${e.details}`), this.hls.nextAutoLevel = t, e.errorAction.resolved = !0, this.hls.nextLoadLevel = this.hls.nextAutoLevel, e.details === B.BUFFER_ADD_CODEC_ERROR && e.mimeType && e.sourceBufferName !== "audiovideo")) {
      const n = Io(e.mimeType), s = this.hls.levels;
      for (let r = s.length; r--; )
        s[r][`${e.sourceBufferName}Codec`] === n && this.hls.removeLevel(r);
    }
  }
}
function ws(i) {
  const e = {
    action: vt.DoNothing,
    flags: ei.None
  };
  return i && (e.resolved = !0), e;
}
var at = {
  NOT_LOADED: "NOT_LOADED",
  APPENDING: "APPENDING",
  PARTIAL: "PARTIAL",
  OK: "OK"
};
class B1 {
  constructor(e) {
    this.activePartLists = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.fragments = /* @__PURE__ */ Object.create(null), this.timeRanges = /* @__PURE__ */ Object.create(null), this.bufferPadding = 0.2, this.hls = void 0, this.hasGaps = !1, this.hls = e, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e && (e.on(S.MANIFEST_LOADING, this.onManifestLoading, this), e.on(S.BUFFER_APPENDED, this.onBufferAppended, this), e.on(S.FRAG_BUFFERED, this.onFragBuffered, this), e.on(S.FRAG_LOADED, this.onFragLoaded, this));
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(S.MANIFEST_LOADING, this.onManifestLoading, this), e.off(S.BUFFER_APPENDED, this.onBufferAppended, this), e.off(S.FRAG_BUFFERED, this.onFragBuffered, this), e.off(S.FRAG_LOADED, this.onFragLoaded, this));
  }
  destroy() {
    this._unregisterListeners(), this.hls = // @ts-ignore
    this.fragments = // @ts-ignore
    this.activePartLists = // @ts-ignore
    this.endListFragments = this.timeRanges = null;
  }
  /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */
  getAppendedFrag(e, t) {
    const n = this.activePartLists[t];
    if (n)
      for (let s = n.length; s--; ) {
        const r = n[s];
        if (!r)
          break;
        if (r.start <= e && e <= r.end && r.loaded)
          return r;
      }
    return this.getBufferedFrag(e, t);
  }
  /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */
  getBufferedFrag(e, t) {
    return this.getFragAtPos(e, t, !0);
  }
  getFragAtPos(e, t, n) {
    const {
      fragments: s
    } = this, r = Object.keys(s);
    for (let a = r.length; a--; ) {
      const o = s[r[a]];
      if (o?.body.type === t && (!n || o.buffered)) {
        const l = o.body;
        if (l.start <= e && e <= l.end)
          return l;
      }
    }
    return null;
  }
  /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */
  detectEvictedFragments(e, t, n, s, r) {
    this.timeRanges && (this.timeRanges[e] = t);
    const a = s?.fragment.sn || -1;
    Object.keys(this.fragments).forEach((o) => {
      const l = this.fragments[o];
      if (!l || a >= l.body.sn)
        return;
      if (!l.buffered && (!l.loaded || r)) {
        l.body.type === n && this.removeFragment(l.body);
        return;
      }
      const d = l.range[e];
      if (d) {
        if (d.time.length === 0) {
          this.removeFragment(l.body);
          return;
        }
        d.time.some((c) => {
          const u = !this.isTimeBuffered(c.startPTS, c.endPTS, t);
          return u && this.removeFragment(l.body), u;
        });
      }
    });
  }
  /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */
  detectPartialFragments(e) {
    const t = this.timeRanges;
    if (!t || e.frag.sn === "initSegment")
      return;
    const n = e.frag, s = An(n), r = this.fragments[s];
    if (!r || r.buffered && n.gap)
      return;
    const a = !n.relurl;
    Object.keys(t).forEach((o) => {
      const l = n.elementaryStreams[o];
      if (!l)
        return;
      const d = t[o], c = a || l.partial === !0;
      r.range[o] = this.getBufferedTimes(n, e.part, c, d);
    }), r.loaded = null, Object.keys(r.range).length ? (r.buffered = !0, (r.body.endList = n.endList || r.body.endList) && (this.endListFragments[r.body.type] = r), Ks(r) || this.removeParts(n.sn - 1, n.type)) : this.removeFragment(r.body);
  }
  removeParts(e, t) {
    const n = this.activePartLists[t];
    n && (this.activePartLists[t] = vc(n, (s) => s.fragment.sn >= e));
  }
  fragBuffered(e, t) {
    const n = An(e);
    let s = this.fragments[n];
    !s && t && (s = this.fragments[n] = {
      body: e,
      appendedPTS: null,
      loaded: null,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    }, e.gap && (this.hasGaps = !0)), s && (s.loaded = null, s.buffered = !0);
  }
  getBufferedTimes(e, t, n, s) {
    const r = {
      time: [],
      partial: n
    }, a = e.start, o = e.end, l = e.minEndPTS || o, d = e.maxStartPTS || a;
    for (let c = 0; c < s.length; c++) {
      const u = s.start(c) - this.bufferPadding, f = s.end(c) + this.bufferPadding;
      if (d >= u && l <= f) {
        r.time.push({
          startPTS: Math.max(a, s.start(c)),
          endPTS: Math.min(o, s.end(c))
        });
        break;
      } else if (a < f && o > u) {
        const h = Math.max(a, s.start(c)), m = Math.min(o, s.end(c));
        m > h && (r.partial = !0, r.time.push({
          startPTS: h,
          endPTS: m
        }));
      } else if (o <= u)
        break;
    }
    return r;
  }
  /**
   * Gets the partial fragment for a certain time
   */
  getPartialFragment(e) {
    let t = null, n, s, r, a = 0;
    const {
      bufferPadding: o,
      fragments: l
    } = this;
    return Object.keys(l).forEach((d) => {
      const c = l[d];
      c && Ks(c) && (s = c.body.start - o, r = c.body.end + o, e >= s && e <= r && (n = Math.min(e - s, r - e), a <= n && (t = c.body, a = n)));
    }), t;
  }
  isEndListAppended(e) {
    const t = this.endListFragments[e];
    return t !== void 0 && (t.buffered || Ks(t));
  }
  getState(e) {
    const t = An(e), n = this.fragments[t];
    return n ? n.buffered ? Ks(n) ? at.PARTIAL : at.OK : at.APPENDING : at.NOT_LOADED;
  }
  isTimeBuffered(e, t, n) {
    let s, r;
    for (let a = 0; a < n.length; a++) {
      if (s = n.start(a) - this.bufferPadding, r = n.end(a) + this.bufferPadding, e >= s && t <= r)
        return !0;
      if (t <= s)
        return !1;
    }
    return !1;
  }
  onManifestLoading() {
    this.removeAllFragments();
  }
  onFragLoaded(e, t) {
    if (t.frag.sn === "initSegment" || t.frag.bitrateTest)
      return;
    const n = t.frag, s = t.part ? null : t, r = An(n);
    this.fragments[r] = {
      body: n,
      appendedPTS: null,
      loaded: s,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    };
  }
  onBufferAppended(e, t) {
    const {
      frag: n,
      part: s,
      timeRanges: r,
      type: a
    } = t;
    if (n.sn === "initSegment")
      return;
    const o = n.type;
    if (s) {
      let d = this.activePartLists[o];
      d || (this.activePartLists[o] = d = []), d.push(s);
    }
    this.timeRanges = r;
    const l = r[a];
    this.detectEvictedFragments(a, l, o, s);
  }
  onFragBuffered(e, t) {
    this.detectPartialFragments(t);
  }
  hasFragment(e) {
    const t = An(e);
    return !!this.fragments[t];
  }
  hasFragments(e) {
    const {
      fragments: t
    } = this, n = Object.keys(t);
    if (!e)
      return n.length > 0;
    for (let s = n.length; s--; ) {
      const r = t[n[s]];
      if (r?.body.type === e)
        return !0;
    }
    return !1;
  }
  hasParts(e) {
    var t;
    return !!((t = this.activePartLists[e]) != null && t.length);
  }
  removeFragmentsInRange(e, t, n, s, r) {
    s && !this.hasGaps || Object.keys(this.fragments).forEach((a) => {
      const o = this.fragments[a];
      if (!o)
        return;
      const l = o.body;
      l.type !== n || s && !l.gap || l.start < t && l.end > e && (o.buffered || r) && this.removeFragment(l);
    });
  }
  removeFragment(e) {
    const t = An(e);
    e.clearElementaryStreamInfo();
    const n = this.activePartLists[e.type];
    if (n) {
      const s = e.sn;
      this.activePartLists[e.type] = vc(n, (r) => r.fragment.sn !== s);
    }
    delete this.fragments[t], e.endList && delete this.endListFragments[e.type];
  }
  removeAllFragments() {
    var e;
    this.fragments = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.activePartLists = /* @__PURE__ */ Object.create(null), this.hasGaps = !1;
    const t = (e = this.hls) == null || (e = e.latestLevelDetails) == null ? void 0 : e.partList;
    t && t.forEach((n) => n.clearElementaryStreamInfo());
  }
}
function Ks(i) {
  var e, t, n;
  return i.buffered && !!(i.body.gap || (e = i.range.video) != null && e.partial || (t = i.range.audio) != null && t.partial || (n = i.range.audiovideo) != null && n.partial);
}
function An(i) {
  return `${i.type}_${i.level}_${i.sn}`;
}
function vc(i, e) {
  return i.filter((t) => {
    const n = e(t);
    return n || t.clearElementaryStreamInfo(), n;
  });
}
var tn = {
  cbc: 0,
  ctr: 1
};
class U1 {
  constructor(e, t, n) {
    this.subtle = void 0, this.aesIV = void 0, this.aesMode = void 0, this.subtle = e, this.aesIV = t, this.aesMode = n;
  }
  decrypt(e, t) {
    switch (this.aesMode) {
      case tn.cbc:
        return this.subtle.decrypt({
          name: "AES-CBC",
          iv: this.aesIV
        }, t, e);
      case tn.ctr:
        return this.subtle.decrypt(
          {
            name: "AES-CTR",
            counter: this.aesIV,
            length: 64
          },
          //64 : NIST SP800-38A standard suggests that the counter should occupy half of the counter block
          t,
          e
        );
      default:
        throw new Error(`[AESCrypto] invalid aes mode ${this.aesMode}`);
    }
  }
}
function V1(i) {
  const e = i.byteLength, t = e && new DataView(i.buffer).getUint8(e - 1);
  return t ? i.slice(0, e - t) : i;
}
class G1 {
  constructor() {
    this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.ksRows = 0, this.keySize = 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.initTable();
  }
  // Using view.getUint32() also swaps the byte order.
  uint8ArrayToUint32Array_(e) {
    const t = new DataView(e), n = new Uint32Array(4);
    for (let s = 0; s < 4; s++)
      n[s] = t.getUint32(s * 4);
    return n;
  }
  initTable() {
    const e = this.sBox, t = this.invSBox, n = this.subMix, s = n[0], r = n[1], a = n[2], o = n[3], l = this.invSubMix, d = l[0], c = l[1], u = l[2], f = l[3], h = new Uint32Array(256);
    let m = 0, g = 0, v = 0;
    for (v = 0; v < 256; v++)
      v < 128 ? h[v] = v << 1 : h[v] = v << 1 ^ 283;
    for (v = 0; v < 256; v++) {
      let p = g ^ g << 1 ^ g << 2 ^ g << 3 ^ g << 4;
      p = p >>> 8 ^ p & 255 ^ 99, e[m] = p, t[p] = m;
      const y = h[m], b = h[y], k = h[b];
      let T = h[p] * 257 ^ p * 16843008;
      s[m] = T << 24 | T >>> 8, r[m] = T << 16 | T >>> 16, a[m] = T << 8 | T >>> 24, o[m] = T, T = k * 16843009 ^ b * 65537 ^ y * 257 ^ m * 16843008, d[p] = T << 24 | T >>> 8, c[p] = T << 16 | T >>> 16, u[p] = T << 8 | T >>> 24, f[p] = T, m ? (m = y ^ h[h[h[k ^ y]]], g ^= h[h[g]]) : m = g = 1;
    }
  }
  expandKey(e) {
    const t = this.uint8ArrayToUint32Array_(e);
    let n = !0, s = 0;
    for (; s < t.length && n; )
      n = t[s] === this.key[s], s++;
    if (n)
      return;
    this.key = t;
    const r = this.keySize = t.length;
    if (r !== 4 && r !== 6 && r !== 8)
      throw new Error("Invalid aes key size=" + r);
    const a = this.ksRows = (r + 6 + 1) * 4;
    let o, l;
    const d = this.keySchedule = new Uint32Array(a), c = this.invKeySchedule = new Uint32Array(a), u = this.sBox, f = this.rcon, h = this.invSubMix, m = h[0], g = h[1], v = h[2], p = h[3];
    let y, b;
    for (o = 0; o < a; o++) {
      if (o < r) {
        y = d[o] = t[o];
        continue;
      }
      b = y, o % r === 0 ? (b = b << 8 | b >>> 24, b = u[b >>> 24] << 24 | u[b >>> 16 & 255] << 16 | u[b >>> 8 & 255] << 8 | u[b & 255], b ^= f[o / r | 0] << 24) : r > 6 && o % r === 4 && (b = u[b >>> 24] << 24 | u[b >>> 16 & 255] << 16 | u[b >>> 8 & 255] << 8 | u[b & 255]), d[o] = y = (d[o - r] ^ b) >>> 0;
    }
    for (l = 0; l < a; l++)
      o = a - l, l & 3 ? b = d[o] : b = d[o - 4], l < 4 || o <= 4 ? c[l] = b : c[l] = m[u[b >>> 24]] ^ g[u[b >>> 16 & 255]] ^ v[u[b >>> 8 & 255]] ^ p[u[b & 255]], c[l] = c[l] >>> 0;
  }
  // Adding this as a method greatly improves performance.
  networkToHostOrderSwap(e) {
    return e << 24 | (e & 65280) << 8 | (e & 16711680) >> 8 | e >>> 24;
  }
  decrypt(e, t, n) {
    const s = this.keySize + 6, r = this.invKeySchedule, a = this.invSBox, o = this.invSubMix, l = o[0], d = o[1], c = o[2], u = o[3], f = this.uint8ArrayToUint32Array_(n);
    let h = f[0], m = f[1], g = f[2], v = f[3];
    const p = new Int32Array(e), y = new Int32Array(p.length);
    let b, k, T, I, x, E, R, A, _, C, O, V, j, X;
    const q = this.networkToHostOrderSwap;
    for (; t < p.length; ) {
      for (_ = q(p[t]), C = q(p[t + 1]), O = q(p[t + 2]), V = q(p[t + 3]), x = _ ^ r[0], E = V ^ r[1], R = O ^ r[2], A = C ^ r[3], j = 4, X = 1; X < s; X++)
        b = l[x >>> 24] ^ d[E >> 16 & 255] ^ c[R >> 8 & 255] ^ u[A & 255] ^ r[j], k = l[E >>> 24] ^ d[R >> 16 & 255] ^ c[A >> 8 & 255] ^ u[x & 255] ^ r[j + 1], T = l[R >>> 24] ^ d[A >> 16 & 255] ^ c[x >> 8 & 255] ^ u[E & 255] ^ r[j + 2], I = l[A >>> 24] ^ d[x >> 16 & 255] ^ c[E >> 8 & 255] ^ u[R & 255] ^ r[j + 3], x = b, E = k, R = T, A = I, j = j + 4;
      b = a[x >>> 24] << 24 ^ a[E >> 16 & 255] << 16 ^ a[R >> 8 & 255] << 8 ^ a[A & 255] ^ r[j], k = a[E >>> 24] << 24 ^ a[R >> 16 & 255] << 16 ^ a[A >> 8 & 255] << 8 ^ a[x & 255] ^ r[j + 1], T = a[R >>> 24] << 24 ^ a[A >> 16 & 255] << 16 ^ a[x >> 8 & 255] << 8 ^ a[E & 255] ^ r[j + 2], I = a[A >>> 24] << 24 ^ a[x >> 16 & 255] << 16 ^ a[E >> 8 & 255] << 8 ^ a[R & 255] ^ r[j + 3], y[t] = q(b ^ h), y[t + 1] = q(I ^ m), y[t + 2] = q(T ^ g), y[t + 3] = q(k ^ v), h = _, m = C, g = O, v = V, t = t + 4;
    }
    return y.buffer;
  }
}
class H1 {
  constructor(e, t, n) {
    this.subtle = void 0, this.key = void 0, this.aesMode = void 0, this.subtle = e, this.key = t, this.aesMode = n;
  }
  expandKey() {
    const e = z1(this.aesMode);
    return this.subtle.importKey("raw", this.key, {
      name: e
    }, !1, ["encrypt", "decrypt"]);
  }
}
function z1(i) {
  switch (i) {
    case tn.cbc:
      return "AES-CBC";
    case tn.ctr:
      return "AES-CTR";
    default:
      throw new Error(`[FastAESKey] invalid aes mode ${i}`);
  }
}
const K1 = 16;
class El {
  constructor(e, {
    removePKCS7Padding: t = !0
  } = {}) {
    if (this.logEnabled = !0, this.removePKCS7Padding = void 0, this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null, this.useSoftware = void 0, this.enableSoftwareAES = void 0, this.enableSoftwareAES = e.enableSoftwareAES, this.removePKCS7Padding = t, t)
      try {
        const n = self.crypto;
        n && (this.subtle = n.subtle || n.webkitSubtle);
      } catch {
      }
    this.useSoftware = !this.subtle;
  }
  destroy() {
    this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null;
  }
  isSync() {
    return this.useSoftware;
  }
  flush() {
    const {
      currentResult: e,
      remainderData: t
    } = this;
    if (!e || t)
      return this.reset(), null;
    const n = new Uint8Array(e);
    return this.reset(), this.removePKCS7Padding ? V1(n) : n;
  }
  reset() {
    this.currentResult = null, this.currentIV = null, this.remainderData = null, this.softwareDecrypter && (this.softwareDecrypter = null);
  }
  decrypt(e, t, n, s) {
    return this.useSoftware ? new Promise((r, a) => {
      const o = ArrayBuffer.isView(e) ? e : new Uint8Array(e);
      this.softwareDecrypt(o, t, n, s);
      const l = this.flush();
      l ? r(l.buffer) : a(new Error("[softwareDecrypt] Failed to decrypt data"));
    }) : this.webCryptoDecrypt(new Uint8Array(e), t, n, s);
  }
  // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
  // data is handled in the flush() call
  softwareDecrypt(e, t, n, s) {
    const {
      currentIV: r,
      currentResult: a,
      remainderData: o
    } = this;
    if (s !== tn.cbc || t.byteLength !== 16)
      return Be.warn("SoftwareDecrypt: can only handle AES-128-CBC"), null;
    this.logOnce("JS AES decrypt"), o && (e = Zt(o, e), this.remainderData = null);
    const l = this.getValidChunk(e);
    if (!l.length)
      return null;
    r && (n = r);
    let d = this.softwareDecrypter;
    d || (d = this.softwareDecrypter = new G1()), d.expandKey(t);
    const c = a;
    return this.currentResult = d.decrypt(l.buffer, 0, n), this.currentIV = l.slice(-16).buffer, c || null;
  }
  webCryptoDecrypt(e, t, n, s) {
    if (this.key !== t || !this.fastAesKey) {
      if (!this.subtle)
        return Promise.resolve(this.onWebCryptoError(e, t, n, s));
      this.key = t, this.fastAesKey = new H1(this.subtle, t, s);
    }
    return this.fastAesKey.expandKey().then((r) => this.subtle ? (this.logOnce("WebCrypto AES decrypt"), new U1(this.subtle, new Uint8Array(n), s).decrypt(e.buffer, r)) : Promise.reject(new Error("web crypto not initialized"))).catch((r) => (Be.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${r.name}: ${r.message}`), this.onWebCryptoError(e, t, n, s)));
  }
  onWebCryptoError(e, t, n, s) {
    const r = this.enableSoftwareAES;
    if (r) {
      this.useSoftware = !0, this.logEnabled = !0, this.softwareDecrypt(e, t, n, s);
      const a = this.flush();
      if (a)
        return a.buffer;
    }
    throw new Error("WebCrypto" + (r ? " and softwareDecrypt" : "") + ": failed to decrypt data");
  }
  getValidChunk(e) {
    let t = e;
    const n = e.length - e.length % K1;
    return n !== e.length && (t = e.slice(0, n), this.remainderData = e.slice(n)), t;
  }
  logOnce(e) {
    this.logEnabled && (Be.log(`[decrypter]: ${e}`), this.logEnabled = !1);
  }
}
const yc = Math.pow(2, 17);
class j1 {
  constructor(e) {
    this.config = void 0, this.loader = null, this.partLoadTimeout = -1, this.config = e;
  }
  destroy() {
    this.loader && (this.loader.destroy(), this.loader = null);
  }
  abort() {
    this.loader && this.loader.abort();
  }
  load(e, t) {
    const n = e.url;
    if (!n)
      return Promise.reject(new Li({
        type: pe.NETWORK_ERROR,
        details: B.FRAG_LOAD_ERROR,
        fatal: !1,
        frag: e,
        error: new Error(`Fragment does not have a ${n ? "part list" : "url"}`),
        networkDetails: null
      }));
    this.abort();
    const s = this.config, r = s.fLoader, a = s.loader;
    return new Promise((o, l) => {
      if (this.loader && this.loader.destroy(), e.gap)
        if (e.tagList.some((m) => m[0] === "GAP")) {
          l(Sc(e));
          return;
        } else
          e.gap = !1;
      const d = this.loader = r ? new r(s) : new a(s), c = bc(e);
      e.loader = d;
      const u = gc(s.fragLoadPolicy.default), f = {
        loadPolicy: u,
        timeout: u.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: e.sn === "initSegment" ? 1 / 0 : yc
      };
      e.stats = d.stats;
      const h = {
        onSuccess: (m, g, v, p) => {
          this.resetLoader(e, d);
          let y = m.data;
          v.resetIV && e.decryptdata && (e.decryptdata.iv = new Uint8Array(y.slice(0, 16)), y = y.slice(16)), o({
            frag: e,
            part: null,
            payload: y,
            networkDetails: p
          });
        },
        onError: (m, g, v, p) => {
          this.resetLoader(e, d), l(new Li({
            type: pe.NETWORK_ERROR,
            details: B.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            response: Ve({
              url: n,
              data: void 0
            }, m),
            error: new Error(`HTTP Error ${m.code} ${m.text}`),
            networkDetails: v,
            stats: p
          }));
        },
        onAbort: (m, g, v) => {
          this.resetLoader(e, d), l(new Li({
            type: pe.NETWORK_ERROR,
            details: B.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            error: new Error("Aborted"),
            networkDetails: v,
            stats: m
          }));
        },
        onTimeout: (m, g, v) => {
          this.resetLoader(e, d), l(new Li({
            type: pe.NETWORK_ERROR,
            details: B.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            error: new Error(`Timeout after ${f.timeout}ms`),
            networkDetails: v,
            stats: m
          }));
        }
      };
      t && (h.onProgress = (m, g, v, p) => t({
        frag: e,
        part: null,
        payload: v,
        networkDetails: p
      })), d.load(c, f, h);
    });
  }
  loadPart(e, t, n) {
    this.abort();
    const s = this.config, r = s.fLoader, a = s.loader;
    return new Promise((o, l) => {
      if (this.loader && this.loader.destroy(), e.gap || t.gap) {
        l(Sc(e, t));
        return;
      }
      const d = this.loader = r ? new r(s) : new a(s), c = bc(e, t);
      e.loader = d;
      const u = gc(s.fragLoadPolicy.default), f = {
        loadPolicy: u,
        timeout: u.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: yc
      };
      t.stats = d.stats, d.load(c, f, {
        onSuccess: (h, m, g, v) => {
          this.resetLoader(e, d), this.updateStatsFromPart(e, t);
          const p = {
            frag: e,
            part: t,
            payload: h.data,
            networkDetails: v
          };
          n(p), o(p);
        },
        onError: (h, m, g, v) => {
          this.resetLoader(e, d), l(new Li({
            type: pe.NETWORK_ERROR,
            details: B.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            part: t,
            response: Ve({
              url: c.url,
              data: void 0
            }, h),
            error: new Error(`HTTP Error ${h.code} ${h.text}`),
            networkDetails: g,
            stats: v
          }));
        },
        onAbort: (h, m, g) => {
          e.stats.aborted = t.stats.aborted, this.resetLoader(e, d), l(new Li({
            type: pe.NETWORK_ERROR,
            details: B.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error("Aborted"),
            networkDetails: g,
            stats: h
          }));
        },
        onTimeout: (h, m, g) => {
          this.resetLoader(e, d), l(new Li({
            type: pe.NETWORK_ERROR,
            details: B.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error(`Timeout after ${f.timeout}ms`),
            networkDetails: g,
            stats: h
          }));
        }
      });
    });
  }
  updateStatsFromPart(e, t) {
    const n = e.stats, s = t.stats, r = s.total;
    if (n.loaded += s.loaded, r) {
      const l = Math.round(e.duration / t.duration), d = Math.min(Math.round(n.loaded / r), l), u = (l - d) * Math.round(n.loaded / d);
      n.total = n.loaded + u;
    } else
      n.total = Math.max(n.loaded, n.total);
    const a = n.loading, o = s.loading;
    a.start ? a.first += o.first - o.start : (a.start = o.start, a.first = o.first), a.end = o.end;
  }
  resetLoader(e, t) {
    e.loader = null, this.loader === t && (self.clearTimeout(this.partLoadTimeout), this.loader = null), t.destroy();
  }
}
function bc(i, e = null) {
  const t = e || i, n = {
    frag: i,
    part: e,
    responseType: "arraybuffer",
    url: t.url,
    headers: {},
    rangeStart: 0,
    rangeEnd: 0
  }, s = t.byteRangeStartOffset, r = t.byteRangeEndOffset;
  if (ae(s) && ae(r)) {
    var a;
    let o = s, l = r;
    if (i.sn === "initSegment" && W1((a = i.decryptdata) == null ? void 0 : a.method)) {
      const d = r - s;
      d % 16 && (l = r + (16 - d % 16)), s !== 0 && (n.resetIV = !0, o = s - 16);
    }
    n.rangeStart = o, n.rangeEnd = l;
  }
  return n;
}
function Sc(i, e) {
  const t = new Error(`GAP ${i.gap ? "tag" : "attribute"} found`), n = {
    type: pe.MEDIA_ERROR,
    details: B.FRAG_GAP,
    fatal: !1,
    frag: i,
    error: t,
    networkDetails: null
  };
  return e && (n.part = e), (e || i).stats.aborted = !0, new Li(n);
}
function W1(i) {
  return i === "AES-128" || i === "AES-256";
}
class Li extends Error {
  constructor(e) {
    super(e.error.message), this.data = void 0, this.data = e;
  }
}
class yh extends ni {
  constructor(e, t) {
    super(e, t), this._boundTick = void 0, this._tickTimer = null, this._tickInterval = null, this._tickCallCount = 0, this._boundTick = this.tick.bind(this);
  }
  destroy() {
    this.onHandlerDestroying(), this.onHandlerDestroyed();
  }
  onHandlerDestroying() {
    this.clearNextTick(), this.clearInterval();
  }
  onHandlerDestroyed() {
  }
  hasInterval() {
    return !!this._tickInterval;
  }
  hasNextTick() {
    return !!this._tickTimer;
  }
  /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */
  setInterval(e) {
    return this._tickInterval ? !1 : (this._tickCallCount = 0, this._tickInterval = self.setInterval(this._boundTick, e), !0);
  }
  /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */
  clearInterval() {
    return this._tickInterval ? (self.clearInterval(this._tickInterval), this._tickInterval = null, !0) : !1;
  }
  /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */
  clearNextTick() {
    return this._tickTimer ? (self.clearTimeout(this._tickTimer), this._tickTimer = null, !0) : !1;
  }
  /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */
  tick() {
    this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), this._tickCallCount = 0);
  }
  tickImmediate() {
    this.clearNextTick(), this._tickTimer = self.setTimeout(this._boundTick, 0);
  }
  /**
   * For subclass to implement task logic
   * @abstract
   */
  doTick() {
  }
}
class xl {
  constructor(e, t, n, s = 0, r = -1, a = !1) {
    this.level = void 0, this.sn = void 0, this.part = void 0, this.id = void 0, this.size = void 0, this.partial = void 0, this.transmuxing = js(), this.buffering = {
      audio: js(),
      video: js(),
      audiovideo: js()
    }, this.level = e, this.sn = t, this.id = n, this.size = s, this.part = r, this.partial = a;
  }
}
function js() {
  return {
    start: 0,
    executeStart: 0,
    executeEnd: 0,
    end: 0
  };
}
const kc = {
  length: 0,
  start: () => 0,
  end: () => 0
};
class Te {
  /**
   * Return true if `media`'s buffered include `position`
   */
  static isBuffered(e, t) {
    if (e) {
      const n = Te.getBuffered(e);
      for (let s = n.length; s--; )
        if (t >= n.start(s) && t <= n.end(s))
          return !0;
    }
    return !1;
  }
  static bufferedRanges(e) {
    if (e) {
      const t = Te.getBuffered(e);
      return Te.timeRangesToArray(t);
    }
    return [];
  }
  static timeRangesToArray(e) {
    const t = [];
    for (let n = 0; n < e.length; n++)
      t.push({
        start: e.start(n),
        end: e.end(n)
      });
    return t;
  }
  static bufferInfo(e, t, n) {
    if (e) {
      const s = Te.bufferedRanges(e);
      if (s.length)
        return Te.bufferedInfo(s, t, n);
    }
    return {
      len: 0,
      start: t,
      end: t,
      bufferedIndex: -1
    };
  }
  static bufferedInfo(e, t, n) {
    t = Math.max(0, t), e.length > 1 && e.sort((c, u) => c.start - u.start || u.end - c.end);
    let s = -1, r = [];
    if (n)
      for (let c = 0; c < e.length; c++) {
        t >= e[c].start && t <= e[c].end && (s = c);
        const u = r.length;
        if (u) {
          const f = r[u - 1].end;
          e[c].start - f < n ? e[c].end > f && (r[u - 1].end = e[c].end) : r.push(e[c]);
        } else
          r.push(e[c]);
      }
    else
      r = e;
    let a = 0, o, l = t, d = t;
    for (let c = 0; c < r.length; c++) {
      const u = r[c].start, f = r[c].end;
      if (s === -1 && t >= u && t <= f && (s = c), t + n >= u && t < f)
        l = u, d = f, a = d - t;
      else if (t + n < u) {
        o = u;
        break;
      }
    }
    return {
      len: a,
      start: l || 0,
      end: d || 0,
      nextStart: o,
      buffered: e,
      bufferedIndex: s
    };
  }
  /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */
  static getBuffered(e) {
    try {
      return e.buffered || kc;
    } catch (t) {
      return Be.log("failed to get media.buffered", t), kc;
    }
  }
}
const bh = /\{\$([a-zA-Z0-9-_]+)\}/g;
function Tc(i) {
  return bh.test(i);
}
function Ro(i, e) {
  if (i.variableList !== null || i.hasVariableRefs) {
    const t = i.variableList;
    return e.replace(bh, (n) => {
      const s = n.substring(2, n.length - 1), r = t?.[s];
      return r === void 0 ? (i.playlistParsingError || (i.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${s}"`)), n) : r;
    });
  }
  return e;
}
function Ec(i, e, t) {
  let n = i.variableList;
  n || (i.variableList = n = {});
  let s, r;
  if ("QUERYPARAM" in e) {
    s = e.QUERYPARAM;
    try {
      const a = new self.URL(t).searchParams;
      if (a.has(s))
        r = a.get(s);
      else
        throw new Error(`"${s}" does not match any query parameter in URI: "${t}"`);
    } catch (a) {
      i.playlistParsingError || (i.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${a.message}`));
    }
  } else
    s = e.NAME, r = e.VALUE;
  s in n ? i.playlistParsingError || (i.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${s}"`)) : n[s] = r || "";
}
function q1(i, e, t) {
  const n = e.IMPORT;
  if (t && n in t) {
    let s = i.variableList;
    s || (i.variableList = s = {}), s[n] = t[n];
  } else
    i.playlistParsingError || (i.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${n}"`));
}
const Y1 = /^(\d+)x(\d+)$/, xc = /(.+?)=(".*?"|.*?)(?:,|$)/g;
class Ye {
  constructor(e, t) {
    typeof e == "string" && (e = Ye.parseAttrList(e, t)), He(this, e);
  }
  get clientAttrs() {
    return Object.keys(this).filter((e) => e.substring(0, 2) === "X-");
  }
  decimalInteger(e) {
    const t = parseInt(this[e], 10);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  hexadecimalInteger(e) {
    if (this[e]) {
      let t = (this[e] || "0x").slice(2);
      t = (t.length & 1 ? "0" : "") + t;
      const n = new Uint8Array(t.length / 2);
      for (let s = 0; s < t.length / 2; s++)
        n[s] = parseInt(t.slice(s * 2, s * 2 + 2), 16);
      return n;
    }
    return null;
  }
  hexadecimalIntegerAsNumber(e) {
    const t = parseInt(this[e], 16);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  decimalFloatingPoint(e) {
    return parseFloat(this[e]);
  }
  optionalFloat(e, t) {
    const n = this[e];
    return n ? parseFloat(n) : t;
  }
  enumeratedString(e) {
    return this[e];
  }
  enumeratedStringList(e, t) {
    const n = this[e];
    return (n ? n.split(/[ ,]+/) : []).reduce((s, r) => (s[r.toLowerCase()] = !0, s), t);
  }
  bool(e) {
    return this[e] === "YES";
  }
  decimalResolution(e) {
    const t = Y1.exec(this[e]);
    if (t !== null)
      return {
        width: parseInt(t[1], 10),
        height: parseInt(t[2], 10)
      };
  }
  static parseAttrList(e, t) {
    let n;
    const s = {}, r = '"';
    for (xc.lastIndex = 0; (n = xc.exec(e)) !== null; ) {
      const a = n[1].trim();
      let o = n[2];
      const l = o.indexOf(r) === 0 && o.lastIndexOf(r) === o.length - 1;
      let d = !1;
      if (l)
        o = o.slice(1, -1);
      else
        switch (a) {
          case "IV":
          case "SCTE35-CMD":
          case "SCTE35-IN":
          case "SCTE35-OUT":
            d = !0;
        }
      if (t && (l || d))
        o = Ro(t, o);
      else if (!d && !l)
        switch (a) {
          case "CLOSED-CAPTIONS":
            if (o === "NONE")
              break;
          // falls through
          case "ALLOWED-CPC":
          case "CLASS":
          case "ASSOC-LANGUAGE":
          case "AUDIO":
          case "BYTERANGE":
          case "CHANNELS":
          case "CHARACTERISTICS":
          case "CODECS":
          case "DATA-ID":
          case "END-DATE":
          case "GROUP-ID":
          case "ID":
          case "IMPORT":
          case "INSTREAM-ID":
          case "KEYFORMAT":
          case "KEYFORMATVERSIONS":
          case "LANGUAGE":
          case "NAME":
          case "PATHWAY-ID":
          case "QUERYPARAM":
          case "RECENTLY-REMOVED-DATERANGES":
          case "SERVER-URI":
          case "STABLE-RENDITION-ID":
          case "STABLE-VARIANT-ID":
          case "START-DATE":
          case "SUBTITLES":
          case "SUPPLEMENTAL-CODECS":
          case "URI":
          case "VALUE":
          case "VIDEO":
          case "X-ASSET-LIST":
          case "X-ASSET-URI":
            Be.warn(`${e}: attribute ${a} is missing quotes`);
        }
      s[a] = o;
    }
    return s;
  }
}
const X1 = "com.apple.hls.interstitial";
function Z1(i) {
  return i !== "ID" && i !== "CLASS" && i !== "CUE" && i !== "START-DATE" && i !== "DURATION" && i !== "END-DATE" && i !== "END-ON-NEXT";
}
function Q1(i) {
  return i === "SCTE35-OUT" || i === "SCTE35-IN" || i === "SCTE35-CMD";
}
class Sh {
  constructor(e, t, n = 0) {
    var s;
    if (this.attr = void 0, this.tagAnchor = void 0, this.tagOrder = void 0, this._startDate = void 0, this._endDate = void 0, this._dateAtEnd = void 0, this._cue = void 0, this._badValueForSameId = void 0, this.tagAnchor = t?.tagAnchor || null, this.tagOrder = (s = t?.tagOrder) != null ? s : n, t) {
      const r = t.attr;
      for (const a in r)
        if (Object.prototype.hasOwnProperty.call(e, a) && e[a] !== r[a]) {
          Be.warn(`DATERANGE tag attribute: "${a}" does not match for tags with ID: "${e.ID}"`), this._badValueForSameId = a;
          break;
        }
      e = He(new Ye({}), r, e);
    }
    if (this.attr = e, t ? (this._startDate = t._startDate, this._cue = t._cue, this._endDate = t._endDate, this._dateAtEnd = t._dateAtEnd) : this._startDate = new Date(e["START-DATE"]), "END-DATE" in this.attr) {
      const r = t?.endDate || new Date(this.attr["END-DATE"]);
      ae(r.getTime()) && (this._endDate = r);
    }
  }
  get id() {
    return this.attr.ID;
  }
  get class() {
    return this.attr.CLASS;
  }
  get cue() {
    const e = this._cue;
    return e === void 0 ? this._cue = this.attr.enumeratedStringList(this.attr.CUE ? "CUE" : "X-CUE", {
      pre: !1,
      post: !1,
      once: !1
    }) : e;
  }
  get startTime() {
    const {
      tagAnchor: e
    } = this;
    return e === null || e.programDateTime === null ? (Be.warn(`Expected tagAnchor Fragment with PDT set for DateRange "${this.id}": ${e}`), NaN) : e.start + (this.startDate.getTime() - e.programDateTime) / 1e3;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    const e = this._endDate || this._dateAtEnd;
    if (e)
      return e;
    const t = this.duration;
    return t !== null ? this._dateAtEnd = new Date(this._startDate.getTime() + t * 1e3) : null;
  }
  get duration() {
    if ("DURATION" in this.attr) {
      const e = this.attr.decimalFloatingPoint("DURATION");
      if (ae(e))
        return e;
    } else if (this._endDate)
      return (this._endDate.getTime() - this._startDate.getTime()) / 1e3;
    return null;
  }
  get plannedDuration() {
    return "PLANNED-DURATION" in this.attr ? this.attr.decimalFloatingPoint("PLANNED-DURATION") : null;
  }
  get endOnNext() {
    return this.attr.bool("END-ON-NEXT");
  }
  get isInterstitial() {
    return this.class === X1;
  }
  get isValid() {
    return !!this.id && !this._badValueForSameId && ae(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class) && (!this.attr.CUE || !this.cue.pre && !this.cue.post || this.cue.pre !== this.cue.post) && (!this.isInterstitial || "X-ASSET-URI" in this.attr || "X-ASSET-LIST" in this.attr);
  }
}
const J1 = 10;
class ey {
  constructor(e) {
    this.PTSKnown = !1, this.alignedSliding = !1, this.averagetargetduration = void 0, this.endCC = 0, this.endSN = 0, this.fragments = void 0, this.fragmentHint = void 0, this.partList = null, this.dateRanges = void 0, this.dateRangeTagCount = 0, this.live = !0, this.requestScheduled = -1, this.ageHeader = 0, this.advancedDateTime = void 0, this.updated = !0, this.advanced = !0, this.misses = 0, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = void 0, this.m3u8 = "", this.version = null, this.canBlockReload = !1, this.canSkipUntil = 0, this.canSkipDateRanges = !1, this.skippedSegments = 0, this.recentlyRemovedDateranges = void 0, this.partHoldBack = 0, this.holdBack = 0, this.partTarget = 0, this.preloadHint = void 0, this.renditionReports = void 0, this.tuneInGoal = 0, this.deltaUpdateFailed = void 0, this.driftStartTime = 0, this.driftEndTime = 0, this.driftStart = 0, this.driftEnd = 0, this.encryptedFragments = void 0, this.playlistParsingError = null, this.variableList = null, this.hasVariableRefs = !1, this.appliedTimelineOffset = void 0, this.fragments = [], this.encryptedFragments = [], this.dateRanges = {}, this.url = e;
  }
  reloaded(e) {
    if (!e) {
      this.advanced = !0, this.updated = !0;
      return;
    }
    const t = this.lastPartSn - e.lastPartSn, n = this.lastPartIndex - e.lastPartIndex;
    this.updated = this.endSN !== e.endSN || !!n || !!t || !this.live, this.advanced = this.endSN > e.endSN || t > 0 || t === 0 && n > 0, this.updated || this.advanced ? this.misses = Math.floor(e.misses * 0.6) : this.misses = e.misses + 1;
  }
  get hasProgramDateTime() {
    return this.fragments.length ? ae(this.fragments[this.fragments.length - 1].programDateTime) : !1;
  }
  get levelTargetDuration() {
    return this.averagetargetduration || this.targetduration || J1;
  }
  get drift() {
    const e = this.driftEndTime - this.driftStartTime;
    return e > 0 ? (this.driftEnd - this.driftStart) * 1e3 / e : 1;
  }
  get edge() {
    return this.partEnd || this.fragmentEnd;
  }
  get partEnd() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].end : this.fragmentEnd;
  }
  get fragmentEnd() {
    return this.fragments.length ? this.fragments[this.fragments.length - 1].end : 0;
  }
  get fragmentStart() {
    return this.fragments.length ? this.fragments[0].start : 0;
  }
  get age() {
    return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
  }
  get lastPartIndex() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].index : -1;
  }
  get maxPartIndex() {
    const e = this.partList;
    if (e) {
      const t = this.lastPartIndex;
      if (t !== -1) {
        for (let n = e.length; n--; )
          if (e[n].index > t)
            return e[n].index;
        return t;
      }
    }
    return 0;
  }
  get lastPartSn() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].fragment.sn : this.endSN;
  }
  get expired() {
    if (this.live && this.age && this.misses < 3) {
      const e = this.partEnd - this.fragmentStart;
      return this.age > Math.max(e, this.totalduration) + this.levelTargetDuration;
    }
    return !1;
  }
}
function Un(i) {
  return i === "AES-128" || i === "AES-256" || i === "AES-256-CTR";
}
function _l(i) {
  switch (i) {
    case "AES-128":
    case "AES-256":
      return tn.cbc;
    case "AES-256-CTR":
      return tn.ctr;
    default:
      throw new Error(`invalid full segment method ${i}`);
  }
}
function Al(i) {
  return Uint8Array.from(atob(i), (e) => e.charCodeAt(0));
}
function Po(i) {
  return Uint8Array.from(unescape(encodeURIComponent(i)), (e) => e.charCodeAt(0));
}
function ty(i) {
  const e = Po(i).subarray(0, 16), t = new Uint8Array(16);
  return t.set(e, 16 - e.length), t;
}
function iy(i) {
  const e = function(n, s, r) {
    const a = n[s];
    n[s] = n[r], n[r] = a;
  };
  e(i, 0, 3), e(i, 1, 2), e(i, 4, 5), e(i, 6, 7);
}
function ny(i) {
  const e = i.split(":");
  let t = null;
  if (e[0] === "data" && e.length === 2) {
    const n = e[1].split(";"), s = n[n.length - 1].split(",");
    if (s.length === 2) {
      const r = s[0] === "base64", a = s[1];
      r ? (n.splice(-1, 1), t = Al(a)) : t = ty(a);
    }
  }
  return t;
}
const Mr = typeof self < "u" ? self : void 0;
var et = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
}, Rt = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.streamingkeydelivery",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function fr(i) {
  switch (i) {
    case Rt.FAIRPLAY:
      return et.FAIRPLAY;
    case Rt.PLAYREADY:
      return et.PLAYREADY;
    case Rt.WIDEVINE:
      return et.WIDEVINE;
    case Rt.CLEARKEY:
      return et.CLEARKEY;
  }
}
function Oa(i) {
  switch (i) {
    case et.FAIRPLAY:
      return Rt.FAIRPLAY;
    case et.PLAYREADY:
      return Rt.PLAYREADY;
    case et.WIDEVINE:
      return Rt.WIDEVINE;
    case et.CLEARKEY:
      return Rt.CLEARKEY;
  }
}
function is(i) {
  const {
    drmSystems: e,
    widevineLicenseUrl: t
  } = i, n = e ? [et.FAIRPLAY, et.WIDEVINE, et.PLAYREADY, et.CLEARKEY].filter((s) => !!e[s]) : [];
  return !n[et.WIDEVINE] && t && n.push(et.WIDEVINE), n;
}
const kh = function(i) {
  return Mr != null && (i = Mr.navigator) != null && i.requestMediaKeySystemAccess ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator) : null;
}();
function sy(i, e, t, n) {
  let s;
  switch (i) {
    case et.FAIRPLAY:
      s = ["cenc", "sinf"];
      break;
    case et.WIDEVINE:
    case et.PLAYREADY:
      s = ["cenc"];
      break;
    case et.CLEARKEY:
      s = ["cenc", "keyids"];
      break;
    default:
      throw new Error(`Unknown key-system: ${i}`);
  }
  return ry(s, e, t, n);
}
function ry(i, e, t, n) {
  return [{
    initDataTypes: i,
    persistentState: n.persistentState || "optional",
    distinctiveIdentifier: n.distinctiveIdentifier || "optional",
    sessionTypes: n.sessionTypes || [n.sessionType || "temporary"],
    audioCapabilities: e.map((r) => ({
      contentType: `audio/mp4; codecs=${r}`,
      robustness: n.audioRobustness || "",
      encryptionScheme: n.audioEncryptionScheme || null
    })),
    videoCapabilities: t.map((r) => ({
      contentType: `video/mp4; codecs=${r}`,
      robustness: n.videoRobustness || "",
      encryptionScheme: n.videoEncryptionScheme || null
    }))
  }];
}
function ay(i) {
  var e;
  return i.sessionType === "persistent-license" || !!((e = i.sessionTypes) != null && e.some((t) => t === "persistent-license"));
}
function oy(i) {
  const e = new Uint16Array(i.buffer, i.byteOffset, i.byteLength / 2), t = String.fromCharCode.apply(null, Array.from(e)), n = t.substring(t.indexOf("<"), t.length), a = new DOMParser().parseFromString(n, "text/xml").getElementsByTagName("KID")[0];
  if (a) {
    const o = a.childNodes[0] ? a.childNodes[0].nodeValue : a.getAttribute("VALUE");
    if (o) {
      const l = Al(o).subarray(0, 16);
      return iy(l), l;
    }
  }
  return null;
}
let Ws = {};
class pa {
  static clearKeyUriToKeyIdMap() {
    Ws = {};
  }
  constructor(e, t, n, s = [1], r = null, a) {
    this.uri = void 0, this.method = void 0, this.keyFormat = void 0, this.keyFormatVersions = void 0, this.encrypted = void 0, this.isCommonEncryption = void 0, this.iv = null, this.key = null, this.keyId = null, this.pssh = null, this.method = e, this.uri = t, this.keyFormat = n, this.keyFormatVersions = s, this.iv = r, this.encrypted = e ? e !== "NONE" : !1, this.isCommonEncryption = this.encrypted && !Un(e), a != null && a.startsWith("0x") && (this.keyId = new Uint8Array(th(a)));
  }
  matches(e) {
    var t, n;
    return e.uri === this.uri && e.method === this.method && e.encrypted === this.encrypted && e.keyFormat === this.keyFormat && e.keyFormatVersions.join(",") === this.keyFormatVersions.join(",") && ((t = e.iv) == null ? void 0 : t.join(",")) === ((n = this.iv) == null ? void 0 : n.join(","));
  }
  isSupported() {
    if (this.method) {
      if (Un(this.method) || this.method === "NONE")
        return !0;
      if (this.keyFormat === "identity")
        return this.method === "SAMPLE-AES";
      switch (this.keyFormat) {
        case Rt.FAIRPLAY:
        case Rt.WIDEVINE:
        case Rt.PLAYREADY:
        case Rt.CLEARKEY:
          return ["ISO-23001-7", "SAMPLE-AES", "SAMPLE-AES-CENC", "SAMPLE-AES-CTR"].indexOf(this.method) !== -1;
      }
    }
    return !1;
  }
  getDecryptData(e) {
    if (!this.encrypted || !this.uri)
      return null;
    if (Un(this.method) && this.uri && !this.iv) {
      typeof e != "number" && (Be.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`), e = 0);
      const n = ly(e);
      return new pa(this.method, this.uri, "identity", this.keyFormatVersions, n);
    }
    if (this.pssh && this.keyId)
      return this;
    const t = ny(this.uri);
    if (t)
      switch (this.keyFormat) {
        case Rt.WIDEVINE:
          if (this.pssh = t, !this.keyId && t.length >= 22) {
            const n = t.length - 22;
            this.keyId = t.subarray(n, n + 16);
          }
          break;
        case Rt.PLAYREADY: {
          const n = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]);
          this.pssh = f1(n, null, t), this.keyId = oy(t);
          break;
        }
        default: {
          let n = t.subarray(0, 16);
          if (n.length !== 16) {
            const s = new Uint8Array(16);
            s.set(n, 16 - n.length), n = s;
          }
          this.keyId = n;
          break;
        }
      }
    if (!this.keyId || this.keyId.byteLength !== 16) {
      let n = Ws[this.uri];
      if (!n) {
        const s = Object.keys(Ws).length % Number.MAX_SAFE_INTEGER;
        n = new Uint8Array(16), new DataView(n.buffer, 12, 4).setUint32(0, s), Ws[this.uri] = n;
      }
      this.keyId = n;
    }
    return this;
  }
}
function ly(i) {
  const e = new Uint8Array(16);
  for (let t = 12; t < 16; t++)
    e[t] = i >> 8 * (15 - t) & 255;
  return e;
}
const _c = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g, Ac = /#EXT-X-MEDIA:(.*)/g, dy = /^#EXT(?:INF|-X-TARGETDURATION):/m, Fa = new RegExp([
  /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
  // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
  /(?!#) *(\S[^\r\n]*)/.source,
  // segment URI, group 3 => the URI (note newline is not eaten)
  /#.*/.source
  // All other non-segment oriented tags will match with all groups empty
].join("|"), "g"), cy = new RegExp([/#EXT-X-(PROGRAM-DATE-TIME|BYTERANGE|DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join("|"));
class hi {
  static findGroup(e, t) {
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      if (s.id === t)
        return s;
    }
  }
  static resolve(e, t) {
    return vl.buildAbsoluteURL(t, e, {
      alwaysNormalize: !0
    });
  }
  static isMediaPlaylist(e) {
    return dy.test(e);
  }
  static parseMasterPlaylist(e, t) {
    const n = Tc(e), s = {
      contentSteering: null,
      levels: [],
      playlistParsingError: null,
      sessionData: null,
      sessionKeys: null,
      startTimeOffset: null,
      variableList: null,
      hasVariableRefs: n
    }, r = [];
    _c.lastIndex = 0;
    let a;
    for (; (a = _c.exec(e)) != null; )
      if (a[1]) {
        var o;
        const d = new Ye(a[1], s), c = Ro(s, a[2]), u = {
          attrs: d,
          bitrate: d.decimalInteger("BANDWIDTH") || d.decimalInteger("AVERAGE-BANDWIDTH"),
          name: d.NAME,
          url: hi.resolve(c, t)
        }, f = d.decimalResolution("RESOLUTION");
        f && (u.width = f.width, u.height = f.height), Ic(d.CODECS, u);
        const h = d["SUPPLEMENTAL-CODECS"];
        h && (u.supplemental = {}, Ic(h, u.supplemental)), (o = u.unknownCodecs) != null && o.length || r.push(u), s.levels.push(u);
      } else if (a[3]) {
        const d = a[3], c = a[4];
        switch (d) {
          case "SESSION-DATA": {
            const u = new Ye(c, s), f = u["DATA-ID"];
            f && (s.sessionData === null && (s.sessionData = {}), s.sessionData[f] = u);
            break;
          }
          case "SESSION-KEY": {
            const u = wc(c, t, s);
            u.encrypted && u.isSupported() ? (s.sessionKeys === null && (s.sessionKeys = []), s.sessionKeys.push(u)) : Be.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${c}"`);
            break;
          }
          case "DEFINE": {
            {
              const u = new Ye(c, s);
              Ec(s, u, t);
            }
            break;
          }
          case "CONTENT-STEERING": {
            const u = new Ye(c, s);
            s.contentSteering = {
              uri: hi.resolve(u["SERVER-URI"], t),
              pathwayId: u["PATHWAY-ID"] || "."
            };
            break;
          }
          case "START": {
            s.startTimeOffset = Lc(c);
            break;
          }
        }
      }
    const l = r.length > 0 && r.length < s.levels.length;
    return s.levels = l ? r : s.levels, s.levels.length === 0 && (s.playlistParsingError = new Error("no levels found in manifest")), s;
  }
  static parseMasterPlaylistMedia(e, t, n) {
    let s;
    const r = {}, a = n.levels, o = {
      AUDIO: a.map((d) => ({
        id: d.attrs.AUDIO,
        audioCodec: d.audioCodec
      })),
      SUBTITLES: a.map((d) => ({
        id: d.attrs.SUBTITLES,
        textCodec: d.textCodec
      })),
      "CLOSED-CAPTIONS": []
    };
    let l = 0;
    for (Ac.lastIndex = 0; (s = Ac.exec(e)) !== null; ) {
      const d = new Ye(s[1], n), c = d.TYPE;
      if (c) {
        const u = o[c], f = r[c] || [];
        r[c] = f;
        const h = d.LANGUAGE, m = d["ASSOC-LANGUAGE"], g = d.CHANNELS, v = d.CHARACTERISTICS, p = d["INSTREAM-ID"], y = {
          attrs: d,
          bitrate: 0,
          id: l++,
          groupId: d["GROUP-ID"] || "",
          name: d.NAME || h || "",
          type: c,
          default: d.bool("DEFAULT"),
          autoselect: d.bool("AUTOSELECT"),
          forced: d.bool("FORCED"),
          lang: h,
          url: d.URI ? hi.resolve(d.URI, t) : ""
        };
        if (m && (y.assocLang = m), g && (y.channels = g), v && (y.characteristics = v), p && (y.instreamId = p), u != null && u.length) {
          const b = hi.findGroup(u, y.groupId) || u[0];
          Cc(y, b, "audioCodec"), Cc(y, b, "textCodec");
        }
        f.push(y);
      }
    }
    return r;
  }
  static parseLevelPlaylist(e, t, n, s, r, a) {
    var o;
    const l = {
      url: t
    }, d = new ey(t), c = d.fragments, u = [];
    let f = null, h = 0, m = 0, g = 0, v = 0, p = 0, y = null, b = new Da(s, l), k, T, I, x = -1, E = !1, R = null, A;
    if (Fa.lastIndex = 0, d.m3u8 = e, d.hasVariableRefs = Tc(e), ((o = Fa.exec(e)) == null ? void 0 : o[0]) !== "#EXTM3U")
      return d.playlistParsingError = new Error("Missing format identifier #EXTM3U"), d;
    for (; (k = Fa.exec(e)) !== null; ) {
      E && (E = !1, b = new Da(s, l), b.playlistOffset = g, b.setStart(g), b.sn = h, b.cc = v, p && (b.bitrate = p), b.level = n, f && (b.initSegment = f, f.rawProgramDateTime && (b.rawProgramDateTime = f.rawProgramDateTime, f.rawProgramDateTime = null), R && (b.setByteRange(R), R = null)));
      const V = k[1];
      if (V) {
        b.duration = parseFloat(V);
        const j = (" " + k[2]).slice(1);
        b.title = j || null, b.tagList.push(j ? ["INF", V, j] : ["INF", V]);
      } else if (k[3]) {
        if (ae(b.duration)) {
          b.playlistOffset = g, b.setStart(g), I && Pc(b, I, d), b.sn = h, b.level = n, b.cc = v, c.push(b);
          const j = (" " + k[3]).slice(1);
          b.relurl = Ro(d, j), Do(b, y, u), y = b, g += b.duration, h++, m = 0, E = !0;
        }
      } else {
        if (k = k[0].match(cy), !k) {
          Be.warn("No matches on slow regex match for level playlist!");
          continue;
        }
        for (T = 1; T < k.length && k[T] === void 0; T++)
          ;
        const j = (" " + k[T]).slice(1), X = (" " + k[T + 1]).slice(1), q = k[T + 2] ? (" " + k[T + 2]).slice(1) : null;
        switch (j) {
          case "BYTERANGE":
            y ? b.setByteRange(X, y) : b.setByteRange(X);
            break;
          case "PROGRAM-DATE-TIME":
            b.rawProgramDateTime = X, b.tagList.push(["PROGRAM-DATE-TIME", X]), x === -1 && (x = c.length);
            break;
          case "PLAYLIST-TYPE":
            d.type && Ti(d, j, k), d.type = X.toUpperCase();
            break;
          case "MEDIA-SEQUENCE":
            d.startSN !== 0 ? Ti(d, j, k) : c.length > 0 && Dc(d, j, k), h = d.startSN = parseInt(X);
            break;
          case "SKIP": {
            d.skippedSegments && Ti(d, j, k);
            const z = new Ye(X, d), Q = z.decimalInteger("SKIPPED-SEGMENTS");
            if (ae(Q)) {
              d.skippedSegments += Q;
              for (let Z = Q; Z--; )
                c.push(null);
              h += Q;
            }
            const oe = z.enumeratedString("RECENTLY-REMOVED-DATERANGES");
            oe && (d.recentlyRemovedDateranges = (d.recentlyRemovedDateranges || []).concat(oe.split("	")));
            break;
          }
          case "TARGETDURATION":
            d.targetduration !== 0 && Ti(d, j, k), d.targetduration = Math.max(parseInt(X), 1);
            break;
          case "VERSION":
            d.version !== null && Ti(d, j, k), d.version = parseInt(X);
            break;
          case "INDEPENDENT-SEGMENTS":
            break;
          case "ENDLIST":
            d.live || Ti(d, j, k), d.live = !1;
            break;
          case "#":
            (X || q) && b.tagList.push(q ? [X, q] : [X]);
            break;
          case "DISCONTINUITY":
            v++, b.tagList.push(["DIS"]);
            break;
          case "GAP":
            b.gap = !0, b.tagList.push([j]);
            break;
          case "BITRATE":
            b.tagList.push([j, X]), p = parseInt(X) * 1e3, ae(p) ? b.bitrate = p : p = 0;
            break;
          case "DATERANGE": {
            const z = new Ye(X, d), Q = new Sh(z, d.dateRanges[z.ID], d.dateRangeTagCount);
            d.dateRangeTagCount++, Q.isValid || d.skippedSegments ? d.dateRanges[Q.id] = Q : Be.warn(`Ignoring invalid DATERANGE tag: "${X}"`), b.tagList.push(["EXT-X-DATERANGE", X]);
            break;
          }
          case "DEFINE": {
            {
              const z = new Ye(X, d);
              "IMPORT" in z ? q1(d, z, a) : Ec(d, z, t);
            }
            break;
          }
          case "DISCONTINUITY-SEQUENCE":
            d.startCC !== 0 ? Ti(d, j, k) : c.length > 0 && Dc(d, j, k), d.startCC = v = parseInt(X);
            break;
          case "KEY": {
            const z = wc(X, t, d);
            if (z.isSupported()) {
              if (z.method === "NONE") {
                I = void 0;
                break;
              }
              I || (I = {});
              const Q = I[z.keyFormat];
              Q != null && Q.matches(z) || (Q && (I = He({}, I)), I[z.keyFormat] = z);
            } else
              Be.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${X}"`);
            break;
          }
          case "START":
            d.startTimeOffset = Lc(X);
            break;
          case "MAP": {
            const z = new Ye(X, d);
            if (b.duration) {
              const Q = new Da(s, l);
              Rc(Q, z, n, I), f = Q, b.initSegment = f, f.rawProgramDateTime && !b.rawProgramDateTime && (b.rawProgramDateTime = f.rawProgramDateTime);
            } else {
              const Q = b.byteRangeEndOffset;
              if (Q) {
                const oe = b.byteRangeStartOffset;
                R = `${Q - oe}@${oe}`;
              } else
                R = null;
              Rc(b, z, n, I), f = b, E = !0;
            }
            f.cc = v;
            break;
          }
          case "SERVER-CONTROL": {
            A && Ti(d, j, k), A = new Ye(X), d.canBlockReload = A.bool("CAN-BLOCK-RELOAD"), d.canSkipUntil = A.optionalFloat("CAN-SKIP-UNTIL", 0), d.canSkipDateRanges = d.canSkipUntil > 0 && A.bool("CAN-SKIP-DATERANGES"), d.partHoldBack = A.optionalFloat("PART-HOLD-BACK", 0), d.holdBack = A.optionalFloat("HOLD-BACK", 0);
            break;
          }
          case "PART-INF": {
            d.partTarget && Ti(d, j, k);
            const z = new Ye(X);
            d.partTarget = z.decimalFloatingPoint("PART-TARGET");
            break;
          }
          case "PART": {
            let z = d.partList;
            z || (z = d.partList = []);
            const Q = m > 0 ? z[z.length - 1] : void 0, oe = m++, Z = new Ye(X, d), te = new Jv(Z, b, l, oe, Q);
            z.push(te), b.duration += te.duration;
            break;
          }
          case "PRELOAD-HINT": {
            const z = new Ye(X, d);
            d.preloadHint = z;
            break;
          }
          case "RENDITION-REPORT": {
            const z = new Ye(X, d);
            d.renditionReports = d.renditionReports || [], d.renditionReports.push(z);
            break;
          }
          default:
            Be.warn(`line parsed but not handled: ${k}`);
            break;
        }
      }
    }
    y && !y.relurl ? (c.pop(), g -= y.duration, d.partList && (d.fragmentHint = y)) : d.partList && (Do(b, y, u), b.cc = v, d.fragmentHint = b, I && Pc(b, I, d)), d.targetduration || (d.playlistParsingError = new Error("#EXT-X-TARGETDURATION is required"));
    const _ = c.length, C = c[0], O = c[_ - 1];
    if (g += d.skippedSegments * d.targetduration, g > 0 && _ && O) {
      d.averagetargetduration = g / _;
      const V = O.sn;
      d.endSN = V !== "initSegment" ? V : 0, d.live || (O.endList = !0), x > 0 && (fy(c, x), C && u.unshift(C));
    }
    return d.fragmentHint && (g += d.fragmentHint.duration), d.totalduration = g, u.length && d.dateRangeTagCount && C && Th(u, d), d.endCC = v, d;
  }
}
function Th(i, e) {
  let t = i.length;
  if (!t)
    if (e.hasProgramDateTime) {
      const o = e.fragments[e.fragments.length - 1];
      i.push(o), t++;
    } else
      return;
  const n = i[t - 1], s = e.live ? 1 / 0 : e.totalduration, r = Object.keys(e.dateRanges);
  for (let o = r.length; o--; ) {
    const l = e.dateRanges[r[o]], d = l.startDate.getTime();
    l.tagAnchor = n.ref;
    for (let c = t; c--; ) {
      var a;
      if (((a = i[c]) == null ? void 0 : a.sn) < e.startSN)
        break;
      const u = uy(e, d, i, c, s);
      if (u !== -1) {
        l.tagAnchor = e.fragments[u].ref;
        break;
      }
    }
  }
}
function uy(i, e, t, n, s) {
  const r = t[n];
  if (r) {
    const o = r.programDateTime;
    if (e >= o || n === 0) {
      var a;
      const l = (((a = t[n + 1]) == null ? void 0 : a.start) || s) - r.start;
      if (e <= o + l * 1e3) {
        const d = t[n].sn - i.startSN;
        if (d < 0)
          return -1;
        const c = i.fragments;
        if (c.length > t.length) {
          const f = (t[n + 1] || c[c.length - 1]).sn - i.startSN;
          for (let h = f; h > d; h--) {
            const m = c[h].programDateTime;
            if (e >= m && e < m + c[h].duration * 1e3)
              return h;
          }
        }
        return d;
      }
    }
  }
  return -1;
}
function wc(i, e, t) {
  var n, s;
  const r = new Ye(i, t), a = (n = r.METHOD) != null ? n : "", o = r.URI, l = r.hexadecimalInteger("IV"), d = r.KEYFORMATVERSIONS, c = (s = r.KEYFORMAT) != null ? s : "identity";
  o && r.IV && !l && Be.error(`Invalid IV: ${r.IV}`);
  const u = o ? hi.resolve(o, e) : "", f = (d || "1").split("/").map(Number).filter(Number.isFinite);
  return new pa(a, u, c, f, l, r.KEYID);
}
function Lc(i) {
  const t = new Ye(i).decimalFloatingPoint("TIME-OFFSET");
  return ae(t) ? t : null;
}
function Ic(i, e) {
  let t = (i || "").split(/[ ,]+/).filter((n) => n);
  ["video", "audio", "text"].forEach((n) => {
    const s = t.filter((r) => Sl(r, n));
    s.length && (e[`${n}Codec`] = s.map((r) => r.split("/")[0]).join(","), t = t.filter((r) => s.indexOf(r) === -1));
  }), e.unknownCodecs = t;
}
function Cc(i, e, t) {
  const n = e[t];
  n && (i[t] = n);
}
function fy(i, e) {
  let t = i[e];
  for (let n = e; n--; ) {
    const s = i[n];
    if (!s)
      return;
    s.programDateTime = t.programDateTime - s.duration * 1e3, t = s;
  }
}
function Do(i, e, t) {
  i.rawProgramDateTime ? t.push(i) : e != null && e.programDateTime && (i.programDateTime = e.endProgramDateTime);
}
function Rc(i, e, t, n) {
  i.relurl = e.URI, e.BYTERANGE && i.setByteRange(e.BYTERANGE), i.level = t, i.sn = "initSegment", n && (i.levelkeys = n), i.initSegment = null;
}
function Pc(i, e, t) {
  i.levelkeys = e;
  const {
    encryptedFragments: n
  } = t;
  (!n.length || n[n.length - 1].levelkeys !== e) && Object.keys(e).some((s) => e[s].isCommonEncryption) && n.push(i);
}
function Ti(i, e, t) {
  i.playlistParsingError = new Error(`#EXT-X-${e} must not appear more than once (${t[0]})`);
}
function Dc(i, e, t) {
  i.playlistParsingError = new Error(`#EXT-X-${e} must appear before the first Media Segment (${t[0]})`);
}
function $a(i, e) {
  const t = e.startPTS;
  if (ae(t)) {
    let n = 0, s;
    e.sn > i.sn ? (n = t - i.start, s = i) : (n = i.start - t, s = e), s.duration !== n && s.setDuration(n);
  } else e.sn > i.sn ? i.cc === e.cc && i.minEndPTS ? e.setStart(i.start + (i.minEndPTS - i.start)) : e.setStart(i.start + i.duration) : e.setStart(Math.max(i.start - e.duration, 0));
}
function Eh(i, e, t, n, s, r, a) {
  n - t <= 0 && (a.warn("Fragment should have a positive duration", e), n = t + e.duration, r = s + e.duration);
  let l = t, d = n;
  const c = e.startPTS, u = e.endPTS;
  if (ae(c)) {
    const p = Math.abs(c - t);
    i && p > i.totalduration ? a.warn(`media timestamps and playlist times differ by ${p}s for level ${e.level} ${i.url}`) : ae(e.deltaPTS) ? e.deltaPTS = Math.max(p, e.deltaPTS) : e.deltaPTS = p, l = Math.max(t, c), t = Math.min(t, c), s = e.startDTS !== void 0 ? Math.min(s, e.startDTS) : s, d = Math.min(n, u), n = Math.max(n, u), r = e.endDTS !== void 0 ? Math.max(r, e.endDTS) : r;
  }
  const f = t - e.start;
  e.start !== 0 && e.setStart(t), e.setDuration(n - e.start), e.startPTS = t, e.maxStartPTS = l, e.startDTS = s, e.endPTS = n, e.minEndPTS = d, e.endDTS = r;
  const h = e.sn;
  if (!i || h < i.startSN || h > i.endSN)
    return 0;
  let m;
  const g = h - i.startSN, v = i.fragments;
  for (v[g] = e, m = g; m > 0; m--)
    $a(v[m], v[m - 1]);
  for (m = g; m < v.length - 1; m++)
    $a(v[m], v[m + 1]);
  return i.fragmentHint && $a(v[v.length - 1], i.fragmentHint), i.PTSKnown = i.alignedSliding = !0, f;
}
function hy(i, e, t) {
  if (i === e)
    return;
  let n = null;
  const s = i.fragments;
  for (let c = s.length - 1; c >= 0; c--) {
    const u = s[c].initSegment;
    if (u) {
      n = u;
      break;
    }
  }
  i.fragmentHint && delete i.fragmentHint.endPTS;
  let r;
  gy(i, e, (c, u, f, h) => {
    if ((!e.startCC || e.skippedSegments) && u.cc !== c.cc) {
      const m = c.cc - u.cc;
      for (let g = f; g < h.length; g++)
        h[g].cc += m;
      e.endCC = h[h.length - 1].cc;
    }
    ae(c.startPTS) && ae(c.endPTS) && (u.setStart(u.startPTS = c.startPTS), u.startDTS = c.startDTS, u.maxStartPTS = c.maxStartPTS, u.endPTS = c.endPTS, u.endDTS = c.endDTS, u.minEndPTS = c.minEndPTS, u.setDuration(c.endPTS - c.startPTS), u.duration && (r = u), e.PTSKnown = e.alignedSliding = !0), c.hasStreams && (u.elementaryStreams = c.elementaryStreams), u.loader = c.loader, c.hasStats && (u.stats = c.stats), c.initSegment && (u.initSegment = c.initSegment, n = c.initSegment);
  });
  const a = e.fragments, o = e.fragmentHint ? a.concat(e.fragmentHint) : a;
  if (n && o.forEach((c) => {
    var u;
    c && (!c.initSegment || c.initSegment.relurl === ((u = n) == null ? void 0 : u.relurl)) && (c.initSegment = n);
  }), e.skippedSegments) {
    if (e.deltaUpdateFailed = a.some((c) => !c), e.deltaUpdateFailed) {
      t.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
      for (let c = e.skippedSegments; c--; )
        a.shift();
      e.startSN = a[0].sn;
    } else {
      e.canSkipDateRanges && (e.dateRanges = my(i.dateRanges, e, t));
      const c = i.fragments.filter((u) => u.rawProgramDateTime);
      if (i.hasProgramDateTime && !e.hasProgramDateTime)
        for (let u = 1; u < o.length; u++)
          o[u].programDateTime === null && Do(o[u], o[u - 1], c);
      Th(c, e);
    }
    e.endCC = a[a.length - 1].cc;
  }
  if (!e.startCC) {
    var l;
    const c = Ah(i, e.startSN - 1);
    e.startCC = (l = c?.cc) != null ? l : a[0].cc;
  }
  py(i.partList, e.partList, (c, u) => {
    u.elementaryStreams = c.elementaryStreams, u.stats = c.stats;
  }), r ? Eh(e, r, r.startPTS, r.endPTS, r.startDTS, r.endDTS, t) : xh(i, e), a.length && (e.totalduration = e.edge - a[0].start), e.driftStartTime = i.driftStartTime, e.driftStart = i.driftStart;
  const d = e.advancedDateTime;
  if (e.advanced && d) {
    const c = e.edge;
    e.driftStart || (e.driftStartTime = d, e.driftStart = c), e.driftEndTime = d, e.driftEnd = c;
  } else
    e.driftEndTime = i.driftEndTime, e.driftEnd = i.driftEnd, e.advancedDateTime = i.advancedDateTime;
  e.requestScheduled === -1 && (e.requestScheduled = i.requestScheduled);
}
function my(i, e, t) {
  const {
    dateRanges: n,
    recentlyRemovedDateranges: s
  } = e, r = He({}, i);
  s && s.forEach((l) => {
    delete r[l];
  });
  const o = Object.keys(r).length;
  return o ? (Object.keys(n).forEach((l) => {
    const d = r[l], c = new Sh(n[l].attr, d);
    c.isValid ? (r[l] = c, d || (c.tagOrder += o)) : t.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${qe(n[l].attr)}"`);
  }), r) : n;
}
function py(i, e, t) {
  if (i && e) {
    let n = 0;
    for (let s = 0, r = i.length; s <= r; s++) {
      const a = i[s], o = e[s + n];
      a && o && a.index === o.index && a.fragment.sn === o.fragment.sn ? t(a, o) : n--;
    }
  }
}
function gy(i, e, t) {
  const n = e.skippedSegments, s = Math.max(i.startSN, e.startSN) - e.startSN, r = (i.fragmentHint ? 1 : 0) + (n ? e.endSN : Math.min(i.endSN, e.endSN)) - e.startSN, a = e.startSN - i.startSN, o = e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments, l = i.fragmentHint ? i.fragments.concat(i.fragmentHint) : i.fragments;
  for (let d = s; d <= r; d++) {
    const c = l[a + d];
    let u = o[d];
    if (n && !u && c && (u = e.fragments[d] = c), c && u) {
      t(c, u, d, o);
      const f = c.relurl, h = u.relurl;
      if (f && vy(f, h)) {
        e.playlistParsingError = Nc(`media sequence mismatch ${u.sn}:`, i, e, c, u);
        return;
      } else if (c.cc !== u.cc) {
        e.playlistParsingError = Nc(`discontinuity sequence mismatch (${c.cc}!=${u.cc})`, i, e, c, u);
        return;
      }
    }
  }
}
function Nc(i, e, t, n, s) {
  return new Error(`${i} ${s.url}
Playlist starting @${e.startSN}
${e.m3u8}

Playlist starting @${t.startSN}
${t.m3u8}`);
}
function xh(i, e, t = !0) {
  const n = e.startSN + e.skippedSegments - i.startSN, s = i.fragments, r = n >= 0;
  let a = 0;
  if (r && n < s.length)
    a = s[n].start;
  else if (r && e.startSN === i.endSN + 1)
    a = i.fragmentEnd;
  else if (r && t)
    a = i.fragmentStart + n * e.levelTargetDuration;
  else if (!e.skippedSegments && e.fragmentStart === 0)
    a = i.fragmentStart;
  else
    return;
  No(e, a);
}
function No(i, e) {
  if (e) {
    const t = i.fragments;
    for (let n = i.skippedSegments; n < t.length; n++)
      t[n].addStart(e);
    i.fragmentHint && i.fragmentHint.addStart(e);
  }
}
function _h(i, e = 1 / 0) {
  let t = 1e3 * i.targetduration;
  if (i.updated) {
    const n = i.fragments;
    if (n.length && t * 4 > e) {
      const r = n[n.length - 1].duration * 1e3;
      r < t && (t = r);
    }
  } else
    t /= 2;
  return Math.round(t);
}
function Ah(i, e, t) {
  if (!i)
    return null;
  let n = i.fragments[e - i.startSN];
  return n || (n = i.fragmentHint, n && n.sn === e) ? n : e < i.startSN && t && t.sn === e ? t : null;
}
function Mc(i, e, t) {
  return i ? wh(i.partList, e, t) : null;
}
function wh(i, e, t) {
  if (i)
    for (let n = i.length; n--; ) {
      const s = i[n];
      if (s.index === t && s.fragment.sn === e)
        return s;
    }
  return null;
}
function Lh(i) {
  i.forEach((e, t) => {
    var n;
    (n = e.details) == null || n.fragments.forEach((s) => {
      s.level = t, s.initSegment && (s.initSegment.level = t);
    });
  });
}
function vy(i, e) {
  return i !== e && e ? Oc(i) !== Oc(e) : !1;
}
function Oc(i) {
  return i.replace(/\?[^?]*$/, "");
}
function us(i, e) {
  for (let n = 0, s = i.length; n < s; n++) {
    var t;
    if (((t = i[n]) == null ? void 0 : t.cc) === e)
      return i[n];
  }
  return null;
}
function yy(i, e) {
  return !!(i && e.startCC < i.endCC && e.endCC > i.startCC);
}
function Fc(i, e) {
  const t = i.start + e;
  i.startPTS = t, i.setStart(t), i.endPTS = t + i.duration;
}
function Ih(i, e) {
  const t = e.fragments;
  for (let n = 0, s = t.length; n < s; n++)
    Fc(t[n], i);
  e.fragmentHint && Fc(e.fragmentHint, i), e.alignedSliding = !0;
}
function by(i, e) {
  i && (Ch(e, i), e.alignedSliding || Or(e, i), !e.alignedSliding && !e.skippedSegments && xh(i, e, !1));
}
function Ch(i, e) {
  if (!yy(e, i))
    return;
  const t = Math.min(e.endCC, i.endCC), n = us(e.fragments, t), s = us(i.fragments, t);
  if (!n || !s)
    return;
  Be.log(`Aligning playlist at start of dicontinuity sequence ${t}`);
  const r = n.start - s.start;
  Ih(r, i);
}
function Or(i, e) {
  if (!i.hasProgramDateTime || !e.hasProgramDateTime)
    return;
  const t = i.fragments, n = e.fragments;
  if (!t.length || !n.length)
    return;
  let s, r;
  const a = Math.min(e.endCC, i.endCC);
  e.startCC < a && i.startCC < a && (s = us(n, a), r = us(t, a)), (!s || !r) && (s = n[Math.floor(n.length / 2)], r = us(t, s.cc) || t[Math.floor(t.length / 2)]);
  const o = s.programDateTime, l = r.programDateTime;
  if (!o || !l)
    return;
  const d = (l - o) / 1e3 - (r.start - s.start);
  Ih(d, i);
}
const Sy = {
  toString: function(i) {
    let e = "";
    const t = i.length;
    for (let n = 0; n < t; n++)
      e += `[${i.start(n).toFixed(3)}-${i.end(n).toFixed(3)}]`;
    return e;
  }
}, K = {
  STOPPED: "STOPPED",
  IDLE: "IDLE",
  KEY_LOADING: "KEY_LOADING",
  FRAG_LOADING: "FRAG_LOADING",
  FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
  WAITING_TRACK: "WAITING_TRACK",
  PARSING: "PARSING",
  PARSED: "PARSED",
  ENDED: "ENDED",
  ERROR: "ERROR",
  WAITING_INIT_PTS: "WAITING_INIT_PTS",
  WAITING_LEVEL: "WAITING_LEVEL"
};
class wl extends yh {
  constructor(e, t, n, s, r) {
    super(s, e.logger), this.hls = void 0, this.fragPrevious = null, this.fragCurrent = null, this.fragmentTracker = void 0, this.transmuxer = null, this._state = K.STOPPED, this.playlistType = void 0, this.media = null, this.mediaBuffer = null, this.config = void 0, this.bitrateTest = !1, this.lastCurrentTime = 0, this.nextLoadPosition = 0, this.startPosition = 0, this.startTimeOffset = null, this.retryDate = 0, this.levels = null, this.fragmentLoader = void 0, this.keyLoader = void 0, this.levelLastLoaded = null, this.startFragRequested = !1, this.decrypter = void 0, this.initPTS = [], this.buffering = !0, this.loadingParts = !1, this.loopSn = void 0, this.onMediaSeeking = () => {
      const {
        config: a,
        fragCurrent: o,
        media: l,
        mediaBuffer: d,
        state: c
      } = this, u = l ? l.currentTime : 0, f = Te.bufferInfo(d || l, u, a.maxBufferHole), h = !f.len;
      if (this.log(`Media seeking to ${ae(u) ? u.toFixed(3) : u}, state: ${c}, ${h ? "out of" : "in"} buffer`), this.state === K.ENDED)
        this.resetLoadingState();
      else if (o) {
        const m = a.maxFragLookUpTolerance, g = o.start - m, v = o.start + o.duration + m;
        if (h || v < f.start || g > f.end) {
          const p = u > v;
          (u < g || p) && (p && o.loader && (this.log(`Cancelling fragment load for seek (sn: ${o.sn})`), o.abortRequests(), this.resetLoadingState()), this.fragPrevious = null);
        }
      }
      if (l) {
        this.fragmentTracker.removeFragmentsInRange(u, 1 / 0, this.playlistType, !0);
        const m = this.lastCurrentTime;
        if (u > m && (this.lastCurrentTime = u), !this.loadingParts) {
          const g = Math.max(f.end, u), v = this.shouldLoadParts(this.getLevelDetails(), g);
          v && (this.log(`LL-Part loading ON after seeking to ${u.toFixed(2)} with buffer @${g.toFixed(2)}`), this.loadingParts = v);
        }
      }
      this.hls.hasEnoughToStart || (this.log(`Setting ${h ? "startPosition" : "nextLoadPosition"} to ${u} for seek without enough to start`), this.nextLoadPosition = u, h && (this.startPosition = u)), this.tickImmediate();
    }, this.onMediaEnded = () => {
      this.log("setting startPosition to 0 because media ended"), this.startPosition = this.lastCurrentTime = 0;
    }, this.playlistType = r, this.hls = e, this.fragmentLoader = new j1(e.config), this.keyLoader = n, this.fragmentTracker = t, this.config = e.config, this.decrypter = new El(e.config);
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(S.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(S.MANIFEST_LOADING, this.onManifestLoading, this), e.on(S.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(S.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(S.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(S.MANIFEST_LOADING, this.onManifestLoading, this), e.off(S.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(S.ERROR, this.onError, this);
  }
  doTick() {
    this.onTickEnd();
  }
  onTickEnd() {
  }
  startLoad(e) {
  }
  stopLoad() {
    if (this.state === K.STOPPED)
      return;
    this.fragmentLoader.abort(), this.keyLoader.abort(this.playlistType);
    const e = this.fragCurrent;
    e != null && e.loader && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.resetTransmuxer(), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = K.STOPPED;
  }
  get startPositionValue() {
    const {
      nextLoadPosition: e,
      startPosition: t
    } = this;
    return t === -1 && e ? e : t;
  }
  get bufferingEnabled() {
    return this.buffering;
  }
  pauseBuffering() {
    this.buffering = !1;
  }
  resumeBuffering() {
    this.buffering = !0;
  }
  get inFlightFrag() {
    return {
      frag: this.fragCurrent,
      state: this.state
    };
  }
  _streamEnded(e, t) {
    if (t.live || !this.media)
      return !1;
    const n = e.end || 0, s = this.config.timelineOffset || 0;
    if (n <= s)
      return !1;
    const r = e.buffered;
    this.config.maxBufferHole && r && r.length > 1 && (e = Te.bufferedInfo(r, e.start, 0));
    const a = e.nextStart;
    if (a && a > s && a < t.edge || this.media.currentTime < e.start)
      return !1;
    const l = t.partList;
    if (l != null && l.length) {
      const c = l[l.length - 1];
      return Te.isBuffered(this.media, c.start + c.duration / 2);
    }
    const d = t.fragments[t.fragments.length - 1].type;
    return this.fragmentTracker.isEndListAppended(d);
  }
  getLevelDetails() {
    if (this.levels && this.levelLastLoaded !== null)
      return this.levelLastLoaded.details;
  }
  get timelineOffset() {
    const e = this.config.timelineOffset;
    if (e) {
      var t;
      return ((t = this.getLevelDetails()) == null ? void 0 : t.appliedTimelineOffset) || e;
    }
    return 0;
  }
  onMediaAttached(e, t) {
    const n = this.media = this.mediaBuffer = t.media;
    n.removeEventListener("seeking", this.onMediaSeeking), n.removeEventListener("ended", this.onMediaEnded), n.addEventListener("seeking", this.onMediaSeeking), n.addEventListener("ended", this.onMediaEnded);
    const s = this.config;
    this.levels && s.autoStartLoad && this.state === K.STOPPED && this.startLoad(s.startPosition);
  }
  onMediaDetaching(e, t) {
    const n = !!t.transferMedia, s = this.media;
    if (s !== null) {
      if (s.ended && (this.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), s.removeEventListener("seeking", this.onMediaSeeking), s.removeEventListener("ended", this.onMediaEnded), this.keyLoader && !n && this.keyLoader.detach(), this.media = this.mediaBuffer = null, this.loopSn = void 0, n) {
        this.resetLoadingState(), this.resetTransmuxer();
        return;
      }
      this.loadingParts = !1, this.fragmentTracker.removeAllFragments(), this.stopLoad();
    }
  }
  onManifestLoading() {
    this.initPTS = [], this.levels = this.levelLastLoaded = this.fragCurrent = null, this.lastCurrentTime = this.startPosition = 0, this.startFragRequested = !1;
  }
  onError(e, t) {
  }
  onManifestLoaded(e, t) {
    this.startTimeOffset = t.startTimeOffset;
  }
  onHandlerDestroying() {
    this.stopLoad(), this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null), super.onHandlerDestroying(), this.hls = this.onMediaSeeking = this.onMediaEnded = null;
  }
  onHandlerDestroyed() {
    this.state = K.STOPPED, this.fragmentLoader && this.fragmentLoader.destroy(), this.keyLoader && this.keyLoader.destroy(), this.decrypter && this.decrypter.destroy(), this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null, super.onHandlerDestroyed();
  }
  loadFragment(e, t, n) {
    this.startFragRequested = !0, this._loadFragForPlayback(e, t, n);
  }
  _loadFragForPlayback(e, t, n) {
    const s = (r) => {
      const a = r.frag;
      if (this.fragContextChanged(a)) {
        this.warn(`${a.type} sn: ${a.sn}${r.part ? " part: " + r.part.index : ""} of ${this.fragInfo(a, !1, r.part)}) was dropped during download.`), this.fragmentTracker.removeFragment(a);
        return;
      }
      a.stats.chunkCount++, this._handleFragmentLoadProgress(r);
    };
    this._doFragLoad(e, t, n, s).then((r) => {
      if (!r)
        return;
      const a = this.state, o = r.frag;
      if (this.fragContextChanged(o)) {
        (a === K.FRAG_LOADING || !this.fragCurrent && a === K.PARSING) && (this.fragmentTracker.removeFragment(o), this.state = K.IDLE);
        return;
      }
      "payload" in r && (this.log(`Loaded ${o.type} sn: ${o.sn} of ${this.playlistLabel()} ${o.level}`), this.hls.trigger(S.FRAG_LOADED, r)), this._handleFragmentLoadComplete(r);
    }).catch((r) => {
      this.state === K.STOPPED || this.state === K.ERROR || (this.warn(`Frag error: ${r?.message || r}`), this.resetFragmentLoading(e));
    });
  }
  clearTrackerIfNeeded(e) {
    var t;
    const {
      fragmentTracker: n
    } = this;
    if (n.getState(e) === at.APPENDING) {
      const r = e.type, a = this.getFwdBufferInfo(this.mediaBuffer, r), o = Math.max(e.duration, a ? a.len : this.config.maxBufferLength), l = this.backtrackFragment;
      ((l ? e.sn - l.sn : 0) === 1 || this.reduceMaxBufferLength(o, e.duration)) && n.removeFragment(e);
    } else ((t = this.mediaBuffer) == null ? void 0 : t.buffered.length) === 0 ? n.removeAllFragments() : n.hasParts(e.type) && (n.detectPartialFragments({
      frag: e,
      part: null,
      stats: e.stats,
      id: e.type
    }), n.getState(e) === at.PARTIAL && n.removeFragment(e));
  }
  checkLiveUpdate(e) {
    if (e.updated && !e.live) {
      const t = e.fragments[e.fragments.length - 1];
      this.fragmentTracker.detectPartialFragments({
        frag: t,
        part: null,
        stats: t.stats,
        id: t.type
      });
    }
    e.fragments[0] || (e.deltaUpdateFailed = !0);
  }
  waitForLive(e) {
    const t = e.details;
    return t?.live && t.type !== "EVENT" && (this.levelLastLoaded !== e || t.expired);
  }
  flushMainBuffer(e, t, n = null) {
    if (!(e - t))
      return;
    const s = {
      startOffset: e,
      endOffset: t,
      type: n
    };
    this.hls.trigger(S.BUFFER_FLUSHING, s);
  }
  _loadInitSegment(e, t) {
    this._doFragLoad(e, t).then((n) => {
      const s = n?.frag;
      if (!s || this.fragContextChanged(s) || !this.levels)
        throw new Error("init load aborted");
      return n;
    }).then((n) => {
      const {
        hls: s
      } = this, {
        frag: r,
        payload: a
      } = n, o = r.decryptdata;
      if (a && a.byteLength > 0 && o != null && o.key && o.iv && Un(o.method)) {
        const l = self.performance.now();
        return this.decrypter.decrypt(new Uint8Array(a), o.key.buffer, o.iv.buffer, _l(o.method)).catch((d) => {
          throw s.trigger(S.ERROR, {
            type: pe.MEDIA_ERROR,
            details: B.FRAG_DECRYPT_ERROR,
            fatal: !1,
            error: d,
            reason: d.message,
            frag: r
          }), d;
        }).then((d) => {
          const c = self.performance.now();
          return s.trigger(S.FRAG_DECRYPTED, {
            frag: r,
            payload: d,
            stats: {
              tstart: l,
              tdecrypt: c
            }
          }), n.payload = d, this.completeInitSegmentLoad(n);
        });
      }
      return this.completeInitSegmentLoad(n);
    }).catch((n) => {
      this.state === K.STOPPED || this.state === K.ERROR || (this.warn(n), this.resetFragmentLoading(e));
    });
  }
  completeInitSegmentLoad(e) {
    const {
      levels: t
    } = this;
    if (!t)
      throw new Error("init load aborted, missing levels");
    const n = e.frag.stats;
    this.state !== K.STOPPED && (this.state = K.IDLE), e.frag.data = new Uint8Array(e.payload), n.parsing.start = n.buffering.start = self.performance.now(), n.parsing.end = n.buffering.end = self.performance.now(), this.tick();
  }
  unhandledEncryptionError(e, t) {
    var n, s;
    const r = e.tracks;
    if (r && !t.encrypted && ((n = r.audio) != null && n.encrypted || (s = r.video) != null && s.encrypted) && (!this.config.emeEnabled || !this.keyLoader.emeController)) {
      const a = this.media, o = new Error(`Encrypted track with no key in ${this.fragInfo(t)} (media ${a ? "attached mediaKeys: " + a.mediaKeys : "detached"})`);
      return this.warn(o.message), !a || a.mediaKeys ? !1 : (this.hls.trigger(S.ERROR, {
        type: pe.KEY_SYSTEM_ERROR,
        details: B.KEY_SYSTEM_NO_KEYS,
        fatal: !1,
        error: o,
        frag: t
      }), this.resetTransmuxer(), !0);
    }
    return !1;
  }
  fragContextChanged(e) {
    const {
      fragCurrent: t
    } = this;
    return !e || !t || e.sn !== t.sn || e.level !== t.level;
  }
  fragBufferedComplete(e, t) {
    const n = this.mediaBuffer ? this.mediaBuffer : this.media;
    if (this.log(`Buffered ${e.type} sn: ${e.sn}${t ? " part: " + t.index : ""} of ${this.fragInfo(e, !1, t)} > buffer:${n ? Sy.toString(Te.getBuffered(n)) : "(detached)"})`), st(e)) {
      var s;
      if (e.type !== ce.SUBTITLE) {
        const a = e.elementaryStreams;
        if (!Object.keys(a).some((o) => !!a[o])) {
          this.state = K.IDLE;
          return;
        }
      }
      const r = (s = this.levels) == null ? void 0 : s[e.level];
      r != null && r.fragmentError && (this.log(`Resetting level fragment error count of ${r.fragmentError} on frag buffered`), r.fragmentError = 0);
    }
    this.state = K.IDLE;
  }
  _handleFragmentLoadComplete(e) {
    const {
      transmuxer: t
    } = this;
    if (!t)
      return;
    const {
      frag: n,
      part: s,
      partsLoaded: r
    } = e, a = !r || r.length === 0 || r.some((l) => !l), o = new xl(n.level, n.sn, n.stats.chunkCount + 1, 0, s ? s.index : -1, !a);
    t.flush(o);
  }
  _handleFragmentLoadProgress(e) {
  }
  _doFragLoad(e, t, n = null, s) {
    var r;
    this.fragCurrent = e;
    const a = t.details;
    if (!this.levels || !a)
      throw new Error(`frag load aborted, missing level${a ? "" : " detail"}s`);
    let o = null;
    e.encrypted && !((r = e.decryptdata) != null && r.key) ? (this.log(`Loading key for ${e.sn} of [${a.startSN}-${a.endSN}], ${this.playlistLabel()} ${e.level}`), this.state = K.KEY_LOADING, this.fragCurrent = e, o = this.keyLoader.load(e).then((f) => {
      if (!this.fragContextChanged(f.frag))
        return this.hls.trigger(S.KEY_LOADED, f), this.state === K.KEY_LOADING && (this.state = K.IDLE), f;
    }), this.hls.trigger(S.KEY_LOADING, {
      frag: e
    }), this.fragCurrent === null && (o = Promise.reject(new Error("frag load aborted, context changed in KEY_LOADING")))) : e.encrypted || (o = this.keyLoader.loadClear(e, a.encryptedFragments, this.startFragRequested), o && this.log("[eme] blocking frag load until media-keys acquired"));
    const l = this.fragPrevious;
    if (st(e) && (!l || e.sn !== l.sn)) {
      const f = this.shouldLoadParts(t.details, e.end);
      f !== this.loadingParts && (this.log(`LL-Part loading ${f ? "ON" : "OFF"} loading sn ${l?.sn}->${e.sn}`), this.loadingParts = f);
    }
    if (n = Math.max(e.start, n || 0), this.loadingParts && st(e)) {
      const f = a.partList;
      if (f && s) {
        n > a.fragmentEnd && a.fragmentHint && (e = a.fragmentHint);
        const h = this.getNextPart(f, e, n);
        if (h > -1) {
          const m = f[h];
          e = this.fragCurrent = m.fragment, this.log(`Loading ${e.type} sn: ${e.sn} part: ${m.index} (${h}/${f.length - 1}) of ${this.fragInfo(e, !1, m)}) cc: ${e.cc} [${a.startSN}-${a.endSN}], target: ${parseFloat(n.toFixed(3))}`), this.nextLoadPosition = m.start + m.duration, this.state = K.FRAG_LOADING;
          let g;
          return o ? g = o.then((v) => !v || this.fragContextChanged(v.frag) ? null : this.doFragPartsLoad(e, m, t, s)).catch((v) => this.handleFragLoadError(v)) : g = this.doFragPartsLoad(e, m, t, s).catch((v) => this.handleFragLoadError(v)), this.hls.trigger(S.FRAG_LOADING, {
            frag: e,
            part: m,
            targetBufferTime: n
          }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING parts")) : g;
        } else if (!e.url || this.loadedEndOfParts(f, n))
          return Promise.resolve(null);
      }
    }
    if (st(e) && this.loadingParts) {
      var d;
      this.log(`LL-Part loading OFF after next part miss @${n.toFixed(2)} Check buffer at sn: ${e.sn} loaded parts: ${(d = a.partList) == null ? void 0 : d.filter((f) => f.loaded).map((f) => `[${f.start}-${f.end}]`)}`), this.loadingParts = !1;
    } else if (!e.url)
      return Promise.resolve(null);
    this.log(`Loading ${e.type} sn: ${e.sn} of ${this.fragInfo(e, !1)}) cc: ${e.cc} ${"[" + a.startSN + "-" + a.endSN + "]"}, target: ${parseFloat(n.toFixed(3))}`), ae(e.sn) && !this.bitrateTest && (this.nextLoadPosition = e.start + e.duration), this.state = K.FRAG_LOADING;
    const c = this.config.progressive;
    let u;
    return c && o ? u = o.then((f) => !f || this.fragContextChanged(f.frag) ? null : this.fragmentLoader.load(e, s)).catch((f) => this.handleFragLoadError(f)) : u = Promise.all([this.fragmentLoader.load(e, c ? s : void 0), o]).then(([f]) => (!c && s && s(f), f)).catch((f) => this.handleFragLoadError(f)), this.hls.trigger(S.FRAG_LOADING, {
      frag: e,
      targetBufferTime: n
    }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING")) : u;
  }
  doFragPartsLoad(e, t, n, s) {
    return new Promise((r, a) => {
      var o;
      const l = [], d = (o = n.details) == null ? void 0 : o.partList, c = (u) => {
        this.fragmentLoader.loadPart(e, u, s).then((f) => {
          l[u.index] = f;
          const h = f.part;
          this.hls.trigger(S.FRAG_LOADED, f);
          const m = Mc(n.details, e.sn, u.index + 1) || wh(d, e.sn, u.index + 1);
          if (m)
            c(m);
          else
            return r({
              frag: e,
              part: h,
              partsLoaded: l
            });
        }).catch(a);
      };
      c(t);
    });
  }
  handleFragLoadError(e) {
    if ("data" in e) {
      const t = e.data;
      t && t.details === B.INTERNAL_ABORTED ? this.handleFragLoadAborted(t.frag, t.part) : this.hls.trigger(S.ERROR, t);
    } else
      this.hls.trigger(S.ERROR, {
        type: pe.OTHER_ERROR,
        details: B.INTERNAL_EXCEPTION,
        err: e,
        error: e,
        fatal: !0
      });
    return null;
  }
  _handleTransmuxerFlush(e) {
    const t = this.getCurrentContext(e);
    if (!t || this.state !== K.PARSING) {
      !this.fragCurrent && this.state !== K.STOPPED && this.state !== K.ERROR && (this.state = K.IDLE);
      return;
    }
    const {
      frag: n,
      part: s,
      level: r
    } = t, a = self.performance.now();
    n.stats.parsing.end = a, s && (s.stats.parsing.end = a);
    const o = this.getLevelDetails(), d = o && n.sn > o.endSN || this.shouldLoadParts(o, n.end);
    d !== this.loadingParts && (this.log(`LL-Part loading ${d ? "ON" : "OFF"} after parsing segment ending @${n.end.toFixed(2)}`), this.loadingParts = d), this.updateLevelTiming(n, s, r, e.partial);
  }
  shouldLoadParts(e, t) {
    if (this.config.lowLatencyMode) {
      if (!e)
        return this.loadingParts;
      if (e.partList) {
        var n;
        const r = e.partList[0];
        if (r.fragment.type === ce.SUBTITLE)
          return !1;
        const a = r.end + (((n = e.fragmentHint) == null ? void 0 : n.duration) || 0);
        if (t >= a) {
          var s;
          if ((this.hls.hasEnoughToStart ? ((s = this.media) == null ? void 0 : s.currentTime) || this.lastCurrentTime : this.getLoadPosition()) > r.start - r.fragment.duration)
            return !0;
        }
      }
    }
    return !1;
  }
  getCurrentContext(e) {
    const {
      levels: t,
      fragCurrent: n
    } = this, {
      level: s,
      sn: r,
      part: a
    } = e;
    if (!(t != null && t[s]))
      return this.warn(`Levels object was unset while buffering fragment ${r} of ${this.playlistLabel()} ${s}. The current chunk will not be buffered.`), null;
    const o = t[s], l = o.details, d = a > -1 ? Mc(l, r, a) : null, c = d ? d.fragment : Ah(l, r, n);
    return c ? (n && n !== c && (c.stats = n.stats), {
      frag: c,
      part: d,
      level: o
    }) : null;
  }
  bufferFragmentData(e, t, n, s, r) {
    if (this.state !== K.PARSING)
      return;
    const {
      data1: a,
      data2: o
    } = e;
    let l = a;
    if (o && (l = Zt(a, o)), !l.length)
      return;
    const d = this.initPTS[t.cc], c = d ? -d.baseTime / d.timescale : void 0, u = {
      type: e.type,
      frag: t,
      part: n,
      chunkMeta: s,
      offset: c,
      parent: t.type,
      data: l
    };
    if (this.hls.trigger(S.BUFFER_APPENDING, u), e.dropped && e.independent && !n) {
      if (r)
        return;
      this.flushBufferGap(t);
    }
  }
  flushBufferGap(e) {
    const t = this.media;
    if (!t)
      return;
    if (!Te.isBuffered(t, t.currentTime)) {
      this.flushMainBuffer(0, e.start);
      return;
    }
    const n = t.currentTime, s = Te.bufferInfo(t, n, 0), r = e.duration, a = Math.min(this.config.maxFragLookUpTolerance * 2, r * 0.25), o = Math.max(Math.min(e.start - a, s.end - a), n + a);
    e.start - o > a && this.flushMainBuffer(o, e.start);
  }
  getFwdBufferInfo(e, t) {
    var n;
    const s = this.getLoadPosition();
    if (!ae(s))
      return null;
    const a = this.lastCurrentTime > s || (n = this.media) != null && n.paused ? 0 : this.config.maxBufferHole;
    return this.getFwdBufferInfoAtPos(e, s, t, a);
  }
  getFwdBufferInfoAtPos(e, t, n, s) {
    const r = Te.bufferInfo(e, t, s);
    if (r.len === 0 && r.nextStart !== void 0) {
      const a = this.fragmentTracker.getBufferedFrag(t, n);
      if (a && (r.nextStart <= a.end || a.gap)) {
        const o = Math.max(Math.min(r.nextStart, a.end) - t, s);
        return Te.bufferInfo(e, t, o);
      }
    }
    return r;
  }
  getMaxBufferLength(e) {
    const {
      config: t
    } = this;
    let n;
    return e ? n = Math.max(8 * t.maxBufferSize / e, t.maxBufferLength) : n = t.maxBufferLength, Math.min(n, t.maxMaxBufferLength);
  }
  reduceMaxBufferLength(e, t) {
    const n = this.config, s = Math.max(Math.min(e - t, n.maxBufferLength), t), r = Math.max(e - t * 3, n.maxMaxBufferLength / 2, s);
    return r >= s ? (n.maxMaxBufferLength = r, this.warn(`Reduce max buffer length to ${r}s`), !0) : !1;
  }
  getAppendedFrag(e, t = ce.MAIN) {
    const n = this.fragmentTracker ? this.fragmentTracker.getAppendedFrag(e, t) : null;
    return n && "fragment" in n ? n.fragment : n;
  }
  getNextFragment(e, t) {
    const n = t.fragments, s = n.length;
    if (!s)
      return null;
    const {
      config: r
    } = this, a = n[0].start, o = r.lowLatencyMode && !!t.partList;
    let l = null;
    if (t.live) {
      const u = r.initialLiveManifestSize;
      if (s < u)
        return this.warn(`Not enough fragments to start playback (have: ${s}, need: ${u})`), null;
      if (!t.PTSKnown && !this.startFragRequested && this.startPosition === -1 || e < a) {
        var d;
        o && !this.loadingParts && (this.log("LL-Part loading ON for initial live fragment"), this.loadingParts = !0), l = this.getInitialLiveFragment(t);
        const f = this.hls.startPosition, h = this.hls.liveSyncPosition, m = l ? (f !== -1 && f >= a ? f : h) || l.start : e;
        this.log(`Setting startPosition to ${m} to match start frag at live edge. mainStart: ${f} liveSyncPosition: ${h} frag.start: ${(d = l) == null ? void 0 : d.start}`), this.startPosition = this.nextLoadPosition = m;
      }
    } else e <= a && (l = n[0]);
    if (!l) {
      const u = this.loadingParts ? t.partEnd : t.fragmentEnd;
      l = this.getFragmentAtPosition(e, u, t);
    }
    let c = this.filterReplacedPrimary(l, t);
    if (!c && l) {
      const u = l.sn - t.startSN;
      c = this.filterReplacedPrimary(n[u + 1] || null, t);
    }
    return this.mapToInitFragWhenRequired(c);
  }
  isLoopLoading(e, t) {
    const n = this.fragmentTracker.getState(e);
    return (n === at.OK || n === at.PARTIAL && !!e.gap) && this.nextLoadPosition > t;
  }
  getNextFragmentLoopLoading(e, t, n, s, r) {
    let a = null;
    if (e.gap && (a = this.getNextFragment(this.nextLoadPosition, t), a && !a.gap && n.nextStart)) {
      const o = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, n.nextStart, s, 0);
      if (o !== null && n.len + o.len >= r) {
        const l = a.sn;
        return this.loopSn !== l && (this.log(`buffer full after gaps in "${s}" playlist starting at sn: ${l}`), this.loopSn = l), null;
      }
    }
    return this.loopSn = void 0, a;
  }
  get primaryPrefetch() {
    if ($c(this.config)) {
      var e;
      if ((e = this.hls.interstitialsManager) == null || (e = e.playingItem) == null ? void 0 : e.event)
        return !0;
    }
    return !1;
  }
  filterReplacedPrimary(e, t) {
    if (!e)
      return e;
    if ($c(this.config) && e.type !== ce.SUBTITLE) {
      const n = this.hls.interstitialsManager, s = n?.bufferingItem;
      if (s) {
        const a = s.event;
        if (a) {
          if (a.appendInPlace || Math.abs(e.start - s.start) > 1 || s.start === 0)
            return null;
        } else if (e.end <= s.start && t?.live === !1 || e.start > s.end && s.nextEvent && (s.nextEvent.appendInPlace || e.start - s.end > 1))
          return null;
      }
      const r = n?.playerQueue;
      if (r)
        for (let a = r.length; a--; ) {
          const o = r[a].interstitial;
          if (o.appendInPlace && e.start >= o.startTime && e.end <= o.resumeTime)
            return null;
        }
    }
    return e;
  }
  mapToInitFragWhenRequired(e) {
    return e != null && e.initSegment && !e.initSegment.data && !this.bitrateTest ? e.initSegment : e;
  }
  getNextPart(e, t, n) {
    let s = -1, r = !1, a = !0;
    for (let o = 0, l = e.length; o < l; o++) {
      const d = e[o];
      if (a = a && !d.independent, s > -1 && n < d.start)
        break;
      const c = d.loaded;
      c ? s = -1 : (r || (d.independent || a) && d.fragment === t) && (d.fragment !== t && this.warn(`Need buffer at ${n} but next unloaded part starts at ${d.start}`), s = o), r = c;
    }
    return s;
  }
  loadedEndOfParts(e, t) {
    let n;
    for (let s = e.length; s--; ) {
      if (n = e[s], !n.loaded)
        return !1;
      if (t > n.start)
        return !0;
    }
    return !1;
  }
  /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */
  getInitialLiveFragment(e) {
    const t = e.fragments, n = this.fragPrevious;
    let s = null;
    if (n) {
      if (e.hasProgramDateTime && (this.log(`Live playlist, switching playlist, load frag with same PDT: ${n.programDateTime}`), s = N1(t, n.endProgramDateTime, this.config.maxFragLookUpTolerance)), !s) {
        const r = n.sn + 1;
        if (r >= e.startSN && r <= e.endSN) {
          const a = t[r - e.startSN];
          n.cc === a.cc && (s = a, this.log(`Live playlist, switching playlist, load frag with next SN: ${s.sn}`));
        }
        s || (s = vh(e, n.cc, n.end), s && this.log(`Live playlist, switching playlist, load frag with same CC: ${s.sn}`));
      }
    } else {
      const r = this.hls.liveSyncPosition;
      r !== null && (s = this.getFragmentAtPosition(r, this.bitrateTest ? e.fragmentEnd : e.edge, e));
    }
    return s;
  }
  /*
  This method finds the best matching fragment given the provided position.
   */
  getFragmentAtPosition(e, t, n) {
    const {
      config: s
    } = this;
    let {
      fragPrevious: r
    } = this, {
      fragments: a,
      endSN: o
    } = n;
    const {
      fragmentHint: l
    } = n, {
      maxFragLookUpTolerance: d
    } = s, c = n.partList, u = !!(this.loadingParts && c != null && c.length && l);
    u && !this.bitrateTest && c[c.length - 1].fragment.sn === l.sn && (a = a.concat(l), o = l.sn);
    let f;
    if (e < t) {
      var h;
      const g = e < this.lastCurrentTime || e > t - d || (h = this.media) != null && h.paused || !this.startFragRequested ? 0 : d;
      f = Sn(r, a, e, g);
    } else
      f = a[a.length - 1];
    if (f) {
      const m = f.sn - n.startSN, g = this.fragmentTracker.getState(f);
      if ((g === at.OK || g === at.PARTIAL && f.gap) && (r = f), r && f.sn === r.sn && (!u || c[0].fragment.sn > f.sn || !n.live) && f.level === r.level) {
        const p = a[m + 1];
        f.sn < o && this.fragmentTracker.getState(p) !== at.OK ? f = p : f = null;
      }
    }
    return f;
  }
  alignPlaylists(e, t, n) {
    const s = e.fragments.length;
    if (!s)
      return this.warn("No fragments in live playlist"), 0;
    const r = e.fragmentStart, a = !t, o = e.alignedSliding && ae(r);
    if (a || !o && !r) {
      by(n, e);
      const l = e.fragmentStart;
      return this.log(`Live playlist sliding: ${l.toFixed(2)} start-sn: ${t ? t.startSN : "na"}->${e.startSN} fragments: ${s}`), l;
    }
    return r;
  }
  waitForCdnTuneIn(e) {
    return e.live && e.canBlockReload && e.partTarget && e.tuneInGoal > Math.max(e.partHoldBack, e.partTarget * 3);
  }
  setStartPosition(e, t) {
    let n = this.startPosition;
    n < t && (n = -1);
    const s = this.timelineOffset;
    if (n === -1) {
      const r = this.startTimeOffset !== null, a = r ? this.startTimeOffset : e.startTimeOffset;
      a !== null && ae(a) ? (n = t + a, a < 0 && (n += e.edge), n = Math.min(Math.max(t, n), t + e.totalduration), this.log(`Setting startPosition to ${n} for start time offset ${a} found in ${r ? "multivariant" : "media"} playlist`), this.startPosition = n) : e.live ? (n = this.hls.liveSyncPosition || t, this.log(`Setting startPosition to -1 to start at live edge ${n}`), this.startPosition = -1) : (this.log("setting startPosition to 0 by default"), this.startPosition = n = 0), this.lastCurrentTime = n + s;
    }
    this.nextLoadPosition = n + s;
  }
  getLoadPosition() {
    var e;
    const {
      media: t
    } = this;
    let n = 0;
    return (e = this.hls) != null && e.hasEnoughToStart && t ? n = t.currentTime : this.nextLoadPosition >= 0 && (n = this.nextLoadPosition), n;
  }
  handleFragLoadAborted(e, t) {
    this.transmuxer && e.type === this.playlistType && st(e) && e.stats.aborted && (this.log(`Fragment ${e.sn}${t ? " part " + t.index : ""} of ${this.playlistLabel()} ${e.level} was aborted`), this.resetFragmentLoading(e));
  }
  resetFragmentLoading(e) {
    (!this.fragCurrent || !this.fragContextChanged(e) && this.state !== K.FRAG_LOADING_WAITING_RETRY) && (this.state = K.IDLE);
  }
  onFragmentOrKeyLoadError(e, t) {
    var n;
    if (t.chunkMeta && !t.frag) {
      const v = this.getCurrentContext(t.chunkMeta);
      v && (t.frag = v.frag);
    }
    const s = t.frag;
    if (!s || s.type !== e || !this.levels)
      return;
    if (this.fragContextChanged(s)) {
      var r;
      this.warn(`Frag load error must match current frag to retry ${s.url} > ${(r = this.fragCurrent) == null ? void 0 : r.url}`);
      return;
    }
    const a = t.details === B.FRAG_GAP;
    a && this.fragmentTracker.fragBuffered(s, !0);
    const o = t.errorAction, {
      action: l,
      flags: d,
      retryCount: c = 0,
      retryConfig: u
    } = o || {}, f = !!o && !!u, h = f && l === vt.RetryRequest, m = f && !o.resolved && d === ei.MoveAllAlternatesMatchingHost, g = ((n = t.response) == null ? void 0 : n.code) || 0;
    if (!h && m && st(s) && !s.endList && g !== 0)
      this.resetFragmentErrors(e), this.treatAsGap(s), o.resolved = !0;
    else if ((h || m) && c < u.maxNumRetry) {
      this.resetStartWhenNotLoaded(this.levelLastLoaded);
      const v = Tl(u, c);
      this.warn(`Fragment ${s.sn} of ${e} ${s.level} errored with ${t.details}, retrying loading ${c + 1}/${u.maxNumRetry} in ${v}ms`), o.resolved = !0, this.retryDate = self.performance.now() + v, this.state = K.FRAG_LOADING_WAITING_RETRY;
    } else if (u && o)
      if (this.resetFragmentErrors(e), c < u.maxNumRetry)
        !a && l !== vt.RemoveAlternatePermanently && (o.resolved = !0);
      else {
        this.warn(`${t.details} reached or exceeded max retry (${c})`);
        return;
      }
    else l === vt.SendAlternateToPenaltyBox ? this.state = K.WAITING_LEVEL : this.state = K.ERROR;
    this.tickImmediate();
  }
  reduceLengthAndFlushBuffer(e) {
    if (this.state === K.PARSING || this.state === K.PARSED) {
      const t = e.frag, n = e.parent, s = this.getFwdBufferInfo(this.mediaBuffer, n), r = s && s.len > 0.5;
      r && this.reduceMaxBufferLength(s.len, t?.duration || 10);
      const a = !r;
      return a && this.warn(`Buffer full error while media.currentTime (${this.getLoadPosition()}) is not buffered, flush ${n} buffer`), t && (this.fragmentTracker.removeFragment(t), this.nextLoadPosition = t.start), this.resetLoadingState(), a;
    }
    return !1;
  }
  resetFragmentErrors(e) {
    e === ce.AUDIO && (this.fragCurrent = null), this.hls.hasEnoughToStart || (this.startFragRequested = !1), this.state !== K.STOPPED && (this.state = K.IDLE);
  }
  afterBufferFlushed(e, t, n) {
    if (!e)
      return;
    const s = Te.getBuffered(e);
    this.fragmentTracker.detectEvictedFragments(t, s, n), this.state === K.ENDED && this.resetLoadingState();
  }
  resetLoadingState() {
    this.log("Reset loading state"), this.fragCurrent = null, this.fragPrevious = null, this.state !== K.STOPPED && (this.state = K.IDLE);
  }
  resetStartWhenNotLoaded(e) {
    if (!this.hls.hasEnoughToStart) {
      this.startFragRequested = !1;
      const t = e ? e.details : null;
      t != null && t.live ? (this.log("resetting startPosition for live start"), this.startPosition = -1, this.setStartPosition(t, t.fragmentStart), this.resetLoadingState()) : this.nextLoadPosition = this.startPosition;
    }
  }
  resetWhenMissingContext(e) {
    this.warn(`The loading context changed while buffering fragment ${e.sn} of ${this.playlistLabel()} ${e.level}. This chunk will not be buffered.`), this.removeUnbufferedFrags(), this.resetStartWhenNotLoaded(this.levelLastLoaded), this.resetLoadingState();
  }
  removeUnbufferedFrags(e = 0) {
    this.fragmentTracker.removeFragmentsInRange(e, 1 / 0, this.playlistType, !1, !0);
  }
  updateLevelTiming(e, t, n, s) {
    const r = n.details;
    if (!r) {
      this.warn("level.details undefined");
      return;
    }
    if (!Object.keys(e.elementaryStreams).reduce((l, d) => {
      const c = e.elementaryStreams[d];
      if (c) {
        const u = c.endPTS - c.startPTS;
        if (u <= 0)
          return this.warn(`Could not parse fragment ${e.sn} ${d} duration reliably (${u})`), l || !1;
        const f = s ? 0 : Eh(r, e, c.startPTS, c.endPTS, c.startDTS, c.endDTS, this);
        return this.hls.trigger(S.LEVEL_PTS_UPDATED, {
          details: r,
          level: n,
          drift: f,
          type: d,
          frag: e,
          start: c.startPTS,
          end: c.endPTS
        }), !0;
      }
      return l;
    }, !1)) {
      var o;
      if (n.fragmentError === 0 && this.treatAsGap(e, n), ((o = this.transmuxer) == null ? void 0 : o.error) === null) {
        const l = new Error(`Found no media in fragment ${e.sn} of ${this.playlistLabel()} ${e.level} resetting transmuxer to fallback to playlist timing`);
        if (this.warn(l.message), this.hls.trigger(S.ERROR, {
          type: pe.MEDIA_ERROR,
          details: B.FRAG_PARSING_ERROR,
          fatal: !1,
          error: l,
          frag: e,
          reason: `Found no media in msn ${e.sn} of ${this.playlistLabel()} "${n.url}"`
        }), !this.hls)
          return;
        this.resetTransmuxer();
      }
    }
    this.state = K.PARSED, this.log(`Parsed ${e.type} sn: ${e.sn}${t ? " part: " + t.index : ""} of ${this.fragInfo(e, !1, t)})`), this.hls.trigger(S.FRAG_PARSED, {
      frag: e,
      part: t
    });
  }
  playlistLabel() {
    return this.playlistType === ce.MAIN ? "level" : "track";
  }
  fragInfo(e, t = !0, n) {
    var s, r;
    return `${this.playlistLabel()} ${e.level} (${n ? "part" : "frag"}:[${((s = t && !n ? e.startPTS : (n || e).start) != null ? s : NaN).toFixed(3)}-${((r = t && !n ? e.endPTS : (n || e).end) != null ? r : NaN).toFixed(3)}]${n && e.type === "main" ? "INDEPENDENT=" + (n.independent ? "YES" : "NO") : ""}`;
  }
  treatAsGap(e, t) {
    t && t.fragmentError++, e.gap = !0, this.fragmentTracker.removeFragment(e), this.fragmentTracker.fragBuffered(e, !0);
  }
  resetTransmuxer() {
    var e;
    (e = this.transmuxer) == null || e.reset();
  }
  recoverWorkerError(e) {
    e.event === "demuxerWorker" && (this.fragmentTracker.removeAllFragments(), this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null), this.resetStartWhenNotLoaded(this.levelLastLoaded), this.resetLoadingState());
  }
  set state(e) {
    const t = this._state;
    t !== e && (this._state = e, this.log(`${t}->${e}`));
  }
  get state() {
    return this._state;
  }
}
function $c(i) {
  return !!i.interstitialsController && i.enableInterstitialPlayback !== !1;
}
class Rh {
  constructor() {
    this.chunks = [], this.dataLength = 0;
  }
  push(e) {
    this.chunks.push(e), this.dataLength += e.length;
  }
  flush() {
    const {
      chunks: e,
      dataLength: t
    } = this;
    let n;
    if (e.length)
      e.length === 1 ? n = e[0] : n = ky(e, t);
    else return new Uint8Array(0);
    return this.reset(), n;
  }
  reset() {
    this.chunks.length = 0, this.dataLength = 0;
  }
}
function ky(i, e) {
  const t = new Uint8Array(e);
  let n = 0;
  for (let s = 0; s < i.length; s++) {
    const r = i[s];
    t.set(r, n), n += r.length;
  }
  return t;
}
var Ba = { exports: {} }, Bc;
function Ty() {
  return Bc || (Bc = 1, function(i) {
    var e = Object.prototype.hasOwnProperty, t = "~";
    function n() {
    }
    Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (t = !1));
    function s(l, d, c) {
      this.fn = l, this.context = d, this.once = c || !1;
    }
    function r(l, d, c, u, f) {
      if (typeof c != "function")
        throw new TypeError("The listener must be a function");
      var h = new s(c, u || l, f), m = t ? t + d : d;
      return l._events[m] ? l._events[m].fn ? l._events[m] = [l._events[m], h] : l._events[m].push(h) : (l._events[m] = h, l._eventsCount++), l;
    }
    function a(l, d) {
      --l._eventsCount === 0 ? l._events = new n() : delete l._events[d];
    }
    function o() {
      this._events = new n(), this._eventsCount = 0;
    }
    o.prototype.eventNames = function() {
      var d = [], c, u;
      if (this._eventsCount === 0) return d;
      for (u in c = this._events)
        e.call(c, u) && d.push(t ? u.slice(1) : u);
      return Object.getOwnPropertySymbols ? d.concat(Object.getOwnPropertySymbols(c)) : d;
    }, o.prototype.listeners = function(d) {
      var c = t ? t + d : d, u = this._events[c];
      if (!u) return [];
      if (u.fn) return [u.fn];
      for (var f = 0, h = u.length, m = new Array(h); f < h; f++)
        m[f] = u[f].fn;
      return m;
    }, o.prototype.listenerCount = function(d) {
      var c = t ? t + d : d, u = this._events[c];
      return u ? u.fn ? 1 : u.length : 0;
    }, o.prototype.emit = function(d, c, u, f, h, m) {
      var g = t ? t + d : d;
      if (!this._events[g]) return !1;
      var v = this._events[g], p = arguments.length, y, b;
      if (v.fn) {
        switch (v.once && this.removeListener(d, v.fn, void 0, !0), p) {
          case 1:
            return v.fn.call(v.context), !0;
          case 2:
            return v.fn.call(v.context, c), !0;
          case 3:
            return v.fn.call(v.context, c, u), !0;
          case 4:
            return v.fn.call(v.context, c, u, f), !0;
          case 5:
            return v.fn.call(v.context, c, u, f, h), !0;
          case 6:
            return v.fn.call(v.context, c, u, f, h, m), !0;
        }
        for (b = 1, y = new Array(p - 1); b < p; b++)
          y[b - 1] = arguments[b];
        v.fn.apply(v.context, y);
      } else {
        var k = v.length, T;
        for (b = 0; b < k; b++)
          switch (v[b].once && this.removeListener(d, v[b].fn, void 0, !0), p) {
            case 1:
              v[b].fn.call(v[b].context);
              break;
            case 2:
              v[b].fn.call(v[b].context, c);
              break;
            case 3:
              v[b].fn.call(v[b].context, c, u);
              break;
            case 4:
              v[b].fn.call(v[b].context, c, u, f);
              break;
            default:
              if (!y) for (T = 1, y = new Array(p - 1); T < p; T++)
                y[T - 1] = arguments[T];
              v[b].fn.apply(v[b].context, y);
          }
      }
      return !0;
    }, o.prototype.on = function(d, c, u) {
      return r(this, d, c, u, !1);
    }, o.prototype.once = function(d, c, u) {
      return r(this, d, c, u, !0);
    }, o.prototype.removeListener = function(d, c, u, f) {
      var h = t ? t + d : d;
      if (!this._events[h]) return this;
      if (!c)
        return a(this, h), this;
      var m = this._events[h];
      if (m.fn)
        m.fn === c && (!f || m.once) && (!u || m.context === u) && a(this, h);
      else {
        for (var g = 0, v = [], p = m.length; g < p; g++)
          (m[g].fn !== c || f && !m[g].once || u && m[g].context !== u) && v.push(m[g]);
        v.length ? this._events[h] = v.length === 1 ? v[0] : v : a(this, h);
      }
      return this;
    }, o.prototype.removeAllListeners = function(d) {
      var c;
      return d ? (c = t ? t + d : d, this._events[c] && a(this, c)) : (this._events = new n(), this._eventsCount = 0), this;
    }, o.prototype.off = o.prototype.removeListener, o.prototype.addListener = o.prototype.on, o.prefixed = t, o.EventEmitter = o, i.exports = o;
  }(Ba)), Ba.exports;
}
var Ey = Ty(), Ll = /* @__PURE__ */ Zv(Ey);
const Ls = "1.6.10", Kn = {};
function xy() {
  return typeof __HLS_WORKER_BUNDLE__ == "function";
}
function _y() {
  const i = Kn[Ls];
  if (i)
    return i.clientCount++, i;
  const e = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], {
    type: "text/javascript"
  }), t = self.URL.createObjectURL(e), s = {
    worker: new self.Worker(t),
    objectURL: t,
    clientCount: 1
  };
  return Kn[Ls] = s, s;
}
function Ay(i) {
  const e = Kn[i];
  if (e)
    return e.clientCount++, e;
  const t = new self.URL(i, self.location.href).href, s = {
    worker: new self.Worker(t),
    scriptURL: t,
    clientCount: 1
  };
  return Kn[i] = s, s;
}
function wy(i) {
  const e = Kn[i || Ls];
  if (e && e.clientCount-- === 1) {
    const {
      worker: n,
      objectURL: s
    } = e;
    delete Kn[i || Ls], s && self.URL.revokeObjectURL(s), n.terminate();
  }
}
function Ph(i, e) {
  return e + 10 <= i.length && i[e] === 51 && i[e + 1] === 68 && i[e + 2] === 73 && i[e + 3] < 255 && i[e + 4] < 255 && i[e + 6] < 128 && i[e + 7] < 128 && i[e + 8] < 128 && i[e + 9] < 128;
}
function Il(i, e) {
  return e + 10 <= i.length && i[e] === 73 && i[e + 1] === 68 && i[e + 2] === 51 && i[e + 3] < 255 && i[e + 4] < 255 && i[e + 6] < 128 && i[e + 7] < 128 && i[e + 8] < 128 && i[e + 9] < 128;
}
function ga(i, e) {
  let t = 0;
  return t = (i[e] & 127) << 21, t |= (i[e + 1] & 127) << 14, t |= (i[e + 2] & 127) << 7, t |= i[e + 3] & 127, t;
}
function Is(i, e) {
  const t = e;
  let n = 0;
  for (; Il(i, e); ) {
    n += 10;
    const s = ga(i, e + 6);
    n += s, Ph(i, e + 10) && (n += 10), e += n;
  }
  if (n > 0)
    return i.subarray(t, t + n);
}
function Ly(i, e, t, n) {
  const s = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350], r = e[t + 2], a = r >> 2 & 15;
  if (a > 12) {
    const h = new Error(`invalid ADTS sampling index:${a}`);
    i.emit(S.ERROR, S.ERROR, {
      type: pe.MEDIA_ERROR,
      details: B.FRAG_PARSING_ERROR,
      fatal: !0,
      error: h,
      reason: h.message
    });
    return;
  }
  const o = (r >> 6 & 3) + 1, l = e[t + 3] >> 6 & 3 | (r & 1) << 2, d = "mp4a.40." + o, c = s[a];
  let u = a;
  (o === 5 || o === 29) && (u -= 3);
  const f = [o << 3 | (u & 14) >> 1, (u & 1) << 7 | l << 3];
  return Be.log(`manifest codec:${n}, parsed codec:${d}, channels:${l}, rate:${c} (ADTS object type:${o} sampling index:${a})`), {
    config: f,
    samplerate: c,
    channelCount: l,
    codec: d,
    parsedCodec: d,
    manifestCodec: n
  };
}
function Dh(i, e) {
  return i[e] === 255 && (i[e + 1] & 246) === 240;
}
function Nh(i, e) {
  return i[e + 1] & 1 ? 7 : 9;
}
function Cl(i, e) {
  return (i[e + 3] & 3) << 11 | i[e + 4] << 3 | (i[e + 5] & 224) >>> 5;
}
function Iy(i, e) {
  return e + 5 < i.length;
}
function Fr(i, e) {
  return e + 1 < i.length && Dh(i, e);
}
function Cy(i, e) {
  return Iy(i, e) && Dh(i, e) && Cl(i, e) <= i.length - e;
}
function Ry(i, e) {
  if (Fr(i, e)) {
    const t = Nh(i, e);
    if (e + t >= i.length)
      return !1;
    const n = Cl(i, e);
    if (n <= t)
      return !1;
    const s = e + n;
    return s === i.length || Fr(i, s);
  }
  return !1;
}
function Mh(i, e, t, n, s) {
  if (!i.samplerate) {
    const r = Ly(e, t, n, s);
    if (!r)
      return;
    He(i, r);
  }
}
function Oh(i) {
  return 1024 * 9e4 / i;
}
function Py(i, e) {
  const t = Nh(i, e);
  if (e + t <= i.length) {
    const n = Cl(i, e) - t;
    if (n > 0)
      return {
        headerLength: t,
        frameLength: n
      };
  }
}
function Fh(i, e, t, n, s) {
  const r = Oh(i.samplerate), a = n + s * r, o = Py(e, t);
  let l;
  if (o) {
    const {
      frameLength: u,
      headerLength: f
    } = o, h = f + u, m = Math.max(0, t + h - e.length);
    m ? (l = new Uint8Array(h - f), l.set(e.subarray(t + f, e.length), 0)) : l = e.subarray(t + f, t + h);
    const g = {
      unit: l,
      pts: a
    };
    return m || i.samples.push(g), {
      sample: g,
      length: h,
      missing: m
    };
  }
  const d = e.length - t;
  return l = new Uint8Array(d), l.set(e.subarray(t, e.length), 0), {
    sample: {
      unit: l,
      pts: a
    },
    length: d,
    missing: -1
  };
}
function Dy(i, e) {
  return Il(i, e) && ga(i, e + 6) + 10 <= i.length - e;
}
function Ny(i) {
  return i instanceof ArrayBuffer ? i : i.byteOffset == 0 && i.byteLength == i.buffer.byteLength ? i.buffer : new Uint8Array(i).buffer;
}
function Ua(i, e = 0, t = 1 / 0) {
  return My(i, e, t, Uint8Array);
}
function My(i, e, t, n) {
  const s = Oy(i);
  let r = 1;
  "BYTES_PER_ELEMENT" in n && (r = n.BYTES_PER_ELEMENT);
  const a = Fy(i) ? i.byteOffset : 0, o = (a + i.byteLength) / r, l = (a + e) / r, d = Math.floor(Math.max(0, Math.min(l, o))), c = Math.floor(Math.min(d + Math.max(t, 0), o));
  return new n(s, d, c - d);
}
function Oy(i) {
  return i instanceof ArrayBuffer ? i : i.buffer;
}
function Fy(i) {
  return i && i.buffer instanceof ArrayBuffer && i.byteLength !== void 0 && i.byteOffset !== void 0;
}
function $y(i) {
  const e = {
    key: i.type,
    description: "",
    data: "",
    mimeType: null,
    pictureType: null
  }, t = 3;
  if (i.size < 2)
    return;
  if (i.data[0] !== t) {
    console.log("Ignore frame with unrecognized character encoding");
    return;
  }
  const n = i.data.subarray(1).indexOf(0);
  if (n === -1)
    return;
  const s = Ht(Ua(i.data, 1, n)), r = i.data[2 + n], a = i.data.subarray(3 + n).indexOf(0);
  if (a === -1)
    return;
  const o = Ht(Ua(i.data, 3 + n, a));
  let l;
  return s === "-->" ? l = Ht(Ua(i.data, 4 + n + a)) : l = Ny(i.data.subarray(4 + n + a)), e.mimeType = s, e.pictureType = r, e.description = o, e.data = l, e;
}
function By(i) {
  if (i.size < 2)
    return;
  const e = Ht(i.data, !0), t = new Uint8Array(i.data.subarray(e.length + 1));
  return {
    key: i.type,
    info: e,
    data: t.buffer
  };
}
function Uy(i) {
  if (i.size < 2)
    return;
  if (i.type === "TXXX") {
    let t = 1;
    const n = Ht(i.data.subarray(t), !0);
    t += n.length + 1;
    const s = Ht(i.data.subarray(t));
    return {
      key: i.type,
      info: n,
      data: s
    };
  }
  const e = Ht(i.data.subarray(1));
  return {
    key: i.type,
    info: "",
    data: e
  };
}
function Vy(i) {
  if (i.type === "WXXX") {
    if (i.size < 2)
      return;
    let t = 1;
    const n = Ht(i.data.subarray(t), !0);
    t += n.length + 1;
    const s = Ht(i.data.subarray(t));
    return {
      key: i.type,
      info: n,
      data: s
    };
  }
  const e = Ht(i.data);
  return {
    key: i.type,
    info: "",
    data: e
  };
}
function Gy(i) {
  return i.type === "PRIV" ? By(i) : i.type[0] === "W" ? Vy(i) : i.type === "APIC" ? $y(i) : Uy(i);
}
function Hy(i) {
  const e = String.fromCharCode(i[0], i[1], i[2], i[3]), t = ga(i, 4), n = 10;
  return {
    type: e,
    size: t,
    data: i.subarray(n, n + t)
  };
}
const qs = 10, zy = 10;
function $h(i) {
  let e = 0;
  const t = [];
  for (; Il(i, e); ) {
    const n = ga(i, e + 6);
    i[e + 5] >> 6 & 1 && (e += qs), e += qs;
    const s = e + n;
    for (; e + zy < s; ) {
      const r = Hy(i.subarray(e)), a = Gy(r);
      a && t.push(a), e += r.size + qs;
    }
    Ph(i, e) && (e += qs);
  }
  return t;
}
function Bh(i) {
  return i && i.key === "PRIV" && i.info === "com.apple.streaming.transportStreamTimestamp";
}
function Ky(i) {
  if (i.data.byteLength === 8) {
    const e = new Uint8Array(i.data), t = e[3] & 1;
    let n = (e[4] << 23) + (e[5] << 15) + (e[6] << 7) + e[7];
    return n /= 45, t && (n += 4772185884e-2), Math.round(n);
  }
}
function Rl(i) {
  const e = $h(i);
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    if (Bh(n))
      return Ky(n);
  }
}
let Bt = /* @__PURE__ */ function(i) {
  return i.audioId3 = "org.id3", i.dateRange = "com.apple.quicktime.HLS", i.emsg = "https://aomedia.org/emsg/ID3", i.misbklv = "urn:misb:KLV:bin:1910.1", i;
}({});
function ui(i = "", e = 9e4) {
  return {
    type: i,
    id: -1,
    pid: -1,
    inputTimeScale: e,
    sequenceNumber: -1,
    samples: [],
    dropped: 0
  };
}
class Pl {
  constructor() {
    this._audioTrack = void 0, this._id3Track = void 0, this.frameIndex = 0, this.cachedData = null, this.basePTS = null, this.initPTS = null, this.lastPTS = null;
  }
  resetInitSegment(e, t, n, s) {
    this._id3Track = {
      type: "id3",
      id: 3,
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0
    };
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.resetContiguity();
  }
  resetContiguity() {
    this.basePTS = null, this.lastPTS = null, this.frameIndex = 0;
  }
  canParse(e, t) {
    return !1;
  }
  appendFrame(e, t, n) {
  }
  // feed incoming data to the front of the parsing pipeline
  demux(e, t) {
    this.cachedData && (e = Zt(this.cachedData, e), this.cachedData = null);
    let n = Is(e, 0), s = n ? n.length : 0, r;
    const a = this._audioTrack, o = this._id3Track, l = n ? Rl(n) : void 0, d = e.length;
    for ((this.basePTS === null || this.frameIndex === 0 && ae(l)) && (this.basePTS = jy(l, t, this.initPTS), this.lastPTS = this.basePTS), this.lastPTS === null && (this.lastPTS = this.basePTS), n && n.length > 0 && o.samples.push({
      pts: this.lastPTS,
      dts: this.lastPTS,
      data: n,
      type: Bt.audioId3,
      duration: Number.POSITIVE_INFINITY
    }); s < d; ) {
      if (this.canParse(e, s)) {
        const c = this.appendFrame(a, e, s);
        c ? (this.frameIndex++, this.lastPTS = c.sample.pts, s += c.length, r = s) : s = d;
      } else Dy(e, s) ? (n = Is(e, s), o.samples.push({
        pts: this.lastPTS,
        dts: this.lastPTS,
        data: n,
        type: Bt.audioId3,
        duration: Number.POSITIVE_INFINITY
      }), s += n.length, r = s) : s++;
      if (s === d && r !== d) {
        const c = e.slice(r);
        this.cachedData ? this.cachedData = Zt(this.cachedData, c) : this.cachedData = c;
      }
    }
    return {
      audioTrack: a,
      videoTrack: ui(),
      id3Track: o,
      textTrack: ui()
    };
  }
  demuxSampleAes(e, t, n) {
    return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
  }
  flush(e) {
    const t = this.cachedData;
    return t && (this.cachedData = null, this.demux(t, 0)), {
      audioTrack: this._audioTrack,
      videoTrack: ui(),
      id3Track: this._id3Track,
      textTrack: ui()
    };
  }
  destroy() {
    this.cachedData = null, this._audioTrack = this._id3Track = void 0;
  }
}
const jy = (i, e, t) => {
  if (ae(i))
    return i * 90;
  const n = t ? t.baseTime * 9e4 / t.timescale : 0;
  return e * 9e4 + n;
};
let Ys = null;
const Wy = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160], qy = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3], Yy = [
  // MPEG 2.5
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // Reserved
  [
    0,
    // Reserved
    0,
    // Layer3
    0,
    // Layer2
    0
    // Layer1
  ],
  // MPEG 2
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // MPEG 1
  [
    0,
    // Reserved
    144,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ]
], Xy = [
  0,
  // Reserved
  1,
  // Layer3
  1,
  // Layer2
  4
  // Layer1
];
function Uh(i, e, t, n, s) {
  if (t + 24 > e.length)
    return;
  const r = Vh(e, t);
  if (r && t + r.frameLength <= e.length) {
    const a = r.samplesPerFrame * 9e4 / r.sampleRate, o = n + s * a, l = {
      unit: e.subarray(t, t + r.frameLength),
      pts: o,
      dts: o
    };
    return i.config = [], i.channelCount = r.channelCount, i.samplerate = r.sampleRate, i.samples.push(l), {
      sample: l,
      length: r.frameLength,
      missing: 0
    };
  }
}
function Vh(i, e) {
  const t = i[e + 1] >> 3 & 3, n = i[e + 1] >> 1 & 3, s = i[e + 2] >> 4 & 15, r = i[e + 2] >> 2 & 3;
  if (t !== 1 && s !== 0 && s !== 15 && r !== 3) {
    const a = i[e + 2] >> 1 & 1, o = i[e + 3] >> 6, l = t === 3 ? 3 - n : n === 3 ? 3 : 4, d = Wy[l * 14 + s - 1] * 1e3, u = qy[(t === 3 ? 0 : t === 2 ? 1 : 2) * 3 + r], f = o === 3 ? 1 : 2, h = Yy[t][n], m = Xy[n], g = h * 8 * m, v = Math.floor(h * d / u + a) * m;
    if (Ys === null) {
      const b = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      Ys = b ? parseInt(b[1]) : 0;
    }
    return !!Ys && Ys <= 87 && n === 2 && d >= 224e3 && o === 0 && (i[e + 3] = i[e + 3] | 128), {
      sampleRate: u,
      channelCount: f,
      frameLength: v,
      samplesPerFrame: g
    };
  }
}
function Dl(i, e) {
  return i[e] === 255 && (i[e + 1] & 224) === 224 && (i[e + 1] & 6) !== 0;
}
function Gh(i, e) {
  return e + 1 < i.length && Dl(i, e);
}
function Zy(i, e) {
  return Dl(i, e) && 4 <= i.length - e;
}
function Hh(i, e) {
  if (e + 1 < i.length && Dl(i, e)) {
    const n = Vh(i, e);
    let s = 4;
    n != null && n.frameLength && (s = n.frameLength);
    const r = e + s;
    return r === i.length || Gh(i, r);
  }
  return !1;
}
class Qy extends Pl {
  constructor(e, t) {
    super(), this.observer = void 0, this.config = void 0, this.observer = e, this.config = t;
  }
  resetInitSegment(e, t, n, s) {
    super.resetInitSegment(e, t, n, s), this._audioTrack = {
      container: "audio/adts",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "aac",
      samples: [],
      manifestCodec: t,
      duration: s,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
  static probe(e, t) {
    if (!e)
      return !1;
    const n = Is(e, 0);
    let s = n?.length || 0;
    if (Hh(e, s))
      return !1;
    for (let r = e.length; s < r; s++)
      if (Ry(e, s))
        return t.log("ADTS sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return Cy(e, t);
  }
  appendFrame(e, t, n) {
    Mh(e, this.observer, t, n, e.manifestCodec);
    const s = Fh(e, t, n, this.basePTS, this.frameIndex);
    if (s && s.missing === 0)
      return s;
  }
}
const zh = (i, e) => {
  let t = 0, n = 5;
  e += n;
  const s = new Uint32Array(1), r = new Uint32Array(1), a = new Uint8Array(1);
  for (; n > 0; ) {
    a[0] = i[e];
    const o = Math.min(n, 8), l = 8 - o;
    r[0] = 4278190080 >>> 24 + l << l, s[0] = (a[0] & r[0]) >> l, t = t ? t << o | s[0] : s[0], e += 1, n -= o;
  }
  return t;
};
class Jy extends Pl {
  constructor(e) {
    super(), this.observer = void 0, this.observer = e;
  }
  resetInitSegment(e, t, n, s) {
    super.resetInitSegment(e, t, n, s), this._audioTrack = {
      container: "audio/ac-3",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "ac3",
      samples: [],
      manifestCodec: t,
      duration: s,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  canParse(e, t) {
    return t + 64 < e.length;
  }
  appendFrame(e, t, n) {
    const s = Kh(e, t, n, this.basePTS, this.frameIndex);
    if (s !== -1)
      return {
        sample: e.samples[e.samples.length - 1],
        length: s,
        missing: 0
      };
  }
  static probe(e) {
    if (!e)
      return !1;
    const t = Is(e, 0);
    if (!t)
      return !1;
    const n = t.length;
    return e[n] === 11 && e[n + 1] === 119 && Rl(t) !== void 0 && // check the bsid to confirm ac-3
    zh(e, n) < 16;
  }
}
function Kh(i, e, t, n, s) {
  if (t + 8 > e.length || e[t] !== 11 || e[t + 1] !== 119)
    return -1;
  const r = e[t + 4] >> 6;
  if (r >= 3)
    return -1;
  const o = [48e3, 44100, 32e3][r], l = e[t + 4] & 63, c = [64, 69, 96, 64, 70, 96, 80, 87, 120, 80, 88, 120, 96, 104, 144, 96, 105, 144, 112, 121, 168, 112, 122, 168, 128, 139, 192, 128, 140, 192, 160, 174, 240, 160, 175, 240, 192, 208, 288, 192, 209, 288, 224, 243, 336, 224, 244, 336, 256, 278, 384, 256, 279, 384, 320, 348, 480, 320, 349, 480, 384, 417, 576, 384, 418, 576, 448, 487, 672, 448, 488, 672, 512, 557, 768, 512, 558, 768, 640, 696, 960, 640, 697, 960, 768, 835, 1152, 768, 836, 1152, 896, 975, 1344, 896, 976, 1344, 1024, 1114, 1536, 1024, 1115, 1536, 1152, 1253, 1728, 1152, 1254, 1728, 1280, 1393, 1920, 1280, 1394, 1920][l * 3 + r] * 2;
  if (t + c > e.length)
    return -1;
  const u = e[t + 6] >> 5;
  let f = 0;
  u === 2 ? f += 2 : (u & 1 && u !== 1 && (f += 2), u & 4 && (f += 2));
  const h = (e[t + 6] << 8 | e[t + 7]) >> 12 - f & 1, g = [2, 1, 2, 3, 3, 4, 4, 5][u] + h, v = e[t + 5] >> 3, p = e[t + 5] & 7, y = new Uint8Array([r << 6 | v << 1 | p >> 2, (p & 3) << 6 | u << 3 | h << 2 | l >> 4, l << 4 & 224]), b = 1536 / o * 9e4, k = n + s * b, T = e.subarray(t, t + c);
  return i.config = y, i.channelCount = g, i.samplerate = o, i.samples.push({
    unit: T,
    pts: k
  }), c;
}
class eb extends Pl {
  resetInitSegment(e, t, n, s) {
    super.resetInitSegment(e, t, n, s), this._audioTrack = {
      container: "audio/mpeg",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "mp3",
      samples: [],
      manifestCodec: t,
      duration: s,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  static probe(e) {
    if (!e)
      return !1;
    const t = Is(e, 0);
    let n = t?.length || 0;
    if (t && e[n] === 11 && e[n + 1] === 119 && Rl(t) !== void 0 && // check the bsid to confirm ac-3 or ec-3 (not mp3)
    zh(e, n) <= 16)
      return !1;
    for (let s = e.length; n < s; n++)
      if (Hh(e, n))
        return Be.log("MPEG Audio sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return Zy(e, t);
  }
  appendFrame(e, t, n) {
    if (this.basePTS !== null)
      return Uh(e, t, n, this.basePTS, this.frameIndex);
  }
}
const tb = /\/emsg[-/]ID3/i;
class ib {
  constructor(e, t) {
    this.remainderData = null, this.timeOffset = 0, this.config = void 0, this.videoTrack = void 0, this.audioTrack = void 0, this.id3Track = void 0, this.txtTrack = void 0, this.config = t;
  }
  resetTimeStamp() {
  }
  resetInitSegment(e, t, n, s) {
    const r = this.videoTrack = ui("video", 1), a = this.audioTrack = ui("audio", 1), o = this.txtTrack = ui("text", 1);
    if (this.id3Track = ui("id3", 1), this.timeOffset = 0, !(e != null && e.byteLength))
      return;
    const l = oh(e);
    if (l.video) {
      const {
        id: d,
        timescale: c,
        codec: u,
        supplemental: f
      } = l.video;
      r.id = d, r.timescale = o.timescale = c, r.codec = u, r.supplemental = f;
    }
    if (l.audio) {
      const {
        id: d,
        timescale: c,
        codec: u
      } = l.audio;
      a.id = d, a.timescale = c, a.codec = u;
    }
    o.id = sh.text, r.sampleDuration = 0, r.duration = a.duration = s;
  }
  resetContiguity() {
    this.remainderData = null;
  }
  static probe(e) {
    return i1(e);
  }
  demux(e, t) {
    this.timeOffset = t;
    let n = e;
    const s = this.videoTrack, r = this.txtTrack;
    if (this.config.progressive) {
      this.remainderData && (n = Zt(this.remainderData, e));
      const o = l1(n);
      this.remainderData = o.remainder, s.samples = o.valid || new Uint8Array();
    } else
      s.samples = n;
    const a = this.extractID3Track(s, t);
    return r.samples = rc(t, s), {
      videoTrack: s,
      audioTrack: this.audioTrack,
      id3Track: a,
      textTrack: this.txtTrack
    };
  }
  flush() {
    const e = this.timeOffset, t = this.videoTrack, n = this.txtTrack;
    t.samples = this.remainderData || new Uint8Array(), this.remainderData = null;
    const s = this.extractID3Track(t, this.timeOffset);
    return n.samples = rc(e, t), {
      videoTrack: t,
      audioTrack: ui(),
      id3Track: s,
      textTrack: ui()
    };
  }
  extractID3Track(e, t) {
    const n = this.id3Track;
    if (e.samples.length) {
      const s = we(e.samples, ["emsg"]);
      s && s.forEach((r) => {
        const a = c1(r);
        if (tb.test(a.schemeIdUri)) {
          const o = Uc(a, t);
          let l = a.eventDuration === 4294967295 ? Number.POSITIVE_INFINITY : a.eventDuration / a.timeScale;
          l <= 1e-3 && (l = Number.POSITIVE_INFINITY);
          const d = a.payload;
          n.samples.push({
            data: d,
            len: d.byteLength,
            dts: o,
            pts: o,
            type: Bt.emsg,
            duration: l
          });
        } else if (this.config.enableEmsgKLVMetadata && a.schemeIdUri.startsWith("urn:misb:KLV:bin:1910.1")) {
          const o = Uc(a, t);
          n.samples.push({
            data: a.payload,
            len: a.payload.byteLength,
            dts: o,
            pts: o,
            type: Bt.misbklv,
            duration: Number.POSITIVE_INFINITY
          });
        }
      });
    }
    return n;
  }
  demuxSampleAes(e, t, n) {
    return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
  }
  destroy() {
    this.config = null, this.remainderData = null, this.videoTrack = this.audioTrack = this.id3Track = this.txtTrack = void 0;
  }
}
function Uc(i, e) {
  return ae(i.presentationTime) ? i.presentationTime / i.timeScale : e + i.presentationTimeDelta / i.timeScale;
}
class nb {
  constructor(e, t, n) {
    this.keyData = void 0, this.decrypter = void 0, this.keyData = n, this.decrypter = new El(t, {
      removePKCS7Padding: !1
    });
  }
  decryptBuffer(e) {
    return this.decrypter.decrypt(e, this.keyData.key.buffer, this.keyData.iv.buffer, tn.cbc);
  }
  // AAC - encrypt all full 16 bytes blocks starting from offset 16
  decryptAacSample(e, t, n) {
    const s = e[t].unit;
    if (s.length <= 16)
      return;
    const r = s.subarray(16, s.length - s.length % 16), a = r.buffer.slice(r.byteOffset, r.byteOffset + r.length);
    this.decryptBuffer(a).then((o) => {
      const l = new Uint8Array(o);
      s.set(l, 16), this.decrypter.isSync() || this.decryptAacSamples(e, t + 1, n);
    });
  }
  decryptAacSamples(e, t, n) {
    for (; ; t++) {
      if (t >= e.length) {
        n();
        return;
      }
      if (!(e[t].unit.length < 32) && (this.decryptAacSample(e, t, n), !this.decrypter.isSync()))
        return;
    }
  }
  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
  getAvcEncryptedData(e) {
    const t = Math.floor((e.length - 48) / 160) * 16 + 16, n = new Int8Array(t);
    let s = 0;
    for (let r = 32; r < e.length - 16; r += 160, s += 16)
      n.set(e.subarray(r, r + 16), s);
    return n;
  }
  getAvcDecryptedUnit(e, t) {
    const n = new Uint8Array(t);
    let s = 0;
    for (let r = 32; r < e.length - 16; r += 160, s += 16)
      e.set(n.subarray(s, s + 16), r);
    return e;
  }
  decryptAvcSample(e, t, n, s, r) {
    const a = dh(r.data), o = this.getAvcEncryptedData(a);
    this.decryptBuffer(o.buffer).then((l) => {
      r.data = this.getAvcDecryptedUnit(a, l), this.decrypter.isSync() || this.decryptAvcSamples(e, t, n + 1, s);
    });
  }
  decryptAvcSamples(e, t, n, s) {
    if (e instanceof Uint8Array)
      throw new Error("Cannot decrypt samples of type Uint8Array");
    for (; ; t++, n = 0) {
      if (t >= e.length) {
        s();
        return;
      }
      const r = e[t].units;
      for (; !(n >= r.length); n++) {
        const a = r[n];
        if (!(a.data.length <= 48 || a.type !== 1 && a.type !== 5) && (this.decryptAvcSample(e, t, n, s, a), !this.decrypter.isSync()))
          return;
      }
    }
  }
}
class jh {
  constructor() {
    this.VideoSample = null;
  }
  createVideoSample(e, t, n) {
    return {
      key: e,
      frame: !1,
      pts: t,
      dts: n,
      units: [],
      length: 0
    };
  }
  getLastNalUnit(e) {
    var t;
    let n = this.VideoSample, s;
    if ((!n || n.units.length === 0) && (n = e[e.length - 1]), (t = n) != null && t.units) {
      const r = n.units;
      s = r[r.length - 1];
    }
    return s;
  }
  pushAccessUnit(e, t) {
    if (e.units.length && e.frame) {
      if (e.pts === void 0) {
        const n = t.samples, s = n.length;
        if (s) {
          const r = n[s - 1];
          e.pts = r.pts, e.dts = r.dts;
        } else {
          t.dropped++;
          return;
        }
      }
      t.samples.push(e);
    }
  }
  parseNALu(e, t, n) {
    const s = t.byteLength;
    let r = e.naluState || 0;
    const a = r, o = [];
    let l = 0, d, c, u, f = -1, h = 0;
    for (r === -1 && (f = 0, h = this.getNALuType(t, 0), r = 0, l = 1); l < s; ) {
      if (d = t[l++], !r) {
        r = d ? 0 : 1;
        continue;
      }
      if (r === 1) {
        r = d ? 0 : 2;
        continue;
      }
      if (!d)
        r = 3;
      else if (d === 1) {
        if (c = l - r - 1, f >= 0) {
          const m = {
            data: t.subarray(f, c),
            type: h
          };
          o.push(m);
        } else {
          const m = this.getLastNalUnit(e.samples);
          m && (a && l <= 4 - a && m.state && (m.data = m.data.subarray(0, m.data.byteLength - a)), c > 0 && (m.data = Zt(m.data, t.subarray(0, c)), m.state = 0));
        }
        l < s ? (u = this.getNALuType(t, l), f = l, h = u, r = 0) : r = -1;
      } else
        r = 0;
    }
    if (f >= 0 && r >= 0) {
      const m = {
        data: t.subarray(f, s),
        type: h,
        state: r
      };
      o.push(m);
    }
    if (o.length === 0) {
      const m = this.getLastNalUnit(e.samples);
      m && (m.data = Zt(m.data, t));
    }
    return e.naluState = r, o;
  }
}
class fs {
  constructor(e) {
    this.data = void 0, this.bytesAvailable = void 0, this.word = void 0, this.bitsAvailable = void 0, this.data = e, this.bytesAvailable = e.byteLength, this.word = 0, this.bitsAvailable = 0;
  }
  // ():void
  loadWord() {
    const e = this.data, t = this.bytesAvailable, n = e.byteLength - t, s = new Uint8Array(4), r = Math.min(4, t);
    if (r === 0)
      throw new Error("no bytes available");
    s.set(e.subarray(n, n + r)), this.word = new DataView(s.buffer).getUint32(0), this.bitsAvailable = r * 8, this.bytesAvailable -= r;
  }
  // (count:int):void
  skipBits(e) {
    let t;
    e = Math.min(e, this.bytesAvailable * 8 + this.bitsAvailable), this.bitsAvailable > e ? (this.word <<= e, this.bitsAvailable -= e) : (e -= this.bitsAvailable, t = e >> 3, e -= t << 3, this.bytesAvailable -= t, this.loadWord(), this.word <<= e, this.bitsAvailable -= e);
  }
  // (size:int):uint
  readBits(e) {
    let t = Math.min(this.bitsAvailable, e);
    const n = this.word >>> 32 - t;
    if (e > 32 && Be.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= t, this.bitsAvailable > 0)
      this.word <<= t;
    else if (this.bytesAvailable > 0)
      this.loadWord();
    else
      throw new Error("no bits available");
    return t = e - t, t > 0 && this.bitsAvailable ? n << t | this.readBits(t) : n;
  }
  // ():uint
  skipLZ() {
    let e;
    for (e = 0; e < this.bitsAvailable; ++e)
      if ((this.word & 2147483648 >>> e) !== 0)
        return this.word <<= e, this.bitsAvailable -= e, e;
    return this.loadWord(), e + this.skipLZ();
  }
  // ():void
  skipUEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():void
  skipEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():uint
  readUEG() {
    const e = this.skipLZ();
    return this.readBits(e + 1) - 1;
  }
  // ():int
  readEG() {
    const e = this.readUEG();
    return 1 & e ? 1 + e >>> 1 : -1 * (e >>> 1);
  }
  // Some convenience functions
  // :Boolean
  readBoolean() {
    return this.readBits(1) === 1;
  }
  // ():int
  readUByte() {
    return this.readBits(8);
  }
  // ():int
  readUShort() {
    return this.readBits(16);
  }
  // ():int
  readUInt() {
    return this.readBits(32);
  }
}
class sb extends jh {
  parsePES(e, t, n, s) {
    const r = this.parseNALu(e, n.data, s);
    let a = this.VideoSample, o, l = !1;
    n.data = null, a && r.length && !e.audFound && (this.pushAccessUnit(a, e), a = this.VideoSample = this.createVideoSample(!1, n.pts, n.dts)), r.forEach((d) => {
      var c, u;
      switch (d.type) {
        // NDR
        case 1: {
          let g = !1;
          o = !0;
          const v = d.data;
          if (l && v.length > 4) {
            const p = this.readSliceType(v);
            (p === 2 || p === 4 || p === 7 || p === 9) && (g = !0);
          }
          if (g) {
            var f;
            (f = a) != null && f.frame && !a.key && (this.pushAccessUnit(a, e), a = this.VideoSample = null);
          }
          a || (a = this.VideoSample = this.createVideoSample(!0, n.pts, n.dts)), a.frame = !0, a.key = g;
          break;
        }
        case 5:
          o = !0, (c = a) != null && c.frame && !a.key && (this.pushAccessUnit(a, e), a = this.VideoSample = null), a || (a = this.VideoSample = this.createVideoSample(!0, n.pts, n.dts)), a.key = !0, a.frame = !0;
          break;
        // SEI
        case 6: {
          o = !0, bl(d.data, 1, n.pts, t.samples);
          break;
        }
        case 7: {
          var h, m;
          o = !0, l = !0;
          const g = d.data, v = this.readSPS(g);
          if (!e.sps || e.width !== v.width || e.height !== v.height || ((h = e.pixelRatio) == null ? void 0 : h[0]) !== v.pixelRatio[0] || ((m = e.pixelRatio) == null ? void 0 : m[1]) !== v.pixelRatio[1]) {
            e.width = v.width, e.height = v.height, e.pixelRatio = v.pixelRatio, e.sps = [g];
            const p = g.subarray(1, 4);
            let y = "avc1.";
            for (let b = 0; b < 3; b++) {
              let k = p[b].toString(16);
              k.length < 2 && (k = "0" + k), y += k;
            }
            e.codec = y;
          }
          break;
        }
        // PPS
        case 8:
          o = !0, e.pps = [d.data];
          break;
        // AUD
        case 9:
          o = !0, e.audFound = !0, (u = a) != null && u.frame && (this.pushAccessUnit(a, e), a = null), a || (a = this.VideoSample = this.createVideoSample(!1, n.pts, n.dts));
          break;
        // Filler Data
        case 12:
          o = !0;
          break;
        default:
          o = !1;
          break;
      }
      a && o && a.units.push(d);
    }), s && a && (this.pushAccessUnit(a, e), this.VideoSample = null);
  }
  getNALuType(e, t) {
    return e[t] & 31;
  }
  readSliceType(e) {
    const t = new fs(e);
    return t.readUByte(), t.readUEG(), t.readUEG();
  }
  /**
   * The scaling list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */
  skipScalingList(e, t) {
    let n = 8, s = 8, r;
    for (let a = 0; a < e; a++)
      s !== 0 && (r = t.readEG(), s = (n + r + 256) % 256), n = s === 0 ? n : s;
  }
  /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */
  readSPS(e) {
    const t = new fs(e);
    let n = 0, s = 0, r = 0, a = 0, o, l, d;
    const c = t.readUByte.bind(t), u = t.readBits.bind(t), f = t.readUEG.bind(t), h = t.readBoolean.bind(t), m = t.skipBits.bind(t), g = t.skipEG.bind(t), v = t.skipUEG.bind(t), p = this.skipScalingList.bind(this);
    c();
    const y = c();
    if (u(5), m(3), c(), v(), y === 100 || y === 110 || y === 122 || y === 244 || y === 44 || y === 83 || y === 86 || y === 118 || y === 128) {
      const E = f();
      if (E === 3 && m(1), v(), v(), m(1), h())
        for (l = E !== 3 ? 8 : 12, d = 0; d < l; d++)
          h() && (d < 6 ? p(16, t) : p(64, t));
    }
    v();
    const b = f();
    if (b === 0)
      f();
    else if (b === 1)
      for (m(1), g(), g(), o = f(), d = 0; d < o; d++)
        g();
    v(), m(1);
    const k = f(), T = f(), I = u(1);
    I === 0 && m(1), m(1), h() && (n = f(), s = f(), r = f(), a = f());
    let x = [1, 1];
    if (h() && h())
      switch (c()) {
        case 1:
          x = [1, 1];
          break;
        case 2:
          x = [12, 11];
          break;
        case 3:
          x = [10, 11];
          break;
        case 4:
          x = [16, 11];
          break;
        case 5:
          x = [40, 33];
          break;
        case 6:
          x = [24, 11];
          break;
        case 7:
          x = [20, 11];
          break;
        case 8:
          x = [32, 11];
          break;
        case 9:
          x = [80, 33];
          break;
        case 10:
          x = [18, 11];
          break;
        case 11:
          x = [15, 11];
          break;
        case 12:
          x = [64, 33];
          break;
        case 13:
          x = [160, 99];
          break;
        case 14:
          x = [4, 3];
          break;
        case 15:
          x = [3, 2];
          break;
        case 16:
          x = [2, 1];
          break;
        case 255: {
          x = [c() << 8 | c(), c() << 8 | c()];
          break;
        }
      }
    return {
      width: Math.ceil((k + 1) * 16 - n * 2 - s * 2),
      height: (2 - I) * (T + 1) * 16 - (I ? 2 : 4) * (r + a),
      pixelRatio: x
    };
  }
}
class rb extends jh {
  constructor(...e) {
    super(...e), this.initVPS = null;
  }
  parsePES(e, t, n, s) {
    const r = this.parseNALu(e, n.data, s);
    let a = this.VideoSample, o, l = !1;
    n.data = null, a && r.length && !e.audFound && (this.pushAccessUnit(a, e), a = this.VideoSample = this.createVideoSample(!1, n.pts, n.dts)), r.forEach((d) => {
      var c, u;
      switch (d.type) {
        // NON-IDR, NON RANDOM ACCESS SLICE
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
          a || (a = this.VideoSample = this.createVideoSample(!1, n.pts, n.dts)), a.frame = !0, o = !0;
          break;
        // CRA, BLA (random access picture)
        case 16:
        case 17:
        case 18:
        case 21:
          if (o = !0, l) {
            var f;
            (f = a) != null && f.frame && !a.key && (this.pushAccessUnit(a, e), a = this.VideoSample = null);
          }
          a || (a = this.VideoSample = this.createVideoSample(!0, n.pts, n.dts)), a.key = !0, a.frame = !0;
          break;
        // IDR
        case 19:
        case 20:
          o = !0, (c = a) != null && c.frame && !a.key && (this.pushAccessUnit(a, e), a = this.VideoSample = null), a || (a = this.VideoSample = this.createVideoSample(!0, n.pts, n.dts)), a.key = !0, a.frame = !0;
          break;
        // SEI
        case 39:
          o = !0, bl(
            d.data,
            2,
            // NALu header size
            n.pts,
            t.samples
          );
          break;
        // VPS
        case 32:
          o = !0, e.vps || (typeof e.params != "object" && (e.params = {}), e.params = He(e.params, this.readVPS(d.data)), this.initVPS = d.data), e.vps = [d.data];
          break;
        // SPS
        case 33:
          if (o = !0, l = !0, e.vps !== void 0 && e.vps[0] !== this.initVPS && e.sps !== void 0 && !this.matchSPS(e.sps[0], d.data) && (this.initVPS = e.vps[0], e.sps = e.pps = void 0), !e.sps) {
            const h = this.readSPS(d.data);
            e.width = h.width, e.height = h.height, e.pixelRatio = h.pixelRatio, e.codec = h.codecString, e.sps = [], typeof e.params != "object" && (e.params = {});
            for (const m in h.params)
              e.params[m] = h.params[m];
          }
          this.pushParameterSet(e.sps, d.data, e.vps), a || (a = this.VideoSample = this.createVideoSample(!0, n.pts, n.dts)), a.key = !0;
          break;
        // PPS
        case 34:
          if (o = !0, typeof e.params == "object") {
            if (!e.pps) {
              e.pps = [];
              const h = this.readPPS(d.data);
              for (const m in h)
                e.params[m] = h[m];
            }
            this.pushParameterSet(e.pps, d.data, e.vps);
          }
          break;
        // ACCESS UNIT DELIMITER
        case 35:
          o = !0, e.audFound = !0, (u = a) != null && u.frame && (this.pushAccessUnit(a, e), a = null), a || (a = this.VideoSample = this.createVideoSample(!1, n.pts, n.dts));
          break;
        default:
          o = !1;
          break;
      }
      a && o && a.units.push(d);
    }), s && a && (this.pushAccessUnit(a, e), this.VideoSample = null);
  }
  pushParameterSet(e, t, n) {
    (n && n[0] === this.initVPS || !n && !e.length) && e.push(t);
  }
  getNALuType(e, t) {
    return (e[t] & 126) >>> 1;
  }
  ebsp2rbsp(e) {
    const t = new Uint8Array(e.byteLength);
    let n = 0;
    for (let s = 0; s < e.byteLength; s++)
      s >= 2 && e[s] === 3 && e[s - 1] === 0 && e[s - 2] === 0 || (t[n] = e[s], n++);
    return new Uint8Array(t.buffer, 0, n);
  }
  pushAccessUnit(e, t) {
    super.pushAccessUnit(e, t), this.initVPS && (this.initVPS = null);
  }
  readVPS(e) {
    const t = new fs(e);
    t.readUByte(), t.readUByte(), t.readBits(4), t.skipBits(2), t.readBits(6);
    const n = t.readBits(3), s = t.readBoolean();
    return {
      numTemporalLayers: n + 1,
      temporalIdNested: s
    };
  }
  readSPS(e) {
    const t = new fs(this.ebsp2rbsp(e));
    t.readUByte(), t.readUByte(), t.readBits(4);
    const n = t.readBits(3);
    t.readBoolean();
    const s = t.readBits(2), r = t.readBoolean(), a = t.readBits(5), o = t.readUByte(), l = t.readUByte(), d = t.readUByte(), c = t.readUByte(), u = t.readUByte(), f = t.readUByte(), h = t.readUByte(), m = t.readUByte(), g = t.readUByte(), v = t.readUByte(), p = t.readUByte(), y = [], b = [];
    for (let G = 0; G < n; G++)
      y.push(t.readBoolean()), b.push(t.readBoolean());
    if (n > 0)
      for (let G = n; G < 8; G++)
        t.readBits(2);
    for (let G = 0; G < n; G++)
      y[G] && (t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte()), b[G] && t.readUByte();
    t.readUEG();
    const k = t.readUEG();
    k == 3 && t.skipBits(1);
    const T = t.readUEG(), I = t.readUEG(), x = t.readBoolean();
    let E = 0, R = 0, A = 0, _ = 0;
    x && (E += t.readUEG(), R += t.readUEG(), A += t.readUEG(), _ += t.readUEG());
    const C = t.readUEG(), O = t.readUEG(), V = t.readUEG(), j = t.readBoolean();
    for (let G = j ? 0 : n; G <= n; G++)
      t.skipUEG(), t.skipUEG(), t.skipUEG();
    if (t.skipUEG(), t.skipUEG(), t.skipUEG(), t.skipUEG(), t.skipUEG(), t.skipUEG(), t.readBoolean() && t.readBoolean())
      for (let W = 0; W < 4; W++)
        for (let ne = 0; ne < (W === 3 ? 2 : 6); ne++)
          if (!t.readBoolean())
            t.readUEG();
          else {
            const ee = Math.min(64, 1 << 4 + (W << 1));
            W > 1 && t.readEG();
            for (let Y = 0; Y < ee; Y++)
              t.readEG();
          }
    t.readBoolean(), t.readBoolean(), t.readBoolean() && (t.readUByte(), t.skipUEG(), t.skipUEG(), t.readBoolean());
    const z = t.readUEG();
    let Q = 0;
    for (let G = 0; G < z; G++) {
      let W = !1;
      if (G !== 0 && (W = t.readBoolean()), W) {
        G === z && t.readUEG(), t.readBoolean(), t.readUEG();
        let ne = 0;
        for (let se = 0; se <= Q; se++) {
          const ee = t.readBoolean();
          let Y = !1;
          ee || (Y = t.readBoolean()), (ee || Y) && ne++;
        }
        Q = ne;
      } else {
        const ne = t.readUEG(), se = t.readUEG();
        Q = ne + se;
        for (let ee = 0; ee < ne; ee++)
          t.readUEG(), t.readBoolean();
        for (let ee = 0; ee < se; ee++)
          t.readUEG(), t.readBoolean();
      }
    }
    if (t.readBoolean()) {
      const G = t.readUEG();
      for (let W = 0; W < G; W++) {
        for (let ne = 0; ne < V + 4; ne++)
          t.readBits(1);
        t.readBits(1);
      }
    }
    let Z = 0, te = 1, Ee = 1, De = !0, xe = 1, Ae = 0;
    t.readBoolean(), t.readBoolean();
    let tt = !1;
    if (t.readBoolean()) {
      if (t.readBoolean()) {
        const me = t.readUByte(), re = [1, 12, 10, 16, 40, 24, 20, 32, 80, 18, 15, 64, 160, 4, 3, 2], ue = [1, 11, 11, 11, 33, 11, 11, 11, 33, 11, 11, 33, 99, 3, 2, 1];
        me > 0 && me < 16 ? (te = re[me - 1], Ee = ue[me - 1]) : me === 255 && (te = t.readBits(16), Ee = t.readBits(16));
      }
      if (t.readBoolean() && t.readBoolean(), t.readBoolean() && (t.readBits(3), t.readBoolean(), t.readBoolean() && (t.readUByte(), t.readUByte(), t.readUByte())), t.readBoolean() && (t.readUEG(), t.readUEG()), t.readBoolean(), t.readBoolean(), t.readBoolean(), tt = t.readBoolean(), tt && (t.skipUEG(), t.skipUEG(), t.skipUEG(), t.skipUEG()), t.readBoolean() && (xe = t.readBits(32), Ae = t.readBits(32), t.readBoolean() && t.readUEG(), t.readBoolean())) {
        const ue = t.readBoolean(), Se = t.readBoolean();
        let _e = !1;
        (ue || Se) && (_e = t.readBoolean(), _e && (t.readUByte(), t.readBits(5), t.readBoolean(), t.readBits(5)), t.readBits(4), t.readBits(4), _e && t.readBits(4), t.readBits(5), t.readBits(5), t.readBits(5));
        for (let Ne = 0; Ne <= n; Ne++) {
          De = t.readBoolean();
          const $e = De || t.readBoolean();
          let Tt = !1;
          $e ? t.readEG() : Tt = t.readBoolean();
          const lt = Tt ? 1 : t.readUEG() + 1;
          if (ue)
            for (let dt = 0; dt < lt; dt++)
              t.readUEG(), t.readUEG(), _e && (t.readUEG(), t.readUEG()), t.skipBits(1);
          if (Se)
            for (let dt = 0; dt < lt; dt++)
              t.readUEG(), t.readUEG(), _e && (t.readUEG(), t.readUEG()), t.skipBits(1);
        }
      }
      t.readBoolean() && (t.readBoolean(), t.readBoolean(), t.readBoolean(), Z = t.readUEG());
    }
    let kt = T, gt = I;
    if (x) {
      let G = 1, W = 1;
      k === 1 ? G = W = 2 : k == 2 && (G = 2), kt = T - G * R - G * E, gt = I - W * _ - W * A;
    }
    const Mi = s ? ["A", "B", "C"][s] : "", D = o << 24 | l << 16 | d << 8 | c;
    let M = 0;
    for (let G = 0; G < 32; G++)
      M = (M | (D >> G & 1) << 31 - G) >>> 0;
    let H = M.toString(16);
    return a === 1 && H === "2" && (H = "6"), {
      codecString: `hvc1.${Mi}${a}.${H}.${r ? "H" : "L"}${p}.B0`,
      params: {
        general_tier_flag: r,
        general_profile_idc: a,
        general_profile_space: s,
        general_profile_compatibility_flags: [o, l, d, c],
        general_constraint_indicator_flags: [u, f, h, m, g, v],
        general_level_idc: p,
        bit_depth: C + 8,
        bit_depth_luma_minus8: C,
        bit_depth_chroma_minus8: O,
        min_spatial_segmentation_idc: Z,
        chroma_format_idc: k,
        frame_rate: {
          fixed: De,
          fps: Ae / xe
        }
      },
      width: kt,
      height: gt,
      pixelRatio: [te, Ee]
    };
  }
  readPPS(e) {
    const t = new fs(this.ebsp2rbsp(e));
    t.readUByte(), t.readUByte(), t.skipUEG(), t.skipUEG(), t.skipBits(2), t.skipBits(3), t.skipBits(2), t.skipUEG(), t.skipUEG(), t.skipEG(), t.skipBits(2), t.readBoolean() && t.skipUEG(), t.skipEG(), t.skipEG(), t.skipBits(4);
    const s = t.readBoolean(), r = t.readBoolean();
    let a = 1;
    return r && s ? a = 0 : r ? a = 3 : s && (a = 2), {
      parallelismType: a
    };
  }
  matchSPS(e, t) {
    return String.fromCharCode.apply(null, e).substr(3) === String.fromCharCode.apply(null, t).substr(3);
  }
}
const ct = 188;
class Hi {
  constructor(e, t, n, s) {
    this.logger = void 0, this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.sampleAes = null, this.pmtParsed = !1, this.audioCodec = void 0, this.videoCodec = void 0, this._pmtId = -1, this._videoTrack = void 0, this._audioTrack = void 0, this._id3Track = void 0, this._txtTrack = void 0, this.aacOverFlow = null, this.remainderData = null, this.videoParser = void 0, this.observer = e, this.config = t, this.typeSupported = n, this.logger = s, this.videoParser = null;
  }
  static probe(e, t) {
    const n = Hi.syncOffset(e);
    return n > 0 && t.warn(`MPEG2-TS detected but first sync word found @ offset ${n}`), n !== -1;
  }
  static syncOffset(e) {
    const t = e.length;
    let n = Math.min(ct * 5, t - ct) + 1, s = 0;
    for (; s < n; ) {
      let r = !1, a = -1, o = 0;
      for (let l = s; l < t; l += ct)
        if (e[l] === 71 && (t - l === ct || e[l + ct] === 71)) {
          if (o++, a === -1 && (a = l, a !== 0 && (n = Math.min(a + ct * 99, e.length - ct) + 1)), r || (r = Mo(e, l) === 0), r && o > 1 && (a === 0 && o > 2 || l + ct > n))
            return a;
        } else {
          if (o)
            return -1;
          break;
        }
      s++;
    }
    return -1;
  }
  /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */
  static createTrack(e, t) {
    return {
      container: e === "video" || e === "audio" ? "video/mp2t" : void 0,
      type: e,
      id: sh[e],
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0,
      duration: e === "audio" ? t : void 0
    };
  }
  /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */
  resetInitSegment(e, t, n, s) {
    this.pmtParsed = !1, this._pmtId = -1, this._videoTrack = Hi.createTrack("video"), this._videoTrack.duration = s, this._audioTrack = Hi.createTrack("audio", s), this._id3Track = Hi.createTrack("id3"), this._txtTrack = Hi.createTrack("text"), this._audioTrack.segmentCodec = "aac", this.videoParser = null, this.aacOverFlow = null, this.remainderData = null, this.audioCodec = t, this.videoCodec = n;
  }
  resetTimeStamp() {
  }
  resetContiguity() {
    const {
      _audioTrack: e,
      _videoTrack: t,
      _id3Track: n
    } = this;
    e && (e.pesData = null), t && (t.pesData = null), n && (n.pesData = null), this.aacOverFlow = null, this.remainderData = null;
  }
  demux(e, t, n = !1, s = !1) {
    n || (this.sampleAes = null);
    let r;
    const a = this._videoTrack, o = this._audioTrack, l = this._id3Track, d = this._txtTrack;
    let c = a.pid, u = a.pesData, f = o.pid, h = l.pid, m = o.pesData, g = l.pesData, v = null, p = this.pmtParsed, y = this._pmtId, b = e.length;
    if (this.remainderData && (e = Zt(this.remainderData, e), b = e.length, this.remainderData = null), b < ct && !s)
      return this.remainderData = e, {
        audioTrack: o,
        videoTrack: a,
        id3Track: l,
        textTrack: d
      };
    const k = Math.max(0, Hi.syncOffset(e));
    b -= (b - k) % ct, b < e.byteLength && !s && (this.remainderData = new Uint8Array(e.buffer, b, e.buffer.byteLength - b));
    let T = 0;
    for (let x = k; x < b; x += ct)
      if (e[x] === 71) {
        const E = !!(e[x + 1] & 64), R = Mo(e, x), A = (e[x + 3] & 48) >> 4;
        let _;
        if (A > 1) {
          if (_ = x + 5 + e[x + 4], _ === x + ct)
            continue;
        } else
          _ = x + 4;
        switch (R) {
          case c:
            E && (u && (r = wn(u, this.logger)) && (this.readyVideoParser(a.segmentCodec), this.videoParser !== null && this.videoParser.parsePES(a, d, r, !1)), u = {
              data: [],
              size: 0
            }), u && (u.data.push(e.subarray(_, x + ct)), u.size += x + ct - _);
            break;
          case f:
            if (E) {
              if (m && (r = wn(m, this.logger)))
                switch (o.segmentCodec) {
                  case "aac":
                    this.parseAACPES(o, r);
                    break;
                  case "mp3":
                    this.parseMPEGPES(o, r);
                    break;
                  case "ac3":
                    this.parseAC3PES(o, r);
                    break;
                }
              m = {
                data: [],
                size: 0
              };
            }
            m && (m.data.push(e.subarray(_, x + ct)), m.size += x + ct - _);
            break;
          case h:
            E && (g && (r = wn(g, this.logger)) && this.parseID3PES(l, r), g = {
              data: [],
              size: 0
            }), g && (g.data.push(e.subarray(_, x + ct)), g.size += x + ct - _);
            break;
          case 0:
            E && (_ += e[_] + 1), y = this._pmtId = ab(e, _);
            break;
          case y: {
            E && (_ += e[_] + 1);
            const C = ob(e, _, this.typeSupported, n, this.observer, this.logger);
            c = C.videoPid, c > 0 && (a.pid = c, a.segmentCodec = C.segmentVideoCodec), f = C.audioPid, f > 0 && (o.pid = f, o.segmentCodec = C.segmentAudioCodec), h = C.id3Pid, h > 0 && (l.pid = h), v !== null && !p && (this.logger.warn(`MPEG-TS PMT found at ${x} after unknown PID '${v}'. Backtracking to sync byte @${k} to parse all TS packets.`), v = null, x = k - 188), p = this.pmtParsed = !0;
            break;
          }
          case 17:
          case 8191:
            break;
          default:
            v = R;
            break;
        }
      } else
        T++;
    T > 0 && Oo(this.observer, new Error(`Found ${T} TS packet/s that do not start with 0x47`), void 0, this.logger), a.pesData = u, o.pesData = m, l.pesData = g;
    const I = {
      audioTrack: o,
      videoTrack: a,
      id3Track: l,
      textTrack: d
    };
    return s && this.extractRemainingSamples(I), I;
  }
  flush() {
    const {
      remainderData: e
    } = this;
    this.remainderData = null;
    let t;
    return e ? t = this.demux(e, -1, !1, !0) : t = {
      videoTrack: this._videoTrack,
      audioTrack: this._audioTrack,
      id3Track: this._id3Track,
      textTrack: this._txtTrack
    }, this.extractRemainingSamples(t), this.sampleAes ? this.decrypt(t, this.sampleAes) : t;
  }
  extractRemainingSamples(e) {
    const {
      audioTrack: t,
      videoTrack: n,
      id3Track: s,
      textTrack: r
    } = e, a = n.pesData, o = t.pesData, l = s.pesData;
    let d;
    if (a && (d = wn(a, this.logger)) ? (this.readyVideoParser(n.segmentCodec), this.videoParser !== null && (this.videoParser.parsePES(n, r, d, !0), n.pesData = null)) : n.pesData = a, o && (d = wn(o, this.logger))) {
      switch (t.segmentCodec) {
        case "aac":
          this.parseAACPES(t, d);
          break;
        case "mp3":
          this.parseMPEGPES(t, d);
          break;
        case "ac3":
          this.parseAC3PES(t, d);
          break;
      }
      t.pesData = null;
    } else
      o != null && o.size && this.logger.log("last AAC PES packet truncated,might overlap between fragments"), t.pesData = o;
    l && (d = wn(l, this.logger)) ? (this.parseID3PES(s, d), s.pesData = null) : s.pesData = l;
  }
  demuxSampleAes(e, t, n) {
    const s = this.demux(e, n, !0, !this.config.progressive), r = this.sampleAes = new nb(this.observer, this.config, t);
    return this.decrypt(s, r);
  }
  readyVideoParser(e) {
    this.videoParser === null && (e === "avc" ? this.videoParser = new sb() : e === "hevc" && (this.videoParser = new rb()));
  }
  decrypt(e, t) {
    return new Promise((n) => {
      const {
        audioTrack: s,
        videoTrack: r
      } = e;
      s.samples && s.segmentCodec === "aac" ? t.decryptAacSamples(s.samples, 0, () => {
        r.samples ? t.decryptAvcSamples(r.samples, 0, 0, () => {
          n(e);
        }) : n(e);
      }) : r.samples && t.decryptAvcSamples(r.samples, 0, 0, () => {
        n(e);
      });
    });
  }
  destroy() {
    this.observer && this.observer.removeAllListeners(), this.config = this.logger = this.observer = null, this.aacOverFlow = this.videoParser = this.remainderData = this.sampleAes = null, this._videoTrack = this._audioTrack = this._id3Track = this._txtTrack = void 0;
  }
  parseAACPES(e, t) {
    let n = 0;
    const s = this.aacOverFlow;
    let r = t.data;
    if (s) {
      this.aacOverFlow = null;
      const u = s.missing, f = s.sample.unit.byteLength;
      if (u === -1)
        r = Zt(s.sample.unit, r);
      else {
        const h = f - u;
        s.sample.unit.set(r.subarray(0, u), h), e.samples.push(s.sample), n = s.missing;
      }
    }
    let a, o;
    for (a = n, o = r.length; a < o - 1 && !Fr(r, a); a++)
      ;
    if (a !== n) {
      let u;
      const f = a < o - 1;
      if (f ? u = `AAC PES did not start with ADTS header,offset:${a}` : u = "No ADTS header found in AAC PES", Oo(this.observer, new Error(u), f, this.logger), !f)
        return;
    }
    Mh(e, this.observer, r, a, this.audioCodec);
    let l;
    if (t.pts !== void 0)
      l = t.pts;
    else if (s) {
      const u = Oh(e.samplerate);
      l = s.sample.pts + u;
    } else {
      this.logger.warn("[tsdemuxer]: AAC PES unknown PTS");
      return;
    }
    let d = 0, c;
    for (; a < o; )
      if (c = Fh(e, r, a, l, d), a += c.length, c.missing) {
        this.aacOverFlow = c;
        break;
      } else
        for (d++; a < o - 1 && !Fr(r, a); a++)
          ;
  }
  parseMPEGPES(e, t) {
    const n = t.data, s = n.length;
    let r = 0, a = 0;
    const o = t.pts;
    if (o === void 0) {
      this.logger.warn("[tsdemuxer]: MPEG PES unknown PTS");
      return;
    }
    for (; a < s; )
      if (Gh(n, a)) {
        const l = Uh(e, n, a, o, r);
        if (l)
          a += l.length, r++;
        else
          break;
      } else
        a++;
  }
  parseAC3PES(e, t) {
    {
      const n = t.data, s = t.pts;
      if (s === void 0) {
        this.logger.warn("[tsdemuxer]: AC3 PES unknown PTS");
        return;
      }
      const r = n.length;
      let a = 0, o = 0, l;
      for (; o < r && (l = Kh(e, n, o, s, a++)) > 0; )
        o += l;
    }
  }
  parseID3PES(e, t) {
    if (t.pts === void 0) {
      this.logger.warn("[tsdemuxer]: ID3 PES unknown PTS");
      return;
    }
    const n = He({}, t, {
      type: this._videoTrack ? Bt.emsg : Bt.audioId3,
      duration: Number.POSITIVE_INFINITY
    });
    e.samples.push(n);
  }
}
function Mo(i, e) {
  return ((i[e + 1] & 31) << 8) + i[e + 2];
}
function ab(i, e) {
  return (i[e + 10] & 31) << 8 | i[e + 11];
}
function ob(i, e, t, n, s, r) {
  const a = {
    audioPid: -1,
    videoPid: -1,
    id3Pid: -1,
    segmentVideoCodec: "avc",
    segmentAudioCodec: "aac"
  }, o = (i[e + 1] & 15) << 8 | i[e + 2], l = e + 3 + o - 4, d = (i[e + 10] & 15) << 8 | i[e + 11];
  for (e += 12 + d; e < l; ) {
    const c = Mo(i, e), u = (i[e + 3] & 15) << 8 | i[e + 4];
    switch (i[e]) {
      case 207:
        if (!n) {
          Va("ADTS AAC", r);
          break;
        }
      /* falls through */
      case 15:
        a.audioPid === -1 && (a.audioPid = c);
        break;
      // Packetized metadata (ID3)
      case 21:
        a.id3Pid === -1 && (a.id3Pid = c);
        break;
      case 219:
        if (!n) {
          Va("H.264", r);
          break;
        }
      /* falls through */
      case 27:
        a.videoPid === -1 && (a.videoPid = c);
        break;
      // ISO/IEC 11172-3 (MPEG-1 audio)
      // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
      case 3:
      case 4:
        !t.mpeg && !t.mp3 ? r.log("MPEG audio found, not supported in this browser") : a.audioPid === -1 && (a.audioPid = c, a.segmentAudioCodec = "mp3");
        break;
      case 193:
        if (!n) {
          Va("AC-3", r);
          break;
        }
      /* falls through */
      case 129:
        t.ac3 ? a.audioPid === -1 && (a.audioPid = c, a.segmentAudioCodec = "ac3") : r.log("AC-3 audio found, not supported in this browser");
        break;
      case 6:
        if (a.audioPid === -1 && u > 0) {
          let f = e + 5, h = u;
          for (; h > 2; ) {
            switch (i[f]) {
              case 106:
                t.ac3 !== !0 ? r.log("AC-3 audio found, not supported in this browser for now") : (a.audioPid = c, a.segmentAudioCodec = "ac3");
                break;
            }
            const g = i[f + 1] + 2;
            f += g, h -= g;
          }
        }
        break;
      case 194:
      // SAMPLE-AES EC3
      /* falls through */
      case 135:
        return Oo(s, new Error("Unsupported EC-3 in M2TS found"), void 0, r), a;
      case 36:
        a.videoPid === -1 && (a.videoPid = c, a.segmentVideoCodec = "hevc", r.log("HEVC in M2TS found"));
        break;
    }
    e += u + 5;
  }
  return a;
}
function Oo(i, e, t, n) {
  n.warn(`parsing error: ${e.message}`), i.emit(S.ERROR, S.ERROR, {
    type: pe.MEDIA_ERROR,
    details: B.FRAG_PARSING_ERROR,
    fatal: !1,
    levelRetry: t,
    error: e,
    reason: e.message
  });
}
function Va(i, e) {
  e.log(`${i} with AES-128-CBC encryption found in unencrypted stream`);
}
function wn(i, e) {
  let t = 0, n, s, r, a, o;
  const l = i.data;
  if (!i || i.size === 0)
    return null;
  for (; l[0].length < 19 && l.length > 1; )
    l[0] = Zt(l[0], l[1]), l.splice(1, 1);
  if (n = l[0], (n[0] << 16) + (n[1] << 8) + n[2] === 1) {
    if (s = (n[4] << 8) + n[5], s && s > i.size - 6)
      return null;
    const c = n[7];
    c & 192 && (a = (n[9] & 14) * 536870912 + // 1 << 29
    (n[10] & 255) * 4194304 + // 1 << 22
    (n[11] & 254) * 16384 + // 1 << 14
    (n[12] & 255) * 128 + // 1 << 7
    (n[13] & 254) / 2, c & 64 ? (o = (n[14] & 14) * 536870912 + // 1 << 29
    (n[15] & 255) * 4194304 + // 1 << 22
    (n[16] & 254) * 16384 + // 1 << 14
    (n[17] & 255) * 128 + // 1 << 7
    (n[18] & 254) / 2, a - o > 60 * 9e4 && (e.warn(`${Math.round((a - o) / 9e4)}s delta between PTS and DTS, align them`), a = o)) : o = a), r = n[8];
    let u = r + 9;
    if (i.size <= u)
      return null;
    i.size -= u;
    const f = new Uint8Array(i.size);
    for (let h = 0, m = l.length; h < m; h++) {
      n = l[h];
      let g = n.byteLength;
      if (u)
        if (u > g) {
          u -= g;
          continue;
        } else
          n = n.subarray(u), g -= u, u = 0;
      f.set(n, t), t += g;
    }
    return s && (s -= r + 3), {
      data: f,
      pts: a,
      dts: o,
      len: s
    };
  }
  return null;
}
class lb {
  static getSilentFrame(e, t) {
    switch (e) {
      case "mp4a.40.2":
        if (t === 1)
          return new Uint8Array([0, 200, 0, 128, 35, 128]);
        if (t === 2)
          return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
        if (t === 3)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
        if (t === 4)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
        if (t === 5)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
        if (t === 6)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
        break;
      // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
      default:
        if (t === 1)
          return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 2)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 3)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        break;
    }
  }
}
const Fi = Math.pow(2, 32) - 1;
class $ {
  static init() {
    $.types = {
      avc1: [],
      // codingname
      avcC: [],
      hvc1: [],
      hvcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      ".mp3": [],
      dac3: [],
      "ac-3": [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: [],
      smhd: []
    };
    let e;
    for (e in $.types)
      $.types.hasOwnProperty(e) && ($.types[e] = [e.charCodeAt(0), e.charCodeAt(1), e.charCodeAt(2), e.charCodeAt(3)]);
    const t = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      118,
      105,
      100,
      101,
      // handler_type: 'vide'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      86,
      105,
      100,
      101,
      111,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'VideoHandler'
    ]), n = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      115,
      111,
      117,
      110,
      // handler_type: 'soun'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      83,
      111,
      117,
      110,
      100,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'SoundHandler'
    ]);
    $.HDLR_TYPES = {
      video: t,
      audio: n
    };
    const s = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // entry_count
      0,
      0,
      0,
      12,
      // entry_size
      117,
      114,
      108,
      32,
      // 'url' type
      0,
      // version 0
      0,
      0,
      1
      // entry_flags
    ]), r = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0
      // entry_count
    ]);
    $.STTS = $.STSC = $.STCO = r, $.STSZ = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // sample_size
      0,
      0,
      0,
      0
      // sample_count
    ]), $.VMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      1,
      // flags
      0,
      0,
      // graphicsmode
      0,
      0,
      0,
      0,
      0,
      0
      // opcolor
    ]), $.SMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      // balance
      0,
      0
      // reserved
    ]), $.STSD = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1
    ]);
    const a = new Uint8Array([105, 115, 111, 109]), o = new Uint8Array([97, 118, 99, 49]), l = new Uint8Array([0, 0, 0, 1]);
    $.FTYP = $.box($.types.ftyp, a, l, a, o), $.DINF = $.box($.types.dinf, $.box($.types.dref, s));
  }
  static box(e, ...t) {
    let n = 8, s = t.length;
    const r = s;
    for (; s--; )
      n += t[s].byteLength;
    const a = new Uint8Array(n);
    for (a[0] = n >> 24 & 255, a[1] = n >> 16 & 255, a[2] = n >> 8 & 255, a[3] = n & 255, a.set(e, 4), s = 0, n = 8; s < r; s++)
      a.set(t[s], n), n += t[s].byteLength;
    return a;
  }
  static hdlr(e) {
    return $.box($.types.hdlr, $.HDLR_TYPES[e]);
  }
  static mdat(e) {
    return $.box($.types.mdat, e);
  }
  static mdhd(e, t) {
    t *= e;
    const n = Math.floor(t / (Fi + 1)), s = Math.floor(t % (Fi + 1));
    return $.box($.types.mdhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      n >> 24,
      n >> 16 & 255,
      n >> 8 & 255,
      n & 255,
      s >> 24,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255,
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]));
  }
  static mdia(e) {
    return $.box($.types.mdia, $.mdhd(e.timescale || 0, e.duration || 0), $.hdlr(e.type), $.minf(e));
  }
  static mfhd(e) {
    return $.box($.types.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      e >> 24,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255
      // sequence_number
    ]));
  }
  static minf(e) {
    return e.type === "audio" ? $.box($.types.minf, $.box($.types.smhd, $.SMHD), $.DINF, $.stbl(e)) : $.box($.types.minf, $.box($.types.vmhd, $.VMHD), $.DINF, $.stbl(e));
  }
  static moof(e, t, n) {
    return $.box($.types.moof, $.mfhd(e), $.traf(n, t));
  }
  static moov(e) {
    let t = e.length;
    const n = [];
    for (; t--; )
      n[t] = $.trak(e[t]);
    return $.box.apply(null, [$.types.moov, $.mvhd(e[0].timescale || 0, e[0].duration || 0)].concat(n).concat($.mvex(e)));
  }
  static mvex(e) {
    let t = e.length;
    const n = [];
    for (; t--; )
      n[t] = $.trex(e[t]);
    return $.box.apply(null, [$.types.mvex, ...n]);
  }
  static mvhd(e, t) {
    t *= e;
    const n = Math.floor(t / (Fi + 1)), s = Math.floor(t % (Fi + 1)), r = new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      n >> 24,
      n >> 16 & 255,
      n >> 8 & 255,
      n & 255,
      s >> 24,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255,
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return $.box($.types.mvhd, r);
  }
  static sdtp(e) {
    const t = e.samples || [], n = new Uint8Array(4 + t.length);
    let s, r;
    for (s = 0; s < t.length; s++)
      r = t[s].flags, n[s + 4] = r.dependsOn << 4 | r.isDependedOn << 2 | r.hasRedundancy;
    return $.box($.types.sdtp, n);
  }
  static stbl(e) {
    return $.box($.types.stbl, $.stsd(e), $.box($.types.stts, $.STTS), $.box($.types.stsc, $.STSC), $.box($.types.stsz, $.STSZ), $.box($.types.stco, $.STCO));
  }
  static avc1(e) {
    let t = [], n = [], s, r, a;
    for (s = 0; s < e.sps.length; s++)
      r = e.sps[s], a = r.byteLength, t.push(a >>> 8 & 255), t.push(a & 255), t = t.concat(Array.prototype.slice.call(r));
    for (s = 0; s < e.pps.length; s++)
      r = e.pps[s], a = r.byteLength, n.push(a >>> 8 & 255), n.push(a & 255), n = n.concat(Array.prototype.slice.call(r));
    const o = $.box($.types.avcC, new Uint8Array([
      1,
      // version
      t[3],
      // profile
      t[4],
      // profile compat
      t[5],
      // level
      255,
      // lengthSizeMinusOne, hard-coded to 4 bytes
      224 | e.sps.length
      // 3bit reserved (111) + numOfSequenceParameterSets
    ].concat(t).concat([
      e.pps.length
      // numOfPictureParameterSets
    ]).concat(n))), l = e.width, d = e.height, c = e.pixelRatio[0], u = e.pixelRatio[1];
    return $.box(
      $.types.avc1,
      new Uint8Array([
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        l >> 8 & 255,
        l & 255,
        // width
        d >> 8 & 255,
        d & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        18,
        100,
        97,
        105,
        108,
        // dailymotion/hls.js
        121,
        109,
        111,
        116,
        105,
        111,
        110,
        47,
        104,
        108,
        115,
        46,
        106,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
      ]),
      // pre_defined = -1
      o,
      $.box($.types.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
      ])),
      // avgBitrate
      $.box($.types.pasp, new Uint8Array([
        c >> 24,
        // hSpacing
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        u >> 24,
        // vSpacing
        u >> 16 & 255,
        u >> 8 & 255,
        u & 255
      ]))
    );
  }
  static esds(e) {
    const t = e.config;
    return new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      3,
      // descriptor_type
      25,
      // length
      0,
      1,
      // es_id
      0,
      // stream_priority
      4,
      // descriptor_type
      17,
      // length
      64,
      // codec : mpeg4_audio
      21,
      // stream_type
      0,
      0,
      0,
      // buffer_size
      0,
      0,
      0,
      0,
      // maxBitrate
      0,
      0,
      0,
      0,
      // avgBitrate
      5,
      // descriptor_type
      2,
      // length
      ...t,
      6,
      1,
      2
      // GASpecificConfig)); // length + audio config descriptor
    ]);
  }
  static audioStsd(e) {
    const t = e.samplerate || 0;
    return new Uint8Array([
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      // reserved
      0,
      1,
      // data_reference_index
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      e.channelCount || 0,
      // channelcount
      0,
      16,
      // sampleSize:16bits
      0,
      0,
      0,
      0,
      // reserved2
      t >> 8 & 255,
      t & 255,
      //
      0,
      0
    ]);
  }
  static mp4a(e) {
    return $.box($.types.mp4a, $.audioStsd(e), $.box($.types.esds, $.esds(e)));
  }
  static mp3(e) {
    return $.box($.types[".mp3"], $.audioStsd(e));
  }
  static ac3(e) {
    return $.box($.types["ac-3"], $.audioStsd(e), $.box($.types.dac3, e.config));
  }
  static stsd(e) {
    const {
      segmentCodec: t
    } = e;
    if (e.type === "audio") {
      if (t === "aac")
        return $.box($.types.stsd, $.STSD, $.mp4a(e));
      if (t === "ac3" && e.config)
        return $.box($.types.stsd, $.STSD, $.ac3(e));
      if (t === "mp3" && e.codec === "mp3")
        return $.box($.types.stsd, $.STSD, $.mp3(e));
    } else if (e.pps && e.sps) {
      if (t === "avc")
        return $.box($.types.stsd, $.STSD, $.avc1(e));
      if (t === "hevc" && e.vps)
        return $.box($.types.stsd, $.STSD, $.hvc1(e));
    } else
      throw new Error("video track missing pps or sps");
    throw new Error(`unsupported ${e.type} segment codec (${t}/${e.codec})`);
  }
  static tkhd(e) {
    const t = e.id, n = (e.duration || 0) * (e.timescale || 0), s = e.width || 0, r = e.height || 0, a = Math.floor(n / (Fi + 1)), o = Math.floor(n % (Fi + 1));
    return $.box($.types.tkhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      t >> 24 & 255,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      a >> 24,
      a >> 16 & 255,
      a >> 8 & 255,
      a & 255,
      o >> 24,
      o >> 16 & 255,
      o >> 8 & 255,
      o & 255,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      0,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      s >> 8 & 255,
      s & 255,
      0,
      0,
      // width
      r >> 8 & 255,
      r & 255,
      0,
      0
      // height
    ]));
  }
  static traf(e, t) {
    const n = $.sdtp(e), s = e.id, r = Math.floor(t / (Fi + 1)), a = Math.floor(t % (Fi + 1));
    return $.box(
      $.types.traf,
      $.box($.types.tfhd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        s >> 24,
        s >> 16 & 255,
        s >> 8 & 255,
        s & 255
        // track_ID
      ])),
      $.box($.types.tfdt, new Uint8Array([
        1,
        // version 1
        0,
        0,
        0,
        // flags
        r >> 24,
        r >> 16 & 255,
        r >> 8 & 255,
        r & 255,
        a >> 24,
        a >> 16 & 255,
        a >> 8 & 255,
        a & 255
      ])),
      $.trun(e, n.length + 16 + // tfhd
      20 + // tfdt
      8 + // traf header
      16 + // mfhd
      8 + // moof header
      8),
      // mdat header
      n
    );
  }
  /**
   * Generate a track box.
   * @param track a track definition
   */
  static trak(e) {
    return e.duration = e.duration || 4294967295, $.box($.types.trak, $.tkhd(e), $.mdia(e));
  }
  static trex(e) {
    const t = e.id;
    return $.box($.types.trex, new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      t >> 24,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]));
  }
  static trun(e, t) {
    const n = e.samples || [], s = n.length, r = 12 + 16 * s, a = new Uint8Array(r);
    let o, l, d, c, u, f;
    for (t += 8 + r, a.set([
      e.type === "video" ? 1 : 0,
      // version 1 for video with signed-int sample_composition_time_offset
      0,
      15,
      1,
      // flags
      s >>> 24 & 255,
      s >>> 16 & 255,
      s >>> 8 & 255,
      s & 255,
      // sample_count
      t >>> 24 & 255,
      t >>> 16 & 255,
      t >>> 8 & 255,
      t & 255
      // data_offset
    ], 0), o = 0; o < s; o++)
      l = n[o], d = l.duration, c = l.size, u = l.flags, f = l.cts, a.set([
        d >>> 24 & 255,
        d >>> 16 & 255,
        d >>> 8 & 255,
        d & 255,
        // sample_duration
        c >>> 24 & 255,
        c >>> 16 & 255,
        c >>> 8 & 255,
        c & 255,
        // sample_size
        u.isLeading << 2 | u.dependsOn,
        u.isDependedOn << 6 | u.hasRedundancy << 4 | u.paddingValue << 1 | u.isNonSync,
        u.degradPrio & 61440,
        u.degradPrio & 15,
        // sample_flags
        f >>> 24 & 255,
        f >>> 16 & 255,
        f >>> 8 & 255,
        f & 255
        // sample_composition_time_offset
      ], 12 + 16 * o);
    return $.box($.types.trun, a);
  }
  static initSegment(e) {
    $.types || $.init();
    const t = $.moov(e);
    return Zt($.FTYP, t);
  }
  static hvc1(e) {
    const t = e.params, n = [e.vps, e.sps, e.pps], s = 4, r = new Uint8Array([1, t.general_profile_space << 6 | (t.general_tier_flag ? 32 : 0) | t.general_profile_idc, t.general_profile_compatibility_flags[0], t.general_profile_compatibility_flags[1], t.general_profile_compatibility_flags[2], t.general_profile_compatibility_flags[3], t.general_constraint_indicator_flags[0], t.general_constraint_indicator_flags[1], t.general_constraint_indicator_flags[2], t.general_constraint_indicator_flags[3], t.general_constraint_indicator_flags[4], t.general_constraint_indicator_flags[5], t.general_level_idc, 240 | t.min_spatial_segmentation_idc >> 8, 255 & t.min_spatial_segmentation_idc, 252 | t.parallelismType, 252 | t.chroma_format_idc, 248 | t.bit_depth_luma_minus8, 248 | t.bit_depth_chroma_minus8, 0, parseInt(t.frame_rate.fps), s - 1 | t.temporal_id_nested << 2 | t.num_temporal_layers << 3 | (t.frame_rate.fixed ? 64 : 0), n.length]);
    let a = r.length;
    for (let m = 0; m < n.length; m += 1) {
      a += 3;
      for (let g = 0; g < n[m].length; g += 1)
        a += 2 + n[m][g].length;
    }
    const o = new Uint8Array(a);
    o.set(r, 0), a = r.length;
    const l = n.length - 1;
    for (let m = 0; m < n.length; m += 1) {
      o.set(new Uint8Array([32 + m | (m === l ? 128 : 0), 0, n[m].length]), a), a += 3;
      for (let g = 0; g < n[m].length; g += 1)
        o.set(new Uint8Array([n[m][g].length >> 8, n[m][g].length & 255]), a), a += 2, o.set(n[m][g], a), a += n[m][g].length;
    }
    const d = $.box($.types.hvcC, o), c = e.width, u = e.height, f = e.pixelRatio[0], h = e.pixelRatio[1];
    return $.box(
      $.types.hvc1,
      new Uint8Array([
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        c >> 8 & 255,
        c & 255,
        // width
        u >> 8 & 255,
        u & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        18,
        100,
        97,
        105,
        108,
        // dailymotion/hls.js
        121,
        109,
        111,
        116,
        105,
        111,
        110,
        47,
        104,
        108,
        115,
        46,
        106,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
      ]),
      // pre_defined = -1
      d,
      $.box($.types.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
      ])),
      // avgBitrate
      $.box($.types.pasp, new Uint8Array([
        f >> 24,
        // hSpacing
        f >> 16 & 255,
        f >> 8 & 255,
        f & 255,
        h >> 24,
        // vSpacing
        h >> 16 & 255,
        h >> 8 & 255,
        h & 255
      ]))
    );
  }
}
$.types = void 0;
$.HDLR_TYPES = void 0;
$.STTS = void 0;
$.STSC = void 0;
$.STCO = void 0;
$.STSZ = void 0;
$.VMHD = void 0;
$.SMHD = void 0;
$.STSD = void 0;
$.FTYP = void 0;
$.DINF = void 0;
const Wh = 9e4;
function Nl(i, e, t = 1, n = !1) {
  const s = i * e * t;
  return n ? Math.round(s) : s;
}
function db(i, e, t = 1, n = !1) {
  return Nl(i, e, 1 / t, n);
}
function Jn(i, e = !1) {
  return Nl(i, 1e3, 1 / Wh, e);
}
function cb(i, e = 1) {
  return Nl(i, Wh, 1 / e);
}
const ub = 10 * 1e3, fb = 1024, hb = 1152, mb = 1536;
let Ln = null, Ga = null;
function Vc(i, e, t, n) {
  return {
    duration: e,
    size: t,
    cts: n,
    flags: {
      isLeading: 0,
      isDependedOn: 0,
      hasRedundancy: 0,
      degradPrio: 0,
      dependsOn: i ? 2 : 1,
      isNonSync: i ? 0 : 1
    }
  };
}
class hr extends ni {
  constructor(e, t, n, s) {
    if (super("mp4-remuxer", s), this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.ISGenerated = !1, this._initPTS = null, this._initDTS = null, this.nextVideoTs = null, this.nextAudioTs = null, this.videoSampleDuration = null, this.isAudioContiguous = !1, this.isVideoContiguous = !1, this.videoTrackConfig = void 0, this.observer = e, this.config = t, this.typeSupported = n, this.ISGenerated = !1, Ln === null) {
      const a = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      Ln = a ? parseInt(a[1]) : 0;
    }
    if (Ga === null) {
      const r = navigator.userAgent.match(/Safari\/(\d+)/i);
      Ga = r ? parseInt(r[1]) : 0;
    }
  }
  destroy() {
    this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
  }
  resetTimeStamp(e) {
    this.log("initPTS & initDTS reset"), this._initPTS = this._initDTS = e;
  }
  resetNextTimestamp() {
    this.log("reset next timestamp"), this.isVideoContiguous = !1, this.isAudioContiguous = !1;
  }
  resetInitSegment() {
    this.log("ISGenerated flag reset"), this.ISGenerated = !1, this.videoTrackConfig = void 0;
  }
  getVideoStartPts(e) {
    let t = !1;
    const n = e[0].pts, s = e.reduce((r, a) => {
      let o = a.pts, l = o - r;
      return l < -4294967296 && (t = !0, o = Wt(o, n), l = o - r), l > 0 ? r : o;
    }, n);
    return t && this.debug("PTS rollover detected"), s;
  }
  remux(e, t, n, s, r, a, o, l) {
    let d, c, u, f, h, m, g = r, v = r;
    const p = e.pid > -1, y = t.pid > -1, b = t.samples.length, k = e.samples.length > 0, T = o && b > 0 || b > 1;
    if ((!p || k) && (!y || T) || this.ISGenerated || o) {
      if (this.ISGenerated) {
        var x, E, R, A;
        const V = this.videoTrackConfig;
        (V && (t.width !== V.width || t.height !== V.height || ((x = t.pixelRatio) == null ? void 0 : x[0]) !== ((E = V.pixelRatio) == null ? void 0 : E[0]) || ((R = t.pixelRatio) == null ? void 0 : R[1]) !== ((A = V.pixelRatio) == null ? void 0 : A[1])) || !V && T || this.nextAudioTs === null && k) && this.resetInitSegment();
      }
      this.ISGenerated || (u = this.generateIS(e, t, r, a));
      const _ = this.isVideoContiguous;
      let C = -1, O;
      if (T && (C = pb(t.samples), !_ && this.config.forceKeyFrameOnDiscontinuity))
        if (m = !0, C > 0) {
          this.warn(`Dropped ${C} out of ${b} video samples due to a missing keyframe`);
          const V = this.getVideoStartPts(t.samples);
          t.samples = t.samples.slice(C), t.dropped += C, v += (t.samples[0].pts - V) / t.inputTimeScale, O = v;
        } else C === -1 && (this.warn(`No keyframe found out of ${b} video samples`), m = !1);
      if (this.ISGenerated) {
        if (k && T) {
          const V = this.getVideoStartPts(t.samples), X = (Wt(e.samples[0].pts, V) - V) / t.inputTimeScale;
          g += Math.max(0, X), v += Math.max(0, -X);
        }
        if (k) {
          if (e.samplerate || (this.warn("regenerate InitSegment as audio detected"), u = this.generateIS(e, t, r, a)), c = this.remuxAudio(e, g, this.isAudioContiguous, a, y || T || l === ce.AUDIO ? v : void 0), T) {
            const V = c ? c.endPTS - c.startPTS : 0;
            t.inputTimeScale || (this.warn("regenerate InitSegment as video detected"), u = this.generateIS(e, t, r, a)), d = this.remuxVideo(t, v, _, V);
          }
        } else T && (d = this.remuxVideo(t, v, _, 0));
        d && (d.firstKeyFrame = C, d.independent = C !== -1, d.firstKeyFramePTS = O);
      }
    }
    return this.ISGenerated && this._initPTS && this._initDTS && (n.samples.length && (h = qh(n, r, this._initPTS, this._initDTS)), s.samples.length && (f = Yh(s, r, this._initPTS))), {
      audio: c,
      video: d,
      initSegment: u,
      independent: m,
      text: f,
      id3: h
    };
  }
  generateIS(e, t, n, s) {
    const r = e.samples, a = t.samples, o = this.typeSupported, l = {}, d = this._initPTS;
    let c = !d || s, u = "audio/mp4", f, h, m, g = -1;
    if (c && (f = h = 1 / 0), e.config && r.length) {
      switch (e.timescale = e.samplerate, e.segmentCodec) {
        case "mp3":
          o.mpeg ? (u = "audio/mpeg", e.codec = "") : o.mp3 && (e.codec = "mp3");
          break;
        case "ac3":
          e.codec = "ac-3";
          break;
      }
      l.audio = {
        id: "audio",
        container: u,
        codec: e.codec,
        initSegment: e.segmentCodec === "mp3" && o.mpeg ? new Uint8Array(0) : $.initSegment([e]),
        metadata: {
          channelCount: e.channelCount
        }
      }, c && (g = e.id, m = e.inputTimeScale, !d || m !== d.timescale ? f = h = r[0].pts - Math.round(m * n) : c = !1);
    }
    if (t.sps && t.pps && a.length) {
      if (t.timescale = t.inputTimeScale, l.video = {
        id: "main",
        container: "video/mp4",
        codec: t.codec,
        initSegment: $.initSegment([t]),
        metadata: {
          width: t.width,
          height: t.height
        }
      }, c)
        if (g = t.id, m = t.inputTimeScale, !d || m !== d.timescale) {
          const v = this.getVideoStartPts(a), p = Math.round(m * n);
          h = Math.min(h, Wt(a[0].dts, v) - p), f = Math.min(f, v - p);
        } else
          c = !1;
      this.videoTrackConfig = {
        width: t.width,
        height: t.height,
        pixelRatio: t.pixelRatio
      };
    }
    if (Object.keys(l).length)
      return this.ISGenerated = !0, c ? (d && this.warn(`Timestamps at playlist time: ${s ? "" : "~"}${n} ${f / m} != initPTS: ${d.baseTime / d.timescale} (${d.baseTime}/${d.timescale}) trackId: ${d.trackId}`), this.log(`Found initPTS at playlist time: ${n} offset: ${f / m} (${f}/${m}) trackId: ${g}`), this._initPTS = {
        baseTime: f,
        timescale: m,
        trackId: g
      }, this._initDTS = {
        baseTime: h,
        timescale: m,
        trackId: g
      }) : f = m = void 0, {
        tracks: l,
        initPTS: f,
        timescale: m,
        trackId: g
      };
  }
  remuxVideo(e, t, n, s) {
    const r = e.inputTimeScale, a = e.samples, o = [], l = a.length, d = this._initPTS, c = d.baseTime * r / d.timescale;
    let u = this.nextVideoTs, f = 8, h = this.videoSampleDuration, m, g, v = Number.POSITIVE_INFINITY, p = Number.NEGATIVE_INFINITY, y = !1;
    if (!n || u === null) {
      const Z = c + t * r, te = a[0].pts - Wt(a[0].dts, a[0].pts);
      Ln && u !== null && Math.abs(Z - te - (u + c)) < 15e3 ? n = !0 : u = Z - te - c;
    }
    const b = u + c;
    for (let Z = 0; Z < l; Z++) {
      const te = a[Z];
      te.pts = Wt(te.pts, b), te.dts = Wt(te.dts, b), te.dts < a[Z > 0 ? Z - 1 : Z].dts && (y = !0);
    }
    y && a.sort(function(Z, te) {
      const Ee = Z.dts - te.dts, De = Z.pts - te.pts;
      return Ee || De;
    }), m = a[0].dts, g = a[a.length - 1].dts;
    const k = g - m, T = k ? Math.round(k / (l - 1)) : h || e.inputTimeScale / 30;
    if (n) {
      const Z = m - b, te = Z > T, Ee = Z < -1;
      if ((te || Ee) && (te ? this.warn(`${(e.segmentCodec || "").toUpperCase()}: ${Jn(Z, !0)} ms (${Z}dts) hole between fragments detected at ${t.toFixed(3)}`) : this.warn(`${(e.segmentCodec || "").toUpperCase()}: ${Jn(-Z, !0)} ms (${Z}dts) overlapping between fragments detected at ${t.toFixed(3)}`), !Ee || b >= a[0].pts || Ln)) {
        m = b;
        const De = a[0].pts - Z;
        if (te)
          a[0].dts = m, a[0].pts = De;
        else {
          let xe = !0;
          for (let Ae = 0; Ae < a.length && !(a[Ae].dts > De && xe); Ae++) {
            const tt = a[Ae].pts;
            if (a[Ae].dts -= Z, a[Ae].pts -= Z, Ae < a.length - 1) {
              const it = a[Ae + 1].pts, kt = a[Ae].pts, gt = it <= kt, Mi = it <= tt;
              xe = gt == Mi;
            }
          }
        }
        this.log(`Video: Initial PTS/DTS adjusted: ${Jn(De, !0)}/${Jn(m, !0)}, delta: ${Jn(Z, !0)} ms`);
      }
    }
    m = Math.max(0, m);
    let I = 0, x = 0, E = m;
    for (let Z = 0; Z < l; Z++) {
      const te = a[Z], Ee = te.units, De = Ee.length;
      let xe = 0;
      for (let Ae = 0; Ae < De; Ae++)
        xe += Ee[Ae].data.length;
      x += xe, I += De, te.length = xe, te.dts < E ? (te.dts = E, E += T / 4 | 0 || 1) : E = te.dts, v = Math.min(te.pts, v), p = Math.max(te.pts, p);
    }
    g = a[l - 1].dts;
    const R = x + 4 * I + 8;
    let A;
    try {
      A = new Uint8Array(R);
    } catch (Z) {
      this.observer.emit(S.ERROR, S.ERROR, {
        type: pe.MUX_ERROR,
        details: B.REMUX_ALLOC_ERROR,
        fatal: !1,
        error: Z,
        bytes: R,
        reason: `fail allocating video mdat ${R}`
      });
      return;
    }
    const _ = new DataView(A.buffer);
    _.setUint32(0, R), A.set($.types.mdat, 4);
    let C = !1, O = Number.POSITIVE_INFINITY, V = Number.POSITIVE_INFINITY, j = Number.NEGATIVE_INFINITY, X = Number.NEGATIVE_INFINITY;
    for (let Z = 0; Z < l; Z++) {
      const te = a[Z], Ee = te.units;
      let De = 0;
      for (let tt = 0, it = Ee.length; tt < it; tt++) {
        const kt = Ee[tt], gt = kt.data, Mi = kt.data.byteLength;
        _.setUint32(f, Mi), f += 4, A.set(gt, f), f += Mi, De += 4 + Mi;
      }
      let xe;
      if (Z < l - 1)
        h = a[Z + 1].dts - te.dts, xe = a[Z + 1].pts - te.pts;
      else {
        const tt = this.config, it = Z > 0 ? te.dts - a[Z - 1].dts : T;
        if (xe = Z > 0 ? te.pts - a[Z - 1].pts : T, tt.stretchShortVideoTrack && this.nextAudioTs !== null) {
          const kt = Math.floor(tt.maxBufferHole * r), gt = (s ? v + s * r : this.nextAudioTs + c) - te.pts;
          gt > kt ? (h = gt - it, h < 0 ? h = it : C = !0, this.log(`It is approximately ${gt / 90} ms to the next segment; using duration ${h / 90} ms for the last video frame.`)) : h = it;
        } else
          h = it;
      }
      const Ae = Math.round(te.pts - te.dts);
      O = Math.min(O, h), j = Math.max(j, h), V = Math.min(V, xe), X = Math.max(X, xe), o.push(Vc(te.key, h, De, Ae));
    }
    if (o.length) {
      if (Ln) {
        if (Ln < 70) {
          const Z = o[0].flags;
          Z.dependsOn = 2, Z.isNonSync = 0;
        }
      } else if (Ga && X - V < j - O && T / j < 0.025 && o[0].cts === 0) {
        this.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
        let Z = m;
        for (let te = 0, Ee = o.length; te < Ee; te++) {
          const De = Z + o[te].duration, xe = Z + o[te].cts;
          if (te < Ee - 1) {
            const Ae = De + o[te + 1].cts;
            o[te].duration = Ae - xe;
          } else
            o[te].duration = te ? o[te - 1].duration : T;
          o[te].cts = 0, Z = De;
        }
      }
    }
    h = C || !h ? T : h;
    const q = g + h;
    this.nextVideoTs = u = q - c, this.videoSampleDuration = h, this.isVideoContiguous = !0;
    const oe = {
      data1: $.moof(e.sequenceNumber++, m, He(e, {
        samples: o
      })),
      data2: A,
      startPTS: (v - c) / r,
      endPTS: (p + h - c) / r,
      startDTS: (m - c) / r,
      endDTS: u / r,
      type: "video",
      hasAudio: !1,
      hasVideo: !0,
      nb: o.length,
      dropped: e.dropped
    };
    return e.samples = [], e.dropped = 0, oe;
  }
  getSamplesPerFrame(e) {
    switch (e.segmentCodec) {
      case "mp3":
        return hb;
      case "ac3":
        return mb;
      default:
        return fb;
    }
  }
  remuxAudio(e, t, n, s, r) {
    const a = e.inputTimeScale, o = e.samplerate ? e.samplerate : a, l = a / o, d = this.getSamplesPerFrame(e), c = d * l, u = this._initPTS, f = e.segmentCodec === "mp3" && this.typeSupported.mpeg, h = [], m = r !== void 0;
    let g = e.samples, v = f ? 0 : 8, p = this.nextAudioTs || -1;
    const y = u.baseTime * a / u.timescale, b = y + t * a;
    if (this.isAudioContiguous = n = n || g.length && p > 0 && (s && Math.abs(b - (p + y)) < 9e3 || Math.abs(Wt(g[0].pts, b) - (p + y)) < 20 * c), g.forEach(function(X) {
      X.pts = Wt(X.pts, b);
    }), !n || p < 0) {
      if (g = g.filter((X) => X.pts >= 0), !g.length)
        return;
      r === 0 ? p = 0 : s && !m ? p = Math.max(0, b - y) : p = g[0].pts - y;
    }
    if (e.segmentCodec === "aac") {
      const X = this.config.maxAudioFramesDrift;
      for (let q = 0, z = p + y; q < g.length; q++) {
        const Q = g[q], oe = Q.pts, Z = oe - z, te = Math.abs(1e3 * Z / a);
        if (Z <= -X * c && m)
          q === 0 && (this.warn(`Audio frame @ ${(oe / a).toFixed(3)}s overlaps marker by ${Math.round(1e3 * Z / a)} ms.`), this.nextAudioTs = p = oe - y, z = oe);
        else if (Z >= X * c && te < ub && m) {
          let Ee = Math.round(Z / c);
          for (z = oe - Ee * c; z < 0 && Ee && c; )
            Ee--, z += c;
          q === 0 && (this.nextAudioTs = p = z - y), this.warn(`Injecting ${Ee} audio frames @ ${((z - y) / a).toFixed(3)}s due to ${Math.round(1e3 * Z / a)} ms gap.`);
          for (let De = 0; De < Ee; De++) {
            let xe = lb.getSilentFrame(e.parsedCodec || e.manifestCodec || e.codec, e.channelCount);
            xe || (this.log("Unable to get silent frame for given audio codec; duplicating last frame instead."), xe = Q.unit.subarray()), g.splice(q, 0, {
              unit: xe,
              pts: z
            }), z += c, q++;
          }
        }
        Q.pts = z, z += c;
      }
    }
    let k = null, T = null, I, x = 0, E = g.length;
    for (; E--; )
      x += g[E].unit.byteLength;
    for (let X = 0, q = g.length; X < q; X++) {
      const z = g[X], Q = z.unit;
      let oe = z.pts;
      if (T !== null) {
        const te = h[X - 1];
        te.duration = Math.round((oe - T) / l);
      } else if (n && e.segmentCodec === "aac" && (oe = p + y), k = oe, x > 0) {
        x += v;
        try {
          I = new Uint8Array(x);
        } catch (te) {
          this.observer.emit(S.ERROR, S.ERROR, {
            type: pe.MUX_ERROR,
            details: B.REMUX_ALLOC_ERROR,
            fatal: !1,
            error: te,
            bytes: x,
            reason: `fail allocating audio mdat ${x}`
          });
          return;
        }
        f || (new DataView(I.buffer).setUint32(0, x), I.set($.types.mdat, 4));
      } else
        return;
      I.set(Q, v);
      const Z = Q.byteLength;
      v += Z, h.push(Vc(!0, d, Z, 0)), T = oe;
    }
    const R = h.length;
    if (!R)
      return;
    const A = h[h.length - 1];
    p = T - y, this.nextAudioTs = p + l * A.duration;
    const _ = f ? new Uint8Array(0) : $.moof(e.sequenceNumber++, k / l, He({}, e, {
      samples: h
    }));
    e.samples = [];
    const C = (k - y) / a, O = p / a, j = {
      data1: _,
      data2: I,
      startPTS: C,
      endPTS: O,
      startDTS: C,
      endDTS: O,
      type: "audio",
      hasAudio: !0,
      hasVideo: !1,
      nb: R
    };
    return this.isAudioContiguous = !0, j;
  }
}
function Wt(i, e) {
  let t;
  if (e === null)
    return i;
  for (e < i ? t = -8589934592 : t = 8589934592; Math.abs(i - e) > 4294967296; )
    i += t;
  return i;
}
function pb(i) {
  for (let e = 0; e < i.length; e++)
    if (i[e].key)
      return e;
  return -1;
}
function qh(i, e, t, n) {
  const s = i.samples.length;
  if (!s)
    return;
  const r = i.inputTimeScale;
  for (let o = 0; o < s; o++) {
    const l = i.samples[o];
    l.pts = Wt(l.pts - t.baseTime * r / t.timescale, e * r) / r, l.dts = Wt(l.dts - n.baseTime * r / n.timescale, e * r) / r;
  }
  const a = i.samples;
  return i.samples = [], {
    samples: a
  };
}
function Yh(i, e, t) {
  const n = i.samples.length;
  if (!n)
    return;
  const s = i.inputTimeScale;
  for (let a = 0; a < n; a++) {
    const o = i.samples[a];
    o.pts = Wt(o.pts - t.baseTime * s / t.timescale, e * s) / s;
  }
  i.samples.sort((a, o) => a.pts - o.pts);
  const r = i.samples;
  return i.samples = [], {
    samples: r
  };
}
class gb extends ni {
  constructor(e, t, n, s) {
    super("passthrough-remuxer", s), this.emitInitSegment = !1, this.audioCodec = void 0, this.videoCodec = void 0, this.initData = void 0, this.initPTS = null, this.initTracks = void 0, this.lastEndTime = null, this.isVideoContiguous = !1;
  }
  destroy() {
  }
  resetTimeStamp(e) {
    this.lastEndTime = null;
    const t = this.initPTS;
    t && e && t.baseTime === e.baseTime && t.timescale === e.timescale || (this.initPTS = e);
  }
  resetNextTimestamp() {
    this.isVideoContiguous = !1, this.lastEndTime = null;
  }
  resetInitSegment(e, t, n, s) {
    this.audioCodec = t, this.videoCodec = n, this.generateInitSegment(e, s), this.emitInitSegment = !0;
  }
  generateInitSegment(e, t) {
    let {
      audioCodec: n,
      videoCodec: s
    } = this;
    if (!(e != null && e.byteLength)) {
      this.initTracks = void 0, this.initData = void 0;
      return;
    }
    const {
      audio: r,
      video: a
    } = this.initData = oh(e);
    if (t)
      a1(e, t);
    else {
      const l = r || a;
      l != null && l.encrypted && this.warn(`Init segment with encrypted track with has no key ("${l.codec}")!`);
    }
    r && (n = Gc(r, ze.AUDIO, this)), a && (s = Gc(a, ze.VIDEO, this));
    const o = {};
    r && a ? o.audiovideo = {
      container: "video/mp4",
      codec: n + "," + s,
      supplemental: a.supplemental,
      encrypted: a.encrypted,
      initSegment: e,
      id: "main"
    } : r ? o.audio = {
      container: "audio/mp4",
      codec: n,
      encrypted: r.encrypted,
      initSegment: e,
      id: "audio"
    } : a ? o.video = {
      container: "video/mp4",
      codec: s,
      supplemental: a.supplemental,
      encrypted: a.encrypted,
      initSegment: e,
      id: "main"
    } : this.warn("initSegment does not contain moov or trak boxes."), this.initTracks = o;
  }
  remux(e, t, n, s, r, a) {
    var o, l;
    let {
      initPTS: d,
      lastEndTime: c
    } = this;
    const u = {
      audio: void 0,
      video: void 0,
      text: s,
      id3: n,
      initSegment: void 0
    };
    ae(c) || (c = this.lastEndTime = r || 0);
    const f = t.samples;
    if (!f.length)
      return u;
    const h = {
      initPTS: void 0,
      timescale: void 0,
      trackId: void 0
    };
    let m = this.initData;
    if ((o = m) != null && o.length || (this.generateInitSegment(f), m = this.initData), !((l = m) != null && l.length))
      return this.warn("Failed to generate initSegment."), u;
    this.emitInitSegment && (h.tracks = this.initTracks, this.emitInitSegment = !1);
    const g = o1(f, m, this), v = m.audio ? g[m.audio.id] : null, p = m.video ? g[m.video.id] : null, y = Xs(p, 1 / 0), b = Xs(v, 1 / 0), k = Xs(p, 0, !0), T = Xs(v, 0, !0);
    let I = r, x = 0;
    const E = v && (!p || !d && b < y || d && d.trackId === m.audio.id), R = E ? v : p;
    if (R) {
      const z = R.timescale, Q = R.start - r * z, oe = E ? m.audio.id : m.video.id;
      I = R.start / z, x = E ? T - b : k - y, (a || !d) && (vb(d, I, r, x) || z !== d.timescale) && (d && this.warn(`Timestamps at playlist time: ${a ? "" : "~"}${r} ${Q / z} != initPTS: ${d.baseTime / d.timescale} (${d.baseTime}/${d.timescale}) trackId: ${d.trackId}`), this.log(`Found initPTS at playlist time: ${r} offset: ${I - r} (${Q}/${z}) trackId: ${oe}`), d = null, h.initPTS = Q, h.timescale = z, h.trackId = oe);
    } else
      this.warn(`No audio or video samples found for initPTS at playlist time: ${r}`);
    d ? (h.initPTS = d.baseTime, h.timescale = d.timescale, h.trackId = d.trackId) : ((!h.timescale || h.trackId === void 0 || h.initPTS === void 0) && (this.warn("Could not set initPTS"), h.initPTS = I, h.timescale = 1, h.trackId = -1), this.initPTS = d = {
      baseTime: h.initPTS,
      timescale: h.timescale,
      trackId: h.trackId
    });
    const A = I - d.baseTime / d.timescale, _ = A + x;
    x > 0 ? this.lastEndTime = _ : (this.warn("Duration parsed from mp4 should be greater than zero"), this.resetNextTimestamp());
    const C = !!m.audio, O = !!m.video;
    let V = "";
    C && (V += "audio"), O && (V += "video");
    const j = (m.audio ? m.audio.encrypted : !1) || (m.video ? m.video.encrypted : !1), X = {
      data1: f,
      startPTS: A,
      startDTS: A,
      endPTS: _,
      endDTS: _,
      type: V,
      hasAudio: C,
      hasVideo: O,
      nb: 1,
      dropped: 0,
      encrypted: j
    };
    u.audio = C && !O ? X : void 0, u.video = O ? X : void 0;
    const q = p?.sampleCount;
    if (q) {
      const z = p.keyFrameIndex, Q = z !== -1;
      X.nb = q, X.dropped = z === 0 || this.isVideoContiguous ? 0 : Q ? z : q, X.independent = Q, X.firstKeyFrame = z, Q && p.keyFrameStart && (X.firstKeyFramePTS = (p.keyFrameStart - d.baseTime) / d.timescale), this.isVideoContiguous || (u.independent = Q), this.isVideoContiguous || (this.isVideoContiguous = Q), X.dropped && this.warn(`fmp4 does not start with IDR: firstIDR ${z}/${q} dropped: ${X.dropped} start: ${X.firstKeyFramePTS || "NA"}`);
    }
    return u.initSegment = h, u.id3 = qh(n, r, d, d), s.samples.length && (u.text = Yh(s, r, d)), u;
  }
}
function Xs(i, e, t = !1) {
  return i?.start !== void 0 ? (i.start + (t ? i.duration : 0)) / i.timescale : e;
}
function vb(i, e, t, n) {
  if (i === null)
    return !0;
  const s = Math.max(n, 1), r = e - i.baseTime / i.timescale;
  return Math.abs(r - t) > s;
}
function Gc(i, e, t) {
  const n = i.codec;
  return n && n.length > 4 ? n : e === ze.AUDIO ? n === "ec-3" || n === "ac-3" || n === "alac" ? n : n === "fLaC" || n === "Opus" ? Cr(n, !1) : (t.warn(`Unhandled audio codec "${n}" in mp4 MAP`), n || "mp4a") : (t.warn(`Unhandled video codec "${n}" in mp4 MAP`), n || "avc1");
}
let Ii;
try {
  Ii = self.performance.now.bind(self.performance);
} catch {
  Ii = Date.now;
}
const mr = [{
  demux: ib,
  remux: gb
}, {
  demux: Hi,
  remux: hr
}, {
  demux: Qy,
  remux: hr
}, {
  demux: eb,
  remux: hr
}];
mr.splice(2, 0, {
  demux: Jy,
  remux: hr
});
class Hc {
  constructor(e, t, n, s, r, a) {
    this.asyncResult = !1, this.logger = void 0, this.observer = void 0, this.typeSupported = void 0, this.config = void 0, this.id = void 0, this.demuxer = void 0, this.remuxer = void 0, this.decrypter = void 0, this.probe = void 0, this.decryptionPromise = null, this.transmuxConfig = void 0, this.currentTransmuxState = void 0, this.observer = e, this.typeSupported = t, this.config = n, this.id = r, this.logger = a;
  }
  configure(e) {
    this.transmuxConfig = e, this.decrypter && this.decrypter.reset();
  }
  push(e, t, n, s) {
    const r = n.transmuxing;
    r.executeStart = Ii();
    let a = new Uint8Array(e);
    const {
      currentTransmuxState: o,
      transmuxConfig: l
    } = this;
    s && (this.currentTransmuxState = s);
    const {
      contiguous: d,
      discontinuity: c,
      trackSwitch: u,
      accurateTimeOffset: f,
      timeOffset: h,
      initSegmentChange: m
    } = s || o, {
      audioCodec: g,
      videoCodec: v,
      defaultInitPts: p,
      duration: y,
      initSegmentData: b
    } = l, k = yb(a, t);
    if (k && Un(k.method)) {
      const E = this.getDecrypter(), R = _l(k.method);
      if (E.isSync()) {
        let A = E.softwareDecrypt(a, k.key.buffer, k.iv.buffer, R);
        if (n.part > -1) {
          const C = E.flush();
          A = C && C.buffer;
        }
        if (!A)
          return r.executeEnd = Ii(), Ha(n);
        a = new Uint8Array(A);
      } else
        return this.asyncResult = !0, this.decryptionPromise = E.webCryptoDecrypt(a, k.key.buffer, k.iv.buffer, R).then((A) => {
          const _ = this.push(A, null, n);
          return this.decryptionPromise = null, _;
        }), this.decryptionPromise;
    }
    const T = this.needsProbing(c, u);
    if (T) {
      const E = this.configureTransmuxer(a);
      if (E)
        return this.logger.warn(`[transmuxer] ${E.message}`), this.observer.emit(S.ERROR, S.ERROR, {
          type: pe.MEDIA_ERROR,
          details: B.FRAG_PARSING_ERROR,
          fatal: !1,
          error: E,
          reason: E.message
        }), r.executeEnd = Ii(), Ha(n);
    }
    (c || u || m || T) && this.resetInitSegment(b, g, v, y, t), (c || m || T) && this.resetInitialTimestamp(p), d || this.resetContiguity();
    const I = this.transmux(a, k, h, f, n);
    this.asyncResult = Cs(I);
    const x = this.currentTransmuxState;
    return x.contiguous = !0, x.discontinuity = !1, x.trackSwitch = !1, r.executeEnd = Ii(), I;
  }
  // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
  flush(e) {
    const t = e.transmuxing;
    t.executeStart = Ii();
    const {
      decrypter: n,
      currentTransmuxState: s,
      decryptionPromise: r
    } = this;
    if (r)
      return this.asyncResult = !0, r.then(() => this.flush(e));
    const a = [], {
      timeOffset: o
    } = s;
    if (n) {
      const u = n.flush();
      u && a.push(this.push(u.buffer, null, e));
    }
    const {
      demuxer: l,
      remuxer: d
    } = this;
    if (!l || !d) {
      t.executeEnd = Ii();
      const u = [Ha(e)];
      return this.asyncResult ? Promise.resolve(u) : u;
    }
    const c = l.flush(o);
    return Cs(c) ? (this.asyncResult = !0, c.then((u) => (this.flushRemux(a, u, e), a))) : (this.flushRemux(a, c, e), this.asyncResult ? Promise.resolve(a) : a);
  }
  flushRemux(e, t, n) {
    const {
      audioTrack: s,
      videoTrack: r,
      id3Track: a,
      textTrack: o
    } = t, {
      accurateTimeOffset: l,
      timeOffset: d
    } = this.currentTransmuxState;
    this.logger.log(`[transmuxer.ts]: Flushed ${this.id} sn: ${n.sn}${n.part > -1 ? " part: " + n.part : ""} of ${this.id === ce.MAIN ? "level" : "track"} ${n.level}`);
    const c = this.remuxer.remux(s, r, a, o, d, l, !0, this.id);
    e.push({
      remuxResult: c,
      chunkMeta: n
    }), n.transmuxing.executeEnd = Ii();
  }
  resetInitialTimestamp(e) {
    const {
      demuxer: t,
      remuxer: n
    } = this;
    !t || !n || (t.resetTimeStamp(e), n.resetTimeStamp(e));
  }
  resetContiguity() {
    const {
      demuxer: e,
      remuxer: t
    } = this;
    !e || !t || (e.resetContiguity(), t.resetNextTimestamp());
  }
  resetInitSegment(e, t, n, s, r) {
    const {
      demuxer: a,
      remuxer: o
    } = this;
    !a || !o || (a.resetInitSegment(e, t, n, s), o.resetInitSegment(e, t, n, r));
  }
  destroy() {
    this.demuxer && (this.demuxer.destroy(), this.demuxer = void 0), this.remuxer && (this.remuxer.destroy(), this.remuxer = void 0);
  }
  transmux(e, t, n, s, r) {
    let a;
    return t && t.method === "SAMPLE-AES" ? a = this.transmuxSampleAes(e, t, n, s, r) : a = this.transmuxUnencrypted(e, n, s, r), a;
  }
  transmuxUnencrypted(e, t, n, s) {
    const {
      audioTrack: r,
      videoTrack: a,
      id3Track: o,
      textTrack: l
    } = this.demuxer.demux(e, t, !1, !this.config.progressive);
    return {
      remuxResult: this.remuxer.remux(r, a, o, l, t, n, !1, this.id),
      chunkMeta: s
    };
  }
  transmuxSampleAes(e, t, n, s, r) {
    return this.demuxer.demuxSampleAes(e, t, n).then((a) => ({
      remuxResult: this.remuxer.remux(a.audioTrack, a.videoTrack, a.id3Track, a.textTrack, n, s, !1, this.id),
      chunkMeta: r
    }));
  }
  configureTransmuxer(e) {
    const {
      config: t,
      observer: n,
      typeSupported: s
    } = this;
    let r;
    for (let u = 0, f = mr.length; u < f; u++) {
      var a;
      if ((a = mr[u].demux) != null && a.probe(e, this.logger)) {
        r = mr[u];
        break;
      }
    }
    if (!r)
      return new Error("Failed to find demuxer by probing fragment data");
    const o = this.demuxer, l = this.remuxer, d = r.remux, c = r.demux;
    (!l || !(l instanceof d)) && (this.remuxer = new d(n, t, s, this.logger)), (!o || !(o instanceof c)) && (this.demuxer = new c(n, t, s, this.logger), this.probe = c.probe);
  }
  needsProbing(e, t) {
    return !this.demuxer || !this.remuxer || e || t;
  }
  getDecrypter() {
    let e = this.decrypter;
    return e || (e = this.decrypter = new El(this.config)), e;
  }
}
function yb(i, e) {
  let t = null;
  return i.byteLength > 0 && e?.key != null && e.iv !== null && e.method != null && (t = e), t;
}
const Ha = (i) => ({
  remuxResult: {},
  chunkMeta: i
});
function Cs(i) {
  return "then" in i && i.then instanceof Function;
}
class bb {
  constructor(e, t, n, s, r) {
    this.audioCodec = void 0, this.videoCodec = void 0, this.initSegmentData = void 0, this.duration = void 0, this.defaultInitPts = void 0, this.audioCodec = e, this.videoCodec = t, this.initSegmentData = n, this.duration = s, this.defaultInitPts = r || null;
  }
}
class Sb {
  constructor(e, t, n, s, r, a) {
    this.discontinuity = void 0, this.contiguous = void 0, this.accurateTimeOffset = void 0, this.trackSwitch = void 0, this.timeOffset = void 0, this.initSegmentChange = void 0, this.discontinuity = e, this.contiguous = t, this.accurateTimeOffset = n, this.trackSwitch = s, this.timeOffset = r, this.initSegmentChange = a;
  }
}
let zc = 0;
class Xh {
  constructor(e, t, n, s) {
    this.error = null, this.hls = void 0, this.id = void 0, this.instanceNo = zc++, this.observer = void 0, this.frag = null, this.part = null, this.useWorker = void 0, this.workerContext = null, this.transmuxer = null, this.onTransmuxComplete = void 0, this.onFlush = void 0, this.onWorkerMessage = (l) => {
      const d = l.data, c = this.hls;
      if (!(!c || !(d != null && d.event) || d.instanceNo !== this.instanceNo))
        switch (d.event) {
          case "init": {
            var u;
            const f = (u = this.workerContext) == null ? void 0 : u.objectURL;
            f && self.URL.revokeObjectURL(f);
            break;
          }
          case "transmuxComplete": {
            this.handleTransmuxComplete(d.data);
            break;
          }
          case "flush": {
            this.onFlush(d.data);
            break;
          }
          // pass logs from the worker thread to the main logger
          case "workerLog": {
            c.logger[d.data.logType] && c.logger[d.data.logType](d.data.message);
            break;
          }
          default: {
            d.data = d.data || {}, d.data.frag = this.frag, d.data.part = this.part, d.data.id = this.id, c.trigger(d.event, d.data);
            break;
          }
        }
    }, this.onWorkerError = (l) => {
      if (!this.hls)
        return;
      const d = new Error(`${l.message}  (${l.filename}:${l.lineno})`);
      this.hls.config.enableWorker = !1, this.hls.logger.warn(`Error in "${this.id}" Web Worker, fallback to inline`), this.hls.trigger(S.ERROR, {
        type: pe.OTHER_ERROR,
        details: B.INTERNAL_EXCEPTION,
        fatal: !1,
        event: "demuxerWorker",
        error: d
      });
    };
    const r = e.config;
    this.hls = e, this.id = t, this.useWorker = !!r.enableWorker, this.onTransmuxComplete = n, this.onFlush = s;
    const a = (l, d) => {
      d = d || {}, d.frag = this.frag || void 0, l === S.ERROR && (d = d, d.parent = this.id, d.part = this.part, this.error = d.error), this.hls.trigger(l, d);
    };
    this.observer = new Ll(), this.observer.on(S.FRAG_DECRYPTED, a), this.observer.on(S.ERROR, a);
    const o = lc(r.preferManagedMediaSource);
    if (this.useWorker && typeof Worker < "u") {
      const l = this.hls.logger;
      if (r.workerPath || xy()) {
        try {
          r.workerPath ? (l.log(`loading Web Worker ${r.workerPath} for "${t}"`), this.workerContext = Ay(r.workerPath)) : (l.log(`injecting Web Worker for "${t}"`), this.workerContext = _y());
          const {
            worker: c
          } = this.workerContext;
          c.addEventListener("message", this.onWorkerMessage), c.addEventListener("error", this.onWorkerError), c.postMessage({
            instanceNo: this.instanceNo,
            cmd: "init",
            typeSupported: o,
            id: t,
            config: qe(r)
          });
        } catch (c) {
          l.warn(`Error setting up "${t}" Web Worker, fallback to inline`, c), this.terminateWorker(), this.error = null, this.transmuxer = new Hc(this.observer, o, r, "", t, e.logger);
        }
        return;
      }
    }
    this.transmuxer = new Hc(this.observer, o, r, "", t, e.logger);
  }
  reset() {
    if (this.frag = null, this.part = null, this.workerContext) {
      const e = this.instanceNo;
      this.instanceNo = zc++;
      const t = this.hls.config, n = lc(t.preferManagedMediaSource);
      this.workerContext.worker.postMessage({
        instanceNo: this.instanceNo,
        cmd: "reset",
        resetNo: e,
        typeSupported: n,
        id: this.id,
        config: qe(t)
      });
    }
  }
  terminateWorker() {
    if (this.workerContext) {
      const {
        worker: e
      } = this.workerContext;
      this.workerContext = null, e.removeEventListener("message", this.onWorkerMessage), e.removeEventListener("error", this.onWorkerError), wy(this.hls.config.workerPath);
    }
  }
  destroy() {
    if (this.workerContext)
      this.terminateWorker(), this.onWorkerMessage = this.onWorkerError = null;
    else {
      const t = this.transmuxer;
      t && (t.destroy(), this.transmuxer = null);
    }
    const e = this.observer;
    e && e.removeAllListeners(), this.frag = null, this.part = null, this.observer = null, this.hls = null;
  }
  push(e, t, n, s, r, a, o, l, d, c) {
    var u, f;
    d.transmuxing.start = self.performance.now();
    const {
      instanceNo: h,
      transmuxer: m
    } = this, g = a ? a.start : r.start, v = r.decryptdata, p = this.frag, y = !(p && r.cc === p.cc), b = !(p && d.level === p.level), k = p ? d.sn - p.sn : -1, T = this.part ? d.part - this.part.index : -1, I = k === 0 && d.id > 1 && d.id === p?.stats.chunkCount, x = !b && (k === 1 || k === 0 && (T === 1 || I && T <= 0)), E = self.performance.now();
    (b || k || r.stats.parsing.start === 0) && (r.stats.parsing.start = E), a && (T || !x) && (a.stats.parsing.start = E);
    const R = !(p && ((u = r.initSegment) == null ? void 0 : u.url) === ((f = p.initSegment) == null ? void 0 : f.url)), A = new Sb(y, x, l, b, g, R);
    if (!x || y || R) {
      this.hls.logger.log(`[transmuxer-interface]: Starting new transmux session for ${r.type} sn: ${d.sn}${d.part > -1 ? " part: " + d.part : ""} ${this.id === ce.MAIN ? "level" : "track"}: ${d.level} id: ${d.id}
        discontinuity: ${y}
        trackSwitch: ${b}
        contiguous: ${x}
        accurateTimeOffset: ${l}
        timeOffset: ${g}
        initSegmentChange: ${R}`);
      const _ = new bb(n, s, t, o, c);
      this.configureTransmuxer(_);
    }
    if (this.frag = r, this.part = a, this.workerContext)
      this.workerContext.worker.postMessage({
        instanceNo: h,
        cmd: "demux",
        data: e,
        decryptdata: v,
        chunkMeta: d,
        state: A
      }, e instanceof ArrayBuffer ? [e] : []);
    else if (m) {
      const _ = m.push(e, v, d, A);
      Cs(_) ? _.then((C) => {
        this.handleTransmuxComplete(C);
      }).catch((C) => {
        this.transmuxerError(C, d, "transmuxer-interface push error");
      }) : this.handleTransmuxComplete(_);
    }
  }
  flush(e) {
    e.transmuxing.start = self.performance.now();
    const {
      instanceNo: t,
      transmuxer: n
    } = this;
    if (this.workerContext)
      this.workerContext.worker.postMessage({
        instanceNo: t,
        cmd: "flush",
        chunkMeta: e
      });
    else if (n) {
      const s = n.flush(e);
      Cs(s) ? s.then((r) => {
        this.handleFlushResult(r, e);
      }).catch((r) => {
        this.transmuxerError(r, e, "transmuxer-interface flush error");
      }) : this.handleFlushResult(s, e);
    }
  }
  transmuxerError(e, t, n) {
    this.hls && (this.error = e, this.hls.trigger(S.ERROR, {
      type: pe.MEDIA_ERROR,
      details: B.FRAG_PARSING_ERROR,
      chunkMeta: t,
      frag: this.frag || void 0,
      part: this.part || void 0,
      fatal: !1,
      error: e,
      err: e,
      reason: n
    }));
  }
  handleFlushResult(e, t) {
    e.forEach((n) => {
      this.handleTransmuxComplete(n);
    }), this.onFlush(t);
  }
  configureTransmuxer(e) {
    const {
      instanceNo: t,
      transmuxer: n
    } = this;
    this.workerContext ? this.workerContext.worker.postMessage({
      instanceNo: t,
      cmd: "configure",
      config: e
    }) : n && n.configure(e);
  }
  handleTransmuxComplete(e) {
    e.chunkMeta.transmuxing.end = self.performance.now(), this.onTransmuxComplete(e);
  }
}
const Kc = 100;
class kb extends wl {
  constructor(e, t, n) {
    super(e, t, n, "audio-stream-controller", ce.AUDIO), this.mainAnchor = null, this.mainFragLoading = null, this.audioOnly = !1, this.bufferedTrack = null, this.switchingTrack = null, this.trackId = -1, this.waitingData = null, this.mainDetails = null, this.flushing = !1, this.bufferFlushed = !1, this.cachedTrackLoadedData = null, this.registerListeners();
  }
  onHandlerDestroying() {
    this.unregisterListeners(), super.onHandlerDestroying(), this.resetItem();
  }
  resetItem() {
    this.mainDetails = this.mainAnchor = this.mainFragLoading = this.bufferedTrack = this.switchingTrack = this.waitingData = this.cachedTrackLoadedData = null;
  }
  registerListeners() {
    super.registerListeners();
    const {
      hls: e
    } = this;
    e.on(S.LEVEL_LOADED, this.onLevelLoaded, this), e.on(S.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.on(S.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(S.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(S.BUFFER_RESET, this.onBufferReset, this), e.on(S.BUFFER_CREATED, this.onBufferCreated, this), e.on(S.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(S.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(S.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(S.FRAG_LOADING, this.onFragLoading, this), e.on(S.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (super.unregisterListeners(), e.off(S.LEVEL_LOADED, this.onLevelLoaded, this), e.off(S.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.off(S.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(S.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(S.BUFFER_RESET, this.onBufferReset, this), e.off(S.BUFFER_CREATED, this.onBufferCreated, this), e.off(S.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(S.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(S.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(S.FRAG_LOADING, this.onFragLoading, this), e.off(S.FRAG_BUFFERED, this.onFragBuffered, this));
  }
  // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
  onInitPtsFound(e, {
    frag: t,
    id: n,
    initPTS: s,
    timescale: r,
    trackId: a
  }) {
    if (n === ce.MAIN) {
      const o = t.cc, l = this.fragCurrent;
      if (this.initPTS[o] = {
        baseTime: s,
        timescale: r,
        trackId: a
      }, this.log(`InitPTS for cc: ${o} found from main: ${s / r} (${s}/${r}) trackId: ${a}`), this.mainAnchor = t, this.state === K.WAITING_INIT_PTS) {
        const d = this.waitingData;
        (!d && !this.loadingParts || d && d.frag.cc !== o) && this.syncWithAnchor(t, d?.frag);
      } else !this.hls.hasEnoughToStart && l && l.cc !== o ? (l.abortRequests(), this.syncWithAnchor(t, l)) : this.state === K.IDLE && this.tick();
    }
  }
  getLoadPosition() {
    return !this.startFragRequested && this.nextLoadPosition >= 0 ? this.nextLoadPosition : super.getLoadPosition();
  }
  syncWithAnchor(e, t) {
    var n;
    const s = ((n = this.mainFragLoading) == null ? void 0 : n.frag) || null;
    if (t && s?.cc === t.cc)
      return;
    const r = (s || e).cc, a = this.getLevelDetails(), o = this.getLoadPosition(), l = vh(a, r, o);
    l && (this.log(`Syncing with main frag at ${l.start} cc ${l.cc}`), this.startFragRequested = !1, this.nextLoadPosition = l.start, this.resetLoadingState(), this.state === K.IDLE && this.doTickIdle());
  }
  startLoad(e, t) {
    if (!this.levels) {
      this.startPosition = e, this.state = K.STOPPED;
      return;
    }
    const n = this.lastCurrentTime;
    this.stopLoad(), this.setInterval(Kc), n > 0 && e === -1 ? (this.log(`Override startPosition with lastCurrentTime @${n.toFixed(3)}`), e = n, this.state = K.IDLE) : this.state = K.WAITING_TRACK, this.nextLoadPosition = this.lastCurrentTime = e + this.timelineOffset, this.startPosition = t ? -1 : e, this.tick();
  }
  doTick() {
    switch (this.state) {
      case K.IDLE:
        this.doTickIdle();
        break;
      case K.WAITING_TRACK: {
        const {
          levels: t,
          trackId: n
        } = this, s = t?.[n], r = s?.details;
        if (r && !this.waitForLive(s)) {
          if (this.waitForCdnTuneIn(r))
            break;
          this.state = K.WAITING_INIT_PTS;
        }
        break;
      }
      case K.FRAG_LOADING_WAITING_RETRY: {
        var e;
        const t = performance.now(), n = this.retryDate;
        if (!n || t >= n || (e = this.media) != null && e.seeking) {
          const {
            levels: s,
            trackId: r
          } = this;
          this.log("RetryDate reached, switch back to IDLE state"), this.resetStartWhenNotLoaded(s?.[r] || null), this.state = K.IDLE;
        }
        break;
      }
      case K.WAITING_INIT_PTS: {
        const t = this.waitingData;
        if (t) {
          const {
            frag: n,
            part: s,
            cache: r,
            complete: a
          } = t, o = this.mainAnchor;
          if (this.initPTS[n.cc] !== void 0) {
            this.waitingData = null, this.state = K.FRAG_LOADING;
            const l = r.flush().buffer, d = {
              frag: n,
              part: s,
              payload: l,
              networkDetails: null
            };
            this._handleFragmentLoadProgress(d), a && super._handleFragmentLoadComplete(d);
          } else o && o.cc !== t.frag.cc && this.syncWithAnchor(o, t.frag);
        } else
          this.state = K.IDLE;
      }
    }
    this.onTickEnd();
  }
  resetLoadingState() {
    const e = this.waitingData;
    e && (this.fragmentTracker.removeFragment(e.frag), this.waitingData = null), super.resetLoadingState();
  }
  onTickEnd() {
    const {
      media: e
    } = this;
    e != null && e.readyState && (this.lastCurrentTime = e.currentTime);
  }
  doTickIdle() {
    var e;
    const {
      hls: t,
      levels: n,
      media: s,
      trackId: r
    } = this, a = t.config;
    if (!this.buffering || !s && !this.primaryPrefetch && (this.startFragRequested || !a.startFragPrefetch) || !(n != null && n[r]))
      return;
    const o = n[r], l = o.details;
    if (!l || this.waitForLive(o) || this.waitForCdnTuneIn(l)) {
      this.state = K.WAITING_TRACK, this.startFragRequested = !1;
      return;
    }
    const d = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.bufferFlushed && d && (this.bufferFlushed = !1, this.afterBufferFlushed(d, ze.AUDIO, ce.AUDIO));
    const c = this.getFwdBufferInfo(d, ce.AUDIO);
    if (c === null)
      return;
    if (!this.switchingTrack && this._streamEnded(c, l)) {
      t.trigger(S.BUFFER_EOS, {
        type: "audio"
      }), this.state = K.ENDED;
      return;
    }
    const u = c.len, f = t.maxBufferLength, h = l.fragments, m = h[0].start, g = this.getLoadPosition(), v = this.flushing ? g : c.end;
    if (this.switchingTrack && s) {
      const b = g;
      l.PTSKnown && b < m && (c.end > m || c.nextStart) && (this.log("Alt audio track ahead of main track, seek to start of alt audio track"), s.currentTime = m + 0.05);
    }
    if (u >= f && !this.switchingTrack && v < h[h.length - 1].start)
      return;
    let p = this.getNextFragment(v, l);
    if (p && this.isLoopLoading(p, v) && (p = this.getNextFragmentLoopLoading(p, l, c, ce.MAIN, f)), !p) {
      this.bufferFlushed = !0;
      return;
    }
    let y = ((e = this.mainFragLoading) == null ? void 0 : e.frag) || null;
    if (!this.audioOnly && this.startFragRequested && y && st(p) && !p.endList && (!l.live || !this.loadingParts && v < this.hls.liveSyncPosition) && (this.fragmentTracker.getState(y) === at.OK && (this.mainFragLoading = y = null), y && st(y))) {
      if (p.start > y.end) {
        const k = this.fragmentTracker.getFragAtPos(v, ce.MAIN);
        k && k.end > y.end && (y = k, this.mainFragLoading = {
          frag: k,
          targetBufferTime: null
        });
      }
      if (p.start > y.end)
        return;
    }
    this.loadFragment(p, o, v);
  }
  onMediaDetaching(e, t) {
    this.bufferFlushed = this.flushing = !1, super.onMediaDetaching(e, t);
  }
  onAudioTracksUpdated(e, {
    audioTracks: t
  }) {
    this.resetTransmuxer(), this.levels = t.map((n) => new As(n));
  }
  onAudioTrackSwitching(e, t) {
    const n = !!t.url;
    this.trackId = t.id;
    const {
      fragCurrent: s
    } = this;
    s && (s.abortRequests(), this.removeUnbufferedFrags(s.start)), this.resetLoadingState(), n ? (this.switchingTrack = t, this.flushAudioIfNeeded(t), this.state !== K.STOPPED && (this.setInterval(Kc), this.state = K.IDLE, this.tick())) : (this.resetTransmuxer(), this.switchingTrack = null, this.bufferedTrack = t, this.clearInterval());
  }
  onManifestLoading() {
    super.onManifestLoading(), this.bufferFlushed = this.flushing = this.audioOnly = !1, this.resetItem(), this.trackId = -1;
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details;
    const n = this.cachedTrackLoadedData;
    n && (this.cachedTrackLoadedData = null, this.onAudioTrackLoaded(S.AUDIO_TRACK_LOADED, n));
  }
  onAudioTrackLoaded(e, t) {
    var n;
    const {
      levels: s
    } = this, {
      details: r,
      id: a,
      groupId: o,
      track: l
    } = t;
    if (!s) {
      this.warn(`Audio tracks reset while loading track ${a} "${l.name}" of "${o}"`);
      return;
    }
    const d = this.mainDetails;
    if (!d || r.endCC > d.endCC || d.expired) {
      this.cachedTrackLoadedData = t, this.state !== K.STOPPED && (this.state = K.WAITING_TRACK);
      return;
    }
    this.cachedTrackLoadedData = null, this.log(`Audio track ${a} "${l.name}" of "${o}" loaded [${r.startSN},${r.endSN}]${r.lastPartSn ? `[part-${r.lastPartSn}-${r.lastPartIndex}]` : ""},duration:${r.totalduration}`);
    const c = s[a];
    let u = 0;
    if (r.live || (n = c.details) != null && n.live) {
      if (this.checkLiveUpdate(r), r.deltaUpdateFailed)
        return;
      if (c.details) {
        var f;
        u = this.alignPlaylists(r, c.details, (f = this.levelLastLoaded) == null ? void 0 : f.details);
      }
      r.alignedSliding || (Ch(r, d), r.alignedSliding || Or(r, d), u = r.fragmentStart);
    }
    c.details = r, this.levelLastLoaded = c, this.startFragRequested || this.setStartPosition(d, u), this.hls.trigger(S.AUDIO_TRACK_UPDATED, {
      details: r,
      id: a,
      groupId: t.groupId
    }), this.state === K.WAITING_TRACK && !this.waitForCdnTuneIn(r) && (this.state = K.IDLE), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const n = e.frag, {
      part: s,
      payload: r
    } = e, {
      config: a,
      trackId: o,
      levels: l
    } = this;
    if (!l) {
      this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${n.sn} of level ${n.level} will not be buffered`);
      return;
    }
    const d = l[o];
    if (!d) {
      this.warn("Audio track is undefined on fragment load progress");
      return;
    }
    const c = d.details;
    if (!c) {
      this.warn("Audio track details undefined on fragment load progress"), this.removeUnbufferedFrags(n.start);
      return;
    }
    const u = a.defaultAudioCodec || d.audioCodec || "mp4a.40.2";
    let f = this.transmuxer;
    f || (f = this.transmuxer = new Xh(this.hls, ce.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)));
    const h = this.initPTS[n.cc], m = (t = n.initSegment) == null ? void 0 : t.data;
    if (h !== void 0) {
      const v = s ? s.index : -1, p = v !== -1, y = new xl(n.level, n.sn, n.stats.chunkCount, r.byteLength, v, p);
      f.push(r, m, u, "", n, s, c.totalduration, !1, y, h);
    } else {
      this.log(`Unknown video PTS for cc ${n.cc}, waiting for video PTS before demuxing audio frag ${n.sn} of [${c.startSN} ,${c.endSN}],track ${o}`);
      const {
        cache: g
      } = this.waitingData = this.waitingData || {
        frag: n,
        part: s,
        cache: new Rh(),
        complete: !1
      };
      g.push(new Uint8Array(r)), this.state !== K.STOPPED && (this.state = K.WAITING_INIT_PTS);
    }
  }
  _handleFragmentLoadComplete(e) {
    if (this.waitingData) {
      this.waitingData.complete = !0;
      return;
    }
    super._handleFragmentLoadComplete(e);
  }
  onBufferReset() {
    this.mediaBuffer = null;
  }
  onBufferCreated(e, t) {
    this.bufferFlushed = this.flushing = !1;
    const n = t.tracks.audio;
    n && (this.mediaBuffer = n.buffer || null);
  }
  onFragLoading(e, t) {
    !this.audioOnly && t.frag.type === ce.MAIN && st(t.frag) && (this.mainFragLoading = t, this.state === K.IDLE && this.tick());
  }
  onFragBuffered(e, t) {
    const {
      frag: n,
      part: s
    } = t;
    if (n.type !== ce.AUDIO) {
      !this.audioOnly && n.type === ce.MAIN && !n.elementaryStreams.video && !n.elementaryStreams.audiovideo && (this.audioOnly = !0, this.mainFragLoading = null);
      return;
    }
    if (this.fragContextChanged(n)) {
      this.warn(`Fragment ${n.sn}${s ? " p: " + s.index : ""} of level ${n.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : "false"}`);
      return;
    }
    if (st(n)) {
      this.fragPrevious = n;
      const r = this.switchingTrack;
      r && (this.bufferedTrack = r, this.switchingTrack = null, this.hls.trigger(S.AUDIO_TRACK_SWITCHED, Ve({}, r)));
    }
    this.fragBufferedComplete(n, s), this.media && this.tick();
  }
  onError(e, t) {
    var n;
    if (t.fatal) {
      this.state = K.ERROR;
      return;
    }
    switch (t.details) {
      case B.FRAG_GAP:
      case B.FRAG_PARSING_ERROR:
      case B.FRAG_DECRYPT_ERROR:
      case B.FRAG_LOAD_ERROR:
      case B.FRAG_LOAD_TIMEOUT:
      case B.KEY_LOAD_ERROR:
      case B.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(ce.AUDIO, t);
        break;
      case B.AUDIO_TRACK_LOAD_ERROR:
      case B.AUDIO_TRACK_LOAD_TIMEOUT:
      case B.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === K.WAITING_TRACK && ((n = t.context) == null ? void 0 : n.type) === Le.AUDIO_TRACK && (this.state = K.IDLE);
        break;
      case B.BUFFER_ADD_CODEC_ERROR:
      case B.BUFFER_APPEND_ERROR:
        if (t.parent !== "audio")
          return;
        this.reduceLengthAndFlushBuffer(t) || this.resetLoadingState();
        break;
      case B.BUFFER_FULL_ERROR:
        if (t.parent !== "audio")
          return;
        this.reduceLengthAndFlushBuffer(t) && (this.bufferedTrack = null, super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"));
        break;
      case B.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  onBufferFlushing(e, {
    type: t
  }) {
    t !== ze.VIDEO && (this.flushing = !0);
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t !== ze.VIDEO) {
      this.flushing = !1, this.bufferFlushed = !0, this.state === K.ENDED && (this.state = K.IDLE);
      const n = this.mediaBuffer || this.media;
      n && (this.afterBufferFlushed(n, t, ce.AUDIO), this.tick());
    }
  }
  _handleTransmuxComplete(e) {
    var t;
    const n = "audio", {
      hls: s
    } = this, {
      remuxResult: r,
      chunkMeta: a
    } = e, o = this.getCurrentContext(a);
    if (!o) {
      this.resetWhenMissingContext(a);
      return;
    }
    const {
      frag: l,
      part: d,
      level: c
    } = o, {
      details: u
    } = c, {
      audio: f,
      text: h,
      id3: m,
      initSegment: g
    } = r;
    if (this.fragContextChanged(l) || !u) {
      this.fragmentTracker.removeFragment(l);
      return;
    }
    if (this.state = K.PARSING, this.switchingTrack && f && this.completeAudioSwitch(this.switchingTrack), g != null && g.tracks) {
      const v = l.initSegment || l;
      if (this.unhandledEncryptionError(g, l))
        return;
      this._bufferInitSegment(c, g.tracks, v, a), s.trigger(S.FRAG_PARSING_INIT_SEGMENT, {
        frag: v,
        id: n,
        tracks: g.tracks
      });
    }
    if (f) {
      const {
        startPTS: v,
        endPTS: p,
        startDTS: y,
        endDTS: b
      } = f;
      d && (d.elementaryStreams[ze.AUDIO] = {
        startPTS: v,
        endPTS: p,
        startDTS: y,
        endDTS: b
      }), l.setElementaryStreamInfo(ze.AUDIO, v, p, y, b), this.bufferFragmentData(f, l, d, a);
    }
    if (m != null && (t = m.samples) != null && t.length) {
      const v = He({
        id: n,
        frag: l,
        details: u
      }, m);
      s.trigger(S.FRAG_PARSING_METADATA, v);
    }
    if (h) {
      const v = He({
        id: n,
        frag: l,
        details: u
      }, h);
      s.trigger(S.FRAG_PARSING_USERDATA, v);
    }
  }
  _bufferInitSegment(e, t, n, s) {
    if (this.state !== K.PARSING || (t.video && delete t.video, t.audiovideo && delete t.audiovideo, !t.audio))
      return;
    const r = t.audio;
    r.id = ce.AUDIO;
    const a = e.audioCodec;
    this.log(`Init audio buffer, container:${r.container}, codecs[level/parsed]=[${a}/${r.codec}]`), a && a.split(",").length === 1 && (r.levelCodec = a), this.hls.trigger(S.BUFFER_CODECS, t);
    const o = r.initSegment;
    if (o != null && o.byteLength) {
      const l = {
        type: "audio",
        frag: n,
        part: null,
        chunkMeta: s,
        parent: n.type,
        data: o
      };
      this.hls.trigger(S.BUFFER_APPENDING, l);
    }
    this.tickImmediate();
  }
  loadFragment(e, t, n) {
    const s = this.fragmentTracker.getState(e);
    if (this.switchingTrack || s === at.NOT_LOADED || s === at.PARTIAL) {
      var r;
      if (!st(e))
        this._loadInitSegment(e, t);
      else if ((r = t.details) != null && r.live && !this.initPTS[e.cc]) {
        this.log(`Waiting for video PTS in continuity counter ${e.cc} of live stream before loading audio fragment ${e.sn} of level ${this.trackId}`), this.state = K.WAITING_INIT_PTS;
        const a = this.mainDetails;
        a && a.fragmentStart !== t.details.fragmentStart && Or(t.details, a);
      } else
        super.loadFragment(e, t, n);
    } else
      this.clearTrackerIfNeeded(e);
  }
  flushAudioIfNeeded(e) {
    if (this.media && this.bufferedTrack) {
      const {
        name: t,
        lang: n,
        assocLang: s,
        characteristics: r,
        audioCodec: a,
        channels: o
      } = this.bufferedTrack;
      bn({
        name: t,
        lang: n,
        assocLang: s,
        characteristics: r,
        audioCodec: a,
        channels: o
      }, e, hn) || (Pr(e.url, this.hls) ? (this.log("Switching audio track : flushing all audio"), super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"), this.bufferedTrack = null) : this.bufferedTrack = e);
    }
  }
  completeAudioSwitch(e) {
    const {
      hls: t
    } = this;
    this.flushAudioIfNeeded(e), this.bufferedTrack = e, this.switchingTrack = null, t.trigger(S.AUDIO_TRACK_SWITCHED, Ve({}, e));
  }
}
class Ml extends ni {
  constructor(e, t) {
    super(t, e.logger), this.hls = void 0, this.canLoad = !1, this.timer = -1, this.hls = e;
  }
  destroy() {
    this.clearTimer(), this.hls = this.log = this.warn = null;
  }
  clearTimer() {
    this.timer !== -1 && (self.clearTimeout(this.timer), this.timer = -1);
  }
  startLoad() {
    this.canLoad = !0, this.loadPlaylist();
  }
  stopLoad() {
    this.canLoad = !1, this.clearTimer();
  }
  switchParams(e, t, n) {
    const s = t?.renditionReports;
    if (s) {
      let r = -1;
      for (let a = 0; a < s.length; a++) {
        const o = s[a];
        let l;
        try {
          l = new self.URL(o.URI, t.url).href;
        } catch (d) {
          this.warn(`Could not construct new URL for Rendition Report: ${d}`), l = o.URI || "";
        }
        if (l === e) {
          r = a;
          break;
        } else l === e.substring(0, l.length) && (r = a);
      }
      if (r !== -1) {
        const a = s[r], o = parseInt(a["LAST-MSN"]) || t.lastPartSn;
        let l = parseInt(a["LAST-PART"]) || t.lastPartIndex;
        if (this.hls.config.lowLatencyMode) {
          const c = Math.min(t.age - t.partTarget, t.targetduration);
          l >= 0 && c > t.partTarget && (l += 1);
        }
        const d = n && dc(n);
        return new cc(o, l >= 0 ? l : void 0, d);
      }
    }
  }
  loadPlaylist(e) {
    this.clearTimer();
  }
  loadingPlaylist(e, t) {
    this.clearTimer();
  }
  shouldLoadPlaylist(e) {
    return this.canLoad && !!e && !!e.url && (!e.details || e.details.live);
  }
  getUrlWithDirectives(e, t) {
    if (t)
      try {
        return t.addDirectives(e);
      } catch (n) {
        this.warn(`Could not construct new URL with HLS Delivery Directives: ${n}`);
      }
    return e;
  }
  playlistLoaded(e, t, n) {
    const {
      details: s,
      stats: r
    } = t, a = self.performance.now(), o = r.loading.first ? Math.max(0, a - r.loading.first) : 0;
    s.advancedDateTime = Date.now() - o;
    const l = this.hls.config.timelineOffset;
    if (l !== s.appliedTimelineOffset) {
      const c = Math.max(l || 0, 0);
      s.appliedTimelineOffset = c, s.fragments.forEach((u) => {
        u.setStart(u.playlistOffset + c);
      });
    }
    if (s.live || n != null && n.live) {
      const c = "levelInfo" in t ? t.levelInfo : t.track;
      if (s.reloaded(n), n && s.fragments.length > 0) {
        hy(n, s, this);
        const y = s.playlistParsingError;
        if (y) {
          this.warn(y);
          const b = this.hls;
          if (!b.config.ignorePlaylistParsingErrors) {
            var d;
            const {
              networkDetails: k
            } = t;
            b.trigger(S.ERROR, {
              type: pe.NETWORK_ERROR,
              details: B.LEVEL_PARSING_ERROR,
              fatal: !1,
              url: s.url,
              error: y,
              reason: y.message,
              level: t.level || void 0,
              parent: (d = s.fragments[0]) == null ? void 0 : d.type,
              networkDetails: k,
              stats: r
            });
            return;
          }
          s.playlistParsingError = null;
        }
      }
      s.requestScheduled === -1 && (s.requestScheduled = r.loading.start);
      const u = this.hls.mainForwardBufferInfo, f = u ? u.end - u.len : 0, h = (s.edge - f) * 1e3, m = _h(s, h);
      if (s.requestScheduled + m < a ? s.requestScheduled = a : s.requestScheduled += m, this.log(`live playlist ${e} ${s.advanced ? "REFRESHED " + s.lastPartSn + "-" + s.lastPartIndex : s.updated ? "UPDATED" : "MISSED"}`), !this.canLoad || !s.live)
        return;
      let g, v, p;
      if (s.canBlockReload && s.endSN && s.advanced) {
        const y = this.hls.config.lowLatencyMode, b = s.lastPartSn, k = s.endSN, T = s.lastPartIndex, I = T !== -1, x = b === k;
        I ? x ? (v = k + 1, p = y ? 0 : T) : (v = b, p = y ? T + 1 : s.maxPartIndex) : v = k + 1;
        const E = s.age, R = E + s.ageHeader;
        let A = Math.min(R - s.partTarget, s.targetduration * 1.5);
        if (A > 0) {
          if (R > s.targetduration * 3)
            this.log(`Playlist last advanced ${E.toFixed(2)}s ago. Omitting segment and part directives.`), v = void 0, p = void 0;
          else if (n != null && n.tuneInGoal && R - s.partTarget > n.tuneInGoal)
            this.warn(`CDN Tune-in goal increased from: ${n.tuneInGoal} to: ${A} with playlist age: ${s.age}`), A = 0;
          else {
            const _ = Math.floor(A / s.targetduration);
            if (v += _, p !== void 0) {
              const C = Math.round(A % s.targetduration / s.partTarget);
              p += C;
            }
            this.log(`CDN Tune-in age: ${s.ageHeader}s last advanced ${E.toFixed(2)}s goal: ${A} skip sn ${_} to part ${p}`);
          }
          s.tuneInGoal = A;
        }
        if (g = this.getDeliveryDirectives(s, t.deliveryDirectives, v, p), y || !x) {
          s.requestScheduled = a, this.loadingPlaylist(c, g);
          return;
        }
      } else (s.canBlockReload || s.canSkipUntil) && (g = this.getDeliveryDirectives(s, t.deliveryDirectives, v, p));
      g && v !== void 0 && s.canBlockReload && (s.requestScheduled = r.loading.first + Math.max(m - o * 2, m / 2)), this.scheduleLoading(c, g, s);
    } else
      this.clearTimer();
  }
  scheduleLoading(e, t, n) {
    const s = n || e.details;
    if (!s) {
      this.loadingPlaylist(e, t);
      return;
    }
    const r = self.performance.now(), a = s.requestScheduled;
    if (r >= a) {
      this.loadingPlaylist(e, t);
      return;
    }
    const o = a - r;
    this.log(`reload live playlist ${e.name || e.bitrate + "bps"} in ${Math.round(o)} ms`), this.clearTimer(), this.timer = self.setTimeout(() => this.loadingPlaylist(e, t), o);
  }
  getDeliveryDirectives(e, t, n, s) {
    let r = dc(e);
    return t != null && t.skip && e.deltaUpdateFailed && (n = t.msn, s = t.part, r = ur.No), new cc(n, s, r);
  }
  checkRetry(e) {
    const t = e.details, n = Dr(e), s = e.errorAction, {
      action: r,
      retryCount: a = 0,
      retryConfig: o
    } = s || {}, l = !!s && !!o && (r === vt.RetryRequest || !s.resolved && r === vt.SendAlternateToPenaltyBox);
    if (l) {
      var d;
      if (a >= o.maxNumRetry)
        return !1;
      if (n && (d = e.context) != null && d.deliveryDirectives)
        this.warn(`Retrying playlist loading ${a + 1}/${o.maxNumRetry} after "${t}" without delivery-directives`), this.loadPlaylist();
      else {
        const c = Tl(o, a);
        this.clearTimer(), this.timer = self.setTimeout(() => this.loadPlaylist(), c), this.warn(`Retrying playlist loading ${a + 1}/${o.maxNumRetry} after "${t}" in ${c}ms`);
      }
      e.levelRetry = !0, s.resolved = !0;
    }
    return l;
  }
}
function Zh(i, e) {
  if (i.length !== e.length)
    return !1;
  for (let t = 0; t < i.length; t++)
    if (!Rs(i[t].attrs, e[t].attrs))
      return !1;
  return !0;
}
function Rs(i, e, t) {
  const n = i["STABLE-RENDITION-ID"];
  return n && !t ? n === e["STABLE-RENDITION-ID"] : !(t || ["LANGUAGE", "NAME", "CHARACTERISTICS", "AUTOSELECT", "DEFAULT", "FORCED", "ASSOC-LANGUAGE"]).some((s) => i[s] !== e[s]);
}
function Fo(i, e) {
  return e.label.toLowerCase() === i.name.toLowerCase() && (!e.language || e.language.toLowerCase() === (i.lang || "").toLowerCase());
}
class Tb extends Ml {
  constructor(e) {
    super(e, "audio-track-controller"), this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.registerListeners();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(S.MANIFEST_LOADING, this.onManifestLoading, this), e.on(S.MANIFEST_PARSED, this.onManifestParsed, this), e.on(S.LEVEL_LOADING, this.onLevelLoading, this), e.on(S.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(S.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(S.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(S.MANIFEST_LOADING, this.onManifestLoading, this), e.off(S.MANIFEST_PARSED, this.onManifestParsed, this), e.off(S.LEVEL_LOADING, this.onLevelLoading, this), e.off(S.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(S.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(S.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, super.destroy();
  }
  onManifestLoading() {
    this.tracks = [], this.tracksInGroup = [], this.groupIds = null, this.currentTrack = null, this.trackId = -1, this.selectDefaultTrack = !0;
  }
  onManifestParsed(e, t) {
    this.tracks = t.audioTracks || [];
  }
  onAudioTrackLoaded(e, t) {
    const {
      id: n,
      groupId: s,
      details: r
    } = t, a = this.tracksInGroup[n];
    if (!a || a.groupId !== s) {
      this.warn(`Audio track with id:${n} and group:${s} not found in active group ${a?.groupId}`);
      return;
    }
    const o = a.details;
    a.details = t.details, this.log(`Audio track ${n} "${a.name}" lang:${a.lang} group:${s} loaded [${r.startSN}-${r.endSN}]`), n === this.trackId && this.playlistLoaded(n, t, o);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!t)
      return;
    const n = t.audioGroups || null, s = this.groupIds;
    let r = this.currentTrack;
    if (!n || s?.length !== n?.length || n != null && n.some((o) => s?.indexOf(o) === -1)) {
      this.groupIds = n, this.trackId = -1, this.currentTrack = null;
      const o = this.tracks.filter((f) => !n || n.indexOf(f.groupId) !== -1);
      if (o.length)
        this.selectDefaultTrack && !o.some((f) => f.default) && (this.selectDefaultTrack = !1), o.forEach((f, h) => {
          f.id = h;
        });
      else if (!r && !this.tracksInGroup.length)
        return;
      this.tracksInGroup = o;
      const l = this.hls.config.audioPreference;
      if (!r && l) {
        const f = fi(l, o, hn);
        if (f > -1)
          r = o[f];
        else {
          const h = fi(l, this.tracks);
          r = this.tracks[h];
        }
      }
      let d = this.findTrackId(r);
      d === -1 && r && (d = this.findTrackId(null));
      const c = {
        audioTracks: o
      };
      this.log(`Updating audio tracks, ${o.length} track(s) found in group(s): ${n?.join(",")}`), this.hls.trigger(S.AUDIO_TRACKS_UPDATED, c);
      const u = this.trackId;
      if (d !== -1 && u === -1)
        this.setAudioTrack(d);
      else if (o.length && u === -1) {
        var a;
        const f = new Error(`No audio track selected for current audio group-ID(s): ${(a = this.groupIds) == null ? void 0 : a.join(",")} track count: ${o.length}`);
        this.warn(f.message), this.hls.trigger(S.ERROR, {
          type: pe.MEDIA_ERROR,
          details: B.AUDIO_TRACK_LOAD_ERROR,
          fatal: !0,
          error: f
        });
      }
    }
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Le.AUDIO_TRACK && t.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(t.context.groupId) !== -1) && this.checkRetry(t);
  }
  get allAudioTracks() {
    return this.tracks;
  }
  get audioTracks() {
    return this.tracksInGroup;
  }
  get audioTrack() {
    return this.trackId;
  }
  set audioTrack(e) {
    this.selectDefaultTrack = !1, this.setAudioTrack(e);
  }
  setAudioOption(e) {
    const t = this.hls;
    if (t.config.audioPreference = e, e) {
      const n = this.allAudioTracks;
      if (this.selectDefaultTrack = !1, n.length) {
        const s = this.currentTrack;
        if (s && bn(e, s, hn))
          return s;
        const r = fi(e, this.tracksInGroup, hn);
        if (r > -1) {
          const a = this.tracksInGroup[r];
          return this.setAudioTrack(r), a;
        } else if (s) {
          let a = t.loadLevel;
          a === -1 && (a = t.firstAutoLevel);
          const o = P1(e, t.levels, n, a, hn);
          if (o === -1)
            return null;
          t.nextLoadLevel = o;
        }
        if (e.channels || e.audioCodec) {
          const a = fi(e, n);
          if (a > -1)
            return n[a];
        }
      }
    }
    return null;
  }
  setAudioTrack(e) {
    const t = this.tracksInGroup;
    if (e < 0 || e >= t.length) {
      this.warn(`Invalid audio track id: ${e}`);
      return;
    }
    this.selectDefaultTrack = !1;
    const n = this.currentTrack, s = t[e], r = s.details && !s.details.live;
    if (e === this.trackId && s === n && r || (this.log(`Switching to audio-track ${e} "${s.name}" lang:${s.lang} group:${s.groupId} channels:${s.channels}`), this.trackId = e, this.currentTrack = s, this.hls.trigger(S.AUDIO_TRACK_SWITCHING, Ve({}, s)), r))
      return;
    const a = this.switchParams(s.url, n?.details, s.details);
    this.loadPlaylist(a);
  }
  findTrackId(e) {
    const t = this.tracksInGroup;
    for (let n = 0; n < t.length; n++) {
      const s = t[n];
      if (!(this.selectDefaultTrack && !s.default) && (!e || bn(e, s, hn)))
        return n;
    }
    if (e) {
      const {
        name: n,
        lang: s,
        assocLang: r,
        characteristics: a,
        audioCodec: o,
        channels: l
      } = e;
      for (let d = 0; d < t.length; d++) {
        const c = t[d];
        if (bn({
          name: n,
          lang: s,
          assocLang: r,
          characteristics: a,
          audioCodec: o,
          channels: l
        }, c, hn))
          return d;
      }
      for (let d = 0; d < t.length; d++) {
        const c = t[d];
        if (Rs(e.attrs, c.attrs, ["LANGUAGE", "ASSOC-LANGUAGE", "CHARACTERISTICS"]))
          return d;
      }
      for (let d = 0; d < t.length; d++) {
        const c = t[d];
        if (Rs(e.attrs, c.attrs, ["LANGUAGE"]))
          return d;
      }
    }
    return -1;
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.currentTrack;
    this.shouldLoadPlaylist(t) && Pr(t.url, this.hls) && this.scheduleLoading(t, e);
  }
  loadingPlaylist(e, t) {
    super.loadingPlaylist(e, t);
    const n = e.id, s = e.groupId, r = this.getUrlWithDirectives(e.url, t), a = e.details, o = a?.age;
    this.log(`Loading audio-track ${n} "${e.name}" lang:${e.lang} group:${s}${t?.msn !== void 0 ? " at sn " + t.msn + " part " + t.part : ""}${o && a.live ? " age " + o.toFixed(1) + (a.type && " " + a.type || "") : ""} ${r}`), this.hls.trigger(S.AUDIO_TRACK_LOADING, {
      url: r,
      id: n,
      groupId: s,
      deliveryDirectives: t || null,
      track: e
    });
  }
}
class Eb {
  constructor(e) {
    this.tracks = void 0, this.queues = {
      video: [],
      audio: [],
      audiovideo: []
    }, this.tracks = e;
  }
  destroy() {
    this.tracks = this.queues = null;
  }
  append(e, t, n) {
    if (this.queues === null || this.tracks === null)
      return;
    const s = this.queues[t];
    s.push(e), s.length === 1 && !n && this.executeNext(t);
  }
  appendBlocker(e) {
    return new Promise((t) => {
      const n = {
        label: "async-blocker",
        execute: t,
        onStart: () => {
        },
        onComplete: () => {
        },
        onError: () => {
        }
      };
      this.append(n, e);
    });
  }
  prependBlocker(e) {
    return new Promise((t) => {
      if (this.queues) {
        const n = {
          label: "async-blocker-prepend",
          execute: t,
          onStart: () => {
          },
          onComplete: () => {
          },
          onError: () => {
          }
        };
        this.queues[e].unshift(n);
      }
    });
  }
  removeBlockers() {
    this.queues !== null && [this.queues.video, this.queues.audio, this.queues.audiovideo].forEach((e) => {
      var t;
      const n = (t = e[0]) == null ? void 0 : t.label;
      (n === "async-blocker" || n === "async-blocker-prepend") && (e[0].execute(), e.splice(0, 1));
    });
  }
  unblockAudio(e) {
    if (this.queues === null)
      return;
    this.queues.audio[0] === e && this.shiftAndExecuteNext("audio");
  }
  executeNext(e) {
    if (this.queues === null || this.tracks === null)
      return;
    const t = this.queues[e];
    if (t.length) {
      const s = t[0];
      try {
        s.execute();
      } catch (r) {
        var n;
        if (s.onError(r), this.queues === null || this.tracks === null)
          return;
        const a = (n = this.tracks[e]) == null ? void 0 : n.buffer;
        a != null && a.updating || this.shiftAndExecuteNext(e);
      }
    }
  }
  shiftAndExecuteNext(e) {
    this.queues !== null && (this.queues[e].shift(), this.executeNext(e));
  }
  current(e) {
    var t;
    return ((t = this.queues) == null ? void 0 : t[e][0]) || null;
  }
  toString() {
    const {
      queues: e,
      tracks: t
    } = this;
    return e === null || t === null ? "<destroyed>" : `
${this.list("video")}
${this.list("audio")}
${this.list("audiovideo")}}`;
  }
  list(e) {
    var t, n;
    return (t = this.queues) != null && t[e] || (n = this.tracks) != null && n[e] ? `${e}: (${this.listSbInfo(e)}) ${this.listOps(e)}` : "";
  }
  listSbInfo(e) {
    var t;
    const n = (t = this.tracks) == null ? void 0 : t[e], s = n?.buffer;
    return s ? `SourceBuffer${s.updating ? " updating" : ""}${n.ended ? " ended" : ""}${n.ending ? " ending" : ""}` : "none";
  }
  listOps(e) {
    var t;
    return ((t = this.queues) == null ? void 0 : t[e].map((n) => n.label).join(", ")) || "";
  }
}
const jc = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/, Qh = "HlsJsTrackRemovedError";
class xb extends Error {
  constructor(e) {
    super(e), this.name = Qh;
  }
}
class _b extends ni {
  constructor(e, t) {
    super("buffer-controller", e.logger), this.hls = void 0, this.fragmentTracker = void 0, this.details = null, this._objectUrl = null, this.operationQueue = null, this.bufferCodecEventsTotal = 0, this.media = null, this.mediaSource = null, this.lastMpegAudioChunk = null, this.blockedAudioAppend = null, this.lastVideoAppendEnd = 0, this.appendSource = void 0, this.transferData = void 0, this.overrides = void 0, this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    }, this.tracks = {}, this.sourceBuffers = [[null, null], [null, null]], this._onEndStreaming = (n) => {
      var s;
      this.hls && ((s = this.mediaSource) == null ? void 0 : s.readyState) === "open" && this.hls.pauseBuffering();
    }, this._onStartStreaming = (n) => {
      this.hls && this.hls.resumeBuffering();
    }, this._onMediaSourceOpen = (n) => {
      const {
        media: s,
        mediaSource: r
      } = this;
      n && this.log("Media source opened"), !(!s || !r) && (r.removeEventListener("sourceopen", this._onMediaSourceOpen), s.removeEventListener("emptied", this._onMediaEmptied), this.updateDuration(), this.hls.trigger(S.MEDIA_ATTACHED, {
        media: s,
        mediaSource: r
      }), this.mediaSource !== null && this.checkPendingTracks());
    }, this._onMediaSourceClose = () => {
      this.log("Media source closed");
    }, this._onMediaSourceEnded = () => {
      this.log("Media source ended");
    }, this._onMediaEmptied = () => {
      const {
        mediaSrc: n,
        _objectUrl: s
      } = this;
      n !== s && this.error(`Media element src was set while attaching MediaSource (${s} > ${n})`);
    }, this.hls = e, this.fragmentTracker = t, this.appendSource = Xv(en(e.config.preferManagedMediaSource)), this.initTracks(), this.registerListeners();
  }
  hasSourceTypes() {
    return Object.keys(this.tracks).length > 0;
  }
  destroy() {
    this.unregisterListeners(), this.details = null, this.lastMpegAudioChunk = this.blockedAudioAppend = null, this.transferData = this.overrides = void 0, this.operationQueue && (this.operationQueue.destroy(), this.operationQueue = null), this.hls = this.fragmentTracker = null, this._onMediaSourceOpen = this._onMediaSourceClose = null, this._onMediaSourceEnded = null, this._onStartStreaming = this._onEndStreaming = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(S.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(S.MANIFEST_LOADING, this.onManifestLoading, this), e.on(S.MANIFEST_PARSED, this.onManifestParsed, this), e.on(S.BUFFER_RESET, this.onBufferReset, this), e.on(S.BUFFER_APPENDING, this.onBufferAppending, this), e.on(S.BUFFER_CODECS, this.onBufferCodecs, this), e.on(S.BUFFER_EOS, this.onBufferEos, this), e.on(S.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(S.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(S.FRAG_PARSED, this.onFragParsed, this), e.on(S.FRAG_CHANGED, this.onFragChanged, this), e.on(S.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(S.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(S.MANIFEST_LOADING, this.onManifestLoading, this), e.off(S.MANIFEST_PARSED, this.onManifestParsed, this), e.off(S.BUFFER_RESET, this.onBufferReset, this), e.off(S.BUFFER_APPENDING, this.onBufferAppending, this), e.off(S.BUFFER_CODECS, this.onBufferCodecs, this), e.off(S.BUFFER_EOS, this.onBufferEos, this), e.off(S.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(S.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(S.FRAG_PARSED, this.onFragParsed, this), e.off(S.FRAG_CHANGED, this.onFragChanged, this), e.off(S.ERROR, this.onError, this);
  }
  transferMedia() {
    const {
      media: e,
      mediaSource: t
    } = this;
    if (!e)
      return null;
    const n = {};
    if (this.operationQueue) {
      const r = this.isUpdating();
      r || this.operationQueue.removeBlockers();
      const a = this.isQueued();
      (r || a) && this.warn(`Transfering MediaSource with${a ? " operations in queue" : ""}${r ? " updating SourceBuffer(s)" : ""} ${this.operationQueue}`), this.operationQueue.destroy();
    }
    const s = this.transferData;
    return !this.sourceBufferCount && s && s.mediaSource === t ? He(n, s.tracks) : this.sourceBuffers.forEach((r) => {
      const [a] = r;
      a && (n[a] = He({}, this.tracks[a]), this.removeBuffer(a)), r[0] = r[1] = null;
    }), {
      media: e,
      mediaSource: t,
      tracks: n
    };
  }
  initTracks() {
    const e = {};
    this.sourceBuffers = [[null, null], [null, null]], this.tracks = e, this.resetQueue(), this.resetAppendErrors(), this.lastMpegAudioChunk = this.blockedAudioAppend = null, this.lastVideoAppendEnd = 0;
  }
  onManifestLoading() {
    this.bufferCodecEventsTotal = 0, this.details = null;
  }
  onManifestParsed(e, t) {
    var n;
    let s = 2;
    (t.audio && !t.video || !t.altAudio) && (s = 1), this.bufferCodecEventsTotal = s, this.log(`${s} bufferCodec event(s) expected.`), (n = this.transferData) != null && n.mediaSource && this.sourceBufferCount && s && this.bufferCreated();
  }
  onMediaAttaching(e, t) {
    const n = this.media = t.media;
    this.transferData = this.overrides = void 0;
    const s = en(this.appendSource);
    if (s) {
      const r = !!t.mediaSource;
      (r || t.overrides) && (this.transferData = t, this.overrides = t.overrides);
      const a = this.mediaSource = t.mediaSource || new s();
      if (this.assignMediaSource(a), r)
        this._objectUrl = n.src, this.attachTransferred();
      else {
        const o = this._objectUrl = self.URL.createObjectURL(a);
        if (this.appendSource)
          try {
            n.removeAttribute("src");
            const l = self.ManagedMediaSource;
            n.disableRemotePlayback = n.disableRemotePlayback || l && a instanceof l, Wc(n), Ab(n, o), n.load();
          } catch {
            n.src = o;
          }
        else
          n.src = o;
      }
      n.addEventListener("emptied", this._onMediaEmptied);
    }
  }
  assignMediaSource(e) {
    var t, n;
    this.log(`${((t = this.transferData) == null ? void 0 : t.mediaSource) === e ? "transferred" : "created"} media source: ${(n = e.constructor) == null ? void 0 : n.name}`), e.addEventListener("sourceopen", this._onMediaSourceOpen), e.addEventListener("sourceended", this._onMediaSourceEnded), e.addEventListener("sourceclose", this._onMediaSourceClose), this.appendSource && (e.addEventListener("startstreaming", this._onStartStreaming), e.addEventListener("endstreaming", this._onEndStreaming));
  }
  attachTransferred() {
    const e = this.media, t = this.transferData;
    if (!t || !e)
      return;
    const n = this.tracks, s = t.tracks, r = s ? Object.keys(s) : null, a = r ? r.length : 0, o = () => {
      Promise.resolve().then(() => {
        this.media && this.mediaSourceOpenOrEnded && this._onMediaSourceOpen();
      });
    };
    if (s && r && a) {
      if (!this.tracksReady) {
        this.hls.config.startFragPrefetch = !0, this.log("attachTransferred: waiting for SourceBuffer track info");
        return;
      }
      if (this.log(`attachTransferred: (bufferCodecEventsTotal ${this.bufferCodecEventsTotal})
required tracks: ${qe(n, (l, d) => l === "initSegment" ? void 0 : d)};
transfer tracks: ${qe(s, (l, d) => l === "initSegment" ? void 0 : d)}}`), !eh(s, n)) {
        t.mediaSource = null, t.tracks = void 0;
        const l = e.currentTime, d = this.details, c = Math.max(l, d?.fragments[0].start || 0);
        if (c - l > 1) {
          this.log(`attachTransferred: waiting for playback to reach new tracks start time ${l} -> ${c}`);
          return;
        }
        this.warn(`attachTransferred: resetting MediaSource for incompatible tracks ("${Object.keys(s)}"->"${Object.keys(n)}") start time: ${c} currentTime: ${l}`), this.onMediaDetaching(S.MEDIA_DETACHING, {}), this.onMediaAttaching(S.MEDIA_ATTACHING, t), e.currentTime = c;
        return;
      }
      this.transferData = void 0, r.forEach((l) => {
        const d = l, c = s[d];
        if (c) {
          const u = c.buffer;
          if (u) {
            const f = this.fragmentTracker, h = c.id;
            if (f.hasFragments(h) || f.hasParts(h)) {
              const v = Te.getBuffered(u);
              f.detectEvictedFragments(d, v, h, null, !0);
            }
            const m = za(d), g = [d, u];
            this.sourceBuffers[m] = g, u.updating && this.operationQueue && this.operationQueue.prependBlocker(d), this.trackSourceBuffer(d, c);
          }
        }
      }), o(), this.bufferCreated();
    } else
      this.log("attachTransferred: MediaSource w/o SourceBuffers"), o();
  }
  get mediaSourceOpenOrEnded() {
    var e;
    const t = (e = this.mediaSource) == null ? void 0 : e.readyState;
    return t === "open" || t === "ended";
  }
  onMediaDetaching(e, t) {
    const n = !!t.transferMedia;
    this.transferData = this.overrides = void 0;
    const {
      media: s,
      mediaSource: r,
      _objectUrl: a
    } = this;
    if (r) {
      if (this.log(`media source ${n ? "transferring" : "detaching"}`), n)
        this.sourceBuffers.forEach(([o]) => {
          o && this.removeBuffer(o);
        }), this.resetQueue();
      else {
        if (this.mediaSourceOpenOrEnded) {
          const o = r.readyState === "open";
          try {
            const l = r.sourceBuffers;
            for (let d = l.length; d--; )
              o && l[d].abort(), r.removeSourceBuffer(l[d]);
            o && r.endOfStream();
          } catch (l) {
            this.warn(`onMediaDetaching: ${l.message} while calling endOfStream`);
          }
        }
        this.sourceBufferCount && this.onBufferReset();
      }
      r.removeEventListener("sourceopen", this._onMediaSourceOpen), r.removeEventListener("sourceended", this._onMediaSourceEnded), r.removeEventListener("sourceclose", this._onMediaSourceClose), this.appendSource && (r.removeEventListener("startstreaming", this._onStartStreaming), r.removeEventListener("endstreaming", this._onEndStreaming)), this.mediaSource = null, this._objectUrl = null;
    }
    s && (s.removeEventListener("emptied", this._onMediaEmptied), n || (a && self.URL.revokeObjectURL(a), this.mediaSrc === a ? (s.removeAttribute("src"), this.appendSource && Wc(s), s.load()) : this.warn("media|source.src was changed by a third party - skip cleanup")), this.media = null), this.hls.trigger(S.MEDIA_DETACHED, t);
  }
  onBufferReset() {
    this.sourceBuffers.forEach(([e]) => {
      e && this.resetBuffer(e);
    }), this.initTracks();
  }
  resetBuffer(e) {
    var t;
    const n = (t = this.tracks[e]) == null ? void 0 : t.buffer;
    if (this.removeBuffer(e), n)
      try {
        var s;
        (s = this.mediaSource) != null && s.sourceBuffers.length && this.mediaSource.removeSourceBuffer(n);
      } catch (r) {
        this.warn(`onBufferReset ${e}`, r);
      }
    delete this.tracks[e];
  }
  removeBuffer(e) {
    this.removeBufferListeners(e), this.sourceBuffers[za(e)] = [null, null];
    const t = this.tracks[e];
    t && (t.buffer = void 0);
  }
  resetQueue() {
    this.operationQueue && this.operationQueue.destroy(), this.operationQueue = new Eb(this.tracks);
  }
  onBufferCodecs(e, t) {
    const n = this.tracks, s = Object.keys(t);
    this.log(`BUFFER_CODECS: "${s}" (current SB count ${this.sourceBufferCount})`);
    const r = "audiovideo" in t && (n.audio || n.video) || n.audiovideo && ("audio" in t || "video" in t), a = !r && this.sourceBufferCount && this.media && s.some((o) => !n[o]);
    if (r || a) {
      this.warn(`Unsupported transition between "${Object.keys(n)}" and "${s}" SourceBuffers`);
      return;
    }
    s.forEach((o) => {
      var l, d;
      const c = t[o], {
        id: u,
        codec: f,
        levelCodec: h,
        container: m,
        metadata: g,
        supplemental: v
      } = c;
      let p = n[o];
      const y = (l = this.transferData) == null || (l = l.tracks) == null ? void 0 : l[o], b = y != null && y.buffer ? y : p, k = b?.pendingCodec || b?.codec, T = b?.levelCodec;
      p || (p = n[o] = {
        buffer: void 0,
        listeners: [],
        codec: f,
        supplemental: v,
        container: m,
        levelCodec: h,
        metadata: g,
        id: u
      });
      const I = cr(k, T), x = I?.replace(jc, "$1");
      let E = cr(f, h);
      const R = (d = E) == null ? void 0 : d.replace(jc, "$1");
      E && I && x !== R && (o.slice(0, 5) === "audio" && (E = Cr(E, this.appendSource)), this.log(`switching codec ${k} to ${E}`), E !== (p.pendingCodec || p.codec) && (p.pendingCodec = E), p.container = m, this.appendChangeType(o, m, E));
    }), (this.tracksReady || this.sourceBufferCount) && (t.tracks = this.sourceBufferTracks), !this.sourceBufferCount && this.mediaSourceOpenOrEnded && this.checkPendingTracks();
  }
  get sourceBufferTracks() {
    return Object.keys(this.tracks).reduce((e, t) => {
      const n = this.tracks[t];
      return e[t] = {
        id: n.id,
        container: n.container,
        codec: n.codec,
        levelCodec: n.levelCodec
      }, e;
    }, {});
  }
  appendChangeType(e, t, n) {
    const s = `${t};codecs=${n}`, r = {
      label: `change-type=${s}`,
      execute: () => {
        const a = this.tracks[e];
        if (a) {
          const o = a.buffer;
          o != null && o.changeType && (this.log(`changing ${e} sourceBuffer type to ${s}`), o.changeType(s), a.codec = n, a.container = t);
        }
        this.shiftAndExecuteNext(e);
      },
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: (a) => {
        this.warn(`Failed to change ${e} SourceBuffer type`, a);
      }
    };
    this.append(r, e, this.isPending(this.tracks[e]));
  }
  blockAudio(e) {
    var t;
    const n = e.start, s = n + e.duration * 0.05;
    if (((t = this.fragmentTracker.getAppendedFrag(n, ce.MAIN)) == null ? void 0 : t.gap) === !0)
      return;
    const a = {
      label: "block-audio",
      execute: () => {
        var o;
        const l = this.tracks.video;
        (this.lastVideoAppendEnd > s || l != null && l.buffer && Te.isBuffered(l.buffer, s) || ((o = this.fragmentTracker.getAppendedFrag(s, ce.MAIN)) == null ? void 0 : o.gap) === !0) && (this.blockedAudioAppend = null, this.shiftAndExecuteNext("audio"));
      },
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: (o) => {
        this.warn("Error executing block-audio operation", o);
      }
    };
    this.blockedAudioAppend = {
      op: a,
      frag: e
    }, this.append(a, "audio", !0);
  }
  unblockAudio() {
    const {
      blockedAudioAppend: e,
      operationQueue: t
    } = this;
    e && t && (this.blockedAudioAppend = null, t.unblockAudio(e.op));
  }
  onBufferAppending(e, t) {
    const {
      tracks: n
    } = this, {
      data: s,
      type: r,
      parent: a,
      frag: o,
      part: l,
      chunkMeta: d,
      offset: c
    } = t, u = d.buffering[r], {
      sn: f,
      cc: h
    } = o, m = self.performance.now();
    u.start = m;
    const g = o.stats.buffering, v = l ? l.stats.buffering : null;
    g.start === 0 && (g.start = m), v && v.start === 0 && (v.start = m);
    const p = n.audio;
    let y = !1;
    r === "audio" && p?.container === "audio/mpeg" && (y = !this.lastMpegAudioChunk || d.id === 1 || this.lastMpegAudioChunk.sn !== d.sn, this.lastMpegAudioChunk = d);
    const b = n.video, k = b?.buffer;
    if (k && f !== "initSegment") {
      const x = l || o, E = this.blockedAudioAppend;
      if (r === "audio" && a !== "main" && !this.blockedAudioAppend && !(b.ending || b.ended)) {
        const A = x.start + x.duration * 0.05, _ = k.buffered, C = this.currentOp("video");
        !_.length && !C ? this.blockAudio(x) : !C && !Te.isBuffered(k, A) && this.lastVideoAppendEnd < A && this.blockAudio(x);
      } else if (r === "video") {
        const R = x.end;
        if (E) {
          const A = E.frag.start;
          (R > A || R < this.lastVideoAppendEnd || Te.isBuffered(k, A)) && this.unblockAudio();
        }
        this.lastVideoAppendEnd = R;
      }
    }
    const T = (l || o).start, I = {
      label: `append-${r}`,
      execute: () => {
        var x;
        u.executeStart = self.performance.now();
        const E = (x = this.tracks[r]) == null ? void 0 : x.buffer;
        E && (y ? this.updateTimestampOffset(E, T, 0.1, r, f, h) : c !== void 0 && ae(c) && this.updateTimestampOffset(E, c, 1e-6, r, f, h)), this.appendExecutor(s, r);
      },
      onStart: () => {
      },
      onComplete: () => {
        const x = self.performance.now();
        u.executeEnd = u.end = x, g.first === 0 && (g.first = x), v && v.first === 0 && (v.first = x);
        const E = {};
        this.sourceBuffers.forEach(([R, A]) => {
          R && (E[R] = Te.getBuffered(A));
        }), this.appendErrors[r] = 0, r === "audio" || r === "video" ? this.appendErrors.audiovideo = 0 : (this.appendErrors.audio = 0, this.appendErrors.video = 0), this.hls.trigger(S.BUFFER_APPENDED, {
          type: r,
          frag: o,
          part: l,
          chunkMeta: d,
          parent: o.type,
          timeRanges: E
        });
      },
      onError: (x) => {
        var E;
        const R = {
          type: pe.MEDIA_ERROR,
          parent: o.type,
          details: B.BUFFER_APPEND_ERROR,
          sourceBufferName: r,
          frag: o,
          part: l,
          chunkMeta: d,
          error: x,
          err: x,
          fatal: !1
        }, A = (E = this.media) == null ? void 0 : E.error;
        if (x.code === DOMException.QUOTA_EXCEEDED_ERR || x.name == "QuotaExceededError" || "quota" in x)
          R.details = B.BUFFER_FULL_ERROR;
        else if (x.code === DOMException.INVALID_STATE_ERR && this.mediaSourceOpenOrEnded && !A)
          R.errorAction = ws(!0);
        else if (x.name === Qh && this.sourceBufferCount === 0)
          R.errorAction = ws(!0);
        else {
          const _ = ++this.appendErrors[r];
          this.warn(`Failed ${_}/${this.hls.config.appendErrorMaxRetry} times to append segment in "${r}" sourceBuffer (${A || "no media error"})`), (_ >= this.hls.config.appendErrorMaxRetry || A) && (R.fatal = !0);
        }
        this.hls.trigger(S.ERROR, R);
      }
    };
    this.append(I, r, this.isPending(this.tracks[r]));
  }
  getFlushOp(e, t, n) {
    return this.log(`queuing "${e}" remove ${t}-${n}`), {
      label: "remove",
      execute: () => {
        this.removeExecutor(e, t, n);
      },
      onStart: () => {
      },
      onComplete: () => {
        this.hls.trigger(S.BUFFER_FLUSHED, {
          type: e
        });
      },
      onError: (s) => {
        this.warn(`Failed to remove ${t}-${n} from "${e}" SourceBuffer`, s);
      }
    };
  }
  onBufferFlushing(e, t) {
    const {
      type: n,
      startOffset: s,
      endOffset: r
    } = t;
    n ? this.append(this.getFlushOp(n, s, r), n) : this.sourceBuffers.forEach(([a]) => {
      a && this.append(this.getFlushOp(a, s, r), a);
    });
  }
  onFragParsed(e, t) {
    const {
      frag: n,
      part: s
    } = t, r = [], a = s ? s.elementaryStreams : n.elementaryStreams;
    a[ze.AUDIOVIDEO] ? r.push("audiovideo") : (a[ze.AUDIO] && r.push("audio"), a[ze.VIDEO] && r.push("video"));
    const o = () => {
      const l = self.performance.now();
      n.stats.buffering.end = l, s && (s.stats.buffering.end = l);
      const d = s ? s.stats : n.stats;
      this.hls.trigger(S.FRAG_BUFFERED, {
        frag: n,
        part: s,
        stats: d,
        id: n.type
      });
    };
    r.length === 0 && this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${n.type} level: ${n.level} sn: ${n.sn}`), this.blockBuffers(o, r).catch((l) => {
      this.warn(`Fragment buffered callback ${l}`), this.stepOperationQueue(this.sourceBufferTypes);
    });
  }
  onFragChanged(e, t) {
    this.trimBuffers();
  }
  get bufferedToEnd() {
    return this.sourceBufferCount > 0 && !this.sourceBuffers.some(([e]) => {
      if (e) {
        const t = this.tracks[e];
        if (t)
          return !t.ended || t.ending;
      }
      return !1;
    });
  }
  // on BUFFER_EOS mark matching sourcebuffer(s) as "ending" and "ended" and queue endOfStream after remaining operations(s)
  // an undefined data.type will mark all buffers as EOS.
  onBufferEos(e, t) {
    var n;
    this.sourceBuffers.forEach(([a]) => {
      if (a) {
        const o = this.tracks[a];
        (!t.type || t.type === a) && (o.ending = !0, o.ended || (o.ended = !0, this.log(`${a} buffer reached EOS`)));
      }
    });
    const s = ((n = this.overrides) == null ? void 0 : n.endOfStream) !== !1;
    this.sourceBufferCount > 0 && !this.sourceBuffers.some(([a]) => {
      var o;
      return a && !((o = this.tracks[a]) != null && o.ended);
    }) ? s ? (this.log("Queueing EOS"), this.blockUntilOpen(() => {
      this.tracksEnded();
      const {
        mediaSource: a
      } = this;
      if (!a || a.readyState !== "open") {
        a && this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${a.readyState}`);
        return;
      }
      this.log("Calling mediaSource.endOfStream()"), a.endOfStream(), this.hls.trigger(S.BUFFERED_TO_END, void 0);
    })) : (this.tracksEnded(), this.hls.trigger(S.BUFFERED_TO_END, void 0)) : t.type === "video" && this.unblockAudio();
  }
  tracksEnded() {
    this.sourceBuffers.forEach(([e]) => {
      if (e !== null) {
        const t = this.tracks[e];
        t && (t.ending = !1);
      }
    });
  }
  onLevelUpdated(e, {
    details: t
  }) {
    t.fragments.length && (this.details = t, this.updateDuration());
  }
  updateDuration() {
    this.blockUntilOpen(() => {
      const e = this.getDurationAndRange();
      e && this.updateMediaSource(e);
    });
  }
  onError(e, t) {
    if (t.details === B.BUFFER_APPEND_ERROR && t.frag) {
      var n;
      const s = (n = t.errorAction) == null ? void 0 : n.nextAutoLevel;
      ae(s) && s !== t.frag.level && this.resetAppendErrors();
    }
  }
  resetAppendErrors() {
    this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    };
  }
  trimBuffers() {
    const {
      hls: e,
      details: t,
      media: n
    } = this;
    if (!n || t === null || !this.sourceBufferCount)
      return;
    const s = e.config, r = n.currentTime, a = t.levelTargetDuration, o = t.live && s.liveBackBufferLength !== null ? s.liveBackBufferLength : s.backBufferLength;
    if (ae(o) && o >= 0) {
      const d = Math.max(o, a), c = Math.floor(r / a) * a - d;
      this.flushBackBuffer(r, a, c);
    }
    const l = s.frontBufferFlushThreshold;
    if (ae(l) && l > 0) {
      const d = Math.max(s.maxBufferLength, l), c = Math.max(d, a), u = Math.floor(r / a) * a + c;
      this.flushFrontBuffer(r, a, u);
    }
  }
  flushBackBuffer(e, t, n) {
    this.sourceBuffers.forEach(([s, r]) => {
      if (r) {
        const o = Te.getBuffered(r);
        if (o.length > 0 && n > o.start(0)) {
          var a;
          this.hls.trigger(S.BACK_BUFFER_REACHED, {
            bufferEnd: n
          });
          const l = this.tracks[s];
          if ((a = this.details) != null && a.live)
            this.hls.trigger(S.LIVE_BACK_BUFFER_REACHED, {
              bufferEnd: n
            });
          else if (l != null && l.ended) {
            this.log(`Cannot flush ${s} back buffer while SourceBuffer is in ended state`);
            return;
          }
          this.hls.trigger(S.BUFFER_FLUSHING, {
            startOffset: 0,
            endOffset: n,
            type: s
          });
        }
      }
    });
  }
  flushFrontBuffer(e, t, n) {
    this.sourceBuffers.forEach(([s, r]) => {
      if (r) {
        const a = Te.getBuffered(r), o = a.length;
        if (o < 2)
          return;
        const l = a.start(o - 1), d = a.end(o - 1);
        if (n > l || e >= l && e <= d)
          return;
        this.hls.trigger(S.BUFFER_FLUSHING, {
          startOffset: l,
          endOffset: 1 / 0,
          type: s
        });
      }
    });
  }
  /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */
  getDurationAndRange() {
    var e;
    const {
      details: t,
      mediaSource: n
    } = this;
    if (!t || !this.media || n?.readyState !== "open")
      return null;
    const s = t.edge;
    if (t.live && this.hls.config.liveDurationInfinity) {
      if (t.fragments.length && n.setLiveSeekableRange) {
        const d = Math.max(0, t.fragmentStart), c = Math.max(d, s);
        return {
          duration: 1 / 0,
          start: d,
          end: c
        };
      }
      return {
        duration: 1 / 0
      };
    }
    const r = (e = this.overrides) == null ? void 0 : e.duration;
    if (r)
      return ae(r) ? {
        duration: r
      } : null;
    const a = this.media.duration, o = ae(n.duration) ? n.duration : 0;
    return s > o && s > a || !ae(a) ? {
      duration: s
    } : null;
  }
  updateMediaSource({
    duration: e,
    start: t,
    end: n
  }) {
    const s = this.mediaSource;
    !this.media || !s || s.readyState !== "open" || (s.duration !== e && (ae(e) && this.log(`Updating MediaSource duration to ${e.toFixed(3)}`), s.duration = e), t !== void 0 && n !== void 0 && (this.log(`MediaSource duration is set to ${s.duration}. Setting seekable range to ${t}-${n}.`), s.setLiveSeekableRange(t, n)));
  }
  get tracksReady() {
    const e = this.pendingTrackCount;
    return e > 0 && (e >= this.bufferCodecEventsTotal || this.isPending(this.tracks.audiovideo));
  }
  checkPendingTracks() {
    const {
      bufferCodecEventsTotal: e,
      pendingTrackCount: t,
      tracks: n
    } = this;
    if (this.log(`checkPendingTracks (pending: ${t} codec events expected: ${e}) ${qe(n)}`), this.tracksReady) {
      var s;
      const r = (s = this.transferData) == null ? void 0 : s.tracks;
      r && Object.keys(r).length ? this.attachTransferred() : this.createSourceBuffers();
    }
  }
  bufferCreated() {
    if (this.sourceBufferCount) {
      const e = {};
      this.sourceBuffers.forEach(([t, n]) => {
        if (t) {
          const s = this.tracks[t];
          e[t] = {
            buffer: n,
            container: s.container,
            codec: s.codec,
            supplemental: s.supplemental,
            levelCodec: s.levelCodec,
            id: s.id,
            metadata: s.metadata
          };
        }
      }), this.hls.trigger(S.BUFFER_CREATED, {
        tracks: e
      }), this.log(`SourceBuffers created. Running queue: ${this.operationQueue}`), this.sourceBuffers.forEach(([t]) => {
        this.executeNext(t);
      });
    } else {
      const e = new Error("could not create source buffer for media codec(s)");
      this.hls.trigger(S.ERROR, {
        type: pe.MEDIA_ERROR,
        details: B.BUFFER_INCOMPATIBLE_CODECS_ERROR,
        fatal: !0,
        error: e,
        reason: e.message
      });
    }
  }
  createSourceBuffers() {
    const {
      tracks: e,
      sourceBuffers: t,
      mediaSource: n
    } = this;
    if (!n)
      throw new Error("createSourceBuffers called when mediaSource was null");
    for (const r in e) {
      const a = r, o = e[a];
      if (this.isPending(o)) {
        const l = this.getTrackCodec(o, a), d = `${o.container};codecs=${l}`;
        o.codec = l, this.log(`creating sourceBuffer(${d})${this.currentOp(a) ? " Queued" : ""} ${qe(o)}`);
        try {
          const c = n.addSourceBuffer(d), u = za(a), f = [a, c];
          t[u] = f, o.buffer = c;
        } catch (c) {
          var s;
          this.error(`error while trying to add sourceBuffer: ${c.message}`), this.shiftAndExecuteNext(a), (s = this.operationQueue) == null || s.removeBlockers(), delete this.tracks[a], this.hls.trigger(S.ERROR, {
            type: pe.MEDIA_ERROR,
            details: B.BUFFER_ADD_CODEC_ERROR,
            fatal: !1,
            error: c,
            sourceBufferName: a,
            mimeType: d,
            parent: o.id
          });
          return;
        }
        this.trackSourceBuffer(a, o);
      }
    }
    this.bufferCreated();
  }
  getTrackCodec(e, t) {
    const n = e.supplemental;
    let s = e.codec;
    n && (t === "video" || t === "audiovideo") && Lo(n, "video") && (s = p1(s, n));
    const r = cr(s, e.levelCodec);
    return r ? t.slice(0, 5) === "audio" ? Cr(r, this.appendSource) : r : "";
  }
  trackSourceBuffer(e, t) {
    const n = t.buffer;
    if (!n)
      return;
    const s = this.getTrackCodec(t, e);
    this.tracks[e] = {
      buffer: n,
      codec: s,
      container: t.container,
      levelCodec: t.levelCodec,
      supplemental: t.supplemental,
      metadata: t.metadata,
      id: t.id,
      listeners: []
    }, this.removeBufferListeners(e), this.addBufferListener(e, "updatestart", this.onSBUpdateStart), this.addBufferListener(e, "updateend", this.onSBUpdateEnd), this.addBufferListener(e, "error", this.onSBUpdateError), this.appendSource && this.addBufferListener(e, "bufferedchange", (r, a) => {
      const o = a.removedRanges;
      o != null && o.length && this.hls.trigger(S.BUFFER_FLUSHED, {
        type: r
      });
    });
  }
  get mediaSrc() {
    var e, t;
    const n = ((e = this.media) == null || (t = e.querySelector) == null ? void 0 : t.call(e, "source")) || this.media;
    return n?.src;
  }
  onSBUpdateStart(e) {
    const t = this.currentOp(e);
    t && t.onStart();
  }
  onSBUpdateEnd(e) {
    var t;
    if (((t = this.mediaSource) == null ? void 0 : t.readyState) === "closed") {
      this.resetBuffer(e);
      return;
    }
    const n = this.currentOp(e);
    n && (n.onComplete(), this.shiftAndExecuteNext(e));
  }
  onSBUpdateError(e, t) {
    var n;
    const s = new Error(`${e} SourceBuffer error. MediaSource readyState: ${(n = this.mediaSource) == null ? void 0 : n.readyState}`);
    this.error(`${s}`, t), this.hls.trigger(S.ERROR, {
      type: pe.MEDIA_ERROR,
      details: B.BUFFER_APPENDING_ERROR,
      sourceBufferName: e,
      error: s,
      fatal: !1
    });
    const r = this.currentOp(e);
    r && r.onError(s);
  }
  updateTimestampOffset(e, t, n, s, r, a) {
    const o = t - e.timestampOffset;
    Math.abs(o) >= n && (this.log(`Updating ${s} SourceBuffer timestampOffset to ${t} (sn: ${r} cc: ${a})`), e.timestampOffset = t);
  }
  // This method must result in an updateend event; if remove is not called, onSBUpdateEnd must be called manually
  removeExecutor(e, t, n) {
    const {
      media: s,
      mediaSource: r
    } = this, a = this.tracks[e], o = a?.buffer;
    if (!s || !r || !o) {
      this.warn(`Attempting to remove from the ${e} SourceBuffer, but it does not exist`), this.shiftAndExecuteNext(e);
      return;
    }
    const l = ae(s.duration) ? s.duration : 1 / 0, d = ae(r.duration) ? r.duration : 1 / 0, c = Math.max(0, t), u = Math.min(n, l, d);
    u > c && (!a.ending || a.ended) ? (a.ended = !1, this.log(`Removing [${c},${u}] from the ${e} SourceBuffer`), o.remove(c, u)) : this.shiftAndExecuteNext(e);
  }
  // This method must result in an updateend event; if append is not called, onSBUpdateEnd must be called manually
  appendExecutor(e, t) {
    const n = this.tracks[t], s = n?.buffer;
    if (!s)
      throw new xb(`Attempting to append to the ${t} SourceBuffer, but it does not exist`);
    n.ending = !1, n.ended = !1, s.appendBuffer(e);
  }
  blockUntilOpen(e) {
    if (this.isUpdating() || this.isQueued())
      this.blockBuffers(e).catch((t) => {
        this.warn(`SourceBuffer blocked callback ${t}`), this.stepOperationQueue(this.sourceBufferTypes);
      });
    else
      try {
        e();
      } catch (t) {
        this.warn(`Callback run without blocking ${this.operationQueue} ${t}`);
      }
  }
  isUpdating() {
    return this.sourceBuffers.some(([e, t]) => e && t.updating);
  }
  isQueued() {
    return this.sourceBuffers.some(([e]) => e && !!this.currentOp(e));
  }
  isPending(e) {
    return !!e && !e.buffer;
  }
  // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
  // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
  // upon completion, since we already do it here
  blockBuffers(e, t = this.sourceBufferTypes) {
    if (!t.length)
      return this.log("Blocking operation requested, but no SourceBuffers exist"), Promise.resolve().then(e);
    const {
      operationQueue: n
    } = this, s = t.map((a) => this.appendBlocker(a));
    return t.length > 1 && !!this.blockedAudioAppend && this.unblockAudio(), Promise.all(s).then((a) => {
      n === this.operationQueue && (e(), this.stepOperationQueue(this.sourceBufferTypes));
    });
  }
  stepOperationQueue(e) {
    e.forEach((t) => {
      var n;
      const s = (n = this.tracks[t]) == null ? void 0 : n.buffer;
      !s || s.updating || this.shiftAndExecuteNext(t);
    });
  }
  append(e, t, n) {
    this.operationQueue && this.operationQueue.append(e, t, n);
  }
  appendBlocker(e) {
    if (this.operationQueue)
      return this.operationQueue.appendBlocker(e);
  }
  currentOp(e) {
    return this.operationQueue ? this.operationQueue.current(e) : null;
  }
  executeNext(e) {
    e && this.operationQueue && this.operationQueue.executeNext(e);
  }
  shiftAndExecuteNext(e) {
    this.operationQueue && this.operationQueue.shiftAndExecuteNext(e);
  }
  get pendingTrackCount() {
    return Object.keys(this.tracks).reduce((e, t) => e + (this.isPending(this.tracks[t]) ? 1 : 0), 0);
  }
  get sourceBufferCount() {
    return this.sourceBuffers.reduce((e, [t]) => e + (t ? 1 : 0), 0);
  }
  get sourceBufferTypes() {
    return this.sourceBuffers.map(([e]) => e).filter((e) => !!e);
  }
  addBufferListener(e, t, n) {
    const s = this.tracks[e];
    if (!s)
      return;
    const r = s.buffer;
    if (!r)
      return;
    const a = n.bind(this, e);
    s.listeners.push({
      event: t,
      listener: a
    }), r.addEventListener(t, a);
  }
  removeBufferListeners(e) {
    const t = this.tracks[e];
    if (!t)
      return;
    const n = t.buffer;
    n && (t.listeners.forEach((s) => {
      n.removeEventListener(s.event, s.listener);
    }), t.listeners.length = 0);
  }
}
function Wc(i) {
  const e = i.querySelectorAll("source");
  [].slice.call(e).forEach((t) => {
    i.removeChild(t);
  });
}
function Ab(i, e) {
  const t = self.document.createElement("source");
  t.type = "video/mp4", t.src = e, i.appendChild(t);
}
function za(i) {
  return i === "audio" ? 1 : 0;
}
class Ol {
  constructor(e) {
    this.hls = void 0, this.autoLevelCapping = void 0, this.firstLevel = void 0, this.media = void 0, this.restrictedLevels = void 0, this.timer = void 0, this.clientRect = void 0, this.streamController = void 0, this.hls = e, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.firstLevel = -1, this.media = null, this.restrictedLevels = [], this.timer = void 0, this.clientRect = null, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  destroy() {
    this.hls && this.unregisterListener(), this.timer && this.stopCapping(), this.media = null, this.clientRect = null, this.hls = this.streamController = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(S.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.on(S.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(S.MANIFEST_PARSED, this.onManifestParsed, this), e.on(S.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(S.BUFFER_CODECS, this.onBufferCodecs, this), e.on(S.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListener() {
    const {
      hls: e
    } = this;
    e.off(S.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.off(S.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(S.MANIFEST_PARSED, this.onManifestParsed, this), e.off(S.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(S.BUFFER_CODECS, this.onBufferCodecs, this), e.off(S.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  onFpsDropLevelCapping(e, t) {
    const n = this.hls.levels[t.droppedLevel];
    this.isLevelAllowed(n) && this.restrictedLevels.push({
      bitrate: n.bitrate,
      height: n.height,
      width: n.width
    });
  }
  onMediaAttaching(e, t) {
    this.media = t.media instanceof HTMLVideoElement ? t.media : null, this.clientRect = null, this.timer && this.hls.levels.length && this.detectPlayerSize();
  }
  onManifestParsed(e, t) {
    const n = this.hls;
    this.restrictedLevels = [], this.firstLevel = t.firstLevel, n.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onLevelsUpdated(e, t) {
    this.timer && ae(this.autoLevelCapping) && this.detectPlayerSize();
  }
  // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
  // to the first level
  onBufferCodecs(e, t) {
    this.hls.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onMediaDetaching() {
    this.stopCapping(), this.media = null;
  }
  detectPlayerSize() {
    if (this.media) {
      if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
        this.clientRect = null;
        return;
      }
      const e = this.hls.levels;
      if (e.length) {
        const t = this.hls, n = this.getMaxLevel(e.length - 1);
        n !== this.autoLevelCapping && t.logger.log(`Setting autoLevelCapping to ${n}: ${e[n].height}p@${e[n].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`), t.autoLevelCapping = n, t.autoLevelEnabled && t.autoLevelCapping > this.autoLevelCapping && this.streamController && this.streamController.nextLevelSwitch(), this.autoLevelCapping = t.autoLevelCapping;
      }
    }
  }
  /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */
  getMaxLevel(e) {
    const t = this.hls.levels;
    if (!t.length)
      return -1;
    const n = t.filter((s, r) => this.isLevelAllowed(s) && r <= e);
    return this.clientRect = null, Ol.getMaxLevelByMediaSize(n, this.mediaWidth, this.mediaHeight);
  }
  startCapping() {
    this.timer || (this.autoLevelCapping = Number.POSITIVE_INFINITY, self.clearInterval(this.timer), this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
  }
  stopCapping() {
    this.restrictedLevels = [], this.firstLevel = -1, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (self.clearInterval(this.timer), this.timer = void 0);
  }
  getDimensions() {
    if (this.clientRect)
      return this.clientRect;
    const e = this.media, t = {
      width: 0,
      height: 0
    };
    if (e) {
      const n = e.getBoundingClientRect();
      t.width = n.width, t.height = n.height, !t.width && !t.height && (t.width = n.right - n.left || e.width || 0, t.height = n.bottom - n.top || e.height || 0);
    }
    return this.clientRect = t, t;
  }
  get mediaWidth() {
    return this.getDimensions().width * this.contentScaleFactor;
  }
  get mediaHeight() {
    return this.getDimensions().height * this.contentScaleFactor;
  }
  get contentScaleFactor() {
    let e = 1;
    if (!this.hls.config.ignoreDevicePixelRatio)
      try {
        e = self.devicePixelRatio;
      } catch {
      }
    return Math.min(e, this.hls.config.maxDevicePixelRatio);
  }
  isLevelAllowed(e) {
    return !this.restrictedLevels.some((n) => e.bitrate === n.bitrate && e.width === n.width && e.height === n.height);
  }
  static getMaxLevelByMediaSize(e, t, n) {
    if (!(e != null && e.length))
      return -1;
    const s = (o, l) => l ? o.width !== l.width || o.height !== l.height : !0;
    let r = e.length - 1;
    const a = Math.max(t, n);
    for (let o = 0; o < e.length; o += 1) {
      const l = e[o];
      if ((l.width >= a || l.height >= a) && s(l, e[o + 1])) {
        r = o;
        break;
      }
    }
    return r;
  }
}
const wb = {
  /**
   * text file, such as a manifest or playlist
   */
  MANIFEST: "m",
  /**
   * audio only
   */
  AUDIO: "a",
  /**
   * video only
   */
  VIDEO: "v",
  /**
   * muxed audio and video
   */
  MUXED: "av",
  /**
   * init segment
   */
  INIT: "i",
  /**
   * ISOBMFF timed text track
   */
  TIMED_TEXT: "tt"
}, It = wb, Lb = {
  /**
   * HTTP Live Streaming (HLS)
   */
  HLS: "h"
}, Ib = Lb;
class vi {
  constructor(e, t) {
    Array.isArray(e) && (e = e.map((n) => n instanceof vi ? n : new vi(n))), this.value = e, this.params = t;
  }
}
const Cb = "Dict";
function Rb(i) {
  return Array.isArray(i) ? JSON.stringify(i) : i instanceof Map ? "Map{}" : i instanceof Set ? "Set{}" : typeof i == "object" ? JSON.stringify(i) : String(i);
}
function Pb(i, e, t, n) {
  return new Error(`failed to ${i} "${Rb(e)}" as ${t}`, {
    cause: n
  });
}
function yi(i, e, t) {
  return Pb("serialize", i, e, t);
}
class Jh {
  constructor(e) {
    this.description = e;
  }
}
const qc = "Bare Item", Db = "Boolean";
function Nb(i) {
  if (typeof i != "boolean")
    throw yi(i, Db);
  return i ? "?1" : "?0";
}
function Mb(i) {
  return btoa(String.fromCharCode(...i));
}
const Ob = "Byte Sequence";
function Fb(i) {
  if (ArrayBuffer.isView(i) === !1)
    throw yi(i, Ob);
  return `:${Mb(i)}:`;
}
const $b = "Integer";
function Bb(i) {
  return i < -999999999999999 || 999999999999999 < i;
}
function em(i) {
  if (Bb(i))
    throw yi(i, $b);
  return i.toString();
}
function Ub(i) {
  return `@${em(i.getTime() / 1e3)}`;
}
function tm(i, e) {
  if (i < 0)
    return -tm(-i, e);
  const t = Math.pow(10, e);
  if (Math.abs(i * t % 1 - 0.5) < Number.EPSILON) {
    const s = Math.floor(i * t);
    return (s % 2 === 0 ? s : s + 1) / t;
  } else
    return Math.round(i * t) / t;
}
const Vb = "Decimal";
function Gb(i) {
  const e = tm(i, 3);
  if (Math.floor(Math.abs(e)).toString().length > 12)
    throw yi(i, Vb);
  const t = e.toString();
  return t.includes(".") ? t : `${t}.0`;
}
const Hb = "String", zb = /[\x00-\x1f\x7f]+/;
function Kb(i) {
  if (zb.test(i))
    throw yi(i, Hb);
  return `"${i.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}
function jb(i) {
  return i.description || i.toString().slice(7, -1);
}
const Wb = "Token";
function Yc(i) {
  const e = jb(i);
  if (/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(e) === !1)
    throw yi(e, Wb);
  return e;
}
function $o(i) {
  switch (typeof i) {
    case "number":
      if (!ae(i))
        throw yi(i, qc);
      return Number.isInteger(i) ? em(i) : Gb(i);
    case "string":
      return Kb(i);
    case "symbol":
      return Yc(i);
    case "boolean":
      return Nb(i);
    case "object":
      if (i instanceof Date)
        return Ub(i);
      if (i instanceof Uint8Array)
        return Fb(i);
      if (i instanceof Jh)
        return Yc(i);
    default:
      throw yi(i, qc);
  }
}
const qb = "Key";
function Bo(i) {
  if (/^[a-z*][a-z0-9\-_.*]*$/.test(i) === !1)
    throw yi(i, qb);
  return i;
}
function Fl(i) {
  return i == null ? "" : Object.entries(i).map(([e, t]) => t === !0 ? `;${Bo(e)}` : `;${Bo(e)}=${$o(t)}`).join("");
}
function im(i) {
  return i instanceof vi ? `${$o(i.value)}${Fl(i.params)}` : $o(i);
}
function Yb(i) {
  return `(${i.value.map(im).join(" ")})${Fl(i.params)}`;
}
function Xb(i, e = {
  whitespace: !0
}) {
  if (typeof i != "object" || i == null)
    throw yi(i, Cb);
  const t = i instanceof Map ? i.entries() : Object.entries(i), n = e?.whitespace ? " " : "";
  return Array.from(t).map(([s, r]) => {
    r instanceof vi || (r = new vi(r));
    let a = Bo(s);
    return r.value === !0 ? a += Fl(r.params) : (a += "=", Array.isArray(r.value) ? a += Yb(r) : a += im(r)), a;
  }).join(`,${n}`);
}
function nm(i, e) {
  return Xb(i, e);
}
const oi = "CMCD-Object", Qe = "CMCD-Request", cn = "CMCD-Session", $i = "CMCD-Status", Zb = {
  // Object
  br: oi,
  ab: oi,
  d: oi,
  ot: oi,
  tb: oi,
  tpb: oi,
  lb: oi,
  tab: oi,
  lab: oi,
  url: oi,
  // Request
  pb: Qe,
  bl: Qe,
  tbl: Qe,
  dl: Qe,
  ltc: Qe,
  mtp: Qe,
  nor: Qe,
  nrr: Qe,
  rc: Qe,
  sn: Qe,
  sta: Qe,
  su: Qe,
  ttfb: Qe,
  ttfbb: Qe,
  ttlb: Qe,
  cmsdd: Qe,
  cmsds: Qe,
  smrt: Qe,
  df: Qe,
  cs: Qe,
  // TODO: Which header to put the `ts` field is not defined yet.
  ts: Qe,
  // Session
  cid: cn,
  pr: cn,
  sf: cn,
  sid: cn,
  st: cn,
  v: cn,
  msd: cn,
  // Status
  bs: $i,
  bsd: $i,
  cdn: $i,
  rtp: $i,
  bg: $i,
  pt: $i,
  ec: $i,
  e: $i
}, Qb = {
  /**
   * keys whose values vary with each request.
   */
  REQUEST: Qe
};
function Jb(i) {
  return Object.keys(i).reduce((e, t) => {
    var n;
    return (n = i[t]) === null || n === void 0 || n.forEach((s) => e[s] = t), e;
  }, {});
}
function eS(i, e) {
  const t = {};
  if (!i)
    return t;
  const n = Object.keys(i), s = e ? Jb(e) : {};
  return n.reduce((r, a) => {
    var o;
    const l = Zb[a] || s[a] || Qb.REQUEST, d = (o = r[l]) !== null && o !== void 0 ? o : r[l] = {};
    return d[a] = i[a], r;
  }, t);
}
function tS(i) {
  return ["ot", "sf", "st", "e", "sta"].includes(i);
}
function iS(i) {
  return typeof i == "number" ? ae(i) : i != null && i !== "" && i !== !1;
}
const sm = "event";
function nS(i, e) {
  const t = new URL(i), n = new URL(e);
  if (t.origin !== n.origin)
    return i;
  const s = t.pathname.split("/").slice(1), r = n.pathname.split("/").slice(1, -1);
  for (; s[0] === r[0]; )
    s.shift(), r.shift();
  for (; r.length; )
    r.shift(), s.unshift("..");
  return s.join("/") + t.search + t.hash;
}
const pr = (i) => Math.round(i), Uo = (i, e) => Array.isArray(i) ? i.map((t) => Uo(t, e)) : i instanceof vi && typeof i.value == "string" ? new vi(Uo(i.value, e), i.params) : (e.baseUrl && (i = nS(i, e.baseUrl)), e.version === 1 ? encodeURIComponent(i) : i), Zs = (i) => pr(i / 100) * 100, sS = (i, e) => {
  let t = i;
  return e.version >= 2 && (i instanceof vi && typeof i.value == "string" ? t = new vi([i]) : typeof i == "string" && (t = [i])), Uo(t, e);
}, rS = {
  /**
   * Bitrate (kbps) rounded integer
   */
  br: pr,
  /**
   * Duration (milliseconds) rounded integer
   */
  d: pr,
  /**
   * Buffer Length (milliseconds) rounded nearest 100ms
   */
  bl: Zs,
  /**
   * Deadline (milliseconds) rounded nearest 100ms
   */
  dl: Zs,
  /**
   * Measured Throughput (kbps) rounded nearest 100kbps
   */
  mtp: Zs,
  /**
   * Next Object Request URL encoded
   */
  nor: sS,
  /**
   * Requested maximum throughput (kbps) rounded nearest 100kbps
   */
  rtp: Zs,
  /**
   * Top Bitrate (kbps) rounded integer
   */
  tb: pr
}, rm = "request", am = "response", $l = ["ab", "bg", "bl", "br", "bs", "bsd", "cdn", "cid", "cs", "df", "ec", "lab", "lb", "ltc", "msd", "mtp", "pb", "pr", "pt", "sf", "sid", "sn", "st", "sta", "tab", "tb", "tbl", "tpb", "ts", "v"], aS = ["e"], oS = /^[a-zA-Z0-9-.]+-[a-zA-Z0-9-.]+$/;
function va(i) {
  return oS.test(i);
}
function lS(i) {
  return $l.includes(i) || aS.includes(i) || va(i);
}
const om = ["d", "dl", "nor", "ot", "rtp", "su"];
function dS(i) {
  return $l.includes(i) || om.includes(i) || va(i);
}
const cS = ["cmsdd", "cmsds", "rc", "smrt", "ttfb", "ttfbb", "ttlb", "url"];
function uS(i) {
  return $l.includes(i) || om.includes(i) || cS.includes(i) || va(i);
}
const fS = ["bl", "br", "bs", "cid", "d", "dl", "mtp", "nor", "nrr", "ot", "pr", "rtp", "sf", "sid", "st", "su", "tb", "v"];
function hS(i) {
  return fS.includes(i) || va(i);
}
const mS = {
  [am]: uS,
  [sm]: lS,
  [rm]: dS
};
function lm(i, e = {}) {
  const t = {};
  if (i == null || typeof i != "object")
    return t;
  const n = e.version || i.v || 1, s = e.reportingMode || rm, r = n === 1 ? hS : mS[s];
  let a = Object.keys(i).filter(r);
  const o = e.filter;
  typeof o == "function" && (a = a.filter(o));
  const l = s === am || s === sm;
  l && !a.includes("ts") && a.push("ts"), n > 1 && !a.includes("v") && a.push("v");
  const d = He({}, rS, e.formatters), c = {
    version: n,
    reportingMode: s,
    baseUrl: e.baseUrl
  };
  return a.sort().forEach((u) => {
    let f = i[u];
    const h = d[u];
    if (typeof h == "function" && (f = h(f, c)), u === "v") {
      if (n === 1)
        return;
      f = n;
    }
    u == "pr" && f === 1 || (l && u === "ts" && !ae(f) && (f = Date.now()), iS(f) && (tS(u) && typeof f == "string" && (f = new Jh(f)), t[u] = f));
  }), t;
}
function pS(i, e = {}) {
  const t = {};
  if (!i)
    return t;
  const n = lm(i, e), s = eS(n, e?.customHeaderMap);
  return Object.entries(s).reduce((r, [a, o]) => {
    const l = nm(o, {
      whitespace: !1
    });
    return l && (r[a] = l), r;
  }, t);
}
function gS(i, e, t) {
  return He(i, pS(e, t));
}
const vS = "CMCD";
function yS(i, e = {}) {
  return i ? nm(lm(i, e), {
    whitespace: !1
  }) : "";
}
function bS(i, e = {}) {
  if (!i)
    return "";
  const t = yS(i, e);
  return encodeURIComponent(t);
}
function SS(i, e = {}) {
  if (!i)
    return "";
  const t = bS(i, e);
  return `${vS}=${t}`;
}
const Xc = /CMCD=[^&#]+/;
function kS(i, e, t) {
  const n = SS(e, t);
  if (!n)
    return i;
  if (Xc.test(i))
    return i.replace(Xc, n);
  const s = i.includes("?") ? "&" : "?";
  return `${i}${s}${n}`;
}
class TS {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = void 0, this.sid = void 0, this.cid = void 0, this.useHeaders = !1, this.includeKeys = void 0, this.initialized = !1, this.starved = !1, this.buffering = !0, this.audioBuffer = void 0, this.videoBuffer = void 0, this.onWaiting = () => {
      this.initialized && (this.starved = !0), this.buffering = !0;
    }, this.onPlaying = () => {
      this.initialized || (this.initialized = !0), this.buffering = !1;
    }, this.applyPlaylistData = (s) => {
      try {
        this.apply(s, {
          ot: It.MANIFEST,
          su: !this.initialized
        });
      } catch (r) {
        this.hls.logger.warn("Could not generate manifest CMCD data.", r);
      }
    }, this.applyFragmentData = (s) => {
      try {
        const {
          frag: r,
          part: a
        } = s, o = this.hls.levels[r.level], l = this.getObjectType(r), d = {
          d: (a || r).duration * 1e3,
          ot: l
        };
        (l === It.VIDEO || l === It.AUDIO || l == It.MUXED) && (d.br = o.bitrate / 1e3, d.tb = this.getTopBandwidth(l) / 1e3, d.bl = this.getBufferLength(l));
        const c = a ? this.getNextPart(a) : this.getNextFrag(r);
        c != null && c.url && c.url !== r.url && (d.nor = c.url), this.apply(s, d);
      } catch (r) {
        this.hls.logger.warn("Could not generate segment CMCD data.", r);
      }
    }, this.hls = e;
    const t = this.config = e.config, {
      cmcd: n
    } = t;
    n != null && (t.pLoader = this.createPlaylistLoader(), t.fLoader = this.createFragmentLoader(), this.sid = n.sessionId || e.sessionId, this.cid = n.contentId, this.useHeaders = n.useHeaders === !0, this.includeKeys = n.includeKeys, this.registerListeners());
  }
  registerListeners() {
    const e = this.hls;
    e.on(S.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(S.MEDIA_DETACHED, this.onMediaDetached, this), e.on(S.BUFFER_CREATED, this.onBufferCreated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e.off(S.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(S.MEDIA_DETACHED, this.onMediaDetached, this), e.off(S.BUFFER_CREATED, this.onBufferCreated, this);
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached(), this.hls = this.config = this.audioBuffer = this.videoBuffer = null, this.onWaiting = this.onPlaying = this.media = null;
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("waiting", this.onWaiting), this.media.addEventListener("playing", this.onPlaying);
  }
  onMediaDetached() {
    this.media && (this.media.removeEventListener("waiting", this.onWaiting), this.media.removeEventListener("playing", this.onPlaying), this.media = null);
  }
  onBufferCreated(e, t) {
    var n, s;
    this.audioBuffer = (n = t.tracks.audio) == null ? void 0 : n.buffer, this.videoBuffer = (s = t.tracks.video) == null ? void 0 : s.buffer;
  }
  /**
   * Create baseline CMCD data
   */
  createData() {
    var e;
    return {
      v: 1,
      sf: Ib.HLS,
      sid: this.sid,
      cid: this.cid,
      pr: (e = this.media) == null ? void 0 : e.playbackRate,
      mtp: this.hls.bandwidthEstimate / 1e3
    };
  }
  /**
   * Apply CMCD data to a request.
   */
  apply(e, t = {}) {
    He(t, this.createData());
    const n = t.ot === It.INIT || t.ot === It.VIDEO || t.ot === It.MUXED;
    this.starved && n && (t.bs = !0, t.su = !0, this.starved = !1), t.su == null && (t.su = this.buffering);
    const {
      includeKeys: s
    } = this;
    s && (t = Object.keys(t).reduce((a, o) => (s.includes(o) && (a[o] = t[o]), a), {}));
    const r = {
      baseUrl: e.url
    };
    this.useHeaders ? (e.headers || (e.headers = {}), gS(e.headers, t, r)) : e.url = kS(e.url, t, r);
  }
  getNextFrag(e) {
    var t;
    const n = (t = this.hls.levels[e.level]) == null ? void 0 : t.details;
    if (n) {
      const s = e.sn - n.startSN;
      return n.fragments[s + 1];
    }
  }
  getNextPart(e) {
    var t;
    const {
      index: n,
      fragment: s
    } = e, r = (t = this.hls.levels[s.level]) == null || (t = t.details) == null ? void 0 : t.partList;
    if (r) {
      const {
        sn: a
      } = s;
      for (let o = r.length - 1; o >= 0; o--) {
        const l = r[o];
        if (l.index === n && l.fragment.sn === a)
          return r[o + 1];
      }
    }
  }
  /**
   * The CMCD object type.
   */
  getObjectType(e) {
    const {
      type: t
    } = e;
    if (t === "subtitle")
      return It.TIMED_TEXT;
    if (e.sn === "initSegment")
      return It.INIT;
    if (t === "audio")
      return It.AUDIO;
    if (t === "main")
      return this.hls.audioTracks.length ? It.VIDEO : It.MUXED;
  }
  /**
   * Get the highest bitrate.
   */
  getTopBandwidth(e) {
    let t = 0, n;
    const s = this.hls;
    if (e === It.AUDIO)
      n = s.audioTracks;
    else {
      const r = s.maxAutoLevel, a = r > -1 ? r + 1 : s.levels.length;
      n = s.levels.slice(0, a);
    }
    return n.forEach((r) => {
      r.bitrate > t && (t = r.bitrate);
    }), t > 0 ? t : NaN;
  }
  /**
   * Get the buffer length for a media type in milliseconds
   */
  getBufferLength(e) {
    const t = this.media, n = e === It.AUDIO ? this.audioBuffer : this.videoBuffer;
    return !n || !t ? NaN : Te.bufferInfo(n, t.currentTime, this.config.maxBufferHole).len * 1e3;
  }
  /**
   * Create a playlist loader
   */
  createPlaylistLoader() {
    const {
      pLoader: e
    } = this.config, t = this.applyPlaylistData, n = e || this.config.loader;
    return class {
      constructor(r) {
        this.loader = void 0, this.loader = new n(r);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(r, a, o) {
        t(r), this.loader.load(r, a, o);
      }
    };
  }
  /**
   * Create a playlist loader
   */
  createFragmentLoader() {
    const {
      fLoader: e
    } = this.config, t = this.applyFragmentData, n = e || this.config.loader;
    return class {
      constructor(r) {
        this.loader = void 0, this.loader = new n(r);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(r, a, o) {
        t(r), this.loader.load(r, a, o);
      }
    };
  }
}
const ES = 3e5;
class xS extends ni {
  constructor(e) {
    super("content-steering", e.logger), this.hls = void 0, this.loader = null, this.uri = null, this.pathwayId = ".", this._pathwayPriority = null, this.timeToLoad = 300, this.reloadTimer = -1, this.updated = 0, this.started = !1, this.enabled = !0, this.levels = null, this.audioTracks = null, this.subtitleTracks = null, this.penalizedPathways = {}, this.hls = e, this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(S.MANIFEST_LOADING, this.onManifestLoading, this), e.on(S.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(S.MANIFEST_PARSED, this.onManifestParsed, this), e.on(S.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(S.MANIFEST_LOADING, this.onManifestLoading, this), e.off(S.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(S.MANIFEST_PARSED, this.onManifestParsed, this), e.off(S.ERROR, this.onError, this));
  }
  pathways() {
    return (this.levels || []).reduce((e, t) => (e.indexOf(t.pathwayId) === -1 && e.push(t.pathwayId), e), []);
  }
  get pathwayPriority() {
    return this._pathwayPriority;
  }
  set pathwayPriority(e) {
    this.updatePathwayPriority(e);
  }
  startLoad() {
    if (this.started = !0, this.clearTimeout(), this.enabled && this.uri) {
      if (this.updated) {
        const e = this.timeToLoad * 1e3 - (performance.now() - this.updated);
        if (e > 0) {
          this.scheduleRefresh(this.uri, e);
          return;
        }
      }
      this.loadSteeringManifest(this.uri);
    }
  }
  stopLoad() {
    this.started = !1, this.loader && (this.loader.destroy(), this.loader = null), this.clearTimeout();
  }
  clearTimeout() {
    this.reloadTimer !== -1 && (self.clearTimeout(this.reloadTimer), this.reloadTimer = -1);
  }
  destroy() {
    this.unregisterListeners(), this.stopLoad(), this.hls = null, this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  removeLevel(e) {
    const t = this.levels;
    t && (this.levels = t.filter((n) => n !== e));
  }
  onManifestLoading() {
    this.stopLoad(), this.enabled = !0, this.timeToLoad = 300, this.updated = 0, this.uri = null, this.pathwayId = ".", this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  onManifestLoaded(e, t) {
    const {
      contentSteering: n
    } = t;
    n !== null && (this.pathwayId = n.pathwayId, this.uri = n.uri, this.started && this.startLoad());
  }
  onManifestParsed(e, t) {
    this.audioTracks = t.audioTracks, this.subtitleTracks = t.subtitleTracks;
  }
  onError(e, t) {
    const {
      errorAction: n
    } = t;
    if (n?.action === vt.SendAlternateToPenaltyBox && n.flags === ei.MoveAllAlternatesMatchingHost) {
      const s = this.levels;
      let r = this._pathwayPriority, a = this.pathwayId;
      if (t.context) {
        const {
          groupId: o,
          pathwayId: l,
          type: d
        } = t.context;
        o && s ? a = this.getPathwayForGroupId(o, d, a) : l && (a = l);
      }
      a in this.penalizedPathways || (this.penalizedPathways[a] = performance.now()), !r && s && (r = this.pathways()), r && r.length > 1 && (this.updatePathwayPriority(r), n.resolved = this.pathwayId !== a), t.details === B.BUFFER_APPEND_ERROR && !t.fatal ? n.resolved = !0 : n.resolved || this.warn(`Could not resolve ${t.details} ("${t.error.message}") with content-steering for Pathway: ${a} levels: ${s && s.length} priorities: ${qe(r)} penalized: ${qe(this.penalizedPathways)}`);
    }
  }
  filterParsedLevels(e) {
    this.levels = e;
    let t = this.getLevelsForPathway(this.pathwayId);
    if (t.length === 0) {
      const n = e[0].pathwayId;
      this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${n}"`), t = this.getLevelsForPathway(n), this.pathwayId = n;
    }
    return t.length !== e.length && this.log(`Found ${t.length}/${e.length} levels in Pathway "${this.pathwayId}"`), t;
  }
  getLevelsForPathway(e) {
    return this.levels === null ? [] : this.levels.filter((t) => e === t.pathwayId);
  }
  updatePathwayPriority(e) {
    this._pathwayPriority = e;
    let t;
    const n = this.penalizedPathways, s = performance.now();
    Object.keys(n).forEach((r) => {
      s - n[r] > ES && delete n[r];
    });
    for (let r = 0; r < e.length; r++) {
      const a = e[r];
      if (a in n)
        continue;
      if (a === this.pathwayId)
        return;
      const o = this.hls.nextLoadLevel, l = this.hls.levels[o];
      if (t = this.getLevelsForPathway(a), t.length > 0) {
        this.log(`Setting Pathway to "${a}"`), this.pathwayId = a, Lh(t), this.hls.trigger(S.LEVELS_UPDATED, {
          levels: t
        });
        const d = this.hls.levels[o];
        l && d && this.levels && (d.attrs["STABLE-VARIANT-ID"] !== l.attrs["STABLE-VARIANT-ID"] && d.bitrate !== l.bitrate && this.log(`Unstable Pathways change from bitrate ${l.bitrate} to ${d.bitrate}`), this.hls.nextLoadLevel = o);
        break;
      }
    }
  }
  getPathwayForGroupId(e, t, n) {
    const s = this.getLevelsForPathway(n).concat(this.levels || []);
    for (let r = 0; r < s.length; r++)
      if (t === Le.AUDIO_TRACK && s[r].hasAudioGroup(e) || t === Le.SUBTITLE_TRACK && s[r].hasSubtitleGroup(e))
        return s[r].pathwayId;
    return n;
  }
  clonePathways(e) {
    const t = this.levels;
    if (!t)
      return;
    const n = {}, s = {};
    e.forEach((r) => {
      const {
        ID: a,
        "BASE-ID": o,
        "URI-REPLACEMENT": l
      } = r;
      if (t.some((c) => c.pathwayId === a))
        return;
      const d = this.getLevelsForPathway(o).map((c) => {
        const u = new Ye(c.attrs);
        u["PATHWAY-ID"] = a;
        const f = u.AUDIO && `${u.AUDIO}_clone_${a}`, h = u.SUBTITLES && `${u.SUBTITLES}_clone_${a}`;
        f && (n[u.AUDIO] = f, u.AUDIO = f), h && (s[u.SUBTITLES] = h, u.SUBTITLES = h);
        const m = dm(c.uri, u["STABLE-VARIANT-ID"], "PER-VARIANT-URIS", l), g = new As({
          attrs: u,
          audioCodec: c.audioCodec,
          bitrate: c.bitrate,
          height: c.height,
          name: c.name,
          url: m,
          videoCodec: c.videoCodec,
          width: c.width
        });
        if (c.audioGroups)
          for (let v = 1; v < c.audioGroups.length; v++)
            g.addGroupId("audio", `${c.audioGroups[v]}_clone_${a}`);
        if (c.subtitleGroups)
          for (let v = 1; v < c.subtitleGroups.length; v++)
            g.addGroupId("text", `${c.subtitleGroups[v]}_clone_${a}`);
        return g;
      });
      t.push(...d), Zc(this.audioTracks, n, l, a), Zc(this.subtitleTracks, s, l, a);
    });
  }
  loadSteeringManifest(e) {
    const t = this.hls.config, n = t.loader;
    this.loader && this.loader.destroy(), this.loader = new n(t);
    let s;
    try {
      s = new self.URL(e);
    } catch {
      this.enabled = !1, this.log(`Failed to parse Steering Manifest URI: ${e}`);
      return;
    }
    if (s.protocol !== "data:") {
      const c = (this.hls.bandwidthEstimate || t.abrEwmaDefaultEstimate) | 0;
      s.searchParams.set("_HLS_pathway", this.pathwayId), s.searchParams.set("_HLS_throughput", "" + c);
    }
    const r = {
      responseType: "json",
      url: s.href
    }, a = t.steeringManifestLoadPolicy.default, o = a.errorRetry || a.timeoutRetry || {}, l = {
      loadPolicy: a,
      timeout: a.maxLoadTimeMs,
      maxRetry: o.maxNumRetry || 0,
      retryDelay: o.retryDelayMs || 0,
      maxRetryDelay: o.maxRetryDelayMs || 0
    }, d = {
      onSuccess: (c, u, f, h) => {
        this.log(`Loaded steering manifest: "${s}"`);
        const m = c.data;
        if (m?.VERSION !== 1) {
          this.log(`Steering VERSION ${m.VERSION} not supported!`);
          return;
        }
        this.updated = performance.now(), this.timeToLoad = m.TTL;
        const {
          "RELOAD-URI": g,
          "PATHWAY-CLONES": v,
          "PATHWAY-PRIORITY": p
        } = m;
        if (g)
          try {
            this.uri = new self.URL(g, s).href;
          } catch {
            this.enabled = !1, this.log(`Failed to parse Steering Manifest RELOAD-URI: ${g}`);
            return;
          }
        this.scheduleRefresh(this.uri || f.url), v && this.clonePathways(v);
        const y = {
          steeringManifest: m,
          url: s.toString()
        };
        this.hls.trigger(S.STEERING_MANIFEST_LOADED, y), p && this.updatePathwayPriority(p);
      },
      onError: (c, u, f, h) => {
        if (this.log(`Error loading steering manifest: ${c.code} ${c.text} (${u.url})`), this.stopLoad(), c.code === 410) {
          this.enabled = !1, this.log(`Steering manifest ${u.url} no longer available`);
          return;
        }
        let m = this.timeToLoad * 1e3;
        if (c.code === 429) {
          const g = this.loader;
          if (typeof g?.getResponseHeader == "function") {
            const v = g.getResponseHeader("Retry-After");
            v && (m = parseFloat(v) * 1e3);
          }
          this.log(`Steering manifest ${u.url} rate limited`);
          return;
        }
        this.scheduleRefresh(this.uri || u.url, m);
      },
      onTimeout: (c, u, f) => {
        this.log(`Timeout loading steering manifest (${u.url})`), this.scheduleRefresh(this.uri || u.url);
      }
    };
    this.log(`Requesting steering manifest: ${s}`), this.loader.load(r, l, d);
  }
  scheduleRefresh(e, t = this.timeToLoad * 1e3) {
    this.clearTimeout(), this.reloadTimer = self.setTimeout(() => {
      var n;
      const s = (n = this.hls) == null ? void 0 : n.media;
      if (s && !s.ended) {
        this.loadSteeringManifest(e);
        return;
      }
      this.scheduleRefresh(e, this.timeToLoad * 1e3);
    }, t);
  }
}
function Zc(i, e, t, n) {
  i && Object.keys(e).forEach((s) => {
    const r = i.filter((a) => a.groupId === s).map((a) => {
      const o = He({}, a);
      return o.details = void 0, o.attrs = new Ye(o.attrs), o.url = o.attrs.URI = dm(a.url, a.attrs["STABLE-RENDITION-ID"], "PER-RENDITION-URIS", t), o.groupId = o.attrs["GROUP-ID"] = e[s], o.attrs["PATHWAY-ID"] = n, o;
    });
    i.push(...r);
  });
}
function dm(i, e, t, n) {
  const {
    HOST: s,
    PARAMS: r,
    [t]: a
  } = n;
  let o;
  e && (o = a?.[e], o && (i = o));
  const l = new self.URL(i);
  return s && !o && (l.host = s), r && Object.keys(r).sort().forEach((d) => {
    d && l.searchParams.set(d, r[d]);
  }), l.href;
}
function Vt(i, e, t) {
  Yt(i, e, t), i.addEventListener(e, t);
}
function Yt(i, e, t) {
  i.removeEventListener(e, t);
}
class Vn extends ni {
  constructor(e) {
    super("eme", e.logger), this.hls = void 0, this.config = void 0, this.media = null, this.keyFormatPromise = null, this.keySystemAccessPromises = {}, this._requestLicenseFailureCount = 0, this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, this.mediaKeys = null, this.setMediaKeysQueue = Vn.CDMCleanupPromise ? [Vn.CDMCleanupPromise] : [], this.onMediaEncrypted = (t) => {
      const {
        initDataType: n,
        initData: s
      } = t, r = `"${t.type}" event: init data type: "${n}"`;
      if (this.debug(r), s !== null) {
        if (!this.keyFormatPromise) {
          let a = Object.keys(this.keySystemAccessPromises);
          a.length || (a = is(this.config));
          const o = a.map(Oa).filter((l) => !!l);
          this.keyFormatPromise = this.getKeyFormatPromise(o);
        }
        this.keyFormatPromise.then((a) => {
          const o = fr(a);
          if (n !== "sinf" || o !== et.FAIRPLAY) {
            this.log(`Ignoring "${t.type}" event with init data type: "${n}" for selected key-system ${o}`);
            return;
          }
          let l;
          try {
            const h = rt(new Uint8Array(s)), m = Al(JSON.parse(h).sinf), g = lh(m);
            if (!g)
              throw new Error("'schm' box missing or not cbcs/cenc with schi > tenc");
            l = new Uint8Array(g.subarray(8, 24));
          } catch (h) {
            this.warn(`${r} Failed to parse sinf: ${h}`);
            return;
          }
          const d = wi.hexDump(l), {
            keyIdToKeySessionPromise: c,
            mediaKeySessions: u
          } = this;
          let f = c[d];
          for (let h = 0; h < u.length; h++) {
            const m = u[h], g = m.decryptdata;
            if (!g.keyId)
              continue;
            const v = wi.hexDump(g.keyId);
            if (d === v || g.uri.replace(/-/g, "").indexOf(d) !== -1) {
              if (f = c[v], !f)
                continue;
              if (g.pssh)
                break;
              delete c[v], g.pssh = new Uint8Array(s), g.keyId = l, f = c[d] = f.then(() => this.generateRequestWithPreferredKeySession(m, n, s, "encrypted-event-key-match")), f.catch((p) => this.handleError(p));
              break;
            }
          }
          f || this.handleError(new Error(`Key ID ${d} not encountered in playlist. Key-system sessions ${u.length}.`));
        }).catch((a) => this.handleError(a));
      }
    }, this.onWaitingForKey = (t) => {
      this.log(`"${t.type}" event`);
    }, this.hls = e, this.config = e.config, this.registerListeners();
  }
  destroy() {
    this.onDestroying(), this.onMediaDetached();
    const e = this.config;
    e.requestMediaKeySystemAccessFunc = null, e.licenseXhrSetup = e.licenseResponseCallback = void 0, e.drmSystems = e.drmSystemOptions = {}, this.hls = this.config = this.keyIdToKeySessionPromise = null, this.onWaitingForKey = null;
  }
  registerListeners() {
    this.hls.on(S.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(S.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.on(S.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(S.MANIFEST_LOADED, this.onManifestLoaded, this), this.hls.on(S.DESTROYING, this.onDestroying, this);
  }
  unregisterListeners() {
    this.hls.off(S.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(S.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.off(S.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(S.MANIFEST_LOADED, this.onManifestLoaded, this), this.hls.off(S.DESTROYING, this.onDestroying, this);
  }
  getLicenseServerUrl(e) {
    const {
      drmSystems: t,
      widevineLicenseUrl: n
    } = this.config, s = t[e];
    if (s)
      return s.licenseUrl;
    if (e === et.WIDEVINE && n)
      return n;
  }
  getLicenseServerUrlOrThrow(e) {
    const t = this.getLicenseServerUrl(e);
    if (t === void 0)
      throw new Error(`no license server URL configured for key-system "${e}"`);
    return t;
  }
  getServerCertificateUrl(e) {
    const {
      drmSystems: t
    } = this.config, n = t[e];
    if (n)
      return n.serverCertificateUrl;
    this.log(`No Server Certificate in config.drmSystems["${e}"]`);
  }
  attemptKeySystemAccess(e) {
    const t = this.hls.levels, n = (a, o, l) => !!a && l.indexOf(a) === o, s = t.map((a) => a.audioCodec).filter(n), r = t.map((a) => a.videoCodec).filter(n);
    return s.length + r.length === 0 && r.push("avc1.42e01e"), new Promise((a, o) => {
      const l = (d) => {
        const c = d.shift();
        this.getMediaKeysPromise(c, s, r).then((u) => a({
          keySystem: c,
          mediaKeys: u
        })).catch((u) => {
          d.length ? l(d) : u instanceof Kt ? o(u) : o(new Kt({
            type: pe.KEY_SYSTEM_ERROR,
            details: B.KEY_SYSTEM_NO_ACCESS,
            error: u,
            fatal: !0
          }, u.message));
        });
      };
      l(e);
    });
  }
  requestMediaKeySystemAccess(e, t) {
    const {
      requestMediaKeySystemAccessFunc: n
    } = this.config;
    if (typeof n != "function") {
      let s = `Configured requestMediaKeySystemAccess is not a function ${n}`;
      return kh === null && self.location.protocol === "http:" && (s = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`), Promise.reject(new Error(s));
    }
    return n(e, t);
  }
  getMediaKeysPromise(e, t, n) {
    const s = sy(e, t, n, this.config.drmSystemOptions), r = this.keySystemAccessPromises[e];
    let a = r?.keySystemAccess;
    if (!a) {
      this.log(`Requesting encrypted media "${e}" key-system access with config: ${qe(s)}`), a = this.requestMediaKeySystemAccess(e, s);
      const o = this.keySystemAccessPromises[e] = {
        keySystemAccess: a
      };
      return a.catch((l) => {
        this.log(`Failed to obtain access to key-system "${e}": ${l}`);
      }), a.then((l) => {
        this.log(`Access for key-system "${l.keySystem}" obtained`);
        const d = this.fetchServerCertificate(e);
        return this.log(`Create media-keys for "${e}"`), o.mediaKeys = l.createMediaKeys().then((c) => (this.log(`Media-keys created for "${e}"`), o.hasMediaKeys = !0, d.then((u) => u ? this.setMediaKeysServerCertificate(c, e, u) : c))), o.mediaKeys.catch((c) => {
          this.error(`Failed to create media-keys for "${e}"}: ${c}`);
        }), o.mediaKeys;
      });
    }
    return a.then(() => r.mediaKeys);
  }
  createMediaKeySessionContext({
    decryptdata: e,
    keySystem: t,
    mediaKeys: n
  }) {
    this.log(`Creating key-system session "${t}" keyId: ${wi.hexDump(e.keyId || [])}`);
    const s = n.createSession(), r = {
      decryptdata: e,
      keySystem: t,
      mediaKeys: n,
      mediaKeysSession: s,
      keyStatus: "status-pending"
    };
    return this.mediaKeySessions.push(r), r;
  }
  renewKeySession(e) {
    const t = e.decryptdata;
    if (t.pssh) {
      const n = this.createMediaKeySessionContext(e), s = this.getKeyIdString(t), r = "cenc";
      this.keyIdToKeySessionPromise[s] = this.generateRequestWithPreferredKeySession(n, r, t.pssh.buffer, "expired");
    } else
      this.warn("Could not renew expired session. Missing pssh initData.");
    this.removeSession(e);
  }
  getKeyIdString(e) {
    if (!e)
      throw new Error("Could not read keyId of undefined decryptdata");
    if (e.keyId === null)
      throw new Error("keyId is null");
    return wi.hexDump(e.keyId);
  }
  updateKeySession(e, t) {
    var n;
    const s = e.mediaKeysSession;
    return this.log(`Updating key-session "${s.sessionId}" for keyID ${wi.hexDump(((n = e.decryptdata) == null ? void 0 : n.keyId) || [])}
      } (data length: ${t && t.byteLength})`), s.update(t);
  }
  getSelectedKeySystemFormats() {
    return Object.keys(this.keySystemAccessPromises).map((e) => ({
      keySystem: e,
      hasMediaKeys: this.keySystemAccessPromises[e].hasMediaKeys
    })).filter(({
      hasMediaKeys: e
    }) => !!e).map(({
      keySystem: e
    }) => Oa(e)).filter((e) => !!e);
  }
  getKeySystemAccess(e) {
    return this.getKeySystemSelectionPromise(e).then(({
      keySystem: t,
      mediaKeys: n
    }) => this.attemptSetMediaKeys(t, n));
  }
  selectKeySystem(e) {
    return new Promise((t, n) => this.getKeySystemSelectionPromise(e).then(({
      keySystem: s
    }) => {
      const r = Oa(s);
      r ? t(r) : n(new Error(`Unable to find format for key-system "${s}"`));
    }).catch(n));
  }
  selectKeySystemFormat(e) {
    const t = Object.keys(e.levelkeys || {});
    return this.keyFormatPromise || (this.log(`Selecting key-system from fragment (sn: ${e.sn} ${e.type}: ${e.level}) key formats ${t.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(t)), this.keyFormatPromise;
  }
  getKeyFormatPromise(e) {
    const t = is(this.config), n = e.map(fr).filter((s) => !!s && t.indexOf(s) !== -1);
    return this.selectKeySystem(n);
  }
  loadKey(e) {
    const t = e.keyInfo.decryptdata, n = this.getKeyIdString(t), s = `(keyId: ${n} format: "${t.keyFormat}" method: ${t.method} uri: ${t.uri})`;
    this.log(`Starting session for key ${s}`);
    let r = this.keyIdToKeySessionPromise[n];
    return r || (r = this.getKeySystemForKeyPromise(t).then(({
      keySystem: o,
      mediaKeys: l
    }) => (this.throwIfDestroyed(), this.log(`Handle encrypted media sn: ${e.frag.sn} ${e.frag.type}: ${e.frag.level} using key ${s}`), this.attemptSetMediaKeys(o, l).then(() => (this.throwIfDestroyed(), this.createMediaKeySessionContext({
      keySystem: o,
      mediaKeys: l,
      decryptdata: t
    }))))), (this.keyIdToKeySessionPromise[n] = r.then((o) => {
      const l = "cenc", d = t.pssh ? t.pssh.buffer : null;
      return this.generateRequestWithPreferredKeySession(o, l, d, "playlist-key");
    })).catch((o) => this.handleError(o))), r;
  }
  throwIfDestroyed(e = "Invalid state") {
    if (!this.hls)
      throw new Error("invalid state");
  }
  handleError(e) {
    this.hls && (this.error(e.message), e instanceof Kt ? this.hls.trigger(S.ERROR, e.data) : this.hls.trigger(S.ERROR, {
      type: pe.KEY_SYSTEM_ERROR,
      details: B.KEY_SYSTEM_NO_KEYS,
      error: e,
      fatal: !0
    }));
  }
  getKeySystemForKeyPromise(e) {
    const t = this.getKeyIdString(e), n = this.keyIdToKeySessionPromise[t];
    if (!n) {
      const s = fr(e.keyFormat), r = s ? [s] : is(this.config);
      return this.attemptKeySystemAccess(r);
    }
    return n;
  }
  getKeySystemSelectionPromise(e) {
    if (e.length || (e = is(this.config)), e.length === 0)
      throw new Kt({
        type: pe.KEY_SYSTEM_ERROR,
        details: B.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
        fatal: !0
      }, `Missing key-system license configuration options ${qe({
        drmSystems: this.config.drmSystems
      })}`);
    return this.attemptKeySystemAccess(e);
  }
  attemptSetMediaKeys(e, t) {
    if (this.mediaKeys === t)
      return Promise.resolve();
    const n = this.setMediaKeysQueue.slice();
    this.log(`Setting media-keys for "${e}"`);
    const s = Promise.all(n).then(() => {
      if (!this.media)
        throw this.mediaKeys = null, new Error("Attempted to set mediaKeys without media element attached");
      return this.media.setMediaKeys(t);
    });
    return this.mediaKeys = t, this.setMediaKeysQueue.push(s), s.then(() => {
      this.log(`Media-keys set for "${e}"`), n.push(s), this.setMediaKeysQueue = this.setMediaKeysQueue.filter((r) => n.indexOf(r) === -1);
    });
  }
  generateRequestWithPreferredKeySession(e, t, n, s) {
    var r;
    const a = (r = this.config.drmSystems) == null || (r = r[e.keySystem]) == null ? void 0 : r.generateRequest;
    if (a)
      try {
        const h = a.call(this.hls, t, n, e);
        if (!h)
          throw new Error("Invalid response from configured generateRequest filter");
        t = h.initDataType, n = h.initData ? h.initData : null, e.decryptdata.pssh = n ? new Uint8Array(n) : null;
      } catch (h) {
        var o;
        if (this.warn(h.message), (o = this.hls) != null && o.config.debug)
          throw h;
      }
    if (n === null)
      return this.log(`Skipping key-session request for "${s}" (no initData)`), Promise.resolve(e);
    const l = this.getKeyIdString(e.decryptdata);
    this.log(`Generating key-session request for "${s}": ${l} (init data type: ${t} length: ${n ? n.byteLength : null})`);
    const d = new Ll(), c = e._onmessage = (h) => {
      const m = e.mediaKeysSession;
      if (!m) {
        d.emit("error", new Error("invalid state"));
        return;
      }
      const {
        messageType: g,
        message: v
      } = h;
      this.log(`"${g}" message event for session "${m.sessionId}" message size: ${v.byteLength}`), g === "license-request" || g === "license-renewal" ? this.renewLicense(e, v).catch((p) => {
        d.eventNames().length ? d.emit("error", p) : this.handleError(p);
      }) : g === "license-release" ? e.keySystem === et.FAIRPLAY && (this.updateKeySession(e, Po("acknowledged")), this.removeSession(e)) : this.warn(`unhandled media key message type "${g}"`);
    }, u = e._onkeystatuseschange = (h) => {
      if (!e.mediaKeysSession) {
        d.emit("error", new Error("invalid state"));
        return;
      }
      this.onKeyStatusChange(e);
      const g = e.keyStatus;
      d.emit("keyStatus", g), g === "expired" && (this.warn(`${e.keySystem} expired for key ${l}`), this.renewKeySession(e));
    };
    Vt(e.mediaKeysSession, "message", c), Vt(e.mediaKeysSession, "keystatuseschange", u);
    const f = new Promise((h, m) => {
      d.on("error", m), d.on("keyStatus", (g) => {
        g.startsWith("usable") ? h() : g === "output-restricted" ? m(new Kt({
          type: pe.KEY_SYSTEM_ERROR,
          details: B.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
          fatal: !1
        }, "HDCP level output restricted")) : g === "internal-error" ? m(new Kt({
          type: pe.KEY_SYSTEM_ERROR,
          details: B.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
          fatal: !0
        }, `key status changed to "${g}"`)) : g === "expired" ? m(new Error("key expired while generating request")) : this.warn(`unhandled key status change "${g}"`);
      });
    });
    return e.mediaKeysSession.generateRequest(t, n).then(() => {
      var h;
      this.log(`Request generated for key-session "${(h = e.mediaKeysSession) == null ? void 0 : h.sessionId}" keyId: ${l}`);
    }).catch((h) => {
      throw new Kt({
        type: pe.KEY_SYSTEM_ERROR,
        details: B.KEY_SYSTEM_NO_SESSION,
        error: h,
        fatal: !1
      }, `Error generating key-session request: ${h}`);
    }).then(() => f).catch((h) => {
      throw d.removeAllListeners(), this.removeSession(e), h;
    }).then(() => (d.removeAllListeners(), e));
  }
  onKeyStatusChange(e) {
    e.mediaKeysSession.keyStatuses.forEach((t, n) => {
      if (typeof n == "string" && typeof t == "object") {
        const s = n;
        n = t, t = s;
      }
      this.log(`key status change "${t}" for keyStatuses keyId: ${wi.hexDump("buffer" in n ? new Uint8Array(n.buffer, n.byteOffset, n.byteLength) : new Uint8Array(n))} session keyId: ${wi.hexDump(new Uint8Array(e.decryptdata.keyId || []))} uri: ${e.decryptdata.uri}`), e.keyStatus = t;
    });
  }
  fetchServerCertificate(e) {
    const t = this.config, n = t.loader, s = new n(t), r = this.getServerCertificateUrl(e);
    return r ? (this.log(`Fetching server certificate for "${e}"`), new Promise((a, o) => {
      const l = {
        responseType: "arraybuffer",
        url: r
      }, d = t.certLoadPolicy.default, c = {
        loadPolicy: d,
        timeout: d.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, u = {
        onSuccess: (f, h, m, g) => {
          a(f.data);
        },
        onError: (f, h, m, g) => {
          o(new Kt({
            type: pe.KEY_SYSTEM_ERROR,
            details: B.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: m,
            response: Ve({
              url: l.url,
              data: void 0
            }, f)
          }, `"${e}" certificate request failed (${r}). Status: ${f.code} (${f.text})`));
        },
        onTimeout: (f, h, m) => {
          o(new Kt({
            type: pe.KEY_SYSTEM_ERROR,
            details: B.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: m,
            response: {
              url: l.url,
              data: void 0
            }
          }, `"${e}" certificate request timed out (${r})`));
        },
        onAbort: (f, h, m) => {
          o(new Error("aborted"));
        }
      };
      s.load(l, c, u);
    })) : Promise.resolve();
  }
  setMediaKeysServerCertificate(e, t, n) {
    return new Promise((s, r) => {
      e.setServerCertificate(n).then((a) => {
        this.log(`setServerCertificate ${a ? "success" : "not supported by CDM"} (${n?.byteLength}) on "${t}"`), s(e);
      }).catch((a) => {
        r(new Kt({
          type: pe.KEY_SYSTEM_ERROR,
          details: B.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
          error: a,
          fatal: !0
        }, a.message));
      });
    });
  }
  renewLicense(e, t) {
    return this.requestLicense(e, new Uint8Array(t)).then((n) => this.updateKeySession(e, new Uint8Array(n)).catch((s) => {
      throw new Kt({
        type: pe.KEY_SYSTEM_ERROR,
        details: B.KEY_SYSTEM_SESSION_UPDATE_FAILED,
        error: s,
        fatal: !0
      }, s.message);
    }));
  }
  unpackPlayReadyKeyMessage(e, t) {
    const n = String.fromCharCode.apply(null, new Uint16Array(t.buffer));
    if (!n.includes("PlayReadyKeyMessage"))
      return e.setRequestHeader("Content-Type", "text/xml; charset=utf-8"), t;
    const s = new DOMParser().parseFromString(n, "application/xml"), r = s.querySelectorAll("HttpHeader");
    if (r.length > 0) {
      let c;
      for (let u = 0, f = r.length; u < f; u++) {
        var a, o;
        c = r[u];
        const h = (a = c.querySelector("name")) == null ? void 0 : a.textContent, m = (o = c.querySelector("value")) == null ? void 0 : o.textContent;
        h && m && e.setRequestHeader(h, m);
      }
    }
    const l = s.querySelector("Challenge"), d = l?.textContent;
    if (!d)
      throw new Error("Cannot find <Challenge> in key message");
    return Po(atob(d));
  }
  setupLicenseXHR(e, t, n, s) {
    const r = this.config.licenseXhrSetup;
    return r ? Promise.resolve().then(() => {
      if (!n.decryptdata)
        throw new Error("Key removed");
      return r.call(this.hls, e, t, n, s);
    }).catch((a) => {
      if (!n.decryptdata)
        throw a;
      return e.open("POST", t, !0), r.call(this.hls, e, t, n, s);
    }).then((a) => (e.readyState || e.open("POST", t, !0), {
      xhr: e,
      licenseChallenge: a || s
    })) : (e.open("POST", t, !0), Promise.resolve({
      xhr: e,
      licenseChallenge: s
    }));
  }
  requestLicense(e, t) {
    const n = this.config.keyLoadPolicy.default;
    return new Promise((s, r) => {
      const a = this.getLicenseServerUrlOrThrow(e.keySystem);
      this.log(`Sending license request to URL: ${a}`);
      const o = new XMLHttpRequest();
      o.responseType = "arraybuffer", o.onreadystatechange = () => {
        if (!this.hls || !e.mediaKeysSession)
          return r(new Error("invalid state"));
        if (o.readyState === 4)
          if (o.status === 200) {
            this._requestLicenseFailureCount = 0;
            let l = o.response;
            this.log(`License received ${l instanceof ArrayBuffer ? l.byteLength : l}`);
            const d = this.config.licenseResponseCallback;
            if (d)
              try {
                l = d.call(this.hls, o, a, e);
              } catch (c) {
                this.error(c);
              }
            s(l);
          } else {
            const l = n.errorRetry, d = l ? l.maxNumRetry : 0;
            if (this._requestLicenseFailureCount++, this._requestLicenseFailureCount > d || o.status >= 400 && o.status < 500)
              r(new Kt({
                type: pe.KEY_SYSTEM_ERROR,
                details: B.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: !0,
                networkDetails: o,
                response: {
                  url: a,
                  data: void 0,
                  code: o.status,
                  text: o.statusText
                }
              }, `License Request XHR failed (${a}). Status: ${o.status} (${o.statusText})`));
            else {
              const c = d - this._requestLicenseFailureCount + 1;
              this.warn(`Retrying license request, ${c} attempts left`), this.requestLicense(e, t).then(s, r);
            }
          }
      }, e.licenseXhr && e.licenseXhr.readyState !== XMLHttpRequest.DONE && e.licenseXhr.abort(), e.licenseXhr = o, this.setupLicenseXHR(o, a, e, t).then(({
        xhr: l,
        licenseChallenge: d
      }) => {
        e.keySystem == et.PLAYREADY && (d = this.unpackPlayReadyKeyMessage(l, d)), l.send(d);
      });
    });
  }
  onDestroying() {
    this.unregisterListeners(), this._clear();
  }
  onMediaAttached(e, t) {
    if (!this.config.emeEnabled)
      return;
    const n = t.media;
    this.media = n, Vt(n, "encrypted", this.onMediaEncrypted), Vt(n, "waitingforkey", this.onWaitingForKey);
  }
  onMediaDetached() {
    const e = this.media;
    e && (Yt(e, "encrypted", this.onMediaEncrypted), Yt(e, "waitingforkey", this.onWaitingForKey), this.media = null, this.mediaKeys = null);
  }
  _clear() {
    var e;
    if (this._requestLicenseFailureCount = 0, this.keyIdToKeySessionPromise = {}, !this.mediaKeys && !this.mediaKeySessions.length)
      return;
    const t = this.media, n = this.mediaKeySessions.slice();
    this.mediaKeySessions = [], this.mediaKeys = null, pa.clearKeyUriToKeyIdMap();
    const s = n.length;
    Vn.CDMCleanupPromise = Promise.all(n.map((r) => this.removeSession(r)).concat(t == null || (e = t.setMediaKeys(null)) == null ? void 0 : e.catch((r) => {
      var a;
      this.log(`Could not clear media keys: ${r}`), (a = this.hls) == null || a.trigger(S.ERROR, {
        type: pe.OTHER_ERROR,
        details: B.KEY_SYSTEM_DESTROY_MEDIA_KEYS_ERROR,
        fatal: !1,
        error: new Error(`Could not clear media keys: ${r}`)
      });
    }))).catch((r) => {
      var a;
      this.log(`Could not close sessions and clear media keys: ${r}`), (a = this.hls) == null || a.trigger(S.ERROR, {
        type: pe.OTHER_ERROR,
        details: B.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR,
        fatal: !1,
        error: new Error(`Could not close sessions and clear media keys: ${r}`)
      });
    }).then(() => {
      s && this.log("finished closing key sessions and clearing media keys");
    });
  }
  onManifestLoading() {
    this.keyFormatPromise = null;
  }
  onManifestLoaded(e, {
    sessionKeys: t
  }) {
    if (!(!t || !this.config.emeEnabled) && !this.keyFormatPromise) {
      const n = t.reduce((s, r) => (s.indexOf(r.keyFormat) === -1 && s.push(r.keyFormat), s), []);
      this.log(`Selecting key-system from session-keys ${n.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(n);
    }
  }
  removeSession(e) {
    const {
      mediaKeysSession: t,
      licenseXhr: n
    } = e;
    if (t) {
      this.log(`Remove licenses and keys and close session ${t.sessionId}`), e._onmessage && (t.removeEventListener("message", e._onmessage), e._onmessage = void 0), e._onkeystatuseschange && (t.removeEventListener("keystatuseschange", e._onkeystatuseschange), e._onkeystatuseschange = void 0), n && n.readyState !== XMLHttpRequest.DONE && n.abort(), e.mediaKeysSession = e.decryptdata = e.licenseXhr = void 0;
      const s = this.mediaKeySessions.indexOf(e);
      s > -1 && this.mediaKeySessions.splice(s, 1);
      const {
        drmSystemOptions: r
      } = this.config;
      return (ay(r) ? new Promise((o, l) => {
        self.setTimeout(() => l(new Error("MediaKeySession.remove() timeout")), 8e3), t.remove().then(o);
      }) : Promise.resolve()).catch((o) => {
        var l;
        this.log(`Could not remove session: ${o}`), (l = this.hls) == null || l.trigger(S.ERROR, {
          type: pe.OTHER_ERROR,
          details: B.KEY_SYSTEM_DESTROY_REMOVE_SESSION_ERROR,
          fatal: !1,
          error: new Error(`Could not remove session: ${o}`)
        });
      }).then(() => t.close()).catch((o) => {
        var l;
        this.log(`Could not close session: ${o}`), (l = this.hls) == null || l.trigger(S.ERROR, {
          type: pe.OTHER_ERROR,
          details: B.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR,
          fatal: !1,
          error: new Error(`Could not close session: ${o}`)
        });
      });
    }
  }
}
Vn.CDMCleanupPromise = void 0;
class Kt extends Error {
  constructor(e, t) {
    super(t), this.data = void 0, e.error || (e.error = new Error(t)), this.data = e, e.err = e.error;
  }
}
class _S {
  constructor(e) {
    this.hls = void 0, this.isVideoPlaybackQualityAvailable = !1, this.timer = void 0, this.media = null, this.lastTime = void 0, this.lastDroppedFrames = 0, this.lastDecodedFrames = 0, this.streamController = void 0, this.hls = e, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  registerListeners() {
    this.hls.on(S.MEDIA_ATTACHING, this.onMediaAttaching, this), this.hls.on(S.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListeners() {
    this.hls.off(S.MEDIA_ATTACHING, this.onMediaAttaching, this), this.hls.off(S.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  destroy() {
    this.timer && clearInterval(this.timer), this.unregisterListeners(), this.isVideoPlaybackQualityAvailable = !1, this.media = null;
  }
  onMediaAttaching(e, t) {
    const n = this.hls.config;
    if (n.capLevelOnFPSDrop) {
      const s = t.media instanceof self.HTMLVideoElement ? t.media : null;
      this.media = s, s && typeof s.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), self.clearInterval(this.timer), this.timer = self.setInterval(this.checkFPSInterval.bind(this), n.fpsDroppedMonitoringPeriod);
    }
  }
  onMediaDetaching() {
    this.media = null;
  }
  checkFPS(e, t, n) {
    const s = performance.now();
    if (t) {
      if (this.lastTime) {
        const r = s - this.lastTime, a = n - this.lastDroppedFrames, o = t - this.lastDecodedFrames, l = 1e3 * a / r, d = this.hls;
        if (d.trigger(S.FPS_DROP, {
          currentDropped: a,
          currentDecoded: o,
          totalDroppedFrames: n
        }), l > 0 && a > d.config.fpsDroppedMonitoringThreshold * o) {
          let c = d.currentLevel;
          d.logger.warn("drop FPS ratio greater than max allowed value for currentLevel: " + c), c > 0 && (d.autoLevelCapping === -1 || d.autoLevelCapping >= c) && (c = c - 1, d.trigger(S.FPS_DROP_LEVEL_CAPPING, {
            level: c,
            droppedLevel: d.currentLevel
          }), d.autoLevelCapping = c, this.streamController.nextLevelSwitch());
        }
      }
      this.lastTime = s, this.lastDroppedFrames = n, this.lastDecodedFrames = t;
    }
  }
  checkFPSInterval() {
    const e = this.media;
    if (e)
      if (this.isVideoPlaybackQualityAvailable) {
        const t = e.getVideoPlaybackQuality();
        this.checkFPS(e, t.totalVideoFrames, t.droppedVideoFrames);
      } else
        this.checkFPS(e, e.webkitDecodedFrameCount, e.webkitDroppedFrameCount);
  }
}
function cm(i, e) {
  let t;
  try {
    t = new Event("addtrack");
  } catch {
    t = document.createEvent("Event"), t.initEvent("addtrack", !1, !1);
  }
  t.track = i, e.dispatchEvent(t);
}
function um(i, e) {
  const t = i.mode;
  if (t === "disabled" && (i.mode = "hidden"), i.cues && !i.cues.getCueById(e.id))
    try {
      if (i.addCue(e), !i.cues.getCueById(e.id))
        throw new Error(`addCue is failed for: ${e}`);
    } catch (n) {
      Be.debug(`[texttrack-utils]: ${n}`);
      try {
        const s = new self.TextTrackCue(e.startTime, e.endTime, e.text);
        s.id = e.id, i.addCue(s);
      } catch (s) {
        Be.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${s}`);
      }
    }
  t === "disabled" && (i.mode = t);
}
function Pn(i, e) {
  const t = i.mode;
  if (t === "disabled" && (i.mode = "hidden"), i.cues)
    for (let n = i.cues.length; n--; )
      e && i.cues[n].removeEventListener("enter", e), i.removeCue(i.cues[n]);
  t === "disabled" && (i.mode = t);
}
function Vo(i, e, t, n) {
  const s = i.mode;
  if (s === "disabled" && (i.mode = "hidden"), i.cues && i.cues.length > 0) {
    const r = wS(i.cues, e, t);
    for (let a = 0; a < r.length; a++)
      (!n || n(r[a])) && i.removeCue(r[a]);
  }
  s === "disabled" && (i.mode = s);
}
function AS(i, e) {
  if (e <= i[0].startTime)
    return 0;
  const t = i.length - 1;
  if (e > i[t].endTime)
    return -1;
  let n = 0, s = t, r;
  for (; n <= s; )
    if (r = Math.floor((s + n) / 2), e < i[r].startTime)
      s = r - 1;
    else if (e > i[r].startTime && n < t)
      n = r + 1;
    else
      return r;
  return i[n].startTime - e < e - i[s].startTime ? n : s;
}
function wS(i, e, t) {
  const n = [], s = AS(i, e);
  if (s > -1)
    for (let r = s, a = i.length; r < a; r++) {
      const o = i[r];
      if (o.startTime >= e && o.endTime <= t)
        n.push(o);
      else if (o.startTime > t)
        return n;
    }
  return n;
}
function gr(i) {
  const e = [];
  for (let t = 0; t < i.length; t++) {
    const n = i[t];
    (n.kind === "subtitles" || n.kind === "captions") && n.label && e.push(i[t]);
  }
  return e;
}
class LS extends Ml {
  constructor(e) {
    super(e, "subtitle-track-controller"), this.media = null, this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.queuedDefaultTrack = -1, this.useTextTrackPolling = !1, this.subtitlePollingInterval = -1, this._subtitleDisplay = !0, this.asyncPollTrackChange = () => this.pollTrackChange(0), this.onTextTracksChanged = () => {
      if (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval), !this.media || !this.hls.config.renderTextTracksNatively)
        return;
      let t = null;
      const n = gr(this.media.textTracks);
      for (let r = 0; r < n.length; r++)
        if (n[r].mode === "hidden")
          t = n[r];
        else if (n[r].mode === "showing") {
          t = n[r];
          break;
        }
      const s = this.findTrackForTextTrack(t);
      this.subtitleTrack !== s && this.setSubtitleTrack(s);
    }, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, this.onTextTracksChanged = this.asyncPollTrackChange = null, super.destroy();
  }
  get subtitleDisplay() {
    return this._subtitleDisplay;
  }
  set subtitleDisplay(e) {
    this._subtitleDisplay = e, this.trackId > -1 && this.toggleTrackModes();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(S.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(S.MANIFEST_LOADING, this.onManifestLoading, this), e.on(S.MANIFEST_PARSED, this.onManifestParsed, this), e.on(S.LEVEL_LOADING, this.onLevelLoading, this), e.on(S.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(S.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(S.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(S.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(S.MANIFEST_LOADING, this.onManifestLoading, this), e.off(S.MANIFEST_PARSED, this.onManifestParsed, this), e.off(S.LEVEL_LOADING, this.onLevelLoading, this), e.off(S.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(S.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(S.ERROR, this.onError, this);
  }
  // Listen for subtitle track change, then extract the current track ID.
  onMediaAttached(e, t) {
    this.media = t.media, this.media && (this.queuedDefaultTrack > -1 && (this.subtitleTrack = this.queuedDefaultTrack, this.queuedDefaultTrack = -1), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.pollTrackChange(500) : this.media.textTracks.addEventListener("change", this.asyncPollTrackChange));
  }
  pollTrackChange(e) {
    self.clearInterval(this.subtitlePollingInterval), this.subtitlePollingInterval = self.setInterval(this.onTextTracksChanged, e);
  }
  onMediaDetaching(e, t) {
    const n = this.media;
    if (!n)
      return;
    const s = !!t.transferMedia;
    if (self.clearInterval(this.subtitlePollingInterval), this.useTextTrackPolling || n.textTracks.removeEventListener("change", this.asyncPollTrackChange), this.trackId > -1 && (this.queuedDefaultTrack = this.trackId), this.subtitleTrack = -1, this.media = null, s)
      return;
    gr(n.textTracks).forEach((a) => {
      Pn(a);
    });
  }
  onManifestLoading() {
    this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0;
  }
  // Fired whenever a new manifest is loaded.
  onManifestParsed(e, t) {
    this.tracks = t.subtitleTracks;
  }
  onSubtitleTrackLoaded(e, t) {
    const {
      id: n,
      groupId: s,
      details: r
    } = t, a = this.tracksInGroup[n];
    if (!a || a.groupId !== s) {
      this.warn(`Subtitle track with id:${n} and group:${s} not found in active group ${a?.groupId}`);
      return;
    }
    const o = a.details;
    a.details = t.details, this.log(`Subtitle track ${n} "${a.name}" lang:${a.lang} group:${s} loaded [${r.startSN}-${r.endSN}]`), n === this.trackId && this.playlistLoaded(n, t, o);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!t)
      return;
    const n = t.subtitleGroups || null, s = this.groupIds;
    let r = this.currentTrack;
    if (!n || s?.length !== n?.length || n != null && n.some((a) => s?.indexOf(a) === -1)) {
      this.groupIds = n, this.trackId = -1, this.currentTrack = null;
      const a = this.tracks.filter((c) => !n || n.indexOf(c.groupId) !== -1);
      if (a.length)
        this.selectDefaultTrack && !a.some((c) => c.default) && (this.selectDefaultTrack = !1), a.forEach((c, u) => {
          c.id = u;
        });
      else if (!r && !this.tracksInGroup.length)
        return;
      this.tracksInGroup = a;
      const o = this.hls.config.subtitlePreference;
      if (!r && o) {
        this.selectDefaultTrack = !1;
        const c = fi(o, a);
        if (c > -1)
          r = a[c];
        else {
          const u = fi(o, this.tracks);
          r = this.tracks[u];
        }
      }
      let l = this.findTrackId(r);
      l === -1 && r && (l = this.findTrackId(null));
      const d = {
        subtitleTracks: a
      };
      this.log(`Updating subtitle tracks, ${a.length} track(s) found in "${n?.join(",")}" group-id`), this.hls.trigger(S.SUBTITLE_TRACKS_UPDATED, d), l !== -1 && this.trackId === -1 && this.setSubtitleTrack(l);
    }
  }
  findTrackId(e) {
    const t = this.tracksInGroup, n = this.selectDefaultTrack;
    for (let s = 0; s < t.length; s++) {
      const r = t[s];
      if (!(n && !r.default || !n && !e) && (!e || bn(r, e)))
        return s;
    }
    if (e) {
      for (let s = 0; s < t.length; s++) {
        const r = t[s];
        if (Rs(e.attrs, r.attrs, ["LANGUAGE", "ASSOC-LANGUAGE", "CHARACTERISTICS"]))
          return s;
      }
      for (let s = 0; s < t.length; s++) {
        const r = t[s];
        if (Rs(e.attrs, r.attrs, ["LANGUAGE"]))
          return s;
      }
    }
    return -1;
  }
  findTrackForTextTrack(e) {
    if (e) {
      const t = this.tracksInGroup;
      for (let n = 0; n < t.length; n++) {
        const s = t[n];
        if (Fo(s, e))
          return n;
      }
    }
    return -1;
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Le.SUBTITLE_TRACK && t.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(t.context.groupId) !== -1) && this.checkRetry(t);
  }
  get allSubtitleTracks() {
    return this.tracks;
  }
  /** get alternate subtitle tracks list from playlist **/
  get subtitleTracks() {
    return this.tracksInGroup;
  }
  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
  get subtitleTrack() {
    return this.trackId;
  }
  set subtitleTrack(e) {
    this.selectDefaultTrack = !1, this.setSubtitleTrack(e);
  }
  setSubtitleOption(e) {
    if (this.hls.config.subtitlePreference = e, e) {
      if (e.id === -1)
        return this.setSubtitleTrack(-1), null;
      const t = this.allSubtitleTracks;
      if (this.selectDefaultTrack = !1, t.length) {
        const n = this.currentTrack;
        if (n && bn(e, n))
          return n;
        const s = fi(e, this.tracksInGroup);
        if (s > -1) {
          const r = this.tracksInGroup[s];
          return this.setSubtitleTrack(s), r;
        } else {
          if (n)
            return null;
          {
            const r = fi(e, t);
            if (r > -1)
              return t[r];
          }
        }
      }
    }
    return null;
  }
  loadPlaylist(e) {
    super.loadPlaylist(), this.shouldLoadPlaylist(this.currentTrack) && this.scheduleLoading(this.currentTrack, e);
  }
  loadingPlaylist(e, t) {
    super.loadingPlaylist(e, t);
    const n = e.id, s = e.groupId, r = this.getUrlWithDirectives(e.url, t), a = e.details, o = a?.age;
    this.log(`Loading subtitle ${n} "${e.name}" lang:${e.lang} group:${s}${t?.msn !== void 0 ? " at sn " + t.msn + " part " + t.part : ""}${o && a.live ? " age " + o.toFixed(1) + (a.type && " " + a.type || "") : ""} ${r}`), this.hls.trigger(S.SUBTITLE_TRACK_LOADING, {
      url: r,
      id: n,
      groupId: s,
      deliveryDirectives: t || null,
      track: e
    });
  }
  /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */
  toggleTrackModes() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = gr(e.textTracks), n = this.currentTrack;
    let s;
    if (n && (s = t.filter((r) => Fo(n, r))[0], s || this.warn(`Unable to find subtitle TextTrack with name "${n.name}" and language "${n.lang}"`)), [].slice.call(t).forEach((r) => {
      r.mode !== "disabled" && r !== s && (r.mode = "disabled");
    }), s) {
      const r = this.subtitleDisplay ? "showing" : "hidden";
      s.mode !== r && (s.mode = r);
    }
  }
  /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */
  setSubtitleTrack(e) {
    const t = this.tracksInGroup;
    if (!this.media) {
      this.queuedDefaultTrack = e;
      return;
    }
    if (e < -1 || e >= t.length || !ae(e)) {
      this.warn(`Invalid subtitle track id: ${e}`);
      return;
    }
    this.selectDefaultTrack = !1;
    const n = this.currentTrack, s = t[e] || null;
    if (this.trackId = e, this.currentTrack = s, this.toggleTrackModes(), !s) {
      this.hls.trigger(S.SUBTITLE_TRACK_SWITCH, {
        id: e
      });
      return;
    }
    const r = !!s.details && !s.details.live;
    if (e === this.trackId && s === n && r)
      return;
    this.log(`Switching to subtitle-track ${e}` + (s ? ` "${s.name}" lang:${s.lang} group:${s.groupId}` : ""));
    const {
      id: a,
      groupId: o = "",
      name: l,
      type: d,
      url: c
    } = s;
    this.hls.trigger(S.SUBTITLE_TRACK_SWITCH, {
      id: a,
      groupId: o,
      name: l,
      type: d,
      url: c
    });
    const u = this.switchParams(s.url, n?.details, s.details);
    this.loadPlaylist(u);
  }
}
function IS() {
  try {
    return crypto.randomUUID();
  } catch {
    try {
      const e = URL.createObjectURL(new Blob()), t = e.toString();
      return URL.revokeObjectURL(e), t.slice(t.lastIndexOf("/") + 1);
    } catch {
      let t = (/* @__PURE__ */ new Date()).getTime();
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (s) => {
        const r = (t + Math.random() * 16) % 16 | 0;
        return t = Math.floor(t / 16), (s == "x" ? r : r & 3 | 8).toString(16);
      });
    }
  }
}
function hs(i) {
  let e = 5381, t = i.length;
  for (; t; )
    e = e * 33 ^ i.charCodeAt(--t);
  return (e >>> 0).toString();
}
const Gn = 0.025;
let $r = /* @__PURE__ */ function(i) {
  return i[i.Point = 0] = "Point", i[i.Range = 1] = "Range", i;
}({});
function CS(i, e, t) {
  return `${i.identifier}-${t + 1}-${hs(e)}`;
}
class RS {
  constructor(e, t) {
    this.base = void 0, this._duration = null, this._timelineStart = null, this.appendInPlaceDisabled = void 0, this.appendInPlaceStarted = void 0, this.dateRange = void 0, this.hasPlayed = !1, this.cumulativeDuration = 0, this.resumeOffset = NaN, this.playoutLimit = NaN, this.restrictions = {
      skip: !1,
      jump: !1
    }, this.snapOptions = {
      out: !1,
      in: !1
    }, this.assetList = [], this.assetListLoader = void 0, this.assetListResponse = null, this.resumeAnchor = void 0, this.error = void 0, this.resetOnResume = void 0, this.base = t, this.dateRange = e, this.setDateRange(e);
  }
  setDateRange(e) {
    this.dateRange = e, this.resumeOffset = e.attr.optionalFloat("X-RESUME-OFFSET", this.resumeOffset), this.playoutLimit = e.attr.optionalFloat("X-PLAYOUT-LIMIT", this.playoutLimit), this.restrictions = e.attr.enumeratedStringList("X-RESTRICT", this.restrictions), this.snapOptions = e.attr.enumeratedStringList("X-SNAP", this.snapOptions);
  }
  reset() {
    var e;
    this.appendInPlaceStarted = !1, (e = this.assetListLoader) == null || e.destroy(), this.assetListLoader = void 0, this.supplementsPrimary || (this.assetListResponse = null, this.assetList = [], this._duration = null);
  }
  isAssetPastPlayoutLimit(e) {
    var t;
    if (e > 0 && e >= this.assetList.length)
      return !0;
    const n = this.playoutLimit;
    return e <= 0 || isNaN(n) ? !1 : n === 0 ? !0 : (((t = this.assetList[e]) == null ? void 0 : t.startOffset) || 0) > n;
  }
  findAssetIndex(e) {
    return this.assetList.indexOf(e);
  }
  get identifier() {
    return this.dateRange.id;
  }
  get startDate() {
    return this.dateRange.startDate;
  }
  get startTime() {
    const e = this.dateRange.startTime;
    if (this.snapOptions.out) {
      const t = this.dateRange.tagAnchor;
      if (t)
        return Ka(e, t);
    }
    return e;
  }
  get startOffset() {
    return this.cue.pre ? 0 : this.startTime;
  }
  get startIsAligned() {
    if (this.startTime === 0 || this.snapOptions.out)
      return !0;
    const e = this.dateRange.tagAnchor;
    if (e) {
      const t = this.dateRange.startTime, n = Ka(t, e);
      return t - n < 0.1;
    }
    return !1;
  }
  get resumptionOffset() {
    const e = this.resumeOffset, t = ae(e) ? e : this.duration;
    return this.cumulativeDuration + t;
  }
  get resumeTime() {
    const e = this.startOffset + this.resumptionOffset;
    if (this.snapOptions.in) {
      const t = this.resumeAnchor;
      if (t)
        return Ka(e, t);
    }
    return e;
  }
  get appendInPlace() {
    return this.appendInPlaceStarted ? !0 : this.appendInPlaceDisabled ? !1 : !!(!this.cue.once && !this.cue.pre && // preroll starts at startPosition before startPosition is known (live)
    this.startIsAligned && (isNaN(this.playoutLimit) && isNaN(this.resumeOffset) || this.resumeOffset && this.duration && Math.abs(this.resumeOffset - this.duration) < Gn));
  }
  set appendInPlace(e) {
    if (this.appendInPlaceStarted) {
      this.resetOnResume = !e;
      return;
    }
    this.appendInPlaceDisabled = !e;
  }
  // Extended timeline start time
  get timelineStart() {
    return this._timelineStart !== null ? this._timelineStart : this.startTime;
  }
  set timelineStart(e) {
    this._timelineStart = e;
  }
  get duration() {
    const e = this.playoutLimit;
    let t;
    return this._duration !== null ? t = this._duration : this.dateRange.duration ? t = this.dateRange.duration : t = this.dateRange.plannedDuration || 0, !isNaN(e) && e < t && (t = e), t;
  }
  set duration(e) {
    this._duration = e;
  }
  get cue() {
    return this.dateRange.cue;
  }
  get timelineOccupancy() {
    return this.dateRange.attr["X-TIMELINE-OCCUPIES"] === "RANGE" ? $r.Range : $r.Point;
  }
  get supplementsPrimary() {
    return this.dateRange.attr["X-TIMELINE-STYLE"] === "PRIMARY";
  }
  get contentMayVary() {
    return this.dateRange.attr["X-CONTENT-MAY-VARY"] !== "NO";
  }
  get assetUrl() {
    return this.dateRange.attr["X-ASSET-URI"];
  }
  get assetListUrl() {
    return this.dateRange.attr["X-ASSET-LIST"];
  }
  get baseUrl() {
    return this.base.url;
  }
  get assetListLoaded() {
    return this.assetList.length > 0 || this.assetListResponse !== null;
  }
  toString() {
    return PS(this);
  }
}
function Ka(i, e) {
  return i - e.start < e.duration / 2 && !(Math.abs(i - (e.start + e.duration)) < Gn) ? e.start : e.start + e.duration;
}
function fm(i, e, t) {
  const n = new self.URL(i, t);
  return n.protocol !== "data:" && n.searchParams.set("_HLS_primary_id", e), n;
}
function ja(i, e) {
  for (; (t = i.assetList[++e]) != null && t.error; )
    var t;
  return e;
}
function PS(i) {
  return `["${i.identifier}" ${i.cue.pre ? "<pre>" : i.cue.post ? "<post>" : ""}${i.timelineStart.toFixed(2)}-${i.resumeTime.toFixed(2)}]`;
}
function Cn(i) {
  const e = i.timelineStart, t = i.duration || 0;
  return `["${i.identifier}" ${e.toFixed(2)}-${(e + t).toFixed(2)}]`;
}
class DS {
  constructor(e, t, n, s) {
    this.hls = void 0, this.interstitial = void 0, this.assetItem = void 0, this.tracks = null, this.hasDetails = !1, this.mediaAttached = null, this._currentTime = void 0, this._bufferedEosTime = void 0, this.checkPlayout = () => {
      this.reachedPlayout(this.currentTime) && this.hls && this.hls.trigger(S.PLAYOUT_LIMIT_REACHED, {});
    };
    const r = this.hls = new e(t);
    this.interstitial = n, this.assetItem = s;
    const a = () => {
      this.hasDetails = !0;
    };
    r.once(S.LEVEL_LOADED, a), r.once(S.AUDIO_TRACK_LOADED, a), r.once(S.SUBTITLE_TRACK_LOADED, a), r.on(S.MEDIA_ATTACHING, (o, {
      media: l
    }) => {
      this.removeMediaListeners(), this.mediaAttached = l, this.interstitial.playoutLimit && (l.addEventListener("timeupdate", this.checkPlayout), this.appendInPlace && r.on(S.BUFFER_APPENDED, () => {
        const c = this.bufferedEnd;
        this.reachedPlayout(c) && (this._bufferedEosTime = c, r.trigger(S.BUFFERED_TO_END, void 0));
      }));
    });
  }
  get appendInPlace() {
    return this.interstitial.appendInPlace;
  }
  loadSource() {
    const e = this.hls;
    if (e)
      if (e.url)
        e.levels.length && !e.started && e.startLoad(-1, !0);
      else {
        let t = this.assetItem.uri;
        try {
          t = fm(t, e.config.primarySessionId || "").href;
        } catch {
        }
        e.loadSource(t);
      }
  }
  bufferedInPlaceToEnd(e) {
    var t;
    if (!this.appendInPlace)
      return !1;
    if ((t = this.hls) != null && t.bufferedToEnd)
      return !0;
    if (!e)
      return !1;
    const n = Math.min(this._bufferedEosTime || 1 / 0, this.duration), s = this.timelineOffset, r = Te.bufferInfo(e, s, 0);
    return this.getAssetTime(r.end) >= n - 0.02;
  }
  reachedPlayout(e) {
    const n = this.interstitial.playoutLimit;
    return this.startOffset + e >= n;
  }
  get destroyed() {
    var e;
    return !((e = this.hls) != null && e.userConfig);
  }
  get assetId() {
    return this.assetItem.identifier;
  }
  get interstitialId() {
    return this.assetItem.parentIdentifier;
  }
  get media() {
    var e;
    return ((e = this.hls) == null ? void 0 : e.media) || null;
  }
  get bufferedEnd() {
    const e = this.media || this.mediaAttached;
    if (!e)
      return this._bufferedEosTime ? this._bufferedEosTime : this.currentTime;
    const t = Te.bufferInfo(e, e.currentTime, 1e-3);
    return this.getAssetTime(t.end);
  }
  get currentTime() {
    const e = this.media || this.mediaAttached;
    return e ? this.getAssetTime(e.currentTime) : this._currentTime || 0;
  }
  get duration() {
    const e = this.assetItem.duration;
    if (!e)
      return 0;
    const t = this.interstitial.playoutLimit;
    if (t) {
      const n = t - this.startOffset;
      if (n > 0 && n < e)
        return n;
    }
    return e;
  }
  get remaining() {
    const e = this.duration;
    return e ? Math.max(0, e - this.currentTime) : 0;
  }
  get startOffset() {
    return this.assetItem.startOffset;
  }
  get timelineOffset() {
    var e;
    return ((e = this.hls) == null ? void 0 : e.config.timelineOffset) || 0;
  }
  set timelineOffset(e) {
    const t = this.timelineOffset;
    if (e !== t) {
      const n = e - t;
      if (Math.abs(n) > 1 / 9e4 && this.hls) {
        if (this.hasDetails)
          throw new Error("Cannot set timelineOffset after playlists are loaded");
        this.hls.config.timelineOffset = e;
      }
    }
  }
  getAssetTime(e) {
    const t = this.timelineOffset, n = this.duration;
    return Math.min(Math.max(0, e - t), n);
  }
  removeMediaListeners() {
    const e = this.mediaAttached;
    e && (this._currentTime = e.currentTime, this.bufferSnapShot(), e.removeEventListener("timeupdate", this.checkPlayout));
  }
  bufferSnapShot() {
    if (this.mediaAttached) {
      var e;
      (e = this.hls) != null && e.bufferedToEnd && (this._bufferedEosTime = this.bufferedEnd);
    }
  }
  destroy() {
    this.removeMediaListeners(), this.hls && this.hls.destroy(), this.hls = null, this.tracks = this.mediaAttached = this.checkPlayout = null;
  }
  attachMedia(e) {
    var t;
    this.loadSource(), (t = this.hls) == null || t.attachMedia(e);
  }
  detachMedia() {
    var e;
    this.removeMediaListeners(), this.mediaAttached = null, (e = this.hls) == null || e.detachMedia();
  }
  resumeBuffering() {
    var e;
    (e = this.hls) == null || e.resumeBuffering();
  }
  pauseBuffering() {
    var e;
    (e = this.hls) == null || e.pauseBuffering();
  }
  transferMedia() {
    var e;
    return this.bufferSnapShot(), ((e = this.hls) == null ? void 0 : e.transferMedia()) || null;
  }
  resetDetails() {
    const e = this.hls;
    if (e && this.hasDetails) {
      e.stopLoad();
      const t = (n) => delete n.details;
      e.levels.forEach(t), e.allAudioTracks.forEach(t), e.allSubtitleTracks.forEach(t), this.hasDetails = !1;
    }
  }
  on(e, t, n) {
    var s;
    (s = this.hls) == null || s.on(e, t);
  }
  once(e, t, n) {
    var s;
    (s = this.hls) == null || s.once(e, t);
  }
  off(e, t, n) {
    var s;
    (s = this.hls) == null || s.off(e, t);
  }
  toString() {
    var e;
    return `HlsAssetPlayer: ${Cn(this.assetItem)} ${(e = this.hls) == null ? void 0 : e.sessionId} ${this.appendInPlace ? "append-in-place" : ""}`;
  }
}
const Qc = 0.033;
class NS extends ni {
  constructor(e, t) {
    super("interstitials-sched", t), this.onScheduleUpdate = void 0, this.eventMap = {}, this.events = null, this.items = null, this.durations = {
      primary: 0,
      playout: 0,
      integrated: 0
    }, this.onScheduleUpdate = e;
  }
  destroy() {
    this.reset(), this.onScheduleUpdate = null;
  }
  reset() {
    this.eventMap = {}, this.setDurations(0, 0, 0), this.events && this.events.forEach((e) => e.reset()), this.events = this.items = null;
  }
  resetErrorsInRange(e, t) {
    return this.events ? this.events.reduce((n, s) => e <= s.startOffset && t > s.startOffset ? (delete s.error, n + 1) : n, 0) : 0;
  }
  get duration() {
    const e = this.items;
    return e ? e[e.length - 1].end : 0;
  }
  get length() {
    return this.items ? this.items.length : 0;
  }
  getEvent(e) {
    return e && this.eventMap[e] || null;
  }
  hasEvent(e) {
    return e in this.eventMap;
  }
  findItemIndex(e, t) {
    if (e.event)
      return this.findEventIndex(e.event.identifier);
    let n = -1;
    e.nextEvent ? n = this.findEventIndex(e.nextEvent.identifier) - 1 : e.previousEvent && (n = this.findEventIndex(e.previousEvent.identifier) + 1);
    const s = this.items;
    if (s)
      for (s[n] || (t === void 0 && (t = e.start), n = this.findItemIndexAtTime(t)); n >= 0 && (r = s[n]) != null && r.event; ) {
        var r;
        n--;
      }
    return n;
  }
  findItemIndexAtTime(e, t) {
    const n = this.items;
    if (n)
      for (let s = 0; s < n.length; s++) {
        let r = n[s];
        if (t && t !== "primary" && (r = r[t]), e === r.start || e > r.start && e < r.end)
          return s;
      }
    return -1;
  }
  findJumpRestrictedIndex(e, t) {
    const n = this.items;
    if (n)
      for (let s = e; s <= t && n[s]; s++) {
        const r = n[s].event;
        if (r != null && r.restrictions.jump && !r.appendInPlace)
          return s;
      }
    return -1;
  }
  findEventIndex(e) {
    const t = this.items;
    if (t)
      for (let s = t.length; s--; ) {
        var n;
        if (((n = t[s].event) == null ? void 0 : n.identifier) === e)
          return s;
      }
    return -1;
  }
  findAssetIndex(e, t) {
    const n = e.assetList, s = n.length;
    if (s > 1)
      for (let r = 0; r < s; r++) {
        const a = n[r];
        if (!a.error) {
          const o = a.timelineStart;
          if (t === o || t > o && (t < o + (a.duration || 0) || r === s - 1))
            return r;
        }
      }
    return 0;
  }
  get assetIdAtEnd() {
    var e;
    const t = (e = this.items) == null || (e = e[this.length - 1]) == null ? void 0 : e.event;
    if (t) {
      const n = t.assetList, s = n[n.length - 1];
      if (s)
        return s.identifier;
    }
    return null;
  }
  parseInterstitialDateRanges(e, t) {
    const n = e.main.details, {
      dateRanges: s
    } = n, r = this.events, a = this.parseDateRanges(s, {
      url: n.url
    }, t), o = Object.keys(s), l = r ? r.filter((d) => !o.includes(d.identifier)) : [];
    a.length && a.sort((d, c) => {
      const u = d.cue.pre, f = d.cue.post, h = c.cue.pre, m = c.cue.post;
      if (u && !h)
        return -1;
      if (h && !u || f && !m)
        return 1;
      if (m && !f)
        return -1;
      if (!u && !h && !f && !m) {
        const g = d.startTime, v = c.startTime;
        if (g !== v)
          return g - v;
      }
      return d.dateRange.tagOrder - c.dateRange.tagOrder;
    }), this.events = a, l.forEach((d) => {
      this.removeEvent(d);
    }), this.updateSchedule(e, l);
  }
  updateSchedule(e, t = [], n = !1) {
    const s = this.events || [];
    if (s.length || t.length || this.length < 2) {
      const r = this.items, a = this.parseSchedule(s, e);
      (n || t.length || r?.length !== a.length || a.some((l, d) => Math.abs(l.playout.start - r[d].playout.start) > 5e-3 || Math.abs(l.playout.end - r[d].playout.end) > 5e-3)) && (this.items = a, this.onScheduleUpdate(t, r));
    }
  }
  parseDateRanges(e, t, n) {
    const s = [], r = Object.keys(e);
    for (let a = 0; a < r.length; a++) {
      const o = r[a], l = e[o];
      if (l.isInterstitial) {
        let d = this.eventMap[o];
        d ? d.setDateRange(l) : (d = new RS(l, t), this.eventMap[o] = d, n === !1 && (d.appendInPlace = n)), s.push(d);
      }
    }
    return s;
  }
  parseSchedule(e, t) {
    const n = [], s = t.main.details, r = s.live ? 1 / 0 : s.edge;
    let a = 0;
    if (e = e.filter((l) => !l.error && !(l.cue.once && l.hasPlayed)), e.length) {
      this.resolveOffsets(e, t);
      let l = 0, d = 0;
      if (e.forEach((c, u) => {
        const f = c.cue.pre, h = c.cue.post, m = e[u - 1] || null, g = c.appendInPlace, v = h ? r : c.startOffset, p = c.duration, y = c.timelineOccupancy === $r.Range ? p : 0, b = c.resumptionOffset, k = m?.startTime === v, T = v + c.cumulativeDuration;
        let I = g ? T + p : v + b;
        if (f || !h && v <= 0) {
          const E = d;
          d += y, c.timelineStart = T;
          const R = a;
          a += p, n.push({
            event: c,
            start: T,
            end: I,
            playout: {
              start: R,
              end: a
            },
            integrated: {
              start: E,
              end: d
            }
          });
        } else if (v <= r) {
          if (!k) {
            const A = v - l;
            if (A > Qc) {
              const _ = l, C = d;
              d += A;
              const O = a;
              a += A;
              const V = {
                previousEvent: e[u - 1] || null,
                nextEvent: c,
                start: _,
                end: _ + A,
                playout: {
                  start: O,
                  end: a
                },
                integrated: {
                  start: C,
                  end: d
                }
              };
              n.push(V);
            } else A > 0 && m && (m.cumulativeDuration += A, n[n.length - 1].end = v);
          }
          h && (I = T), c.timelineStart = T;
          const E = d;
          d += y;
          const R = a;
          a += p, n.push({
            event: c,
            start: T,
            end: I,
            playout: {
              start: R,
              end: a
            },
            integrated: {
              start: E,
              end: d
            }
          });
        } else
          return;
        const x = c.resumeTime;
        h || x > r ? l = r : l = x;
      }), l < r) {
        var o;
        const c = l, u = d, f = r - l;
        d += f;
        const h = a;
        a += f, n.push({
          previousEvent: ((o = n[n.length - 1]) == null ? void 0 : o.event) || null,
          nextEvent: null,
          start: l,
          end: c + f,
          playout: {
            start: h,
            end: a
          },
          integrated: {
            start: u,
            end: d
          }
        });
      }
      this.setDurations(r, a, d);
    } else
      n.push({
        previousEvent: null,
        nextEvent: null,
        start: 0,
        end: r,
        playout: {
          start: 0,
          end: r
        },
        integrated: {
          start: 0,
          end: r
        }
      }), this.setDurations(r, r, r);
    return n;
  }
  setDurations(e, t, n) {
    this.durations = {
      primary: e,
      playout: t,
      integrated: n
    };
  }
  resolveOffsets(e, t) {
    const n = t.main.details, s = n.live ? 1 / 0 : n.edge;
    let r = 0, a = -1;
    e.forEach((o, l) => {
      const d = o.cue.pre, c = o.cue.post, u = d ? 0 : c ? s : o.startTime;
      this.updateAssetDurations(o), a === u ? o.cumulativeDuration = r : (r = 0, a = u), !c && o.snapOptions.in && (o.resumeAnchor = Sn(null, n.fragments, o.startOffset + o.resumptionOffset, 0, 0) || void 0), o.appendInPlace && !o.appendInPlaceStarted && (this.primaryCanResumeInPlaceAt(o, t) || (o.appendInPlace = !1)), !o.appendInPlace && l + 1 < e.length && e[l + 1].startTime - e[l].resumeTime < Qc && (e[l + 1].appendInPlace = !1, e[l + 1].appendInPlace && this.warn(`Could not change append strategy for abutting event ${o}`));
      const h = ae(o.resumeOffset) ? o.resumeOffset : o.duration;
      r += h;
    });
  }
  primaryCanResumeInPlaceAt(e, t) {
    const n = e.resumeTime, s = e.startTime + e.resumptionOffset;
    return Math.abs(n - s) > Gn ? (this.log(`"${e.identifier}" resumption ${n} not aligned with estimated timeline end ${s}`), !1) : !Object.keys(t).some((a) => {
      const o = t[a].details, l = o.edge;
      if (n >= l)
        return this.log(`"${e.identifier}" resumption ${n} past ${a} playlist end ${l}`), !1;
      const d = Sn(null, o.fragments, n);
      if (!d)
        return this.log(`"${e.identifier}" resumption ${n} does not align with any fragments in ${a} playlist (${o.fragStart}-${o.fragmentEnd})`), !0;
      const c = a === "audio" ? 0.175 : 0;
      return Math.abs(d.start - n) < Gn + c || Math.abs(d.end - n) < Gn + c ? !1 : (this.log(`"${e.identifier}" resumption ${n} not aligned with ${a} fragment bounds (${d.start}-${d.end} sn: ${d.sn} cc: ${d.cc})`), !0);
    });
  }
  updateAssetDurations(e) {
    if (!e.assetListLoaded)
      return;
    const t = e.timelineStart;
    let n = 0, s = !1, r = !1;
    for (let a = 0; a < e.assetList.length; a++) {
      const o = e.assetList[a], l = t + n;
      o.startOffset = n, o.timelineStart = l, s || (s = o.duration === null), r || (r = !!o.error);
      const d = o.error ? 0 : o.duration || 0;
      n += d;
    }
    s && !r ? e.duration = Math.max(n, e.duration) : e.duration = n;
  }
  removeEvent(e) {
    e.reset(), delete this.eventMap[e.identifier];
  }
}
function Ei(i) {
  return `[${i.event ? '"' + i.event.identifier + '"' : "primary"}: ${i.start.toFixed(2)}-${i.end.toFixed(2)}]`;
}
class MS {
  constructor(e) {
    this.hls = void 0, this.hls = e;
  }
  destroy() {
    this.hls = null;
  }
  loadAssetList(e, t) {
    const n = e.assetListUrl;
    let s;
    try {
      s = fm(n, this.hls.sessionId, e.baseUrl);
    } catch (f) {
      const h = this.assignAssetListError(e, B.ASSET_LIST_LOAD_ERROR, f, n);
      this.hls.trigger(S.ERROR, h);
      return;
    }
    t && s.protocol !== "data:" && s.searchParams.set("_HLS_start_offset", "" + t);
    const r = this.hls.config, a = r.loader, o = new a(r), l = {
      responseType: "json",
      url: s.href
    }, d = r.interstitialAssetListLoadPolicy.default, c = {
      loadPolicy: d,
      timeout: d.maxLoadTimeMs,
      maxRetry: 0,
      retryDelay: 0,
      maxRetryDelay: 0
    }, u = {
      onSuccess: (f, h, m, g) => {
        const v = f.data, p = v?.ASSETS;
        if (!Array.isArray(p)) {
          const y = this.assignAssetListError(e, B.ASSET_LIST_PARSING_ERROR, new Error("Invalid interstitial asset list"), m.url, h, g);
          this.hls.trigger(S.ERROR, y);
          return;
        }
        e.assetListResponse = v, this.hls.trigger(S.ASSET_LIST_LOADED, {
          event: e,
          assetListResponse: v,
          networkDetails: g
        });
      },
      onError: (f, h, m, g) => {
        const v = this.assignAssetListError(e, B.ASSET_LIST_LOAD_ERROR, new Error(`Error loading X-ASSET-LIST: HTTP status ${f.code} ${f.text} (${h.url})`), h.url, g, m);
        this.hls.trigger(S.ERROR, v);
      },
      onTimeout: (f, h, m) => {
        const g = this.assignAssetListError(e, B.ASSET_LIST_LOAD_TIMEOUT, new Error(`Timeout loading X-ASSET-LIST (${h.url})`), h.url, f, m);
        this.hls.trigger(S.ERROR, g);
      }
    };
    return o.load(l, c, u), this.hls.trigger(S.ASSET_LIST_LOADING, {
      event: e
    }), o;
  }
  assignAssetListError(e, t, n, s, r, a) {
    return e.error = n, {
      type: pe.NETWORK_ERROR,
      details: t,
      fatal: !1,
      interstitial: e,
      url: s,
      error: n,
      networkDetails: a,
      stats: r
    };
  }
}
function Jc(i) {
  i?.play().catch(() => {
  });
}
class OS extends ni {
  constructor(e, t) {
    super("interstitials", e.logger), this.HlsPlayerClass = void 0, this.hls = void 0, this.assetListLoader = void 0, this.mediaSelection = null, this.altSelection = null, this.media = null, this.detachedData = null, this.requiredTracks = null, this.manager = null, this.playerQueue = [], this.bufferedPos = -1, this.timelinePos = -1, this.schedule = void 0, this.playingItem = null, this.bufferingItem = null, this.waitingItem = null, this.endedItem = null, this.playingAsset = null, this.endedAsset = null, this.bufferingAsset = null, this.shouldPlay = !1, this.onPlay = () => {
      this.shouldPlay = !0;
    }, this.onPause = () => {
      this.shouldPlay = !1;
    }, this.onSeeking = () => {
      const n = this.currentTime;
      if (n === void 0 || this.playbackDisabled || !this.schedule)
        return;
      const s = n - this.timelinePos;
      if (Math.abs(s) < 1 / 7056e5)
        return;
      const a = s <= -0.01;
      this.timelinePos = n, this.bufferedPos = n;
      const o = this.playingItem;
      if (!o) {
        this.checkBuffer();
        return;
      }
      if (a && this.schedule.resetErrorsInRange(n, n - s) && this.updateSchedule(!0), this.checkBuffer(), a && n < o.start || n >= o.end) {
        var l;
        const h = this.findItemIndex(o);
        let m = this.schedule.findItemIndexAtTime(n);
        if (m === -1 && (m = h + (a ? -1 : 1), this.log(`seeked ${a ? "back " : ""}to position not covered by schedule ${n} (resolving from ${h} to ${m})`)), !this.isInterstitial(o) && (l = this.media) != null && l.paused && (this.shouldPlay = !1), !a && m > h) {
          const g = this.schedule.findJumpRestrictedIndex(h + 1, m);
          if (g > h) {
            this.setSchedulePosition(g);
            return;
          }
        }
        this.setSchedulePosition(m);
        return;
      }
      const d = this.playingAsset;
      if (!d) {
        if (this.playingLastItem && this.isInterstitial(o)) {
          const h = o.event.assetList[0];
          h && (this.endedItem = this.playingItem, this.playingItem = null, this.setScheduleToAssetAtTime(n, h));
        }
        return;
      }
      const c = d.timelineStart, u = d.duration || 0;
      if (a && n < c || n >= c + u) {
        var f;
        (f = o.event) != null && f.appendInPlace && (this.clearInterstitial(o.event, o), this.flushFrontBuffer(n)), this.setScheduleToAssetAtTime(n, d);
      }
    }, this.onTimeupdate = () => {
      const n = this.currentTime;
      if (n === void 0 || this.playbackDisabled)
        return;
      if (n > this.timelinePos)
        this.timelinePos = n, n > this.bufferedPos && this.checkBuffer();
      else
        return;
      const s = this.playingItem;
      if (!s || this.playingLastItem)
        return;
      if (n >= s.end) {
        this.timelinePos = s.end;
        const o = this.findItemIndex(s);
        this.setSchedulePosition(o + 1);
      }
      const r = this.playingAsset;
      if (!r)
        return;
      const a = r.timelineStart + (r.duration || 0);
      n >= a && this.setScheduleToAssetAtTime(n, r);
    }, this.onScheduleUpdate = (n, s) => {
      const r = this.schedule;
      if (!r)
        return;
      const a = this.playingItem, o = r.events || [], l = r.items || [], d = r.durations, c = n.map((g) => g.identifier), u = !!(o.length || c.length);
      (u || s) && this.log(`INTERSTITIALS_UPDATED (${o.length}): ${o}
Schedule: ${l.map((g) => Ei(g))} pos: ${this.timelinePos}`), c.length && this.log(`Removed events ${c}`);
      let f = null, h = null;
      a && (f = this.updateItem(a, this.timelinePos), this.itemsMatch(a, f) ? this.playingItem = f : this.waitingItem = this.endedItem = null), this.waitingItem = this.updateItem(this.waitingItem), this.endedItem = this.updateItem(this.endedItem);
      const m = this.bufferingItem;
      if (m && (h = this.updateItem(m, this.bufferedPos), this.itemsMatch(m, h) ? this.bufferingItem = h : m.event && (this.bufferingItem = this.playingItem, this.clearInterstitial(m.event, null))), n.forEach((g) => {
        g.assetList.forEach((v) => {
          this.clearAssetPlayer(v.identifier, null);
        });
      }), this.playerQueue.forEach((g) => {
        if (g.interstitial.appendInPlace) {
          const v = g.assetItem.timelineStart, p = g.timelineOffset - v;
          if (p)
            try {
              g.timelineOffset = v;
            } catch (y) {
              Math.abs(p) > Gn && this.warn(`${y} ("${g.assetId}" ${g.timelineOffset}->${v})`);
            }
        }
      }), u || s) {
        if (this.hls.trigger(S.INTERSTITIALS_UPDATED, {
          events: o.slice(0),
          schedule: l.slice(0),
          durations: d,
          removedIds: c
        }), this.isInterstitial(a) && c.includes(a.event.identifier)) {
          this.warn(`Interstitial "${a.event.identifier}" removed while playing`), this.primaryFallback(a.event);
          return;
        }
        a && this.trimInPlace(f, a), m && this.trimInPlace(h, m), this.checkBuffer();
      }
    }, this.hls = e, this.HlsPlayerClass = t, this.assetListLoader = new MS(e), this.schedule = new NS(this.onScheduleUpdate, e.logger), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e && (e.on(S.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(S.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(S.MANIFEST_LOADING, this.onManifestLoading, this), e.on(S.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(S.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(S.AUDIO_TRACK_UPDATED, this.onAudioTrackUpdated, this), e.on(S.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.on(S.SUBTITLE_TRACK_UPDATED, this.onSubtitleTrackUpdated, this), e.on(S.EVENT_CUE_ENTER, this.onInterstitialCueEnter, this), e.on(S.ASSET_LIST_LOADED, this.onAssetListLoaded, this), e.on(S.BUFFER_APPENDED, this.onBufferAppended, this), e.on(S.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(S.BUFFERED_TO_END, this.onBufferedToEnd, this), e.on(S.MEDIA_ENDED, this.onMediaEnded, this), e.on(S.ERROR, this.onError, this), e.on(S.DESTROYING, this.onDestroying, this));
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(S.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(S.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(S.MANIFEST_LOADING, this.onManifestLoading, this), e.off(S.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(S.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(S.AUDIO_TRACK_UPDATED, this.onAudioTrackUpdated, this), e.off(S.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.off(S.SUBTITLE_TRACK_UPDATED, this.onSubtitleTrackUpdated, this), e.off(S.EVENT_CUE_ENTER, this.onInterstitialCueEnter, this), e.off(S.ASSET_LIST_LOADED, this.onAssetListLoaded, this), e.off(S.BUFFER_CODECS, this.onBufferCodecs, this), e.off(S.BUFFER_APPENDED, this.onBufferAppended, this), e.off(S.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(S.BUFFERED_TO_END, this.onBufferedToEnd, this), e.off(S.MEDIA_ENDED, this.onMediaEnded, this), e.off(S.ERROR, this.onError, this), e.off(S.DESTROYING, this.onDestroying, this));
  }
  startLoad() {
    this.resumeBuffering();
  }
  stopLoad() {
    this.pauseBuffering();
  }
  resumeBuffering() {
    var e;
    (e = this.getBufferingPlayer()) == null || e.resumeBuffering();
  }
  pauseBuffering() {
    var e;
    (e = this.getBufferingPlayer()) == null || e.pauseBuffering();
  }
  destroy() {
    this.unregisterListeners(), this.stopLoad(), this.assetListLoader && this.assetListLoader.destroy(), this.emptyPlayerQueue(), this.clearScheduleState(), this.schedule && this.schedule.destroy(), this.media = this.detachedData = this.mediaSelection = this.requiredTracks = this.altSelection = this.schedule = this.manager = null, this.hls = this.HlsPlayerClass = this.log = null, this.assetListLoader = null, this.onPlay = this.onPause = this.onSeeking = this.onTimeupdate = null, this.onScheduleUpdate = null;
  }
  onDestroying() {
    const e = this.primaryMedia || this.media;
    e && this.removeMediaListeners(e);
  }
  removeMediaListeners(e) {
    Yt(e, "play", this.onPlay), Yt(e, "pause", this.onPause), Yt(e, "seeking", this.onSeeking), Yt(e, "timeupdate", this.onTimeupdate);
  }
  onMediaAttaching(e, t) {
    const n = this.media = t.media;
    Vt(n, "seeking", this.onSeeking), Vt(n, "timeupdate", this.onTimeupdate), Vt(n, "play", this.onPlay), Vt(n, "pause", this.onPause);
  }
  onMediaAttached(e, t) {
    const n = this.effectivePlayingItem, s = this.detachedData;
    if (this.detachedData = null, n === null)
      this.checkStart();
    else if (!s) {
      this.clearScheduleState();
      const r = this.findItemIndex(n);
      this.setSchedulePosition(r);
    }
  }
  clearScheduleState() {
    this.playingItem = this.bufferingItem = this.waitingItem = this.endedItem = this.playingAsset = this.endedAsset = this.bufferingAsset = null;
  }
  onMediaDetaching(e, t) {
    const n = !!t.transferMedia, s = this.media;
    if (this.media = null, !n && (s && this.removeMediaListeners(s), this.detachedData)) {
      const r = this.getBufferingPlayer();
      r && (this.playingAsset = this.endedAsset = this.bufferingAsset = this.bufferingItem = this.waitingItem = this.detachedData = null, r.detachMedia()), this.shouldPlay = !1;
    }
  }
  get interstitialsManager() {
    if (!this.hls)
      return null;
    if (this.manager)
      return this.manager;
    const e = this, t = () => e.bufferingItem || e.waitingItem, n = (u) => u && e.getAssetPlayer(u.identifier), s = (u, f, h, m, g) => {
      if (u) {
        let v = u[f].start;
        const p = u.event;
        if (p) {
          if (f === "playout" || p.timelineOccupancy !== $r.Point) {
            const y = n(h);
            y?.interstitial === p && (v += y.assetItem.startOffset + y[g]);
          }
        } else {
          const y = m === "bufferedPos" ? a() : e[m];
          v += y - u.start;
        }
        return v;
      }
      return 0;
    }, r = (u, f) => {
      var h;
      if (u !== 0 && f !== "primary" && (h = e.schedule) != null && h.length) {
        var m;
        const g = e.schedule.findItemIndexAtTime(u), v = (m = e.schedule.items) == null ? void 0 : m[g];
        if (v) {
          const p = v[f].start - v.start;
          return u + p;
        }
      }
      return u;
    }, a = () => {
      const u = e.bufferedPos;
      return u === Number.MAX_VALUE ? o("primary") : Math.max(u, 0);
    }, o = (u) => {
      var f, h;
      return (f = e.primaryDetails) != null && f.live ? e.primaryDetails.edge : ((h = e.schedule) == null ? void 0 : h.durations[u]) || 0;
    }, l = (u, f) => {
      var h, m;
      const g = e.effectivePlayingItem;
      if (g != null && (h = g.event) != null && h.restrictions.skip || !e.schedule)
        return;
      e.log(`seek to ${u} "${f}"`);
      const v = e.effectivePlayingItem, p = e.schedule.findItemIndexAtTime(u, f), y = (m = e.schedule.items) == null ? void 0 : m[p], b = e.getBufferingPlayer(), k = b?.interstitial, T = k?.appendInPlace, I = v && e.itemsMatch(v, y);
      if (v && (T || I)) {
        const x = n(e.playingAsset), E = x?.media || e.primaryMedia;
        if (E) {
          const R = f === "primary" ? E.currentTime : s(v, f, e.playingAsset, "timelinePos", "currentTime"), A = u - R, _ = (T ? R : E.currentTime) + A;
          if (_ >= 0 && (!x || T || _ <= x.duration)) {
            E.currentTime = _;
            return;
          }
        }
      }
      if (y) {
        let x = u;
        if (f !== "primary") {
          const R = y[f].start, A = u - R;
          x = y.start + A;
        }
        const E = !e.isInterstitial(y);
        if ((!e.isInterstitial(v) || v.event.appendInPlace) && (E || y.event.appendInPlace)) {
          const R = e.media || (T ? b?.media : null);
          R && (R.currentTime = x);
        } else if (v) {
          const R = e.findItemIndex(v);
          if (p > R) {
            const _ = e.schedule.findJumpRestrictedIndex(R + 1, p);
            if (_ > R) {
              e.setSchedulePosition(_);
              return;
            }
          }
          let A = 0;
          if (E)
            e.timelinePos = x, e.checkBuffer();
          else {
            const _ = y.event.assetList, C = u - (y[f] || y).start;
            for (let O = _.length; O--; ) {
              const V = _[O];
              if (V.duration && C >= V.startOffset && C < V.startOffset + V.duration) {
                A = O;
                break;
              }
            }
          }
          e.setSchedulePosition(p, A);
        }
      }
    }, d = () => {
      const u = e.effectivePlayingItem;
      if (e.isInterstitial(u))
        return u;
      const f = t();
      return e.isInterstitial(f) ? f : null;
    }, c = {
      get bufferedEnd() {
        const u = t(), f = e.bufferingItem;
        if (f && f === u) {
          var h;
          return s(f, "playout", e.bufferingAsset, "bufferedPos", "bufferedEnd") - f.playout.start || ((h = e.bufferingAsset) == null ? void 0 : h.startOffset) || 0;
        }
        return 0;
      },
      get currentTime() {
        const u = d(), f = e.effectivePlayingItem;
        return f && f === u ? s(f, "playout", e.effectivePlayingAsset, "timelinePos", "currentTime") - f.playout.start : 0;
      },
      set currentTime(u) {
        const f = d(), h = e.effectivePlayingItem;
        h && h === f && l(u + h.playout.start, "playout");
      },
      get duration() {
        const u = d();
        return u ? u.playout.end - u.playout.start : 0;
      },
      get assetPlayers() {
        var u;
        const f = (u = d()) == null ? void 0 : u.event.assetList;
        return f ? f.map((h) => e.getAssetPlayer(h.identifier)) : [];
      },
      get playingIndex() {
        var u;
        const f = (u = d()) == null ? void 0 : u.event;
        return f && e.effectivePlayingAsset ? f.findAssetIndex(e.effectivePlayingAsset) : -1;
      },
      get scheduleItem() {
        return d();
      }
    };
    return this.manager = {
      get events() {
        var u;
        return ((u = e.schedule) == null || (u = u.events) == null ? void 0 : u.slice(0)) || [];
      },
      get schedule() {
        var u;
        return ((u = e.schedule) == null || (u = u.items) == null ? void 0 : u.slice(0)) || [];
      },
      get interstitialPlayer() {
        return d() ? c : null;
      },
      get playerQueue() {
        return e.playerQueue.slice(0);
      },
      get bufferingAsset() {
        return e.bufferingAsset;
      },
      get bufferingItem() {
        return t();
      },
      get bufferingIndex() {
        const u = t();
        return e.findItemIndex(u);
      },
      get playingAsset() {
        return e.effectivePlayingAsset;
      },
      get playingItem() {
        return e.effectivePlayingItem;
      },
      get playingIndex() {
        const u = e.effectivePlayingItem;
        return e.findItemIndex(u);
      },
      primary: {
        get bufferedEnd() {
          return a();
        },
        get currentTime() {
          const u = e.timelinePos;
          return u > 0 ? u : 0;
        },
        set currentTime(u) {
          l(u, "primary");
        },
        get duration() {
          return o("primary");
        },
        get seekableStart() {
          var u;
          return ((u = e.primaryDetails) == null ? void 0 : u.fragmentStart) || 0;
        }
      },
      integrated: {
        get bufferedEnd() {
          return s(t(), "integrated", e.bufferingAsset, "bufferedPos", "bufferedEnd");
        },
        get currentTime() {
          return s(e.effectivePlayingItem, "integrated", e.effectivePlayingAsset, "timelinePos", "currentTime");
        },
        set currentTime(u) {
          l(u, "integrated");
        },
        get duration() {
          return o("integrated");
        },
        get seekableStart() {
          var u;
          return r(((u = e.primaryDetails) == null ? void 0 : u.fragmentStart) || 0, "integrated");
        }
      },
      skip: () => {
        const u = e.effectivePlayingItem, f = u?.event;
        if (f && !f.restrictions.skip) {
          const h = e.findItemIndex(u);
          if (f.appendInPlace) {
            const m = u.playout.start + u.event.duration;
            l(m + 1e-3, "playout");
          } else
            e.advanceAfterAssetEnded(f, h, 1 / 0);
        }
      }
    };
  }
  // Schedule getters
  get effectivePlayingItem() {
    return this.waitingItem || this.playingItem || this.endedItem;
  }
  get effectivePlayingAsset() {
    return this.playingAsset || this.endedAsset;
  }
  get playingLastItem() {
    var e;
    const t = this.playingItem, n = (e = this.schedule) == null ? void 0 : e.items;
    return !this.playbackStarted || !t || !n ? !1 : this.findItemIndex(t) === n.length - 1;
  }
  get playbackStarted() {
    return this.effectivePlayingItem !== null;
  }
  // Media getters and event callbacks
  get currentTime() {
    var e, t;
    if (this.mediaSelection === null)
      return;
    const n = this.waitingItem || this.playingItem;
    if (this.isInterstitial(n) && !n.event.appendInPlace)
      return;
    let s = this.media;
    !s && (e = this.bufferingItem) != null && (e = e.event) != null && e.appendInPlace && (s = this.primaryMedia);
    const r = (t = s) == null ? void 0 : t.currentTime;
    if (!(r === void 0 || !ae(r)))
      return r;
  }
  get primaryMedia() {
    var e;
    return this.media || ((e = this.detachedData) == null ? void 0 : e.media) || null;
  }
  isInterstitial(e) {
    return !!(e != null && e.event);
  }
  retreiveMediaSource(e, t) {
    const n = this.getAssetPlayer(e);
    n && this.transferMediaFromPlayer(n, t);
  }
  transferMediaFromPlayer(e, t) {
    const n = e.interstitial.appendInPlace, s = e.media;
    if (n && s === this.primaryMedia) {
      if (this.bufferingAsset = null, (!t || this.isInterstitial(t) && !t.event.appendInPlace) && t && s) {
        this.detachedData = {
          media: s
        };
        return;
      }
      const r = e.transferMedia();
      this.log(`transfer MediaSource from ${e} ${qe(r)}`), this.detachedData = r;
    } else t && s && (this.shouldPlay || (this.shouldPlay = !s.paused));
  }
  transferMediaTo(e, t) {
    var n, s;
    if (e.media === t)
      return;
    let r = null;
    const a = this.hls, o = e !== a, l = o && e.interstitial.appendInPlace, d = (n = this.detachedData) == null ? void 0 : n.mediaSource;
    let c;
    if (a.media)
      l && (r = a.transferMedia(), this.detachedData = r), c = "Primary";
    else if (d) {
      const m = this.getBufferingPlayer();
      m ? (r = m.transferMedia(), c = `${m}`) : c = "detached MediaSource";
    } else
      c = "detached media";
    if (!r) {
      if (d)
        r = this.detachedData, this.log(`using detachedData: MediaSource ${qe(r)}`);
      else if (!this.detachedData || a.media === t) {
        const m = this.playerQueue;
        m.length > 1 && m.forEach((g) => {
          if (o && g.interstitial.appendInPlace !== l) {
            const v = g.interstitial;
            this.clearInterstitial(g.interstitial, null), v.appendInPlace = !1, v.appendInPlace && this.warn(`Could not change append strategy for queued assets ${v}`);
          }
        }), this.hls.detachMedia(), this.detachedData = {
          media: t
        };
      }
    }
    const u = r && "mediaSource" in r && ((s = r.mediaSource) == null ? void 0 : s.readyState) !== "closed", f = u && r ? r : t;
    this.log(`${u ? "transfering MediaSource" : "attaching media"} to ${o ? e : "Primary"} from ${c} (media.currentTime: ${t.currentTime})`);
    const h = this.schedule;
    if (f === r && h) {
      const m = o && e.assetId === h.assetIdAtEnd;
      f.overrides = {
        duration: h.duration,
        endOfStream: !o || m,
        cueRemoval: !o
      };
    }
    e.attachMedia(f);
  }
  onInterstitialCueEnter() {
    this.onTimeupdate();
  }
  // Scheduling methods
  checkStart() {
    const e = this.schedule, t = e?.events;
    if (!t || this.playbackDisabled || !this.media)
      return;
    this.bufferedPos === -1 && (this.bufferedPos = 0);
    const n = this.timelinePos, s = this.effectivePlayingItem;
    if (n === -1) {
      const r = this.hls.startPosition;
      if (this.timelinePos = r, t.length && t[0].cue.pre) {
        const a = e.findEventIndex(t[0].identifier);
        this.setSchedulePosition(a);
      } else if (r >= 0 || !this.primaryLive) {
        const a = this.timelinePos = r > 0 ? r : 0, o = e.findItemIndexAtTime(a);
        this.setSchedulePosition(o);
      }
    } else if (s && !this.playingItem) {
      const r = e.findItemIndex(s);
      this.setSchedulePosition(r);
    }
  }
  advanceAssetBuffering(e, t) {
    const n = e.event, s = n.findAssetIndex(t), r = ja(n, s);
    if (!n.isAssetPastPlayoutLimit(r))
      this.bufferedToEvent(e, r);
    else if (this.schedule) {
      var a;
      const o = (a = this.schedule.items) == null ? void 0 : a[this.findItemIndex(e) + 1];
      o && this.bufferedToItem(o);
    }
  }
  advanceAfterAssetEnded(e, t, n) {
    const s = ja(e, n);
    if (e.isAssetPastPlayoutLimit(s)) {
      if (this.schedule) {
        const r = this.schedule.items;
        if (r) {
          const a = t + 1, o = r.length;
          if (a >= o) {
            this.setSchedulePosition(-1);
            return;
          }
          const l = e.resumeTime;
          this.timelinePos < l && (this.timelinePos = l, e.appendInPlace && this.advanceInPlace(l), this.checkBuffer(this.bufferedPos < l)), this.setSchedulePosition(a);
        }
      }
    } else {
      if (e.appendInPlace) {
        const r = e.assetList[s];
        r && this.advanceInPlace(r.timelineStart);
      }
      this.setSchedulePosition(t, s);
    }
  }
  setScheduleToAssetAtTime(e, t) {
    const n = this.schedule;
    if (!n)
      return;
    const s = t.parentIdentifier, r = n.getEvent(s);
    if (r) {
      const a = n.findEventIndex(s), o = n.findAssetIndex(r, e);
      this.advanceAfterAssetEnded(r, a, o - 1);
    }
  }
  setSchedulePosition(e, t) {
    var n;
    const s = (n = this.schedule) == null ? void 0 : n.items;
    if (!s || this.playbackDisabled)
      return;
    const r = e >= 0 ? s[e] : null;
    this.log(`setSchedulePosition ${e}, ${t} (${r && Ei(r)})`);
    const a = this.waitingItem || this.playingItem, o = this.playingLastItem;
    if (this.isInterstitial(a)) {
      const c = a.event, u = this.playingAsset, f = u?.identifier, h = f ? this.getAssetPlayer(f) : null;
      if (h && f && (!this.eventItemsMatch(a, r) || t !== void 0 && f !== c.assetList[t].identifier)) {
        var l;
        const m = c.findAssetIndex(u);
        if (this.log(`INTERSTITIAL_ASSET_ENDED ${m + 1}/${c.assetList.length} ${Cn(u)}`), this.endedAsset = u, this.playingAsset = null, this.hls.trigger(S.INTERSTITIAL_ASSET_ENDED, {
          asset: u,
          assetListIndex: m,
          event: c,
          schedule: s.slice(0),
          scheduleIndex: e,
          player: h
        }), a !== this.playingItem) {
          this.itemsMatch(a, this.playingItem) && // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          !this.playingAsset && this.advanceAfterAssetEnded(c, this.findItemIndex(this.playingItem), m);
          return;
        }
        this.retreiveMediaSource(f, r), h.media && !((l = this.detachedData) != null && l.mediaSource) && h.detachMedia();
      }
      if (!this.eventItemsMatch(a, r) && (this.endedItem = a, this.playingItem = null, this.log(`INTERSTITIAL_ENDED ${c} ${Ei(a)}`), c.hasPlayed = !0, this.hls.trigger(S.INTERSTITIAL_ENDED, {
        event: c,
        schedule: s.slice(0),
        scheduleIndex: e
      }), c.cue.once)) {
        var d;
        this.updateSchedule();
        const m = (d = this.schedule) == null ? void 0 : d.items;
        if (r && m) {
          const g = this.findItemIndex(r);
          this.advanceSchedule(g, m, t, a, o);
        }
        return;
      }
    }
    this.advanceSchedule(e, s, t, a, o);
  }
  advanceSchedule(e, t, n, s, r) {
    const a = this.schedule;
    if (!a)
      return;
    const o = e >= 0 ? t[e] : null, l = this.primaryMedia, d = this.playerQueue;
    if (d.length && d.forEach((c) => {
      const u = c.interstitial, f = a.findEventIndex(u.identifier);
      (f < e || f > e + 1) && this.clearInterstitial(u, o);
    }), this.isInterstitial(o)) {
      this.timelinePos = Math.min(Math.max(this.timelinePos, o.start), o.end);
      const c = o.event;
      if (n === void 0) {
        n = a.findAssetIndex(c, this.timelinePos);
        const m = ja(c, n - 1);
        if (c.isAssetPastPlayoutLimit(m) || c.appendInPlace && this.timelinePos === o.end) {
          this.advanceAfterAssetEnded(c, e, n);
          return;
        }
        n = m;
      }
      const u = this.waitingItem;
      this.assetsBuffered(o, l) || this.setBufferingItem(o);
      let f = this.preloadAssets(c, n);
      if (this.eventItemsMatch(o, u || s) || (this.waitingItem = o, this.log(`INTERSTITIAL_STARTED ${Ei(o)} ${c.appendInPlace ? "append in place" : ""}`), this.hls.trigger(S.INTERSTITIAL_STARTED, {
        event: c,
        schedule: t.slice(0),
        scheduleIndex: e
      })), !c.assetListLoaded) {
        this.log(`Waiting for ASSET-LIST to complete loading ${c}`);
        return;
      }
      if (c.assetListLoader && (c.assetListLoader.destroy(), c.assetListLoader = void 0), !l) {
        this.log(`Waiting for attachMedia to start Interstitial ${c}`);
        return;
      }
      this.waitingItem = this.endedItem = null, this.playingItem = o;
      const h = c.assetList[n];
      if (!h) {
        this.advanceAfterAssetEnded(c, e, n || 0);
        return;
      }
      if (f || (f = this.getAssetPlayer(h.identifier)), f === null || f.destroyed) {
        const m = c.assetList.length;
        this.warn(`asset ${n + 1}/${m} player destroyed ${c}`), f = this.createAssetPlayer(c, h, n), f.loadSource();
      }
      if (!this.eventItemsMatch(o, this.bufferingItem) && c.appendInPlace && this.isAssetBuffered(h))
        return;
      this.startAssetPlayer(f, n, t, e, l), this.shouldPlay && Jc(f.media);
    } else o !== null ? (this.resumePrimary(o, e, s), this.shouldPlay && Jc(this.hls.media)) : r && this.isInterstitial(s) && (this.endedItem = null, this.playingItem = s, s.event.appendInPlace || this.attachPrimary(a.durations.primary, null));
  }
  get playbackDisabled() {
    return this.hls.config.enableInterstitialPlayback === !1;
  }
  get primaryDetails() {
    var e;
    return (e = this.mediaSelection) == null ? void 0 : e.main.details;
  }
  get primaryLive() {
    var e;
    return !!((e = this.primaryDetails) != null && e.live);
  }
  resumePrimary(e, t, n) {
    var s, r;
    if (this.playingItem = e, this.playingAsset = this.endedAsset = null, this.waitingItem = this.endedItem = null, this.bufferedToItem(e), this.log(`resuming ${Ei(e)}`), !((s = this.detachedData) != null && s.mediaSource)) {
      let o = this.timelinePos;
      (o < e.start || o >= e.end) && (o = this.getPrimaryResumption(e, t), this.timelinePos = o), this.attachPrimary(o, e);
    }
    if (!n)
      return;
    const a = (r = this.schedule) == null ? void 0 : r.items;
    a && (this.log(`INTERSTITIALS_PRIMARY_RESUMED ${Ei(e)}`), this.hls.trigger(S.INTERSTITIALS_PRIMARY_RESUMED, {
      schedule: a.slice(0),
      scheduleIndex: t
    }), this.checkBuffer());
  }
  getPrimaryResumption(e, t) {
    const n = e.start;
    if (this.primaryLive) {
      const s = this.primaryDetails;
      if (t === 0)
        return this.hls.startPosition;
      if (s && (n < s.fragmentStart || n > s.edge))
        return this.hls.liveSyncPosition || -1;
    }
    return n;
  }
  isAssetBuffered(e) {
    const t = this.getAssetPlayer(e.identifier);
    return t != null && t.hls ? t.hls.bufferedToEnd : Te.bufferInfo(this.primaryMedia, this.timelinePos, 0).end + 1 >= e.timelineStart + (e.duration || 0);
  }
  attachPrimary(e, t, n) {
    t ? this.setBufferingItem(t) : this.bufferingItem = this.playingItem, this.bufferingAsset = null;
    const s = this.primaryMedia;
    if (!s)
      return;
    const r = this.hls;
    r.media ? this.checkBuffer() : (this.transferMediaTo(r, s), n && this.startLoadingPrimaryAt(e, n)), n || (this.timelinePos = e, this.startLoadingPrimaryAt(e, n));
  }
  startLoadingPrimaryAt(e, t) {
    var n;
    const s = this.hls;
    !s.loadingEnabled || !s.media || Math.abs((((n = s.mainForwardBufferInfo) == null ? void 0 : n.start) || s.media.currentTime) - e) > 0.5 ? s.startLoad(e, t) : s.bufferingEnabled || s.resumeBuffering();
  }
  // HLS.js event callbacks
  onManifestLoading() {
    var e;
    this.stopLoad(), (e = this.schedule) == null || e.reset(), this.emptyPlayerQueue(), this.clearScheduleState(), this.shouldPlay = !1, this.bufferedPos = this.timelinePos = -1, this.mediaSelection = this.altSelection = this.manager = this.requiredTracks = null, this.hls.off(S.BUFFER_CODECS, this.onBufferCodecs, this), this.hls.on(S.BUFFER_CODECS, this.onBufferCodecs, this);
  }
  onLevelUpdated(e, t) {
    if (t.level === -1 || !this.schedule)
      return;
    const n = this.hls.levels[t.level], s = Ve(Ve({}, this.mediaSelection || this.altSelection), {}, {
      main: n
    });
    this.mediaSelection = s, this.schedule.parseInterstitialDateRanges(s, this.hls.config.interstitialAppendInPlace), !this.effectivePlayingItem && this.schedule.items && this.checkStart();
  }
  onAudioTrackUpdated(e, t) {
    const n = this.hls.audioTracks[t.id], s = this.mediaSelection;
    if (!s) {
      this.altSelection = Ve(Ve({}, this.altSelection), {}, {
        audio: n
      });
      return;
    }
    const r = Ve(Ve({}, s), {}, {
      audio: n
    });
    this.mediaSelection = r;
  }
  onSubtitleTrackUpdated(e, t) {
    const n = this.hls.subtitleTracks[t.id], s = this.mediaSelection;
    if (!s) {
      this.altSelection = Ve(Ve({}, this.altSelection), {}, {
        subtitles: n
      });
      return;
    }
    const r = Ve(Ve({}, s), {}, {
      subtitles: n
    });
    this.mediaSelection = r;
  }
  onAudioTrackSwitching(e, t) {
    const n = fc(t);
    this.playerQueue.forEach(({
      hls: s
    }) => s && (s.setAudioOption(t) || s.setAudioOption(n)));
  }
  onSubtitleTrackSwitch(e, t) {
    const n = fc(t);
    this.playerQueue.forEach(({
      hls: s
    }) => s && (s.setSubtitleOption(t) || t.id !== -1 && s.setSubtitleOption(n)));
  }
  onBufferCodecs(e, t) {
    const n = t.tracks;
    n && (this.requiredTracks = n);
  }
  onBufferAppended(e, t) {
    this.checkBuffer();
  }
  onBufferFlushed(e, t) {
    const n = this.playingItem;
    if (n && !this.itemsMatch(n, this.bufferingItem) && !this.isInterstitial(n)) {
      const s = this.timelinePos;
      this.bufferedPos = s, this.checkBuffer();
    }
  }
  onBufferedToEnd(e) {
    if (!this.schedule)
      return;
    const t = this.schedule.events;
    if (this.bufferedPos < Number.MAX_VALUE && t) {
      for (let s = 0; s < t.length; s++) {
        const r = t[s];
        if (r.cue.post) {
          var n;
          const a = this.schedule.findEventIndex(r.identifier), o = (n = this.schedule.items) == null ? void 0 : n[a];
          this.isInterstitial(o) && this.eventItemsMatch(o, this.bufferingItem) && this.bufferedToItem(o, 0);
          break;
        }
      }
      this.bufferedPos = Number.MAX_VALUE;
    }
  }
  onMediaEnded(e) {
    const t = this.playingItem;
    if (!this.playingLastItem && t) {
      const n = this.findItemIndex(t);
      this.setSchedulePosition(n + 1);
    } else
      this.shouldPlay = !1;
  }
  updateItem(e, t) {
    var n;
    const s = (n = this.schedule) == null ? void 0 : n.items;
    if (e && s) {
      const r = this.findItemIndex(e, t);
      return s[r] || null;
    }
    return null;
  }
  trimInPlace(e, t) {
    if (this.isInterstitial(e) && e.event.appendInPlace && t.end - e.end > 0.25) {
      e.event.assetList.forEach((r, a) => {
        e.event.isAssetPastPlayoutLimit(a) && this.clearAssetPlayer(r.identifier, null);
      });
      const n = e.end + 0.25, s = Te.bufferInfo(this.primaryMedia, n, 0);
      (s.end > n || (s.nextStart || 0) > n) && (this.attachPrimary(n, null), this.flushFrontBuffer(n));
    }
  }
  itemsMatch(e, t) {
    return !!t && (e === t || e.event && t.event && this.eventItemsMatch(e, t) || !e.event && !t.event && this.findItemIndex(e) === this.findItemIndex(t));
  }
  eventItemsMatch(e, t) {
    var n;
    return !!t && (e === t || e.event.identifier === ((n = t.event) == null ? void 0 : n.identifier));
  }
  findItemIndex(e, t) {
    return e && this.schedule ? this.schedule.findItemIndex(e, t) : -1;
  }
  updateSchedule(e = !1) {
    var t;
    const n = this.mediaSelection;
    n && ((t = this.schedule) == null || t.updateSchedule(n, [], e));
  }
  // Schedule buffer control
  checkBuffer(e) {
    var t;
    const n = (t = this.schedule) == null ? void 0 : t.items;
    if (!n)
      return;
    const s = Te.bufferInfo(this.primaryMedia, this.timelinePos, 0);
    e && (this.bufferedPos = this.timelinePos), e || (e = s.len < 1), this.updateBufferedPos(s.end, n, e);
  }
  updateBufferedPos(e, t, n) {
    const s = this.schedule, r = this.bufferingItem;
    if (this.bufferedPos > e || !s)
      return;
    if (t.length === 1 && this.itemsMatch(t[0], r)) {
      this.bufferedPos = e;
      return;
    }
    const a = this.playingItem, o = this.findItemIndex(a);
    let l = s.findItemIndexAtTime(e);
    if (this.bufferedPos < e) {
      var d;
      const c = this.findItemIndex(r), u = Math.min(c + 1, t.length - 1), f = t[u];
      if ((l === -1 && r && e >= r.end || (d = f.event) != null && d.appendInPlace && e + 0.01 >= f.start) && (l = u), this.isInterstitial(r)) {
        const h = r.event;
        if (u - o > 1 && h.appendInPlace === !1 || h.assetList.length === 0 && h.assetListLoader)
          return;
      }
      if (this.bufferedPos = e, l > c && l > o)
        this.bufferedToItem(f);
      else {
        const h = this.primaryDetails;
        this.primaryLive && h && e > h.edge - h.targetduration && f.start < h.edge + this.hls.config.interstitialLiveLookAhead && this.isInterstitial(f) && this.preloadAssets(f.event, 0);
      }
    } else n && a && !this.itemsMatch(a, r) && (l === o ? this.bufferedToItem(a) : l === o + 1 && this.bufferedToItem(t[l]));
  }
  assetsBuffered(e, t) {
    return e.event.assetList.length === 0 ? !1 : !e.event.assetList.some((s) => {
      const r = this.getAssetPlayer(s.identifier);
      return !(r != null && r.bufferedInPlaceToEnd(t));
    });
  }
  setBufferingItem(e) {
    const t = this.bufferingItem, n = this.schedule;
    if (!this.itemsMatch(e, t) && n) {
      const {
        items: s,
        events: r
      } = n;
      if (!s || !r)
        return t;
      const a = this.isInterstitial(e), o = this.getBufferingPlayer();
      this.bufferingItem = e, this.bufferedPos = Math.max(e.start, Math.min(e.end, this.timelinePos));
      const l = o ? o.remaining : t ? t.end - this.timelinePos : 0;
      if (this.log(`INTERSTITIALS_BUFFERED_TO_BOUNDARY ${Ei(e)}` + (t ? ` (${l.toFixed(2)} remaining)` : "")), !this.playbackDisabled)
        if (a) {
          const d = n.findAssetIndex(e.event, this.bufferedPos);
          e.event.assetList.forEach((c, u) => {
            const f = this.getAssetPlayer(c.identifier);
            f && (u === d && f.loadSource(), f.resumeBuffering());
          });
        } else
          this.hls.resumeBuffering(), this.playerQueue.forEach((d) => d.pauseBuffering());
      this.hls.trigger(S.INTERSTITIALS_BUFFERED_TO_BOUNDARY, {
        events: r.slice(0),
        schedule: s.slice(0),
        bufferingIndex: this.findItemIndex(e),
        playingIndex: this.findItemIndex(this.playingItem)
      });
    } else this.bufferingItem !== e && (this.bufferingItem = e);
    return t;
  }
  bufferedToItem(e, t = 0) {
    const n = this.setBufferingItem(e);
    if (!this.playbackDisabled) {
      if (this.isInterstitial(e))
        this.bufferedToEvent(e, t);
      else if (n !== null) {
        this.bufferingAsset = null;
        const s = this.detachedData;
        s ? s.mediaSource ? this.attachPrimary(e.start, e, !0) : this.preloadPrimary(e) : this.preloadPrimary(e);
      }
    }
  }
  preloadPrimary(e) {
    const t = this.findItemIndex(e), n = this.getPrimaryResumption(e, t);
    this.startLoadingPrimaryAt(n);
  }
  bufferedToEvent(e, t) {
    const n = e.event, s = n.assetList.length === 0 && !n.assetListLoader, r = n.cue.once;
    if (s || !r) {
      const a = this.preloadAssets(n, t);
      if (a != null && a.interstitial.appendInPlace) {
        const o = this.primaryMedia;
        o && this.bufferAssetPlayer(a, o);
      }
    }
  }
  preloadAssets(e, t) {
    const n = e.assetUrl, s = e.assetList.length, r = s === 0 && !e.assetListLoader, a = e.cue.once;
    if (r) {
      const l = e.timelineStart;
      if (e.appendInPlace) {
        var o;
        const f = this.playingItem;
        !this.isInterstitial(f) && (f == null || (o = f.nextEvent) == null ? void 0 : o.identifier) === e.identifier && this.flushFrontBuffer(l + 0.25);
      }
      let d, c = 0;
      if (!this.playingItem && this.primaryLive && (c = this.hls.startPosition, c === -1 && (c = this.hls.liveSyncPosition || 0)), c && !(e.cue.pre || e.cue.post)) {
        const f = c - l;
        f > 0 && (d = Math.round(f * 1e3) / 1e3);
      }
      if (this.log(`Load interstitial asset ${t + 1}/${n ? 1 : s} ${e}${d ? ` live-start: ${c} start-offset: ${d}` : ""}`), n)
        return this.createAsset(e, 0, 0, l, e.duration, n);
      const u = this.assetListLoader.loadAssetList(e, d);
      u && (e.assetListLoader = u);
    } else if (!a && s) {
      for (let d = t; d < s; d++) {
        const c = e.assetList[d], u = this.getAssetPlayerQueueIndex(c.identifier);
        (u === -1 || this.playerQueue[u].destroyed) && !c.error && this.createAssetPlayer(e, c, d);
      }
      const l = e.assetList[t];
      if (l) {
        const d = this.getAssetPlayer(l.identifier);
        return d && d.loadSource(), d;
      }
    }
    return null;
  }
  flushFrontBuffer(e) {
    const t = this.requiredTracks;
    if (!t)
      return;
    this.log(`Removing front buffer starting at ${e}`), Object.keys(t).forEach((s) => {
      this.hls.trigger(S.BUFFER_FLUSHING, {
        startOffset: e,
        endOffset: 1 / 0,
        type: s
      });
    });
  }
  // Interstitial Asset Player control
  getAssetPlayerQueueIndex(e) {
    const t = this.playerQueue;
    for (let n = 0; n < t.length; n++)
      if (e === t[n].assetId)
        return n;
    return -1;
  }
  getAssetPlayer(e) {
    const t = this.getAssetPlayerQueueIndex(e);
    return this.playerQueue[t] || null;
  }
  getBufferingPlayer() {
    const {
      playerQueue: e,
      primaryMedia: t
    } = this;
    if (t) {
      for (let n = 0; n < e.length; n++)
        if (e[n].media === t)
          return e[n];
    }
    return null;
  }
  createAsset(e, t, n, s, r, a) {
    const o = {
      parentIdentifier: e.identifier,
      identifier: CS(e, a, t),
      duration: r,
      startOffset: n,
      timelineStart: s,
      uri: a
    };
    return this.createAssetPlayer(e, o, t);
  }
  createAssetPlayer(e, t, n) {
    const s = this.hls, r = s.userConfig;
    let a = r.videoPreference;
    const o = s.loadLevelObj || s.levels[s.currentLevel];
    (a || o) && (a = He({}, a), o.videoCodec && (a.videoCodec = o.videoCodec), o.videoRange && (a.allowedVideoRanges = [o.videoRange]));
    const l = s.audioTracks[s.audioTrack], d = s.subtitleTracks[s.subtitleTrack];
    let c = 0;
    if (this.primaryLive || e.appendInPlace) {
      const k = this.timelinePos - t.timelineStart;
      if (k > 1) {
        const T = t.duration;
        T && k < T && (c = k);
      }
    }
    const u = t.identifier, f = Ve(Ve({}, r), {}, {
      maxMaxBufferLength: Math.min(180, s.config.maxMaxBufferLength),
      autoStartLoad: !0,
      startFragPrefetch: !0,
      primarySessionId: s.sessionId,
      assetPlayerId: u,
      abrEwmaDefaultEstimate: s.bandwidthEstimate,
      interstitialsController: void 0,
      startPosition: c,
      liveDurationInfinity: !1,
      testBandwidth: !1,
      videoPreference: a,
      audioPreference: l || r.audioPreference,
      subtitlePreference: d || r.subtitlePreference
    });
    e.appendInPlace && (e.appendInPlaceStarted = !0, t.timelineStart && (f.timelineOffset = t.timelineStart));
    const h = f.cmcd;
    h != null && h.sessionId && h.contentId && (f.cmcd = He({}, h, {
      contentId: hs(t.uri)
    })), this.getAssetPlayer(u) && this.warn(`Duplicate date range identifier ${e} and asset ${u}`);
    const m = new DS(this.HlsPlayerClass, f, e, t);
    this.playerQueue.push(m), e.assetList[n] = t;
    let g = !0;
    const v = (k) => {
      if (k.live) {
        var T;
        const E = new Error(`Interstitials MUST be VOD assets ${e}`), R = {
          fatal: !0,
          type: pe.OTHER_ERROR,
          details: B.INTERSTITIAL_ASSET_ITEM_ERROR,
          error: E
        }, A = ((T = this.schedule) == null ? void 0 : T.findEventIndex(e.identifier)) || -1;
        this.handleAssetItemError(R, e, A, n, E.message);
        return;
      }
      const I = k.edge - k.fragmentStart, x = t.duration;
      (g || x === null || I > x) && (g = !1, this.log(`Interstitial asset "${u}" duration change ${x} > ${I}`), t.duration = I, this.updateSchedule());
    };
    m.on(S.LEVEL_UPDATED, (k, {
      details: T
    }) => v(T)), m.on(S.LEVEL_PTS_UPDATED, (k, {
      details: T
    }) => v(T)), m.on(S.EVENT_CUE_ENTER, () => this.onInterstitialCueEnter());
    const p = (k, T) => {
      const I = this.getAssetPlayer(u);
      if (I && T.tracks) {
        I.off(S.BUFFER_CODECS, p), I.tracks = T.tracks;
        const x = this.primaryMedia;
        this.bufferingAsset === I.assetItem && x && !I.media && this.bufferAssetPlayer(I, x);
      }
    };
    m.on(S.BUFFER_CODECS, p);
    const y = () => {
      var k;
      const T = this.getAssetPlayer(u);
      if (this.log(`buffered to end of asset ${T}`), !T || !this.schedule)
        return;
      const I = this.schedule.findEventIndex(e.identifier), x = (k = this.schedule.items) == null ? void 0 : k[I];
      this.isInterstitial(x) && this.advanceAssetBuffering(x, t);
    };
    m.on(S.BUFFERED_TO_END, y);
    const b = (k) => () => {
      if (!this.getAssetPlayer(u) || !this.schedule)
        return;
      this.shouldPlay = !0;
      const I = this.schedule.findEventIndex(e.identifier);
      this.advanceAfterAssetEnded(e, I, k);
    };
    return m.once(S.MEDIA_ENDED, b(n)), m.once(S.PLAYOUT_LIMIT_REACHED, b(1 / 0)), m.on(S.ERROR, (k, T) => {
      if (!this.schedule)
        return;
      const I = this.getAssetPlayer(u);
      if (T.details === B.BUFFER_STALLED_ERROR) {
        if (I != null && I.appendInPlace) {
          this.handleInPlaceStall(e);
          return;
        }
        this.onTimeupdate(), this.checkBuffer(!0);
        return;
      }
      this.handleAssetItemError(T, e, this.schedule.findEventIndex(e.identifier), n, `Asset player error ${T.error} ${e}`);
    }), m.on(S.DESTROYING, () => {
      if (!this.getAssetPlayer(u) || !this.schedule)
        return;
      const T = new Error(`Asset player destroyed unexpectedly ${u}`), I = {
        fatal: !0,
        type: pe.OTHER_ERROR,
        details: B.INTERSTITIAL_ASSET_ITEM_ERROR,
        error: T
      };
      this.handleAssetItemError(I, e, this.schedule.findEventIndex(e.identifier), n, T.message);
    }), this.log(`INTERSTITIAL_ASSET_PLAYER_CREATED ${Cn(t)}`), this.hls.trigger(S.INTERSTITIAL_ASSET_PLAYER_CREATED, {
      asset: t,
      assetListIndex: n,
      event: e,
      player: m
    }), m;
  }
  clearInterstitial(e, t) {
    e.assetList.forEach((n) => {
      this.clearAssetPlayer(n.identifier, t);
    }), e.reset();
  }
  resetAssetPlayer(e) {
    const t = this.getAssetPlayerQueueIndex(e);
    if (t !== -1) {
      this.log(`reset asset player "${e}" after error`);
      const n = this.playerQueue[t];
      this.transferMediaFromPlayer(n, null), n.resetDetails();
    }
  }
  clearAssetPlayer(e, t) {
    const n = this.getAssetPlayerQueueIndex(e);
    if (n !== -1) {
      this.log(`clear asset player "${e}" toSegment: ${t && Ei(t)}`);
      const s = this.playerQueue[n];
      this.transferMediaFromPlayer(s, t), this.playerQueue.splice(n, 1), s.destroy();
    }
  }
  emptyPlayerQueue() {
    let e;
    for (; e = this.playerQueue.pop(); )
      e.destroy();
    this.playerQueue = [];
  }
  startAssetPlayer(e, t, n, s, r) {
    const {
      interstitial: a,
      assetItem: o,
      assetId: l
    } = e, d = a.assetList.length, c = this.playingAsset;
    this.endedAsset = null, this.playingAsset = o, (!c || c.identifier !== l) && (c && (this.clearAssetPlayer(c.identifier, n[s]), delete c.error), this.log(`INTERSTITIAL_ASSET_STARTED ${t + 1}/${d} ${Cn(o)}`), this.hls.trigger(S.INTERSTITIAL_ASSET_STARTED, {
      asset: o,
      assetListIndex: t,
      event: a,
      schedule: n.slice(0),
      scheduleIndex: s,
      player: e
    })), this.bufferAssetPlayer(e, r);
  }
  bufferAssetPlayer(e, t) {
    var n, s;
    if (!this.schedule)
      return;
    const {
      interstitial: r,
      assetItem: a
    } = e, o = this.schedule.findEventIndex(r.identifier), l = (n = this.schedule.items) == null ? void 0 : n[o];
    if (!l)
      return;
    e.loadSource(), this.setBufferingItem(l), this.bufferingAsset = a;
    const d = this.getBufferingPlayer();
    if (d === e)
      return;
    const c = r.appendInPlace;
    if (c && d?.interstitial.appendInPlace === !1)
      return;
    const u = d?.tracks || ((s = this.detachedData) == null ? void 0 : s.tracks) || this.requiredTracks;
    if (c && a !== this.playingAsset) {
      if (!e.tracks) {
        this.log(`Waiting for track info before buffering ${e}`);
        return;
      }
      if (u && !eh(u, e.tracks)) {
        const f = new Error(`Asset ${Cn(a)} SourceBuffer tracks ('${Object.keys(e.tracks)}') are not compatible with primary content tracks ('${Object.keys(u)}')`), h = {
          fatal: !0,
          type: pe.OTHER_ERROR,
          details: B.INTERSTITIAL_ASSET_ITEM_ERROR,
          error: f
        }, m = r.findAssetIndex(a);
        this.handleAssetItemError(h, r, o, m, f.message);
        return;
      }
    }
    this.transferMediaTo(e, t);
  }
  handleInPlaceStall(e) {
    const t = this.schedule, n = this.primaryMedia;
    if (!t || !n)
      return;
    const s = n.currentTime, r = t.findAssetIndex(e, s), a = e.assetList[r];
    if (a) {
      const o = this.getAssetPlayer(a.identifier);
      if (o) {
        const l = o.currentTime || s - a.timelineStart, d = o.duration - l;
        if (this.warn(`Stalled at ${l} of ${l + d} in ${o} ${e} (media.currentTime: ${s})`), l && (d / n.playbackRate < 0.5 || o.bufferedInPlaceToEnd(n)) && o.hls) {
          const c = t.findEventIndex(e.identifier);
          this.advanceAfterAssetEnded(e, c, r);
        }
      }
    }
  }
  advanceInPlace(e) {
    const t = this.primaryMedia;
    t && t.currentTime < e && (t.currentTime = e);
  }
  handleAssetItemError(e, t, n, s, r) {
    if (e.details === B.BUFFER_STALLED_ERROR)
      return;
    const a = t.assetList[s] || null;
    if (this.warn(`INTERSTITIAL_ASSET_ERROR ${a && Cn(a)} ${e.error}`), !this.schedule)
      return;
    const o = a?.identifier || "", l = this.getAssetPlayerQueueIndex(o), d = this.playerQueue[l] || null, c = this.schedule.items, u = He({}, e, {
      fatal: !1,
      errorAction: ws(!0),
      asset: a,
      assetListIndex: s,
      event: t,
      schedule: c,
      scheduleIndex: n,
      player: d
    });
    if (this.hls.trigger(S.INTERSTITIAL_ASSET_ERROR, u), !e.fatal)
      return;
    const f = this.playingAsset, h = this.bufferingAsset, m = new Error(r);
    if (a && (this.clearAssetPlayer(o, null), a.error = m), !t.assetList.some((g) => !g.error))
      t.error = m;
    else
      for (let g = s; g < t.assetList.length; g++)
        this.resetAssetPlayer(t.assetList[g].identifier);
    this.updateSchedule(!0), t.error ? this.primaryFallback(t) : f && f.identifier === o ? this.advanceAfterAssetEnded(t, n, s) : h && h.identifier === o && this.isInterstitial(this.bufferingItem) && this.advanceAssetBuffering(this.bufferingItem, h);
  }
  primaryFallback(e) {
    const t = e.timelineStart, n = this.effectivePlayingItem;
    if (n) {
      this.log(`Fallback to primary from event "${e.identifier}" start: ${t} pos: ${this.timelinePos} playing: ${Ei(n)} error: ${e.error}`);
      let s = this.timelinePos;
      s === -1 && (s = this.hls.startPosition);
      const r = this.updateItem(n, s);
      if (this.itemsMatch(n, r) && this.clearInterstitial(e, null), e.appendInPlace && (this.attachPrimary(t, null), this.flushFrontBuffer(t)), !this.schedule)
        return;
      const a = this.schedule.findItemIndexAtTime(s);
      this.setSchedulePosition(a);
    } else
      this.checkStart();
  }
  // Asset List loading
  onAssetListLoaded(e, t) {
    var n, s;
    const r = t.event, a = r.identifier, o = t.assetListResponse.ASSETS;
    if (!((n = this.schedule) != null && n.hasEvent(a)))
      return;
    const l = r.timelineStart, d = r.duration;
    let c = 0;
    o.forEach((g, v) => {
      const p = parseFloat(g.DURATION);
      this.createAsset(r, v, c, l + c, p, g.URI), c += p;
    }), r.duration = c, this.log(`Loaded asset-list with duration: ${c} (was: ${d}) ${r}`);
    const u = this.waitingItem, f = u?.event.identifier === a;
    this.updateSchedule();
    const h = (s = this.bufferingItem) == null ? void 0 : s.event;
    if (f) {
      var m;
      const g = this.schedule.findEventIndex(a), v = (m = this.schedule.items) == null ? void 0 : m[g];
      if (v) {
        if (!this.playingItem && this.timelinePos > v.end && this.schedule.findItemIndexAtTime(this.timelinePos) !== g) {
          r.error = new Error(`Interstitial no longer within playback range ${this.timelinePos} ${r}`), this.updateSchedule(!0), this.primaryFallback(r);
          return;
        }
        this.setBufferingItem(v);
      }
      this.setSchedulePosition(g);
    } else if (h?.identifier === a) {
      const g = r.assetList[0];
      if (g) {
        const v = this.getAssetPlayer(g.identifier);
        if (h.appendInPlace) {
          const p = this.primaryMedia;
          v && p && this.bufferAssetPlayer(v, p);
        } else v && v.loadSource();
      }
    }
  }
  onError(e, t) {
    if (this.schedule)
      switch (t.details) {
        case B.ASSET_LIST_PARSING_ERROR:
        case B.ASSET_LIST_LOAD_ERROR:
        case B.ASSET_LIST_LOAD_TIMEOUT: {
          const n = t.interstitial;
          n && (this.updateSchedule(!0), this.primaryFallback(n));
          break;
        }
        case B.BUFFER_STALLED_ERROR: {
          const n = this.endedItem || this.waitingItem || this.playingItem;
          if (this.isInterstitial(n) && n.event.appendInPlace) {
            this.handleInPlaceStall(n.event);
            return;
          }
          this.log(`Primary player stall @${this.timelinePos} bufferedPos: ${this.bufferedPos}`), this.onTimeupdate(), this.checkBuffer(!0);
          break;
        }
      }
  }
}
const eu = 500;
class FS extends wl {
  constructor(e, t, n) {
    super(e, t, n, "subtitle-stream-controller", ce.SUBTITLE), this.currentTrackId = -1, this.tracksBuffered = [], this.mainDetails = null, this.registerListeners();
  }
  onHandlerDestroying() {
    this.unregisterListeners(), super.onHandlerDestroying(), this.mainDetails = null;
  }
  registerListeners() {
    super.registerListeners();
    const {
      hls: e
    } = this;
    e.on(S.LEVEL_LOADED, this.onLevelLoaded, this), e.on(S.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(S.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.on(S.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(S.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.on(S.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  unregisterListeners() {
    super.unregisterListeners();
    const {
      hls: e
    } = this;
    e.off(S.LEVEL_LOADED, this.onLevelLoaded, this), e.off(S.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(S.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.off(S.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(S.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.off(S.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  startLoad(e, t) {
    this.stopLoad(), this.state = K.IDLE, this.setInterval(eu), this.nextLoadPosition = this.lastCurrentTime = e + this.timelineOffset, this.startPosition = t ? -1 : e, this.tick();
  }
  onManifestLoading() {
    super.onManifestLoading(), this.mainDetails = null;
  }
  onMediaDetaching(e, t) {
    this.tracksBuffered = [], super.onMediaDetaching(e, t);
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details;
  }
  onSubtitleFragProcessed(e, t) {
    const {
      frag: n,
      success: s
    } = t;
    if (this.fragContextChanged(n) || (st(n) && (this.fragPrevious = n), this.state = K.IDLE), !s)
      return;
    const r = this.tracksBuffered[this.currentTrackId];
    if (!r)
      return;
    let a;
    const o = n.start;
    for (let d = 0; d < r.length; d++)
      if (o >= r[d].start && o <= r[d].end) {
        a = r[d];
        break;
      }
    const l = n.start + n.duration;
    a ? a.end = l : (a = {
      start: o,
      end: l
    }, r.push(a)), this.fragmentTracker.fragBuffered(n), this.fragBufferedComplete(n, null), this.media && this.tick();
  }
  onBufferFlushing(e, t) {
    const {
      startOffset: n,
      endOffset: s
    } = t;
    if (n === 0 && s !== Number.POSITIVE_INFINITY) {
      const r = s - 1;
      if (r <= 0)
        return;
      t.endOffsetSubtitles = Math.max(0, r), this.tracksBuffered.forEach((a) => {
        for (let o = 0; o < a.length; ) {
          if (a[o].end <= r) {
            a.shift();
            continue;
          } else if (a[o].start < r)
            a[o].start = r;
          else
            break;
          o++;
        }
      }), this.fragmentTracker.removeFragmentsInRange(n, r, ce.SUBTITLE);
    }
  }
  // If something goes wrong, proceed to next frag, if we were processing one.
  onError(e, t) {
    const n = t.frag;
    n?.type === ce.SUBTITLE && (t.details === B.FRAG_GAP && this.fragmentTracker.fragBuffered(n, !0), this.fragCurrent && this.fragCurrent.abortRequests(), this.state !== K.STOPPED && (this.state = K.IDLE));
  }
  // Got all new subtitle levels.
  onSubtitleTracksUpdated(e, {
    subtitleTracks: t
  }) {
    if (this.levels && Zh(this.levels, t)) {
      this.levels = t.map((n) => new As(n));
      return;
    }
    this.tracksBuffered = [], this.levels = t.map((n) => {
      const s = new As(n);
      return this.tracksBuffered[s.id] = [], s;
    }), this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, ce.SUBTITLE), this.fragPrevious = null, this.mediaBuffer = null;
  }
  onSubtitleTrackSwitch(e, t) {
    var n;
    if (this.currentTrackId = t.id, !((n = this.levels) != null && n.length) || this.currentTrackId === -1) {
      this.clearInterval();
      return;
    }
    const s = this.levels[this.currentTrackId];
    s != null && s.details ? this.mediaBuffer = this.mediaBufferTimeRanges : this.mediaBuffer = null, s && this.state !== K.STOPPED && this.setInterval(eu);
  }
  // Got a new set of subtitle fragments.
  onSubtitleTrackLoaded(e, t) {
    var n;
    const {
      currentTrackId: s,
      levels: r
    } = this, {
      details: a,
      id: o
    } = t;
    if (!r) {
      this.warn(`Subtitle tracks were reset while loading level ${o}`);
      return;
    }
    const l = r[o];
    if (o >= r.length || !l)
      return;
    this.log(`Subtitle track ${o} loaded [${a.startSN},${a.endSN}]${a.lastPartSn ? `[part-${a.lastPartSn}-${a.lastPartIndex}]` : ""},duration:${a.totalduration}`), this.mediaBuffer = this.mediaBufferTimeRanges;
    let d = 0;
    if (a.live || (n = l.details) != null && n.live) {
      if (a.deltaUpdateFailed)
        return;
      const u = this.mainDetails;
      if (!u) {
        this.startFragRequested = !1;
        return;
      }
      const f = u.fragments[0];
      if (!l.details)
        a.hasProgramDateTime && u.hasProgramDateTime ? (Or(a, u), d = a.fragmentStart) : f && (d = f.start, No(a, d));
      else {
        var c;
        d = this.alignPlaylists(a, l.details, (c = this.levelLastLoaded) == null ? void 0 : c.details), d === 0 && f && (d = f.start, No(a, d));
      }
      u && !this.startFragRequested && this.setStartPosition(u, d);
    }
    l.details = a, this.levelLastLoaded = l, o === s && (this.hls.trigger(S.SUBTITLE_TRACK_UPDATED, {
      details: a,
      id: o,
      groupId: t.groupId
    }), this.tick(), a.live && !this.fragCurrent && this.media && this.state === K.IDLE && (Sn(null, a.fragments, this.media.currentTime, 0) || (this.warn("Subtitle playlist not aligned with playback"), l.details = void 0)));
  }
  _handleFragmentLoadComplete(e) {
    const {
      frag: t,
      payload: n
    } = e, s = t.decryptdata, r = this.hls;
    if (!this.fragContextChanged(t) && n && n.byteLength > 0 && s != null && s.key && s.iv && Un(s.method)) {
      const a = performance.now();
      this.decrypter.decrypt(new Uint8Array(n), s.key.buffer, s.iv.buffer, _l(s.method)).catch((o) => {
        throw r.trigger(S.ERROR, {
          type: pe.MEDIA_ERROR,
          details: B.FRAG_DECRYPT_ERROR,
          fatal: !1,
          error: o,
          reason: o.message,
          frag: t
        }), o;
      }).then((o) => {
        const l = performance.now();
        r.trigger(S.FRAG_DECRYPTED, {
          frag: t,
          payload: o,
          stats: {
            tstart: a,
            tdecrypt: l
          }
        });
      }).catch((o) => {
        this.warn(`${o.name}: ${o.message}`), this.state = K.IDLE;
      });
    }
  }
  doTick() {
    if (!this.media) {
      this.state = K.IDLE;
      return;
    }
    if (this.state === K.IDLE) {
      const {
        currentTrackId: e,
        levels: t
      } = this, n = t?.[e];
      if (!n || !t.length || !n.details || this.waitForLive(n))
        return;
      const {
        config: s
      } = this, r = this.getLoadPosition(), a = Te.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], r, s.maxBufferHole), {
        end: o,
        len: l
      } = a, d = n.details, c = this.hls.maxBufferLength + d.levelTargetDuration;
      if (l > c)
        return;
      const u = d.fragments, f = u.length, h = d.edge;
      let m = null;
      const g = this.fragPrevious;
      if (o < h) {
        const y = s.maxFragLookUpTolerance, b = o > h - y ? 0 : y;
        m = Sn(g, u, Math.max(u[0].start, o), b), !m && g && g.start < u[0].start && (m = u[0]);
      } else
        m = u[f - 1];
      if (m = this.filterReplacedPrimary(m, n.details), !m)
        return;
      const v = m.sn - d.startSN, p = u[v - 1];
      if (p && p.cc === m.cc && this.fragmentTracker.getState(p) === at.NOT_LOADED && (m = p), this.fragmentTracker.getState(m) === at.NOT_LOADED) {
        const y = this.mapToInitFragWhenRequired(m);
        y && this.loadFragment(y, n, o);
      }
    }
  }
  loadFragment(e, t, n) {
    st(e) ? super.loadFragment(e, t, n) : this._loadInitSegment(e, t);
  }
  get mediaBufferTimeRanges() {
    return new $S(this.tracksBuffered[this.currentTrackId] || []);
  }
}
class $S {
  constructor(e) {
    this.buffered = void 0;
    const t = (n, s, r) => {
      if (s = s >>> 0, s > r - 1)
        throw new DOMException(`Failed to execute '${n}' on 'TimeRanges': The index provided (${s}) is greater than the maximum bound (${r})`);
      return e[s][n];
    };
    this.buffered = {
      get length() {
        return e.length;
      },
      end(n) {
        return t("end", n, e.length);
      },
      start(n) {
        return t("start", n, e.length);
      }
    };
  }
}
const BS = {
  42: 225,
  // lowercase a, acute accent
  92: 233,
  // lowercase e, acute accent
  94: 237,
  // lowercase i, acute accent
  95: 243,
  // lowercase o, acute accent
  96: 250,
  // lowercase u, acute accent
  123: 231,
  // lowercase c with cedilla
  124: 247,
  // division symbol
  125: 209,
  // uppercase N tilde
  126: 241,
  // lowercase n tilde
  127: 9608,
  // Full block
  // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
  // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
  128: 174,
  // Registered symbol (R)
  129: 176,
  // degree sign
  130: 189,
  // 1/2 symbol
  131: 191,
  // Inverted (open) question mark
  132: 8482,
  // Trademark symbol (TM)
  133: 162,
  // Cents symbol
  134: 163,
  // Pounds sterling
  135: 9834,
  // Music 8'th note
  136: 224,
  // lowercase a, grave accent
  137: 32,
  // transparent space (regular)
  138: 232,
  // lowercase e, grave accent
  139: 226,
  // lowercase a, circumflex accent
  140: 234,
  // lowercase e, circumflex accent
  141: 238,
  // lowercase i, circumflex accent
  142: 244,
  // lowercase o, circumflex accent
  143: 251,
  // lowercase u, circumflex accent
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
  144: 193,
  // capital letter A with acute
  145: 201,
  // capital letter E with acute
  146: 211,
  // capital letter O with acute
  147: 218,
  // capital letter U with acute
  148: 220,
  // capital letter U with diaresis
  149: 252,
  // lowercase letter U with diaeresis
  150: 8216,
  // opening single quote
  151: 161,
  // inverted exclamation mark
  152: 42,
  // asterisk
  153: 8217,
  // closing single quote
  154: 9473,
  // box drawings heavy horizontal
  155: 169,
  // copyright sign
  156: 8480,
  // Service mark
  157: 8226,
  // (round) bullet
  158: 8220,
  // Left double quotation mark
  159: 8221,
  // Right double quotation mark
  160: 192,
  // uppercase A, grave accent
  161: 194,
  // uppercase A, circumflex
  162: 199,
  // uppercase C with cedilla
  163: 200,
  // uppercase E, grave accent
  164: 202,
  // uppercase E, circumflex
  165: 203,
  // capital letter E with diaresis
  166: 235,
  // lowercase letter e with diaresis
  167: 206,
  // uppercase I, circumflex
  168: 207,
  // uppercase I, with diaresis
  169: 239,
  // lowercase i, with diaresis
  170: 212,
  // uppercase O, circumflex
  171: 217,
  // uppercase U, grave accent
  172: 249,
  // lowercase u, grave accent
  173: 219,
  // uppercase U, circumflex
  174: 171,
  // left-pointing double angle quotation mark
  175: 187,
  // right-pointing double angle quotation mark
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
  176: 195,
  // Uppercase A, tilde
  177: 227,
  // Lowercase a, tilde
  178: 205,
  // Uppercase I, acute accent
  179: 204,
  // Uppercase I, grave accent
  180: 236,
  // Lowercase i, grave accent
  181: 210,
  // Uppercase O, grave accent
  182: 242,
  // Lowercase o, grave accent
  183: 213,
  // Uppercase O, tilde
  184: 245,
  // Lowercase o, tilde
  185: 123,
  // Open curly brace
  186: 125,
  // Closing curly brace
  187: 92,
  // Backslash
  188: 94,
  // Caret
  189: 95,
  // Underscore
  190: 124,
  // Pipe (vertical line)
  191: 8764,
  // Tilde operator
  192: 196,
  // Uppercase A, umlaut
  193: 228,
  // Lowercase A, umlaut
  194: 214,
  // Uppercase O, umlaut
  195: 246,
  // Lowercase o, umlaut
  196: 223,
  // Esszett (sharp S)
  197: 165,
  // Yen symbol
  198: 164,
  // Generic currency sign
  199: 9475,
  // Box drawings heavy vertical
  200: 197,
  // Uppercase A, ring
  201: 229,
  // Lowercase A, ring
  202: 216,
  // Uppercase O, stroke
  203: 248,
  // Lowercase o, strok
  204: 9487,
  // Box drawings heavy down and right
  205: 9491,
  // Box drawings heavy down and left
  206: 9495,
  // Box drawings heavy up and right
  207: 9499
  // Box drawings heavy up and left
}, hm = (i) => String.fromCharCode(BS[i] || i), Jt = 15, xi = 100, US = {
  17: 1,
  18: 3,
  21: 5,
  22: 7,
  23: 9,
  16: 11,
  19: 12,
  20: 14
}, VS = {
  17: 2,
  18: 4,
  21: 6,
  22: 8,
  23: 10,
  19: 13,
  20: 15
}, GS = {
  25: 1,
  26: 3,
  29: 5,
  30: 7,
  31: 9,
  24: 11,
  27: 12,
  28: 14
}, HS = {
  25: 2,
  26: 4,
  29: 6,
  30: 8,
  31: 10,
  27: 13,
  28: 15
}, zS = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"];
class KS {
  constructor() {
    this.time = null, this.verboseLevel = 0;
  }
  log(e, t) {
    if (this.verboseLevel >= e) {
      const n = typeof t == "function" ? t() : t;
      Be.log(`${this.time} [${e}] ${n}`);
    }
  }
}
const un = function(e) {
  const t = [];
  for (let n = 0; n < e.length; n++)
    t.push(e[n].toString(16));
  return t;
};
class mm {
  constructor() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  reset() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  setStyles(e) {
    const t = ["foreground", "underline", "italics", "background", "flash"];
    for (let n = 0; n < t.length; n++) {
      const s = t[n];
      e.hasOwnProperty(s) && (this[s] = e[s]);
    }
  }
  isDefault() {
    return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
  }
  equals(e) {
    return this.foreground === e.foreground && this.underline === e.underline && this.italics === e.italics && this.background === e.background && this.flash === e.flash;
  }
  copy(e) {
    this.foreground = e.foreground, this.underline = e.underline, this.italics = e.italics, this.background = e.background, this.flash = e.flash;
  }
  toString() {
    return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
  }
}
class jS {
  constructor() {
    this.uchar = " ", this.penState = new mm();
  }
  reset() {
    this.uchar = " ", this.penState.reset();
  }
  setChar(e, t) {
    this.uchar = e, this.penState.copy(t);
  }
  setPenState(e) {
    this.penState.copy(e);
  }
  equals(e) {
    return this.uchar === e.uchar && this.penState.equals(e.penState);
  }
  copy(e) {
    this.uchar = e.uchar, this.penState.copy(e.penState);
  }
  isEmpty() {
    return this.uchar === " " && this.penState.isDefault();
  }
}
class WS {
  constructor(e) {
    this.chars = [], this.pos = 0, this.currPenState = new mm(), this.cueStartTime = null, this.logger = void 0;
    for (let t = 0; t < xi; t++)
      this.chars.push(new jS());
    this.logger = e;
  }
  equals(e) {
    for (let t = 0; t < xi; t++)
      if (!this.chars[t].equals(e.chars[t]))
        return !1;
    return !0;
  }
  copy(e) {
    for (let t = 0; t < xi; t++)
      this.chars[t].copy(e.chars[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < xi; t++)
      if (!this.chars[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  /**
   *  Set the cursor to a valid column.
   */
  setCursor(e) {
    this.pos !== e && (this.pos = e), this.pos < 0 ? (this.logger.log(3, "Negative cursor position " + this.pos), this.pos = 0) : this.pos > xi && (this.logger.log(3, "Too large cursor position " + this.pos), this.pos = xi);
  }
  /**
   * Move the cursor relative to current position.
   */
  moveCursor(e) {
    const t = this.pos + e;
    if (e > 1)
      for (let n = this.pos + 1; n < t + 1; n++)
        this.chars[n].setPenState(this.currPenState);
    this.setCursor(t);
  }
  /**
   * Backspace, move one step back and clear character.
   */
  backSpace() {
    this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
  }
  insertChar(e) {
    e >= 144 && this.backSpace();
    const t = hm(e);
    if (this.pos >= xi) {
      this.logger.log(0, () => "Cannot insert " + e.toString(16) + " (" + t + ") at position " + this.pos + ". Skipping it!");
      return;
    }
    this.chars[this.pos].setChar(t, this.currPenState), this.moveCursor(1);
  }
  clearFromPos(e) {
    let t;
    for (t = e; t < xi; t++)
      this.chars[t].reset();
  }
  clear() {
    this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
  }
  clearToEndOfRow() {
    this.clearFromPos(this.pos);
  }
  getTextString() {
    const e = [];
    let t = !0;
    for (let n = 0; n < xi; n++) {
      const s = this.chars[n].uchar;
      s !== " " && (t = !1), e.push(s);
    }
    return t ? "" : e.join("");
  }
  setPenStyles(e) {
    this.currPenState.setStyles(e), this.chars[this.pos].setPenState(this.currPenState);
  }
}
class Wa {
  constructor(e) {
    this.rows = [], this.currRow = Jt - 1, this.nrRollUpRows = null, this.lastOutputScreen = null, this.logger = void 0;
    for (let t = 0; t < Jt; t++)
      this.rows.push(new WS(e));
    this.logger = e;
  }
  reset() {
    for (let e = 0; e < Jt; e++)
      this.rows[e].clear();
    this.currRow = Jt - 1;
  }
  equals(e) {
    let t = !0;
    for (let n = 0; n < Jt; n++)
      if (!this.rows[n].equals(e.rows[n])) {
        t = !1;
        break;
      }
    return t;
  }
  copy(e) {
    for (let t = 0; t < Jt; t++)
      this.rows[t].copy(e.rows[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < Jt; t++)
      if (!this.rows[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  backSpace() {
    this.rows[this.currRow].backSpace();
  }
  clearToEndOfRow() {
    this.rows[this.currRow].clearToEndOfRow();
  }
  /**
   * Insert a character (without styling) in the current row.
   */
  insertChar(e) {
    this.rows[this.currRow].insertChar(e);
  }
  setPen(e) {
    this.rows[this.currRow].setPenStyles(e);
  }
  moveCursor(e) {
    this.rows[this.currRow].moveCursor(e);
  }
  setCursor(e) {
    this.logger.log(2, "setCursor: " + e), this.rows[this.currRow].setCursor(e);
  }
  setPAC(e) {
    this.logger.log(2, () => "pacData = " + qe(e));
    let t = e.row - 1;
    if (this.nrRollUpRows && t < this.nrRollUpRows - 1 && (t = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== t) {
      for (let o = 0; o < Jt; o++)
        this.rows[o].clear();
      const r = this.currRow + 1 - this.nrRollUpRows, a = this.lastOutputScreen;
      if (a) {
        const o = a.rows[r].cueStartTime, l = this.logger.time;
        if (o !== null && l !== null && o < l)
          for (let d = 0; d < this.nrRollUpRows; d++)
            this.rows[t - this.nrRollUpRows + d + 1].copy(a.rows[r + d]);
      }
    }
    this.currRow = t;
    const n = this.rows[this.currRow];
    if (e.indent !== null) {
      const r = e.indent, a = Math.max(r - 1, 0);
      n.setCursor(e.indent), e.color = n.chars[a].penState.foreground;
    }
    const s = {
      foreground: e.color,
      underline: e.underline,
      italics: e.italics,
      background: "black",
      flash: !1
    };
    this.setPen(s);
  }
  /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */
  setBkgData(e) {
    this.logger.log(2, () => "bkgData = " + qe(e)), this.backSpace(), this.setPen(e), this.insertChar(32);
  }
  setRollUpRows(e) {
    this.nrRollUpRows = e;
  }
  rollUp() {
    if (this.nrRollUpRows === null) {
      this.logger.log(3, "roll_up but nrRollUpRows not set yet");
      return;
    }
    this.logger.log(1, () => this.getDisplayText());
    const e = this.currRow + 1 - this.nrRollUpRows, t = this.rows.splice(e, 1)[0];
    t.clear(), this.rows.splice(this.currRow, 0, t), this.logger.log(2, "Rolling up");
  }
  /**
   * Get all non-empty rows with as unicode text.
   */
  getDisplayText(e) {
    e = e || !1;
    const t = [];
    let n = "", s = -1;
    for (let r = 0; r < Jt; r++) {
      const a = this.rows[r].getTextString();
      a && (s = r + 1, e ? t.push("Row " + s + ": '" + a + "'") : t.push(a.trim()));
    }
    return t.length > 0 && (e ? n = "[" + t.join(" | ") + "]" : n = t.join(`
`)), n;
  }
  getTextAndFormat() {
    return this.rows;
  }
}
class tu {
  constructor(e, t, n) {
    this.chNr = void 0, this.outputFilter = void 0, this.mode = void 0, this.verbose = void 0, this.displayedMemory = void 0, this.nonDisplayedMemory = void 0, this.lastOutputScreen = void 0, this.currRollUpRow = void 0, this.writeScreen = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chNr = e, this.outputFilter = t, this.mode = null, this.verbose = 0, this.displayedMemory = new Wa(n), this.nonDisplayedMemory = new Wa(n), this.lastOutputScreen = new Wa(n), this.currRollUpRow = this.displayedMemory.rows[Jt - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.logger = n;
  }
  reset() {
    this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.outputFilter.reset(), this.currRollUpRow = this.displayedMemory.rows[Jt - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
  }
  getHandler() {
    return this.outputFilter;
  }
  setHandler(e) {
    this.outputFilter = e;
  }
  setPAC(e) {
    this.writeScreen.setPAC(e);
  }
  setBkgData(e) {
    this.writeScreen.setBkgData(e);
  }
  setMode(e) {
    e !== this.mode && (this.mode = e, this.logger.log(2, () => "MODE=" + e), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = e);
  }
  insertChars(e) {
    for (let n = 0; n < e.length; n++)
      this.writeScreen.insertChar(e[n]);
    const t = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
    this.logger.log(2, () => t + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (this.logger.log(1, () => "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
  }
  ccRCL() {
    this.logger.log(2, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
  }
  ccBS() {
    this.logger.log(2, "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
  }
  ccAOF() {
  }
  ccAON() {
  }
  ccDER() {
    this.logger.log(2, "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
  }
  ccRU(e) {
    this.logger.log(2, "RU(" + e + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(e);
  }
  ccFON() {
    this.logger.log(2, "FON - Flash On"), this.writeScreen.setPen({
      flash: !0
    });
  }
  ccRDC() {
    this.logger.log(2, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
  }
  ccTR() {
    this.logger.log(2, "TR"), this.setMode("MODE_TEXT");
  }
  ccRTD() {
    this.logger.log(2, "RTD"), this.setMode("MODE_TEXT");
  }
  ccEDM() {
    this.logger.log(2, "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
  }
  ccCR() {
    this.logger.log(2, "CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
  }
  ccENM() {
    this.logger.log(2, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
  }
  ccEOC() {
    if (this.logger.log(2, "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
      const e = this.displayedMemory;
      this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = e, this.writeScreen = this.nonDisplayedMemory, this.logger.log(1, () => "DISP: " + this.displayedMemory.getDisplayText());
    }
    this.outputDataUpdate(!0);
  }
  ccTO(e) {
    this.logger.log(2, "TO(" + e + ") - Tab Offset"), this.writeScreen.moveCursor(e);
  }
  ccMIDROW(e) {
    const t = {
      flash: !1
    };
    if (t.underline = e % 2 === 1, t.italics = e >= 46, t.italics)
      t.foreground = "white";
    else {
      const n = Math.floor(e / 2) - 16, s = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
      t.foreground = s[n];
    }
    this.logger.log(2, "MIDROW: " + qe(t)), this.writeScreen.setPen(t);
  }
  outputDataUpdate(e = !1) {
    const t = this.logger.time;
    t !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = t : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen), e && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(), this.cueStartTime = this.displayedMemory.isEmpty() ? null : t), this.lastOutputScreen.copy(this.displayedMemory));
  }
  cueSplitAtTime(e) {
    this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, e, this.displayedMemory), this.cueStartTime = e));
  }
}
class iu {
  constructor(e, t, n) {
    this.channels = void 0, this.currentChannel = 0, this.cmdHistory = YS(), this.logger = void 0;
    const s = this.logger = new KS();
    this.channels = [null, new tu(e, t, s), new tu(e + 1, n, s)];
  }
  getHandler(e) {
    return this.channels[e].getHandler();
  }
  setHandler(e, t) {
    this.channels[e].setHandler(t);
  }
  /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */
  addData(e, t) {
    this.logger.time = e;
    for (let n = 0; n < t.length; n += 2) {
      const s = t[n] & 127, r = t[n + 1] & 127;
      let a = !1, o = null;
      if (s === 0 && r === 0)
        continue;
      this.logger.log(3, () => "[" + un([t[n], t[n + 1]]) + "] -> (" + un([s, r]) + ")");
      const l = this.cmdHistory;
      if (s >= 16 && s <= 31) {
        if (qS(s, r, l)) {
          Qs(null, null, l), this.logger.log(3, () => "Repeated command (" + un([s, r]) + ") is dropped");
          continue;
        }
        Qs(s, r, this.cmdHistory), a = this.parseCmd(s, r), a || (a = this.parseMidrow(s, r)), a || (a = this.parsePAC(s, r)), a || (a = this.parseBackgroundAttributes(s, r));
      } else
        Qs(null, null, l);
      if (!a && (o = this.parseChars(s, r), o)) {
        const c = this.currentChannel;
        c && c > 0 ? this.channels[c].insertChars(o) : this.logger.log(2, "No channel found yet. TEXT-MODE?");
      }
      !a && !o && this.logger.log(2, () => "Couldn't parse cleaned data " + un([s, r]) + " orig: " + un([t[n], t[n + 1]]));
    }
  }
  /**
   * Parse Command.
   * @returns True if a command was found
   */
  parseCmd(e, t) {
    const n = (e === 20 || e === 28 || e === 21 || e === 29) && t >= 32 && t <= 47, s = (e === 23 || e === 31) && t >= 33 && t <= 35;
    if (!(n || s))
      return !1;
    const r = e === 20 || e === 21 || e === 23 ? 1 : 2, a = this.channels[r];
    return e === 20 || e === 21 || e === 28 || e === 29 ? t === 32 ? a.ccRCL() : t === 33 ? a.ccBS() : t === 34 ? a.ccAOF() : t === 35 ? a.ccAON() : t === 36 ? a.ccDER() : t === 37 ? a.ccRU(2) : t === 38 ? a.ccRU(3) : t === 39 ? a.ccRU(4) : t === 40 ? a.ccFON() : t === 41 ? a.ccRDC() : t === 42 ? a.ccTR() : t === 43 ? a.ccRTD() : t === 44 ? a.ccEDM() : t === 45 ? a.ccCR() : t === 46 ? a.ccENM() : t === 47 && a.ccEOC() : a.ccTO(t - 32), this.currentChannel = r, !0;
  }
  /**
   * Parse midrow styling command
   */
  parseMidrow(e, t) {
    let n = 0;
    if ((e === 17 || e === 25) && t >= 32 && t <= 47) {
      if (e === 17 ? n = 1 : n = 2, n !== this.currentChannel)
        return this.logger.log(0, "Mismatch channel in midrow parsing"), !1;
      const s = this.channels[n];
      return s ? (s.ccMIDROW(t), this.logger.log(3, () => "MIDROW (" + un([e, t]) + ")"), !0) : !1;
    }
    return !1;
  }
  /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */
  parsePAC(e, t) {
    let n;
    const s = (e >= 17 && e <= 23 || e >= 25 && e <= 31) && t >= 64 && t <= 127, r = (e === 16 || e === 24) && t >= 64 && t <= 95;
    if (!(s || r))
      return !1;
    const a = e <= 23 ? 1 : 2;
    t >= 64 && t <= 95 ? n = a === 1 ? US[e] : GS[e] : n = a === 1 ? VS[e] : HS[e];
    const o = this.channels[a];
    return o ? (o.setPAC(this.interpretPAC(n, t)), this.currentChannel = a, !0) : !1;
  }
  /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */
  interpretPAC(e, t) {
    let n;
    const s = {
      color: null,
      italics: !1,
      indent: null,
      underline: !1,
      row: e
    };
    return t > 95 ? n = t - 96 : n = t - 64, s.underline = (n & 1) === 1, n <= 13 ? s.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(n / 2)] : n <= 15 ? (s.italics = !0, s.color = "white") : s.indent = Math.floor((n - 16) / 2) * 4, s;
  }
  /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */
  parseChars(e, t) {
    let n, s = null, r = null;
    if (e >= 25 ? (n = 2, r = e - 8) : (n = 1, r = e), r >= 17 && r <= 19) {
      let a;
      r === 17 ? a = t + 80 : r === 18 ? a = t + 112 : a = t + 144, this.logger.log(2, () => "Special char '" + hm(a) + "' in channel " + n), s = [a];
    } else e >= 32 && e <= 127 && (s = t === 0 ? [e] : [e, t]);
    return s && this.logger.log(3, () => "Char codes =  " + un(s).join(",")), s;
  }
  /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */
  parseBackgroundAttributes(e, t) {
    const n = (e === 16 || e === 24) && t >= 32 && t <= 47, s = (e === 23 || e === 31) && t >= 45 && t <= 47;
    if (!(n || s))
      return !1;
    let r;
    const a = {};
    e === 16 || e === 24 ? (r = Math.floor((t - 32) / 2), a.background = zS[r], t % 2 === 1 && (a.background = a.background + "_semi")) : t === 45 ? a.background = "transparent" : (a.foreground = "black", t === 47 && (a.underline = !0));
    const o = e <= 23 ? 1 : 2;
    return this.channels[o].setBkgData(a), !0;
  }
  /**
   * Reset state of parser and its channels.
   */
  reset() {
    for (let e = 0; e < Object.keys(this.channels).length; e++) {
      const t = this.channels[e];
      t && t.reset();
    }
    Qs(null, null, this.cmdHistory);
  }
  /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */
  cueSplitAtTime(e) {
    for (let t = 0; t < this.channels.length; t++) {
      const n = this.channels[t];
      n && n.cueSplitAtTime(e);
    }
  }
}
function Qs(i, e, t) {
  t.a = i, t.b = e;
}
function qS(i, e, t) {
  return t.a === i && t.b === e;
}
function YS() {
  return {
    a: null,
    b: null
  };
}
var Bl = function() {
  if (Mr != null && Mr.VTTCue)
    return self.VTTCue;
  const i = ["", "lr", "rl"], e = ["start", "middle", "end", "left", "right"];
  function t(o, l) {
    if (typeof l != "string" || !Array.isArray(o))
      return !1;
    const d = l.toLowerCase();
    return ~o.indexOf(d) ? d : !1;
  }
  function n(o) {
    return t(i, o);
  }
  function s(o) {
    return t(e, o);
  }
  function r(o, ...l) {
    let d = 1;
    for (; d < arguments.length; d++) {
      const c = arguments[d];
      for (const u in c)
        o[u] = c[u];
    }
    return o;
  }
  function a(o, l, d) {
    const c = this, u = {
      enumerable: !0
    };
    c.hasBeenReset = !1;
    let f = "", h = !1, m = o, g = l, v = d, p = null, y = "", b = !0, k = "auto", T = "start", I = 50, x = "middle", E = 50, R = "middle";
    Object.defineProperty(c, "id", r({}, u, {
      get: function() {
        return f;
      },
      set: function(A) {
        f = "" + A;
      }
    })), Object.defineProperty(c, "pauseOnExit", r({}, u, {
      get: function() {
        return h;
      },
      set: function(A) {
        h = !!A;
      }
    })), Object.defineProperty(c, "startTime", r({}, u, {
      get: function() {
        return m;
      },
      set: function(A) {
        if (typeof A != "number")
          throw new TypeError("Start time must be set to a number.");
        m = A, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "endTime", r({}, u, {
      get: function() {
        return g;
      },
      set: function(A) {
        if (typeof A != "number")
          throw new TypeError("End time must be set to a number.");
        g = A, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "text", r({}, u, {
      get: function() {
        return v;
      },
      set: function(A) {
        v = "" + A, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "region", r({}, u, {
      get: function() {
        return p;
      },
      set: function(A) {
        p = A, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "vertical", r({}, u, {
      get: function() {
        return y;
      },
      set: function(A) {
        const _ = n(A);
        if (_ === !1)
          throw new SyntaxError("An invalid or illegal string was specified.");
        y = _, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "snapToLines", r({}, u, {
      get: function() {
        return b;
      },
      set: function(A) {
        b = !!A, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "line", r({}, u, {
      get: function() {
        return k;
      },
      set: function(A) {
        if (typeof A != "number" && A !== "auto")
          throw new SyntaxError("An invalid number or illegal string was specified.");
        k = A, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "lineAlign", r({}, u, {
      get: function() {
        return T;
      },
      set: function(A) {
        const _ = s(A);
        if (!_)
          throw new SyntaxError("An invalid or illegal string was specified.");
        T = _, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "position", r({}, u, {
      get: function() {
        return I;
      },
      set: function(A) {
        if (A < 0 || A > 100)
          throw new Error("Position must be between 0 and 100.");
        I = A, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "positionAlign", r({}, u, {
      get: function() {
        return x;
      },
      set: function(A) {
        const _ = s(A);
        if (!_)
          throw new SyntaxError("An invalid or illegal string was specified.");
        x = _, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "size", r({}, u, {
      get: function() {
        return E;
      },
      set: function(A) {
        if (A < 0 || A > 100)
          throw new Error("Size must be between 0 and 100.");
        E = A, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "align", r({}, u, {
      get: function() {
        return R;
      },
      set: function(A) {
        const _ = s(A);
        if (!_)
          throw new SyntaxError("An invalid or illegal string was specified.");
        R = _, this.hasBeenReset = !0;
      }
    })), c.displayState = void 0;
  }
  return a.prototype.getCueAsHTML = function() {
    return self.WebVTT.convertCueToDOMTree(self, this.text);
  }, a;
}();
class XS {
  decode(e, t) {
    if (!e)
      return "";
    if (typeof e != "string")
      throw new Error("Error - expected string data.");
    return decodeURIComponent(encodeURIComponent(e));
  }
}
function pm(i) {
  function e(n, s, r, a) {
    return (n | 0) * 3600 + (s | 0) * 60 + (r | 0) + parseFloat(a || 0);
  }
  const t = i.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
  return t ? parseFloat(t[2]) > 59 ? e(t[2], t[3], 0, t[4]) : e(t[1], t[2], t[3], t[4]) : null;
}
class ZS {
  constructor() {
    this.values = /* @__PURE__ */ Object.create(null);
  }
  // Only accept the first assignment to any key.
  set(e, t) {
    !this.get(e) && t !== "" && (this.values[e] = t);
  }
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get(e, t, n) {
    return n ? this.has(e) ? this.values[e] : t[n] : this.has(e) ? this.values[e] : t;
  }
  // Check whether we have a value for a key.
  has(e) {
    return e in this.values;
  }
  // Accept a setting if its one of the given alternatives.
  alt(e, t, n) {
    for (let s = 0; s < n.length; ++s)
      if (t === n[s]) {
        this.set(e, t);
        break;
      }
  }
  // Accept a setting if its a valid (signed) integer.
  integer(e, t) {
    /^-?\d+$/.test(t) && this.set(e, parseInt(t, 10));
  }
  // Accept a setting if its a valid percentage.
  percent(e, t) {
    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(t)) {
      const n = parseFloat(t);
      if (n >= 0 && n <= 100)
        return this.set(e, n), !0;
    }
    return !1;
  }
}
function gm(i, e, t, n) {
  const s = n ? i.split(n) : [i];
  for (const r in s) {
    if (typeof s[r] != "string")
      continue;
    const a = s[r].split(t);
    if (a.length !== 2)
      continue;
    const o = a[0], l = a[1];
    e(o, l);
  }
}
const Go = new Bl(0, 0, ""), Js = Go.align === "middle" ? "middle" : "center";
function QS(i, e, t) {
  const n = i;
  function s() {
    const o = pm(i);
    if (o === null)
      throw new Error("Malformed timestamp: " + n);
    return i = i.replace(/^[^\sa-zA-Z-]+/, ""), o;
  }
  function r(o, l) {
    const d = new ZS();
    gm(o, function(f, h) {
      let m;
      switch (f) {
        case "region":
          for (let g = t.length - 1; g >= 0; g--)
            if (t[g].id === h) {
              d.set(f, t[g].region);
              break;
            }
          break;
        case "vertical":
          d.alt(f, h, ["rl", "lr"]);
          break;
        case "line":
          m = h.split(","), d.integer(f, m[0]), d.percent(f, m[0]) && d.set("snapToLines", !1), d.alt(f, m[0], ["auto"]), m.length === 2 && d.alt("lineAlign", m[1], ["start", Js, "end"]);
          break;
        case "position":
          m = h.split(","), d.percent(f, m[0]), m.length === 2 && d.alt("positionAlign", m[1], ["start", Js, "end", "line-left", "line-right", "auto"]);
          break;
        case "size":
          d.percent(f, h);
          break;
        case "align":
          d.alt(f, h, ["start", Js, "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), l.region = d.get("region", null), l.vertical = d.get("vertical", "");
    let c = d.get("line", "auto");
    c === "auto" && Go.line === -1 && (c = -1), l.line = c, l.lineAlign = d.get("lineAlign", "start"), l.snapToLines = d.get("snapToLines", !0), l.size = d.get("size", 100), l.align = d.get("align", Js);
    let u = d.get("position", "auto");
    u === "auto" && Go.position === 50 && (u = l.align === "start" || l.align === "left" ? 0 : l.align === "end" || l.align === "right" ? 100 : 50), l.position = u;
  }
  function a() {
    i = i.replace(/^\s+/, "");
  }
  if (a(), e.startTime = s(), a(), i.slice(0, 3) !== "-->")
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + n);
  i = i.slice(3), a(), e.endTime = s(), a(), r(i, e);
}
function vm(i) {
  return i.replace(/<br(?: \/)?>/gi, `
`);
}
class JS {
  constructor() {
    this.state = "INITIAL", this.buffer = "", this.decoder = new XS(), this.regionList = [], this.cue = null, this.oncue = void 0, this.onparsingerror = void 0, this.onflush = void 0;
  }
  parse(e) {
    const t = this;
    e && (t.buffer += t.decoder.decode(e, {
      stream: !0
    }));
    function n() {
      let r = t.buffer, a = 0;
      for (r = vm(r); a < r.length && r[a] !== "\r" && r[a] !== `
`; )
        ++a;
      const o = r.slice(0, a);
      return r[a] === "\r" && ++a, r[a] === `
` && ++a, t.buffer = r.slice(a), o;
    }
    function s(r) {
      gm(r, function(a, o) {
      }, /:/);
    }
    try {
      let r = "";
      if (t.state === "INITIAL") {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        r = n();
        const o = r.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
        if (!(o != null && o[0]))
          throw new Error("Malformed WebVTT signature.");
        t.state = "HEADER";
      }
      let a = !1;
      for (; t.buffer; ) {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        switch (a ? a = !1 : r = n(), t.state) {
          case "HEADER":
            /:/.test(r) ? s(r) : r || (t.state = "ID");
            continue;
          case "NOTE":
            r || (t.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(r)) {
              t.state = "NOTE";
              break;
            }
            if (!r)
              continue;
            if (t.cue = new Bl(0, 0, ""), t.state = "CUE", r.indexOf("-->") === -1) {
              t.cue.id = r;
              continue;
            }
          // Process line as start of a cue.
          /* falls through */
          case "CUE":
            if (!t.cue) {
              t.state = "BADCUE";
              continue;
            }
            try {
              QS(r, t.cue, t.regionList);
            } catch {
              t.cue = null, t.state = "BADCUE";
              continue;
            }
            t.state = "CUETEXT";
            continue;
          case "CUETEXT":
            {
              const o = r.indexOf("-->") !== -1;
              if (!r || o && (a = !0)) {
                t.oncue && t.cue && t.oncue(t.cue), t.cue = null, t.state = "ID";
                continue;
              }
              if (t.cue === null)
                continue;
              t.cue.text && (t.cue.text += `
`), t.cue.text += r;
            }
            continue;
          case "BADCUE":
            r || (t.state = "ID");
        }
      }
    } catch {
      t.state === "CUETEXT" && t.cue && t.oncue && t.oncue(t.cue), t.cue = null, t.state = t.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  }
  flush() {
    const e = this;
    try {
      if ((e.cue || e.state === "HEADER") && (e.buffer += `

`, e.parse()), e.state === "INITIAL" || e.state === "BADWEBVTT")
        throw new Error("Malformed WebVTT signature.");
    } catch (t) {
      e.onparsingerror && e.onparsingerror(t);
    }
    return e.onflush && e.onflush(), this;
  }
}
const ek = /\r\n|\n\r|\n|\r/g, qa = function(e, t, n = 0) {
  return e.slice(n, n + t.length) === t;
}, tk = function(e) {
  let t = parseInt(e.slice(-3));
  const n = parseInt(e.slice(-6, -4)), s = parseInt(e.slice(-9, -7)), r = e.length > 9 ? parseInt(e.substring(0, e.indexOf(":"))) : 0;
  if (!ae(t) || !ae(n) || !ae(s) || !ae(r))
    throw Error(`Malformed X-TIMESTAMP-MAP: Local:${e}`);
  return t += 1e3 * n, t += 60 * 1e3 * s, t += 60 * 60 * 1e3 * r, t;
};
function Ul(i, e, t) {
  return hs(i.toString()) + hs(e.toString()) + hs(t);
}
const ik = function(e, t, n) {
  let s = e[t], r = e[s.prevCC];
  if (!r || !r.new && s.new) {
    e.ccOffset = e.presentationOffset = s.start, s.new = !1;
    return;
  }
  for (; (a = r) != null && a.new; ) {
    var a;
    e.ccOffset += s.start - r.start, s.new = !1, s = r, r = e[s.prevCC];
  }
  e.presentationOffset = n;
};
function nk(i, e, t, n, s, r, a) {
  const o = new JS(), l = Ht(new Uint8Array(i)).trim().replace(ek, `
`).split(`
`), d = [], c = e ? cb(e.baseTime, e.timescale) : 0;
  let u = "00:00.000", f = 0, h = 0, m, g = !0;
  o.oncue = function(v) {
    const p = t[n];
    let y = t.ccOffset;
    const b = (f - c) / 9e4;
    if (p != null && p.new && (h !== void 0 ? y = t.ccOffset = p.start : ik(t, n, b)), b) {
      if (!e) {
        m = new Error("Missing initPTS for VTT MPEGTS");
        return;
      }
      y = b - t.presentationOffset;
    }
    const k = v.endTime - v.startTime, T = Wt((v.startTime + y - h) * 9e4, s * 9e4) / 9e4;
    v.startTime = Math.max(T, 0), v.endTime = Math.max(T + k, 0);
    const I = v.text.trim();
    v.text = decodeURIComponent(encodeURIComponent(I)), v.id || (v.id = Ul(v.startTime, v.endTime, I)), v.endTime > 0 && d.push(v);
  }, o.onparsingerror = function(v) {
    m = v;
  }, o.onflush = function() {
    if (m) {
      a(m);
      return;
    }
    r(d);
  }, l.forEach((v) => {
    if (g)
      if (qa(v, "X-TIMESTAMP-MAP=")) {
        g = !1, v.slice(16).split(",").forEach((p) => {
          qa(p, "LOCAL:") ? u = p.slice(6) : qa(p, "MPEGTS:") && (f = parseInt(p.slice(7)));
        });
        try {
          h = tk(u) / 1e3;
        } catch (p) {
          m = p;
        }
        return;
      } else v === "" && (g = !1);
    o.parse(v + `
`);
  }), o.flush();
}
const Ya = "stpp.ttml.im1t", ym = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, bm = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/, sk = {
  left: "start",
  center: "center",
  right: "end",
  start: "start",
  end: "end"
};
function nu(i, e, t, n) {
  const s = we(new Uint8Array(i), ["mdat"]);
  if (s.length === 0) {
    n(new Error("Could not parse IMSC1 mdat"));
    return;
  }
  const r = s.map((o) => Ht(o)), a = db(e.baseTime, 1, e.timescale);
  try {
    r.forEach((o) => t(rk(o, a)));
  } catch (o) {
    n(o);
  }
}
function rk(i, e) {
  const s = new DOMParser().parseFromString(i, "text/xml").getElementsByTagName("tt")[0];
  if (!s)
    throw new Error("Invalid ttml");
  const r = {
    frameRate: 30,
    subFrameRate: 1,
    frameRateMultiplier: 0,
    tickRate: 0
  }, a = Object.keys(r).reduce((u, f) => (u[f] = s.getAttribute(`ttp:${f}`) || r[f], u), {}), o = s.getAttribute("xml:space") !== "preserve", l = su(Xa(s, "styling", "style")), d = su(Xa(s, "layout", "region")), c = Xa(s, "body", "[begin]");
  return [].map.call(c, (u) => {
    const f = Sm(u, o);
    if (!f || !u.hasAttribute("begin"))
      return null;
    const h = Qa(u.getAttribute("begin"), a), m = Qa(u.getAttribute("dur"), a);
    let g = Qa(u.getAttribute("end"), a);
    if (h === null)
      throw ru(u);
    if (g === null) {
      if (m === null)
        throw ru(u);
      g = h + m;
    }
    const v = new Bl(h - e, g - e, f);
    v.id = Ul(v.startTime, v.endTime, v.text);
    const p = d[u.getAttribute("region")], y = l[u.getAttribute("style")], b = ak(p, y, l), {
      textAlign: k
    } = b;
    if (k) {
      const T = sk[k];
      T && (v.lineAlign = T), v.align = k;
    }
    return He(v, b), v;
  }).filter((u) => u !== null);
}
function Xa(i, e, t) {
  const n = i.getElementsByTagName(e)[0];
  return n ? [].slice.call(n.querySelectorAll(t)) : [];
}
function su(i) {
  return i.reduce((e, t) => {
    const n = t.getAttribute("xml:id");
    return n && (e[n] = t), e;
  }, {});
}
function Sm(i, e) {
  return [].slice.call(i.childNodes).reduce((t, n, s) => {
    var r;
    return n.nodeName === "br" && s ? t + `
` : (r = n.childNodes) != null && r.length ? Sm(n, e) : e ? t + n.textContent.trim().replace(/\s+/g, " ") : t + n.textContent;
  }, "");
}
function ak(i, e, t) {
  const n = "http://www.w3.org/ns/ttml#styling";
  let s = null;
  const r = [
    "displayAlign",
    "textAlign",
    "color",
    "backgroundColor",
    "fontSize",
    "fontFamily"
    // 'fontWeight',
    // 'lineHeight',
    // 'wrapOption',
    // 'fontStyle',
    // 'direction',
    // 'writingMode'
  ], a = i != null && i.hasAttribute("style") ? i.getAttribute("style") : null;
  return a && t.hasOwnProperty(a) && (s = t[a]), r.reduce((o, l) => {
    const d = Za(e, n, l) || Za(i, n, l) || Za(s, n, l);
    return d && (o[l] = d), o;
  }, {});
}
function Za(i, e, t) {
  return i && i.hasAttributeNS(e, t) ? i.getAttributeNS(e, t) : null;
}
function ru(i) {
  return new Error(`Could not parse ttml timestamp ${i}`);
}
function Qa(i, e) {
  if (!i)
    return null;
  let t = pm(i);
  return t === null && (ym.test(i) ? t = ok(i, e) : bm.test(i) && (t = lk(i, e))), t;
}
function ok(i, e) {
  const t = ym.exec(i), n = (t[4] | 0) + (t[5] | 0) / e.subFrameRate;
  return (t[1] | 0) * 3600 + (t[2] | 0) * 60 + (t[3] | 0) + n / e.frameRate;
}
function lk(i, e) {
  const t = bm.exec(i), n = Number(t[1]);
  switch (t[2]) {
    case "h":
      return n * 3600;
    case "m":
      return n * 60;
    case "ms":
      return n * 1e3;
    case "f":
      return n / e.frameRate;
    case "t":
      return n / e.tickRate;
  }
  return n;
}
class er {
  constructor(e, t) {
    this.timelineController = void 0, this.cueRanges = [], this.trackName = void 0, this.startTime = null, this.endTime = null, this.screen = null, this.timelineController = e, this.trackName = t;
  }
  dispatchCue() {
    this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges), this.startTime = null);
  }
  newCue(e, t, n) {
    (this.startTime === null || this.startTime > e) && (this.startTime = e), this.endTime = t, this.screen = n, this.timelineController.createCaptionsTrack(this.trackName);
  }
  reset() {
    this.cueRanges = [], this.startTime = null;
  }
}
class dk {
  constructor(e) {
    this.hls = void 0, this.media = null, this.config = void 0, this.enabled = !0, this.Cues = void 0, this.textTracks = [], this.tracks = [], this.initPTS = [], this.unparsedVttFrags = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.cea608Parser1 = void 0, this.cea608Parser2 = void 0, this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = ou(), this.captionsProperties = void 0, this.hls = e, this.config = e.config, this.Cues = e.config.cueHandler, this.captionsProperties = {
      textTrack1: {
        label: this.config.captionsTextTrack1Label,
        languageCode: this.config.captionsTextTrack1LanguageCode
      },
      textTrack2: {
        label: this.config.captionsTextTrack2Label,
        languageCode: this.config.captionsTextTrack2LanguageCode
      },
      textTrack3: {
        label: this.config.captionsTextTrack3Label,
        languageCode: this.config.captionsTextTrack3LanguageCode
      },
      textTrack4: {
        label: this.config.captionsTextTrack4Label,
        languageCode: this.config.captionsTextTrack4LanguageCode
      }
    }, e.on(S.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(S.MANIFEST_LOADING, this.onManifestLoading, this), e.on(S.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(S.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(S.FRAG_LOADING, this.onFragLoading, this), e.on(S.FRAG_LOADED, this.onFragLoaded, this), e.on(S.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.on(S.FRAG_DECRYPTED, this.onFragDecrypted, this), e.on(S.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(S.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.on(S.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  destroy() {
    const {
      hls: e
    } = this;
    e.off(S.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(S.MANIFEST_LOADING, this.onManifestLoading, this), e.off(S.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(S.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(S.FRAG_LOADING, this.onFragLoading, this), e.off(S.FRAG_LOADED, this.onFragLoaded, this), e.off(S.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.off(S.FRAG_DECRYPTED, this.onFragDecrypted, this), e.off(S.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(S.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.off(S.BUFFER_FLUSHING, this.onBufferFlushing, this), this.hls = this.config = this.media = null, this.cea608Parser1 = this.cea608Parser2 = void 0;
  }
  initCea608Parsers() {
    const e = new er(this, "textTrack1"), t = new er(this, "textTrack2"), n = new er(this, "textTrack3"), s = new er(this, "textTrack4");
    this.cea608Parser1 = new iu(1, e, t), this.cea608Parser2 = new iu(3, n, s);
  }
  addCues(e, t, n, s, r) {
    let a = !1;
    for (let o = r.length; o--; ) {
      const l = r[o], d = ck(l[0], l[1], t, n);
      if (d >= 0 && (l[0] = Math.min(l[0], t), l[1] = Math.max(l[1], n), a = !0, d / (n - t) > 0.5))
        return;
    }
    if (a || r.push([t, n]), this.config.renderTextTracksNatively) {
      const o = this.captionsTracks[e];
      this.Cues.newCue(o, t, n, s);
    } else {
      const o = this.Cues.newCue(null, t, n, s);
      this.hls.trigger(S.CUES_PARSED, {
        type: "captions",
        cues: o,
        track: e
      });
    }
  }
  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
  onInitPtsFound(e, {
    frag: t,
    id: n,
    initPTS: s,
    timescale: r,
    trackId: a
  }) {
    const {
      unparsedVttFrags: o
    } = this;
    n === ce.MAIN && (this.initPTS[t.cc] = {
      baseTime: s,
      timescale: r,
      trackId: a
    }), o.length && (this.unparsedVttFrags = [], o.forEach((l) => {
      this.initPTS[l.frag.cc] ? this.onFragLoaded(S.FRAG_LOADED, l) : this.hls.trigger(S.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: l.frag,
        error: new Error("Subtitle discontinuity domain does not match main")
      });
    }));
  }
  getExistingTrack(e, t) {
    const {
      media: n
    } = this;
    if (n)
      for (let s = 0; s < n.textTracks.length; s++) {
        const r = n.textTracks[s];
        if (au(r, {
          name: e,
          lang: t,
          characteristics: "transcribes-spoken-dialog,describes-music-and-sound"
        }))
          return r;
      }
    return null;
  }
  createCaptionsTrack(e) {
    this.config.renderTextTracksNatively ? this.createNativeTrack(e) : this.createNonNativeTrack(e);
  }
  createNativeTrack(e) {
    if (this.captionsTracks[e])
      return;
    const {
      captionsProperties: t,
      captionsTracks: n,
      media: s
    } = this, {
      label: r,
      languageCode: a
    } = t[e], o = this.getExistingTrack(r, a);
    if (o)
      n[e] = o, Pn(n[e]), cm(n[e], s);
    else {
      const l = this.createTextTrack("captions", r, a);
      l && (l[e] = !0, n[e] = l);
    }
  }
  createNonNativeTrack(e) {
    if (this.nonNativeCaptionsTracks[e])
      return;
    const t = this.captionsProperties[e];
    if (!t)
      return;
    const n = t.label, s = {
      _id: e,
      label: n,
      kind: "captions",
      default: t.media ? !!t.media.default : !1,
      closedCaptions: t.media
    };
    this.nonNativeCaptionsTracks[e] = s, this.hls.trigger(S.NON_NATIVE_TEXT_TRACKS_FOUND, {
      tracks: [s]
    });
  }
  createTextTrack(e, t, n) {
    const s = this.media;
    if (s)
      return s.addTextTrack(e, t, n);
  }
  onMediaAttaching(e, t) {
    this.media = t.media, t.mediaSource || this._cleanTracks();
  }
  onMediaDetaching(e, t) {
    const n = !!t.transferMedia;
    if (this.media = null, n)
      return;
    const {
      captionsTracks: s
    } = this;
    Object.keys(s).forEach((r) => {
      Pn(s[r]), delete s[r];
    }), this.nonNativeCaptionsTracks = {};
  }
  onManifestLoading() {
    this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = ou(), this._cleanTracks(), this.tracks = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.textTracks = [], this.unparsedVttFrags = [], this.initPTS = [], this.cea608Parser1 && this.cea608Parser2 && (this.cea608Parser1.reset(), this.cea608Parser2.reset());
  }
  _cleanTracks() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.textTracks;
    if (t)
      for (let n = 0; n < t.length; n++)
        Pn(t[n]);
  }
  onSubtitleTracksUpdated(e, t) {
    const n = t.subtitleTracks || [], s = n.some((r) => r.textCodec === Ya);
    if (this.config.enableWebVTT || s && this.config.enableIMSC1) {
      if (Zh(this.tracks, n)) {
        this.tracks = n;
        return;
      }
      if (this.textTracks = [], this.tracks = n, this.config.renderTextTracksNatively) {
        const a = this.media, o = a ? gr(a.textTracks) : null;
        if (this.tracks.forEach((l, d) => {
          let c;
          if (o) {
            let u = null;
            for (let f = 0; f < o.length; f++)
              if (o[f] && au(o[f], l)) {
                u = o[f], o[f] = null;
                break;
              }
            u && (c = u);
          }
          if (c)
            Pn(c);
          else {
            const u = km(l);
            c = this.createTextTrack(u, l.name, l.lang), c && (c.mode = "disabled");
          }
          c && this.textTracks.push(c);
        }), o != null && o.length) {
          const l = o.filter((d) => d !== null).map((d) => d.label);
          l.length && this.hls.logger.warn(`Media element contains unused subtitle tracks: ${l.join(", ")}. Replace media element for each source to clear TextTracks and captions menu.`);
        }
      } else if (this.tracks.length) {
        const a = this.tracks.map((o) => ({
          label: o.name,
          kind: o.type.toLowerCase(),
          default: o.default,
          subtitleTrack: o
        }));
        this.hls.trigger(S.NON_NATIVE_TEXT_TRACKS_FOUND, {
          tracks: a
        });
      }
    }
  }
  onManifestLoaded(e, t) {
    this.config.enableCEA708Captions && t.captions && t.captions.forEach((n) => {
      const s = /(?:CC|SERVICE)([1-4])/.exec(n.instreamId);
      if (!s)
        return;
      const r = `textTrack${s[1]}`, a = this.captionsProperties[r];
      a && (a.label = n.name, n.lang && (a.languageCode = n.lang), a.media = n);
    });
  }
  closedCaptionsForLevel(e) {
    const t = this.hls.levels[e.level];
    return t?.attrs["CLOSED-CAPTIONS"];
  }
  onFragLoading(e, t) {
    if (this.enabled && t.frag.type === ce.MAIN) {
      var n, s;
      const {
        cea608Parser1: r,
        cea608Parser2: a,
        lastSn: o
      } = this, {
        cc: l,
        sn: d
      } = t.frag, c = (n = (s = t.part) == null ? void 0 : s.index) != null ? n : -1;
      r && a && (d !== o + 1 || d === o && c !== this.lastPartIndex + 1 || l !== this.lastCc) && (r.reset(), a.reset()), this.lastCc = l, this.lastSn = d, this.lastPartIndex = c;
    }
  }
  onFragLoaded(e, t) {
    const {
      frag: n,
      payload: s
    } = t;
    if (n.type === ce.SUBTITLE)
      if (s.byteLength) {
        const r = n.decryptdata, a = "stats" in t;
        if (r == null || !r.encrypted || a) {
          const o = this.tracks[n.level], l = this.vttCCs;
          l[n.cc] || (l[n.cc] = {
            start: n.start,
            prevCC: this.prevCC,
            new: !0
          }, this.prevCC = n.cc), o && o.textCodec === Ya ? this._parseIMSC1(n, s) : this._parseVTTs(t);
        }
      } else
        this.hls.trigger(S.SUBTITLE_FRAG_PROCESSED, {
          success: !1,
          frag: n,
          error: new Error("Empty subtitle payload")
        });
  }
  _parseIMSC1(e, t) {
    const n = this.hls;
    nu(t, this.initPTS[e.cc], (s) => {
      this._appendCues(s, e.level), n.trigger(S.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: e
      });
    }, (s) => {
      n.logger.log(`Failed to parse IMSC1: ${s}`), n.trigger(S.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: e,
        error: s
      });
    });
  }
  _parseVTTs(e) {
    var t;
    const {
      frag: n,
      payload: s
    } = e, {
      initPTS: r,
      unparsedVttFrags: a
    } = this, o = r.length - 1;
    if (!r[n.cc] && o === -1) {
      a.push(e);
      return;
    }
    const l = this.hls, d = (t = n.initSegment) != null && t.data ? Zt(n.initSegment.data, new Uint8Array(s)).buffer : s;
    nk(d, this.initPTS[n.cc], this.vttCCs, n.cc, n.start, (c) => {
      this._appendCues(c, n.level), l.trigger(S.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: n
      });
    }, (c) => {
      const u = c.message === "Missing initPTS for VTT MPEGTS";
      u ? a.push(e) : this._fallbackToIMSC1(n, s), l.logger.log(`Failed to parse VTT cue: ${c}`), !(u && o > n.cc) && l.trigger(S.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: n,
        error: c
      });
    });
  }
  _fallbackToIMSC1(e, t) {
    const n = this.tracks[e.level];
    n.textCodec || nu(t, this.initPTS[e.cc], () => {
      n.textCodec = Ya, this._parseIMSC1(e, t);
    }, () => {
      n.textCodec = "wvtt";
    });
  }
  _appendCues(e, t) {
    const n = this.hls;
    if (this.config.renderTextTracksNatively) {
      const s = this.textTracks[t];
      if (!s || s.mode === "disabled")
        return;
      e.forEach((r) => um(s, r));
    } else {
      const s = this.tracks[t];
      if (!s)
        return;
      const r = s.default ? "default" : "subtitles" + t;
      n.trigger(S.CUES_PARSED, {
        type: "subtitles",
        cues: e,
        track: r
      });
    }
  }
  onFragDecrypted(e, t) {
    const {
      frag: n
    } = t;
    n.type === ce.SUBTITLE && this.onFragLoaded(S.FRAG_LOADED, t);
  }
  onSubtitleTracksCleared() {
    this.tracks = [], this.captionsTracks = {};
  }
  onFragParsingUserdata(e, t) {
    if (!this.enabled || !this.config.enableCEA708Captions)
      return;
    const {
      frag: n,
      samples: s
    } = t;
    if (!(n.type === ce.MAIN && this.closedCaptionsForLevel(n) === "NONE"))
      for (let r = 0; r < s.length; r++) {
        const a = s[r].bytes;
        if (a) {
          this.cea608Parser1 || this.initCea608Parsers();
          const o = this.extractCea608Data(a);
          this.cea608Parser1.addData(s[r].pts, o[0]), this.cea608Parser2.addData(s[r].pts, o[1]);
        }
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: n,
    endOffsetSubtitles: s,
    type: r
  }) {
    const {
      media: a
    } = this;
    if (!(!a || a.currentTime < n)) {
      if (!r || r === "video") {
        const {
          captionsTracks: o
        } = this;
        Object.keys(o).forEach((l) => Vo(o[l], t, n));
      }
      if (this.config.renderTextTracksNatively && t === 0 && s !== void 0) {
        const {
          textTracks: o
        } = this;
        Object.keys(o).forEach((l) => Vo(o[l], t, s));
      }
    }
  }
  extractCea608Data(e) {
    const t = [[], []], n = e[0] & 31;
    let s = 2;
    for (let r = 0; r < n; r++) {
      const a = e[s++], o = 127 & e[s++], l = 127 & e[s++];
      if (o === 0 && l === 0)
        continue;
      if ((4 & a) !== 0) {
        const c = 3 & a;
        (c === 0 || c === 1) && (t[c].push(o), t[c].push(l));
      }
    }
    return t;
  }
}
function km(i) {
  return i.characteristics && /transcribes-spoken-dialog/gi.test(i.characteristics) && /describes-music-and-sound/gi.test(i.characteristics) ? "captions" : "subtitles";
}
function au(i, e) {
  return !!i && i.kind === km(e) && Fo(e, i);
}
function ck(i, e, t, n) {
  return Math.min(e, n) - Math.max(i, t);
}
function ou() {
  return {
    ccOffset: 0,
    presentationOffset: 0,
    0: {
      start: 0,
      prevCC: -1,
      new: !0
    }
  };
}
const uk = /\s/, fk = {
  newCue(i, e, t, n) {
    const s = [];
    let r, a, o, l, d;
    const c = self.VTTCue || self.TextTrackCue;
    for (let f = 0; f < n.rows.length; f++)
      if (r = n.rows[f], o = !0, l = 0, d = "", !r.isEmpty()) {
        var u;
        for (let g = 0; g < r.chars.length; g++)
          uk.test(r.chars[g].uchar) && o ? l++ : (d += r.chars[g].uchar, o = !1);
        r.cueStartTime = e, e === t && (t += 1e-4), l >= 16 ? l-- : l++;
        const h = vm(d.trim()), m = Ul(e, t, h);
        i != null && (u = i.cues) != null && u.getCueById(m) || (a = new c(e, t, h), a.id = m, a.line = f + 1, a.align = "left", a.position = 10 + Math.min(80, Math.floor(l * 8 / 32) * 10), s.push(a));
      }
    return i && s.length && (s.sort((f, h) => f.line === "auto" || h.line === "auto" ? 0 : f.line > 8 && h.line > 8 ? h.line - f.line : f.line - h.line), s.forEach((f) => um(i, f))), s;
  }
};
function hk() {
  if (
    // @ts-ignore
    self.fetch && self.AbortController && self.ReadableStream && self.Request
  )
    try {
      return new self.ReadableStream({}), !0;
    } catch {
    }
  return !1;
}
const mk = /(\d+)-(\d+)\/(\d+)/;
class lu {
  constructor(e) {
    this.fetchSetup = void 0, this.requestTimeout = void 0, this.request = null, this.response = null, this.controller = void 0, this.context = null, this.config = null, this.callbacks = null, this.stats = void 0, this.loader = null, this.fetchSetup = e.fetchSetup || yk, this.controller = new self.AbortController(), this.stats = new yl();
  }
  destroy() {
    this.loader = this.callbacks = this.context = this.config = this.request = null, this.abortInternal(), this.response = null, this.fetchSetup = this.controller = this.stats = null;
  }
  abortInternal() {
    this.controller && !this.stats.loading.end && (this.stats.aborted = !0, this.controller.abort());
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.response);
  }
  load(e, t, n) {
    const s = this.stats;
    if (s.loading.start)
      throw new Error("Loader can only be used once.");
    s.loading.start = self.performance.now();
    const r = pk(e, this.controller.signal), a = e.responseType === "arraybuffer", o = a ? "byteLength" : "length", {
      maxTimeToFirstByteMs: l,
      maxLoadTimeMs: d
    } = t.loadPolicy;
    this.context = e, this.config = t, this.callbacks = n, this.request = this.fetchSetup(e, r), self.clearTimeout(this.requestTimeout), t.timeout = l && ae(l) ? l : d, this.requestTimeout = self.setTimeout(() => {
      this.callbacks && (this.abortInternal(), this.callbacks.onTimeout(s, e, this.response));
    }, t.timeout), (Cs(this.request) ? this.request.then(self.fetch) : self.fetch(this.request)).then((u) => {
      var f;
      this.response = this.loader = u;
      const h = Math.max(self.performance.now(), s.loading.start);
      if (self.clearTimeout(this.requestTimeout), t.timeout = d, this.requestTimeout = self.setTimeout(() => {
        this.callbacks && (this.abortInternal(), this.callbacks.onTimeout(s, e, this.response));
      }, d - (h - s.loading.start)), !u.ok) {
        const {
          status: g,
          statusText: v
        } = u;
        throw new bk(v || "fetch, bad network response", g, u);
      }
      s.loading.first = h, s.total = vk(u.headers) || s.total;
      const m = (f = this.callbacks) == null ? void 0 : f.onProgress;
      return m && ae(t.highWaterMark) ? this.loadProgressively(u, s, e, t.highWaterMark, m) : a ? u.arrayBuffer() : e.responseType === "json" ? u.json() : u.text();
    }).then((u) => {
      var f, h;
      const m = this.response;
      if (!m)
        throw new Error("loader destroyed");
      self.clearTimeout(this.requestTimeout), s.loading.end = Math.max(self.performance.now(), s.loading.first);
      const g = u[o];
      g && (s.loaded = s.total = g);
      const v = {
        url: m.url,
        data: u,
        code: m.status
      }, p = (f = this.callbacks) == null ? void 0 : f.onProgress;
      p && !ae(t.highWaterMark) && p(s, e, u, m), (h = this.callbacks) == null || h.onSuccess(v, s, e, m);
    }).catch((u) => {
      var f;
      if (self.clearTimeout(this.requestTimeout), s.aborted)
        return;
      const h = u && u.code || 0, m = u ? u.message : null;
      (f = this.callbacks) == null || f.onError({
        code: h,
        text: m
      }, e, u ? u.details : null, s);
    });
  }
  getCacheAge() {
    let e = null;
    if (this.response) {
      const t = this.response.headers.get("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.response ? this.response.headers.get(e) : null;
  }
  loadProgressively(e, t, n, s = 0, r) {
    const a = new Rh(), o = e.body.getReader(), l = () => o.read().then((d) => {
      if (d.done)
        return a.dataLength && r(t, n, a.flush().buffer, e), Promise.resolve(new ArrayBuffer(0));
      const c = d.value, u = c.length;
      return t.loaded += u, u < s || a.dataLength ? (a.push(c), a.dataLength >= s && r(t, n, a.flush().buffer, e)) : r(t, n, c.buffer, e), l();
    }).catch(() => Promise.reject());
    return l();
  }
}
function pk(i, e) {
  const t = {
    method: "GET",
    mode: "cors",
    credentials: "same-origin",
    signal: e,
    headers: new self.Headers(He({}, i.headers))
  };
  return i.rangeEnd && t.headers.set("Range", "bytes=" + i.rangeStart + "-" + String(i.rangeEnd - 1)), t;
}
function gk(i) {
  const e = mk.exec(i);
  if (e)
    return parseInt(e[2]) - parseInt(e[1]) + 1;
}
function vk(i) {
  const e = i.get("Content-Range");
  if (e) {
    const n = gk(e);
    if (ae(n))
      return n;
  }
  const t = i.get("Content-Length");
  if (t)
    return parseInt(t);
}
function yk(i, e) {
  return new self.Request(i.url, e);
}
class bk extends Error {
  constructor(e, t, n) {
    super(e), this.code = void 0, this.details = void 0, this.code = t, this.details = n;
  }
}
const Sk = /^age:\s*[\d.]+\s*$/im;
class Tm {
  constructor(e) {
    this.xhrSetup = void 0, this.requestTimeout = void 0, this.retryTimeout = void 0, this.retryDelay = void 0, this.config = null, this.callbacks = null, this.context = null, this.loader = null, this.stats = void 0, this.xhrSetup = e && e.xhrSetup || null, this.stats = new yl(), this.retryDelay = 0;
  }
  destroy() {
    this.callbacks = null, this.abortInternal(), this.loader = null, this.config = null, this.context = null, this.xhrSetup = null;
  }
  abortInternal() {
    const e = this.loader;
    self.clearTimeout(this.requestTimeout), self.clearTimeout(this.retryTimeout), e && (e.onreadystatechange = null, e.onprogress = null, e.readyState !== 4 && (this.stats.aborted = !0, e.abort()));
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.loader);
  }
  load(e, t, n) {
    if (this.stats.loading.start)
      throw new Error("Loader can only be used once.");
    this.stats.loading.start = self.performance.now(), this.context = e, this.config = t, this.callbacks = n, this.loadInternal();
  }
  loadInternal() {
    const {
      config: e,
      context: t
    } = this;
    if (!e || !t)
      return;
    const n = this.loader = new self.XMLHttpRequest(), s = this.stats;
    s.loading.first = 0, s.loaded = 0, s.aborted = !1;
    const r = this.xhrSetup;
    r ? Promise.resolve().then(() => {
      if (!(this.loader !== n || this.stats.aborted))
        return r(n, t.url);
    }).catch((a) => {
      if (!(this.loader !== n || this.stats.aborted))
        return n.open("GET", t.url, !0), r(n, t.url);
    }).then(() => {
      this.loader !== n || this.stats.aborted || this.openAndSendXhr(n, t, e);
    }).catch((a) => {
      var o;
      (o = this.callbacks) == null || o.onError({
        code: n.status,
        text: a.message
      }, t, n, s);
    }) : this.openAndSendXhr(n, t, e);
  }
  openAndSendXhr(e, t, n) {
    e.readyState || e.open("GET", t.url, !0);
    const s = t.headers, {
      maxTimeToFirstByteMs: r,
      maxLoadTimeMs: a
    } = n.loadPolicy;
    if (s)
      for (const o in s)
        e.setRequestHeader(o, s[o]);
    t.rangeEnd && e.setRequestHeader("Range", "bytes=" + t.rangeStart + "-" + (t.rangeEnd - 1)), e.onreadystatechange = this.readystatechange.bind(this), e.onprogress = this.loadprogress.bind(this), e.responseType = t.responseType, self.clearTimeout(this.requestTimeout), n.timeout = r && ae(r) ? r : a, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), n.timeout), e.send();
  }
  readystatechange() {
    const {
      context: e,
      loader: t,
      stats: n
    } = this;
    if (!e || !t)
      return;
    const s = t.readyState, r = this.config;
    if (!n.aborted && s >= 2 && (n.loading.first === 0 && (n.loading.first = Math.max(self.performance.now(), n.loading.start), r.timeout !== r.loadPolicy.maxLoadTimeMs && (self.clearTimeout(this.requestTimeout), r.timeout = r.loadPolicy.maxLoadTimeMs, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), r.loadPolicy.maxLoadTimeMs - (n.loading.first - n.loading.start)))), s === 4)) {
      self.clearTimeout(this.requestTimeout), t.onreadystatechange = null, t.onprogress = null;
      const d = t.status, c = t.responseType === "text" ? t.responseText : null;
      if (d >= 200 && d < 300) {
        const m = c ?? t.response;
        if (m != null) {
          var a, o;
          n.loading.end = Math.max(self.performance.now(), n.loading.first);
          const g = t.responseType === "arraybuffer" ? m.byteLength : m.length;
          n.loaded = n.total = g, n.bwEstimate = n.total * 8e3 / (n.loading.end - n.loading.first);
          const v = (a = this.callbacks) == null ? void 0 : a.onProgress;
          v && v(n, e, m, t);
          const p = {
            url: t.responseURL,
            data: m,
            code: d
          };
          (o = this.callbacks) == null || o.onSuccess(p, n, e, t);
          return;
        }
      }
      const u = r.loadPolicy.errorRetry, f = n.retry, h = {
        url: e.url,
        data: void 0,
        code: d
      };
      if (Nr(u, f, !1, h))
        this.retry(u);
      else {
        var l;
        Be.error(`${d} while loading ${e.url}`), (l = this.callbacks) == null || l.onError({
          code: d,
          text: t.statusText
        }, e, t, n);
      }
    }
  }
  loadtimeout() {
    if (!this.config) return;
    const e = this.config.loadPolicy.timeoutRetry, t = this.stats.retry;
    if (Nr(e, t, !0))
      this.retry(e);
    else {
      var n;
      Be.warn(`timeout while loading ${(n = this.context) == null ? void 0 : n.url}`);
      const s = this.callbacks;
      s && (this.abortInternal(), s.onTimeout(this.stats, this.context, this.loader));
    }
  }
  retry(e) {
    const {
      context: t,
      stats: n
    } = this;
    this.retryDelay = Tl(e, n.retry), n.retry++, Be.warn(`${status ? "HTTP Status " + status : "Timeout"} while loading ${t?.url}, retrying ${n.retry}/${e.maxNumRetry} in ${this.retryDelay}ms`), this.abortInternal(), this.loader = null, self.clearTimeout(this.retryTimeout), this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
  }
  loadprogress(e) {
    const t = this.stats;
    t.loaded = e.loaded, e.lengthComputable && (t.total = e.total);
  }
  getCacheAge() {
    let e = null;
    if (this.loader && Sk.test(this.loader.getAllResponseHeaders())) {
      const t = this.loader.getResponseHeader("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.loader && new RegExp(`^${e}:\\s*[\\d.]+\\s*$`, "im").test(this.loader.getAllResponseHeaders()) ? this.loader.getResponseHeader(e) : null;
  }
}
const kk = {
  maxTimeToFirstByteMs: 8e3,
  maxLoadTimeMs: 2e4,
  timeoutRetry: null,
  errorRetry: null
}, Tk = Ve(Ve({
  autoStartLoad: !0,
  // used by stream-controller
  startPosition: -1,
  // used by stream-controller
  defaultAudioCodec: void 0,
  // used by stream-controller
  debug: !1,
  // used by logger
  capLevelOnFPSDrop: !1,
  // used by fps-controller
  capLevelToPlayerSize: !1,
  // used by cap-level-controller
  ignoreDevicePixelRatio: !1,
  // used by cap-level-controller
  maxDevicePixelRatio: Number.POSITIVE_INFINITY,
  // used by cap-level-controller
  preferManagedMediaSource: !0,
  initialLiveManifestSize: 1,
  // used by stream-controller
  maxBufferLength: 30,
  // used by stream-controller
  backBufferLength: 1 / 0,
  // used by buffer-controller
  frontBufferFlushThreshold: 1 / 0,
  startOnSegmentBoundary: !1,
  // used by stream-controller
  maxBufferSize: 60 * 1e3 * 1e3,
  // used by stream-controller
  maxFragLookUpTolerance: 0.25,
  // used by stream-controller
  maxBufferHole: 0.1,
  // used by stream-controller and gap-controller
  detectStallWithCurrentTimeMs: 1250,
  // used by gap-controller
  highBufferWatchdogPeriod: 2,
  // used by gap-controller
  nudgeOffset: 0.1,
  // used by gap-controller
  nudgeMaxRetry: 3,
  // used by gap-controller
  nudgeOnVideoHole: !0,
  // used by gap-controller
  liveSyncMode: "edge",
  // used by stream-controller
  liveSyncDurationCount: 3,
  // used by latency-controller
  liveSyncOnStallIncrease: 1,
  // used by latency-controller
  liveMaxLatencyDurationCount: 1 / 0,
  // used by latency-controller
  liveSyncDuration: void 0,
  // used by latency-controller
  liveMaxLatencyDuration: void 0,
  // used by latency-controller
  maxLiveSyncPlaybackRate: 1,
  // used by latency-controller
  liveDurationInfinity: !1,
  // used by buffer-controller
  /**
   * @deprecated use backBufferLength
   */
  liveBackBufferLength: null,
  // used by buffer-controller
  maxMaxBufferLength: 600,
  // used by stream-controller
  enableWorker: !0,
  // used by transmuxer
  workerPath: null,
  // used by transmuxer
  enableSoftwareAES: !0,
  // used by decrypter
  startLevel: void 0,
  // used by level-controller
  startFragPrefetch: !1,
  // used by stream-controller
  fpsDroppedMonitoringPeriod: 5e3,
  // used by fps-controller
  fpsDroppedMonitoringThreshold: 0.2,
  // used by fps-controller
  appendErrorMaxRetry: 3,
  // used by buffer-controller
  ignorePlaylistParsingErrors: !1,
  loader: Tm,
  // loader: FetchLoader,
  fLoader: void 0,
  // used by fragment-loader
  pLoader: void 0,
  // used by playlist-loader
  xhrSetup: void 0,
  // used by xhr-loader
  licenseXhrSetup: void 0,
  // used by eme-controller
  licenseResponseCallback: void 0,
  // used by eme-controller
  abrController: D1,
  bufferController: _b,
  capLevelController: Ol,
  errorController: $1,
  fpsController: _S,
  stretchShortVideoTrack: !1,
  // used by mp4-remuxer
  maxAudioFramesDrift: 1,
  // used by mp4-remuxer
  forceKeyFrameOnDiscontinuity: !0,
  // used by ts-demuxer
  abrEwmaFastLive: 3,
  // used by abr-controller
  abrEwmaSlowLive: 9,
  // used by abr-controller
  abrEwmaFastVoD: 3,
  // used by abr-controller
  abrEwmaSlowVoD: 9,
  // used by abr-controller
  abrEwmaDefaultEstimate: 5e5,
  // 500 kbps  // used by abr-controller
  abrEwmaDefaultEstimateMax: 5e6,
  // 5 mbps
  abrBandWidthFactor: 0.95,
  // used by abr-controller
  abrBandWidthUpFactor: 0.7,
  // used by abr-controller
  abrMaxWithRealBitrate: !1,
  // used by abr-controller
  maxStarvationDelay: 4,
  // used by abr-controller
  maxLoadingDelay: 4,
  // used by abr-controller
  minAutoBitrate: 0,
  // used by hls
  emeEnabled: !1,
  // used by eme-controller
  widevineLicenseUrl: void 0,
  // used by eme-controller
  drmSystems: {},
  // used by eme-controller
  drmSystemOptions: {},
  // used by eme-controller
  requestMediaKeySystemAccessFunc: kh,
  // used by eme-controller
  requireKeySystemAccessOnStart: !1,
  // used by eme-controller
  testBandwidth: !0,
  progressive: !1,
  lowLatencyMode: !0,
  cmcd: void 0,
  enableDateRangeMetadataCues: !0,
  enableEmsgMetadataCues: !0,
  enableEmsgKLVMetadata: !1,
  enableID3MetadataCues: !0,
  enableInterstitialPlayback: !0,
  interstitialAppendInPlace: !0,
  interstitialLiveLookAhead: 10,
  useMediaCapabilities: !0,
  preserveManualLevelOnError: !1,
  certLoadPolicy: {
    default: kk
  },
  keyLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 8e3,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      },
      errorRetry: {
        maxNumRetry: 8,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      }
    }
  },
  manifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1 / 0,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  playlistLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 2,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  fragLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 12e4,
      timeoutRetry: {
        maxNumRetry: 4,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 6,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  steeringManifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  interstitialAssetListLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 3e4,
      timeoutRetry: {
        maxNumRetry: 0,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 0,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  // These default settings are deprecated in favor of the above policies
  // and are maintained for backwards compatibility
  manifestLoadingTimeOut: 1e4,
  manifestLoadingMaxRetry: 1,
  manifestLoadingRetryDelay: 1e3,
  manifestLoadingMaxRetryTimeout: 64e3,
  levelLoadingTimeOut: 1e4,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1e3,
  levelLoadingMaxRetryTimeout: 64e3,
  fragLoadingTimeOut: 2e4,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1e3,
  fragLoadingMaxRetryTimeout: 64e3
}, Ek()), {}, {
  subtitleStreamController: FS,
  subtitleTrackController: LS,
  timelineController: dk,
  audioStreamController: kb,
  audioTrackController: Tb,
  emeController: Vn,
  cmcdController: TS,
  contentSteeringController: xS,
  interstitialsController: OS
});
function Ek() {
  return {
    cueHandler: fk,
    // used by timeline-controller
    enableWebVTT: !0,
    // used by timeline-controller
    enableIMSC1: !0,
    // used by timeline-controller
    enableCEA708Captions: !0,
    // used by timeline-controller
    captionsTextTrack1Label: "English",
    // used by timeline-controller
    captionsTextTrack1LanguageCode: "en",
    // used by timeline-controller
    captionsTextTrack2Label: "Spanish",
    // used by timeline-controller
    captionsTextTrack2LanguageCode: "es",
    // used by timeline-controller
    captionsTextTrack3Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack3LanguageCode: "",
    // used by timeline-controller
    captionsTextTrack4Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack4LanguageCode: "",
    // used by timeline-controller
    renderTextTracksNatively: !0
  };
}
function xk(i, e, t) {
  if ((e.liveSyncDurationCount || e.liveMaxLatencyDurationCount) && (e.liveSyncDuration || e.liveMaxLatencyDuration))
    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
  if (e.liveMaxLatencyDurationCount !== void 0 && (e.liveSyncDurationCount === void 0 || e.liveMaxLatencyDurationCount <= e.liveSyncDurationCount))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
  if (e.liveMaxLatencyDuration !== void 0 && (e.liveSyncDuration === void 0 || e.liveMaxLatencyDuration <= e.liveSyncDuration))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
  const n = Ho(i), s = ["manifest", "level", "frag"], r = ["TimeOut", "MaxRetry", "RetryDelay", "MaxRetryTimeout"];
  return s.forEach((a) => {
    const o = `${a === "level" ? "playlist" : a}LoadPolicy`, l = e[o] === void 0, d = [];
    r.forEach((c) => {
      const u = `${a}Loading${c}`, f = e[u];
      if (f !== void 0 && l) {
        d.push(u);
        const h = n[o].default;
        switch (e[o] = {
          default: h
        }, c) {
          case "TimeOut":
            h.maxLoadTimeMs = f, h.maxTimeToFirstByteMs = f;
            break;
          case "MaxRetry":
            h.errorRetry.maxNumRetry = f, h.timeoutRetry.maxNumRetry = f;
            break;
          case "RetryDelay":
            h.errorRetry.retryDelayMs = f, h.timeoutRetry.retryDelayMs = f;
            break;
          case "MaxRetryTimeout":
            h.errorRetry.maxRetryDelayMs = f, h.timeoutRetry.maxRetryDelayMs = f;
            break;
        }
      }
    }), d.length && t.warn(`hls.js config: "${d.join('", "')}" setting(s) are deprecated, use "${o}": ${qe(e[o])}`);
  }), Ve(Ve({}, n), e);
}
function Ho(i) {
  return i && typeof i == "object" ? Array.isArray(i) ? i.map(Ho) : Object.keys(i).reduce((e, t) => (e[t] = Ho(i[t]), e), {}) : i;
}
function _k(i, e) {
  const t = i.loader;
  t !== lu && t !== Tm ? (e.log("[config]: Custom loader detected, cannot enable progressive streaming"), i.progressive = !1) : hk() && (i.loader = lu, i.progressive = !0, i.enableSoftwareAES = !0, e.log("[config]: Progressive streaming enabled, using FetchLoader"));
}
const vr = 2, Ak = 0.1, wk = 0.05, Lk = 100;
class Ik extends yh {
  constructor(e, t) {
    super("gap-controller", e.logger), this.hls = void 0, this.fragmentTracker = void 0, this.media = null, this.mediaSource = void 0, this.nudgeRetry = 0, this.stallReported = !1, this.stalled = null, this.moved = !1, this.seeking = !1, this.buffered = {}, this.lastCurrentTime = 0, this.ended = 0, this.waiting = 0, this.onMediaPlaying = () => {
      this.ended = 0, this.waiting = 0;
    }, this.onMediaWaiting = () => {
      var n;
      (n = this.media) != null && n.seeking || (this.waiting = self.performance.now(), this.tick());
    }, this.onMediaEnded = () => {
      if (this.hls) {
        var n;
        this.ended = ((n = this.media) == null ? void 0 : n.currentTime) || 1, this.hls.trigger(S.MEDIA_ENDED, {
          stalled: !1
        });
      }
    }, this.hls = e, this.fragmentTracker = t, this.registerListeners();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e && (e.on(S.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(S.BUFFER_APPENDED, this.onBufferAppended, this));
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(S.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(S.BUFFER_APPENDED, this.onBufferAppended, this));
  }
  destroy() {
    super.destroy(), this.unregisterListeners(), this.media = this.hls = this.fragmentTracker = null, this.mediaSource = void 0;
  }
  onMediaAttached(e, t) {
    this.setInterval(Lk), this.mediaSource = t.mediaSource;
    const n = this.media = t.media;
    Vt(n, "playing", this.onMediaPlaying), Vt(n, "waiting", this.onMediaWaiting), Vt(n, "ended", this.onMediaEnded);
  }
  onMediaDetaching(e, t) {
    this.clearInterval();
    const {
      media: n
    } = this;
    n && (Yt(n, "playing", this.onMediaPlaying), Yt(n, "waiting", this.onMediaWaiting), Yt(n, "ended", this.onMediaEnded), this.media = null), this.mediaSource = void 0;
  }
  onBufferAppended(e, t) {
    this.buffered = t.timeRanges;
  }
  get hasBuffered() {
    return Object.keys(this.buffered).length > 0;
  }
  tick() {
    var e;
    if (!((e = this.media) != null && e.readyState) || !this.hasBuffered)
      return;
    const t = this.media.currentTime;
    this.poll(t, this.lastCurrentTime), this.lastCurrentTime = t;
  }
  /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */
  poll(e, t) {
    var n, s;
    const r = (n = this.hls) == null ? void 0 : n.config;
    if (!r)
      return;
    const a = this.media;
    if (!a)
      return;
    const {
      seeking: o
    } = a, l = this.seeking && !o, d = !this.seeking && o, c = a.paused && !o || a.ended || a.playbackRate === 0;
    if (this.seeking = o, e !== t) {
      t && (this.ended = 0), this.moved = !0, o || (this.nudgeRetry = 0, r.nudgeOnVideoHole && !c && e > t && this.nudgeOnVideoHole(e, t)), this.waiting === 0 && this.stallResolved(e);
      return;
    }
    if (d || l) {
      l && this.stallResolved(e);
      return;
    }
    if (c) {
      this.nudgeRetry = 0, this.stallResolved(e), !this.ended && a.ended && this.hls && (this.ended = e || 1, this.hls.trigger(S.MEDIA_ENDED, {
        stalled: !1
      }));
      return;
    }
    if (!Te.getBuffered(a).length) {
      this.nudgeRetry = 0;
      return;
    }
    const u = Te.bufferInfo(a, e, 0), f = u.nextStart || 0, h = this.fragmentTracker;
    if (o && h && this.hls) {
      const I = du(this.hls.inFlightFragments, e), x = u.len > vr, E = !f || I || f - e > vr && !h.getPartialFragment(e);
      if (x || E)
        return;
      this.moved = !1;
    }
    const m = (s = this.hls) == null ? void 0 : s.latestLevelDetails;
    if (!this.moved && this.stalled !== null && h) {
      if (!(u.len > 0) && !f)
        return;
      const x = Math.max(f, u.start || 0) - e, R = !!(m != null && m.live) ? m.targetduration * 2 : vr, A = tr(e, h);
      if (x > 0 && (x <= R || A)) {
        a.paused || this._trySkipBufferHole(A);
        return;
      }
    }
    const g = r.detectStallWithCurrentTimeMs, v = self.performance.now(), p = this.waiting;
    let y = this.stalled;
    if (y === null)
      if (p > 0 && v - p < g)
        y = this.stalled = p;
      else {
        this.stalled = v;
        return;
      }
    const b = v - y;
    if (!o && (b >= g || p) && this.hls) {
      var k;
      if (((k = this.mediaSource) == null ? void 0 : k.readyState) === "ended" && !(m != null && m.live) && Math.abs(e - (m?.edge || 0)) < 1) {
        if (this.ended)
          return;
        this.ended = e || 1, this.hls.trigger(S.MEDIA_ENDED, {
          stalled: !0
        });
        return;
      }
      if (this._reportStall(u), !this.media || !this.hls)
        return;
    }
    const T = Te.bufferInfo(a, e, r.maxBufferHole);
    this._tryFixBufferStall(T, b, e);
  }
  stallResolved(e) {
    const t = this.stalled;
    if (t && this.hls && (this.stalled = null, this.stallReported)) {
      const n = self.performance.now() - t;
      this.log(`playback not stuck anymore @${e}, after ${Math.round(n)}ms`), this.stallReported = !1, this.waiting = 0, this.hls.trigger(S.STALL_RESOLVED, {});
    }
  }
  nudgeOnVideoHole(e, t) {
    var n;
    const s = this.buffered.video;
    if (this.hls && this.media && this.fragmentTracker && (n = this.buffered.audio) != null && n.length && s && s.length > 1 && e > s.end(0)) {
      const r = Te.bufferedInfo(Te.timeRangesToArray(this.buffered.audio), e, 0);
      if (r.len > 1 && t >= r.start) {
        const a = Te.timeRangesToArray(s), o = Te.bufferedInfo(a, t, 0).bufferedIndex;
        if (o > -1 && o < a.length - 1) {
          const l = Te.bufferedInfo(a, e, 0).bufferedIndex, d = a[o].end, c = a[o + 1].start;
          if ((l === -1 || l > o) && c - d < 1 && // `maxBufferHole` may be too small and setting it to 0 should not disable this feature
          e - d < 2) {
            const u = new Error(`nudging playhead to flush pipeline after video hole. currentTime: ${e} hole: ${d} -> ${c} buffered index: ${l}`);
            this.warn(u.message), this.media.currentTime += 1e-6;
            let f = tr(e, this.fragmentTracker);
            f && "fragment" in f ? f = f.fragment : f || (f = void 0);
            const h = Te.bufferInfo(this.media, e, 0);
            this.hls.trigger(S.ERROR, {
              type: pe.MEDIA_ERROR,
              details: B.BUFFER_SEEK_OVER_HOLE,
              fatal: !1,
              error: u,
              reason: u.message,
              frag: f,
              buffer: h.len,
              bufferInfo: h
            });
          }
        }
      }
    }
  }
  /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */
  _tryFixBufferStall(e, t, n) {
    var s, r;
    const {
      fragmentTracker: a,
      media: o
    } = this, l = (s = this.hls) == null ? void 0 : s.config;
    if (!o || !a || !l)
      return;
    const d = (r = this.hls) == null ? void 0 : r.latestLevelDetails, c = tr(n, a);
    if ((c || d != null && d.live && n < d.fragmentStart) && (this._trySkipBufferHole(c) || !this.media))
      return;
    const u = e.buffered, f = this.adjacentTraversal(e, n);
    (u && u.length > 1 && e.len > l.maxBufferHole || e.nextStart && (e.nextStart - n < l.maxBufferHole || f)) && (t > l.highBufferWatchdogPeriod * 1e3 || this.waiting) && (this.warn("Trying to nudge playhead over buffer-hole"), this._tryNudgeBuffer(e));
  }
  adjacentTraversal(e, t) {
    const n = this.fragmentTracker, s = e.nextStart;
    if (n && s) {
      const r = n.getFragAtPos(t, ce.MAIN), a = n.getFragAtPos(s, ce.MAIN);
      if (r && a)
        return a.sn - r.sn < 2;
    }
    return !1;
  }
  /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */
  _reportStall(e) {
    const {
      hls: t,
      media: n,
      stallReported: s,
      stalled: r
    } = this;
    if (!s && r !== null && n && t) {
      this.stallReported = !0;
      const a = new Error(`Playback stalling at @${n.currentTime} due to low buffer (${qe(e)})`);
      this.warn(a.message), t.trigger(S.ERROR, {
        type: pe.MEDIA_ERROR,
        details: B.BUFFER_STALLED_ERROR,
        fatal: !1,
        error: a,
        buffer: e.len,
        bufferInfo: e,
        stalled: {
          start: r
        }
      });
    }
  }
  /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param appended - The fragment or part found at the current time (where playback is stalling).
   * @private
   */
  _trySkipBufferHole(e) {
    var t;
    const {
      fragmentTracker: n,
      media: s
    } = this, r = (t = this.hls) == null ? void 0 : t.config;
    if (!s || !n || !r)
      return 0;
    const a = s.currentTime, o = Te.bufferInfo(s, a, 0), l = a < o.start ? o.start : o.nextStart;
    if (l && this.hls) {
      const c = o.len <= r.maxBufferHole, u = o.len > 0 && o.len < 1 && s.readyState < 3, f = l - a;
      if (f > 0 && (c || u)) {
        if (f > r.maxBufferHole) {
          let m = !1;
          if (a === 0) {
            const g = n.getAppendedFrag(0, ce.MAIN);
            g && l < g.end && (m = !0);
          }
          if (!m && e) {
            var d;
            if (!((d = this.hls.loadLevelObj) != null && d.details) || du(this.hls.inFlightFragments, l))
              return 0;
            let v = !1, p = e.end;
            for (; p < l; ) {
              const y = tr(p, n);
              if (y)
                p += y.duration;
              else {
                v = !0;
                break;
              }
            }
            if (v)
              return 0;
          }
        }
        const h = Math.max(l + wk, a + Ak);
        if (this.warn(`skipping hole, adjusting currentTime from ${a} to ${h}`), this.moved = !0, s.currentTime = h, !(e != null && e.gap)) {
          const m = new Error(`fragment loaded with buffer holes, seeking from ${a} to ${h}`), g = {
            type: pe.MEDIA_ERROR,
            details: B.BUFFER_SEEK_OVER_HOLE,
            fatal: !1,
            error: m,
            reason: m.message,
            buffer: o.len,
            bufferInfo: o
          };
          e && ("fragment" in e ? g.part = e : g.frag = e), this.hls.trigger(S.ERROR, g);
        }
        return h;
      }
    }
    return 0;
  }
  /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */
  _tryNudgeBuffer(e) {
    const {
      hls: t,
      media: n,
      nudgeRetry: s
    } = this, r = t?.config;
    if (!n || !r)
      return 0;
    const a = n.currentTime;
    if (this.nudgeRetry++, s < r.nudgeMaxRetry) {
      const o = a + (s + 1) * r.nudgeOffset, l = new Error(`Nudging 'currentTime' from ${a} to ${o}`);
      this.warn(l.message), n.currentTime = o, t.trigger(S.ERROR, {
        type: pe.MEDIA_ERROR,
        details: B.BUFFER_NUDGE_ON_STALL,
        error: l,
        fatal: !1,
        buffer: e.len,
        bufferInfo: e
      });
    } else {
      const o = new Error(`Playhead still not moving while enough data buffered @${a} after ${r.nudgeMaxRetry} nudges`);
      this.error(o.message), t.trigger(S.ERROR, {
        type: pe.MEDIA_ERROR,
        details: B.BUFFER_STALLED_ERROR,
        error: o,
        fatal: !0,
        buffer: e.len,
        bufferInfo: e
      });
    }
  }
}
function du(i, e) {
  const t = cu(i.main);
  if (t && t.start <= e)
    return t;
  const n = cu(i.audio);
  return n && n.start <= e ? n : null;
}
function cu(i) {
  if (!i)
    return null;
  switch (i.state) {
    case K.IDLE:
    case K.STOPPED:
    case K.ENDED:
    case K.ERROR:
      return null;
  }
  return i.frag;
}
function tr(i, e) {
  return e.getAppendedFrag(i, ce.MAIN) || e.getPartialFragment(i);
}
const Ck = 0.25;
function zo() {
  if (!(typeof self > "u"))
    return self.VTTCue || self.TextTrackCue;
}
function Ja(i, e, t, n, s) {
  let r = new i(e, t, "");
  try {
    r.value = n, s && (r.type = s);
  } catch {
    r = new i(e, t, qe(s ? Ve({
      type: s
    }, n) : n));
  }
  return r;
}
const ir = (() => {
  const i = zo();
  try {
    i && new i(0, Number.POSITIVE_INFINITY, "");
  } catch {
    return Number.MAX_VALUE;
  }
  return Number.POSITIVE_INFINITY;
})();
class Rk {
  constructor(e) {
    this.hls = void 0, this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.removeCues = !0, this.assetCue = void 0, this.onEventCueEnter = () => {
      this.hls && this.hls.trigger(S.EVENT_CUE_ENTER, {});
    }, this.hls = e, this._registerListeners();
  }
  destroy() {
    this._unregisterListeners(), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = this.onEventCueEnter = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e && (e.on(S.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(S.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(S.MANIFEST_LOADING, this.onManifestLoading, this), e.on(S.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.on(S.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(S.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(S.LEVEL_PTS_UPDATED, this.onLevelPtsUpdated, this));
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(S.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(S.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(S.MANIFEST_LOADING, this.onManifestLoading, this), e.off(S.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.off(S.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(S.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(S.LEVEL_PTS_UPDATED, this.onLevelPtsUpdated, this));
  }
  // Add ID3 metatadata text track.
  onMediaAttaching(e, t) {
    var n;
    this.media = t.media, ((n = t.overrides) == null ? void 0 : n.cueRemoval) === !1 && (this.removeCues = !1);
  }
  onMediaAttached() {
    var e;
    const t = (e = this.hls) == null ? void 0 : e.latestLevelDetails;
    t && this.updateDateRangeCues(t);
  }
  onMediaDetaching(e, t) {
    this.media = null, !t.transferMedia && (this.id3Track && (this.removeCues && Pn(this.id3Track, this.onEventCueEnter), this.id3Track = null), this.dateRangeCuesAppended = {});
  }
  onManifestLoading() {
    this.dateRangeCuesAppended = {};
  }
  createTrack(e) {
    const t = this.getID3Track(e.textTracks);
    return t.mode = "hidden", t;
  }
  getID3Track(e) {
    if (this.media) {
      for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n.kind === "metadata" && n.label === "id3")
          return cm(n, this.media), n;
      }
      return this.media.addTextTrack("metadata", "id3");
    }
  }
  onFragParsingMetadata(e, t) {
    if (!this.media || !this.hls)
      return;
    const {
      enableEmsgMetadataCues: n,
      enableID3MetadataCues: s
    } = this.hls.config;
    if (!n && !s)
      return;
    const {
      samples: r
    } = t;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const a = zo();
    if (a)
      for (let o = 0; o < r.length; o++) {
        const l = r[o].type;
        if (l === Bt.emsg && !n || !s)
          continue;
        const d = $h(r[o].data), c = r[o].pts;
        let u = c + r[o].duration;
        u > ir && (u = ir), u - c <= 0 && (u = c + Ck);
        for (let h = 0; h < d.length; h++) {
          const m = d[h];
          if (!Bh(m)) {
            this.updateId3CueEnds(c, l);
            const g = Ja(a, c, u, m, l);
            g && this.id3Track.addCue(g);
          }
        }
      }
  }
  updateId3CueEnds(e, t) {
    var n;
    const s = (n = this.id3Track) == null ? void 0 : n.cues;
    if (s)
      for (let r = s.length; r--; ) {
        const a = s[r];
        a.type === t && a.startTime < e && a.endTime === ir && (a.endTime = e);
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: n,
    type: s
  }) {
    const {
      id3Track: r,
      hls: a
    } = this;
    if (!a)
      return;
    const {
      config: {
        enableEmsgMetadataCues: o,
        enableID3MetadataCues: l
      }
    } = a;
    if (r && (o || l)) {
      let d;
      s === "audio" ? d = (c) => c.type === Bt.audioId3 && l : s === "video" ? d = (c) => c.type === Bt.emsg && o : d = (c) => c.type === Bt.audioId3 && l || c.type === Bt.emsg && o, Vo(r, t, n, d);
    }
  }
  onLevelUpdated(e, {
    details: t
  }) {
    this.updateDateRangeCues(t, !0);
  }
  onLevelPtsUpdated(e, t) {
    Math.abs(t.drift) > 0.01 && this.updateDateRangeCues(t.details);
  }
  updateDateRangeCues(e, t) {
    if (!this.hls || !this.media)
      return;
    const {
      assetPlayerId: n,
      timelineOffset: s,
      enableDateRangeMetadataCues: r,
      interstitialsController: a
    } = this.hls.config;
    if (!r)
      return;
    const o = zo();
    if (n && s && !a) {
      const {
        fragmentStart: g,
        fragmentEnd: v
      } = e;
      let p = this.assetCue;
      p ? (p.startTime = g, p.endTime = v) : o && (p = this.assetCue = Ja(o, g, v, {
        assetPlayerId: this.hls.config.assetPlayerId
      }, "hlsjs.interstitial.asset"), p && (p.id = n, this.id3Track || (this.id3Track = this.createTrack(this.media)), this.id3Track.addCue(p), p.addEventListener("enter", this.onEventCueEnter)));
    }
    if (!e.hasProgramDateTime)
      return;
    const {
      id3Track: l
    } = this, {
      dateRanges: d
    } = e, c = Object.keys(d);
    let u = this.dateRangeCuesAppended;
    if (l && t) {
      var f;
      if ((f = l.cues) != null && f.length) {
        const g = Object.keys(u).filter((v) => !c.includes(v));
        for (let v = g.length; v--; ) {
          var h;
          const p = g[v], y = (h = u[p]) == null ? void 0 : h.cues;
          delete u[p], y && Object.keys(y).forEach((b) => {
            const k = y[b];
            if (k) {
              k.removeEventListener("enter", this.onEventCueEnter);
              try {
                l.removeCue(k);
              } catch {
              }
            }
          });
        }
      } else
        u = this.dateRangeCuesAppended = {};
    }
    const m = e.fragments[e.fragments.length - 1];
    if (!(c.length === 0 || !ae(m?.programDateTime))) {
      this.id3Track || (this.id3Track = this.createTrack(this.media));
      for (let g = 0; g < c.length; g++) {
        const v = c[g], p = d[v], y = p.startTime, b = u[v], k = b?.cues || {};
        let T = b?.durationKnown || !1, I = ir;
        const {
          duration: x,
          endDate: E
        } = p;
        if (E && x !== null)
          I = y + x, T = !0;
        else if (p.endOnNext && !T) {
          const A = c.reduce((_, C) => {
            if (C !== p.id) {
              const O = d[C];
              if (O.class === p.class && O.startDate > p.startDate && (!_ || p.startDate < _.startDate))
                return O;
            }
            return _;
          }, null);
          A && (I = A.startTime, T = !0);
        }
        const R = Object.keys(p.attr);
        for (let A = 0; A < R.length; A++) {
          const _ = R[A];
          if (!Z1(_))
            continue;
          const C = k[_];
          if (C)
            T && !(b != null && b.durationKnown) ? C.endTime = I : Math.abs(C.startTime - y) > 0.01 && (C.startTime = y, C.endTime = I);
          else if (o) {
            let O = p.attr[_];
            Q1(_) && (O = th(O));
            const j = Ja(o, y, I, {
              key: _,
              data: O
            }, Bt.dateRange);
            j && (j.id = v, this.id3Track.addCue(j), k[_] = j, a && (_ === "X-ASSET-LIST" || _ === "X-ASSET-URL") && j.addEventListener("enter", this.onEventCueEnter));
          }
        }
        u[v] = {
          cues: k,
          dateRange: p,
          durationKnown: T
        };
      }
    }
  }
}
class Pk {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.currentTime = 0, this.stallCount = 0, this._latency = null, this._targetLatencyUpdated = !1, this.onTimeupdate = () => {
      const {
        media: t
      } = this, n = this.levelDetails;
      if (!t || !n)
        return;
      this.currentTime = t.currentTime;
      const s = this.computeLatency();
      if (s === null)
        return;
      this._latency = s;
      const {
        lowLatencyMode: r,
        maxLiveSyncPlaybackRate: a
      } = this.config;
      if (!r || a === 1 || !n.live)
        return;
      const o = this.targetLatency;
      if (o === null)
        return;
      const l = s - o, d = Math.min(this.maxLatency, o + n.targetduration);
      if (l < d && l > 0.05 && this.forwardBufferLength > 1) {
        const u = Math.min(2, Math.max(1, a)), f = Math.round(2 / (1 + Math.exp(-0.75 * l - this.edgeStalled)) * 20) / 20, h = Math.min(u, Math.max(1, f));
        this.changeMediaPlaybackRate(t, h);
      } else t.playbackRate !== 1 && t.playbackRate !== 0 && this.changeMediaPlaybackRate(t, 1);
    }, this.hls = e, this.config = e.config, this.registerListeners();
  }
  get levelDetails() {
    var e;
    return ((e = this.hls) == null ? void 0 : e.latestLevelDetails) || null;
  }
  get latency() {
    return this._latency || 0;
  }
  get maxLatency() {
    const {
      config: e
    } = this;
    if (e.liveMaxLatencyDuration !== void 0)
      return e.liveMaxLatencyDuration;
    const t = this.levelDetails;
    return t ? e.liveMaxLatencyDurationCount * t.targetduration : 0;
  }
  get targetLatency() {
    const e = this.levelDetails;
    if (e === null || this.hls === null)
      return null;
    const {
      holdBack: t,
      partHoldBack: n,
      targetduration: s
    } = e, {
      liveSyncDuration: r,
      liveSyncDurationCount: a,
      lowLatencyMode: o
    } = this.config, l = this.hls.userConfig;
    let d = o && n || t;
    (this._targetLatencyUpdated || l.liveSyncDuration || l.liveSyncDurationCount || d === 0) && (d = r !== void 0 ? r : a * s);
    const c = s;
    return d + Math.min(this.stallCount * this.config.liveSyncOnStallIncrease, c);
  }
  set targetLatency(e) {
    this.stallCount = 0, this.config.liveSyncDuration = e, this._targetLatencyUpdated = !0;
  }
  get liveSyncPosition() {
    const e = this.estimateLiveEdge(), t = this.targetLatency;
    if (e === null || t === null)
      return null;
    const n = this.levelDetails;
    if (n === null)
      return null;
    const s = n.edge, r = e - t - this.edgeStalled, a = s - n.totalduration, o = s - (this.config.lowLatencyMode && n.partTarget || n.targetduration);
    return Math.min(Math.max(a, r), o);
  }
  get drift() {
    const e = this.levelDetails;
    return e === null ? 1 : e.drift;
  }
  get edgeStalled() {
    const e = this.levelDetails;
    if (e === null)
      return 0;
    const t = (this.config.lowLatencyMode && e.partTarget || e.targetduration) * 3;
    return Math.max(e.age - t, 0);
  }
  get forwardBufferLength() {
    const {
      media: e
    } = this, t = this.levelDetails;
    if (!e || !t)
      return 0;
    const n = e.buffered.length;
    return (n ? e.buffered.end(n - 1) : t.edge) - this.currentTime;
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetaching(), this.hls = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e && (e.on(S.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(S.MANIFEST_LOADING, this.onManifestLoading, this), e.on(S.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(S.ERROR, this.onError, this));
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(S.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(S.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(S.MANIFEST_LOADING, this.onManifestLoading, this), e.off(S.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(S.ERROR, this.onError, this));
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("timeupdate", this.onTimeupdate);
  }
  onMediaDetaching() {
    this.media && (this.media.removeEventListener("timeupdate", this.onTimeupdate), this.media = null);
  }
  onManifestLoading() {
    this._latency = null, this.stallCount = 0;
  }
  onLevelUpdated(e, {
    details: t
  }) {
    t.advanced && this.onTimeupdate(), !t.live && this.media && this.media.removeEventListener("timeupdate", this.onTimeupdate);
  }
  onError(e, t) {
    var n;
    t.details === B.BUFFER_STALLED_ERROR && (this.stallCount++, this.hls && (n = this.levelDetails) != null && n.live && this.hls.logger.warn("[latency-controller]: Stall detected, adjusting target latency"));
  }
  changeMediaPlaybackRate(e, t) {
    var n, s;
    e.playbackRate !== t && ((n = this.hls) == null || n.logger.debug(`[latency-controller]: latency=${this.latency.toFixed(3)}, targetLatency=${(s = this.targetLatency) == null ? void 0 : s.toFixed(3)}, forwardBufferLength=${this.forwardBufferLength.toFixed(3)}: adjusting playback rate from ${e.playbackRate} to ${t}`), e.playbackRate = t);
  }
  estimateLiveEdge() {
    const e = this.levelDetails;
    return e === null ? null : e.edge + e.age;
  }
  computeLatency() {
    const e = this.estimateLiveEdge();
    return e === null ? null : e - this.currentTime;
  }
}
class Dk extends Ml {
  constructor(e, t) {
    super(e, "level-controller"), this._levels = [], this._firstLevel = -1, this._maxAutoLevel = -1, this._startLevel = void 0, this.currentLevel = null, this.currentLevelIndex = -1, this.manualLevelIndex = -1, this.steering = void 0, this.onParsedComplete = void 0, this.steering = t, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(S.MANIFEST_LOADING, this.onManifestLoading, this), e.on(S.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(S.LEVEL_LOADED, this.onLevelLoaded, this), e.on(S.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(S.FRAG_BUFFERED, this.onFragBuffered, this), e.on(S.ERROR, this.onError, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(S.MANIFEST_LOADING, this.onManifestLoading, this), e.off(S.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(S.LEVEL_LOADED, this.onLevelLoaded, this), e.off(S.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(S.FRAG_BUFFERED, this.onFragBuffered, this), e.off(S.ERROR, this.onError, this);
  }
  destroy() {
    this._unregisterListeners(), this.steering = null, this.resetLevels(), super.destroy();
  }
  stopLoad() {
    this._levels.forEach((t) => {
      t.loadError = 0, t.fragmentError = 0;
    }), super.stopLoad();
  }
  resetLevels() {
    this._startLevel = void 0, this.manualLevelIndex = -1, this.currentLevelIndex = -1, this.currentLevel = null, this._levels = [], this._maxAutoLevel = -1;
  }
  onManifestLoading(e, t) {
    this.resetLevels();
  }
  onManifestLoaded(e, t) {
    const n = this.hls.config.preferManagedMediaSource, s = [], r = {}, a = {};
    let o = !1, l = !1, d = !1;
    t.levels.forEach((c) => {
      const u = c.attrs;
      let {
        audioCodec: f,
        videoCodec: h
      } = c;
      f && (c.audioCodec = f = Cr(f, n) || void 0), h && (h = c.videoCodec = g1(h));
      const {
        width: m,
        height: g,
        unknownCodecs: v
      } = c;
      let p = v ? v.length : 0;
      if (v)
        for (let A = p; A--; ) {
          const _ = v[A];
          this.isAudioSupported(_) ? (c.audioCodec = f = f ? `${f},${_}` : _, p--, zn.audio[f.substring(0, 4)] = 2) : this.isVideoSupported(_) && (c.videoCodec = h = h ? `${h},${_}` : _, p--, zn.video[h.substring(0, 4)] = 2);
        }
      if (o || (o = !!(m && g)), l || (l = !!h), d || (d = !!f), p || f && !this.isAudioSupported(f) || h && !this.isVideoSupported(h)) {
        this.log(`Some or all CODECS not supported "${u.CODECS}"`);
        return;
      }
      const {
        CODECS: y,
        "FRAME-RATE": b,
        "HDCP-LEVEL": k,
        "PATHWAY-ID": T,
        RESOLUTION: I,
        "VIDEO-RANGE": x
      } = u, R = `${`${T || "."}-`}${c.bitrate}-${I}-${b}-${y}-${x}-${k}`;
      if (r[R])
        if (r[R].uri !== c.url && !c.attrs["PATHWAY-ID"]) {
          const A = a[R] += 1;
          c.attrs["PATHWAY-ID"] = new Array(A + 1).join(".");
          const _ = this.createLevel(c);
          r[R] = _, s.push(_);
        } else
          r[R].addGroupId("audio", u.AUDIO), r[R].addGroupId("text", u.SUBTITLES);
      else {
        const A = this.createLevel(c);
        r[R] = A, a[R] = 1, s.push(A);
      }
    }), this.filterAndSortMediaOptions(s, t, o, l, d);
  }
  createLevel(e) {
    const t = new As(e), n = e.supplemental;
    if (n != null && n.videoCodec && !this.isVideoSupported(n.videoCodec)) {
      const s = new Error(`SUPPLEMENTAL-CODECS not supported "${n.videoCodec}"`);
      this.log(s.message), t.supportedResult = fh(s, []);
    }
    return t;
  }
  isAudioSupported(e) {
    return Lo(e, "audio", this.hls.config.preferManagedMediaSource);
  }
  isVideoSupported(e) {
    return Lo(e, "video", this.hls.config.preferManagedMediaSource);
  }
  filterAndSortMediaOptions(e, t, n, s, r) {
    let a = [], o = [], l = e;
    if ((n || s) && r && (l = l.filter(({
      videoCodec: v,
      videoRange: p,
      width: y,
      height: b
    }) => (!!v || !!(y && b)) && x1(p))), l.length === 0) {
      Promise.resolve().then(() => {
        if (this.hls) {
          let v = "no level with compatible codecs found in manifest", p = v;
          t.levels.length && (p = `one or more CODECS in variant not supported: ${qe(t.levels.map((b) => b.attrs.CODECS).filter((b, k, T) => T.indexOf(b) === k))}`, this.warn(p), v += ` (${p})`);
          const y = new Error(v);
          this.hls.trigger(S.ERROR, {
            type: pe.MEDIA_ERROR,
            details: B.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
            fatal: !0,
            url: t.url,
            error: y,
            reason: p
          });
        }
      });
      return;
    }
    t.audioTracks && (a = t.audioTracks.filter((v) => !v.audioCodec || this.isAudioSupported(v.audioCodec)), uu(a)), t.subtitles && (o = t.subtitles, uu(o));
    const d = l.slice(0);
    l.sort((v, p) => {
      if (v.attrs["HDCP-LEVEL"] !== p.attrs["HDCP-LEVEL"])
        return (v.attrs["HDCP-LEVEL"] || "") > (p.attrs["HDCP-LEVEL"] || "") ? 1 : -1;
      if (n && v.height !== p.height)
        return v.height - p.height;
      if (v.frameRate !== p.frameRate)
        return v.frameRate - p.frameRate;
      if (v.videoRange !== p.videoRange)
        return Rr.indexOf(v.videoRange) - Rr.indexOf(p.videoRange);
      if (v.videoCodec !== p.videoCodec) {
        const y = ac(v.videoCodec), b = ac(p.videoCodec);
        if (y !== b)
          return b - y;
      }
      if (v.uri === p.uri && v.codecSet !== p.codecSet) {
        const y = Ir(v.codecSet), b = Ir(p.codecSet);
        if (y !== b)
          return b - y;
      }
      return v.averageBitrate !== p.averageBitrate ? v.averageBitrate - p.averageBitrate : 0;
    });
    let c = d[0];
    if (this.steering && (l = this.steering.filterParsedLevels(l), l.length !== d.length)) {
      for (let v = 0; v < d.length; v++)
        if (d[v].pathwayId === l[0].pathwayId) {
          c = d[v];
          break;
        }
    }
    this._levels = l;
    for (let v = 0; v < l.length; v++)
      if (l[v] === c) {
        var u;
        this._firstLevel = v;
        const p = c.bitrate, y = this.hls.bandwidthEstimate;
        if (this.log(`manifest loaded, ${l.length} level(s) found, first bitrate: ${p}`), ((u = this.hls.userConfig) == null ? void 0 : u.abrEwmaDefaultEstimate) === void 0) {
          const b = Math.min(p, this.hls.config.abrEwmaDefaultEstimateMax);
          b > y && y === this.hls.abrEwmaDefaultEstimate && (this.hls.bandwidthEstimate = b);
        }
        break;
      }
    const f = r && !s, h = this.hls.config, m = !!(h.audioStreamController && h.audioTrackController), g = {
      levels: l,
      audioTracks: a,
      subtitleTracks: o,
      sessionData: t.sessionData,
      sessionKeys: t.sessionKeys,
      firstLevel: this._firstLevel,
      stats: t.stats,
      audio: r,
      video: s,
      altAudio: m && !f && a.some((v) => !!v.url)
    };
    this.hls.trigger(S.MANIFEST_PARSED, g);
  }
  get levels() {
    return this._levels.length === 0 ? null : this._levels;
  }
  get loadLevelObj() {
    return this.currentLevel;
  }
  get level() {
    return this.currentLevelIndex;
  }
  set level(e) {
    const t = this._levels;
    if (t.length === 0)
      return;
    if (e < 0 || e >= t.length) {
      const c = new Error("invalid level idx"), u = e < 0;
      if (this.hls.trigger(S.ERROR, {
        type: pe.OTHER_ERROR,
        details: B.LEVEL_SWITCH_ERROR,
        level: e,
        fatal: u,
        error: c,
        reason: c.message
      }), u)
        return;
      e = Math.min(e, t.length - 1);
    }
    const n = this.currentLevelIndex, s = this.currentLevel, r = s ? s.attrs["PATHWAY-ID"] : void 0, a = t[e], o = a.attrs["PATHWAY-ID"];
    if (this.currentLevelIndex = e, this.currentLevel = a, n === e && s && r === o)
      return;
    this.log(`Switching to level ${e} (${a.height ? a.height + "p " : ""}${a.videoRange ? a.videoRange + " " : ""}${a.codecSet ? a.codecSet + " " : ""}@${a.bitrate})${o ? " with Pathway " + o : ""} from level ${n}${r ? " with Pathway " + r : ""}`);
    const l = {
      level: e,
      attrs: a.attrs,
      details: a.details,
      bitrate: a.bitrate,
      averageBitrate: a.averageBitrate,
      maxBitrate: a.maxBitrate,
      realBitrate: a.realBitrate,
      width: a.width,
      height: a.height,
      codecSet: a.codecSet,
      audioCodec: a.audioCodec,
      videoCodec: a.videoCodec,
      audioGroups: a.audioGroups,
      subtitleGroups: a.subtitleGroups,
      loaded: a.loaded,
      loadError: a.loadError,
      fragmentError: a.fragmentError,
      name: a.name,
      id: a.id,
      uri: a.uri,
      url: a.url,
      urlId: 0,
      audioGroupIds: a.audioGroupIds,
      textGroupIds: a.textGroupIds
    };
    this.hls.trigger(S.LEVEL_SWITCHING, l);
    const d = a.details;
    if (!d || d.live) {
      const c = this.switchParams(a.uri, s?.details, d);
      this.loadPlaylist(c);
    }
  }
  get manualLevel() {
    return this.manualLevelIndex;
  }
  set manualLevel(e) {
    this.manualLevelIndex = e, this._startLevel === void 0 && (this._startLevel = e), e !== -1 && (this.level = e);
  }
  get firstLevel() {
    return this._firstLevel;
  }
  set firstLevel(e) {
    this._firstLevel = e;
  }
  get startLevel() {
    if (this._startLevel === void 0) {
      const e = this.hls.config.startLevel;
      return e !== void 0 ? e : this.hls.firstAutoLevel;
    }
    return this._startLevel;
  }
  set startLevel(e) {
    this._startLevel = e;
  }
  get pathways() {
    return this.steering ? this.steering.pathways() : [];
  }
  get pathwayPriority() {
    return this.steering ? this.steering.pathwayPriority : null;
  }
  set pathwayPriority(e) {
    if (this.steering) {
      const t = this.steering.pathways(), n = e.filter((s) => t.indexOf(s) !== -1);
      if (e.length < 1) {
        this.warn(`pathwayPriority ${e} should contain at least one pathway from list: ${t}`);
        return;
      }
      this.steering.pathwayPriority = n;
    }
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Le.LEVEL && t.context.level === this.level && this.checkRetry(t);
  }
  // reset errors on the successful load of a fragment
  onFragBuffered(e, {
    frag: t
  }) {
    if (t !== void 0 && t.type === ce.MAIN) {
      const n = t.elementaryStreams;
      if (!Object.keys(n).some((r) => !!n[r]))
        return;
      const s = this._levels[t.level];
      s != null && s.loadError && (this.log(`Resetting level error count of ${s.loadError} on frag buffered`), s.loadError = 0);
    }
  }
  onLevelLoaded(e, t) {
    var n;
    const {
      level: s,
      details: r
    } = t, a = t.levelInfo;
    if (!a) {
      var o;
      this.warn(`Invalid level index ${s}`), (o = t.deliveryDirectives) != null && o.skip && (r.deltaUpdateFailed = !0);
      return;
    }
    if (a === this.currentLevel || t.withoutMultiVariant) {
      a.fragmentError === 0 && (a.loadError = 0);
      let l = a.details;
      l === t.details && l.advanced && (l = void 0), this.playlistLoaded(s, t, l);
    } else (n = t.deliveryDirectives) != null && n.skip && (r.deltaUpdateFailed = !0);
  }
  loadPlaylist(e) {
    super.loadPlaylist(), this.shouldLoadPlaylist(this.currentLevel) && this.scheduleLoading(this.currentLevel, e);
  }
  loadingPlaylist(e, t) {
    super.loadingPlaylist(e, t);
    const n = this.getUrlWithDirectives(e.uri, t), s = this.currentLevelIndex, r = e.attrs["PATHWAY-ID"], a = e.details, o = a?.age;
    this.log(`Loading level index ${s}${t?.msn !== void 0 ? " at sn " + t.msn + " part " + t.part : ""}${r ? " Pathway " + r : ""}${o && a.live ? " age " + o.toFixed(1) + (a.type && " " + a.type || "") : ""} ${n}`), this.hls.trigger(S.LEVEL_LOADING, {
      url: n,
      level: s,
      levelInfo: e,
      pathwayId: e.attrs["PATHWAY-ID"],
      id: 0,
      // Deprecated Level urlId
      deliveryDirectives: t || null
    });
  }
  get nextLoadLevel() {
    return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
  }
  set nextLoadLevel(e) {
    this.level = e, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = e);
  }
  removeLevel(e) {
    var t;
    if (this._levels.length === 1)
      return;
    const n = this._levels.filter((r, a) => a !== e ? !0 : (this.steering && this.steering.removeLevel(r), r === this.currentLevel && (this.currentLevel = null, this.currentLevelIndex = -1, r.details && r.details.fragments.forEach((o) => o.level = -1)), !1));
    Lh(n), this._levels = n, this.currentLevelIndex > -1 && (t = this.currentLevel) != null && t.details && (this.currentLevelIndex = this.currentLevel.details.fragments[0].level), this.manualLevelIndex > -1 && (this.manualLevelIndex = this.currentLevelIndex);
    const s = n.length - 1;
    this._firstLevel = Math.min(this._firstLevel, s), this._startLevel && (this._startLevel = Math.min(this._startLevel, s)), this.hls.trigger(S.LEVELS_UPDATED, {
      levels: n
    });
  }
  onLevelsUpdated(e, {
    levels: t
  }) {
    this._levels = t;
  }
  checkMaxAutoUpdated() {
    const {
      autoLevelCapping: e,
      maxAutoLevel: t,
      maxHdcpLevel: n
    } = this.hls;
    this._maxAutoLevel !== t && (this._maxAutoLevel = t, this.hls.trigger(S.MAX_AUTO_LEVEL_UPDATED, {
      autoLevelCapping: e,
      levels: this.levels,
      maxAutoLevel: t,
      minAutoLevel: this.hls.minAutoLevel,
      maxHdcpLevel: n
    }));
  }
}
function uu(i) {
  const e = {};
  i.forEach((t) => {
    const n = t.groupId || "";
    t.id = e[n] = e[n] || 0, e[n]++;
  });
}
function Em() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function xm() {
  if (!en())
    return !1;
  const e = Em();
  return !e || e.prototype && typeof e.prototype.appendBuffer == "function" && typeof e.prototype.remove == "function";
}
function Nk() {
  if (!xm())
    return !1;
  const i = en();
  return typeof i?.isTypeSupported == "function" && (["avc1.42E01E,mp4a.40.2", "av01.0.01M.08", "vp09.00.50.08"].some((e) => i.isTypeSupported(_s(e, "video"))) || ["mp4a.40.2", "fLaC"].some((e) => i.isTypeSupported(_s(e, "audio"))));
}
function Mk() {
  var i;
  const e = Em();
  return typeof (e == null || (i = e.prototype) == null ? void 0 : i.changeType) == "function";
}
const Ok = 100;
class Fk extends wl {
  constructor(e, t, n) {
    super(e, t, n, "stream-controller", ce.MAIN), this.audioCodecSwap = !1, this.level = -1, this._forceStartLoad = !1, this._hasEnoughToStart = !1, this.altAudio = 0, this.audioOnly = !1, this.fragPlaying = null, this.fragLastKbps = 0, this.couldBacktrack = !1, this.backtrackFragment = null, this.audioCodecSwitch = !1, this.videoBuffer = null, this.onMediaPlaying = () => {
      this.tick();
    }, this.onMediaSeeked = () => {
      const s = this.media, r = s ? s.currentTime : null;
      if (r === null || !ae(r) || (this.log(`Media seeked to ${r.toFixed(3)}`), !this.getBufferedFrag(r)))
        return;
      const a = this.getFwdBufferInfoAtPos(s, r, ce.MAIN, 0);
      if (a === null || a.len === 0) {
        this.warn(`Main forward buffer length at ${r} on "seeked" event ${a ? a.len : "empty"})`);
        return;
      }
      this.tick();
    }, this.registerListeners();
  }
  registerListeners() {
    super.registerListeners();
    const {
      hls: e
    } = this;
    e.on(S.MANIFEST_PARSED, this.onManifestParsed, this), e.on(S.LEVEL_LOADING, this.onLevelLoading, this), e.on(S.LEVEL_LOADED, this.onLevelLoaded, this), e.on(S.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.on(S.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(S.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.on(S.BUFFER_CREATED, this.onBufferCreated, this), e.on(S.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(S.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(S.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  unregisterListeners() {
    super.unregisterListeners();
    const {
      hls: e
    } = this;
    e.off(S.MANIFEST_PARSED, this.onManifestParsed, this), e.off(S.LEVEL_LOADED, this.onLevelLoaded, this), e.off(S.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.off(S.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(S.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.off(S.BUFFER_CREATED, this.onBufferCreated, this), e.off(S.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(S.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(S.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  onHandlerDestroying() {
    this.onMediaPlaying = this.onMediaSeeked = null, this.unregisterListeners(), super.onHandlerDestroying();
  }
  startLoad(e, t) {
    if (this.levels) {
      const {
        lastCurrentTime: n,
        hls: s
      } = this;
      if (this.stopLoad(), this.setInterval(Ok), this.level = -1, !this.startFragRequested) {
        let r = s.startLevel;
        r === -1 && (s.config.testBandwidth && this.levels.length > 1 ? (r = 0, this.bitrateTest = !0) : r = s.firstAutoLevel), s.nextLoadLevel = r, this.level = s.loadLevel, this._hasEnoughToStart = !!t;
      }
      n > 0 && e === -1 && !t && (this.log(`Override startPosition with lastCurrentTime @${n.toFixed(3)}`), e = n), this.state = K.IDLE, this.nextLoadPosition = this.lastCurrentTime = e + this.timelineOffset, this.startPosition = t ? -1 : e, this.tick();
    } else
      this._forceStartLoad = !0, this.state = K.STOPPED;
  }
  stopLoad() {
    this._forceStartLoad = !1, super.stopLoad();
  }
  doTick() {
    switch (this.state) {
      case K.WAITING_LEVEL: {
        const {
          levels: t,
          level: n
        } = this, s = t?.[n], r = s?.details;
        if (r && (!r.live || this.levelLastLoaded === s && !this.waitForLive(s))) {
          if (this.waitForCdnTuneIn(r))
            break;
          this.state = K.IDLE;
          break;
        } else if (this.hls.nextLoadLevel !== this.level) {
          this.state = K.IDLE;
          break;
        }
        break;
      }
      case K.FRAG_LOADING_WAITING_RETRY:
        {
          var e;
          const t = self.performance.now(), n = this.retryDate;
          if (!n || t >= n || (e = this.media) != null && e.seeking) {
            const {
              levels: s,
              level: r
            } = this, a = s?.[r];
            this.resetStartWhenNotLoaded(a || null), this.state = K.IDLE;
          }
        }
        break;
    }
    this.state === K.IDLE && this.doTickIdle(), this.onTickEnd();
  }
  onTickEnd() {
    var e;
    super.onTickEnd(), (e = this.media) != null && e.readyState && this.media.seeking === !1 && (this.lastCurrentTime = this.media.currentTime), this.checkFragmentChanged();
  }
  doTickIdle() {
    const {
      hls: e,
      levelLastLoaded: t,
      levels: n,
      media: s
    } = this;
    if (t === null || !s && !this.primaryPrefetch && (this.startFragRequested || !e.config.startFragPrefetch) || this.altAudio && this.audioOnly)
      return;
    const r = this.buffering ? e.nextLoadLevel : e.loadLevel;
    if (!(n != null && n[r]))
      return;
    const a = n[r], o = this.getMainFwdBufferInfo();
    if (o === null)
      return;
    const l = this.getLevelDetails();
    if (l && this._streamEnded(o, l)) {
      const g = {};
      this.altAudio === 2 && (g.type = "video"), this.hls.trigger(S.BUFFER_EOS, g), this.state = K.ENDED;
      return;
    }
    if (!this.buffering)
      return;
    e.loadLevel !== r && e.manualLevel === -1 && this.log(`Adapting to level ${r} from level ${this.level}`), this.level = e.nextLoadLevel = r;
    const d = a.details;
    if (!d || this.state === K.WAITING_LEVEL || this.waitForLive(a)) {
      this.level = r, this.state = K.WAITING_LEVEL, this.startFragRequested = !1;
      return;
    }
    const c = o.len, u = this.getMaxBufferLength(a.maxBitrate);
    if (c >= u)
      return;
    this.backtrackFragment && this.backtrackFragment.start > o.end && (this.backtrackFragment = null);
    const f = this.backtrackFragment ? this.backtrackFragment.start : o.end;
    let h = this.getNextFragment(f, d);
    if (this.couldBacktrack && !this.fragPrevious && h && st(h) && this.fragmentTracker.getState(h) !== at.OK) {
      var m;
      const v = ((m = this.backtrackFragment) != null ? m : h).sn - d.startSN, p = d.fragments[v - 1];
      p && h.cc === p.cc && (h = p, this.fragmentTracker.removeFragment(p));
    } else this.backtrackFragment && o.len && (this.backtrackFragment = null);
    if (h && this.isLoopLoading(h, f)) {
      if (!h.gap) {
        const v = this.audioOnly && !this.altAudio ? ze.AUDIO : ze.VIDEO, p = (v === ze.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
        p && this.afterBufferFlushed(p, v, ce.MAIN);
      }
      h = this.getNextFragmentLoopLoading(h, d, o, ce.MAIN, u);
    }
    h && (h.initSegment && !h.initSegment.data && !this.bitrateTest && (h = h.initSegment), this.loadFragment(h, a, f));
  }
  loadFragment(e, t, n) {
    const s = this.fragmentTracker.getState(e);
    s === at.NOT_LOADED || s === at.PARTIAL ? st(e) ? this.bitrateTest ? (this.log(`Fragment ${e.sn} of level ${e.level} is being downloaded to test bitrate and will not be buffered`), this._loadBitrateTestFrag(e, t)) : super.loadFragment(e, t, n) : this._loadInitSegment(e, t) : this.clearTrackerIfNeeded(e);
  }
  getBufferedFrag(e) {
    return this.fragmentTracker.getBufferedFrag(e, ce.MAIN);
  }
  followingBufferedFrag(e) {
    return e ? this.getBufferedFrag(e.end + 0.5) : null;
  }
  /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */
  immediateLevelSwitch() {
    this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
  }
  /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */
  nextLevelSwitch() {
    const {
      levels: e,
      media: t
    } = this;
    if (t != null && t.readyState) {
      let n;
      const s = this.getAppendedFrag(t.currentTime);
      s && s.start > 1 && this.flushMainBuffer(0, s.start - 1);
      const r = this.getLevelDetails();
      if (r != null && r.live) {
        const o = this.getMainFwdBufferInfo();
        if (!o || o.len < r.targetduration * 2)
          return;
      }
      if (!t.paused && e) {
        const o = this.hls.nextLoadLevel, l = e[o], d = this.fragLastKbps;
        d && this.fragCurrent ? n = this.fragCurrent.duration * l.maxBitrate / (1e3 * d) + 1 : n = 0;
      } else
        n = 0;
      const a = this.getBufferedFrag(t.currentTime + n);
      if (a) {
        const o = this.followingBufferedFrag(a);
        if (o) {
          this.abortCurrentFrag();
          const l = o.maxStartPTS ? o.maxStartPTS : o.start, d = o.duration, c = Math.max(a.end, l + Math.min(Math.max(d - this.config.maxFragLookUpTolerance, d * (this.couldBacktrack ? 0.5 : 0.125)), d * (this.couldBacktrack ? 0.75 : 0.25)));
          this.flushMainBuffer(c, Number.POSITIVE_INFINITY);
        }
      }
    }
  }
  abortCurrentFrag() {
    const e = this.fragCurrent;
    switch (this.fragCurrent = null, this.backtrackFragment = null, e && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.state) {
      case K.KEY_LOADING:
      case K.FRAG_LOADING:
      case K.FRAG_LOADING_WAITING_RETRY:
      case K.PARSING:
      case K.PARSED:
        this.state = K.IDLE;
        break;
    }
    this.nextLoadPosition = this.getLoadPosition();
  }
  flushMainBuffer(e, t) {
    super.flushMainBuffer(e, t, this.altAudio === 2 ? "video" : null);
  }
  onMediaAttached(e, t) {
    super.onMediaAttached(e, t);
    const n = t.media;
    Vt(n, "playing", this.onMediaPlaying), Vt(n, "seeked", this.onMediaSeeked);
  }
  onMediaDetaching(e, t) {
    const {
      media: n
    } = this;
    n && (Yt(n, "playing", this.onMediaPlaying), Yt(n, "seeked", this.onMediaSeeked)), this.videoBuffer = null, this.fragPlaying = null, super.onMediaDetaching(e, t), !t.transferMedia && (this._hasEnoughToStart = !1);
  }
  onManifestLoading() {
    super.onManifestLoading(), this.log("Trigger BUFFER_RESET"), this.hls.trigger(S.BUFFER_RESET, void 0), this.couldBacktrack = !1, this.fragLastKbps = 0, this.fragPlaying = this.backtrackFragment = null, this.altAudio = 0, this.audioOnly = !1;
  }
  onManifestParsed(e, t) {
    let n = !1, s = !1;
    for (let r = 0; r < t.levels.length; r++) {
      const a = t.levels[r].audioCodec;
      a && (n = n || a.indexOf("mp4a.40.2") !== -1, s = s || a.indexOf("mp4a.40.5") !== -1);
    }
    this.audioCodecSwitch = n && s && !Mk(), this.audioCodecSwitch && this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = t.levels, this.startFragRequested = !1;
  }
  onLevelLoading(e, t) {
    const {
      levels: n
    } = this;
    if (!n || this.state !== K.IDLE)
      return;
    const s = t.levelInfo;
    (!s.details || s.details.live && (this.levelLastLoaded !== s || s.details.expired) || this.waitForCdnTuneIn(s.details)) && (this.state = K.WAITING_LEVEL);
  }
  onLevelLoaded(e, t) {
    var n;
    const {
      levels: s,
      startFragRequested: r
    } = this, a = t.level, o = t.details, l = o.totalduration;
    if (!s) {
      this.warn(`Levels were reset while loading level ${a}`);
      return;
    }
    this.log(`Level ${a} loaded [${o.startSN},${o.endSN}]${o.lastPartSn ? `[part-${o.lastPartSn}-${o.lastPartIndex}]` : ""}, cc [${o.startCC}, ${o.endCC}] duration:${l}`);
    const d = t.levelInfo, c = this.fragCurrent;
    c && (this.state === K.FRAG_LOADING || this.state === K.FRAG_LOADING_WAITING_RETRY) && c.level !== t.level && c.loader && this.abortCurrentFrag();
    let u = 0;
    if (o.live || (n = d.details) != null && n.live) {
      var f;
      if (this.checkLiveUpdate(o), o.deltaUpdateFailed)
        return;
      u = this.alignPlaylists(o, d.details, (f = this.levelLastLoaded) == null ? void 0 : f.details);
    }
    if (d.details = o, this.levelLastLoaded = d, r || this.setStartPosition(o, u), this.hls.trigger(S.LEVEL_UPDATED, {
      details: o,
      level: a
    }), this.state === K.WAITING_LEVEL) {
      if (this.waitForCdnTuneIn(o))
        return;
      this.state = K.IDLE;
    }
    r && o.live && this.synchronizeToLiveEdge(o), this.tick();
  }
  synchronizeToLiveEdge(e) {
    const {
      config: t,
      media: n
    } = this;
    if (!n)
      return;
    const s = this.hls.liveSyncPosition, r = this.getLoadPosition(), a = e.fragmentStart, o = e.edge, l = r >= a - t.maxFragLookUpTolerance && r <= o;
    if (s !== null && n.duration > s && (r < s || !l)) {
      const c = t.liveMaxLatencyDuration !== void 0 ? t.liveMaxLatencyDuration : t.liveMaxLatencyDurationCount * e.targetduration;
      if ((!l && n.readyState < 4 || r < o - c) && (this._hasEnoughToStart || (this.nextLoadPosition = s), n.readyState))
        if (this.warn(`Playback: ${r.toFixed(3)} is located too far from the end of live sliding playlist: ${o}, reset currentTime to : ${s.toFixed(3)}`), this.config.liveSyncMode === "buffered") {
          var d;
          const u = Te.bufferInfo(n, s, 0);
          if (!((d = u.buffered) != null && d.length)) {
            n.currentTime = s;
            return;
          }
          if (u.start <= r) {
            n.currentTime = s;
            return;
          }
          const {
            nextStart: h
          } = Te.bufferedInfo(u.buffered, r, 0);
          h && (n.currentTime = h);
        } else
          n.currentTime = s;
    }
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const n = e.frag, {
      part: s,
      payload: r
    } = e, {
      levels: a
    } = this;
    if (!a) {
      this.warn(`Levels were reset while fragment load was in progress. Fragment ${n.sn} of level ${n.level} will not be buffered`);
      return;
    }
    const o = a[n.level];
    if (!o) {
      this.warn(`Level ${n.level} not found on progress`);
      return;
    }
    const l = o.details;
    if (!l) {
      this.warn(`Dropping fragment ${n.sn} of level ${n.level} after level details were reset`), this.fragmentTracker.removeFragment(n);
      return;
    }
    const d = o.videoCodec, c = l.PTSKnown || !l.live, u = (t = n.initSegment) == null ? void 0 : t.data, f = this._getAudioCodec(o), h = this.transmuxer = this.transmuxer || new Xh(this.hls, ce.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)), m = s ? s.index : -1, g = m !== -1, v = new xl(n.level, n.sn, n.stats.chunkCount, r.byteLength, m, g), p = this.initPTS[n.cc];
    h.push(r, u, f, d, n, s, l.totalduration, c, v, p);
  }
  onAudioTrackSwitching(e, t) {
    const n = this.hls, s = this.altAudio === 2;
    if (Pr(t.url, n))
      this.altAudio = 1;
    else {
      if (this.mediaBuffer !== this.media) {
        this.log("Switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
        const a = this.fragCurrent;
        a && (this.log("Switching to main audio track, cancel main fragment load"), a.abortRequests(), this.fragmentTracker.removeFragment(a)), this.resetTransmuxer(), this.resetLoadingState();
      } else this.audioOnly && this.resetTransmuxer();
      if (s) {
        this.fragmentTracker.removeAllFragments(), n.once(S.BUFFER_FLUSHED, () => {
          this.hls && this.hls.trigger(S.AUDIO_TRACK_SWITCHED, t);
        }), n.trigger(S.BUFFER_FLUSHING, {
          startOffset: 0,
          endOffset: Number.POSITIVE_INFINITY,
          type: null
        });
        return;
      }
      n.trigger(S.AUDIO_TRACK_SWITCHED, t);
    }
  }
  onAudioTrackSwitched(e, t) {
    const n = Pr(t.url, this.hls);
    if (n) {
      const s = this.videoBuffer;
      s && this.mediaBuffer !== s && (this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = s);
    }
    this.altAudio = n ? 2 : 0, this.tick();
  }
  onBufferCreated(e, t) {
    const n = t.tracks;
    let s, r, a = !1;
    for (const o in n) {
      const l = n[o];
      if (l.id === "main") {
        if (r = o, s = l, o === "video") {
          const d = n[o];
          d && (this.videoBuffer = d.buffer);
        }
      } else
        a = !0;
    }
    a && s ? (this.log(`Alternate track found, use ${r}.buffered to schedule main fragment loading`), this.mediaBuffer = s.buffer) : this.mediaBuffer = this.media;
  }
  onFragBuffered(e, t) {
    const {
      frag: n,
      part: s
    } = t, r = n.type === ce.MAIN;
    if (r) {
      if (this.fragContextChanged(n)) {
        this.warn(`Fragment ${n.sn}${s ? " p: " + s.index : ""} of level ${n.level} finished buffering, but was aborted. state: ${this.state}`), this.state === K.PARSED && (this.state = K.IDLE);
        return;
      }
      const o = s ? s.stats : n.stats;
      this.fragLastKbps = Math.round(8 * o.total / (o.buffering.end - o.loading.first)), st(n) && (this.fragPrevious = n), this.fragBufferedComplete(n, s);
    }
    const a = this.media;
    a && (!this._hasEnoughToStart && Te.getBuffered(a).length && (this._hasEnoughToStart = !0, this.seekToStartPos()), r && this.tick());
  }
  get hasEnoughToStart() {
    return this._hasEnoughToStart;
  }
  onError(e, t) {
    var n;
    if (t.fatal) {
      this.state = K.ERROR;
      return;
    }
    switch (t.details) {
      case B.FRAG_GAP:
      case B.FRAG_PARSING_ERROR:
      case B.FRAG_DECRYPT_ERROR:
      case B.FRAG_LOAD_ERROR:
      case B.FRAG_LOAD_TIMEOUT:
      case B.KEY_LOAD_ERROR:
      case B.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(ce.MAIN, t);
        break;
      case B.LEVEL_LOAD_ERROR:
      case B.LEVEL_LOAD_TIMEOUT:
      case B.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === K.WAITING_LEVEL && ((n = t.context) == null ? void 0 : n.type) === Le.LEVEL && (this.state = K.IDLE);
        break;
      case B.BUFFER_ADD_CODEC_ERROR:
      case B.BUFFER_APPEND_ERROR:
        if (t.parent !== "main")
          return;
        this.reduceLengthAndFlushBuffer(t) && this.resetLoadingState();
        break;
      case B.BUFFER_FULL_ERROR:
        if (t.parent !== "main")
          return;
        this.reduceLengthAndFlushBuffer(t) && (!this.config.interstitialsController && this.config.assetPlayerId ? this._hasEnoughToStart = !0 : this.flushMainBuffer(0, Number.POSITIVE_INFINITY));
        break;
      case B.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  onFragLoadEmergencyAborted() {
    this.state = K.IDLE, this._hasEnoughToStart || (this.startFragRequested = !1, this.nextLoadPosition = this.lastCurrentTime), this.tickImmediate();
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t !== ze.AUDIO || !this.altAudio) {
      const n = (t === ze.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
      n && (this.afterBufferFlushed(n, t, ce.MAIN), this.tick());
    }
  }
  onLevelsUpdated(e, t) {
    this.level > -1 && this.fragCurrent && (this.level = this.fragCurrent.level, this.level === -1 && this.resetWhenMissingContext(this.fragCurrent)), this.levels = t.levels;
  }
  swapAudioCodec() {
    this.audioCodecSwap = !this.audioCodecSwap;
  }
  /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */
  seekToStartPos() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.currentTime;
    let n = this.startPosition;
    if (n >= 0 && t < n) {
      if (e.seeking) {
        this.log(`could not seek to ${n}, already seeking at ${t}`);
        return;
      }
      const s = this.timelineOffset;
      s && n && (n += s);
      const r = this.getLevelDetails(), a = Te.getBuffered(e), o = a.length ? a.start(0) : 0, l = o - n, d = Math.max(this.config.maxBufferHole, this.config.maxFragLookUpTolerance);
      (this.config.startOnSegmentBoundary || l > 0 && (l < d || this.loadingParts && l < 2 * (r?.partTarget || 0))) && (this.log(`adjusting start position by ${l} to match buffer start`), n += l, this.startPosition = n), t < n && (this.log(`seek to target start position ${n} from current time ${t} buffer start ${o}`), e.currentTime = n);
    }
  }
  _getAudioCodec(e) {
    let t = this.config.defaultAudioCodec || e.audioCodec;
    return this.audioCodecSwap && t && (this.log("Swapping audio codec"), t.indexOf("mp4a.40.5") !== -1 ? t = "mp4a.40.2" : t = "mp4a.40.5"), t;
  }
  _loadBitrateTestFrag(e, t) {
    e.bitrateTest = !0, this._doFragLoad(e, t).then((n) => {
      const {
        hls: s
      } = this, r = n?.frag;
      if (!r || this.fragContextChanged(r))
        return;
      t.fragmentError = 0, this.state = K.IDLE, this.startFragRequested = !1, this.bitrateTest = !1;
      const a = r.stats;
      a.parsing.start = a.parsing.end = a.buffering.start = a.buffering.end = self.performance.now(), s.trigger(S.FRAG_LOADED, n), r.bitrateTest = !1;
    });
  }
  _handleTransmuxComplete(e) {
    const t = this.playlistType, {
      hls: n
    } = this, {
      remuxResult: s,
      chunkMeta: r
    } = e, a = this.getCurrentContext(r);
    if (!a) {
      this.resetWhenMissingContext(r);
      return;
    }
    const {
      frag: o,
      part: l,
      level: d
    } = a, {
      video: c,
      text: u,
      id3: f,
      initSegment: h
    } = s, {
      details: m
    } = d, g = this.altAudio ? void 0 : s.audio;
    if (this.fragContextChanged(o)) {
      this.fragmentTracker.removeFragment(o);
      return;
    }
    if (this.state = K.PARSING, h) {
      const v = h.tracks;
      if (v) {
        const k = o.initSegment || o;
        if (this.unhandledEncryptionError(h, o))
          return;
        this._bufferInitSegment(d, v, k, r), n.trigger(S.FRAG_PARSING_INIT_SEGMENT, {
          frag: k,
          id: t,
          tracks: v
        });
      }
      const p = h.initPTS, y = h.timescale, b = this.initPTS[o.cc];
      if (ae(p) && (!b || b.baseTime !== p || b.timescale !== y)) {
        const k = h.trackId;
        this.initPTS[o.cc] = {
          baseTime: p,
          timescale: y,
          trackId: k
        }, n.trigger(S.INIT_PTS_FOUND, {
          frag: o,
          id: t,
          initPTS: p,
          timescale: y,
          trackId: k
        });
      }
    }
    if (c && m) {
      g && c.type === "audiovideo" && this.logMuxedErr(o);
      const v = m.fragments[o.sn - 1 - m.startSN], p = o.sn === m.startSN, y = !v || o.cc > v.cc;
      if (s.independent !== !1) {
        const {
          startPTS: b,
          endPTS: k,
          startDTS: T,
          endDTS: I
        } = c;
        if (l)
          l.elementaryStreams[c.type] = {
            startPTS: b,
            endPTS: k,
            startDTS: T,
            endDTS: I
          };
        else if (c.firstKeyFrame && c.independent && r.id === 1 && !y && (this.couldBacktrack = !0), c.dropped && c.independent) {
          const x = this.getMainFwdBufferInfo(), E = (x ? x.end : this.getLoadPosition()) + this.config.maxBufferHole, R = c.firstKeyFramePTS ? c.firstKeyFramePTS : b;
          if (!p && E < R - this.config.maxBufferHole && !y) {
            this.backtrack(o);
            return;
          } else y && (o.gap = !0);
          o.setElementaryStreamInfo(c.type, o.start, k, o.start, I, !0);
        } else p && b - (m.appliedTimelineOffset || 0) > vr && (o.gap = !0);
        o.setElementaryStreamInfo(c.type, b, k, T, I), this.backtrackFragment && (this.backtrackFragment = o), this.bufferFragmentData(c, o, l, r, p || y);
      } else if (p || y)
        o.gap = !0;
      else {
        this.backtrack(o);
        return;
      }
    }
    if (g) {
      const {
        startPTS: v,
        endPTS: p,
        startDTS: y,
        endDTS: b
      } = g;
      l && (l.elementaryStreams[ze.AUDIO] = {
        startPTS: v,
        endPTS: p,
        startDTS: y,
        endDTS: b
      }), o.setElementaryStreamInfo(ze.AUDIO, v, p, y, b), this.bufferFragmentData(g, o, l, r);
    }
    if (m && f != null && f.samples.length) {
      const v = {
        id: t,
        frag: o,
        details: m,
        samples: f.samples
      };
      n.trigger(S.FRAG_PARSING_METADATA, v);
    }
    if (m && u) {
      const v = {
        id: t,
        frag: o,
        details: m,
        samples: u.samples
      };
      n.trigger(S.FRAG_PARSING_USERDATA, v);
    }
  }
  logMuxedErr(e) {
    this.warn(`${st(e) ? "Media" : "Init"} segment with muxed audiovideo where only video expected: ${e.url}`);
  }
  _bufferInitSegment(e, t, n, s) {
    if (this.state !== K.PARSING)
      return;
    this.audioOnly = !!t.audio && !t.video, this.altAudio && !this.audioOnly && (delete t.audio, t.audiovideo && this.logMuxedErr(n));
    const {
      audio: r,
      video: a,
      audiovideo: o
    } = t;
    if (r) {
      const d = e.audioCodec;
      let c = cr(r.codec, d);
      c === "mp4a" && (c = "mp4a.40.5");
      const u = navigator.userAgent.toLowerCase();
      if (this.audioCodecSwitch) {
        c && (c.indexOf("mp4a.40.5") !== -1 ? c = "mp4a.40.2" : c = "mp4a.40.5");
        const f = r.metadata;
        f && "channelCount" in f && (f.channelCount || 1) !== 1 && u.indexOf("firefox") === -1 && (c = "mp4a.40.5");
      }
      c && c.indexOf("mp4a.40.5") !== -1 && u.indexOf("android") !== -1 && r.container !== "audio/mpeg" && (c = "mp4a.40.2", this.log(`Android: force audio codec to ${c}`)), d && d !== c && this.log(`Swapping manifest audio codec "${d}" for "${c}"`), r.levelCodec = c, r.id = ce.MAIN, this.log(`Init audio buffer, container:${r.container}, codecs[selected/level/parsed]=[${c || ""}/${d || ""}/${r.codec}]`), delete t.audiovideo;
    }
    if (a) {
      a.levelCodec = e.videoCodec, a.id = ce.MAIN;
      const d = a.codec;
      if (d?.length === 4)
        switch (d) {
          case "hvc1":
          case "hev1":
            a.codec = "hvc1.1.6.L120.90";
            break;
          case "av01":
            a.codec = "av01.0.04M.08";
            break;
          case "avc1":
            a.codec = "avc1.42e01e";
            break;
        }
      this.log(`Init video buffer, container:${a.container}, codecs[level/parsed]=[${e.videoCodec || ""}/${d}]${a.codec !== d ? " parsed-corrected=" + a.codec : ""}${a.supplemental ? " supplemental=" + a.supplemental : ""}`), delete t.audiovideo;
    }
    o && (this.log(`Init audiovideo buffer, container:${o.container}, codecs[level/parsed]=[${e.codecs}/${o.codec}]`), delete t.video, delete t.audio);
    const l = Object.keys(t);
    if (l.length) {
      if (this.hls.trigger(S.BUFFER_CODECS, t), !this.hls)
        return;
      l.forEach((d) => {
        const u = t[d].initSegment;
        u != null && u.byteLength && this.hls.trigger(S.BUFFER_APPENDING, {
          type: d,
          data: u,
          frag: n,
          part: null,
          chunkMeta: s,
          parent: n.type
        });
      });
    }
    this.tickImmediate();
  }
  getMainFwdBufferInfo() {
    const e = this.mediaBuffer && this.altAudio === 2 ? this.mediaBuffer : this.media;
    return this.getFwdBufferInfo(e, ce.MAIN);
  }
  get maxBufferLength() {
    const {
      levels: e,
      level: t
    } = this, n = e?.[t];
    return n ? this.getMaxBufferLength(n.maxBitrate) : this.config.maxBufferLength;
  }
  backtrack(e) {
    this.couldBacktrack = !0, this.backtrackFragment = e, this.resetTransmuxer(), this.flushBufferGap(e), this.fragmentTracker.removeFragment(e), this.fragPrevious = null, this.nextLoadPosition = e.start, this.state = K.IDLE;
  }
  checkFragmentChanged() {
    const e = this.media;
    let t = null;
    if (e && e.readyState > 1 && e.seeking === !1) {
      const n = e.currentTime;
      if (Te.isBuffered(e, n) ? t = this.getAppendedFrag(n) : Te.isBuffered(e, n + 0.1) && (t = this.getAppendedFrag(n + 0.1)), t) {
        this.backtrackFragment = null;
        const s = this.fragPlaying, r = t.level;
        (!s || t.sn !== s.sn || s.level !== r) && (this.fragPlaying = t, this.hls.trigger(S.FRAG_CHANGED, {
          frag: t
        }), (!s || s.level !== r) && this.hls.trigger(S.LEVEL_SWITCHED, {
          level: r
        }));
      }
    }
  }
  get nextLevel() {
    const e = this.nextBufferedFrag;
    return e ? e.level : -1;
  }
  get currentFrag() {
    var e;
    if (this.fragPlaying)
      return this.fragPlaying;
    const t = ((e = this.media) == null ? void 0 : e.currentTime) || this.lastCurrentTime;
    return ae(t) ? this.getAppendedFrag(t) : null;
  }
  get currentProgramDateTime() {
    var e;
    const t = ((e = this.media) == null ? void 0 : e.currentTime) || this.lastCurrentTime;
    if (ae(t)) {
      const n = this.getLevelDetails(), s = this.currentFrag || (n ? Sn(null, n.fragments, t) : null);
      if (s) {
        const r = s.programDateTime;
        if (r !== null) {
          const a = r + (t - s.start) * 1e3;
          return new Date(a);
        }
      }
    }
    return null;
  }
  get currentLevel() {
    const e = this.currentFrag;
    return e ? e.level : -1;
  }
  get nextBufferedFrag() {
    const e = this.currentFrag;
    return e ? this.followingBufferedFrag(e) : null;
  }
  get forceStartLoad() {
    return this._forceStartLoad;
  }
}
class $k {
  constructor(e) {
    this.config = void 0, this.keyUriToKeyInfo = {}, this.emeController = null, this.config = e;
  }
  abort(e) {
    for (const n in this.keyUriToKeyInfo) {
      const s = this.keyUriToKeyInfo[n].loader;
      if (s) {
        var t;
        if (e && e !== ((t = s.context) == null ? void 0 : t.frag.type))
          return;
        s.abort();
      }
    }
  }
  detach() {
    for (const e in this.keyUriToKeyInfo) {
      const t = this.keyUriToKeyInfo[e];
      (t.mediaKeySessionContext || t.decryptdata.isCommonEncryption) && delete this.keyUriToKeyInfo[e];
    }
  }
  destroy() {
    this.detach();
    for (const e in this.keyUriToKeyInfo) {
      const t = this.keyUriToKeyInfo[e].loader;
      t && t.destroy();
    }
    this.keyUriToKeyInfo = {};
  }
  createKeyLoadError(e, t = B.KEY_LOAD_ERROR, n, s, r) {
    return new Li({
      type: pe.NETWORK_ERROR,
      details: t,
      fatal: !1,
      frag: e,
      response: r,
      error: n,
      networkDetails: s
    });
  }
  loadClear(e, t, n) {
    if (this.emeController && this.config.emeEnabled && !this.emeController.getSelectedKeySystemFormats().length) {
      if (t.length)
        for (let s = 0, r = t.length; s < r; s++) {
          const a = t[s];
          if (e.cc <= a.cc && (!st(e) || !st(a) || e.sn < a.sn) || !n && s == r - 1)
            return this.emeController.selectKeySystemFormat(a).then((o) => {
              if (!this.emeController)
                return;
              a.setKeyFormat(o);
              const l = fr(o);
              if (l)
                return this.emeController.getKeySystemAccess([l]);
            });
        }
      if (this.config.requireKeySystemAccessOnStart) {
        const s = is(this.config);
        if (s.length)
          return this.emeController.getKeySystemAccess(s);
      }
    }
    return null;
  }
  load(e) {
    return !e.decryptdata && e.encrypted && this.emeController && this.config.emeEnabled ? this.emeController.selectKeySystemFormat(e).then((t) => this.loadInternal(e, t)) : this.loadInternal(e);
  }
  loadInternal(e, t) {
    var n, s;
    t && e.setKeyFormat(t);
    const r = e.decryptdata;
    if (!r) {
      const d = new Error(t ? `Expected frag.decryptdata to be defined after setting format ${t}` : "Missing decryption data on fragment in onKeyLoading");
      return Promise.reject(this.createKeyLoadError(e, B.KEY_LOAD_ERROR, d));
    }
    const a = r.uri;
    if (!a)
      return Promise.reject(this.createKeyLoadError(e, B.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${a}"`)));
    let o = this.keyUriToKeyInfo[a];
    if ((n = o) != null && n.decryptdata.key)
      return r.key = o.decryptdata.key, Promise.resolve({
        frag: e,
        keyInfo: o
      });
    if ((s = o) != null && s.keyLoadPromise) {
      var l;
      switch ((l = o.mediaKeySessionContext) == null ? void 0 : l.keyStatus) {
        case void 0:
        case "status-pending":
        case "usable":
        case "usable-in-future":
          return o.keyLoadPromise.then((d) => (r.key = d.keyInfo.decryptdata.key, {
            frag: e,
            keyInfo: o
          }));
      }
    }
    switch (o = this.keyUriToKeyInfo[a] = {
      decryptdata: r,
      keyLoadPromise: null,
      loader: null,
      mediaKeySessionContext: null
    }, r.method) {
      case "ISO-23001-7":
      case "SAMPLE-AES":
      case "SAMPLE-AES-CENC":
      case "SAMPLE-AES-CTR":
        return r.keyFormat === "identity" ? this.loadKeyHTTP(o, e) : this.loadKeyEME(o, e);
      case "AES-128":
      case "AES-256":
      case "AES-256-CTR":
        return this.loadKeyHTTP(o, e);
      default:
        return Promise.reject(this.createKeyLoadError(e, B.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${r.method}"`)));
    }
  }
  loadKeyEME(e, t) {
    const n = {
      frag: t,
      keyInfo: e
    };
    if (this.emeController && this.config.emeEnabled) {
      const s = this.emeController.loadKey(n);
      if (s)
        return (e.keyLoadPromise = s.then((r) => (e.mediaKeySessionContext = r, n))).catch((r) => {
          throw e.keyLoadPromise = null, r;
        });
    }
    return Promise.resolve(n);
  }
  loadKeyHTTP(e, t) {
    const n = this.config, s = n.loader, r = new s(n);
    return t.keyLoader = e.loader = r, e.keyLoadPromise = new Promise((a, o) => {
      const l = {
        keyInfo: e,
        frag: t,
        responseType: "arraybuffer",
        url: e.decryptdata.uri
      }, d = n.keyLoadPolicy.default, c = {
        loadPolicy: d,
        timeout: d.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, u = {
        onSuccess: (f, h, m, g) => {
          const {
            frag: v,
            keyInfo: p,
            url: y
          } = m;
          if (!v.decryptdata || p !== this.keyUriToKeyInfo[y])
            return o(this.createKeyLoadError(v, B.KEY_LOAD_ERROR, new Error("after key load, decryptdata unset or changed"), g));
          p.decryptdata.key = v.decryptdata.key = new Uint8Array(f.data), v.keyLoader = null, p.loader = null, a({
            frag: v,
            keyInfo: p
          });
        },
        onError: (f, h, m, g) => {
          this.resetLoader(h), o(this.createKeyLoadError(t, B.KEY_LOAD_ERROR, new Error(`HTTP Error ${f.code} loading key ${f.text}`), m, Ve({
            url: l.url,
            data: void 0
          }, f)));
        },
        onTimeout: (f, h, m) => {
          this.resetLoader(h), o(this.createKeyLoadError(t, B.KEY_LOAD_TIMEOUT, new Error("key loading timed out"), m));
        },
        onAbort: (f, h, m) => {
          this.resetLoader(h), o(this.createKeyLoadError(t, B.INTERNAL_ABORTED, new Error("key loading aborted"), m));
        }
      };
      r.load(l, c, u);
    });
  }
  resetLoader(e) {
    const {
      frag: t,
      keyInfo: n,
      url: s
    } = e, r = n.loader;
    t.keyLoader === r && (t.keyLoader = null, n.loader = null), delete this.keyUriToKeyInfo[s], r && r.destroy();
  }
}
function fu(i) {
  const {
    type: e
  } = i;
  switch (e) {
    case Le.AUDIO_TRACK:
      return ce.AUDIO;
    case Le.SUBTITLE_TRACK:
      return ce.SUBTITLE;
    default:
      return ce.MAIN;
  }
}
function eo(i, e) {
  let t = i.url;
  return (t === void 0 || t.indexOf("data:") === 0) && (t = e.url), t;
}
class Bk {
  constructor(e) {
    this.hls = void 0, this.loaders = /* @__PURE__ */ Object.create(null), this.variableList = null, this.onManifestLoaded = this.checkAutostartLoad, this.hls = e, this.registerListeners();
  }
  startLoad(e) {
  }
  stopLoad() {
    this.destroyInternalLoaders();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(S.MANIFEST_LOADING, this.onManifestLoading, this), e.on(S.LEVEL_LOADING, this.onLevelLoading, this), e.on(S.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.on(S.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this), e.on(S.LEVELS_UPDATED, this.onLevelsUpdated, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(S.MANIFEST_LOADING, this.onManifestLoading, this), e.off(S.LEVEL_LOADING, this.onLevelLoading, this), e.off(S.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.off(S.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this), e.off(S.LEVELS_UPDATED, this.onLevelsUpdated, this);
  }
  /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */
  createInternalLoader(e) {
    const t = this.hls.config, n = t.pLoader, s = t.loader, r = n || s, a = new r(t);
    return this.loaders[e.type] = a, a;
  }
  getInternalLoader(e) {
    return this.loaders[e.type];
  }
  resetInternalLoader(e) {
    this.loaders[e] && delete this.loaders[e];
  }
  /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */
  destroyInternalLoaders() {
    for (const e in this.loaders) {
      const t = this.loaders[e];
      t && t.destroy(), this.resetInternalLoader(e);
    }
  }
  destroy() {
    this.variableList = null, this.unregisterListeners(), this.destroyInternalLoaders();
  }
  onManifestLoading(e, t) {
    const {
      url: n
    } = t;
    this.variableList = null, this.load({
      id: null,
      level: 0,
      responseType: "text",
      type: Le.MANIFEST,
      url: n,
      deliveryDirectives: null,
      levelOrTrack: null
    });
  }
  onLevelLoading(e, t) {
    const {
      id: n,
      level: s,
      pathwayId: r,
      url: a,
      deliveryDirectives: o,
      levelInfo: l
    } = t;
    this.load({
      id: n,
      level: s,
      pathwayId: r,
      responseType: "text",
      type: Le.LEVEL,
      url: a,
      deliveryDirectives: o,
      levelOrTrack: l
    });
  }
  onAudioTrackLoading(e, t) {
    const {
      id: n,
      groupId: s,
      url: r,
      deliveryDirectives: a,
      track: o
    } = t;
    this.load({
      id: n,
      groupId: s,
      level: null,
      responseType: "text",
      type: Le.AUDIO_TRACK,
      url: r,
      deliveryDirectives: a,
      levelOrTrack: o
    });
  }
  onSubtitleTrackLoading(e, t) {
    const {
      id: n,
      groupId: s,
      url: r,
      deliveryDirectives: a,
      track: o
    } = t;
    this.load({
      id: n,
      groupId: s,
      level: null,
      responseType: "text",
      type: Le.SUBTITLE_TRACK,
      url: r,
      deliveryDirectives: a,
      levelOrTrack: o
    });
  }
  onLevelsUpdated(e, t) {
    const n = this.loaders[Le.LEVEL];
    if (n) {
      const s = n.context;
      s && !t.levels.some((r) => r === s.levelOrTrack) && (n.abort(), delete this.loaders[Le.LEVEL]);
    }
  }
  load(e) {
    var t;
    const n = this.hls.config;
    let s = this.getInternalLoader(e);
    if (s) {
      const d = this.hls.logger, c = s.context;
      if (c && c.levelOrTrack === e.levelOrTrack && (c.url === e.url || c.deliveryDirectives && !e.deliveryDirectives)) {
        c.url === e.url ? d.log(`[playlist-loader]: ignore ${e.url} ongoing request`) : d.log(`[playlist-loader]: ignore ${e.url} in favor of ${c.url}`);
        return;
      }
      d.log(`[playlist-loader]: aborting previous loader for type: ${e.type}`), s.abort();
    }
    let r;
    if (e.type === Le.MANIFEST ? r = n.manifestLoadPolicy.default : r = He({}, n.playlistLoadPolicy.default, {
      timeoutRetry: null,
      errorRetry: null
    }), s = this.createInternalLoader(e), ae((t = e.deliveryDirectives) == null ? void 0 : t.part)) {
      let d;
      if (e.type === Le.LEVEL && e.level !== null ? d = this.hls.levels[e.level].details : e.type === Le.AUDIO_TRACK && e.id !== null ? d = this.hls.audioTracks[e.id].details : e.type === Le.SUBTITLE_TRACK && e.id !== null && (d = this.hls.subtitleTracks[e.id].details), d) {
        const c = d.partTarget, u = d.targetduration;
        if (c && u) {
          const f = Math.max(c * 3, u * 0.8) * 1e3;
          r = He({}, r, {
            maxTimeToFirstByteMs: Math.min(f, r.maxTimeToFirstByteMs),
            maxLoadTimeMs: Math.min(f, r.maxTimeToFirstByteMs)
          });
        }
      }
    }
    const a = r.errorRetry || r.timeoutRetry || {}, o = {
      loadPolicy: r,
      timeout: r.maxLoadTimeMs,
      maxRetry: a.maxNumRetry || 0,
      retryDelay: a.retryDelayMs || 0,
      maxRetryDelay: a.maxRetryDelayMs || 0
    }, l = {
      onSuccess: (d, c, u, f) => {
        const h = this.getInternalLoader(u);
        this.resetInternalLoader(u.type);
        const m = d.data;
        if (m.indexOf("#EXTM3U") !== 0) {
          this.handleManifestParsingError(d, u, new Error("no EXTM3U delimiter"), f || null, c);
          return;
        }
        c.parsing.start = performance.now(), hi.isMediaPlaylist(m) || u.type !== Le.MANIFEST ? this.handleTrackOrLevelPlaylist(d, c, u, f || null, h) : this.handleMasterPlaylist(d, c, u, f);
      },
      onError: (d, c, u, f) => {
        this.handleNetworkError(c, u, !1, d, f);
      },
      onTimeout: (d, c, u) => {
        this.handleNetworkError(c, u, !0, void 0, d);
      }
    };
    s.load(e, o, l);
  }
  checkAutostartLoad() {
    if (!this.hls)
      return;
    const {
      config: {
        autoStartLoad: e,
        startPosition: t
      },
      forceStartLoad: n
    } = this.hls;
    (e || n) && (this.hls.logger.log(`${e ? "auto" : "force"} startLoad with configured startPosition ${t}`), this.hls.startLoad(t));
  }
  handleMasterPlaylist(e, t, n, s) {
    const r = this.hls, a = e.data, o = eo(e, n), l = hi.parseMasterPlaylist(a, o);
    if (l.playlistParsingError) {
      this.handleManifestParsingError(e, n, l.playlistParsingError, s, t);
      return;
    }
    const {
      contentSteering: d,
      levels: c,
      sessionData: u,
      sessionKeys: f,
      startTimeOffset: h,
      variableList: m
    } = l;
    this.variableList = m;
    const {
      AUDIO: g = [],
      SUBTITLES: v,
      "CLOSED-CAPTIONS": p
    } = hi.parseMasterPlaylistMedia(a, o, l);
    g.length && !g.some((b) => !b.url) && c[0].audioCodec && !c[0].attrs.AUDIO && (this.hls.logger.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"), g.unshift({
      type: "main",
      name: "main",
      groupId: "main",
      default: !1,
      autoselect: !1,
      forced: !1,
      id: -1,
      attrs: new Ye({}),
      bitrate: 0,
      url: ""
    })), r.trigger(S.MANIFEST_LOADED, {
      levels: c,
      audioTracks: g,
      subtitles: v,
      captions: p,
      contentSteering: d,
      url: o,
      stats: t,
      networkDetails: s,
      sessionData: u,
      sessionKeys: f,
      startTimeOffset: h,
      variableList: m
    });
  }
  handleTrackOrLevelPlaylist(e, t, n, s, r) {
    const a = this.hls, {
      id: o,
      level: l,
      type: d
    } = n, c = eo(e, n), u = ae(l) ? l : ae(o) ? o : 0, f = fu(n), h = hi.parseLevelPlaylist(e.data, c, u, f, 0, this.variableList);
    if (d === Le.MANIFEST) {
      const m = {
        attrs: new Ye({}),
        bitrate: 0,
        details: h,
        name: "",
        url: c
      };
      h.requestScheduled = t.loading.start + _h(h, 0), a.trigger(S.MANIFEST_LOADED, {
        levels: [m],
        audioTracks: [],
        url: c,
        stats: t,
        networkDetails: s,
        sessionData: null,
        sessionKeys: null,
        contentSteering: null,
        startTimeOffset: null,
        variableList: null
      });
    }
    t.parsing.end = performance.now(), n.levelDetails = h, this.handlePlaylistLoaded(h, e, t, n, s, r);
  }
  handleManifestParsingError(e, t, n, s, r) {
    this.hls.trigger(S.ERROR, {
      type: pe.NETWORK_ERROR,
      details: B.MANIFEST_PARSING_ERROR,
      fatal: t.type === Le.MANIFEST,
      url: e.url,
      err: n,
      error: n,
      reason: n.message,
      response: e,
      context: t,
      networkDetails: s,
      stats: r
    });
  }
  handleNetworkError(e, t, n = !1, s, r) {
    let a = `A network ${n ? "timeout" : "error" + (s ? " (status " + s.code + ")" : "")} occurred while loading ${e.type}`;
    e.type === Le.LEVEL ? a += `: ${e.level} id: ${e.id}` : (e.type === Le.AUDIO_TRACK || e.type === Le.SUBTITLE_TRACK) && (a += ` id: ${e.id} group-id: "${e.groupId}"`);
    const o = new Error(a);
    this.hls.logger.warn(`[playlist-loader]: ${a}`);
    let l = B.UNKNOWN, d = !1;
    const c = this.getInternalLoader(e);
    switch (e.type) {
      case Le.MANIFEST:
        l = n ? B.MANIFEST_LOAD_TIMEOUT : B.MANIFEST_LOAD_ERROR, d = !0;
        break;
      case Le.LEVEL:
        l = n ? B.LEVEL_LOAD_TIMEOUT : B.LEVEL_LOAD_ERROR, d = !1;
        break;
      case Le.AUDIO_TRACK:
        l = n ? B.AUDIO_TRACK_LOAD_TIMEOUT : B.AUDIO_TRACK_LOAD_ERROR, d = !1;
        break;
      case Le.SUBTITLE_TRACK:
        l = n ? B.SUBTITLE_TRACK_LOAD_TIMEOUT : B.SUBTITLE_LOAD_ERROR, d = !1;
        break;
    }
    c && this.resetInternalLoader(e.type);
    const u = {
      type: pe.NETWORK_ERROR,
      details: l,
      fatal: d,
      url: e.url,
      loader: c,
      context: e,
      error: o,
      networkDetails: t,
      stats: r
    };
    if (s) {
      const f = t?.url || e.url;
      u.response = Ve({
        url: f,
        data: void 0
      }, s);
    }
    this.hls.trigger(S.ERROR, u);
  }
  handlePlaylistLoaded(e, t, n, s, r, a) {
    const o = this.hls, {
      type: l,
      level: d,
      id: c,
      groupId: u,
      deliveryDirectives: f
    } = s, h = eo(t, s), m = fu(s), g = typeof s.level == "number" && m === ce.MAIN ? d : void 0;
    if (!e.fragments.length) {
      const p = e.playlistParsingError = new Error("No Segments found in Playlist");
      o.trigger(S.ERROR, {
        type: pe.NETWORK_ERROR,
        details: B.LEVEL_EMPTY_ERROR,
        fatal: !1,
        url: h,
        error: p,
        reason: p.message,
        response: t,
        context: s,
        level: g,
        parent: m,
        networkDetails: r,
        stats: n
      });
      return;
    }
    e.targetduration || (e.playlistParsingError = new Error("Missing Target Duration"));
    const v = e.playlistParsingError;
    if (v) {
      if (this.hls.logger.warn(`${v} ${e.url}`), !o.config.ignorePlaylistParsingErrors) {
        o.trigger(S.ERROR, {
          type: pe.NETWORK_ERROR,
          details: B.LEVEL_PARSING_ERROR,
          fatal: !1,
          url: h,
          error: v,
          reason: v.message,
          response: t,
          context: s,
          level: g,
          parent: m,
          networkDetails: r,
          stats: n
        });
        return;
      }
      e.playlistParsingError = null;
    }
    switch (e.live && a && (a.getCacheAge && (e.ageHeader = a.getCacheAge() || 0), (!a.getCacheAge || isNaN(e.ageHeader)) && (e.ageHeader = 0)), l) {
      case Le.MANIFEST:
      case Le.LEVEL:
        o.trigger(S.LEVEL_LOADED, {
          details: e,
          levelInfo: s.levelOrTrack || o.levels[0],
          level: g || 0,
          id: c || 0,
          stats: n,
          networkDetails: r,
          deliveryDirectives: f,
          withoutMultiVariant: l === Le.MANIFEST
        });
        break;
      case Le.AUDIO_TRACK:
        o.trigger(S.AUDIO_TRACK_LOADED, {
          details: e,
          track: s.levelOrTrack,
          id: c || 0,
          groupId: u || "",
          stats: n,
          networkDetails: r,
          deliveryDirectives: f
        });
        break;
      case Le.SUBTITLE_TRACK:
        o.trigger(S.SUBTITLE_TRACK_LOADED, {
          details: e,
          track: s.levelOrTrack,
          id: c || 0,
          groupId: u || "",
          stats: n,
          networkDetails: r,
          deliveryDirectives: f
        });
        break;
    }
  }
}
class nt {
  /**
   * Get the video-dev/hls.js package version.
   */
  static get version() {
    return Ls;
  }
  /**
   * Check if the required MediaSource Extensions are available.
   */
  static isMSESupported() {
    return xm();
  }
  /**
   * Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
   */
  static isSupported() {
    return Nk();
  }
  /**
   * Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
   */
  static getMediaSource() {
    return en();
  }
  static get Events() {
    return S;
  }
  static get MetadataSchema() {
    return Bt;
  }
  static get ErrorTypes() {
    return pe;
  }
  static get ErrorDetails() {
    return B;
  }
  /**
   * Get the default configuration applied to new instances.
   */
  static get DefaultConfig() {
    return nt.defaultConfig ? nt.defaultConfig : Tk;
  }
  /**
   * Replace the default configuration applied to new instances.
   */
  static set DefaultConfig(e) {
    nt.defaultConfig = e;
  }
  /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */
  constructor(e = {}) {
    this.config = void 0, this.userConfig = void 0, this.logger = void 0, this.coreComponents = void 0, this.networkControllers = void 0, this._emitter = new Ll(), this._autoLevelCapping = -1, this._maxHdcpLevel = null, this.abrController = void 0, this.bufferController = void 0, this.capLevelController = void 0, this.latencyController = void 0, this.levelController = void 0, this.streamController = void 0, this.audioStreamController = void 0, this.subtititleStreamController = void 0, this.audioTrackController = void 0, this.subtitleTrackController = void 0, this.interstitialsController = void 0, this.gapController = void 0, this.emeController = void 0, this.cmcdController = void 0, this._media = null, this._url = null, this._sessionId = void 0, this.triggeringException = void 0, this.started = !1;
    const t = this.logger = Yv(e.debug || !1, "Hls instance", e.assetPlayerId), n = this.config = xk(nt.DefaultConfig, e, t);
    this.userConfig = e, n.progressive && _k(n, t);
    const {
      abrController: s,
      bufferController: r,
      capLevelController: a,
      errorController: o,
      fpsController: l
    } = n, d = new o(this), c = this.abrController = new s(this), u = new B1(this), f = n.interstitialsController, h = f ? this.interstitialsController = new f(this, nt) : null, m = this.bufferController = new r(this, u), g = this.capLevelController = new a(this), v = new l(this), p = new Bk(this), y = n.contentSteeringController, b = y ? new y(this) : null, k = this.levelController = new Dk(this, b), T = new Rk(this), I = new $k(this.config), x = this.streamController = new Fk(this, u, I), E = this.gapController = new Ik(this, u);
    g.setStreamController(x), v.setStreamController(x);
    const R = [p, k, x];
    h && R.splice(1, 0, h), b && R.splice(1, 0, b), this.networkControllers = R;
    const A = [c, m, E, g, v, T, u];
    this.audioTrackController = this.createController(n.audioTrackController, R);
    const _ = n.audioStreamController;
    _ && R.push(this.audioStreamController = new _(this, u, I)), this.subtitleTrackController = this.createController(n.subtitleTrackController, R);
    const C = n.subtitleStreamController;
    C && R.push(this.subtititleStreamController = new C(this, u, I)), this.createController(n.timelineController, A), I.emeController = this.emeController = this.createController(n.emeController, A), this.cmcdController = this.createController(n.cmcdController, A), this.latencyController = this.createController(Pk, A), this.coreComponents = A, R.push(d);
    const O = d.onErrorOut;
    typeof O == "function" && this.on(S.ERROR, O, d), this.on(S.MANIFEST_LOADED, p.onManifestLoaded, p);
  }
  createController(e, t) {
    if (e) {
      const n = new e(this);
      return t && t.push(n), n;
    }
    return null;
  }
  // Delegate the EventEmitter through the public API of Hls.js
  on(e, t, n = this) {
    this._emitter.on(e, t, n);
  }
  once(e, t, n = this) {
    this._emitter.once(e, t, n);
  }
  removeAllListeners(e) {
    this._emitter.removeAllListeners(e);
  }
  off(e, t, n = this, s) {
    this._emitter.off(e, t, n, s);
  }
  listeners(e) {
    return this._emitter.listeners(e);
  }
  emit(e, t, n) {
    return this._emitter.emit(e, t, n);
  }
  trigger(e, t) {
    if (this.config.debug)
      return this.emit(e, e, t);
    try {
      return this.emit(e, e, t);
    } catch (n) {
      if (this.logger.error("An internal error happened while handling event " + e + '. Error message: "' + n.message + '". Here is a stacktrace:', n), !this.triggeringException) {
        this.triggeringException = !0;
        const s = e === S.ERROR;
        this.trigger(S.ERROR, {
          type: pe.OTHER_ERROR,
          details: B.INTERNAL_EXCEPTION,
          fatal: s,
          event: e,
          error: n
        }), this.triggeringException = !1;
      }
    }
    return !1;
  }
  listenerCount(e) {
    return this._emitter.listenerCount(e);
  }
  /**
   * Dispose of the instance
   */
  destroy() {
    this.logger.log("destroy"), this.trigger(S.DESTROYING, void 0), this.detachMedia(), this.removeAllListeners(), this._autoLevelCapping = -1, this._url = null, this.networkControllers.forEach((t) => t.destroy()), this.networkControllers.length = 0, this.coreComponents.forEach((t) => t.destroy()), this.coreComponents.length = 0;
    const e = this.config;
    e.xhrSetup = e.fetchSetup = void 0, this.userConfig = null;
  }
  /**
   * Attaches Hls.js to a media element
   */
  attachMedia(e) {
    if (!e || "media" in e && !e.media) {
      const r = new Error(`attachMedia failed: invalid argument (${e})`);
      this.trigger(S.ERROR, {
        type: pe.OTHER_ERROR,
        details: B.ATTACH_MEDIA_ERROR,
        fatal: !0,
        error: r
      });
      return;
    }
    this.logger.log("attachMedia"), this._media && (this.logger.warn("media must be detached before attaching"), this.detachMedia());
    const t = "media" in e, n = t ? e.media : e, s = t ? e : {
      media: n
    };
    this._media = n, this.trigger(S.MEDIA_ATTACHING, s);
  }
  /**
   * Detach Hls.js from the media
   */
  detachMedia() {
    this.logger.log("detachMedia"), this.trigger(S.MEDIA_DETACHING, {}), this._media = null;
  }
  /**
   * Detach HTMLMediaElement, MediaSource, and SourceBuffers without reset, for attaching to another instance
   */
  transferMedia() {
    this._media = null;
    const e = this.bufferController.transferMedia();
    return this.trigger(S.MEDIA_DETACHING, {
      transferMedia: e
    }), e;
  }
  /**
   * Set the source URL. Can be relative or absolute.
   */
  loadSource(e) {
    this.stopLoad();
    const t = this.media, n = this._url, s = this._url = vl.buildAbsoluteURL(self.location.href, e, {
      alwaysNormalize: !0
    });
    this._autoLevelCapping = -1, this._maxHdcpLevel = null, this.logger.log(`loadSource:${s}`), t && n && (n !== s || this.bufferController.hasSourceTypes()) && (this.detachMedia(), this.attachMedia(t)), this.trigger(S.MANIFEST_LOADING, {
      url: e
    });
  }
  /**
   * Gets the currently loaded URL
   */
  get url() {
    return this._url;
  }
  /**
   * Whether or not enough has been buffered to seek to start position or use `media.currentTime` to determine next load position
   */
  get hasEnoughToStart() {
    return this.streamController.hasEnoughToStart;
  }
  /**
   * Get the startPosition set on startLoad(position) or on autostart with config.startPosition
   */
  get startPosition() {
    return this.streamController.startPositionValue;
  }
  /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */
  startLoad(e = -1, t) {
    this.logger.log(`startLoad(${e + (t ? ", <skip seek to start>" : "")})`), this.started = !0, this.resumeBuffering();
    for (let n = 0; n < this.networkControllers.length && (this.networkControllers[n].startLoad(e, t), !(!this.started || !this.networkControllers)); n++)
      ;
  }
  /**
   * Stop loading of any stream data.
   */
  stopLoad() {
    this.logger.log("stopLoad"), this.started = !1;
    for (let e = 0; e < this.networkControllers.length && (this.networkControllers[e].stopLoad(), !(this.started || !this.networkControllers)); e++)
      ;
  }
  /**
   * Returns whether loading, toggled with `startLoad()` and `stopLoad()`, is active or not`.
   */
  get loadingEnabled() {
    return this.started;
  }
  /**
   * Returns state of fragment loading toggled by calling `pauseBuffering()` and `resumeBuffering()`.
   */
  get bufferingEnabled() {
    return this.streamController.bufferingEnabled;
  }
  /**
   * Resumes stream controller segment loading after `pauseBuffering` has been called.
   */
  resumeBuffering() {
    this.bufferingEnabled || (this.logger.log("resume buffering"), this.networkControllers.forEach((e) => {
      e.resumeBuffering && e.resumeBuffering();
    }));
  }
  /**
   * Prevents stream controller from loading new segments until `resumeBuffering` is called.
   * This allows for media buffering to be paused without interupting playlist loading.
   */
  pauseBuffering() {
    this.bufferingEnabled && (this.logger.log("pause buffering"), this.networkControllers.forEach((e) => {
      e.pauseBuffering && e.pauseBuffering();
    }));
  }
  get inFlightFragments() {
    const e = {
      [ce.MAIN]: this.streamController.inFlightFrag
    };
    return this.audioStreamController && (e[ce.AUDIO] = this.audioStreamController.inFlightFrag), this.subtititleStreamController && (e[ce.SUBTITLE] = this.subtititleStreamController.inFlightFrag), e;
  }
  /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */
  swapAudioCodec() {
    this.logger.log("swapAudioCodec"), this.streamController.swapAudioCodec();
  }
  /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */
  recoverMediaError() {
    this.logger.log("recoverMediaError");
    const e = this._media, t = e?.currentTime;
    this.detachMedia(), e && (this.attachMedia(e), t && this.startLoad(t));
  }
  removeLevel(e) {
    this.levelController.removeLevel(e);
  }
  /**
   * @returns a UUID for this player instance
   */
  get sessionId() {
    let e = this._sessionId;
    return e || (e = this._sessionId = IS()), e;
  }
  /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */
  get levels() {
    const e = this.levelController.levels;
    return e || [];
  }
  /**
   * @returns LevelDetails of last loaded level (variant) or `null` prior to loading a media playlist.
   */
  get latestLevelDetails() {
    return this.streamController.getLevelDetails() || null;
  }
  /**
   * @returns Level object of selected level (variant) or `null` prior to selecting a level or once the level is removed.
   */
  get loadLevelObj() {
    return this.levelController.loadLevelObj;
  }
  /**
   * Index of quality level (variant) currently played
   */
  get currentLevel() {
    return this.streamController.currentLevel;
  }
  /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */
  set currentLevel(e) {
    this.logger.log(`set currentLevel:${e}`), this.levelController.manualLevel = e, this.streamController.immediateLevelSwitch();
  }
  /**
   * Index of next quality level loaded as scheduled by stream controller.
   */
  get nextLevel() {
    return this.streamController.nextLevel;
  }
  /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */
  set nextLevel(e) {
    this.logger.log(`set nextLevel:${e}`), this.levelController.manualLevel = e, this.streamController.nextLevelSwitch();
  }
  /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */
  get loadLevel() {
    return this.levelController.level;
  }
  /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */
  set loadLevel(e) {
    this.logger.log(`set loadLevel:${e}`), this.levelController.manualLevel = e;
  }
  /**
   * get next quality level loaded
   */
  get nextLoadLevel() {
    return this.levelController.nextLoadLevel;
  }
  /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */
  set nextLoadLevel(e) {
    this.levelController.nextLoadLevel = e;
  }
  /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */
  get firstLevel() {
    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
  }
  /**
   * Sets "first-level", see getter.
   */
  set firstLevel(e) {
    this.logger.log(`set firstLevel:${e}`), this.levelController.firstLevel = e;
  }
  /**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */
  get startLevel() {
    const e = this.levelController.startLevel;
    return e === -1 && this.abrController.forcedAutoLevel > -1 ? this.abrController.forcedAutoLevel : e;
  }
  /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  set startLevel(e) {
    this.logger.log(`set startLevel:${e}`), e !== -1 && (e = Math.max(e, this.minAutoLevel)), this.levelController.startLevel = e;
  }
  /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */
  get capLevelToPlayerSize() {
    return this.config.capLevelToPlayerSize;
  }
  /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */
  set capLevelToPlayerSize(e) {
    const t = !!e;
    t !== this.config.capLevelToPlayerSize && (t ? this.capLevelController.startCapping() : (this.capLevelController.stopCapping(), this.autoLevelCapping = -1, this.streamController.nextLevelSwitch()), this.config.capLevelToPlayerSize = t);
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  get autoLevelCapping() {
    return this._autoLevelCapping;
  }
  /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */
  get bandwidthEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimate() : NaN;
  }
  set bandwidthEstimate(e) {
    this.abrController.resetEstimator(e);
  }
  get abrEwmaDefaultEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.defaultEstimate : NaN;
  }
  /**
   * get time to first byte estimate
   * @type {number}
   */
  get ttfbEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimateTTFB() : NaN;
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  set autoLevelCapping(e) {
    this._autoLevelCapping !== e && (this.logger.log(`set autoLevelCapping:${e}`), this._autoLevelCapping = e, this.levelController.checkMaxAutoUpdated());
  }
  get maxHdcpLevel() {
    return this._maxHdcpLevel;
  }
  set maxHdcpLevel(e) {
    E1(e) && this._maxHdcpLevel !== e && (this._maxHdcpLevel = e, this.levelController.checkMaxAutoUpdated());
  }
  /**
   * True when automatic level selection enabled
   */
  get autoLevelEnabled() {
    return this.levelController.manualLevel === -1;
  }
  /**
   * Level set manually (if any)
   */
  get manualLevel() {
    return this.levelController.manualLevel;
  }
  /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */
  get minAutoLevel() {
    const {
      levels: e,
      config: {
        minAutoBitrate: t
      }
    } = this;
    if (!e) return 0;
    const n = e.length;
    for (let s = 0; s < n; s++)
      if (e[s].maxBitrate >= t)
        return s;
    return 0;
  }
  /**
   * max level selectable in auto mode according to autoLevelCapping
   */
  get maxAutoLevel() {
    const {
      levels: e,
      autoLevelCapping: t,
      maxHdcpLevel: n
    } = this;
    let s;
    if (t === -1 && e != null && e.length ? s = e.length - 1 : s = t, n)
      for (let r = s; r--; ) {
        const a = e[r].attrs["HDCP-LEVEL"];
        if (a && a <= n)
          return r;
      }
    return s;
  }
  get firstAutoLevel() {
    return this.abrController.firstAutoLevel;
  }
  /**
   * next automatically selected quality level
   */
  get nextAutoLevel() {
    return this.abrController.nextAutoLevel;
  }
  /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */
  set nextAutoLevel(e) {
    this.abrController.nextAutoLevel = e;
  }
  /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */
  get playingDate() {
    return this.streamController.currentProgramDateTime;
  }
  get mainForwardBufferInfo() {
    return this.streamController.getMainFwdBufferInfo();
  }
  get maxBufferLength() {
    return this.streamController.maxBufferLength;
  }
  /**
   * Find and select the best matching audio track, making a level switch when a Group change is necessary.
   * Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
   */
  setAudioOption(e) {
    var t;
    return ((t = this.audioTrackController) == null ? void 0 : t.setAudioOption(e)) || null;
  }
  /**
   * Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
   * Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
   */
  setSubtitleOption(e) {
    var t;
    return ((t = this.subtitleTrackController) == null ? void 0 : t.setSubtitleOption(e)) || null;
  }
  /**
   * Get the complete list of audio tracks across all media groups
   */
  get allAudioTracks() {
    const e = this.audioTrackController;
    return e ? e.allAudioTracks : [];
  }
  /**
   * Get the list of selectable audio tracks
   */
  get audioTracks() {
    const e = this.audioTrackController;
    return e ? e.audioTracks : [];
  }
  /**
   * index of the selected audio track (index in audio track lists)
   */
  get audioTrack() {
    const e = this.audioTrackController;
    return e ? e.audioTrack : -1;
  }
  /**
   * selects an audio track, based on its index in audio track lists
   */
  set audioTrack(e) {
    const t = this.audioTrackController;
    t && (t.audioTrack = e);
  }
  /**
   * get the complete list of subtitle tracks across all media groups
   */
  get allSubtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.allSubtitleTracks : [];
  }
  /**
   * get alternate subtitle tracks list from playlist
   */
  get subtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTracks : [];
  }
  /**
   * index of the selected subtitle track (index in subtitle track lists)
   */
  get subtitleTrack() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTrack : -1;
  }
  get media() {
    return this._media;
  }
  /**
   * select an subtitle track, based on its index in subtitle track lists
   */
  set subtitleTrack(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleTrack = e);
  }
  /**
   * Whether subtitle display is enabled or not
   */
  get subtitleDisplay() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleDisplay : !1;
  }
  /**
   * Enable/disable subtitle display rendering
   */
  set subtitleDisplay(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleDisplay = e);
  }
  /**
   * get mode for Low-Latency HLS loading
   */
  get lowLatencyMode() {
    return this.config.lowLatencyMode;
  }
  /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */
  set lowLatencyMode(e) {
    this.config.lowLatencyMode = e;
  }
  /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */
  get liveSyncPosition() {
    return this.latencyController.liveSyncPosition;
  }
  /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */
  get latency() {
    return this.latencyController.latency;
  }
  /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */
  get maxLatency() {
    return this.latencyController.maxLatency;
  }
  /**
   * target distance from the edge as calculated by the latency controller
   */
  get targetLatency() {
    return this.latencyController.targetLatency;
  }
  set targetLatency(e) {
    this.latencyController.targetLatency = e;
  }
  /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */
  get drift() {
    return this.latencyController.drift;
  }
  /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */
  get forceStartLoad() {
    return this.streamController.forceStartLoad;
  }
  /**
   * ContentSteering pathways getter
   */
  get pathways() {
    return this.levelController.pathways;
  }
  /**
   * ContentSteering pathwayPriority getter/setter
   */
  get pathwayPriority() {
    return this.levelController.pathwayPriority;
  }
  set pathwayPriority(e) {
    this.levelController.pathwayPriority = e;
  }
  /**
   * returns true when all SourceBuffers are buffered to the end
   */
  get bufferedToEnd() {
    var e;
    return !!((e = this.bufferController) != null && e.bufferedToEnd);
  }
  /**
   * returns Interstitials Program Manager
   */
  get interstitialsManager() {
    var e;
    return ((e = this.interstitialsController) == null ? void 0 : e.interstitialsManager) || null;
  }
  /**
   * returns mediaCapabilities.decodingInfo for a variant/rendition
   */
  getMediaDecodingInfo(e, t = this.allAudioTracks) {
    const n = ph(t);
    return hh(e, n, navigator.mediaCapabilities);
  }
}
nt.defaultConfig = void 0;
const Uk = { class: "poloclub-spinner" }, Vk = /* @__PURE__ */ Re({
  __name: "PoloclubSpinner.ce",
  props: {
    theme: { type: String },
    width: { type: String }
  },
  setup(i) {
    return Nt((e) => ({
      "71a20cce": e.width,
      "4a4201ba": e.theme === "light" ? "#fff" : "var(--color-black)"
    })), (e, t) => (P(), N("div", Uk));
  }
}), Gk = "[data-v-7d22a8f9],[data-v-7d22a8f9]:before,[data-v-7d22a8f9]:after{box-sizing:border-box}p[data-v-7d22a8f9],[data-v-7d22a8f9] p{margin:0;padding:0}h1[data-v-7d22a8f9],h2[data-v-7d22a8f9]{margin:0}[data-v-7d22a8f9]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.poloclub-spinner[data-v-7d22a8f9]{width:var(--71a20cce);height:var(--71a20cce);aspect-ratio:1;border-radius:50%;border:1px solid var(--4a4201ba);border-top:1px solid transparent;animation:spin-7d22a8f9 1s linear infinite}@keyframes spin-7d22a8f9{0%{transform:rotate(0)}to{transform:rotate(360deg)}}", bi = /* @__PURE__ */ Pe(Vk, [["styles", [Gk]], ["__scopeId", "data-v-7d22a8f9"]]), Hk = { class: "poloclub-video" }, zk = ["poster", "width", "height"], Kk = {
  key: 0,
  class: "error-message"
}, jk = {
  key: 1,
  class: "loading-container"
}, Wk = /* @__PURE__ */ Re({
  __name: "PoloclubVideo.ce",
  props: {
    video: { type: Object }
  },
  setup(i) {
    const e = i, t = ge(), n = ge(), s = ge(!1), r = ge(""), a = ge(), o = async (f) => {
      try {
        await fetch(f);
      } catch (h) {
        console.warn("Video preload failed:", h);
      }
    }, l = () => {
      t.value && (a.value = new IntersectionObserver(
        (f) => {
          f.forEach((h) => {
            h.isIntersecting ? t.value && t.value.paused && t.value.play() : t.value && !t.value.paused && t.value.pause();
          });
        },
        {
          threshold: 1,
          rootMargin: "0px"
        }
      ), a.value.observe(t.value));
    }, d = async () => {
      if (!t.value) return;
      const f = t.value;
      if (f.canPlayType("application/vnd.apple.mpegurl")) {
        const h = e.video.sources.find(
          (m) => m.format === "m3u8" || m.mimeType === "application/x-mpegURL"
        );
        if (h) {
          f.src = h.url;
          return;
        }
      }
      if (nt.isSupported())
        try {
          s.value = !0, r.value = "", n.value = new nt({
            enableWorker: !0,
            lowLatencyMode: !0,
            backBufferLength: 90,
            startLevel: -1,
            abrEwmaDefaultEstimate: 2e6,
            abrBandWidthFactor: 0.9,
            abrBandWidthUpFactor: 0.8,
            abrEwmaFastLive: 3,
            abrEwmaSlowLive: 9,
            abrMaxWithRealBitrate: !0,
            maxBufferLength: 30,
            maxMaxBufferLength: 60,
            maxBufferSize: 60 * 1e3 * 1e3,
            maxBufferHole: 0.5,
            highBufferWatchdogPeriod: 2,
            nudgeOffset: 0.1,
            nudgeMaxRetry: 5,
            maxFragLookUpTolerance: 0.25,
            liveSyncDurationCount: 3,
            liveMaxLatencyDurationCount: 10
          });
          const h = e.video.sources.find(
            (m) => m.format === "m3u8" || m.mimeType === "application/x-mpegURL"
          );
          h ? (await o(h.url), n.value.loadSource(h.url), n.value.attachMedia(f), n.value.on(nt.Events.MANIFEST_PARSED, () => {
            if (s.value = !1, n.value && n.value.levels && n.value.levels.length > 0) {
              const m = Math.min(Math.floor(n.value.levels.length * 0.7), n.value.levels.length - 1);
              n.value.nextLevel = m;
            }
          }), n.value.on(nt.Events.LEVEL_SWITCHED, (m, g) => {
          }), n.value.on(nt.Events.ERROR, (m, g) => {
            if (g.fatal)
              switch (g.type) {
                case nt.ErrorTypes.NETWORK_ERROR:
                  r.value = "Network error. Trying to reconnect...", n.value?.startLoad();
                  break;
                case nt.ErrorTypes.MEDIA_ERROR:
                  r.value = "Media error. Trying to recover...", n.value?.recoverMediaError();
                  break;
                default:
                  r.value = "Fatal error of the HLS player";
                  break;
              }
          })) : (r.value = "No valid HLS source found", s.value = !1);
        } catch (h) {
          r.value = `Error initializing HLS: ${h instanceof Error ? h.message : "Unknown error"}`, s.value = !1;
        }
      else
        r.value = "HLS is not compatible with this browser";
    }, c = () => {
      s.value = !1;
    }, u = (f) => {
      const h = f.target;
      h.error && (r.value = `Video error: ${h.error.message || "Unknown error"}`);
    };
    return wt(async () => {
      await Gt(), d(), l();
    }), ia(() => {
      n.value && n.value.destroy(), a.value && a.value.disconnect();
    }), (f, h) => (P(), N("div", Hk, [
      w("video", {
        ref_key: "videoRef",
        ref: t,
        poster: f.video.previewImage?.url,
        width: f.video.sources[0]?.width || 640,
        height: f.video.sources[0]?.height || 360,
        controls: "",
        preload: "metadata",
        onLoadedmetadata: c,
        onError: u
      }, h[0] || (h[0] = [
        w("p", null, "Your browser does not support the playback of HLS videos.", -1)
      ]), 40, zk),
      r.value ? (P(), N("div", Kk, " Error: " + ie(r.value), 1)) : U("", !0),
      s.value ? (P(), N("div", jk, [
        de(bi, {
          width: "50px",
          theme: "dark"
        })
      ])) : U("", !0)
    ]));
  }
}), qk = "[data-v-df6a29c6],[data-v-df6a29c6]:before,[data-v-df6a29c6]:after{box-sizing:border-box}p[data-v-df6a29c6],[data-v-df6a29c6] p{margin:0;padding:0}h1[data-v-df6a29c6],h2[data-v-df6a29c6]{margin:0}[data-v-df6a29c6]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.poloclub-video[data-v-df6a29c6]{position:relative}video[data-v-df6a29c6]{width:100%;height:100%;object-fit:cover}.error-message[data-v-df6a29c6]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background:#f00c;color:#fff;padding:10px;border-radius:4px;text-align:center;max-width:80%}.loading-container[data-v-df6a29c6]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", Yk = /* @__PURE__ */ Pe(Wk, [["styles", [qk]], ["__scopeId", "data-v-df6a29c6"]]), Xk = {
  key: 0,
  class: "product-media__main-container"
}, Zk = { class: "product-media__media-slider" }, Qk = ["id", "onClick"], Jk = ["media", "srcset"], eT = ["media", "srcset"], tT = ["src", "alt"], iT = { class: "media-zoom-icon" }, nT = ["zoomed-id"], sT = ["media", "srcset"], rT = ["media", "srcset"], aT = ["src", "alt"], oT = /* @__PURE__ */ Re({
  __name: "PoloclubProductMedia.ce",
  props: {
    isLogged: { type: Boolean }
  },
  setup(i) {
    const e = ge(!1), t = ge(null), n = Zi({}), s = (g, v) => {
      v instanceof HTMLElement && (n[g] = v);
    }, r = (g) => g.mediaContentType === "IMAGE", a = (g) => g.mediaContentType === "VIDEO" || g.mediaContentType === "EXTERNAL_VIDEO", o = (g) => g.mediaContentType === "VIDEO", l = (g) => g.url?.includes("_color") || g.url?.includes("_aire"), d = le(() => F.productView.product?.media?.nodes || []), c = le(
      () => d.value.filter((g) => r(g) ? !l(g.image) : !0)
    ), u = (g) => {
      r(g) && f(g.id);
    }, f = (g) => {
      h(), Gt(() => {
        const v = t.value, p = n[g];
        v && p && v.scrollTo({ top: p.offsetTop, behavior: "auto" });
      });
    }, h = () => {
      e.value = !e.value, m();
    }, m = () => {
      const g = document.body;
      g.style.overflow = g.style.overflow === "hidden" ? "auto" : "hidden";
    };
    return (g, v) => c.value.length > 0 ? (P(), N("div", Xk, [
      w("div", Zk, [
        (P(!0), N(ve, null, pt(c.value, (p, y) => (P(), N("div", {
          key: y,
          class: "product-media__media-item-container",
          id: p.id,
          onClick: (b) => u(p)
        }, [
          r(p) ? (P(), N(ve, { key: 0 }, [
            w("picture", null, [
              p.image.desktop ? (P(), N("source", {
                key: 0,
                media: `(width >= ${L(F).tabletBreakpoint}px)`,
                srcset: p.image.desktop
              }, null, 8, Jk)) : U("", !0),
              p.image.tablet ? (P(), N("source", {
                key: 1,
                media: `(width >= ${L(F).mobileBreakpoint}px)`,
                srcset: p.image.tablet
              }, null, 8, eT)) : U("", !0),
              w("img", {
                class: "media-image",
                src: p.image.mobile,
                alt: p.image.altText,
                loading: "lazy"
              }, null, 8, tT)
            ]),
            w("div", iT, [
              de(wv)
            ])
          ], 64)) : U("", !0),
          a(p) ? (P(), N(ve, { key: 1 }, [
            o(p) ? (P(), Ie(Yk, {
              key: 0,
              video: p
            }, null, 8, ["video"])) : U("", !0)
          ], 64)) : U("", !0)
        ], 8, Qk))), 128)),
        de(gl, {
          class: "product-labels",
          type: "product-view",
          product: L(F).productView.product,
          "is-logged": g.isLogged,
          position: "top"
        }, null, 8, ["product", "is-logged"])
      ]),
      e.value ? (P(), N("div", {
        key: 0,
        class: "product-media__zoomed-container",
        ref_key: "zoomedContainer",
        ref: t
      }, [
        (P(!0), N(ve, null, pt(c.value, (p, y) => (P(), N(ve, null, [
          r(p) ? (P(), N("div", {
            key: y,
            class: "product-media__zoomed-item-container",
            "zoomed-id": p.id,
            ref_for: !0,
            ref: (b) => s(p.id, b)
          }, [
            w("picture", null, [
              p.image.desktop ? (P(), N("source", {
                key: 0,
                media: `(width >= ${L(F).tabletBreakpoint}px)`,
                srcset: p.image.desktop
              }, null, 8, sT)) : U("", !0),
              p.image.tablet ? (P(), N("source", {
                key: 1,
                media: `(width >= ${L(F).mobileBreakpoint}px)`,
                srcset: p.image.tablet
              }, null, 8, rT)) : U("", !0),
              w("img", {
                src: p.image.mobile,
                alt: p.image.altText,
                loading: "lazy"
              }, null, 8, aT)
            ])
          ], 8, nT)) : U("", !0)
        ], 64))), 256)),
        w("div", {
          class: "zoomed-close-icon",
          onClick: h
        }, [
          de(Jf, { width: "24px" })
        ])
      ], 512)) : U("", !0),
      L(he).enable_wishlist ? (P(), Ie(ha, {
        key: 1,
        class: "wishlist-icon",
        type: "product-view"
      })) : U("", !0)
    ])) : U("", !0);
  }
}), lT = "[data-v-917c89ee],[data-v-917c89ee]:before,[data-v-917c89ee]:after{box-sizing:border-box}p[data-v-917c89ee],[data-v-917c89ee] p{margin:0;padding:0}h1[data-v-917c89ee],h2[data-v-917c89ee]{margin:0}[data-v-917c89ee]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.product-media__main-container[data-v-917c89ee]{position:relative}.wishlist-icon[data-v-917c89ee]{position:absolute;top:0;right:0;margin:1rem 1.5rem 0 0}.product-media__media-slider[data-v-917c89ee]{position:relative;display:flex;overflow-x:auto;padding-bottom:.4rem;scrollbar-color:#000 transparent;scrollbar-width:thin}.product-labels[data-v-917c89ee]{position:absolute;top:8px;left:8px}.product-media__media-item-container[data-v-917c89ee]{position:relative;display:flex;flex-shrink:0;flex-basis:94%;cursor:pointer;aspect-ratio:9 / 13.5}.product-media__media-item-container[data-v-917c89ee]:has(>video){display:block}.product-media__media-item-container[data-v-917c89ee]:not(:last-child){margin-right:.3rem}.product-media__media-item-container>picture[data-v-917c89ee],.media-image[data-v-917c89ee],.product-media__media-item-container>video[data-v-917c89ee]{width:100%;display:flex}.product-media__media-item-container>picture[data-v-917c89ee]{background-color:#e5e5e5}.product-media__media-item-container>video[data-v-917c89ee]{width:100%;pointer-events:none}.product-media__zoomed-container[data-v-917c89ee]{position:fixed;z-index:9999998;top:0;left:0;display:flex;flex-direction:column;align-items:center;overflow-y:auto;width:100vw;height:100vh;background-color:#fff}.product-media__zoomed-item-container[data-v-917c89ee]{padding:2rem}.product-media__zoomed-item-container img[data-v-917c89ee]{width:100%}.media-zoom-icon[data-v-917c89ee]{position:absolute;bottom:0;right:0;width:27px;height:29px}.zoomed-close-icon[data-v-917c89ee]{position:fixed;z-index:9999999;top:1%;right:1%;display:flex;justify-content:center;padding:1rem;background-color:#fff;cursor:pointer;border-radius:50%;border:1px solid rgba(0,0,0,.6)}@media (499px >=width > 320px){.product-media__media-item-container[data-v-917c89ee]{flex-basis:93%}}@media (768px >=width > 500px){.product-media__media-item-container[data-v-917c89ee]{flex-basis:60%}}@media (width >=768px){.product-media__main-container[data-v-917c89ee]{width:50%;padding-left:1rem;padding-bottom:0}.product-media__media-slider[data-v-917c89ee]{display:grid;grid-template-columns:repeat(1,1fr);gap:.8rem;max-height:85rem;overflow-y:auto;padding-right:.8rem;scrollbar-color:auto;scrollbar-width:auto}.product-media__media-item-container[data-v-917c89ee]{margin-right:initial!important;aspect-ratio:9 / 14}.product-labels[data-v-917c89ee]{top:15px;left:15px}@-moz-document url-prefix(){.product-media__media-slider[data-v-917c89ee]{scrollbar-color:#000 transparent;scrollbar-width:thin}}.product-media__media-slider[data-v-917c89ee]::-webkit-scrollbar{width:1px;height:2px;background-color:transparent}.product-media__media-slider[data-v-917c89ee]::-webkit-scrollbar-thumb{background-color:transparent}.product-media__media-slider[data-v-917c89ee]:hover::-webkit-scrollbar-thumb{background-color:#000}.product-media__media-slider[data-v-917c89ee]:hover::-webkit-scrollbar-track{background:var(--color-border-gray)}}@media (width >=1024px){.product-media__main-container[data-v-917c89ee]{width:65%;padding-left:3rem}.product-media__media-slider[data-v-917c89ee]{grid-template-columns:repeat(2,1fr)}}", dT = /* @__PURE__ */ Pe(oT, [["styles", [lT]], ["__scopeId", "data-v-917c89ee"]]), cT = ["data-key", "data-locale", "data-theme", "data-purchase-amount"], uT = /* @__PURE__ */ Re({
  __name: "KlarnaPlacement.ce",
  props: {
    purchaseAmount: { type: Number },
    klarnaKey: { type: String },
    klarnaTheme: { type: String }
  },
  setup(i) {
    const e = le(() => F.locale.includes("en") ? "en-ES" : F.locale.includes("fr") ? "fr-FR" : F.locale.includes("de") ? "de-DE" : F.locale.includes("it") ? "it-IT" : F.locale.includes("pt") ? "pt-PT" : F.locale.includes("nl") ? "nl-NL" : "es-ES");
    return (t, n) => (P(), N("klarna-placement", {
      "data-key": t.klarnaKey,
      "data-locale": e.value,
      "data-theme": t.klarnaTheme,
      "data-purchase-amount": t.purchaseAmount
    }, null, 8, cT));
  }
}), fT = ["hide", "hide-price", "min-amount", "max-amount", "amount", "currency-position", "currency-display", "logo-size", "theme", "locale", "cart-scalapay-snippet", "amount-separator"], hT = /* @__PURE__ */ Re({
  __name: "ScalapayWidget.ce",
  props: {
    hide: { type: Boolean },
    hidePrice: { type: Boolean },
    min: { type: Number },
    max: { type: Number },
    amount: { type: String },
    currencyPosition: { type: String },
    currencyDisplay: { type: String },
    logoSize: { type: Number },
    theme: { type: String },
    cartSnippet: { type: Boolean },
    amountSeparator: { type: String }
  },
  setup(i) {
    return wt(() => {
      if (!document.querySelector("#scalapay-widget-script")) {
        const e = document.createElement("script");
        e.id = "scalapay-widget-script", e.type = "module", e.src = "https://cdn.scalapay.com/widget/scalapay-widget-loader.js?version=V5", document.head.appendChild(e);
      }
    }), (e, t) => (P(), N("scalapay-widget", {
      hide: e.hide,
      "hide-price": e.hidePrice,
      "min-amount": e.min || 0,
      "max-amount": e.max || 15e3,
      amount: e.amount,
      "currency-position": e.currencyPosition || "after",
      "currency-display": e.currencyDisplay || "symbol",
      "logo-size": e.logoSize || 85,
      theme: e.theme || "primary",
      locale: L(F).locale,
      "cart-scalapay-snippet": e.cartSnippet,
      "amount-separator": e.amountSeparator || ","
    }, null, 8, fT));
  }
}), mT = { class: "poloclub-drawer-header" }, pT = { key: 0 }, gT = { class: "poloclub-drawer-content" }, vT = /* @__PURE__ */ Re({
  __name: "PoloclubDrawer.ce",
  props: {
    type: { type: String },
    state: { type: String },
    title: { type: String },
    height: { type: String }
  },
  emits: ["close"],
  setup(i, { emit: e }) {
    Nt((n) => ({
      "46c12154": n.height ? n.height : "100%",
      "75e3c74a": n.height ? n.height : "90dvh"
    }));
    const t = e;
    return Dt(
      () => i.state,
      (n) => {
        n === "open" ? document.body.style.overflow = "hidden" : document.body.style.overflow = "";
      },
      { immediate: !0 }
    ), (n, s) => (P(), N(ve, null, [
      n.state === "open" ? (P(), N("div", {
        key: 0,
        class: "overlay",
        onClick: s[0] || (s[0] = (r) => t("close"))
      })) : U("", !0),
      de(Rf, {
        name: `drawer-${n.type}`,
        appear: ""
      }, {
        default: Xe(() => [
          n.state === "open" ? (P(), N("div", {
            key: 0,
            class: Ke(["poloclub-drawer", [n.type, n.state]])
          }, [
            w("div", mT, [
              n.title ? (P(), N("p", pT, ie(n.title), 1)) : U("", !0),
              de(Jf, {
                width: "2rem",
                onClick: s[1] || (s[1] = (r) => t("close"))
              })
            ]),
            w("div", gT, [
              na(n.$slots, "default", {}, void 0, !0)
            ])
          ], 2)) : U("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ], 64));
  }
}), yT = "[data-v-e1ac5f6f],[data-v-e1ac5f6f]:before,[data-v-e1ac5f6f]:after{box-sizing:border-box}p[data-v-e1ac5f6f],[data-v-e1ac5f6f] p{margin:0;padding:0}h1[data-v-e1ac5f6f],h2[data-v-e1ac5f6f]{margin:0}[data-v-e1ac5f6f]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.overlay[data-v-e1ac5f6f]{z-index:999;display:none;position:fixed;top:0;left:0;width:100%;height:100%;background-color:#0000004d}.overlay[data-v-e1ac5f6f]:has(+.poloclub-drawer.open){display:block}.poloclub-drawer[data-v-e1ac5f6f]{z-index:99999999999;position:fixed;overflow-y:auto;width:100%;padding:2rem 15px;background-color:#fff;box-sizing:border-box;display:flex;flex-direction:column;gap:2rem}.poloclub-drawer.top[data-v-e1ac5f6f],.poloclub-drawer.bottom[data-v-e1ac5f6f],.poloclub-drawer.left[data-v-e1ac5f6f]{left:0}.poloclub-drawer.right[data-v-e1ac5f6f]{right:0}.poloclub-drawer.top[data-v-e1ac5f6f],.poloclub-drawer.left[data-v-e1ac5f6f],.poloclub-drawer.right[data-v-e1ac5f6f]{top:0}.poloclub-drawer.bottom[data-v-e1ac5f6f]{bottom:0}.poloclub-drawer.left[data-v-e1ac5f6f],.poloclub-drawer.right[data-v-e1ac5f6f]{height:var(--46c12154)}.poloclub-drawer.top[data-v-e1ac5f6f],.poloclub-drawer.bottom[data-v-e1ac5f6f]{height:var(--75e3c74a)}.poloclub-drawer .poloclub-drawer-header[data-v-e1ac5f6f]{display:flex;justify-content:space-between;align-items:center}.poloclub-drawer .poloclub-drawer-header p[data-v-e1ac5f6f]{font-size:1.8rem;color:var(--color-black)}.drawer-right-enter-active[data-v-e1ac5f6f],.drawer-right-leave-active[data-v-e1ac5f6f],.drawer-left-enter-active[data-v-e1ac5f6f],.drawer-left-leave-active[data-v-e1ac5f6f],.drawer-top-enter-active[data-v-e1ac5f6f],.drawer-top-leave-active[data-v-e1ac5f6f],.drawer-bottom-enter-active[data-v-e1ac5f6f],.drawer-bottom-leave-active[data-v-e1ac5f6f]{transition:transform .6s ease-in-out}.drawer-right-enter-from[data-v-e1ac5f6f],.drawer-right-leave-to[data-v-e1ac5f6f]{transform:translate(100%)}.drawer-left-enter-from[data-v-e1ac5f6f],.drawer-left-leave-to[data-v-e1ac5f6f]{transform:translate(-100%)}.drawer-top-enter-from[data-v-e1ac5f6f],.drawer-top-leave-to[data-v-e1ac5f6f]{transform:translateY(-100%)}.drawer-bottom-enter-from[data-v-e1ac5f6f],.drawer-bottom-leave-to[data-v-e1ac5f6f]{transform:translateY(100%)}.drawer-right-leave-from[data-v-e1ac5f6f],.drawer-right-enter-to[data-v-e1ac5f6f],.drawer-left-enter-to[data-v-e1ac5f6f],.drawer-left-leave-from[data-v-e1ac5f6f]{transform:translate(0)}.drawer-top-enter-to[data-v-e1ac5f6f],.drawer-top-leave-from[data-v-e1ac5f6f],.drawer-bottom-leave-from[data-v-e1ac5f6f],.drawer-bottom-enter-to[data-v-e1ac5f6f]{transform:translateY(0)}@media (width >=768px){.poloclub-drawer[data-v-e1ac5f6f]{padding:2rem 25px}.poloclub-drawer .poloclub-drawer-header p[data-v-e1ac5f6f]{font-size:2.4rem}.poloclub-drawer.right[data-v-e1ac5f6f],.poloclub-drawer.left[data-v-e1ac5f6f]{max-width:50rem}}@media (width >=1024px){.poloclub-drawer[data-v-e1ac5f6f]{padding:2rem 50px}}@media (prefers-reduced-motion: reduce){.drawer-right-enter-active[data-v-e1ac5f6f],.drawer-right-leave-active[data-v-e1ac5f6f],.drawer-left-enter-active[data-v-e1ac5f6f],.drawer-left-leave-active[data-v-e1ac5f6f],.drawer-top-enter-active[data-v-e1ac5f6f],.drawer-top-leave-active[data-v-e1ac5f6f],.drawer-bottom-enter-active[data-v-e1ac5f6f],.drawer-bottom-leave-active[data-v-e1ac5f6f]{transition:none}}", Pi = /* @__PURE__ */ Pe(vT, [["styles", [yT]], ["__scopeId", "data-v-e1ac5f6f"]]), rn = (i) => i ? i.availableForSale : !1, bT = "*,*:before,*:after{box-sizing:border-box}p,:deep(p){margin:0;padding:0}h1,h2{margin:0}*{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.container-things{display:flex;flex-direction:column;gap:1rem;width:100%}.container-things>p{font-size:1.4rem;color:var(--color-black)}", ST = {}, kT = { class: "container-things" };
function TT(i, e) {
  return P(), N("div", kT, [
    na(i.$slots, "default")
  ]);
}
const Vl = /* @__PURE__ */ Pe(ST, [["render", TT], ["styles", [bT]]]), ET = { class: "back-in-stock" }, xT = { class: "back-in-stock-container" }, _T = { class: "form-row form-row--email" }, AT = ["placeholder"], wT = ["disabled"], LT = { class: "form-checkboxes" }, IT = { class: "form-row form-row--checkbox" }, CT = { for: "consent-to-process" }, RT = { class: "form-row form-row--checkbox" }, PT = { for: "subscribe-communications" }, DT = {
  key: 0,
  class: "spinner-container"
}, NT = {
  key: 0,
  class: "form-submission-result"
}, MT = /* @__PURE__ */ Re({
  __name: "PoloclubBackInStockForm.ce",
  props: {
    product: { type: null },
    variant: { type: null },
    block: { type: null }
  },
  setup(i) {
    const e = ge(""), t = ge(!1), n = ge(!1), s = ge(!1), r = ge(""), a = ge(""), l = `https://api.hsforms.com/submissions/v3/integration/submit/27231861/${i.block.backInStockFormIdHubspot}`, d = le(() => {
      const u = document.cookie.split("; ").find((f) => f.startsWith("hubspotutk="));
      return u ? u.split("=")[1] : "";
    }), c = async () => {
      if (a.value = "", !e.value.trim()) {
        a.value = i.block.backInStockEmailEmptyErrorText;
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.value)) {
        a.value = i.block.backInStockEmailFormatErrorText;
        return;
      }
      if (!t.value) {
        a.value = i.block.backInStockPrivacyPolicyEmptyErrorText;
        return;
      }
      s.value = !0, r.value = "";
      const f = {
        fields: [
          { name: "email", value: e.value },
          {
            name: "back_in_stock_json",
            value: JSON.stringify({
              product_id: i.product.id.split("/").pop(),
              variant_title: i.variant?.title || ""
            })
          },
          { name: "newsletter_language", value: window.Shopify?.locale || "" }
        ],
        context: {
          hutk: d.value,
          pageUri: window.location.href,
          pageName: document.title
        },
        legalConsentOptions: {
          consent: {
            consentToProcess: t.value,
            text: "By signing up, you accept our Privacy Policy.",
            communications: [
              {
                value: n.value,
                subscriptionTypeId: 178667791,
                text: "I agree to receive other communications from Polo Club."
              }
            ]
          }
        }
      };
      try {
        const h = await fetch(l, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(f)
        });
        if (h.ok)
          r.value = i.block.backInStockSubmitSuccessText, e.value = "", t.value = !1, n.value = !1;
        else {
          const m = await h.json();
          console.error("HubSpot Error:", m), r.value = i.block.backInStockSubmitErrorText;
        }
      } catch (h) {
        console.error(h), r.value = i.block.backInStockSubmitErrorText;
      } finally {
        s.value = !1;
      }
    };
    return Dt(() => i.product, (u) => {
      u && (r.value = "");
    }), Dt(() => i.variant, (u) => {
      u && (r.value = "");
    }), (u, f) => (P(), N("div", ET, [
      w("div", xT, [
        w("p", null, ie(u.block.backInStockHeading), 1),
        w("form", {
          onSubmit: oa(c, ["prevent"])
        }, [
          w("div", _T, [
            ar(w("input", {
              "onUpdate:modelValue": f[0] || (f[0] = (h) => e.value = h),
              type: "text",
              name: "email",
              id: "email",
              placeholder: u.block.backInStockEmailPlaceholder
            }, null, 8, AT), [
              [s0, e.value]
            ]),
            w("button", {
              type: "submit",
              disabled: s.value
            }, ie(u.block.backInStockButtonText), 9, wT)
          ]),
          w("p", {
            class: Ke(["form-error", { "form-error--visible": a.value }])
          }, ie(a.value ? a.value : "Error placeholder"), 3),
          w("div", LT, [
            w("div", IT, [
              ar(w("input", {
                type: "checkbox",
                "onUpdate:modelValue": f[1] || (f[1] = (h) => t.value = h),
                name: "consent-to-process",
                id: "consent-to-process"
              }, null, 512), [
                [Ld, t.value]
              ]),
              w("label", CT, ie(u.block.backInStockPrivacyPolicyText), 1)
            ]),
            w("div", RT, [
              ar(w("input", {
                type: "checkbox",
                "onUpdate:modelValue": f[2] || (f[2] = (h) => n.value = h),
                name: "subscribe-communications",
                id: "subscribe-communications"
              }, null, 512), [
                [Ld, n.value]
              ]),
              w("label", PT, ie(u.block.backInStockSubscribeCommunicationsText), 1)
            ])
          ])
        ], 32)
      ]),
      s.value || r.value ? (P(), N("div", DT, [
        r.value ? (P(), N("p", NT, ie(r.value), 1)) : (P(), Ie(bi, {
          key: 1,
          theme: "dark",
          width: "24px"
        }))
      ])) : U("", !0)
    ]));
  }
}), OT = `[data-v-9e9167df],[data-v-9e9167df]:before,[data-v-9e9167df]:after{box-sizing:border-box}p[data-v-9e9167df],[data-v-9e9167df] p{margin:0;padding:0}h1[data-v-9e9167df],h2[data-v-9e9167df]{margin:0}[data-v-9e9167df]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.back-in-stock[data-v-9e9167df]{position:relative}.back-in-stock .back-in-stock-container[data-v-9e9167df]{display:flex;flex-direction:column;gap:1rem}.back-in-stock .back-in-stock-container>p[data-v-9e9167df]{font-size:14px;color:var(--color-black)}.back-in-stock .spinner-container[data-v-9e9167df]{position:absolute;top:0;left:0;display:flex;align-items:center;justify-content:center;width:100%;height:100%;background-color:#ffffffb3}.back-in-stock .spinner-container .form-submission-result[data-v-9e9167df]{font-size:14px;color:var(--color-black)}form[data-v-9e9167df]{display:flex;flex-direction:column;position:relative}.form-error[data-v-9e9167df]{color:red;font-size:12px;opacity:0}.form-error.form-error--visible[data-v-9e9167df]{opacity:1}.form-checkboxes[data-v-9e9167df]{display:flex;flex-direction:column;gap:.5rem}.form-row[data-v-9e9167df]{display:flex;gap:.5rem}.form-row--email[data-v-9e9167df]{align-items:center;justify-content:space-between;border-bottom:1px solid var(--color-border-gray);font-size:14px;color:var(--color-black);padding-bottom:.5rem}.form-row--email input[data-v-9e9167df]{all:unset;box-sizing:border-box;flex:1}.form-row--email button[data-v-9e9167df]{all:unset;box-sizing:border-box;cursor:pointer}.form-row--checkbox[data-v-9e9167df]{align-items:center;font-size:12px;color:var(--color-black)}.form-row--checkbox input[data-v-9e9167df]{-webkit-appearance:none;appearance:none;display:grid;place-content:center;width:16px;height:16px;margin:0;border:1px solid var(--color-gray-secondary);background-color:#fff;transform:translateY(-.075em);cursor:pointer}.form-row--checkbox input[data-v-9e9167df]:checked{background-color:var(--color-black)}.form-row--checkbox input[type=checkbox][data-v-9e9167df]:checked:before{content:url("data:image/svg+xml,%3Csvg width='9' height='7' viewBox='0 0 9 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.94953 6.75L0 3.81408L0.730821 3.08663L2.94953 5.2951L8.26918 0L9 0.727449L2.94953 6.75Z' fill='white'/%3E%3C/svg%3E")}.form-row--checkbox label[data-v-9e9167df]{cursor:pointer}`, FT = /* @__PURE__ */ Pe(MT, [["styles", [OT]], ["__scopeId", "data-v-9e9167df"]]), Br = {
  openDrawer(i) {
    const e = document.querySelector(i);
    e ? (e.classList.add("is-active"), setTimeout(() => {
      e.classList.add("is-visible");
    }, 1)) : console.error(`Drawer ${i} not found`);
  }
}, hu = () => [
  {
    id: "drawer-cart",
    section: window.renderCartSection,
    selector: "#drawer-cart"
  },
  {
    id: "cart-icon-bubble",
    section: "cart-icon-bubble",
    selector: ".shopify-section"
  }
], $T = (i, e) => new DOMParser().parseFromString(i, "text/html").querySelector(e)?.innerHTML || "", BT = (i) => {
  const e = document.querySelector("cart-items"), t = document.getElementById("main-cart-footer"), n = document.getElementById("checkout");
  e?.classList.remove("is-empty"), t?.classList.remove("is-empty"), n && (n.disabled = !1);
  const s = document.querySelector(`li[data-id="${i.variant_id}"]`);
  let r = 1;
  if (s) {
    const a = s.getAttribute("data-index");
    a && (r = parseInt(a));
  }
  return { line: r, quantity: i.quantity };
}, UT = async (i, e) => {
  const t = JSON.stringify({
    line: i,
    quantity: e,
    sections: hu().map((s) => s.section),
    sections_url: window.location.pathname
  }), n = await fetch(`${window.routes.cart_change_url}`, {
    ...window.fetchConfig(),
    body: t
  });
  if (n.status === 200) {
    const s = await n.json();
    s && (hu().forEach((r) => {
      const a = document.getElementById(r.id)?.querySelector(r.selector) || document.getElementById(r.id);
      a && (a.innerHTML = $T(
        s.sections[r.section],
        r.selector
      ));
    }), window.clarity && window.clarity("event", "add_to_cart"), Br.openDrawer("drawer-cart"));
  }
}, _m = async (i, e, t) => {
  if (!e || !rn(e)) throw new Error("Variant not available for sale");
  const n = i?.productActionMetafield?.value, s = window.fetchConfig("javascript");
  s.method = "POST", s.headers["X-Requested-With"] = "XMLHttpRequest";
  const r = {
    id: e?.id.split("/").pop() || "",
    quantity: 1,
    properties: {}
  };
  n && (r.properties._product_action = n), t && (r.properties = { ...r.properties, ...t }), s.body = JSON.stringify(r);
  try {
    const a = await fetch(`${window.routes.cart_add_url}`, s);
    if (a.status === 200) {
      const o = await a.json();
      if (o) {
        const { line: l, quantity: d } = BT(o);
        await UT(l, d);
      }
    }
  } catch {
    throw new Error("Error adding to cart");
  }
}, Gl = "https://vfr-v3-production.sizebay.technology/", VT = "https://vfr-v3-production.sizebay.technology/V4/", GT = "https://vfr-redesigned.sizebay.technology/", HT = "https://vfr-v3-production.sizebay.technology/V4/", zT = "https://vfr-redesigned.sizebay.technology/", ye = Zi({
  isInitialized: !1,
  currentProductId: null,
  productId: "",
  sid: "",
  isAccessory: !1,
  isShoe: !1,
  recommendedSize: null,
  productCache: /* @__PURE__ */ new Map(),
  isInitializing: !1
}), mu = ge(F.locale.replace("pt-PT", "pt")), ns = ge(() => ({
  "pccha.myshopify.com": 3709,
  "pccha-eu.myshopify.com": 3716,
  "polo-club-uk.myshopify.com": 4941
})[F.permanentShopDomain] || 3709), KT = () => typeof navigator < "u" && [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i].some((e) => navigator.userAgent.match(e)), jT = () => typeof navigator < "u" && [/iPad/i, /Tablet/i].some((e) => navigator.userAgent.match(e)), WT = () => typeof window < "u" && window?.navigator?.standalone === !0, Ko = () => typeof window > "u" ? "DESKTOP" : WT() ? "APP" : jT() ? "TABLET" : KT() ? "MOBILE" : "DESKTOP", qT = (i) => {
  if (typeof document > "u") return "";
  const e = `${i}=`, t = document.cookie.split(";");
  for (let n = 0; n < t.length; n += 1) {
    let s = t[n];
    for (; s.charAt(0) === " "; ) s = s.substring(1);
    if (s.indexOf(e) === 0) return s.substring(e.length, s.length);
  }
  return "";
}, YT = (i, e) => {
  if (typeof window > "u" || typeof document > "u") return;
  const t = `; domain=${window.location.hostname.replace("www.", ".")}`;
  document.cookie = `${i}=${e}; path=/${t}`;
}, Am = async (i, e = {}) => {
  const t = {
    ...e,
    headers: {
      ...e.headers || {},
      referer: e?.permalink ?? "",
      "x-szb-tenant-id": String(ns.value()),
      "x-szb-device": Ko(),
      "x-szb-country": F.localizationCountry
    },
    referrerPolicy: "origin-when-cross-origin"
  };
  try {
    const n = await fetch(i, t), a = (n.headers.get("content-type") || "").includes("application/json") ? await n.json() : await n.text();
    return {
      ...typeof a == "object" && a || { message: a },
      status: n.status,
      error: n.status === 500 || n.status === 404
    };
  } catch {
    return console.error(`An error ocurred while fetching data from ${i}.`), { error: !0, message: "Cannot fetch resource", status: 500 };
  }
}, XT = async (i) => {
  try {
    const e = await fetch(`${Gl}${i}`, { method: "GET" });
    if (e.ok) return await e.json();
  } catch {
  }
  console.error("SID not found");
}, ZT = async () => {
  const i = await XT("api/me/session-id") || "";
  return i && YT("SIZEBAY_SESSION_ID_V4", i), i;
}, QT = async (i, e) => {
  const t = `${i}-${e}`;
  if (ye.productCache.has(t))
    return ye.productCache.get(t);
  const n = `${Gl}plugin/my-product-id?sid=${e}&permalink=${encodeURIComponent(i)}`, s = await Am(n, { method: "GET", permalink: i }), r = !s.error && s.status !== 500 && s.status !== 404, a = s.status === 404 && typeof s.message == "string" && !s.message.includes("Not product found");
  if (r && s.id) {
    const o = {
      id: String(s.id),
      accessory: !!s.accessory,
      shoe: !!s.shoe
    };
    return ye.productCache.set(t, o), o;
  }
  return null;
}, pu = async (i, e, t) => Am(`${Gl}api/me/analysis/${i}?sid=${e}&tenant=${t}`, {
  method: "GET"
}), JT = async (i) => {
  try {
    const e = F.productView.product;
    if (!e) {
      console.error("No product available for add to cart");
      return;
    }
    const t = e.variants.nodes.find((n) => n.title === i.size);
    if (!t) {
      console.error(`Variant with size "${i.size}" not found`);
      return;
    }
    if (!rn(t)) {
      console.error(`Variant with size "${i.size}" is not available for sale`);
      return;
    }
    await _m(e, t, {
      _sizebay_recommended: "true",
      _sizebay_size: i.size
    }), console.log(`Successfully added ${i.quantity} item(s) of size "${i.size}" to cart`);
  } catch (e) {
    console.error("Error adding Sizebay recommended item to cart:", e);
  }
}, jt = {
  state: ye,
  get sizes() {
    const i = F.productView.product?.variants.nodes.map((e) => e.title) || [];
    return btoa(JSON.stringify(i));
  },
  get sizesInStock() {
    return (F.productView.product?.variants.nodes || []).filter((e) => rn(e)).map((e) => e.title).join(",");
  },
  get iframeSrc() {
    if (!ye.productId || !ye.sid) return "";
    const e = Ko() === "MOBILE" ? "&configProfile=mobileProfile" : "";
    return `${ye.isShoe ? GT : VT}?mode=vfr&id=${ye.productId}&sid=${ye.sid}&tenantId=${ns.value()}&lang=${mu.value}&sizes=${this.sizes}&sizesInStock=${this.sizesInStock}&watchOpeningEvents=true${e}`;
  },
  get chartIframeSrc() {
    if (!ye.productId || !ye.sid) return "";
    const e = Ko() === "MOBILE" ? "&configProfile=mobileProfile" : "";
    return `${ye.isShoe ? zT : HT}?mode=chart&id=${ye.productId}&sid=${ye.sid}&tenantId=${ns.value()}&lang=${mu.value}&sizes=${this.sizes}&sizesInStock=${this.sizesInStock}&watchOpeningEvents=true${e}`;
  },
  async initialize(i) {
    if (!ye.isInitializing && !(ye.isInitialized && ye.currentProductId === i)) {
      ye.isInitializing = !0;
      try {
        if (typeof window > "u") return;
        const e = `https://${window.location.host}/products/${i}`;
        ye.sid || (ye.sid = qT("SIZEBAY_SESSION_ID_V4") || await ZT()), ye.currentProductId = i, ye.productId = "", ye.isAccessory = !1, ye.isShoe = !1, ye.recommendedSize = null;
        const t = await QT(e, ye.sid);
        if (t) {
          ye.productId = t.id, ye.isAccessory = t.accessory, ye.isShoe = !!t.shoe;
          const n = await pu(ye.productId, ye.sid, ns.value());
          n && n.recommendedSize ? ye.recommendedSize = String(n.recommendedSize) : ye.recommendedSize = null;
        }
        ye.isInitialized = !0;
      } catch (e) {
        console.error("Error initializing Sizebay:", e);
      } finally {
        ye.isInitializing = !1;
      }
    }
  },
  async updateRecommendation() {
    if (!ye.productId || !ye.sid) return;
    const i = await pu(ye.productId, ye.sid, ns.value());
    i && i.recommendedSize ? ye.recommendedSize = String(i.recommendedSize) : ye.recommendedSize = null;
  },
  reset() {
    ye.isInitialized = !1, ye.currentProductId = null, ye.productId = "", ye.isAccessory = !1, ye.isShoe = !1, ye.recommendedSize = null, ye.isInitializing = !1;
  },
  clearCache() {
    ye.productCache.clear();
  },
  setupMessageListener() {
    if (typeof window > "u") return;
    const i = (e) => {
      try {
        const t = e.data;
        t && typeof t == "object" && t.id === "szb-compose-add-to-cart" && JT(t);
      } catch (t) {
        console.error("Error processing Sizebay message:", t);
      }
    };
    window.addEventListener("message", i), window.__sizebayMessageHandler = i;
  },
  removeMessageListener() {
    if (typeof window > "u") return;
    const i = window.__sizebayMessageHandler;
    i && (window.removeEventListener("message", i), delete window.__sizebayMessageHandler);
  }
}, eE = { class: "sizebay-container" }, tE = {
  key: 2,
  class: "sizebay-recommendation"
}, iE = ["src"], nE = /* @__PURE__ */ Re({
  __name: "Sizebay.ce",
  props: {
    block: { type: Object }
  },
  setup(i) {
    const e = ge(!1), t = ge(!1), n = ge(null), s = ge(0), r = le(() => jt.state.isAccessory), a = le(() => jt.state.recommendedSize), o = le(() => !!(jt.state.productId && jt.state.sid)), l = le(() => !e.value || !n.value ? "" : n.value === "chart" ? jt.chartIframeSrc : jt.iframeSrc);
    let d = null;
    const c = () => {
      t.value = !0;
    }, u = (v) => {
      !jt.state.productId || !jt.state.sid || (n.value = v, t.value = !1, e.value = !0, typeof window < "u" && (d = (p) => {
        p.data === "close-fitting-room" && f();
      }, window.addEventListener("message", d), document.querySelector("html")?.classList.add("vfr-modal-active"), document.body.style.overflow = "hidden"));
    }, f = async () => {
      e.value = !1, typeof window < "u" && (d && window.removeEventListener("message", d), d = null, document.querySelector("html")?.classList.remove("vfr-modal-active"), document.body.style.overflow = ""), await jt.updateRecommendation();
    }, h = () => {
      u("vfr");
    }, m = () => {
      u("chart");
    }, g = async () => {
      if (typeof window > "u") return;
      const v = F.productView.product?.id?.split("/").pop();
      v && await jt.initialize(v);
    };
    return wt(() => {
      g(), jt.setupMessageListener();
    }), Fs(() => {
      d && typeof window < "u" && window.removeEventListener("message", d), typeof document < "u" && (document.body.style.overflow = "", document.querySelector("html")?.classList.remove("vfr-modal-active")), jt.removeMessageListener();
    }), Dt(
      () => F.productView.product?.id,
      async (v, p) => {
        !v || v === p || (await g(), e.value && (t.value = !1, s.value += 1));
      }
    ), (v, p) => (P(), N("div", eE, [
      o.value && !r.value ? (P(), N("p", {
        key: 0,
        class: "sizebay-button",
        onClick: h
      }, ie(v.block.sizeRecommenderText), 1)) : U("", !0),
      o.value ? (P(), N("p", {
        key: 1,
        class: "sizebay-button",
        onClick: m
      }, ie(v.block.sizeGuideText), 1)) : U("", !0),
      a.value ? (P(), N("p", tE, [
        sn(ie(L(Je).sizeRecommended) + " ", 1),
        w("span", null, ie(a.value), 1)
      ])) : U("", !0),
      e.value ? (P(), N("div", {
        key: 3,
        class: "vfr__container--backdrop visible szb-modal-open",
        onClick: oa(f, ["self"])
      }, [
        (P(), N("iframe", {
          id: "szb-modal",
          class: Ke(["vfr-app", { "modal-loading": !t.value, "modal-loaded": t.value, "szb-modal-desktop": !0 }]),
          key: s.value,
          src: l.value,
          onLoad: c
        }, null, 42, iE))
      ])) : U("", !0)
    ]));
  }
}), sE = ".sizebay-container[data-v-d05366ec]{display:grid;grid-template-columns:repeat(2,1fr);gap:.5rem;min-height:5.2rem}.sizebay-button[data-v-d05366ec]{color:var(--color-border-hover);font-size:1.4rem;text-decoration:underline;text-underline-offset:3px;cursor:pointer}.sizebay-recommendation[data-v-d05366ec]{font-size:1.2rem;color:var(--color-border-hover)}.sizebay-recommendation>span[data-v-d05366ec]{font-weight:600;color:var(--color-black)}.vfr__container--backdrop[data-v-d05366ec]{position:fixed;inset:0;background:#0006;display:flex;align-items:center;justify-content:center;z-index:9999;overflow:hidden}.vfr-app[data-v-d05366ec]{width:min(900px,95vw);height:min(85vh,700px);border:0;background:#fff}.modal-loading[data-v-d05366ec]{opacity:0}.modal-loaded[data-v-d05366ec]{opacity:1;transition:opacity .15s ease-in}.vfr__container--backdrop[data-v-d05366ec]{z-index:99999;display:none;position:fixed;top:0;right:0;width:100%;height:100%;opacity:0;background:#000c}.szb-modal-open[data-v-d05366ec]{opacity:1;display:flex;justify-content:flex-end}.szb-modal-desktop[data-v-d05366ec]{width:100%;height:100%}@media (width >=768px){.szb-modal-desktop[data-v-d05366ec]{width:50rem}}", rE = /* @__PURE__ */ Pe(nE, [["styles", [sE]], ["__scopeId", "data-v-d05366ec"]]), Fe = Zi({
  product: {},
  drawers: {
    variants: "closed",
    colors: "closed",
    similarProducts: "closed",
    specialConditions: "closed",
    details: "closed"
  },
  similarProducts: {
    products: [],
    selectedVariant: {},
    status: "idle"
  }
}), Hl = { definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ProductCardFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Product" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "handle" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "title" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "vendor" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "productType" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "tags" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "totalInventory" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "featuredImage" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "altText" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "url" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "desktop" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "800" } }] } }], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "tablet" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "700" } }] } }], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "mobile" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "500" } }] } }], directives: [] }, { kind: "Field", name: { kind: "Name", value: "width" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "height" }, arguments: [], directives: [] }] } }, { kind: "Field", name: { kind: "Name", value: "variants" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxVariants" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "title" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "barcode" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "sku" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "availableForSale" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "quantityAvailable" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "price" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "currencyCode" }, arguments: [], directives: [] }] } }, { kind: "Field", name: { kind: "Name", value: "compareAtPrice" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "currencyCode" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "highlightedPriceMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "price", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "highlighted", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "privatePriceMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "markets", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "private_price_default", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "privatePriceMetafieldPolonia" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "markets", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "private_price_polonia", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "middlePriceMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "markets", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "middle_price_default", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "middlePriceMetafieldPolonia" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "markets", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "middle_price_polonia", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "productCategory" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "category", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "privateFontColorMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "private", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "font_color", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "privateBgColorMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "private", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "background_color", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "envio5_7_diasMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "envio", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "envio5_a_7_dias", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "backInStockMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "extra", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "back_in_stock", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "lastUnitsMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "extra", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "last_units", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "showSimilarMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "extra", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "show_similar", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "mainStockMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "stock", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "main", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "reserveStockMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "stock", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "reserve", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "preorderMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "extra", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "preorder", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "reference" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Metaobject" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "date" }, name: { kind: "Name", value: "field" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "date", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "previewText" }, name: { kind: "Name", value: "field" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "preview_text", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "text" }, name: { kind: "Name", value: "field" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "text", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "partialShipping" }, name: { kind: "Name", value: "field" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "partial_shipping", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxMedia" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "previewImage" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "altText" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "url" }, arguments: [], directives: [] }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MediaImage" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "altText" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "url" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "desktop" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "800" } }] } }], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "tablet" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "700" } }] } }], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "mobile" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "500" } }] } }], directives: [] }, { kind: "Field", name: { kind: "Name", value: "width" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "height" }, arguments: [], directives: [] }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Video" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sources" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "format" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "width" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "height" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "mimeType" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "url" }, arguments: [], directives: [] }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "colorsMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "related", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "colors", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "references" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxColors" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Product" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableForSale" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "title" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "tags" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "colorMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "color", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", name: { kind: "Name", value: "images" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxMedia" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "altText" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "url" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "desktop" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "800" } }] } }], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "tablet" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "700" } }] } }], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "mobile" }, name: { kind: "Name", value: "url" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "transform" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "maxWidth" }, value: { kind: "IntValue", value: "500" } }] } }], directives: [] }, { kind: "Field", name: { kind: "Name", value: "width" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "height" }, arguments: [], directives: [] }] } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "productLabelsMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "extra", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "label", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "categoryMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "category", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "locMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "loc", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "productActionMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "product_action", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "filterColorMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "filters", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "color", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "modelMetafield" }, name: { kind: "Name", value: "metafield" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "namespace" }, value: { kind: "StringValue", value: "info", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "key" }, value: { kind: "StringValue", value: "model", block: !1 } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }] } }] }, aE = `#import "./fragments/productCardFields.graphql"

query getProductsShowSimilar(
  $first: Int
  $query: String!
  $maxColors: Int
  $maxMedia: Int
  $maxVariants: Int
  $locale: LanguageCode
  $sortKey: ProductSortKeys
  $country: CountryCode!
) @inContext(country: $country, language: $locale) {
  products(first: $first, query: $query, sortKey: $sortKey) {
    nodes {
      ...ProductCardFields
    }
  }
}
`, Ur = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProductsShowSimilar" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxColors" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxMedia" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxVariants" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NamedType", name: { kind: "Name", value: "LanguageCode" } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "sortKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ProductSortKeys" } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "country" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CountryCode" } } }, directives: [] }], directives: [{ kind: "Directive", name: { kind: "Name", value: "inContext" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "country" }, value: { kind: "Variable", name: { kind: "Name", value: "country" } } }, { kind: "Argument", name: { kind: "Name", value: "language" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "Variable", name: { kind: "Name", value: "sortKey" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProductCardFields" }, directives: [] }] } }] } }] } }], loc: { start: 0, end: 447, source: { name: "GraphQL request", locationOffset: { line: 1, column: 1 }, body: aE } } }, oE = (i) => {
  const e = {};
  return i.filter(function(t) {
    if (t.kind !== "FragmentDefinition")
      return !0;
    const n = t.name.value;
    return e[n] ? !1 : (e[n] = !0, !0);
  });
};
Ur.definitions = oE(Ur.definitions.concat(Hl.definitions));
const lE = (i, e) => {
  const t = (c, u) => {
    if (c.kind === "FragmentSpread")
      u.add(c.name.value);
    else if (c.kind === "VariableDefinition") {
      const f = c.type;
      f.kind === "NamedType" && u.add(f.name.value);
    }
    return c && "selectionSet" in c && c.selectionSet && c.selectionSet.selections.forEach((f) => {
      t(f, u);
    }), c && "variableDefinitions" in c && c.variableDefinitions && c.variableDefinitions.forEach((f) => {
      t(f, u);
    }), c && "definitions" in c && c.definitions && c.definitions.forEach((f) => {
      t(f, u);
    }), u;
  }, n = (c) => {
    const u = {};
    return c.definitions.forEach(function(f) {
      "name" in f && f.name && (u[f.name.value] = t(f, /* @__PURE__ */ new Set()));
    }), u;
  }, s = (c, u) => {
    for (let f = 0; f < c.definitions.length; f++) {
      const h = c.definitions[f];
      if (h && "name" in h && h.name && h.name.value == u)
        return h;
    }
  }, r = n(i), a = Object.assign({}, i, {
    definitions: [s(i, e)]
  }), o = r[e] || /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set();
  let d = /* @__PURE__ */ new Set();
  for (o.forEach((c) => {
    d.add(c);
  }); d.size > 0; ) {
    const c = d;
    d = /* @__PURE__ */ new Set(), c.forEach((u) => {
      l.has(u) || (l.add(u), (r[u] || /* @__PURE__ */ new Set()).forEach((h) => {
        d.add(h);
      }));
    });
  }
  return l.forEach((c) => {
    const u = s(i, c);
    u && a.definitions.push(u);
  }), a;
};
lE(Ur, "getProductsShowSimilar");
const dE = 25, cE = 25, uE = 50, fE = 50, hE = "BEST_SELLING", mE = ["CAMISETA", "POLO", "CAMISA", "JERSEY", "CARDIGAN", "PANTALON", "BERMUDAS", "VESTIDO", "TANK TOP", "FALDA", "SUDADERA", "CHAQUETA", "CHALECO", "CALZADO", "PACK", "ACCESORIOS", "CINTURÓN", "TOTE BAG", "MOCHILA", "CORBATA", "UNDERWEAR"], pE = ["AMARILLO", "AZUL", "BEIGE", "BLANCO", "FUCSIA", "GRIS", "LILA", "MARRÓN", "MULTICOLOR", "NARANJA", "NEGRO", "ROJO", "ROSA", "VERDE"], gE = ["HOMBRE", "MUJER"], vE = async ({
  product: i,
  selectedVariant: e
}) => {
  if (!i) return [];
  const t = ua();
  if (!t) throw new Error("Shopify client not initialized");
  const n = i?.tags.find((c) => mE.includes(c)), s = i?.tags.find((c) => pE.includes(c)), r = i?.tags.find((c) => gE.includes(c)), a = da(Ur), o = async (c) => {
    const u = {
      first: dE,
      query: c,
      country: F.localizationCountry,
      locale: F.locale.replace(/-/g, "_").toUpperCase(),
      maxColors: uE,
      maxMedia: cE,
      maxVariants: fE,
      sortKey: hE
    }, f = await t.request(
      a,
      { variables: u }
    ), h = f.data?.products?.nodes;
    return Array.isArray(f.errors?.graphQLErrors) && f.errors.graphQLErrors.length > 0 && console.error("GraphQL errors:", f.errors.graphQLErrors), h ? h.filter((m) => m.variants.nodes.some((g) => g.title === e.title && rn(g))) : (console.warn(`Products with query ${c} not found`), []);
  }, l = `tag:SELECCIÓN AND tag:STOCK AND tag:${r} AND tag:${n} AND tag:${s}`;
  let d = await o(l);
  if (!d.length) {
    const c = `tag:SELECCIÓN AND tag:STOCK AND tag:${r} AND tag:${s}`;
    if (d = await o(c), !d.length)
      return console.warn(`No similar products found for ${i.title} with variant ${e.title}`), [];
  }
  return d;
}, yE = { key: 0 }, bE = { class: "variants__wrapper" }, SE = ["onClick"], kE = /* @__PURE__ */ Re({
  __name: "PoloclubProductVariants.ce",
  props: {
    product: { type: null },
    selectedVariant: { type: null },
    showHeading: { type: Boolean, default: !0 },
    block: { type: null }
  },
  setup(i) {
    const e = ge(!1), t = ge(null), n = (a) => {
      const o = rn(a);
      return o && a.lastUnitsMetafield?.value === "true" ? {
        type: "last-units",
        show: !0,
        text: i.block.lastUnitsVariantLabel,
        class: "last-units"
      } : !o && i.block.enableBackInStockHubspot && i.block.backInStockFormIdHubspot && i.product.backInStockMetafield?.value === "true" && a.backInStockMetafield?.value === "true" ? {
        type: "back-in-stock",
        show: !0,
        text: i.block.backInStockVariantLabel,
        class: "back-in-stock"
      } : !o && a.showSimilarMetafield?.value === "true" ? {
        type: "show-similar",
        show: !0,
        text: i.block.showSimilarVariantLabel,
        class: "show-similar"
      } : o ? { type: "", show: !1, text: "", class: "" } : {
        type: "sold-out",
        show: !0,
        text: i.block.soldOutVariantLabel,
        class: "sold-out"
      };
    }, s = le(() => i.product?.variants?.nodes || []), r = async (a) => {
      const o = n(a).type;
      if (F.productView.selectedVariant.variant = null, o === "sold-out")
        return;
      const l = o === "back-in-stock";
      if (e.value = l, t.value = l ? a : null, o === "show-similar") {
        Fe.similarProducts.selectedVariant = a, Fe.drawers.similarProducts = "open", Fe.similarProducts.status = "pending";
        try {
          Fe.similarProducts.products = await vE({
            product: F.productView.product,
            selectedVariant: a
          }), Fe.similarProducts.status = "success";
        } catch (d) {
          console.error("Error getting similar products:", d), Fe.similarProducts.status = "error";
        }
        return;
      }
      F.productView.selectedVariant.variant = a, Fe.drawers.variants = "closed";
    };
    return Dt(() => i.product, (a) => {
      a && (e.value = !1);
    }), (a, o) => (P(), Ie(Vl, null, {
      default: Xe(() => [
        a.showHeading ? (P(), N("p", yE, ie(L(Je).selectASize), 1)) : U("", !0),
        w("div", bE, [
          (P(!0), N(ve, null, pt(s.value, (l, d) => (P(), N("div", {
            key: d,
            onClick: (c) => r(l),
            class: Ke(["variant", [{ selected: a.selectedVariant?.id === l.id }, n(l).type]])
          }, [
            w("p", null, ie(l.title), 1),
            n(l).show ? (P(), N("p", {
              key: 0,
              class: Ke(n(l).class)
            }, ie(n(l).text), 3)) : U("", !0)
          ], 10, SE))), 128))
        ]),
        de(rE, { block: a.block }, null, 8, ["block"]),
        L(he).enable_hubspot && a.block.enableBackInStockHubspot && a.block.backInStockFormIdHubspot ? ar((P(), Ie(FT, {
          key: 1,
          product: a.product,
          variant: t.value,
          block: a.block
        }, null, 8, ["product", "variant", "block"])), [
          [Hg, e.value]
        ]) : U("", !0)
      ]),
      _: 1
    }));
  }
}), TE = "[data-v-d34029ca],[data-v-d34029ca]:before,[data-v-d34029ca]:after{box-sizing:border-box}p[data-v-d34029ca],[data-v-d34029ca] p{margin:0;padding:0}h1[data-v-d34029ca],h2[data-v-d34029ca]{margin:0}[data-v-d34029ca]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.variants-container[data-v-d34029ca]{display:flex;flex-direction:column;gap:1rem}.variants__wrapper[data-v-d34029ca]{display:grid;grid-template-columns:repeat(4,1fr);gap:.5rem}.variant[data-v-d34029ca]{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;aspect-ratio:3/2;border:1px solid var(--color-border-gray);color:var(--color-black);background-color:#fff;transition:background-color .2s ease-in-out;cursor:pointer}.variant>p[data-v-d34029ca]:first-child{font-size:1.3rem;margin:0}.variant>p[data-v-d34029ca]:first-child:has(+p.back-in-stock,+p.show-similar,+p.sold-out){color:var(--color-gray)!important}.variant>p[data-v-d34029ca]:nth-child(2){position:absolute;margin:35px 0 0;font-size:.8rem}.variant[data-v-d34029ca]:has(p.sold-out){cursor:auto}.variant[data-v-d34029ca]:has(p.back-in-stock){color:var(--color-gray)}.variant[data-v-d34029ca]:has(p.last-units){color:var(--color-black)}.variant[data-v-d34029ca]:not(:has(p.back-in-stock,p.show-similar,p.sold-out)):hover{border:1px solid var(--color-border-hover)}.variant.selected[data-v-d34029ca]:not(.sold-out):not(.back-in-stock):not(.show-similar){background-color:var(--color-black);color:#fff}.variant.selected:not(.sold-out):not(.back-in-stock):not(.show-similar) p[data-v-d34029ca]{color:#fff}.variant>p.last-units[data-v-d34029ca]{color:var(--color-red)}.variant>p.sold-out[data-v-d34029ca],.variant>p.show-similar[data-v-d34029ca]{color:var(--color-gray)}.variant>p.back-in-stock[data-v-d34029ca]{color:var(--color-gray)}.variant[data-v-d34029ca]:hover:not(.sold-out):not(.back-in-stock):not(.show-similar){background-color:var(--color-black);color:#fff}.variant[data-v-d34029ca]:not(.sold-out):not(.back-in-stock):not(.show-similar){border-color:var(--color-border-black)}.variant:hover:not(.sold-out):not(.back-in-stock):not(.show-similar) p[data-v-d34029ca]{color:#fff}.variant[data-v-d34029ca]:hover:is(.sold-out,.back-in-stock,.show-similar){background-color:#e5e5e5}", gu = /* @__PURE__ */ Pe(kE, [["styles", [TE]], ["__scopeId", "data-v-d34029ca"]]), zi = (i, e) => {
  const t = i.find((n) => n[e]?.includes("_color") && !n[e]?.includes("_swatch"));
  return t ? t[e] : "";
}, EE = {
  class: "caret-icon",
  xmlns: "http://www.w3.org/2000/svg",
  id: "keyboard_arrow_down",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, xE = /* @__PURE__ */ Re({
  __name: "PoloclubCaretIcon.ce",
  props: {
    direction: { type: String },
    width: { type: String }
  },
  setup(i) {
    Nt((n) => ({
      "6f08de21": n.width,
      a1d5db4c: t.value
    }));
    const e = i, t = le(() => {
      switch (e.direction) {
        case "up":
          return "rotate(180deg)";
        case "left":
          return "rotate(90deg)";
        case "right":
          return "rotate(-90deg)";
        case "down":
          return "rotate(0deg)";
      }
    });
    return (n, s) => (P(), N("svg", EE, s[0] || (s[0] = [
      w("path", {
        id: "Vector",
        d: "M0,0H24V24H0Z",
        fill: "none"
      }, null, -1),
      w("path", {
        id: "Subtract",
        d: "M12,15.293h0L6.707,10l.7-.7L12,13.876,16.59,9.3l.7.7L12,15.292Z"
      }, null, -1)
    ])));
  }
}), _E = "[data-v-e332e9f4],[data-v-e332e9f4]:before,[data-v-e332e9f4]:after{box-sizing:border-box}p[data-v-e332e9f4],[data-v-e332e9f4] p{margin:0;padding:0}h1[data-v-e332e9f4],h2[data-v-e332e9f4]{margin:0}[data-v-e332e9f4]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.caret-icon[data-v-e332e9f4]{width:var(--6f08de21);height:auto;transform:var(--a1d5db4c);transition:transform .1s ease}", kn = /* @__PURE__ */ Pe(xE, [["styles", [_E]], ["__scopeId", "data-v-e332e9f4"]]), Rn = (i, e) => {
  const t = i.find((n) => n[e]?.includes("_aire"));
  return t ? t[e] : "";
}, AE = { class: "colors-container-wrapper" }, wE = ["onClick", "onMouseenter"], LE = ["media", "srcset"], IE = ["media", "srcset"], CE = ["src", "alt"], RE = /* @__PURE__ */ Re({
  __name: "PoloclubProductColors.ce",
  props: {
    product: { type: null },
    display: { type: String },
    gridColumns: { default: 7, type: Number }
  },
  emits: ["selectColor"],
  setup(i, { emit: e }) {
    Nt((v) => ({
      "7536b1e9": v.display,
      "00539144": v.gridColumns,
      "4b231aac": v.display === "flex" ? "210px" : "auto"
    }));
    const t = e, n = ge(""), s = bs("colorsContainer"), r = bs("picturesColor"), a = ge(!1), o = ge(!1), l = () => {
      const v = s.value;
      v && (a.value = v.scrollLeft > 0, o.value = Math.ceil(v.scrollLeft + v.clientWidth) < Math.floor(v.scrollWidth));
    }, d = () => {
      i.display === "flex" && l();
    }, c = (v) => {
      const p = s.value;
      if (!p) return;
      const y = g.value;
      p.scrollBy({ left: v === "left" ? -y : y, behavior: "smooth" });
    };
    wt(() => {
      i.display === "flex" && l();
    });
    const u = (v) => {
      n.value = v.colorMetafield?.value ?? "";
    }, f = () => {
      n.value = "";
    }, h = le(() => {
      const v = i.product?.colorsMetafield?.references?.nodes?.find((p) => p.id === i.product?.id);
      return n.value || v?.colorMetafield?.value || "";
    }), m = le(() => [...i.product?.colorsMetafield?.references?.nodes.filter((p) => p.tags?.includes("SELECCIÓN") && p.availableForSale) || []].sort((p, y) => {
      const b = p.colorMetafield?.value?.toLowerCase() || "", k = y.colorMetafield?.value?.toLowerCase() || "";
      return b.localeCompare(k);
    })), g = le(() => r.value?.[0]?.offsetWidth || 0);
    return Dt(() => m.value.length, (v) => {
      console.log(v), v && Gt(l);
    }), (v, p) => (P(), N("div", AE, [
      v.display === "flex" ? (P(), Ie(kn, {
        key: 0,
        onClick: p[0] || (p[0] = (y) => c("left")),
        direction: "left",
        width: "90px",
        class: Ke({ hidden: !a.value })
      }, null, 8, ["class"])) : U("", !0),
      de(Vl, null, {
        default: Xe(() => [
          w("p", null, ie(h.value), 1),
          w("div", {
            class: "colors-container",
            ref_key: "colorsContainer",
            ref: s,
            onScroll: d
          }, [
            (P(!0), N(ve, null, pt(m.value, (y, b) => (P(), N("picture", {
              key: b,
              ref_for: !0,
              ref_key: "picturesColor",
              ref: r,
              onClick: (k) => t("selectColor", y.id),
              onMouseenter: (k) => u(y),
              onMouseleave: f,
              class: Ke(y.id === v.product?.id ? "current-color" : "not-current-color")
            }, [
              L(zi)(y.images.nodes, "desktop") || L(Rn)(y.images.nodes, "desktop") ? (P(), N("source", {
                key: 0,
                media: `(width >= ${L(F).tabletBreakpoint}px)`,
                srcset: L(zi)(y.images.nodes, "desktop") || L(Rn)(y.images.nodes, "desktop")
              }, null, 8, LE)) : U("", !0),
              L(zi)(y.images.nodes, "tablet") || L(Rn)(y.images.nodes, "tablet") ? (P(), N("source", {
                key: 1,
                media: `(width >= ${L(F).mobileBreakpoint}px)`,
                srcset: L(zi)(y.images.nodes, "tablet") || L(Rn)(y.images.nodes, "tablet")
              }, null, 8, IE)) : U("", !0),
              w("img", {
                src: L(zi)(y.images.nodes, "mobile") || L(Rn)(y.images.nodes, "mobile"),
                alt: y.images.nodes[0].altText || y.colorMetafield?.value,
                loading: "lazy"
              }, null, 8, CE)
            ], 42, wE))), 128))
          ], 544)
        ]),
        _: 1
      }),
      v.display === "flex" ? (P(), Ie(kn, {
        key: 1,
        onClick: p[1] || (p[1] = (y) => c("right")),
        direction: "right",
        width: "90px",
        class: Ke({ hidden: !o.value })
      }, null, 8, ["class"])) : U("", !0)
    ]));
  }
}), PE = "*,*:before,*:after{box-sizing:border-box}p,:deep(p){margin:0;padding:0}h1,h2{margin:0}*{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.colors-container-wrapper{display:flex;align-items:center;gap:.5rem}.colors-container-wrapper .hidden{opacity:0;pointer-events:none}.colors-container-wrapper>svg{cursor:pointer}.colors-container-wrapper .colors-container{display:var(--7536b1e9);grid-template-columns:repeat(var(--00539144),1fr);gap:.5rem;overflow-x:auto;white-space:nowrap;scrollbar-width:thin;scrollbar-color:var(--color-gray) transparent;padding-bottom:.5rem}.colors-container-wrapper .colors-container>picture{display:flex;flex:0 0 15%;min-width:var(--4b231aac);max-width:320px}.colors-container-wrapper .colors-container>picture.not-current-color{border:1px solid transparent;transition:border .2s ease-in-out;cursor:pointer}.colors-container-wrapper .colors-container>picture.not-current-color:hover{border:1px solid var(--color-border-hover)}.colors-container-wrapper .colors-container>picture.current-color{border:1px solid var(--color-border-black)}.colors-container-wrapper .colors-container>picture>img{width:100%;height:100%;object-fit:cover;aspect-ratio:9/13.5}", Vr = /* @__PURE__ */ Pe(RE, [["styles", [PE]]]), gn = (i) => Number(i.amount).toLocaleString(F.locale, { style: "currency", currency: i.currencyCode, minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s(?=[\p{Sc}])/u, ""), wm = (i, e) => {
  const t = le(() => {
    const v = window.Shopify?.country == "PL" ? i?.value?.privatePriceMetafieldPolonia?.value : i?.value?.privatePriceMetafield?.value;
    if (St?.hasAccount && he?.enable_private_sale && v)
      try {
        return {
          amount: Number(v),
          currencyCode: window.Shopify?.currency.active || "EUR"
        };
      } catch {
        return null;
      }
    return null;
  }), n = le(() => {
    const v = window.Shopify?.country == "PL" ? i?.value?.middlePriceMetafieldPolonia?.value : i?.value?.middlePriceMetafield?.value;
    if (!t.value && he?.enable_middle_price && v)
      try {
        return {
          amount: Number(v),
          currencyCode: window.Shopify?.currency.active || "EUR"
        };
      } catch {
        return null;
      }
    return null;
  }), s = le(() => i?.value?.price ? gn(i.value.price) : null), r = le(() => i?.value?.compareAtPrice ? gn(i.value.compareAtPrice) : null), a = le(() => t.value ? gn(t.value) : null), o = le(() => n.value ? gn(n?.value) : null), l = le(() => he?.select_prices_number === "three" || he?.enable_middle_price), d = le(() => l.value ? 3 : 2), c = le(() => !!t.value), u = le(() => ({
    price: a.value || s.value,
    ...g.value
  })), f = le(() => l.value ? a.value ? s.value : o.value ? o.value : r.value : c.value ? r.value ? r.value : s.value : r.value || null), h = le(() => l.value && (a.value || o.value) ? r.value : null), m = le(() => {
    const v = he.select_percentage;
    if (v === "logged" && !St?.hasAccount || v === "not_logged" && St?.hasAccount) return 0;
    const p = c.value ? window.Shopify?.country == "PL" ? Number(i?.value?.privatePriceMetafieldPolonia?.value) : Number(i?.value?.privatePriceMetafield?.value) : parseFloat(i.value.price.amount), y = i?.value?.compareAtPrice?.amount ? parseFloat(i?.value?.compareAtPrice?.amount) : parseFloat(i.value.price.amount);
    if (y <= 0) return 0;
    const b = y > p ? Math.floor((y - p) * 100 / y) : Math.floor((p - y) * 100 / y);
    return b > 0 ? b : 0;
  }), g = le(() => {
    let v;
    c.value && he.enable_private_sale ? v = he?.color_private : i?.value?.highlightedPriceMetafield?.value === "true" ? m.value > 0 ? v = he.font_color_highlighted_prices : v = void 0 : m.value > 0 ? v = he.color_outlet : v = void 0;
    let p;
    c.value && he.enable_private_sale ? p = he?.bg_color_private : i?.value?.highlightedPriceMetafield?.value === "true" ? p = he.font_color_highlighted_prices : v == he.color_outlet ? p = he.color_outlet : p = void 0;
    let y;
    return c.value && he.enable_private_sale ? y = he?.bg_color_private : i?.value?.highlightedPriceMetafield?.value === "true" && m.value > 0 ? y = he?.bg_color_highlighted_prices : y = void 0, { color: v, bg: y, border: p };
  });
  return {
    firstProductPrice: u,
    secondProductPrice: f,
    thirdProductPrice: h,
    pricesNumber: d,
    discountPercentage: m
  };
}, zl = () => {
  const i = le(() => F.productView.targetVariant);
  return le(() => F.productView.product), wm(i);
}, En = () => {
  const i = ge(window.innerWidth), e = () => i.value = window.innerWidth;
  return wt(() => window.addEventListener("resize", e)), ia(() => window.removeEventListener("resize", e)), i;
}, $s = () => {
  const i = ge(!1);
  return {
    addingToCart: i,
    handleAddToCart: async (t, n) => {
      try {
        i.value = !0, await _m(t, n);
      } catch (s) {
        throw console.error("Error adding to cart:", s), s;
      } finally {
        i.value = !1;
      }
    }
  };
}, DE = ["disabled"], NE = /* @__PURE__ */ Re({
  __name: "PoloclubButton.ce",
  props: {
    type: { type: String },
    disabled: { type: Boolean, default: !1 },
    theme: { type: String }
  },
  setup(i) {
    return Nt((e) => ({
      "2ae4f90f": L(he).enable_preorder && L(he).bg_color_button_preorder && L(F).productView.selectedVariant.isPreorder ? L(he).bg_color_button_preorder : "var(--color-black)"
    })), (e, t) => (P(), N("button", {
      class: Ke(`${e.type} ${e.theme}`),
      disabled: e.disabled
    }, [
      na(e.$slots, "default", {}, void 0, !0)
    ], 10, DE));
  }
}), ME = "[data-v-a57d2a0e],[data-v-a57d2a0e]:before,[data-v-a57d2a0e]:after{box-sizing:border-box}p[data-v-a57d2a0e],[data-v-a57d2a0e] p{margin:0;padding:0}h1[data-v-a57d2a0e],h2[data-v-a57d2a0e]{margin:0}[data-v-a57d2a0e]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}button[data-v-a57d2a0e]{display:flex;justify-content:center;align-items:center;width:100%;height:48px;max-height:100%;border:none;background:none;outline:none;box-shadow:none;padding:0;margin:0;color:inherit;font:inherit;text-align:center;appearance:none;cursor:pointer}:is(button.primary.light,button.add-to-cart.light)[data-v-a57d2a0e]{color:#fff;background-color:var(--color-black)}:is(button.primary.light,button.add-to-cart.light)[data-v-a57d2a0e]:hover{background-color:#000}:is(button.primary.light,button.add-to-cart.light)[data-v-a57d2a0e]:disabled{color:#d0d0d0;background-color:#f5f5f5}:is(button.primary.light,button.add-to-cart.light).add-to-cart[data-v-a57d2a0e]{height:60px;background-color:var(--2ae4f90f)}:is(button.primary.light,button.add-to-cart.light)[data-v-a57d2a0e]:not(.add-to-cart){max-width:240px}:is(button.primary.light,button.add-to-cart.light).add-to-cart[data-v-a57d2a0e]:disabled{color:#fff;background-color:var(--2ae4f90f)}", Kl = /* @__PURE__ */ Pe(NE, [["styles", [ME]], ["__scopeId", "data-v-a57d2a0e"]]), OE = (i, e) => {
  const t = le(() => i);
  return le(() => e), wm(t);
}, FE = { class: "prices-container" }, $E = { key: 0 }, BE = { key: 1 }, UE = { key: 2 }, VE = { key: 0 }, GE = { key: 1 }, HE = /* @__PURE__ */ Re({
  __name: "PoloclubProductPrice.ce",
  props: {
    type: { type: String },
    variant: { type: null },
    product: { type: null }
  },
  setup(i) {
    Nt((o) => ({
      "4a445d8c": o.type === "product-card" || o.type === "product-fixed-bar" ? "1.4rem" : "1.6rem",
      "127e869e": o.type === "product-card" || o.type === "product-fixed-bar" ? "1.6rem" : "2rem"
    }));
    const e = i.type === "product-card" ? OE(i.variant, i.product) : zl(), { firstProductPrice: t, secondProductPrice: n, thirdProductPrice: s, pricesNumber: r, discountPercentage: a } = e;
    return (o, l) => (P(), N("div", FE, [
      L(r) === 3 ? (P(), N(ve, { key: 0 }, [
        L(s) ? (P(), N("span", $E, ie(L(s)), 1)) : U("", !0),
        L(n) ? (P(), N("span", BE, ie(L(n)), 1)) : U("", !0),
        L(t) ? (P(), N("span", UE, [
          w("span", {
            style: We({ color: L(t).color, "background-color": L(t).bg, padding: L(t).bg ? "0 0.6rem" : "0" })
          }, ie(L(t).price), 5),
          L(a) && L(a) != 0 ? (P(), N("span", {
            key: 0,
            style: We({ color: L(t).color, "background-color": L(t).bg, border: L(t).border ? "1px solid" : "0px", "border-color": L(t).border, padding: L(t).bg ? "0 0.6rem" : "0 0.3rem", "margin-left": ".3rem" })
          }, "-" + ie(L(a)) + "%", 5)) : U("", !0)
        ])) : U("", !0)
      ], 64)) : U("", !0),
      L(r) === 2 ? (P(), N(ve, { key: 1 }, [
        L(n) ? (P(), N("span", VE, ie(L(n)), 1)) : U("", !0),
        L(t) ? (P(), N("span", GE, [
          w("span", {
            style: We({ color: L(t).color, "background-color": L(t).bg, padding: L(t).bg ? "0 0.6rem" : "0" })
          }, ie(L(t).price), 5),
          L(a) && L(a) != 0 ? (P(), N("span", {
            key: 0,
            style: We({ color: L(t).color, "background-color": L(t).bg, border: L(t).border ? "1px solid" : "0px", "border-color": L(t).border, padding: L(t).bg ? "0 0.6rem" : "0 0.3rem", "margin-left": ".3rem" })
          }, "-" + ie(L(a)) + "%", 5)) : U("", !0)
        ])) : U("", !0)
      ], 64)) : U("", !0)
    ]));
  }
}), zE = "[data-v-99d30cd3],[data-v-99d30cd3]:before,[data-v-99d30cd3]:after{box-sizing:border-box}p[data-v-99d30cd3],[data-v-99d30cd3] p{margin:0;padding:0}h1[data-v-99d30cd3],h2[data-v-99d30cd3]{margin:0}[data-v-99d30cd3]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.prices-container[data-v-99d30cd3]{display:flex;gap:0 1rem;font-size:var(--4a445d8c);flex-wrap:wrap}.prices-container>span[data-v-99d30cd3]:not(:last-child){color:var(--color-gray);text-decoration:line-through}.prices-container>span[data-v-99d30cd3]:last-child{color:var(--color-black)}@media (width >=768px){.prices-container[data-v-99d30cd3]{font-size:var(--127e869e)}}", ya = /* @__PURE__ */ Pe(HE, [["styles", [zE]], ["__scopeId", "data-v-99d30cd3"]]), KE = { class: "fixed-bar-info" }, jE = { class: "fixed-bar-info-item fixed-bar-info-item-title" }, WE = { class: "product-title" }, qE = ["src"], YE = { class: "fixed-bar-info-item-container" }, XE = { class: "fixed-bar-info-item-text" }, ZE = { class: "fixed-bar-info-item-container" }, QE = { class: "fixed-bar-info-item-text" }, JE = {
  key: 0,
  class: "fixed-bar-info-item fixed-bar-info-item-second-price"
}, ex = { key: 0 }, tx = { key: 1 }, ix = ["bg"], nx = /* @__PURE__ */ Re({
  __name: "PoloclubProductFixedBar.ce",
  props: {
    hideFixedBar: { type: Boolean }
  },
  setup(i) {
    Nt((c) => ({
      "5f34e8c8": L(e).color,
      "6f7b5600": L(e).bg
    }));
    const { firstProductPrice: e, secondProductPrice: t, thirdProductPrice: n } = zl(), s = En();
    le(() => !!F.productView.selectedVariant.variant);
    const r = le(() => F.productView.product?.media?.nodes.filter((u) => u.mediaContentType === "IMAGE").map((u) => u.image)), { addingToCart: a, handleAddToCart: o } = $s(), l = async () => {
      F.productView.selectedVariant.variant && await o(F.productView.product, F.productView.selectedVariant.variant);
    }, d = async () => {
      F.productView.selectedVariant.variant ? await l() : Fe.drawers.variants = "open";
    };
    return Dt(() => i.hideFixedBar, (c, u) => {
      if (!(s.value > F.mobileBreakpoint)) {
        if (c === !1) {
          const f = document.querySelector("#accessease-icon");
          f && (f.style.transition = "transform 0.3s ease-in-out", f.style.transform = "translateY(-60px)");
        }
        if (u === !1) {
          const f = document.querySelector("#accessease-icon");
          f && (f.style.transition = "transform 0.3s ease-in-out", f.style.transform = "translateY(0)");
        }
      }
    }, { immediate: !0 }), (c, u) => (P(), N("div", {
      class: Ke(["fixed-bar", { "fixed-bar-hiden": c.hideFixedBar }])
    }, [
      w("div", KE, [
        w("div", jE, [
          w("p", WE, ie(L(F).productView.product?.title), 1),
          de(ya, { type: "product-fixed-bar" })
        ]),
        w("div", {
          onClick: u[0] || (u[0] = (f) => L(Fe).drawers.colors = "open"),
          class: "fixed-bar-info-item fixed-bar-info-item-selector fixed-bar-info-item-selector-colors"
        }, [
          w("img", {
            src: L(zi)(r.value, "mobile")
          }, null, 8, qE),
          w("div", YE, [
            w("div", XE, [
              w("p", null, ie(L(Je).color + ` (${L(F).productView.product?.colorsMetafield?.references?.nodes?.length})`), 1),
              w("p", null, ie(L(F).productView.product?.colorMetafield?.value), 1)
            ]),
            de(kn, {
              direction: "right",
              width: "20px"
            })
          ])
        ]),
        w("div", {
          onClick: u[1] || (u[1] = (f) => L(Fe).drawers.variants = "open"),
          class: "fixed-bar-info-item fixed-bar-info-item-selector fixed-bar-info-item-selector-sizes"
        }, [
          w("div", ZE, [
            w("div", QE, [
              w("p", null, ie(L(Je).size), 1),
              w("p", null, ie(L(F).productView.selectedVariant?.variant?.title ?? L(Je).size), 1)
            ]),
            de(kn, {
              direction: "right",
              width: "20px"
            })
          ])
        ]),
        L(t) ? (P(), N("div", JE, [
          L(n) ? (P(), N("p", ex, ie(L(n)), 1)) : (P(), N("p", tx, ie(L(t)), 1))
        ])) : U("", !0),
        w("div", {
          class: "fixed-bar-info-item fixed-bar-info-item-first-price",
          bg: L(e).bg
        }, [
          w("p", null, ie(L(e).price), 1)
        ], 8, ix)
      ]),
      de(Kl, {
        onClick: d,
        type: "add-to-cart",
        theme: "light",
        class: "buy-button"
      }, {
        default: Xe(() => [
          L(a) ? (P(), Ie(bi, {
            key: 0,
            theme: "light",
            width: "20px"
          })) : (P(), N(ve, { key: 1 }, [
            sn(ie(L(F).productView.selectedVariant.variant ? L(he).enable_preorder && L(F).productView.selectedVariant.isPreorder ? L(Je).addToCartPreorder : L(Je).addToCart : L(Je).selectASize), 1)
          ], 64))
        ]),
        _: 1
      })
    ], 2));
  }
}), sx = "[data-v-afcef26d],[data-v-afcef26d]:before,[data-v-afcef26d]:after{box-sizing:border-box}p[data-v-afcef26d],[data-v-afcef26d] p{margin:0;padding:0}h1[data-v-afcef26d],h2[data-v-afcef26d]{margin:0}[data-v-afcef26d]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.fixed-bar[data-v-afcef26d]{z-index:999;position:fixed;bottom:0;left:0;display:flex;flex-direction:column;justify-content:center;gap:1rem;width:100%;padding:1.2rem var(--page-horizontal-padding) 2.8rem var(--page-horizontal-padding);background-color:#fff;box-shadow:0 -3px 5px #0000001a;transition:transform .3s ease-in-out}.fixed-bar.fixed-bar-hiden[data-v-afcef26d]{transform:translateY(100%)}.fixed-bar-info[data-v-afcef26d]{display:flex;justify-content:space-between;align-items:center;height:5rem}.fixed-bar-info-item[data-v-afcef26d]{height:100%;border:1px solid var(--color-border-gray);border-left:none}.fixed-bar-info-item-second-price[data-v-afcef26d]{border-right:none}.fixed-bar-info-item-first-price[bg][data-v-afcef26d]{border:none}.fixed-bar-info:not(:has(.fixed-bar-info-item-second-price)) .fixed-bar-info-item-first-price[data-v-afcef26d]{max-width:40%}.fixed-bar-info:not(:has(.fixed-bar-info-item-first-price[bg])) .fixed-bar-info-item-second-price[data-v-afcef26d]{border-right:1px solid var(--color-border-gray)}.fixed-bar-info-item-second-price[data-v-afcef26d]{color:var(--color-gray);text-decoration:line-through}.fixed-bar-info-item-first-price[data-v-afcef26d]{color:var(--5f34e8c8);background-color:var(--6f7b5600)}.fixed-bar-info-item-selector[data-v-afcef26d]{display:flex;align-items:center;width:100%;cursor:pointer}.fixed-bar-info-item-selector img[data-v-afcef26d]{height:100%;object-fit:contain}.fixed-bar-info-item-container[data-v-afcef26d]{display:flex;align-items:center;justify-content:space-between;width:100%;padding:0 .5rem 0 .8rem}.fixed-bar-info-item-container .fixed-bar-info-item-text[data-v-afcef26d]{display:flex;flex-direction:column}.fixed-bar-info-item-container .fixed-bar-info-item-text>p[data-v-afcef26d]:first-child{font-size:1.2rem;color:var(--color-gray)}.fixed-bar-info-item-container .fixed-bar-info-item-text>p[data-v-afcef26d]:last-child{font-size:1.3rem;color:var(--color-black)}.fixed-bar-info-item-container .fixed-bar-info-item-text>p[data-v-afcef26d]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.fixed-bar-info-item-title[data-v-afcef26d]{display:none}.fixed-bar-info-item-second-price[data-v-afcef26d],.fixed-bar-info-item-first-price[data-v-afcef26d]{display:flex;justify-content:center;align-items:center;width:100%;max-width:20%}@media (width >=1024px){.fixed-bar[data-v-afcef26d]{flex-direction:row;gap:0;height:60px;padding:0}.fixed-bar-info[data-v-afcef26d]{height:100%;width:88.4%}.fixed-bar-info-item[data-v-afcef26d]{border-left:none;border-bottom:none}.fixed-bar-info-item-title[data-v-afcef26d]{display:flex;align-items:center;gap:1.5rem;width:73.5%;padding:0 0 0 var(--page-horizontal-padding)}.fixed-bar-info-item-title .product-title[data-v-afcef26d]{margin:0;font-family:FreightDisp Pro;font-size:2.4rem;line-height:2.8rem;font-weight:400;letter-spacing:-.5px;color:#000}.fixed-bar-info-item-title>p[data-v-afcef26d]:nth-child(2){color:var(--color-gray);text-decoration:line-through}.fixed-bar-info-item-selector img[data-v-afcef26d]{padding:.5rem}.fixed-bar-info-item-selector-sizes[data-v-afcef26d]{border-right:none}.fixed-bar-info-item-selector[data-v-afcef26d]{width:13.2%}.fixed-bar-info-item-second-price[data-v-afcef26d],.fixed-bar-info-item-first-price[data-v-afcef26d]{display:none}.buy-button[data-v-afcef26d]{width:11.6%}}", rx = /* @__PURE__ */ Pe(nx, [["styles", [sx]], ["__scopeId", "data-v-afcef26d"]]), ax = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 144.83 127.21",
  style: { width: "40px", height: "25px" }
}, ox = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, lx = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, dx = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, cx = {
  key: 4,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, ux = {
  key: 5,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, fx = {
  key: 6,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, hx = {
  key: 7,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, mx = {
  key: 8,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, px = {
  key: 9,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, gx = {
  key: 10,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, vx = {
  key: 11,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, yx = {
  key: 12,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, bx = {
  key: 13,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, Sx = {
  key: 14,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, kx = {
  key: 15,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, Tx = {
  key: 16,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 40"
}, Ex = /* @__PURE__ */ Re({
  __name: "PoloclubCareIcons.ce",
  props: {
    icon: { type: String }
  },
  setup(i) {
    return (e, t) => (P(), N(ve, null, [
      e.icon === "no-lavar" ? (P(), N("svg", ax, t[0] || (t[0] = [
        w("defs", null, null, -1),
        w("g", { id: "Capa_1-2" }, [
          w("path", {
            class: "cls-no-lavar",
            d: "m118.8,113.82H26.04l-12.55,12.55c-1.03,1.12-2.84,1.12-3.87,0-1.12-1.03-1.12-2.75,0-3.87l11.78-11.78L.08,25.45c-.34-1.46.52-2.92,1.98-3.27,1.55-.43,3.01.52,3.35,1.98,0,0,.95,3.7,2.41,9.46l7.31,7.39c1.72,1.72,4.04,2.66,6.53,2.66s4.81-.95,6.53-2.66c2.75-2.75,6.45-4.3,10.4-4.3,1.12,0,2.24.17,3.35.43L9.62,4.73c-1.12-1.12-1.12-2.84,0-3.95,1.03-1.03,2.84-1.03,3.87,0l42.81,42.9c2.15-.17,4.13-1.12,5.67-2.66,5.76-5.76,15.13-5.76,20.8,0,1.63,1.55,3.53,2.49,5.76,2.66L131.35.77c1.12-1.03,2.84-1.03,3.87,0,1.12,1.12,1.12,2.84,0,3.95l-32.41,32.41c4.81-1.2,10.06.17,13.84,3.87,1.72,1.72,4.04,2.66,6.53,2.66s4.73-.95,6.53-2.66l7.31-7.39c1.46-5.76,2.41-9.46,2.41-9.46.34-1.55,1.81-2.41,3.27-2.06,1.46.43,2.41,1.89,2.06,3.35l-21.32,85.28,11.78,11.78c1.12,1.12,1.12,2.84,0,3.87-1.03,1.12-2.75,1.12-3.87,0l-12.55-12.55ZM10.39,44.02c5.33,21.49,13.33,53.56,15.47,62.24l42.64-42.64-14.53-14.53c-3.35-.34-6.45-1.8-8.85-4.21-1.81-1.72-4.04-2.67-6.53-2.67s-4.81.95-6.53,2.67c-5.76,5.76-15.04,5.76-20.8,0l-.86-.86Zm21.15,64.3h81.76l-40.83-40.83-40.92,40.83Zm40.92-48.57l11.52-11.52c-1.81-.77-3.61-1.8-5.07-3.35-1.72-1.72-4.04-2.67-6.53-2.67s-4.73.95-6.45,2.67c-1.55,1.46-3.27,2.58-5.07,3.27l11.61,11.61Zm18.4-10.66l-14.53,14.53,42.55,42.64c2.15-8.6,10.14-40.75,15.56-62.24l-.86.86c-5.76,5.76-15.04,5.76-20.8,0-1.72-1.72-4.04-2.67-6.53-2.67s-4.81.95-6.53,2.67c-2.49,2.49-5.59,3.87-8.86,4.21Z"
          })
        ], -1)
      ]))) : U("", !0),
      e.icon === "lavar-30" ? (P(), N("svg", ox, t[1] || (t[1] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", { d: "M12.24,31.66,6.63,9.21A.69.69,0,0,1,8,8.88l.61,2.41,1.86,1.87a2.29,2.29,0,0,0,1.66.68,2.33,2.33,0,0,0,1.66-.68,3.74,3.74,0,0,1,5.28,0,2.34,2.34,0,0,0,3.3,0,3.73,3.73,0,0,1,5.28,0,2.36,2.36,0,0,0,1.66.68A2.33,2.33,0,0,0,31,13.16a3.73,3.73,0,0,1,5.28,0,2.37,2.37,0,0,0,3.32,0l1.86-1.87L42,8.88a.68.68,0,0,1,.83-.52.74.74,0,0,1,.53.85L37.76,31.66Zm-3-17.73c1.52,6.11,3.9,15.65,4.08,16.33H36.67c.18-.68,2.56-10.22,4.08-16.33l-.21.22a3.74,3.74,0,0,1-5.29,0,2.29,2.29,0,0,0-1.66-.68,2.33,2.33,0,0,0-1.66.68,3.73,3.73,0,0,1-5.28,0,2.34,2.34,0,0,0-3.3,0,3.78,3.78,0,0,1-2.64,1.09,3.71,3.71,0,0,1-2.64-1.09,2.36,2.36,0,0,0-1.66-.68,2.31,2.31,0,0,0-1.66.68,3.74,3.74,0,0,1-5.29,0Zm8.6,4h6.27v1s-2.21,2.51-2.84,3.25a2.92,2.92,0,0,1,2.84,3,3.14,3.14,0,0,1-6.25.44H19.2A1.79,1.79,0,0,0,21,27.05a1.7,1.7,0,0,0,1.82-1.81c0-1.49-1.18-1.81-2.17-1.81H19.47V22.36s2.07-2.4,2.7-3.17H17.85ZM32.17,23v.13c0,2.57-.83,5.28-3.62,5.28S25,25.65,25,23.08V23c0-2.56.8-5.29,3.6-5.29S32.17,20.39,32.17,23ZM30.84,23a7.28,7.28,0,0,0-.44-2.71,2,2,0,0,0-1.85-1.39,2.06,2.06,0,0,0-1.86,1.39A7.55,7.55,0,0,0,26.26,23a7.41,7.41,0,0,0,.43,2.73,1.93,1.93,0,0,0,3.71,0A7.15,7.15,0,0,0,30.84,23Zm4.7-3.93a1.58,1.58,0,0,1-3.15,0,1.58,1.58,0,0,1,3.15,0Zm-1.1,0A.47.47,0,0,0,34,18.6a.48.48,0,0,0-.5.48.49.49,0,0,0,.5.5A.48.48,0,0,0,34.44,19.08Z" })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "lavar-40" ? (P(), N("svg", lx, t[2] || (t[2] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", { d: "M12.24,31.66,6.63,9.21A.69.69,0,0,1,8,8.88l.61,2.41,1.86,1.87a2.29,2.29,0,0,0,1.66.68,2.33,2.33,0,0,0,1.66-.68,3.74,3.74,0,0,1,5.28,0,2.34,2.34,0,0,0,3.3,0,3.73,3.73,0,0,1,5.28,0,2.36,2.36,0,0,0,1.66.68A2.33,2.33,0,0,0,31,13.16a3.73,3.73,0,0,1,5.28,0,2.37,2.37,0,0,0,3.32,0l1.86-1.87L42,8.88a.68.68,0,0,1,.83-.52.74.74,0,0,1,.53.85L37.76,31.66Zm-3-17.73c1.52,6.11,3.9,15.65,4.08,16.33H36.67c.18-.68,2.56-10.22,4.08-16.33l-.21.22a3.74,3.74,0,0,1-5.29,0,2.29,2.29,0,0,0-1.66-.68,2.33,2.33,0,0,0-1.66.68,3.73,3.73,0,0,1-5.28,0,2.34,2.34,0,0,0-3.3,0,3.78,3.78,0,0,1-2.64,1.09,3.71,3.71,0,0,1-2.64-1.09,2.36,2.36,0,0,0-1.66-.68,2.31,2.31,0,0,0-1.66.68,3.74,3.74,0,0,1-5.29,0ZM23.31,24.8H25v1.25H23.31v2.2H22v-2.2H17.65V25l4.11-7.1h1.55ZM22,20c-.72,1.26-2.36,4.15-2.75,4.82H22Zm10.37,3v.13c0,2.57-.83,5.28-3.62,5.28s-3.61-2.71-3.61-5.28V23c0-2.56.81-5.29,3.61-5.29S32.39,20.39,32.39,23ZM31.06,23a7.28,7.28,0,0,0-.44-2.71,1.93,1.93,0,0,0-3.71,0A7.28,7.28,0,0,0,26.47,23a7.15,7.15,0,0,0,.44,2.73,1.93,1.93,0,0,0,3.71,0A7.15,7.15,0,0,0,31.06,23Zm4.69-3.93a1.57,1.57,0,0,1-3.14,0,1.57,1.57,0,0,1,3.14,0Zm-1.09,0a.47.47,0,0,0-.48-.48.48.48,0,0,0-.5.48.49.49,0,1,0,1,0Z" })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "lavar-mano" ? (P(), N("svg", dx, t[3] || (t[3] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", { d: "M29.47,9.87a4.26,4.26,0,0,0,.59,1.53,11.89,11.89,0,0,1,1.31,3.78c0,.43.08.87.11,1.33a3.74,3.74,0,0,1,4.75.43,2.37,2.37,0,0,0,3.32,0l1.86-1.87L42,12.66a.68.68,0,0,1,.83-.52.74.74,0,0,1,.53.85L37.76,35.44H12.24L6.63,13A.69.69,0,0,1,8,12.66l.61,2.41,1.86,1.87a2.29,2.29,0,0,0,1.66.68,2.33,2.33,0,0,0,1.66-.68,3.74,3.74,0,0,1,5.28,0,.23.23,0,0,0,.11.11l.76-2.64a14.65,14.65,0,0,1,1.82-3.54,19.79,19.79,0,0,0,2-5l.27-.9a.52.52,0,0,1,1,.31l-.26.9a20.11,20.11,0,0,1-2.14,5.32,16.15,16.15,0,0,0-1.6,3c-.56,1.48-.91,3.3-1.28,4.39a11.69,11.69,0,0,0-.88,3.32A6.23,6.23,0,0,0,19.42,25a20.65,20.65,0,0,1,.9-6.05.54.54,0,0,1,.67-.33.49.49,0,0,1,.33.66A19.47,19.47,0,0,0,20.38,25c0,2.32.55,4.17,1.2,3.91A11.58,11.58,0,0,1,21,24.81,17.74,17.74,0,0,1,22.15,19a.56.56,0,0,1,.68-.33.5.5,0,0,1,.33.63A15.11,15.11,0,0,0,22,25.05c-.06,2.51.94,5.3,1.23,5.28s.43-.31.3-.66a15.51,15.51,0,0,1-.7-4.71,15.31,15.31,0,0,1,1.34-5.46.56.56,0,0,1,.69-.26.51.51,0,0,1,.25.7,12.2,12.2,0,0,0-.68,9.41c.78-.92,0-3.15.3-4.85a28.61,28.61,0,0,1,2.21-6.77c.57-1.07.87-1.44,1.42-1.13.89.45,1.26,1.83,1.26,3.64a13.4,13.4,0,0,1-.24,2.36c-.39,2.36.42,2,.62-.39,0-.53.13-1.16.24-1.79a17.34,17.34,0,0,0,.15-5.07A11.65,11.65,0,0,0,29,11.57a4.28,4.28,0,0,1-.61-1.74,1.37,1.37,0,0,1,.06-.42,26.58,26.58,0,0,1,1.77-4A.55.55,0,0,1,31,5.2a.57.57,0,0,1,.26.46.65.65,0,0,1-.06.26,13.88,13.88,0,0,0-1.7,3.82ZM9.25,17.71c1.52,6.11,3.9,15.65,4.08,16.33H36.67c.18-.68,2.56-10.22,4.08-16.33l-.21.22a3.74,3.74,0,0,1-5.29,0,2.29,2.29,0,0,0-1.66-.68,2.33,2.33,0,0,0-1.66.68,3.91,3.91,0,0,1-.45.39c-.05.72-.14,1.4-.22,1.92S31.06,21.51,31,22a9.73,9.73,0,0,1-.22,1.42c-.26,1.33-.9,2.08-1.55,1.94s-1-.65-1-1.79a10.34,10.34,0,0,1,.13-1.2,16.27,16.27,0,0,0,.26-2.09c0-.46-.06-2.14-.5-2.54-.17-.17-.63.81-.85,1.38a28.3,28.3,0,0,0-1.57,5.28c-.22,1.51.24,3-.11,4.66a1.67,1.67,0,0,1-1.29,1.37,1.19,1.19,0,0,1-1.13.9c-.59,0-1-.51-1.31-1.49a1.11,1.11,0,0,1-1.18-.17c-.59-.48-1-1.47-1.2-3.32-1.34-.26-1.66-3.58-1.69-4.06A9.05,9.05,0,0,1,18.57,19c0-.14.11-.31.17-.51a2.89,2.89,0,0,1-.67-.54,2.36,2.36,0,0,0-1.66-.68,2.31,2.31,0,0,0-1.66.68,3.74,3.74,0,0,1-5.29,0Z" })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "no-lejia" ? (P(), N("svg", cx, t[4] || (t[4] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", { d: "M43.71,11.87,31.55,17.15l3.23,5.62,8.93,3.88a.7.7,0,0,1,.37.92.71.71,0,0,1-.94.35L36,24.8,40.13,32H9.87L14,24.8,6.85,27.92a.71.71,0,0,1-.93-.35.7.7,0,0,1,.37-.92l8.93-3.88,3.23-5.62L6.29,11.87A.7.7,0,0,1,5.92,11a.72.72,0,0,1,.93-.37L19.15,16,25,5.8,30.85,16l12.29-5.37a.72.72,0,0,1,.94.37A.7.7,0,0,1,43.71,11.87Zm-9.91,12L25,20l-8.8,3.85c-1.94,3.36-3.54,6.11-3.91,6.75H37.71C37.34,30,35.74,27.22,33.8,23.86Zm-16.42-2,5.87-2.58-3.51-1.53C19,19.08,18.14,20.47,17.38,21.83Zm3.06-5.33,4.56,2,4.56-2C27.34,12.66,25.41,9.34,25,8.6,24.58,9.34,22.66,12.66,20.44,16.5Zm9.82,1.22-3.51,1.53,5.89,2.58C31.86,20.47,31.05,19.08,30.26,17.72Z" })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "no-planchar" ? (P(), N("svg", ux, t[5] || (t[5] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", {
              class: "cls-2",
              d: "M31,28.24H20.56l-6.7,6.69a.69.69,0,0,1-1,0,.66.66,0,0,1,0-1l5.71-5.71H6.47v-.7A11.69,11.69,0,0,1,18.15,15.85h.44l-5.71-5.71a.69.69,0,0,1,1-1l6.7,6.69H31l6.41-6.41c-.43-1.73-.74-2.93-.78-3.17H12.66a.71.71,0,0,1-.7-.7.72.72,0,0,1,.7-.7h25l5.84,23.37H32.94L38.65,34a.69.69,0,0,1-1,1Zm-11-1.4,4.79-4.79L20,17.25H18.17A10.28,10.28,0,0,0,7.93,26.84Zm5.78-5.78,3.8-3.81H22ZM22,26.84h7.61L25.77,23Zm9.58-9.59-4.79,4.8,4.79,4.79h10.2l-2.41-9.59ZM37.78,11l-4.84,4.83h6C38.54,14.15,38.13,12.48,37.78,11Z"
            })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "no-secadora" ? (P(), N("svg", fx, t[6] || (t[6] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", {
              class: "cls-2",
              d: "M36.8,32.78H13.2L10,36a.7.7,0,0,1-1-1l3.21-3.22V8.23L9,5A.68.68,0,0,1,9,4a.71.71,0,0,1,1,0l3.22,3.21H36.78L40,4a.71.71,0,0,1,1,0,.68.68,0,0,1,0,1l-3.19,3.2V31.8L41,35a.7.7,0,0,1-1,1ZM17.2,13.2,13.63,9.63V30.37l3.57-3.56a10.39,10.39,0,0,1,0-13.61Zm1,14.59L14.6,31.38H35.4l-3.56-3.57A10.38,10.38,0,0,1,25,30.37,10.2,10.2,0,0,1,18.18,27.79Zm13.64-15.6,3.56-3.57H14.62l3.56,3.59a10.33,10.33,0,0,1,13.64,0Zm-13.64,2a9,9,0,0,0,0,11.62L24,20Zm1,12.61a9,9,0,0,0,11.66,0L25,21ZM25,19l5.82-5.82a8.89,8.89,0,0,0-11.64,0Zm6.81-4.84L26,20l5.82,5.84a8.95,8.95,0,0,0,0-11.66Zm1,12.65,3.57,3.57V9.61l-3.57,3.57a10.38,10.38,0,0,1,0,13.65Z"
            })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "no-seco" ? (P(), N("svg", hx, t[7] || (t[7] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", {
              class: "cls-2",
              d: "M33.54,29.53a12.8,12.8,0,0,1-17.07,0L13.1,32.9a.71.71,0,0,1-1,0,.69.69,0,0,1,0-1l3.37-3.37a12.8,12.8,0,0,1,0-17.07L12.12,8.1a.69.69,0,1,1,1-1l3.37,3.39a12.77,12.77,0,0,1,17.07,0l3.37-3.37a.69.69,0,0,1,1,0,.71.71,0,0,1,0,1l-3.37,3.37A12.88,12.88,0,0,1,37.79,20a12.71,12.71,0,0,1-3.29,8.53l3.4,3.37a.7.7,0,1,1-1,1Zm-17.07-2L24,20l-7.55-7.53a11.43,11.43,0,0,0,0,15.08Zm1-16.06L25,19l7.52-7.52a11.33,11.33,0,0,0-15.07,0Zm15.07,17L25,21l-7.55,7.55a11.39,11.39,0,0,0,15.07,0Zm1-16.06L26,20l7.53,7.55a11.34,11.34,0,0,0,0-15.08Z"
            })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "plancha-baja" ? (P(), N("svg", mx, t[8] || (t[8] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", {
              class: "cls-2",
              d: "M43.53,31.68H6.47V31A11.68,11.68,0,0,1,18.15,19.3H39L36.6,9.72H12.66a.7.7,0,0,1,0-1.4h25Zm-1.79-1.4L39.33,20.7H18.17A10.28,10.28,0,0,0,7.93,30.28Zm-14.4-4.79a1.56,1.56,0,1,1-3.11,0,1.56,1.56,0,0,1,3.11,0Z"
            })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "plancha-baja-sin-vapor" ? (P(), N("svg", px, t[9] || (t[9] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", {
              class: "cls-2",
              d: "M26.55,19.8A1.55,1.55,0,1,1,25,18.25,1.56,1.56,0,0,1,26.55,19.8Z"
            }),
            w("path", {
              class: "cls-2",
              d: "M43.53,26H31.59l.72,2.82,5.23-1.71a.69.69,0,0,1,.87.46.71.71,0,0,1-.43.88l-5.34,1.73.83,3.28L38,34.92a.72.72,0,0,1,.43.9.67.67,0,0,1-.87.44l-3.68-1.21.35,1.47a.67.67,0,0,1-.5.83.47.47,0,0,1-.18,0,.68.68,0,0,1-.67-.52l-.57-2.3-6.52-2.12-6.52,2.12-.57,2.3a.7.7,0,0,1-.68.52.62.62,0,0,1-.18,0,.68.68,0,0,1-.5-.83l.35-1.47L14,36.26a.7.7,0,0,1-.9-.44.74.74,0,0,1,.46-.9l4.51-1.46.81-3.28-5.32-1.73A.71.71,0,1,1,14,27.11l5.23,1.71L20,26H6.47v-.7A11.77,11.77,0,0,1,9.9,17a11.65,11.65,0,0,1,8.25-3.41H39C37.8,8.86,36.71,4.49,36.6,4H12.66a.7.7,0,0,1,0-1.4h25Zm-1.79-1.4L39.33,15H18.17A10.28,10.28,0,0,0,7.93,24.6ZM23.51,31.69l-3.28-1.08L19.66,33Zm2.26-.75L31,29.26,30.14,26H21.39l-.81,3.26Zm5.53-.33L28,31.69,31.89,33Z"
            })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "plancha-media" ? (P(), N("svg", gx, t[10] || (t[10] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", {
              class: "cls-2",
              d: "M43.53,31.68H6.47V31A11.68,11.68,0,0,1,18.15,19.3H39L36.6,9.72H12.66a.7.7,0,0,1,0-1.4h25Zm-1.79-1.4L39.33,20.7H18.17A10.28,10.28,0,0,0,7.93,30.28Zm-18.4-4.79a1.56,1.56,0,1,1-1.56-1.55A1.56,1.56,0,0,1,23.34,25.49Zm8,0a1.55,1.55,0,1,1-1.55-1.55A1.56,1.56,0,0,1,31.3,25.49Z"
            })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "plancha-media-sin-vapor" ? (P(), N("svg", vx, t[11] || (t[11] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", {
              class: "cls-2",
              d: "M43.53,31.68H6.47V31A11.68,11.68,0,0,1,18.15,19.3H39L36.6,9.72H12.66a.7.7,0,0,1,0-1.4h25Zm-1.79-1.4L39.33,20.7H18.17A10.28,10.28,0,0,0,7.93,30.28Zm-18.4-4.79a1.56,1.56,0,1,1-1.56-1.55A1.56,1.56,0,0,1,23.34,25.49Zm8,0a1.55,1.55,0,1,1-1.55-1.55A1.56,1.56,0,0,1,31.3,25.49Z"
            })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "secadora" ? (P(), N("svg", yx, t[12] || (t[12] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", {
              class: "cls-2",
              d: "M12.22,7.22H37.78V32.78H12.22Zm1.4,24.16H36.38V8.62H13.62ZM35.37,20A10.36,10.36,0,1,1,25,9.63,10.37,10.37,0,0,1,35.37,20ZM34,20a9,9,0,1,0-9,9A9,9,0,0,0,34,20Zm-7.42,0A1.55,1.55,0,1,1,25,18.4,1.56,1.56,0,0,1,26.55,20Z"
            })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "seco" ? (P(), N("svg", bx, t[13] || (t[13] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", {
              class: "cls-2",
              d: "M12.22,20A12.78,12.78,0,1,1,25,32.78,12.78,12.78,0,0,1,12.22,20Zm1.4,0A11.38,11.38,0,1,0,25,8.62,11.39,11.39,0,0,0,13.62,20Z"
            })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "seco-sin-solve" ? (P(), N("svg", Sx, t[14] || (t[14] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", {
              class: "cls-2",
              d: "M12.22,20A12.78,12.78,0,1,1,25,32.78,12.78,12.78,0,0,1,12.22,20Zm1.4,0A11.38,11.38,0,1,0,25,8.62,11.39,11.39,0,0,0,13.62,20ZM21,26.89H19.44l4.77-15.18h1.6l4.75,15.18H29s-1.34-4.59-1.38-4.77h-5.3C22.31,22.3,21,26.89,21,26.89Zm1.72-6h4.56c-.09-.29-2.1-7.27-2.26-7.81C24.87,13.63,22.81,20.59,22.72,20.9Z"
            })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "seco-sin-triclo" ? (P(), N("svg", kx, t[15] || (t[15] = [
        w("defs", null, null, -1),
        w("g", {
          id: "Capa_2",
          "data-name": "Capa 2"
        }, [
          w("g", {
            id: "Capa_1-2",
            "data-name": "Capa 1"
          }, [
            w("path", {
              class: "cls-2",
              d: "M12.22,20A12.78,12.78,0,1,1,25,32.78,12.78,12.78,0,0,1,12.22,20Zm1.4,0A11.38,11.38,0,1,0,25,8.62,11.39,11.39,0,0,0,13.62,20Zm8.71,7.59H20.86V12.41h4.62c2.85,0,4.75,1.44,4.75,4.26,0,3.11-2.39,4.1-5.34,4.1H22.33Zm0-8.07h2.58c2.23,0,3.88-.59,3.88-2.89,0-2-1.25-3-3.59-3H22.33Z"
            })
          ])
        ], -1)
      ]))) : U("", !0),
      e.icon === "trapo" ? (P(), N("svg", Tx, t[16] || (t[16] = [
        Af('<defs data-v-e88891b0></defs><g id="Capa_2" data-name="Capa 2" data-v-e88891b0><g id="Capa_1-2" data-name="Capa 1" data-v-e88891b0><path class="cls-2" d="M38.12,28c-2.69-4.74-1.9-8.71-1.06-12.91.63-3.19,1.29-6.49.47-10.26a.61.61,0,0,0-.33-.42.6.6,0,0,0-.54,0c-3.27,1.43-5.39.77-7.84,0-3.48-1.09-7.43-2.31-15.44,1.43a.63.63,0,0,0-.34.7c.74,3.4.13,6.35-.46,9.22-.87,4.17-1.76,8.49,1.76,13.82a.63.63,0,0,0,.52.28.66.66,0,0,0,.27-.06,24,24,0,0,1,6.43-2.11h0c-.17-.16-.31-.33-.49-.48a1,1,0,0,1-.26-.44l0-.22a25.76,25.76,0,0,0-5.69,1.89C12.2,23.77,13,20,13.8,16c.59-2.86,1.2-5.8.56-9.24,7.27-3.29,10.89-2.16,14.08-1.17,2.41.75,4.7,1.47,8,.24a24.38,24.38,0,0,1-.62,9C35,18.93,34.19,23.14,36.7,28a8,8,0,0,1-3.07.54,1.15,1.15,0,0,0,.06.17,8.13,8.13,0,0,1,.15.86,1.46,1.46,0,0,1,0,.22,9.61,9.61,0,0,0,4-.91.59.59,0,0,0,.34-.37A.61.61,0,0,0,38.12,28Z" data-v-e88891b0></path><path class="cls-2" d="M34.43,30.74a11.68,11.68,0,0,0,2.92,1.9.46.46,0,0,1,.16.15.49.49,0,0,1,0,.44.45.45,0,0,1-.59.19,21.75,21.75,0,0,1-3.05-2,1.48,1.48,0,0,1-.24-.26,3.59,3.59,0,0,1-.36-1.5,10,10,0,0,0-.79-3.23A14.6,14.6,0,0,0,30.11,23c-.36-.39-.71-.79-1-1.14-1.22-1.59-1.94-1.47-.6,0a12.77,12.77,0,0,1,1.23,1.54c.82,1.27,1.18,2.39.77,3.12-.25.46-.63.34-1.51-.15a23.77,23.77,0,0,1-4.6-3.73c-1-1.07-1.44-3-2.4-3.25a10.18,10.18,0,0,0,4.72,6.27.42.42,0,0,1,.15.59.46.46,0,0,1-.6.14,12.82,12.82,0,0,1-3.4-3.21,12.76,12.76,0,0,1-1.65-3.61.38.38,0,0,0-.51-.32c-.2.11.36,2.52,1.54,4.24a12.56,12.56,0,0,0,3.43,3.47.41.41,0,0,1,.06.59.47.47,0,0,1-.62.08,14.64,14.64,0,0,1-3.43-3.54,9.58,9.58,0,0,1-1.46-3.14c-.57.11-.12,1.65.93,3.27a16.44,16.44,0,0,0,3.27,3.61.41.41,0,0,1,.07.61.46.46,0,0,1-.62.08,17.34,17.34,0,0,1-3.36-3.82,5.39,5.39,0,0,0,.83,2.19,9.92,9.92,0,0,0,2.11,1.92c.76.59,1.82,1.7,2.89,2.48a13.69,13.69,0,0,0,2.48,1.4,16.73,16.73,0,0,1,3.9,2.75l.59.51a.42.42,0,0,1,0,.61.43.43,0,0,1-.61,0l-.59-.5a16.19,16.19,0,0,0-3.67-2.63,12.28,12.28,0,0,1-2.86-1.65c-1.26-1.07-2.37-2.08-3-2.57a7.42,7.42,0,0,1-2.06-2c-.2-.34-1.47-2.81-.66-3.59-.69-1.4-.86-2.26-.66-2.86a.91.91,0,0,1,.74-.66c-.23-.82-.17-1.36.24-1.63a1,1,0,0,1,1.2.12A1.37,1.37,0,0,1,23,19c1,1,1.35,2.25,2.18,3.2a23.68,23.68,0,0,0,3.49,3c.41.3,1.17.78,1.22.57.12-.47-.58-1.68-.8-2a13.47,13.47,0,0,0-1.13-1.35,6.34,6.34,0,0,1-.63-.78c-.5-.8-.46-1.34-.1-1.71s1.18-.15,2,.66a7.59,7.59,0,0,1,.8.89,13.11,13.11,0,0,0,1,1.14,14.71,14.71,0,0,1,2.36,3.49,9.46,9.46,0,0,1,.79,3.23,3.84,3.84,0,0,0,.28,1.33Z" data-v-e88891b0></path><path class="cls-2" d="M33.06,36.8a.53.53,0,0,1-.36-.13l-.59-.51-.45-.38a13.52,13.52,0,0,0-3.19-2.22,12.58,12.58,0,0,1-2.89-1.67L24.2,30.7c-.66-.58-1.23-1.08-1.62-1.38a7.4,7.4,0,0,1-2.1-2s-1.51-2.69-.7-3.67c-.65-1.34-.84-2.23-.63-2.88a1,1,0,0,1,.71-.71c-.21-.83-.1-1.36.33-1.64a1.11,1.11,0,0,1,1.29.07,1.51,1.51,0,0,1,1.58.43,7.74,7.74,0,0,1,1.26,1.8,8.19,8.19,0,0,0,.93,1.41,22.81,22.81,0,0,0,3.46,3,4.14,4.14,0,0,0,1,.59A4.31,4.31,0,0,0,29,23.82a14.64,14.64,0,0,0-1.12-1.33l-.11-.12a6.93,6.93,0,0,1-.54-.68c-.49-.79-.52-1.42-.08-1.87a.82.82,0,0,1,.59-.22,2.45,2.45,0,0,1,1.55.88,8,8,0,0,1,.81.9c.25.33.58.72,1,1.14A14.6,14.6,0,0,1,33.41,26a9.56,9.56,0,0,1,.8,3.23v0a3.66,3.66,0,0,0,.26,1.29l.06.09a12.18,12.18,0,0,0,2.86,1.85.54.54,0,0,1,.22.2.59.59,0,0,1,0,.55.57.57,0,0,1-.76.25l0,0a20,20,0,0,1-3-2,.91.91,0,0,1-.26-.29,3.56,3.56,0,0,1-.39-1.55v0a9.51,9.51,0,0,0-.78-3.15A14,14,0,0,0,30,23.05c-.39-.42-.73-.81-1-1.15A3.92,3.92,0,0,0,28,20.82a3.61,3.61,0,0,0,.67.92,12.28,12.28,0,0,1,1.25,1.55c.92,1.43,1.18,2.53.76,3.25a.61.61,0,0,1-.36.33c-.3.09-.67-.08-1.31-.43a23.53,23.53,0,0,1-4.63-3.76,7.76,7.76,0,0,1-1-1.55,4.4,4.4,0,0,0-1.12-1.55,10,10,0,0,0,4.6,5.93.56.56,0,0,1,.19.76.6.6,0,0,1-.77.19,12.89,12.89,0,0,1-3.45-3.25,13.21,13.21,0,0,1-1.66-3.65.31.31,0,0,0-.17-.24.2.2,0,0,0-.13,0,9.33,9.33,0,0,0,1.55,4.07,12.31,12.31,0,0,0,3.4,3.43.51.51,0,0,1,.21.38.54.54,0,0,1-.12.4.6.6,0,0,1-.79.1,14.86,14.86,0,0,1-3.47-3.57,10.11,10.11,0,0,1-1.43-3v0c-.15.36.19,1.53,1.13,3a16.25,16.25,0,0,0,3.24,3.59.53.53,0,0,1,.09.78.58.58,0,0,1-.8.09,17.74,17.74,0,0,1-3.08-3.37,6.74,6.74,0,0,0,.74,1.58,10.19,10.19,0,0,0,2.08,1.89c.31.25.68.58,1.07.94a22.89,22.89,0,0,0,1.81,1.54,13.33,13.33,0,0,0,2.46,1.38A15.13,15.13,0,0,1,32.52,35l.9.77a.53.53,0,0,1,.2.38.52.52,0,0,1-.13.41.57.57,0,0,1-.37.2ZM20.78,18.48a.84.84,0,0,0-.46.13c-.35.23-.41.7-.19,1.49l0,.13-.14,0a.77.77,0,0,0-.64.57c-.2.59,0,1.47.65,2.76l0,.08-.06.07c-.7.68.37,2.92.68,3.44a7.32,7.32,0,0,0,2,1.94c.39.3,1,.81,1.63,1.39l1.38,1.19a12,12,0,0,0,2.83,1.63,13.62,13.62,0,0,1,3.25,2.26l.45.38.59.51a.32.32,0,0,0,.23.07.31.31,0,0,0,.21-.11.33.33,0,0,0,.07-.23.28.28,0,0,0-.11-.21l-.9-.77a14.75,14.75,0,0,0-3.56-2.47,13.64,13.64,0,0,1-2.51-1.41,23.11,23.11,0,0,1-1.83-1.56c-.39-.35-.75-.68-1.05-.92a9.61,9.61,0,0,1-2.14-2,5.39,5.39,0,0,1-.86-2.26l0-.4.22.34A17,17,0,0,0,24,28.38a.33.33,0,0,0,.44-.06.27.27,0,0,0-.05-.43,16.26,16.26,0,0,1-3.29-3.64c-.9-1.38-1.37-2.7-1.15-3.22a.42.42,0,0,1,.3-.25l.12,0,0,.12A9.38,9.38,0,0,0,21.81,24a14.77,14.77,0,0,0,3.4,3.49.34.34,0,0,0,.45-.05.32.32,0,0,0,.08-.22.31.31,0,0,0-.11-.19,12.82,12.82,0,0,1-3.47-3.5,9.17,9.17,0,0,1-1.58-4.28.24.24,0,0,1,.09-.14.44.44,0,0,1,.39,0,.61.61,0,0,1,.31.4A12.61,12.61,0,0,0,23,23.07a12.52,12.52,0,0,0,3.36,3.17.34.34,0,0,0,.44-.1.3.3,0,0,0-.12-.42,10.27,10.27,0,0,1-4.77-6.33l-.06-.22.21.06c.63.19,1.05,1,1.49,1.78a9.09,9.09,0,0,0,1,1.51,23.72,23.72,0,0,0,4.57,3.7c.54.3.92.48,1.12.41a.4.4,0,0,0,.22-.21c.36-.63.1-1.66-.76-3a11.69,11.69,0,0,0-1.22-1.52c-.39-.43-.83-1-.75-1.23a.2.2,0,0,1,.15-.13c.31-.05.94.61,1.39,1.19.25.33.6.73,1,1.14a14.21,14.21,0,0,1,2.42,3.5,9.51,9.51,0,0,1,.8,3.23v0a3.5,3.5,0,0,0,.35,1.44,1.1,1.1,0,0,0,.2.23,21.78,21.78,0,0,0,3,2l0,0a.33.33,0,0,0,.42-.14.37.37,0,0,0,0-.31.43.43,0,0,0-.12-.11,11.4,11.4,0,0,1-3-1.94h0l-.06-.09a3.69,3.69,0,0,1-.3-1.39v0a9.36,9.36,0,0,0-.77-3.14,14,14,0,0,0-2.35-3.45c-.38-.42-.72-.82-1-1.15a6.87,6.87,0,0,0-.78-.88,2.28,2.28,0,0,0-1.39-.81h0a.53.53,0,0,0-.39.15c-.35.36-.32.86.11,1.56a6.14,6.14,0,0,0,.52.65l.1.11a11.74,11.74,0,0,1,1.14,1.36c.13.18,1,1.53.82,2.1a.2.2,0,0,1-.12.12c-.25.1-1-.41-1.3-.63a23.29,23.29,0,0,1-3.5-3,8.8,8.8,0,0,1-1-1.44,7.38,7.38,0,0,0-1.22-1.75,1.25,1.25,0,0,0-1.38-.35l-.07,0-.06-.05A.85.85,0,0,0,20.78,18.48Zm9,7.23h0Z" data-v-e88891b0></path></g></g>', 2)
      ]))) : U("", !0)
    ], 64));
  }
}), xx = "svg[data-v-e88891b0]{width:4rem}", _x = /* @__PURE__ */ Pe(Ex, [["styles", [xx]], ["__scopeId", "data-v-e88891b0"]]), Ax = ".poloclub-separator[data-v-b555ae10]{width:100%;height:1px;margin:2rem 0;background-color:var(--color-border-gray)}", wx = {}, Lx = { class: "poloclub-separator" };
function Ix(i, e) {
  return P(), N("div", Lx);
}
const jo = /* @__PURE__ */ Pe(wx, [["render", Ix], ["styles", [Ax]], ["__scopeId", "data-v-b555ae10"]]), Cx = {
  key: 0,
  class: "poloclub-size-and-cut"
}, Rx = { class: "collapsible-drawer-row__heading" }, Px = { class: "collapsible-drawer-row__content" }, Dx = { key: 0 }, Nx = { key: 1 }, Mx = /* @__PURE__ */ Re({
  __name: "PoloclubSizeAndCut.ce",
  setup(i) {
    return (e, t) => L(F).productView.product?.modelSizeMetafield?.value || L(F).productView.product?.cutMetafield?.value ? (P(), N("div", Cx, [
      w("p", Rx, ie(L(Je).sizeAndCut), 1),
      w("div", Px, [
        L(F).productView.product?.modelSizeMetafield?.value ? (P(), N("p", Dx, ie(L(F).productView.product?.modelSizeMetafield?.value), 1)) : U("", !0),
        L(F).productView.product?.cutMetafield?.value ? (P(), N("p", Nx, ie(L(F).productView.product?.cutMetafield?.value), 1)) : U("", !0)
      ])
    ])) : U("", !0);
  }
}), Ox = "[data-v-21798537],[data-v-21798537]:before,[data-v-21798537]:after{box-sizing:border-box}p[data-v-21798537],[data-v-21798537] p{margin:0;padding:0}h1[data-v-21798537],h2[data-v-21798537]{margin:0}[data-v-21798537]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.poloclub-size-and-cut[data-v-21798537]{display:flex;flex-direction:column;gap:.8rem;font-size:1.4rem}.collapsible-drawer-row__heading[data-v-21798537]{color:var(--color-black)}.collapsible-drawer-row__content[data-v-21798537]{display:flex;flex-direction:column;gap:.8rem;color:var(--color-gray)}", Lm = /* @__PURE__ */ Pe(Mx, [["styles", [Ox]], ["__scopeId", "data-v-21798537"]]), Fx = ["innerHTML"], $x = ["innerHTML"], Bx = { key: 2 }, Ux = { key: 0 }, Vx = { class: "collapsible-drawer-row__content" }, Gx = { key: 0 }, Hx = { key: 1 }, zx = { key: 3 }, Kx = { class: "collapsible-drawer-row__heading" }, jx = { class: "collapsible-drawer-row__content" }, Wx = { key: 0 }, qx = { class: "care-info-wrapper" }, Yx = ["innerHTML"], Xx = { key: 3 }, Zx = /* @__PURE__ */ Re({
  __name: "PoloclubCollapsibleDrawerRow.ce",
  props: {
    product: { type: null },
    block: { type: null }
  },
  setup(i) {
    const e = En(), t = (n) => {
      const s = F.mobileBreakpoint, r = F.tabletBreakpoint;
      i.block.typeMobile === "collapsible" && e.value < s || i.block.typeTablet === "collapsible" && e.value >= s && e.value < r || i.block.typeDesktop === "collapsible" && e.value >= r || (i.block.typeMobile === "drawer" && e.value < s || i.block.typeTablet === "drawer" && e.value >= s && e.value < r || i.block.typeDesktop === "drawer" && e.value >= r) && (n.preventDefault(), console.log("block.drawerToOpen", i.block.drawerToOpen), i.block.drawerToOpen == "poloclub-drawer-details" ? Fe.drawers.details = "open" : Br.openDrawer(i.block.drawerToOpen));
    };
    return (n, s) => (P(), N("details", {
      class: "collapsible-drawer-row",
      name: "collapsible-drawer-row",
      onClick: t
    }, [
      w("summary", null, [
        w("p", null, ie(n.block.heading), 1),
        de(kn, {
          direction: "right",
          width: "24px"
        })
      ]),
      n.block.contentSource === "custom" ? (P(), N("div", {
        key: 0,
        innerHTML: n.block.customContent,
        class: "collapsible-drawer-row__content"
      }, null, 8, Fx)) : n.block.contentSource === "page" ? (P(), N("div", {
        key: 1,
        innerHTML: n.block.pageContent
      }, null, 8, $x)) : n.block.contentSource === "product_details" ? (P(), N("div", Bx, [
        n.product?.description || n.product?.locMetafield?.value ? (P(), N("div", Ux, [
          w("div", Vx, [
            n.product?.description ? (P(), N("p", Gx, ie(n.product?.description), 1)) : U("", !0),
            n.product?.locMetafield?.value ? (P(), N("p", Hx, "Ref. " + ie(n.product?.locMetafield?.value), 1)) : U("", !0)
          ])
        ])) : U("", !0),
        (n.product?.description || n.product?.locMetafield?.value) && (n.product?.modelSizeMetafield?.value || n.product?.cutMetafield?.value) ? (P(), Ie(jo, { key: 1 })) : U("", !0),
        de(Lm),
        (n.product?.modelSizeMetafield?.value || n.product?.cutMetafield?.value) && (n.product?.compositionMetafield?.value || n.product?.caresInfoMetafield?.references?.nodes?.length || n.product?.careInfoMetafield?.value) ? (P(), Ie(jo, { key: 2 })) : U("", !0),
        n.product?.compositionMetafield?.value || n.product?.caresInfoMetafield?.references?.nodes?.length || n.product?.careInfoMetafield?.value ? (P(), N("div", zx, [
          w("p", Kx, ie(L(Je).care), 1),
          w("div", jx, [
            n.product?.compositionMetafield?.value ? (P(), N("p", Wx, ie(n.product?.compositionMetafield?.value), 1)) : U("", !0),
            n.product?.caresInfoMetafield?.references?.nodes?.length ? (P(!0), N(ve, { key: 1 }, pt(n.product?.caresInfoMetafield?.references?.nodes, (r) => (P(), N("p", null, ie(r.description?.value), 1))), 256)) : (P(!0), N(ve, { key: 2 }, pt(JSON.parse(n.product?.careIconsMetafield?.value || "[]"), (r) => (P(), N("div", qx, [
              de(_x, { icon: r }, null, 8, ["icon"]),
              w("p", {
                innerHTML: L(Je)[r]
              }, null, 8, Yx)
            ]))), 256)),
            n.product?.careInfoMetafield?.value ? (P(), N("p", Xx, ie(n.product?.careInfoMetafield?.value), 1)) : U("", !0)
          ])
        ])) : U("", !0)
      ])) : U("", !0)
    ]));
  }
}), Qx = '[data-v-e523b36d],[data-v-e523b36d]:before,[data-v-e523b36d]:after{box-sizing:border-box}p[data-v-e523b36d],[data-v-e523b36d] p{margin:0;padding:0}h1[data-v-e523b36d],h2[data-v-e523b36d]{margin:0}[data-v-e523b36d]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.collapsible-drawer-row[data-v-e523b36d]{border-top:1px solid var(--color-border-gray);border-bottom:1px solid var(--color-border-gray);overflow:hidden;interpolate-size:allow-keywords}.collapsible-drawer-row summary[data-v-e523b36d]{display:flex;justify-content:space-between;align-items:center;cursor:pointer;padding-top:2rem;padding-bottom:2rem;transition:padding-bottom .5s}.collapsible-drawer-row summary>p[data-v-e523b36d]{font-size:1.4rem;color:var(--color-black)}.collapsible-drawer-row summary[data-v-e523b36d]::marker{content:""}.collapsible-drawer-row>div[data-v-e523b36d]{display:flex;flex-direction:column;padding-top:1rem;padding-bottom:2rem}.collapsible-drawer-row>div>div:not(.poloclub-separator)[data-v-e523b36d]{display:flex;flex-direction:column;gap:1rem}.collapsible-drawer-row>div>div:not(.poloclub-separator) .collapsible-drawer-row__heading[data-v-e523b36d]{font-size:1.4rem;color:var(--color-black)}.collapsible-drawer-row>div>div:not(.poloclub-separator) .collapsible-drawer-row__content[data-v-e523b36d]{font-size:1.4rem;display:flex;flex-direction:column;gap:1rem;color:var(--color-gray)}.collapsible-drawer-row__content[data-v-e523b36d] p{font-size:1.4rem;color:var(--color-gray)}.collapsible-drawer-row__content[data-v-e523b36d] a{color:var(--color-black)}.collapsible-drawer-row__content[data-v-e523b36d] strong{font-weight:600;color:var(--color-black)}.collapsible-drawer-row:open>summary[data-v-e523b36d],.collapsible-drawer-row[open]>summary[data-v-e523b36d]{padding-bottom:0}.collapsible-drawer-row[open]>summary>.caret-icon[data-v-e523b36d]{transform:rotate(0)}.collapsible-drawer-row[data-v-e523b36d]::details-content{block-size:0;transition:block-size .5s,content-visibility .5s;transition-behavior:allow-discrete}.collapsible-drawer-row[data-v-e523b36d]:open::details-content{block-size:auto}.care-info-wrapper[data-v-e523b36d]{display:flex;align-items:center;gap:1rem}', Jx = /* @__PURE__ */ Pe(Zx, [["styles", [Qx]], ["__scopeId", "data-v-e523b36d"]]), e_ = ["width", "height"], t_ = /* @__PURE__ */ Re({
  __name: "PoloclubInfoIcon",
  props: {
    width: { default: "24" }
  },
  setup(i) {
    return (e, t) => (P(), N("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      id: "cart",
      width: e.width,
      height: e.width,
      viewBox: "0 0 24 24"
    }, t[0] || (t[0] = [
      Af('<path id="Vector" d="M0,0H24V24H0Z" fill="none"></path><g id="Ellipse_35" data-name="Ellipse 35" transform="translate(2 2)" fill="none" stroke="#000" stroke-width="1"><circle cx="10" cy="10" r="10" stroke="none"></circle><circle cx="10" cy="10" r="9.5" fill="none"></circle></g><path id="_0" data-name="0" d="M.726-8.34a.725.725,0,0,0-.72-.732.745.745,0,0,0-.744.732.738.738,0,0,0,.744.732A.717.717,0,0,0,.726-8.34ZM-.522,0H.51V-6H-.522Z" transform="translate(12.006 16.536)"></path>', 3)
    ]), 8, e_));
  }
});
function nn(i, e = {}) {
  let { scoped: t } = e, n = "";
  if ((typeof i == "string" || i instanceof String) && (i = JSON.parse(i)), (typeof e == "string" || e instanceof String || e === !0) && (t = e), i.type === "root" && i.children.length > 0)
    t ? n += `
      <div class="${t === !0 ? "rte" : t}">
        ${nn(i.children, e)}
      </div>
      ` : n += nn(i.children, e);
  else
    for (const s of i)
      switch (s.type) {
        case "paragraph":
          n += s_(s, e);
          break;
        case "heading":
          n += r_(s, e);
          break;
        case "list":
          n += a_(s, e);
          break;
        case "list-item":
          n += o_(s, e);
          break;
        case "link":
          n += l_(s, e);
          break;
        case "text":
          n += d_(s, e);
          break;
      }
  return n;
}
function i_(i, e) {
  return e && e[i] ? e[i] : null;
}
function n_(i) {
  if (!i && i?.class) return "";
  const e = " ";
  return Object.keys(i).map((t) => {
    if (i[t])
      return `${e}${t}="${i[t]}"`;
  }).join("");
}
function Di(i, e, t, n = {}) {
  return n = { ...n, class: i_(i, e) }, `<${i}${n_(n)}>${t}</${i}>`;
}
function s_(i, e) {
  const { classes: t } = e;
  return Di("p", t, nn(i?.children, e));
}
function r_(i, e) {
  const { classes: t } = e, n = `h${i?.level}`;
  return Di(n, t, nn(i?.children, e));
}
function a_(i, e) {
  const { classes: t } = e, n = i?.listType === "ordered" ? "ol" : "ul";
  return Di(n, t, nn(i?.children, e));
}
function o_(i, e) {
  const { classes: t } = e;
  return Di("li", t, nn(i?.children, e));
}
function l_(i, e) {
  const { classes: t } = e, n = {
    href: i?.url,
    title: i?.title,
    target: i?.target
  };
  return Di("a", t, nn(i?.children, e), n);
}
function d_(i, e) {
  const { classes: t, newLineToBreak: n } = e;
  return i?.bold && i?.italic ? Di("strong", t, Di("em", t, i?.value)) : i?.bold ? Di("strong", t, i?.value) : i?.italic ? Di("em", t, i?.value) : n ? i?.value?.replace(/\n/g, "<br>") : i?.value;
}
const c_ = ["innerHTML"], u_ = ["innerHTML"], f_ = /* @__PURE__ */ Re({
  __name: "PoloclubProductMessage.ce",
  props: {
    block: { type: null }
  },
  setup(i) {
    Nt((p) => ({
      "293ad38e": L(he)?.color_outlet
    }));
    const e = bs("richtext-body"), t = En(), n = le(() => {
      const p = !!St.hasAccount, y = i.block.showFor, b = i.block.type, k = St.tags || [], T = typeof i.block.loggedCustomerTags == "string" && i.block.loggedCustomerTags.trim() ? i.block.loggedCustomerTags.split(",").map((C) => C.trim()).filter(Boolean) : [], I = () => T.length ? k.some((C) => T.includes(C)) : !0, x = window.Shopify.country == "PL" ? !!F.productView.targetVariant?.privatePriceMetafieldPolonia?.value : !!F.productView.targetVariant?.privatePriceMetafield?.value, E = () => he.enable_private_sale && x, R = () => !!F.productView.targetVariant?.envio5_7_diasMetafield?.value, A = () => he.enable_preorder && F.productView.selectedVariant.isPreorder, _ = () => F.productView.product?.showProductSizeWarning?.value;
      return y === "logged" ? b === "private_sale" ? p && E() && I() : b === "5_7_days" ? p && R() && I() : b === "preorder" ? p && A() && I() : p && I() : y === "not_logged" ? b === "private_sale" ? !p && E() : b === "5_7_days" ? !p && R() : b === "preorder" ? !p && A() : !p : y === "all_users" ? b === "private_sale" ? E() : b === "5_7_days" ? R() : b === "preorder" ? A() : b === "product_size_warning" ? _() : !0 : !0;
    }), s = le(() => {
      const p = window.Shopify.country == "PL" ? F.productView?.targetVariant?.privatePriceMetafieldPolonia?.value : F.productView.targetVariant?.privatePriceMetafield?.value;
      return {
        amount: Number(p),
        currencyCode: window.Shopify?.currency.active || "EUR"
      };
    }), r = (p, y) => {
      let b = new Date(p), k = 0;
      for (; k < y; )
        b.setDate(b.getDate() + 1), b.getDay() !== 0 && b.getDay() !== 6 && k++;
      return b;
    }, a = (p) => {
      const y = new Date(p), b = y.getDay();
      return b === 6 ? y.setDate(y.getDate() + 2) : b === 0 && y.setDate(y.getDate() + 1), y;
    }, o = () => St.hasAccount && St.defaultAddress?.countryCode ? St.defaultAddress.countryCode : F.localizationCountry || "REST", l = () => {
      const p = o(), y = kv?.metaobjects?.deliveryCountry || [];
      let b = y.find((k) => k.country === p);
      return b || (b = y.find((k) => k.country === "REST")), b;
    }, d = (p) => {
      const y = (F.locale || "es-ES").replace("_", "-");
      if (isNaN(p.getTime()))
        return "";
      try {
        return p.toLocaleDateString(y, { weekday: "long", day: "numeric", month: "long" });
      } catch {
        const b = String(p.getDate()).padStart(2, "0"), k = String(p.getMonth() + 1).padStart(2, "0"), T = p.getFullYear();
        return `${b}/${k}/${T}`;
      }
    }, c = (p) => {
      const y = (F.locale || "es-ES").replace("_", "-");
      if (isNaN(p.getTime()))
        return "";
      try {
        return p.toLocaleDateString(y, { day: "numeric", month: "long" });
      } catch {
        const b = String(p.getDate()).padStart(2, "0"), k = String(p.getMonth() + 1).padStart(2, "0");
        return p.getFullYear(), `${b}/${k}`;
      }
    }, u = (p) => {
      if (!p) return /* @__PURE__ */ new Date();
      const b = p.replace(/\[|\]/g, "").trim().replace(/^"|"$/g, ""), k = b.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (k) {
        const [, x, E, R] = k;
        return new Date(Number(x), Number(E) - 1, Number(R));
      }
      const T = b.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (T) {
        const [, x, E, R] = T;
        return new Date(Number(R), Number(E) - 1, Number(x));
      }
      const I = new Date(b);
      return isNaN(I.getTime()) ? /* @__PURE__ */ new Date() : I;
    }, f = le(() => i.block.type === "private_sale" ? i.block.headingPrivateSale : i.block.type === "preorder" ? i.block.headingPreorder : i.block.type === "estimated_date" ? i.block.headingEstimatedDate : i.block.type === "5_7_days" ? i.block.heading57Days : i.block.headingCustom), h = le(() => {
      if (i.block.type === "private_sale") {
        const p = `<p class="private-price">${gn(s.value)}</p>`, y = `<span class="private-sign-in" style="cursor:pointer;text-decoration:underline;">${i.block.signInText}</span>`, b = `<span class="private-sign-up" style="cursor:pointer;text-decoration:underline;">${i.block.signUpText}</span>`;
        return i.block.bodyPrivateSale.replace(i.block.privatePriceTarget, p).replace(i.block.signInTarget, y).replace(i.block.signUpTarget, b);
      }
      if (i.block.type === "5_7_days")
        return i.block.body57Days.replace(i.block.daysTarget, i.block.daysText);
      if (i.block.type === "product_size_warning") {
        const p = F.productView.product?.showProductSizeWarning?.value;
        if (p === "runs_small")
          return i.block.runsSmallMessage;
        if (p === "runs_large")
          return i.block.runsLargeMessage;
      }
      if (i.block.type === "estimated_date") {
        const p = l();
        if (!p) return i.block.bodyEstimatedDate;
        let y = Number(p.minimum_date), b = Number(p.maximum_date);
        const k = /* @__PURE__ */ new Date();
        i.block.cutOffHour && k.getHours() >= Number(i.block.cutOffHour) && (y += 1);
        let T = r(k, y), I = r(k, b);
        (T.getDay() === 0 || T.getDay() === 6) && (T = a(T)), (I.getDay() === 0 || I.getDay() === 6) && (I = a(I));
        let x = i.block.bodyEstimatedDate;
        return x = x.replace(i.block.minDateTarget, c(T)), x = x.replace(i.block.maxDateTarget, c(I)), x;
      }
      if (i.block.type === "preorder") {
        const p = F.productView.targetVariant?.preorderMetafield?.reference?.date?.value, y = u(p);
        return F.productView.targetVariant?.preorderMetafield?.reference?.previewText?.value?.replace("__first_date__", d(y));
      }
      return i.block.bodyCustom;
    }), m = le(() => {
      if (i.block.type === "preorder") {
        const p = F.productView.targetVariant?.preorderMetafield?.reference?.text?.value;
        if (!p) return "";
        const y = nn(p), b = F.productView.targetVariant?.preorderMetafield?.reference?.date?.value, k = u(b);
        return y.replace("__first_date__", d(k));
      }
      return "";
    }), g = (p, y) => {
      let b, k, T, I, x, E, R, A, _;
      return t.value >= F.tabletBreakpoint ? (b = p.headingFontFamilyDesktop, k = p.bodyFontFamilyDesktop, T = p.fontSizeDesktop, I = p.fontColorDesktop, x = p.bgColorDesktop, E = p.paddingTopDesktop, R = p.paddingBottomDesktop, A = p.paddingLeftDesktop, _ = p.paddingRightDesktop) : t.value >= F.mobileBreakpoint ? (b = p.headingFontFamilyTablet, k = p.bodyFontFamilyTablet, T = p.fontSizeTablet, I = p.fontColorTablet, x = p.bgColorTablet, E = p.paddingTopTablet, R = p.paddingBottomTablet, A = p.paddingLeftTablet, _ = p.paddingRightTablet) : (b = p.headingFontFamilyMobile, k = p.bodyFontFamilyMobile, T = p.fontSizeMobile, I = p.fontColorMobile, x = p.bgColorMobile, E = p.paddingTopMobile, R = p.paddingBottomMobile, A = p.paddingLeftMobile, _ = p.paddingRightMobile), y === "heading" ? {
        fontFamily: b,
        fontSize: `${T}px`,
        color: I
      } : y === "body" ? {
        fontFamily: k,
        fontSize: `${T}px`,
        color: I
      } : {
        backgroundColor: x,
        padding: `${E}px ${_}px ${R}px ${A}px`
      };
    }, v = () => {
      if (!e.value) return;
      const p = e.value.querySelector(".private-sign-in"), y = e.value.querySelector(".private-sign-up");
      p && p.addEventListener("click", () => Br.openDrawer("drawer-login")), y && y.addEventListener("click", () => Br.openDrawer("drawer-sign-up"));
    };
    return wt(() => {
      Gt(v);
    }), (p, y) => n.value ? (P(), N("div", {
      key: 0,
      style: We(g(p.block, "parent")),
      class: "richtext"
    }, [
      w("p", {
        style: We(g(p.block, "heading"))
      }, ie(f.value), 5),
      w("div", {
        class: Ke(["richtext-body-container", p.block.type]),
        style: We(g(p.block, "body"))
      }, [
        p.block.type === "preorder" ? (P(), N(ve, { key: 0 }, [
          de(t_, { width: "20px" }),
          w("div", {
            innerHTML: m.value,
            class: "richtext-tooltip"
          }, null, 8, c_)
        ], 64)) : U("", !0),
        w("div", {
          ref: "richtext-body",
          innerHTML: h.value,
          class: "richtext-body"
        }, null, 8, u_)
      ], 6)
    ], 4)) : U("", !0);
  }
}), h_ = "[data-v-02d08e46],[data-v-02d08e46]:before,[data-v-02d08e46]:after{box-sizing:border-box}p[data-v-02d08e46],[data-v-02d08e46] p{margin:0;padding:0}h1[data-v-02d08e46],h2[data-v-02d08e46]{margin:0}[data-v-02d08e46]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.richtext-body-container[data-v-02d08e46]{display:flex;align-items:flex-start;gap:.5rem}.richtext-body-container>svg[data-v-02d08e46]{margin-top:.1rem}.richtext-body[data-v-02d08e46] a{color:var(--color-gray)}.richtext-body-container.private_sale[data-v-02d08e46] *{color:var(--293ad38e)}.richtext-body-container.product_size_warning[data-v-02d08e46] *{color:#9a6a4f}.richtext-body[data-v-02d08e46] .private-price{display:inline-block;width:fit-content;margin-right:.5rem;font-size:1.6rem;font-family:var(--font-body-family);color:var(--293ad38e)}.richtext-body-container:has(.richtext-tooltip)[data-v-02d08e46]{position:relative;width:fit-content;cursor:pointer}.richtext-body-container:has(.richtext-tooltip) .richtext-tooltip[data-v-02d08e46]{z-index:999;display:none;position:absolute;top:105%;left:0;width:100%;padding:1rem 1.5rem;font-size:1.4rem;color:#fff;background-color:var(--color-black);border-radius:1rem;opacity:.9}.richtext-body-container:has(.richtext-tooltip) .richtext-tooltip[data-v-02d08e46]:hover{display:block}.richtext-body-container:has(.richtext-tooltip):hover .richtext-tooltip[data-v-02d08e46]{display:block}.richtext-body-container:has(.richtext-tooltip) .richtext-body[data-v-02d08e46]{text-decoration:underline dashed;text-underline-offset:3px}@media (width >=768px){.richtext-body-container>svg[data-v-02d08e46]{margin-top:.05rem}}", m_ = /* @__PURE__ */ Pe(f_, [["styles", [h_]], ["__scopeId", "data-v-02d08e46"]]), Im = (i, e) => {
  const t = i.find((n) => n[e]?.includes("_color_swatch"));
  return t ? t[e] : "";
}, p_ = { class: "variants__wrapper" }, g_ = ["onClick"], v_ = { key: 1 }, y_ = /* @__PURE__ */ Re({
  __name: "PoloclubProductCardVariants.ce",
  props: {
    product: { type: null }
  },
  emits: ["selectVariant"],
  setup(i, { emit: e }) {
    const t = ge([]), { handleAddToCart: n } = $s(), s = e, r = le(() => i.product?.variants?.nodes || []), a = async (o) => {
      t.value.push(o), await n(i.product, o), t.value = t.value.filter((l) => l.id !== o.id), s("selectVariant", o);
    };
    return (o, l) => (P(), Ie(Vl, null, {
      default: Xe(() => [
        w("div", p_, [
          (P(!0), N(ve, null, pt(r.value, (d, c) => (P(), N(ve, { key: c }, [
            L(rn)(d) ? (P(), N("div", {
              key: 0,
              onClick: (u) => a(d),
              class: "variant"
            }, [
              t.value.includes(d) ? (P(), Ie(bi, {
                key: 0,
                theme: "dark",
                width: "20px"
              })) : (P(), N("p", v_, ie(d.title), 1))
            ], 8, g_)) : U("", !0)
          ], 64))), 128))
        ])
      ]),
      _: 1
    }));
  }
}), b_ = "[data-v-18546d5a],[data-v-18546d5a]:before,[data-v-18546d5a]:after{box-sizing:border-box}p[data-v-18546d5a],[data-v-18546d5a] p{margin:0;padding:0}h1[data-v-18546d5a],h2[data-v-18546d5a]{margin:0}[data-v-18546d5a]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.variants-container[data-v-18546d5a]{display:flex;flex-direction:column;gap:1rem}.variants__wrapper[data-v-18546d5a]{display:grid;grid-template-columns:repeat(4,1fr);gap:.5rem}.sizebay-container[data-v-18546d5a]{display:grid;grid-template-columns:repeat(2,1fr);gap:.5rem}.sizebay-container .sizebay-button[data-v-18546d5a]{color:var(--color-border-hover);font-size:1.4rem;text-decoration:underline;text-underline-offset:3px;cursor:pointer}.variant[data-v-18546d5a]{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;aspect-ratio:4/3;border:1px solid var(--color-border-gray);color:var(--color-black);background-color:#fff;transition:background-color .2s ease-in-out;cursor:pointer}.variant>p[data-v-18546d5a]:first-child{font-size:1.3rem;margin:0}.variant>p[data-v-18546d5a]:first-child:has(+p.back-in-stock,+p.show-similar,+p.sold-out){color:var(--color-gray)}.variant>p[data-v-18546d5a]:nth-child(2){position:absolute;margin:35px 0 0;font-size:.8rem;color:var(--color-gray)}.variant[data-v-18546d5a]:has(p.sold-out){cursor:auto}.variant[data-v-18546d5a]:not(:has(p.back-in-stock,p.show-similar,p.sold-out)):hover{border:1px solid var(--color-border-hover)}", Cm = /* @__PURE__ */ Pe(y_, [["styles", [b_]], ["__scopeId", "data-v-18546d5a"]]), S_ = {}, k_ = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "CART-COMPRAR",
  width: "35",
  height: "35",
  viewBox: "0 0 35 35"
};
function T_(i, e) {
  return P(), N("svg", k_, e[0] || (e[0] = [
    w("rect", {
      id: "Rectángulo_1004",
      "data-name": "Rectángulo 1004",
      width: "35",
      height: "35",
      fill: "#fff"
    }, null, -1),
    w("path", {
      id: "Sustracción_1",
      "data-name": "Sustracción 1",
      d: "M-7416.985,8010.6a1.967,1.967,0,0,1-1.952-1.979,1.969,1.969,0,0,1,1.952-1.979,1.969,1.969,0,0,1,1.951,1.979A1.967,1.967,0,0,1-7416.985,8010.6Zm0-2.957a.974.974,0,0,0-.967.979.972.972,0,0,0,.967.977.971.971,0,0,0,.965-.977A.973.973,0,0,0-7416.985,8007.645Zm-9.509,2.957a1.966,1.966,0,0,1-1.949-1.979,1.968,1.968,0,0,1,1.949-1.979,1.969,1.969,0,0,1,1.954,1.979A1.968,1.968,0,0,1-7426.494,8010.6Zm0-2.957a.973.973,0,0,0-.965.979.971.971,0,0,0,.965.977.973.973,0,0,0,.967-.977A.974.974,0,0,0-7426.494,8007.645Zm9.023-2.9h-8.469a2.234,2.234,0,0,1-2.179-1.815l-1.444-7.319,0-.012s0-.006,0-.01a.116.116,0,0,1,0-.027l-.767-3.878-.017-.081h-3.052a.5.5,0,0,1-.491-.5.5.5,0,0,1,.491-.5h3.458a.494.494,0,0,1,.483.4l.77,3.9.016.082h14.289a.491.491,0,0,1,.379.181.5.5,0,0,1,.1.414l-1.381,7.352A2.243,2.243,0,0,1-7417.471,8004.744Zm-11.014-8.76,1.333,6.75a1.247,1.247,0,0,0,1.216,1.008h8.465a1.241,1.241,0,0,0,1.21-1.008l1.249-6.63.022-.12Z",
      transform: "translate(7440.4 -7983.101)"
    }, null, -1)
  ]));
}
const E_ = /* @__PURE__ */ Pe(S_, [["render", T_]]), es = (i, e) => i[1]?.[e], x_ = { class: "product-card" }, __ = { class: "product-image-container" }, A_ = {
  key: 0,
  class: "product-image"
}, w_ = ["media", "srcset"], L_ = ["media", "srcset"], I_ = ["src", "alt"], C_ = { key: 1 }, R_ = ["media", "srcset"], P_ = ["media", "srcset"], D_ = ["src", "alt"], N_ = {
  key: 0,
  class: "product-cart-icon-container"
}, M_ = {
  key: 1,
  class: "product-cart-variants-selector"
}, O_ = ["onClick"], F_ = { key: 1 }, $_ = { class: "product-title" }, B_ = {
  width: "16px",
  height: "16px",
  viewBox: "0 0 64 64",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linejoin": "round", "stroke-miterlimit": "2" }
}, U_ = { class: "product-colors" }, V_ = { class: "product-colors-flex" }, G_ = ["onClick", "src"], vu = 5, H_ = /* @__PURE__ */ Re({
  __name: "PoloclubProductCard.ce",
  props: {
    product: { type: null },
    showSecondaryImage: { type: Boolean, default: !1 },
    showAireImage: { type: Boolean, default: !1 },
    showPrivateMsg: { type: Boolean },
    isLogged: { type: Boolean }
  },
  emits: ["click-product-image"],
  setup(i, { emit: e }) {
    const t = ge(i.product), n = ge("closed"), s = ge("closed"), r = ge(!1), a = ge([]), o = ge(!1), l = e, { setProduct: d } = fa(), { handleAddToCart: c } = $s(), u = En(), f = le(() => window.matchMedia("(hover: none)").matches), h = le(() => t.value.variants.nodes[0]), m = le(() => t.value.colorsMetafield?.references?.nodes.filter((_) => _.tags?.includes("SELECCIÓN") && _.tags?.includes("STOCK")) || []), g = le(() => t.value.media.nodes.filter((_) => _.mediaContentType === "IMAGE").map((_) => _.image)), v = () => {
      if (l("click-product-image"), yn.name === "product")
        d(t.value.id), window.dispatchEvent(new CustomEvent("product:changed")), window.scrollTo({ top: 0, behavior: "smooth" });
      else {
        const _ = Qf(`/products/${t.value.handle}`, { absoluteWhenNoLocale: !1 });
        window.location.href = _;
      }
    }, p = le(() => he.color_private_msg_preview), y = le(() => {
      if (!t.value) return !1;
      if (!i.showPrivateMsg && !St.private_sale) {
        const _ = t.value.variants?.nodes?.find(
          (C) => window.Shopify.country == "PL" ? !!C.privatePriceMetafieldPolonia?.value : !!C.privatePriceMetafield?.value
        );
        if (_) {
          const C = {
            amount: window.Shopify.country == "PL" ? _.privatePriceMetafieldPolonia?.value : _.privatePriceMetafield?.value,
            currencyCode: window.Shopify.currency.active
          };
          return Je.private_msg.replace("__price__", gn(C));
        }
      }
      return !1;
    }), b = () => {
      i.showSecondaryImage && (o.value = !0);
    }, k = (_) => {
      const C = document.querySelector(_);
      C && (C.classList.add("is-active"), document.body.style.overflow = "hidden", setTimeout(() => {
        C.classList.add("is-visible");
      }, 50));
    }, T = () => {
      i.showSecondaryImage && (o.value = !1);
    }, I = (_) => i.showAireImage && Rn(g.value, _) || t.value.featuredImage?.[_], x = async (_) => {
      const C = await pl({ productIdentifier: _ });
      C && (t.value = C);
    }, E = (_) => {
      n.value = "closed", x(_);
    }, R = async () => {
      t.value.variants.nodes.length > 1 ? s.value = "open" : (r.value = !0, await c(t.value, t.value.variants.nodes[0]), r.value = !1);
    }, A = async (_) => {
      a.value.push(_), await c(t.value, _), a.value = a.value.filter((C) => C.id !== _.id);
    };
    return Dt(() => i.product, (_) => {
      t.value = _;
    }), (_, C) => (P(), N("div", x_, [
      w("div", __, [
        w("div", {
          onClick: v,
          onMouseover: b,
          onMouseleave: T,
          class: "product-image-container-wrapper"
        }, [
          de(Rf, { name: "fade" }, {
            default: Xe(() => [
              o.value ? U("", !0) : (P(), N("picture", A_, [
                I("desktop") ? (P(), N("source", {
                  key: 0,
                  media: `(width >= ${L(F).tabletBreakpoint}px)`,
                  srcset: I("desktop")
                }, null, 8, w_)) : U("", !0),
                I("tablet") ? (P(), N("source", {
                  key: 1,
                  media: `(width >= ${L(F).mobileBreakpoint}px)`,
                  srcset: I("tablet")
                }, null, 8, L_)) : U("", !0),
                w("img", {
                  class: "product-image",
                  src: I("mobile"),
                  alt: t.value.featuredImage?.altText || "",
                  loading: "lazy"
                }, null, 8, I_)
              ])),
              i.showSecondaryImage && o.value ? (P(), N("picture", C_, [
                L(es)(g.value, "desktop") ? (P(), N("source", {
                  key: 0,
                  media: `(width >= ${L(F).tabletBreakpoint}px)`,
                  srcset: L(es)(g.value, "desktop")
                }, null, 8, R_)) : U("", !0),
                L(es)(g.value, "tablet") ? (P(), N("source", {
                  key: 1,
                  media: `(width >= ${L(F).mobileBreakpoint}px)`,
                  srcset: L(es)(g.value, "tablet")
                }, null, 8, P_)) : U("", !0),
                w("img", {
                  class: "product-image",
                  src: L(es)(g.value, "mobile"),
                  alt: t.value.featuredImage?.altText || "",
                  loading: "lazy"
                }, null, 8, D_)
              ])) : U("", !0)
            ]),
            _: 1
          })
        ], 32),
        f.value ? (P(), N("div", N_, [
          r.value ? (P(), Ie(bi, {
            key: 0,
            theme: "dark",
            width: "20px"
          })) : (P(), Ie(E_, {
            key: 1,
            onClick: R
          }))
        ])) : (P(), N("div", M_, [
          (P(!0), N(ve, null, pt(t.value.variants.nodes, (O) => (P(), N(ve, {
            key: O.id
          }, [
            L(rn)(O) ? (P(), N("div", {
              key: 0,
              onClick: (V) => A(O),
              class: "product-cart-variant-selector-item"
            }, [
              a.value.includes(O) ? (P(), Ie(bi, {
                key: 0,
                theme: "dark",
                width: "20px"
              })) : (P(), N("p", F_, ie(O.title), 1))
            ], 8, O_)) : U("", !0)
          ], 64))), 128))
        ])),
        de(gl, {
          class: "product-labels",
          type: "product-card",
          product: t.value,
          "is-logged": _.isLogged,
          variant: h.value
        }, null, 8, ["product", "is-logged", "variant"]),
        L(he).enable_wishlist ? (P(), Ie(ha, {
          key: 2,
          class: "wishlist-icon",
          type: "product-card",
          "product-id": t.value.id
        }, null, 8, ["product-id"])) : U("", !0)
      ]),
      w("p", $_, ie(t.value.title), 1),
      de(ya, {
        type: "product-card",
        variant: h.value,
        product: t.value,
        "is-highlited": h.value.highlightedPriceMetafield
      }, null, 8, ["variant", "product", "is-highlited"]),
      y.value != !1 ? (P(), N("div", {
        key: 0,
        class: "product-price--private-price-msg",
        style: We({ color: p.value }),
        onClick: C[0] || (C[0] = oa((O) => k("#drawer-login"), ["prevent", "stop"]))
      }, [
        sn(ie(y.value) + " ", 1),
        (P(), N("svg", B_, C[5] || (C[5] = [
          w("rect", {
            id: "Icons",
            x: "-576",
            y: "-64",
            width: "1280",
            height: "800",
            style: { fill: "none" }
          }, null, -1),
          w("g", {
            id: "Icons1",
            "serif:id": "Icons"
          }, [
            w("g", { id: "Strike" }),
            w("g", { id: "H1" }),
            w("g", { id: "H2" }),
            w("g", { id: "H3" }),
            w("g", { id: "list-ul" }),
            w("g", { id: "hamburger-1" }),
            w("g", { id: "hamburger-2" }),
            w("g", { id: "list-ol" }),
            w("g", { id: "list-task" }),
            w("g", { id: "trash" }),
            w("g", { id: "vertical-menu" }),
            w("g", { id: "horizontal-menu" }),
            w("g", { id: "sidebar-2" }),
            w("g", { id: "Pen" }),
            w("g", {
              id: "Pen1",
              "serif:id": "Pen"
            }),
            w("g", { id: "clock" }),
            w("g", { id: "external-link" }),
            w("g", { id: "hr" }),
            w("g", { id: "info" }, [
              w("path", {
                d: "M32.168,56.028c6.18,-0.06 12.297,-2.62 16.697,-6.967c5.224,-5.163 7.915,-12.803 6.977,-20.096c-1.609,-12.499 -11.883,-20.98 -23.828,-20.98c-9.075,0 -17.896,5.677 -21.764,13.909c-2.962,6.303 -2.968,13.911 0,20.225c3.841,8.174 12.517,13.821 21.61,13.909c0.103,0 0.205,0 0.308,0Zm-0.283,-4.004c-9.23,-0.089 -17.841,-7.227 -19.553,-16.378c-1.207,-6.452 1.071,-13.433 5.818,-18.015c5.543,-5.35 14.253,-7.142 21.496,-4.11c6.481,2.714 11.331,9.014 12.225,15.955c0.766,5.949 -1.369,12.185 -5.565,16.48c-3.68,3.767 -8.841,6.017 -14.163,6.068c-0.086,0 -0.172,0 -0.258,0Z",
                style: { "fill-rule": "nonzero" }
              }),
              w("path", {
                d: "M33.986,44.028l-3.907,0l0,-17.393l3.907,0l0,17.393Zm-4.148,-21.91c0,-0.601 0.19,-1.099 0.571,-1.495c0.38,-0.397 0.924,-0.595 1.632,-0.595c0.707,0 1.253,0.198 1.639,0.595c0.386,0.396 0.579,0.894 0.579,1.495c0,0.589 -0.193,1.079 -0.579,1.47c-0.386,0.392 -0.932,0.587 -1.639,0.587c-0.708,0 -1.252,-0.195 -1.632,-0.587c-0.381,-0.391 -0.571,-0.881 -0.571,-1.47Z",
                style: { "fill-rule": "nonzero" }
              })
            ]),
            w("g", { id: "warning" }),
            w("g", { id: "plus-circle" }),
            w("g", { id: "minus-circle" }),
            w("g", { id: "vue" }),
            w("g", { id: "cog" }),
            w("g", { id: "logo" }),
            w("g", { id: "radio-check" }),
            w("g", { id: "eye-slash" }),
            w("g", { id: "eye" }),
            w("g", { id: "toggle-off" }),
            w("g", { id: "shredder" }),
            w("g", {
              id: "spinner--loading--dots-",
              "serif:id": "spinner [loading, dots]"
            }),
            w("g", { id: "react" }),
            w("g", { id: "check-selected" }),
            w("g", { id: "turn-off" }),
            w("g", { id: "code-block" }),
            w("g", { id: "user" }),
            w("g", { id: "coffee-bean" }),
            w("g", { id: "coffee-beans" }, [
              w("g", {
                id: "coffee-bean1",
                "serif:id": "coffee-bean"
              })
            ]),
            w("g", { id: "coffee-bean-filled" }),
            w("g", { id: "coffee-beans-filled" }, [
              w("g", {
                id: "coffee-bean2",
                "serif:id": "coffee-bean"
              })
            ]),
            w("g", { id: "clipboard" }),
            w("g", { id: "clipboard-paste" }),
            w("g", { id: "clipboard-copy" }),
            w("g", { id: "Layer1" })
          ], -1)
        ])))
      ], 4)) : U("", !0),
      w("div", U_, [
        w("div", V_, [
          (P(!0), N(ve, null, pt(m.value, (O) => (P(), N("img", {
            key: O.id,
            onClick: (V) => x(O.id),
            class: Ke({ "selected-color": t.value.id === O.id }),
            src: L(Im)(O.images.nodes, "mobile") || L(zi)(O.images.nodes, "mobile")
          }, null, 10, G_))), 128))
        ]),
        (m.value?.length || 0) > vu ? (P(), N("span", {
          key: 0,
          onClick: C[1] || (C[1] = (O) => n.value = "open"),
          class: "hidden-colors-count"
        }, " +" + ie((m.value?.length || 0) - vu), 1)) : U("", !0)
      ]),
      de(Pi, {
        type: L(u) >= L(F).tabletBreakpoint ? "right" : "bottom",
        state: n.value,
        title: L(Je).selectAColor,
        onClose: C[3] || (C[3] = (O) => n.value = "closed")
      }, {
        default: Xe(() => [
          de(Vr, {
            product: t.value,
            display: "grid",
            "grid-columns": 3,
            onSelectColor: C[2] || (C[2] = (O) => E(O))
          }, null, 8, ["product"])
        ]),
        _: 1
      }, 8, ["type", "state", "title"]),
      de(Pi, {
        type: L(u) >= L(F).tabletBreakpoint ? "right" : "bottom",
        state: s.value,
        title: L(Je).selectASize,
        onClose: C[4] || (C[4] = (O) => s.value = "closed")
      }, {
        default: Xe(() => [
          de(Cm, {
            product: t.value,
            onSelectVariant: L(c)
          }, null, 8, ["product", "onSelectVariant"])
        ]),
        _: 1
      }, 8, ["type", "state", "title"])
    ]));
  }
}), z_ = "[data-v-bff346ee],[data-v-bff346ee]:before,[data-v-bff346ee]:after{box-sizing:border-box}p[data-v-bff346ee],[data-v-bff346ee] p{margin:0;padding:0}h1[data-v-bff346ee],h2[data-v-bff346ee]{margin:0}[data-v-bff346ee]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.product-card[data-v-bff346ee]{display:flex;flex-direction:column;gap:.5rem;width:clamp(160px,100%,320px)}.product-card .product-image-container[data-v-bff346ee]{position:relative}.product-card .product-image-container .product-image-container-wrapper[data-v-bff346ee]{position:relative;width:100%;aspect-ratio:9 / 13.5}.product-card .product-image-container .product-image-container-wrapper>picture[data-v-bff346ee]{position:absolute;top:0;left:0;display:flex;cursor:pointer}.product-card .product-image-container .product-image-container-wrapper>picture .product-image[data-v-bff346ee]{width:100%;aspect-ratio:9/13.5}.product-card .product-colors[data-v-bff346ee]{display:flex;align-items:center;gap:.7rem}.product-card .product-colors .product-colors-flex[data-v-bff346ee]{display:flex;align-items:center;gap:.5rem}.product-card .product-colors .product-colors-flex>img[data-v-bff346ee]{width:20px;aspect-ratio:1;border-radius:50%;border:1px solid var(--color-gray-2);padding:.1rem;cursor:pointer;object-fit:cover}.product-card .product-colors .product-colors-flex>img.selected-color[data-v-bff346ee]{border:1px solid var(--color-black)}.product-card .product-colors .product-colors-flex>img[data-v-bff346ee]:nth-child(n+6){display:none}.product-card .product-colors .hidden-colors-count[data-v-bff346ee]{font-size:14px;color:var(--color-gray);text-decoration:underline;cursor:pointer}.product-card .product-labels[data-v-bff346ee]{position:absolute;bottom:8px;left:8px}.product-image-container:has(.product-cart-variants-selector):hover>.product-labels[data-v-bff346ee]{display:none}.product-card .wishlist-icon[data-v-bff346ee]{position:absolute;top:12px;right:12px}.product-image-container:hover>.product-cart-variants-selector[data-v-bff346ee]:has(.product-cart-variant-selector-item){display:flex;opacity:1}@starting-style{.product-image-container:hover>.product-cart-variants-selector[data-v-bff346ee]:has(.product-cart-variant-selector-item){opacity:0}}.product-cart-icon-container[data-v-bff346ee]{position:absolute;bottom:0;right:0;display:flex;justify-content:center;align-items:center;width:35px;aspect-ratio:1;background-color:#fff;cursor:pointer}.product-cart-variants-selector[data-v-bff346ee]{display:none;position:absolute;bottom:0;left:1rem;right:1rem;justify-content:space-between;align-items:center;gap:.5em;height:7%;min-height:48px;margin:0 0 1rem;background-color:#fff9;box-shadow:0 0 5px #0000001a;padding:.5em .7em;opacity:0;transition:opacity .3s ease-in-out,display .3s ease-in-out allow-discrete}.product-cart-variants-selector>div[data-v-bff346ee]:hover{background-color:#fff}.product-cart-variants-selector>div[data-v-bff346ee]{display:flex;justify-content:center;align-items:center;width:100%;height:100%;font-size:12px;color:#000;cursor:pointer}.product-title[data-v-bff346ee]{display:-webkit-box;line-clamp:1;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;color:var(--color-black);font-size:1.2rem}@media (width >=768px){.product-title[data-v-bff346ee]{font-size:1.4rem}.product-card[data-v-bff346ee]{width:clamp(170px,100%,465px)}.product-card .product-labels[data-v-bff346ee]{bottom:15px;left:15px}.product-card .wishlist-icon[data-v-bff346ee]{top:15px;right:15px}}.fade-enter-active[data-v-bff346ee],.fade-leave-active[data-v-bff346ee]{transition:opacity .1s ease-in-out}.fade-enter-from[data-v-bff346ee],.fade-leave-to[data-v-bff346ee]{opacity:.2}.product-price--private-price-msg[data-v-bff346ee]{margin:0;font-size:clamp(1.1rem,2.5vw,1.2rem);opacity:.8;cursor:pointer;display:flex;align-items:center;gap:.3rem}.product-price--private-price-msg svg[data-v-bff346ee]{fill:currentColor}", Rm = /* @__PURE__ */ Pe(H_, [["styles", [z_]], ["__scopeId", "data-v-bff346ee"]]), K_ = {
  key: 0,
  class: "spinner-container"
}, j_ = {
  key: 1,
  class: "error-container"
}, W_ = {
  key: 2,
  class: "show-similar-container"
}, q_ = /* @__PURE__ */ Re({
  __name: "PoloclubProductShowSimilar.ce",
  props: {
    isLogged: { type: Boolean }
  },
  setup(i) {
    const e = {
      en: "We didn't find any similar products",
      es: "No encontramos productos similares",
      it: "Non abbiamo trovato prodotti simili",
      pl: "Nie znaleźliśmy podobnych produktów",
      pt: "Não encontramos produtos semelhantes",
      nl: "We hebben geen vergelijkbare producten gevonden",
      fr: "Nous n'avons trouvé aucun produit similaire",
      de: "Wir haben keine ähnlichen Produkte gefunden"
    }, t = window.Shopify?.locale ?? "en", n = e[t] ?? e.en, s = le(() => !Fe.similarProducts.selectedVariant || !Fe.similarProducts.products.length ? [] : Fe.similarProducts.products.map((r) => {
      const a = r.variants?.nodes?.find(
        (o) => o.title === Fe.similarProducts.selectedVariant.title
      );
      return a ? {
        ...r,
        variants: {
          ...r.variants,
          nodes: [a]
        }
      } : null;
    }).filter((r) => r !== null).sort((r, a) => (a.totalInventory ?? 0) - (r.totalInventory ?? 0)));
    return Dt(s, (r) => {
      if (!r.length) return;
      console.log("newValue", r);
      const a = r.flatMap((o) => o.variants.nodes.map((l) => Number(l.price.amount))).reduce((o, l) => o + l, 0);
      window.dataLayer = window.dataLayer || [], window.dataLayer.push({
        event: "view_item_list",
        ecommerce: {
          event_category: "ecommerce",
          currency: Shopify.currency.active,
          value: a,
          item_list_id: "",
          item_list_name: "View similar products",
          items: r.map((o, l) => ({
            item_id: o?.variants?.nodes[0]?.id.split("/").pop(),
            product_id: o?.id?.split("/").pop(),
            item_name: o?.title,
            quantity: 1,
            price: Number(o?.variants?.nodes[0]?.price?.amount) || 0,
            price_new: Number(o?.variants?.nodes[0]?.compareAtPrice?.amount) || 0,
            discount: Number((o?.variants?.nodes[0]?.compareAtPrice?.amount - o?.variants?.nodes[0]?.price?.amount).toFixed(2)) || 0,
            coupon: "",
            item_brand: o?.vendor,
            item_category: o?.productType?.split(">")[0],
            item_category2: o?.productType?.split(">")[1],
            item_category3: o?.productType?.split(">")[2],
            item_variant: o?.variants?.nodes[0]?.title,
            affiliation: "",
            location_id: o?.locMetafield?.value,
            index: l,
            item_list_name: "View similar products",
            item_list_id: "",
            promotion_name: o?.productActionMetafield?.value,
            promotion_id: "",
            product_img: o?.media?.nodes[0]?.previewImage?.url || o.media?.nodes[0]?.image?.url,
            color: o?.filterColorMetafield?.value,
            tags: o?.tags
          }))
        }
      });
    }, { immediate: !0 }), (r, a) => L(Fe).similarProducts.status === "pending" ? (P(), N("div", K_, [
      de(bi, {
        theme: "dark",
        width: "50px"
      })
    ])) : L(Fe).similarProducts.status === "error" ? (P(), N("div", j_, [
      w("p", null, ie(L(n)), 1)
    ])) : (P(), N("div", W_, [
      (P(!0), N(ve, null, pt(s.value, (o) => (P(), Ie(Rm, {
        key: o.id,
        product: o,
        "is-logged": r.isLogged,
        onClickProductImage: a[0] || (a[0] = (l) => L(Fe).drawers.similarProducts = "closed")
      }, null, 8, ["product", "is-logged"]))), 128))
    ]));
  }
}), Y_ = "[data-v-d118e8a6],[data-v-d118e8a6]:before,[data-v-d118e8a6]:after{box-sizing:border-box}p[data-v-d118e8a6],[data-v-d118e8a6] p{margin:0;padding:0}h1[data-v-d118e8a6],h2[data-v-d118e8a6]{margin:0}[data-v-d118e8a6]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.spinner-container[data-v-d118e8a6]{display:flex;justify-content:center;align-items:center;height:100%}.error-container[data-v-d118e8a6]{text-align:center;color:var(--color-black)}.show-similar-container[data-v-d118e8a6]{display:grid;grid-template-columns:repeat(2,1fr);gap:4px}@media (width >=768px){.show-similar-container[data-v-d118e8a6]{gap:8px}}", X_ = /* @__PURE__ */ Pe(q_, [["styles", [Y_]], ["__scopeId", "data-v-d118e8a6"]]), Z_ = { class: "poloclub-product-info" }, Q_ = {
  key: 0,
  class: "product-title"
}, J_ = ["innerHTML"], e2 = { class: "special_conditions_drawer__title" }, t2 = ["innerHTML"], i2 = ["innerHTML"], n2 = { key: 0 }, s2 = { key: 0 }, r2 = /* @__PURE__ */ Re({
  __name: "PoloclubProductInfo.ce",
  props: {
    isLogged: { type: Boolean },
    blocks: { type: null }
  },
  setup(i) {
    const { setProduct: e } = fa(), t = bs("buy-button"), n = ge(!1), { addingToCart: s, handleAddToCart: r } = $s();
    let a = null;
    const o = En(), {
      firstProductPrice: l
    } = zl(), d = (g) => {
      Fe.drawers.colors = "closed", e(g), window.scrollTo({ top: 0, behavior: "smooth" });
    }, c = async () => {
      F.productView.selectedVariant.variant && await r(F.productView.product, F.productView.selectedVariant.variant);
    }, u = (g) => he.klarna_active && g.locales.split(",").includes(F.locale), f = (g) => he.scalapay_active && g.locales.split(",").includes(F.locale), h = (g) => {
      let v, p;
      return o.value >= F.tabletBreakpoint ? (v = g.marginTopDesktop, p = g.marginBottomDesktop) : o.value >= F.mobileBreakpoint ? (v = g.marginTopTablet, p = g.marginBottomTablet) : (v = g.marginTopMobile, p = g.marginBottomMobile), {
        marginTop: `${v}px`,
        marginBottom: `${p}px`
      };
    }, m = () => {
      Gt(() => {
        let g = Array.isArray(t.value) ? t.value[0] : t.value, v = document.querySelector("footer");
        g && v && (a = new IntersectionObserver(
          (p) => {
            p.forEach((y) => {
              n.value = y.isIntersecting;
            });
          },
          {
            root: null,
            threshold: 0.01
          }
        ), a.observe(g.$el), a.observe(v));
      });
    };
    return wt(() => {
      m();
    }), (g, v) => (P(), N("div", Z_, [
      (P(!0), N(ve, null, pt(g.blocks, (p, y) => (P(), N("div", {
        key: y,
        class: Ke(["block", `block-${p.name}`]),
        style: We(h(p))
      }, [
        p.name === "title" ? (P(), N("h1", Q_, ie(L(F).productView.product?.title), 1)) : U("", !0),
        p.name === `product-message-${p.id}` ? (P(), Ie(m_, {
          key: 1,
          block: p
        }, null, 8, ["block"])) : U("", !0),
        p.name === `@app-${p.id}` ? na(g.$slots, p.name, { key: 2 }, void 0, !0) : U("", !0),
        p.name === "colors" && L(F).productView.product?.colorsMetafield ? (P(), N(ve, { key: 3 }, [
          de(Pi, {
            type: "bottom",
            state: L(Fe).drawers.colors,
            title: L(Je).selectAColor,
            height: L(o) > L(F).mobileBreakpoint ? "fit-content" : void 0,
            onClose: v[1] || (v[1] = (b) => L(Fe).drawers.colors = "closed")
          }, {
            default: Xe(() => [
              de(Vr, {
                product: L(F).productView.product,
                display: L(o) > L(F).mobileBreakpoint ? "flex" : "grid",
                "grid-columns": 3,
                onSelectColor: v[0] || (v[0] = (b) => d(b))
              }, null, 8, ["product", "display"])
            ]),
            _: 1
          }, 8, ["state", "title", "height"]),
          de(Vr, {
            product: L(F).productView.product,
            display: "grid",
            "grid-columns": 7,
            onSelectColor: v[2] || (v[2] = (b) => L(e)(b))
          }, null, 8, ["product"])
        ], 64)) : U("", !0),
        p.name === "buy-button" ? (P(), N(ve, { key: 4 }, [
          L(F).productView.product?.returnsSpecialConditions?.value == "true" && L(he).show_special_conditions_drawer == !0 ? (P(), N(ve, { key: 0 }, [
            w("div", {
              class: "special_conditions_drawer",
              onClick: v[3] || (v[3] = (b) => L(Fe).drawers.specialConditions = "open"),
              innerHTML: L(he).special_conditions_richtext
            }, null, 8, J_),
            de(Pi, {
              type: "right",
              state: L(Fe).drawers.specialConditions,
              title: L(he).special_conditions_title,
              onClose: v[4] || (v[4] = (b) => L(Fe).drawers.specialConditions = "closed"),
              height: "100dvh"
            }, {
              default: Xe(() => [
                w("p", e2, ie(L(he).special_conditions_desc_title), 1),
                L(F).productView.product?.productCategory?.value == "Underwear" ? (P(), N("div", {
                  key: 0,
                  innerHTML: L(he).special_conditions_description_boxers
                }, null, 8, t2)) : L(F).productView.product?.productCategory?.value == "Camiseta" ? (P(), N("div", {
                  key: 1,
                  innerHTML: L(he).special_conditions_description_pack
                }, null, 8, i2)) : U("", !0)
              ]),
              _: 1
            }, 8, ["state", "title"])
          ], 64)) : U("", !0),
          de(Kl, {
            ref_for: !0,
            ref: "buy-button",
            onClick: c,
            type: "add-to-cart",
            theme: "light",
            disabled: !L(F).productView.selectedVariant.variant || !L(rn)(L(F).productView.selectedVariant.variant) || L(s)
          }, {
            default: Xe(() => [
              L(s) ? (P(), Ie(bi, {
                key: 0,
                theme: "light",
                width: "20px"
              })) : (P(), N(ve, { key: 1 }, [
                sn(ie(L(F).productView.selectedVariant.variant ? L(he).enable_preorder && L(F).productView.selectedVariant.isPreorder ? L(Je).addToCartPreorder : L(Je).addToCart : L(Je).selectASize), 1)
              ], 64))
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 64)) : U("", !0),
        p.name === "price" ? (P(), Ie(ya, {
          key: 5,
          type: "product-view",
          "is-highlited": L(F).productView.product?.variants.nodes[0].highlightedPriceMetafield?.value
        }, null, 8, ["is-highlited"])) : U("", !0),
        p.name === "variants" ? (P(), N(ve, { key: 6 }, [
          de(Pi, {
            type: L(o) >= L(F).mobileBreakpoint ? "right" : "bottom",
            state: L(Fe).drawers.variants,
            title: L(Je).selectASize,
            onClose: v[5] || (v[5] = (b) => L(Fe).drawers.variants = "closed")
          }, {
            default: Xe(() => [
              de(gu, {
                product: L(F).productView.product,
                "selected-variant": L(F).productView.selectedVariant.variant,
                "show-heading": !1,
                block: p
              }, null, 8, ["product", "selected-variant", "block"]),
              de(jo),
              de(Lm)
            ]),
            _: 2
          }, 1032, ["type", "state", "title"]),
          de(Pi, {
            type: L(o) >= L(F).mobileBreakpoint ? "right" : "bottom",
            state: L(Fe).drawers.similarProducts,
            title: p.showSimilarDrawerHeading.replace("__SIZE__", L(Fe).similarProducts.selectedVariant?.title),
            onClose: v[6] || (v[6] = (b) => L(Fe).drawers.similarProducts = "closed")
          }, {
            default: Xe(() => [
              de(X_, { "is-logged": g.isLogged }, null, 8, ["is-logged"])
            ]),
            _: 2
          }, 1032, ["type", "state", "title"]),
          de(gu, {
            product: L(F).productView.product,
            "selected-variant": L(F).productView.selectedVariant.variant,
            block: p
          }, null, 8, ["product", "selected-variant", "block"])
        ], 64)) : U("", !0),
        p.name === "klarna" ? (P(), N(ve, { key: 7 }, [
          u(p) ? (P(), N("div", n2, [
            de(uT, {
              "klarna-key": p.klarnaStyle,
              "klarna-theme": p.klarnaStyle,
              "purchase-amount": L(l).price ? Math.round(Number(L(l).price.replace(/[^\d.,-]/g, "").replace(",", ".")) * 100) : 0
            }, null, 8, ["klarna-key", "klarna-theme", "purchase-amount"])
          ])) : U("", !0)
        ], 64)) : U("", !0),
        p.name === "scalapay" ? (P(), N(ve, { key: 8 }, [
          f(p) ? (P(), N("div", s2, [
            de(hT, {
              amount: L(l).price ? L(l).price.replace(/[^\d.,-]/g, "") : "0"
            }, null, 8, ["amount"])
          ])) : U("", !0)
        ], 64)) : U("", !0),
        p.name === "collapsible-drawer-row" ? (P(), Ie(Jx, {
          key: 9,
          product: L(F).productView.product,
          block: p
        }, null, 8, ["product", "block"])) : U("", !0),
        p.name === "fixed-bar" ? (P(), Ie(rx, {
          key: 10,
          "hide-fixed-bar": n.value
        }, null, 8, ["hide-fixed-bar"])) : U("", !0)
      ], 6))), 128))
    ]));
  }
}), a2 = "[data-v-e9ca89c4],[data-v-e9ca89c4]:before,[data-v-e9ca89c4]:after{box-sizing:border-box}p[data-v-e9ca89c4],[data-v-e9ca89c4] p{margin:0;padding:0}h1[data-v-e9ca89c4],h2[data-v-e9ca89c4]{margin:0}[data-v-e9ca89c4]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.poloclub-product-info[data-v-e9ca89c4]{padding:0 var(--page-horizontal-padding)}.product-title[data-v-e9ca89c4]{font-family:FreightDisp Pro;font-size:2.1rem;color:var(--color-black);line-height:2.8rem;font-weight:400}.price__block[data-v-e9ca89c4]{display:inline-flex;gap:5px;margin:0}.sale[data-v-e9ca89c4]{color:#9a6a4f;font-weight:400}.private-price__msg[data-v-e9ca89c4]{display:flex;gap:.3rem}.private-price__msg[data-v-e9ca89c4]:hover{width:fit-content;border-bottom-width:1px;border-bottom-style:dashed;cursor:pointer}.private-price__msg>svg[data-v-e9ca89c4]{height:auto;aspect-ratio:1}.private-price__block[data-v-e9ca89c4]{display:flex;align-items:baseline;flex-wrap:wrap;gap:.7rem}.private-price[data-v-e9ca89c4]{font-size:1.6rem;font-weight:400}.private-price__block-text[data-v-e9ca89c4]{line-height:1.8rem}.private-price__block-text[data-v-e9ca89c4]>span{text-decoration:underline;cursor:pointer}.block-collapsible-drawer-row:has(~.block-collapsible-drawer-row) details[data-v-e9ca89c4]{border-bottom:none}.product__alternatives[data-v-e9ca89c4]{position:fixed;display:block;top:50%;left:50%;width:60vw;height:80vh;transform:translate(-50%,-50%);background-color:#fff;padding:1.5rem;z-index:2}.product__alternatives--grid[data-v-e9ca89c4]{display:grid;grid-template-columns:repeat(4,1fr);gap:8px}.related__product[data-v-e9ca89c4]{display:flex;flex-wrap:wrap}.related__product img[data-v-e9ca89c4]{width:100%;max-width:400px}.special_conditions_drawer[data-v-e9ca89c4]{margin-bottom:1rem;font-size:1.4rem;line-height:1.8rem;margin-top:1rem;cursor:pointer}.special_conditions_drawer__title[data-v-e9ca89c4]{margin-bottom:1.6rem;font-size:1.2rem;line-height:1rem;letter-spacing:.1rem;text-transform:uppercase;color:#000}@media (width >=768px){.poloclub-product-info[data-v-e9ca89c4]{width:50%;padding:0 calc(3rem - var(--page-horizontal-padding)) 0 3rem}.product-title[data-v-e9ca89c4]{font-size:3.2rem;line-height:4.2rem}}@media (width >=1024px){.poloclub-product-info[data-v-e9ca89c4]{width:35%;padding:0 calc(clamp(1.5rem,3vw,10rem) - var(--page-horizontal-padding)) 0 clamp(1.5rem,3vw,10rem)}}", o2 = /* @__PURE__ */ Pe(r2, [["styles", [a2]], ["__scopeId", "data-v-e9ca89c4"]]), Ni = (i) => {
  const e = Uint8Array.from(atob(i), (t) => t.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(e));
}, l2 = {
  key: 0,
  class: "product-view-main"
}, d2 = /* @__PURE__ */ Re({
  __name: "PoloclubProductView.ce",
  props: {
    sectionSettingsData: { type: String },
    blocksData: { type: String }
  },
  setup(i) {
    Nt((a) => ({
      "0dc0d4d5": L(t).marginTopMobile + "px",
      "355da521": L(t).marginBottomMobile + "px",
      "0ccde291": L(t).marginTopTablet + "px",
      "346ab2dd": L(t).marginBottomTablet + "px",
      "7ca39472": L(t).marginTopDesktop + "px",
      e4a9220a: L(t).marginBottomDesktop + "px"
    }));
    const e = i, t = Ni(e.sectionSettingsData), n = Ni(e.blocksData), s = le(() => F.productView.product && n), r = le(() => n.find((a) => a.name === "product_media"));
    return Dt(() => F.productView.product, (a) => {
      a && (F.productView.selectedVariant.variant = null);
    }), (a, o) => s.value ? (P(), N("div", l2, [
      r.value ? (P(), Ie(dT, {
        key: 0,
        "is-logged": JSON.parse(L(t)?.customer?.isLogged)
      }, null, 8, ["is-logged"])) : U("", !0),
      de(o2, {
        blocks: L(n),
        "is-logged": JSON.parse(L(t)?.customer?.isLogged)
      }, null, 8, ["blocks", "is-logged"])
    ])) : U("", !0);
  }
}), c2 = "[data-v-85e382a1],[data-v-85e382a1]:before,[data-v-85e382a1]:after{box-sizing:border-box}p[data-v-85e382a1],[data-v-85e382a1] p{margin:0;padding:0}h1[data-v-85e382a1],h2[data-v-85e382a1]{margin:0}[data-v-85e382a1]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.product-view-main[data-v-85e382a1]{display:flex;flex-direction:column;justify-self:center;width:100%;max-width:175rem;margin-top:var(--0dc0d4d5);margin-bottom:var(--355da521)}@media (width >=768px){.product-view-main[data-v-85e382a1]{flex-direction:row;padding:0 var(--page-horizontal-padding);margin-top:var(--0ccde291);margin-bottom:var(--346ab2dd)}}@media (width >=1024px){.product-view-main[data-v-85e382a1]{margin-top:var(--7ca39472);margin-bottom:var(--e4a9220a)}}", u2 = /* @__PURE__ */ Pe(d2, [["styles", [c2]], ["__scopeId", "data-v-85e382a1"]]), f2 = `#import "./fragments/productCardFields.graphql"

query GetProductCard(
  $productGid: ID
  $productHandle: String!
  $useGid: Boolean!
  $useHandle: Boolean!
  $country: CountryCode!
  $locale: LanguageCode!
  $maxVariants: Int!
  $maxMedia: Int!
  $maxColors: Int!
) @inContext(country: $country, language: $locale) {
  productById: product(id: $productGid) @include(if: $useGid) {
    ...ProductCardFields
  }
  productByHandle: productByHandle(handle: $productHandle) @include(if: $useHandle) {
    ...ProductCardFields
  }
}
`, Gr = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "GetProductCard" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productGid" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productHandle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "useGid" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "useHandle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "country" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CountryCode" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LanguageCode" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxVariants" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxMedia" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxColors" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }], directives: [{ kind: "Directive", name: { kind: "Name", value: "inContext" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "country" }, value: { kind: "Variable", name: { kind: "Name", value: "country" } } }, { kind: "Argument", name: { kind: "Name", value: "language" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "productById" }, name: { kind: "Name", value: "product" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "productGid" } } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "useGid" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProductCardFields" }, directives: [] }] } }, { kind: "Field", alias: { kind: "Name", value: "productByHandle" }, name: { kind: "Name", value: "productByHandle" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "handle" }, value: { kind: "Variable", name: { kind: "Name", value: "productHandle" } } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "useHandle" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProductCardFields" }, directives: [] }] } }] } }], loc: { start: 0, end: 567, source: { name: "GraphQL request", locationOffset: { line: 1, column: 1 }, body: f2 } } }, h2 = (i) => {
  const e = {};
  return i.filter(function(t) {
    if (t.kind !== "FragmentDefinition")
      return !0;
    const n = t.name.value;
    return e[n] ? !1 : (e[n] = !0, !0);
  });
};
Gr.definitions = h2(Gr.definitions.concat(Hl.definitions));
const m2 = (i, e) => {
  const t = (c, u) => {
    if (c.kind === "FragmentSpread")
      u.add(c.name.value);
    else if (c.kind === "VariableDefinition") {
      const f = c.type;
      f.kind === "NamedType" && u.add(f.name.value);
    }
    return c && "selectionSet" in c && c.selectionSet && c.selectionSet.selections.forEach((f) => {
      t(f, u);
    }), c && "variableDefinitions" in c && c.variableDefinitions && c.variableDefinitions.forEach((f) => {
      t(f, u);
    }), c && "definitions" in c && c.definitions && c.definitions.forEach((f) => {
      t(f, u);
    }), u;
  }, n = (c) => {
    const u = {};
    return c.definitions.forEach(function(f) {
      "name" in f && f.name && (u[f.name.value] = t(f, /* @__PURE__ */ new Set()));
    }), u;
  }, s = (c, u) => {
    for (let f = 0; f < c.definitions.length; f++) {
      const h = c.definitions[f];
      if (h && "name" in h && h.name && h.name.value == u)
        return h;
    }
  }, r = n(i), a = Object.assign({}, i, {
    definitions: [s(i, e)]
  }), o = r[e] || /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set();
  let d = /* @__PURE__ */ new Set();
  for (o.forEach((c) => {
    d.add(c);
  }); d.size > 0; ) {
    const c = d;
    d = /* @__PURE__ */ new Set(), c.forEach((u) => {
      l.has(u) || (l.add(u), (r[u] || /* @__PURE__ */ new Set()).forEach((h) => {
        d.add(h);
      }));
    });
  }
  return l.forEach((c) => {
    const u = s(i, c);
    u && a.definitions.push(u);
  }), a;
};
m2(Gr, "GetProductCard");
const p2 = 25, g2 = 25, v2 = 25, ms = async ({
  productIdentifiers: i
}) => {
  if (!i.length) return [];
  const e = ua();
  if (!e) throw new Error("Shopify client not initialized");
  return (await Promise.all(
    i.map(async (n) => {
      const s = typeof n == "string" && n.startsWith("gid://"), r = {
        productGid: s ? n : void 0,
        productHandle: s ? "" : n,
        useGid: s,
        useHandle: !s,
        country: F.localizationCountry,
        locale: F.locale.replace(/-/g, "_").toUpperCase(),
        maxVariants: p2,
        maxMedia: g2,
        maxColors: v2
      };
      try {
        const a = da(Gr), o = await e.request(
          a,
          {
            variables: r
          }
        ), l = o.data?.productById || o.data?.productByHandle;
        return Array.isArray(o.errors?.graphQLErrors) && o.errors.graphQLErrors.length > 0 && console.error("GraphQL errors:", o.errors.graphQLErrors), l || (console.warn(`Product with identifier ${n} not found`), null);
      } catch (a) {
        return console.error(`Error fetching product ${n}:`, a), null;
      }
    })
  )).filter(
    (n) => n !== null
  );
}, Wo = (i) => {
  window.dataLayer && (window.dataLayer.push({ ecommerce: null }), window.dataLayer.push(i));
}, y2 = `#import "./fragments/productCardFields.graphql"

query GetCollectionProducts(
  $collectionGid: ID
  $collectionHandle: String!
  $useGid: Boolean!
  $useHandle: Boolean!
  $country: CountryCode!
  $locale: LanguageCode!
  $first: Int!
  $maxVariants: Int!
  $maxMedia: Int!
  $maxColors: Int!
) @inContext(country: $country, language: $locale) {
  collectionById: collection(id: $collectionGid) @include(if: $useGid) {
    products(first: $first) {
      nodes {
        ...ProductCardFields
      }
    }
  }
  collectionByHandle: collectionByHandle(handle: $collectionHandle)
    @include(if: $useHandle) {
    products(first: $first) {
      nodes {
        ...ProductCardFields
      }
    }
  }
}
`, Hr = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "GetCollectionProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "collectionGid" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "collectionHandle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "useGid" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "useHandle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "country" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CountryCode" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LanguageCode" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxVariants" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxMedia" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxColors" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }], directives: [{ kind: "Directive", name: { kind: "Name", value: "inContext" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "country" }, value: { kind: "Variable", name: { kind: "Name", value: "country" } } }, { kind: "Argument", name: { kind: "Name", value: "language" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "collectionById" }, name: { kind: "Name", value: "collection" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "collectionGid" } } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "useGid" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProductCardFields" }, directives: [] }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "collectionByHandle" }, name: { kind: "Name", value: "collectionByHandle" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "handle" }, value: { kind: "Variable", name: { kind: "Name", value: "collectionHandle" } } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "useHandle" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProductCardFields" }, directives: [] }] } }] } }] } }] } }], loc: { start: 0, end: 741, source: { name: "GraphQL request", locationOffset: { line: 1, column: 1 }, body: y2 } } }, b2 = (i) => {
  const e = {};
  return i.filter(function(t) {
    if (t.kind !== "FragmentDefinition")
      return !0;
    const n = t.name.value;
    return e[n] ? !1 : (e[n] = !0, !0);
  });
};
Hr.definitions = b2(Hr.definitions.concat(Hl.definitions));
const S2 = (i, e) => {
  const t = (c, u) => {
    if (c.kind === "FragmentSpread")
      u.add(c.name.value);
    else if (c.kind === "VariableDefinition") {
      const f = c.type;
      f.kind === "NamedType" && u.add(f.name.value);
    }
    return c && "selectionSet" in c && c.selectionSet && c.selectionSet.selections.forEach((f) => {
      t(f, u);
    }), c && "variableDefinitions" in c && c.variableDefinitions && c.variableDefinitions.forEach((f) => {
      t(f, u);
    }), c && "definitions" in c && c.definitions && c.definitions.forEach((f) => {
      t(f, u);
    }), u;
  }, n = (c) => {
    const u = {};
    return c.definitions.forEach(function(f) {
      "name" in f && f.name && (u[f.name.value] = t(f, /* @__PURE__ */ new Set()));
    }), u;
  }, s = (c, u) => {
    for (let f = 0; f < c.definitions.length; f++) {
      const h = c.definitions[f];
      if (h && "name" in h && h.name && h.name.value == u)
        return h;
    }
  }, r = n(i), a = Object.assign({}, i, {
    definitions: [s(i, e)]
  }), o = r[e] || /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set();
  let d = /* @__PURE__ */ new Set();
  for (o.forEach((c) => {
    d.add(c);
  }); d.size > 0; ) {
    const c = d;
    d = /* @__PURE__ */ new Set(), c.forEach((u) => {
      l.has(u) || (l.add(u), (r[u] || /* @__PURE__ */ new Set()).forEach((h) => {
        d.add(h);
      }));
    });
  }
  return l.forEach((c) => {
    const u = s(i, c);
    u && a.definitions.push(u);
  }), a;
};
S2(Hr, "GetCollectionProducts");
const k2 = 25, T2 = 25, E2 = 25, x2 = 16, _2 = async ({
  collectionIdentifier: i,
  first: e = x2
}) => {
  const t = ua();
  if (!t) throw new Error("Shopify client not initialized");
  if (!i) return { products: [], hasNextPage: !1, endCursor: null };
  try {
    const n = typeof i == "string" && i.startsWith("gid://"), s = {
      collectionGid: n ? i : void 0,
      collectionHandle: n ? "" : i,
      useGid: n,
      useHandle: !n,
      country: F.localizationCountry,
      locale: F.locale.replace(/-/g, "_").toUpperCase(),
      first: e,
      maxVariants: k2,
      maxMedia: T2,
      maxColors: E2
    }, r = await t.request(
      da(Hr),
      {
        variables: s
      }
    );
    if (r.errors)
      return console.error("Error fetching collection products for", r.errors), { products: [], hasNextPage: !1, endCursor: null };
    const a = r.data?.collectionById, o = r.data?.collectionByHandle;
    return {
      products: a?.products?.nodes || o?.products?.nodes || [],
      hasNextPage: !1,
      endCursor: null
    };
  } catch (n) {
    return console.error(`Error fetching collection products for ${i}:`, n), { products: [], hasNextPage: !1, endCursor: null };
  }
}, A2 = { class: "main-cnt__header" }, w2 = ["href"], L2 = { class: "main-cnt__slider" }, I2 = {
  key: 0,
  class: "main-cnt__slider-cnt-controls"
}, C2 = /* @__PURE__ */ Re({
  __name: "PoloclubProductSlider.ce",
  props: {
    sectionSettingsData: { type: String },
    blockProductsGidsData: { type: String }
  },
  setup(i) {
    Nt((_) => ({
      d6db11f6: L(t).marginTopMobile + "px",
      "0a68ee71": L(t).marginBottomMobile + "px",
      "3b26b707": L(t).enableScrollSnap ? "x proximity" : "none",
      cc970fce: L(t).columns_desktop,
      "411400ad": T.value,
      d8c0f67e: L(t).marginTopTablet + "px",
      "0975fc2d": L(t).marginBottomTablet + "px",
      "185e6317": L(t).marginTopDesktop + "px",
      "5d56d92b": L(t).marginBottomDesktop + "px"
    }));
    const e = i, t = Ni(e.sectionSettingsData), n = Ni(e.blockProductsGidsData), s = bs("slider"), r = ge([]), a = Zi({
      observer: null,
      observed: !1
    }), o = Zi({
      enableSliderControls: !1,
      visibleCount: 1,
      notVisibleCount: 0,
      controls: { left: !1, right: !0 }
    }), l = () => {
      window.location.href = I.value;
    }, d = async () => {
      if (t.blockType === "last-viewed") {
        const _ = localStorage.getItem("last-viewed-products-pc");
        if (!_) return [];
        const C = JSON.parse(_);
        if (!Array.isArray(C) || !C.length) return [];
        const V = C.filter((j) => j !== F.productView.product?.id).slice(0, t.productsLimit);
        return (await ms({ productIdentifiers: V })).filter((j) => j.tags.includes("SELECCIÓN") && j.tags.includes("STOCK"));
      }
      if (t.blockType === "products") {
        const _ = n.slice(0, t.productsLimit);
        return (await ms({ productIdentifiers: _ })).filter((C) => C.id !== F.productView.product?.id).filter((C) => C.tags.includes("SELECCIÓN") && C.tags.includes("STOCK"));
      }
      if (t.blockType === "collection") {
        let _ = t.collectionId;
        return yn.name === "product" && (_ = F.productView.product?.relatedProductsCollection?.value), (await _2({ collectionIdentifier: _, first: t.productsLimit })).products.filter((C) => C.id !== F.productView.product?.id).filter((C) => C.tags.includes("SELECCIÓN") && C.tags.includes("STOCK"));
      }
      return [];
    }, c = () => {
      const { scrollWidth: _, clientWidth: C } = s.value;
      o.enableSliderControls = _ > C;
    }, u = () => {
      const { scrollLeft: _, scrollWidth: C, clientWidth: O } = s.value, V = _ <= 0, j = _ + O >= C - 1;
      o.controls = {
        left: !V,
        right: !j
      };
    }, f = () => {
      R();
    }, h = (_) => {
      const j = s.value.children[0]?.offsetWidth + 16;
      s.value.scrollLeft += _ === "left" ? -j : j;
    }, m = () => {
      u(), v();
    }, g = () => {
      const V = s.value.children[0]?.offsetWidth + 16, j = r.value.length, X = Math.ceil(s.value.clientWidth / V);
      o.notVisibleCount = Math.max(0, j - X) + 1;
    }, v = () => {
      const V = s.value.children[0]?.offsetWidth + 16, { scrollLeft: j, scrollWidth: X, clientWidth: q } = s.value;
      j + q >= X - 1 ? o.visibleCount = o.notVisibleCount : o.visibleCount = Math.floor(j / V) + 1;
    }, p = (_, C) => {
      if (!_ || !_.variants?.nodes?.[0]) return null;
      const O = _.variants.nodes[0], V = t.collectionId || `${x.value}-${t.blockId}`;
      return {
        index: C + 1,
        item_id: `shopify_${F.localizationCountry}_${_.id}_${O.id}`,
        item_name: _.title,
        item_brand: _.vendor,
        item_category: _.productType,
        item_category2: _.categoryMetafield?.value,
        item_list_id: V,
        item_list_name: x.value,
        item_variant: O.title,
        product_id: _.id.toString(),
        product_loc: _.locMetafield?.value,
        product_sku: O.sku,
        product_ean: O.barcode,
        product_action: _.productActionMetafield?.value,
        product_color: _.filterColorMetafield?.value,
        product_img: _.featuredImage?.url,
        variant_id: O.id.toString(),
        location_id: _.locMetafield?.value,
        price: Number(O.price.amount),
        discount: O.compareAtPrice?.amount ? Number((O.compareAtPrice.amount - O.price.amount).toFixed(2)) : 0,
        quantity: 1
      };
    }, y = () => {
      if (!r.value.length) return;
      const _ = r.value.map(
        (V, j) => p(V, j)
      ).filter((V) => V !== null), C = _.reduce((V, j) => V + (j?.price || 0), 0), O = {
        event: "view_item_list",
        ecommerce: {
          currency: F.currencyIsoCode,
          items: _,
          value: Number(C.toFixed(2)),
          item_list_id: t.collectionId || `${x.value}-${t.blockId}`,
          item_list_name: x.value
        }
      };
      Wo(O);
    }, b = (_) => {
      const C = r.value.findIndex((V) => V.id === _.id), O = {
        event: "select_item",
        ecommerce: {
          item_list_id: t.collectionId || `${x.value}-${t.blockId}`,
          item_list_name: x.value,
          currency: F.currencyIsoCode,
          items: [
            p(_, C)
          ]
        }
      };
      Wo(O);
    }, k = le(() => ({
      paddingTop: `${t.paddingTop}px`,
      paddingBottom: `${t.paddingBottom}px`
    })), T = le(() => t.container_width + "%"), I = le(() => t.enableLink ? t.linkType === "collection_url" && t.blockType === "collection" && r.value.length ? t.collectionUrl : t.linkType === "custom_url" && t.customUrl ? t.customUrl : null : null), x = le(() => t.blockType === "collection" ? t.collectionTitle : yn.name === "product" && t.blockType === "products" ? `${t.heading} - ${F.productView.product?.modelMetafield?.value}` : t.blockType === "last-viewed" ? "Last Viewed Products" : t.heading), E = () => {
      a.observer && a.observer.disconnect(), a.observer = new IntersectionObserver(([_]) => {
        _.isIntersecting && !a.observed && (a.observed = !0, y());
      }, {
        root: null,
        rootMargin: "0px",
        threshold: 0.8
      }), s.value && a.observer.observe(s.value);
    }, R = () => {
      s.value && (c(), g(), v(), u());
    };
    wt(async () => {
      r.value = await d(), await Gt(), R(), E(), window.addEventListener("resize", f), window.addEventListener("product:changed", A);
    }), Fs(() => {
      window.removeEventListener("product:changed", A);
    }), Dt(() => F.productView.product, async (_) => {
      _ && yn.name === "product" && (r.value = await d(), await Gt(), R());
    });
    async function A() {
      r.value = await d(), await Gt(), R();
    }
    return (_, C) => r.value.length ? (P(), N("div", {
      key: 0,
      class: "main-cnt",
      style: We(k.value)
    }, [
      w("div", A2, [
        w("h2", null, ie(L(t).heading), 1),
        L(t).enableLink ? (P(), N("a", {
          key: 0,
          class: Ke({ "view-btn__view-more": L(t).pageType == "product" }),
          href: I.value
        }, ie(L(t).linkLabel), 11, w2)) : U("", !0)
      ]),
      w("div", L2, [
        w("div", {
          ref_key: "slider",
          ref: s,
          class: Ke(["main-cnt__slider-cnt", L(t).enable_slider_desktop == "grid" ? "main-cnt__grid-cnt" : "", L(t).enable_mobile_layout ? `main-cnt--mobile-grid-${L(t).mobile_layout}` : ""]),
          onScroll: m
        }, [
          (P(!0), N(ve, null, pt(r.value, (O, V) => (P(), Ie(Rm, {
            key: O.id || V,
            product: O,
            "show-private-msg": L(t).private_sale_hide_message,
            "show-aire-image": L(t).showAireImage,
            "show-secondary-image": L(t).showSecondaryImage,
            "is-logged": JSON.parse(L(t)?.customer?.isLogged),
            onClick: (j) => b(O)
          }, null, 8, ["product", "show-private-msg", "show-aire-image", "show-secondary-image", "is-logged", "onClick"]))), 128))
        ], 34),
        o.enableSliderControls ? (P(), N("div", I2, [
          de(kn, {
            direction: "left",
            width: "24px",
            onClick: C[0] || (C[0] = (O) => h("left")),
            class: Ke({ disabled: !o.controls.left })
          }, null, 8, ["class"]),
          w("span", null, ie(o.visibleCount) + " / " + ie(o.notVisibleCount), 1),
          de(kn, {
            direction: "right",
            width: "24px",
            onClick: C[1] || (C[1] = (O) => h("right")),
            class: Ke({ disabled: !o.controls.right })
          }, null, 8, ["class"])
        ])) : U("", !0)
      ]),
      L(t).enableLink ? (P(), Ie(Kl, {
        key: 0,
        class: Ke(["main-cnt__slider-btn", { "hide-btn__view-more": L(t).pageType == "product" }]),
        type: "primary",
        theme: "light",
        onClick: l
      }, {
        default: Xe(() => [
          sn(ie(L(t).linkLabel), 1)
        ]),
        _: 1
      }, 8, ["class"])) : U("", !0)
    ], 4)) : U("", !0);
  }
}), R2 = "[data-v-8d58a645],[data-v-8d58a645]:before,[data-v-8d58a645]:after{box-sizing:border-box}p[data-v-8d58a645],[data-v-8d58a645] p{margin:0;padding:0}h1[data-v-8d58a645],h2[data-v-8d58a645]{margin:0}[data-v-8d58a645]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.main-cnt[data-v-8d58a645]{display:flex;flex-direction:column;gap:1.5rem;margin-top:var(--d6db11f6);margin-bottom:var(--0a68ee71)}.main-cnt__header[data-v-8d58a645]{box-sizing:border-box;display:flex;justify-content:space-between;align-items:baseline;align-self:center;width:100%;padding:0 100px}.main-cnt__header>h2[data-v-8d58a645]{margin:0 auto;color:var(--color-black);font-size:2rem;font-family:EuclidCircularA-WebS;font-weight:300}.main-cnt__header>a[data-v-8d58a645]{display:none;color:var(--color-black);font-size:1.4rem;text-underline-offset:.3rem}.main-cnt__slider[data-v-8d58a645]{display:flex;flex-direction:column;gap:2.8rem}.main-cnt__slider-cnt[data-v-8d58a645]{overflow-x:scroll;display:flex;flex-wrap:nowrap;align-items:stretch;gap:.4rem;padding:0 var(--page-horizontal-padding) 0 var(--page-horizontal-padding);scroll-padding-left:var(--page-horizontal-padding);overscroll-behavior-x:contain;scroll-snap-type:var(--3b26b707);scroll-behavior:smooth;scrollbar-width:none}.main-cnt__slider-cnt>div[data-v-8d58a645]{flex:0 0 49%;scroll-snap-align:start}.main-cnt__slider-cnt[data-v-8d58a645]::-webkit-scrollbar{display:none}.scroll-snap[data-v-8d58a645]{scroll-snap-align:start;scroll-snap-stop:always}.main-cnt__slider-cnt-controls[data-v-8d58a645]{display:flex;justify-content:center;align-items:center;gap:2.5rem}.main-cnt__slider-cnt-controls>span[data-v-8d58a645]{font-size:1rem}.main-cnt__slider-cnt-controls>svg[data-v-8d58a645]{cursor:pointer}.main-cnt__slider-cnt-controls>svg.disabled[data-v-8d58a645]{pointer-events:none;opacity:.5}.placeholder[data-v-8d58a645]{display:flex;flex-direction:column;gap:1rem}.placeholder>div[data-v-8d58a645]{width:100%;background-color:#dfdddd}.placeholder>div[data-v-8d58a645]:first-child{height:85.5%}.placeholder>div[data-v-8d58a645]:nth-child(2){height:4%}.placeholder>div[data-v-8d58a645]:nth-child(3){height:3.5%}.animation-loading[data-v-8d58a645]{animation:blinkBackground-8d58a645 .5s infinite}.main-cnt__slider-btn[data-v-8d58a645]{margin:0 auto}@media (width >=768px){.main-cnt__grid-cnt[data-v-8d58a645]{display:grid;gap:2rem .4rem;grid-template-columns:repeat(var(--cc970fce),1fr);width:var(--411400ad);margin:0 auto}.main-cnt[data-v-8d58a645]{margin-top:var(--d8c0f67e);margin-bottom:var(--0975fc2d)}.main-cnt__header>h2[data-v-8d58a645]{margin:initial}.main-cnt__header>a[data-v-8d58a645]{display:block}.main-cnt__slider-btn[data-v-8d58a645]{display:none}.main-cnt__slider-cnt-controls>span[data-v-8d58a645]{font-size:1.2rem}.main-cnt__slider-cnt>div[data-v-8d58a645]{flex:0 0 32%}}@media (width <=749px){.main-cnt__header[data-v-8d58a645]{padding:0 var(--page-horizontal-padding) 0 var(--page-horizontal-padding)}.main-cnt__header>h2[data-v-8d58a645]{margin:0}.hide-btn__view-more[data-v-8d58a645]{display:none}.view-btn__view-more[data-v-8d58a645]{display:block!important}.main-cnt__slider-cnt.main-cnt--mobile-grid-one[data-v-8d58a645]{display:flex;flex-wrap:wrap}.main-cnt__slider-cnt.main-cnt--mobile-grid-one>div[data-v-8d58a645]{flex:100%;margin-bottom:1.5rem}.main-cnt__slider-cnt.main-cnt--mobile-grid-two[data-v-8d58a645]{display:flex;flex-wrap:wrap}.main-cnt__slider-cnt.main-cnt--mobile-grid-two>div[data-v-8d58a645]{width:calc(50% - .8rem);margin-bottom:1.5rem}.main-cnt--mobile-grid-two[data-v-8d58a645] .product-image-container{min-height:25.9rem}.main-cnt--mobile-grid-two[data-v-8d58a645] .product-image-container-wrapper,.main-cnt--mobile-grid-two[data-v-8d58a645] picture{height:100%}}@media (width >=1024px){.main-cnt[data-v-8d58a645]{margin-top:var(--185e6317);margin-bottom:var(--5d56d92b)}.main-cnt__header>h2[data-v-8d58a645]{font-size:3rem}.main-cnt__slider-cnt[data-v-8d58a645]{gap:.8rem}.main-cnt__slider-cnt>div[data-v-8d58a645]{flex:0 0 24%}}@keyframes blinkBackground-8d58a645{0%,to{background-color:#dfdddd}50%{background-color:#ebebeb}}", P2 = /* @__PURE__ */ Pe(C2, [["styles", [R2]], ["__scopeId", "data-v-8d58a645"]]), D2 = /* @__PURE__ */ Re({
  __name: "PoloclubMainWishlist.ce",
  setup(i) {
    const e = async () => {
      try {
        const r = `https://poloclub-wishlist.vercel.app/global?shop_name=${F.permanentShopDomain}&customer_id=${St.id}`, a = await fetch(r);
        if (!a.ok)
          throw new Error(`HTTP error! status: ${a.status}`);
        const o = await a.json();
        F.wishlist = Array.isArray(o) ? o.map((l) => `gid://shopify/Product/${l}` || "") : [];
      } catch (r) {
        console.error("Error fetching wishlist from server:", r), t();
      }
    }, t = () => {
      try {
        const r = localStorage.getItem("wishlistProducts");
        F.wishlist = r ? JSON.parse(r) : [];
      } catch (r) {
        console.error("Error loading wishlist from localStorage:", r), F.wishlist = [];
      }
    }, n = async () => {
      St.hasAccount ? (await e(), await s()) : t();
    }, s = async () => {
      const a = JSON.parse(localStorage.getItem("wishlistProducts") || "[]").filter(
        (o) => !F.wishlist.includes(o)
      );
      if (a.length > 0)
        try {
          const o = "https://poloclub-wishlist.vercel.app/global", l = JSON.stringify({
            shop_name: F.permanentShopDomain,
            customer_id: St.id,
            products_id: a
          }), d = await fetch(o, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: l
          });
          d.ok || console.error(
            "Error updating wishlist on server:",
            d.statusText
          );
        } catch (o) {
          console.error("Error updating wishlist on server:", o);
        }
    };
    return wt(async () => {
      await n();
    }), (r, a) => L(he).enable_wishlist ? (P(), Ie(ha, {
      key: 0,
      type: "main"
    })) : U("", !0);
  }
}), N2 = { class: "poloclub-video" }, M2 = ["poster", "width", "height"], O2 = {
  key: 0,
  class: "error-message"
}, F2 = {
  key: 1,
  class: "loading-container"
}, $2 = /* @__PURE__ */ Re({
  __name: "PoloclubVideoSlider.ce",
  props: {
    video: { type: Object }
  },
  setup(i) {
    const e = i, t = ge(null), n = ge(null), s = ge(!1), r = ge(""), a = ge(null), o = async (f) => {
      try {
        await fetch(f);
      } catch (h) {
        console.warn("Video preload failed:", h);
      }
    }, l = () => {
      t.value && (a.value = new IntersectionObserver(
        (f) => {
          f.forEach((h) => {
            t.value && (h.isIntersecting ? t.value.paused && t.value.play() : t.value.paused || t.value.pause());
          });
        },
        { threshold: 0.5, rootMargin: "0px" }
      ), a.value.observe(t.value));
    }, d = async () => {
      const f = t.value;
      if (f) {
        if (f.canPlayType("application/vnd.apple.mpegurl")) {
          const h = e.video.sources.find(
            (m) => m.format === "m3u8" || m.mime_type === "application/x-mpegURL"
          );
          if (h) {
            f.src = h.url;
            return;
          }
        }
        if (nt.isSupported()) {
          s.value = !0, r.value = "", n.value = new nt({
            enableWorker: !0,
            lowLatencyMode: !0,
            maxBufferLength: 30,
            maxMaxBufferLength: 60,
            maxBufferSize: 60 * 1e3 * 1e3
          });
          const h = e.video.sources.find(
            (m) => m.format === "m3u8" || m.mime_type === "application/x-mpegURL"
          );
          if (!h) {
            r.value = "No valid HLS source found", s.value = !1;
            return;
          }
          await o(h.url), n.value.loadSource(h.url), n.value.attachMedia(f), n.value.on(nt.Events.MANIFEST_PARSED, () => {
            if (s.value = !1, n.value?.levels?.length) {
              const m = Math.min(Math.floor(n.value.levels.length * 0.7), n.value.levels.length - 1);
              n.value.nextLevel = m;
            }
          }), n.value.on(nt.Events.ERROR, (m, g) => {
            if (g.fatal)
              switch (g.type) {
                case nt.ErrorTypes.NETWORK_ERROR:
                  r.value = "Network error. Trying to reconnect...", n.value?.startLoad();
                  break;
                case nt.ErrorTypes.MEDIA_ERROR:
                  r.value = "Media error. Trying to recover...", n.value?.recoverMediaError();
                  break;
                default:
                  r.value = "Fatal error of the HLS player";
                  break;
              }
          });
        } else
          r.value = "HLS is not compatible with this browser";
      }
    }, c = () => {
      s.value = !1;
    }, u = (f) => {
      const h = f.target;
      h.error && (r.value = `Video error: ${h.error.message || "Unknown error"}`);
    };
    return wt(async () => {
      await Gt(), d(), l();
    }), ia(() => {
      n.value?.destroy(), a.value?.disconnect();
    }), (f, h) => (P(), N("div", N2, [
      w("video", {
        ref_key: "videoRef",
        ref: t,
        poster: f.video.preview_image?.src,
        width: f.video.sources[0]?.width || 640,
        height: f.video.sources[0]?.height || 360,
        preload: "metadata",
        onLoadedmetadata: c,
        autoplay: "",
        playsinline: "",
        "webkit-playsinline": "",
        loop: "",
        muted: "",
        onError: u
      }, h[0] || (h[0] = [
        w("p", null, "Your browser does not support the playback of HLS videos.", -1)
      ]), 40, M2),
      r.value ? (P(), N("div", O2, " Error: " + ie(r.value), 1)) : U("", !0),
      s.value ? (P(), N("div", F2, [
        de(bi, {
          width: "50px",
          theme: "dark"
        })
      ])) : U("", !0)
    ]));
  }
}), B2 = "[data-v-92f6c157],[data-v-92f6c157]:before,[data-v-92f6c157]:after{box-sizing:border-box}p[data-v-92f6c157],[data-v-92f6c157] p{margin:0;padding:0}h1[data-v-92f6c157],h2[data-v-92f6c157]{margin:0}[data-v-92f6c157]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.poloclub-video[data-v-92f6c157]{position:relative}.error-message[data-v-92f6c157]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background:#f00c;color:#fff;padding:10px;border-radius:4px;text-align:center;max-width:80%}.loading-container[data-v-92f6c157]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.poloclub-video[data-v-92f6c157]{position:relative;width:100%;height:100%;overflow:hidden;display:flex;align-items:center;justify-content:center}video[data-v-92f6c157]{width:100%;height:100%;object-fit:cover}", U2 = /* @__PURE__ */ Pe($2, [["styles", [B2]], ["__scopeId", "data-v-92f6c157"]]);
function yu(i) {
  return i !== null && typeof i == "object" && "constructor" in i && i.constructor === Object;
}
function jl(i = {}, e = {}) {
  const t = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((n) => t.indexOf(n) < 0).forEach((n) => {
    typeof i[n] > "u" ? i[n] = e[n] : yu(e[n]) && yu(i[n]) && Object.keys(e[n]).length > 0 && jl(i[n], e[n]);
  });
}
const Pm = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function pi() {
  const i = typeof document < "u" ? document : {};
  return jl(i, Pm), i;
}
const V2 = {
  document: Pm,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(i) {
    return typeof setTimeout > "u" ? (i(), null) : setTimeout(i, 0);
  },
  cancelAnimationFrame(i) {
    typeof setTimeout > "u" || clearTimeout(i);
  }
};
function Lt() {
  const i = typeof window < "u" ? window : {};
  return jl(i, V2), i;
}
function G2(i = "") {
  return i.trim().split(" ").filter((e) => !!e.trim());
}
function H2(i) {
  const e = i;
  Object.keys(e).forEach((t) => {
    try {
      e[t] = null;
    } catch {
    }
    try {
      delete e[t];
    } catch {
    }
  });
}
function Dm(i, e = 0) {
  return setTimeout(i, e);
}
function zr() {
  return Date.now();
}
function z2(i) {
  const e = Lt();
  let t;
  return e.getComputedStyle && (t = e.getComputedStyle(i, null)), !t && i.currentStyle && (t = i.currentStyle), t || (t = i.style), t;
}
function K2(i, e = "x") {
  const t = Lt();
  let n, s, r;
  const a = z2(i);
  return t.WebKitCSSMatrix ? (s = a.transform || a.webkitTransform, s.split(",").length > 6 && (s = s.split(", ").map((o) => o.replace(",", ".")).join(", ")), r = new t.WebKitCSSMatrix(s === "none" ? "" : s)) : (r = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = r.toString().split(",")), e === "x" && (t.WebKitCSSMatrix ? s = r.m41 : n.length === 16 ? s = parseFloat(n[12]) : s = parseFloat(n[4])), e === "y" && (t.WebKitCSSMatrix ? s = r.m42 : n.length === 16 ? s = parseFloat(n[13]) : s = parseFloat(n[5])), s || 0;
}
function nr(i) {
  return typeof i == "object" && i !== null && i.constructor && Object.prototype.toString.call(i).slice(8, -1) === "Object";
}
function j2(i) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? i instanceof HTMLElement : i && (i.nodeType === 1 || i.nodeType === 11);
}
function Ft(...i) {
  const e = Object(i[0]), t = ["__proto__", "constructor", "prototype"];
  for (let n = 1; n < i.length; n += 1) {
    const s = i[n];
    if (s != null && !j2(s)) {
      const r = Object.keys(Object(s)).filter((a) => t.indexOf(a) < 0);
      for (let a = 0, o = r.length; a < o; a += 1) {
        const l = r[a], d = Object.getOwnPropertyDescriptor(s, l);
        d !== void 0 && d.enumerable && (nr(e[l]) && nr(s[l]) ? s[l].__swiper__ ? e[l] = s[l] : Ft(e[l], s[l]) : !nr(e[l]) && nr(s[l]) ? (e[l] = {}, s[l].__swiper__ ? e[l] = s[l] : Ft(e[l], s[l])) : e[l] = s[l]);
      }
    }
  }
  return e;
}
function sr(i, e, t) {
  i.style.setProperty(e, t);
}
function Nm({
  swiper: i,
  targetPosition: e,
  side: t
}) {
  const n = Lt(), s = -i.translate;
  let r = null, a;
  const o = i.params.speed;
  i.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(i.cssModeFrameID);
  const l = e > s ? "next" : "prev", d = (u, f) => l === "next" && u >= f || l === "prev" && u <= f, c = () => {
    a = (/* @__PURE__ */ new Date()).getTime(), r === null && (r = a);
    const u = Math.max(Math.min((a - r) / o, 1), 0), f = 0.5 - Math.cos(u * Math.PI) / 2;
    let h = s + f * (e - s);
    if (d(h, e) && (h = e), i.wrapperEl.scrollTo({
      [t]: h
    }), d(h, e)) {
      i.wrapperEl.style.overflow = "hidden", i.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        i.wrapperEl.style.overflow = "", i.wrapperEl.scrollTo({
          [t]: h
        });
      }), n.cancelAnimationFrame(i.cssModeFrameID);
      return;
    }
    i.cssModeFrameID = n.requestAnimationFrame(c);
  };
  c();
}
function ba(i) {
  return i.querySelector(".swiper-slide-transform") || i.shadowRoot && i.shadowRoot.querySelector(".swiper-slide-transform") || i;
}
function mi(i, e = "") {
  const t = Lt(), n = [...i.children];
  return t.HTMLSlotElement && i instanceof HTMLSlotElement && n.push(...i.assignedElements()), e ? n.filter((s) => s.matches(e)) : n;
}
function W2(i, e) {
  const t = [e];
  for (; t.length > 0; ) {
    const n = t.shift();
    if (i === n)
      return !0;
    t.push(...n.children, ...n.shadowRoot ? n.shadowRoot.children : [], ...n.assignedElements ? n.assignedElements() : []);
  }
}
function q2(i, e) {
  const t = Lt();
  let n = e.contains(i);
  return !n && t.HTMLSlotElement && e instanceof HTMLSlotElement && (n = [...e.assignedElements()].includes(i), n || (n = W2(i, e))), n;
}
function Kr(i) {
  try {
    console.warn(i);
    return;
  } catch {
  }
}
function Ps(i, e = []) {
  const t = document.createElement(i);
  return t.classList.add(...Array.isArray(e) ? e : G2(e)), t;
}
function Y2(i, e) {
  const t = [];
  for (; i.previousElementSibling; ) {
    const n = i.previousElementSibling;
    e ? n.matches(e) && t.push(n) : t.push(n), i = n;
  }
  return t;
}
function X2(i, e) {
  const t = [];
  for (; i.nextElementSibling; ) {
    const n = i.nextElementSibling;
    e ? n.matches(e) && t.push(n) : t.push(n), i = n;
  }
  return t;
}
function Ki(i, e) {
  return Lt().getComputedStyle(i, null).getPropertyValue(e);
}
function jr(i) {
  let e = i, t;
  if (e) {
    for (t = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (t += 1);
    return t;
  }
}
function Mm(i, e) {
  const t = [];
  let n = i.parentElement;
  for (; n; )
    e ? n.matches(e) && t.push(n) : t.push(n), n = n.parentElement;
  return t;
}
function Z2(i, e) {
  function t(n) {
    n.target === i && (e.call(i, n), i.removeEventListener("transitionend", t));
  }
  e && i.addEventListener("transitionend", t);
}
function qo(i, e, t) {
  const n = Lt();
  return i[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(n.getComputedStyle(i, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(n.getComputedStyle(i, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
}
function ut(i) {
  return (Array.isArray(i) ? i : [i]).filter((e) => !!e);
}
function Q2(i) {
  return (e) => Math.abs(e) > 0 && i.browser && i.browser.need3dFix && Math.abs(e) % 90 === 0 ? e + 1e-3 : e;
}
function Ds(i, e = "") {
  typeof trustedTypes < "u" ? i.innerHTML = trustedTypes.createPolicy("html", {
    createHTML: (t) => t
  }).createHTML(e) : i.innerHTML = e;
}
let to;
function J2() {
  const i = Lt(), e = pi();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in i || i.DocumentTouch && e instanceof i.DocumentTouch)
  };
}
function Om() {
  return to || (to = J2()), to;
}
let io;
function eA({
  userAgent: i
} = {}) {
  const e = Om(), t = Lt(), n = t.navigator.platform, s = i || t.navigator.userAgent, r = {
    ios: !1,
    android: !1
  }, a = t.screen.width, o = t.screen.height, l = s.match(/(Android);?[\s\/]+([\d.]+)?/);
  let d = s.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
  const c = s.match(/(iPod)(.*OS\s([\d_]+))?/), u = !d && s.match(/(iPhone\sOS|iOS)\s([\d_]+)/), f = n === "Win32";
  let h = n === "MacIntel";
  const m = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !d && h && e.touch && m.indexOf(`${a}x${o}`) >= 0 && (d = s.match(/(Version)\/([\d.]+)/), d || (d = [0, 1, "13_0_0"]), h = !1), l && !f && (r.os = "android", r.android = !0), (d || u || c) && (r.os = "ios", r.ios = !0), r;
}
function Fm(i = {}) {
  return io || (io = eA(i)), io;
}
let no;
function tA() {
  const i = Lt(), e = Fm();
  let t = !1;
  function n() {
    const o = i.navigator.userAgent.toLowerCase();
    return o.indexOf("safari") >= 0 && o.indexOf("chrome") < 0 && o.indexOf("android") < 0;
  }
  if (n()) {
    const o = String(i.navigator.userAgent);
    if (o.includes("Version/")) {
      const [l, d] = o.split("Version/")[1].split(" ")[0].split(".").map((c) => Number(c));
      t = l < 16 || l === 16 && d < 2;
    }
  }
  const s = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(i.navigator.userAgent), r = n(), a = r || s && e.ios;
  return {
    isSafari: t || r,
    needPerspectiveFix: t,
    need3dFix: a,
    isWebView: s
  };
}
function $m() {
  return no || (no = tA()), no;
}
function iA({
  swiper: i,
  on: e,
  emit: t
}) {
  const n = Lt();
  let s = null, r = null;
  const a = () => {
    !i || i.destroyed || !i.initialized || (t("beforeResize"), t("resize"));
  }, o = () => {
    !i || i.destroyed || !i.initialized || (s = new ResizeObserver((c) => {
      r = n.requestAnimationFrame(() => {
        const {
          width: u,
          height: f
        } = i;
        let h = u, m = f;
        c.forEach(({
          contentBoxSize: g,
          contentRect: v,
          target: p
        }) => {
          p && p !== i.el || (h = v ? v.width : (g[0] || g).inlineSize, m = v ? v.height : (g[0] || g).blockSize);
        }), (h !== u || m !== f) && a();
      });
    }), s.observe(i.el));
  }, l = () => {
    r && n.cancelAnimationFrame(r), s && s.unobserve && i.el && (s.unobserve(i.el), s = null);
  }, d = () => {
    !i || i.destroyed || !i.initialized || t("orientationchange");
  };
  e("init", () => {
    if (i.params.resizeObserver && typeof n.ResizeObserver < "u") {
      o();
      return;
    }
    n.addEventListener("resize", a), n.addEventListener("orientationchange", d);
  }), e("destroy", () => {
    l(), n.removeEventListener("resize", a), n.removeEventListener("orientationchange", d);
  });
}
function nA({
  swiper: i,
  extendParams: e,
  on: t,
  emit: n
}) {
  const s = [], r = Lt(), a = (d, c = {}) => {
    const u = r.MutationObserver || r.WebkitMutationObserver, f = new u((h) => {
      if (i.__preventObserver__) return;
      if (h.length === 1) {
        n("observerUpdate", h[0]);
        return;
      }
      const m = function() {
        n("observerUpdate", h[0]);
      };
      r.requestAnimationFrame ? r.requestAnimationFrame(m) : r.setTimeout(m, 0);
    });
    f.observe(d, {
      attributes: typeof c.attributes > "u" ? !0 : c.attributes,
      childList: i.isElement || (typeof c.childList > "u" ? !0 : c).childList,
      characterData: typeof c.characterData > "u" ? !0 : c.characterData
    }), s.push(f);
  }, o = () => {
    if (i.params.observer) {
      if (i.params.observeParents) {
        const d = Mm(i.hostEl);
        for (let c = 0; c < d.length; c += 1)
          a(d[c]);
      }
      a(i.hostEl, {
        childList: i.params.observeSlideChildren
      }), a(i.wrapperEl, {
        attributes: !1
      });
    }
  }, l = () => {
    s.forEach((d) => {
      d.disconnect();
    }), s.splice(0, s.length);
  };
  e({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), t("init", o), t("destroy", l);
}
var sA = {
  on(i, e, t) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
    const s = t ? "unshift" : "push";
    return i.split(" ").forEach((r) => {
      n.eventsListeners[r] || (n.eventsListeners[r] = []), n.eventsListeners[r][s](e);
    }), n;
  },
  once(i, e, t) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
    function s(...r) {
      n.off(i, s), s.__emitterProxy && delete s.__emitterProxy, e.apply(n, r);
    }
    return s.__emitterProxy = e, n.on(i, s, t);
  },
  onAny(i, e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || typeof i != "function") return t;
    const n = e ? "unshift" : "push";
    return t.eventsAnyListeners.indexOf(i) < 0 && t.eventsAnyListeners[n](i), t;
  },
  offAny(i) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const t = e.eventsAnyListeners.indexOf(i);
    return t >= 0 && e.eventsAnyListeners.splice(t, 1), e;
  },
  off(i, e) {
    const t = this;
    return !t.eventsListeners || t.destroyed || !t.eventsListeners || i.split(" ").forEach((n) => {
      typeof e > "u" ? t.eventsListeners[n] = [] : t.eventsListeners[n] && t.eventsListeners[n].forEach((s, r) => {
        (s === e || s.__emitterProxy && s.__emitterProxy === e) && t.eventsListeners[n].splice(r, 1);
      });
    }), t;
  },
  emit(...i) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsListeners) return e;
    let t, n, s;
    return typeof i[0] == "string" || Array.isArray(i[0]) ? (t = i[0], n = i.slice(1, i.length), s = e) : (t = i[0].events, n = i[0].data, s = i[0].context || e), n.unshift(s), (Array.isArray(t) ? t : t.split(" ")).forEach((a) => {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((o) => {
        o.apply(s, [a, ...n]);
      }), e.eventsListeners && e.eventsListeners[a] && e.eventsListeners[a].forEach((o) => {
        o.apply(s, n);
      });
    }), e;
  }
};
function rA() {
  const i = this;
  let e, t;
  const n = i.el;
  typeof i.params.width < "u" && i.params.width !== null ? e = i.params.width : e = n.clientWidth, typeof i.params.height < "u" && i.params.height !== null ? t = i.params.height : t = n.clientHeight, !(e === 0 && i.isHorizontal() || t === 0 && i.isVertical()) && (e = e - parseInt(Ki(n, "padding-left") || 0, 10) - parseInt(Ki(n, "padding-right") || 0, 10), t = t - parseInt(Ki(n, "padding-top") || 0, 10) - parseInt(Ki(n, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(t) && (t = 0), Object.assign(i, {
    width: e,
    height: t,
    size: i.isHorizontal() ? e : t
  }));
}
function aA() {
  const i = this;
  function e(A, _) {
    return parseFloat(A.getPropertyValue(i.getDirectionLabel(_)) || 0);
  }
  const t = i.params, {
    wrapperEl: n,
    slidesEl: s,
    rtlTranslate: r,
    wrongRTL: a
  } = i, o = i.virtual && t.virtual.enabled, l = o ? i.virtual.slides.length : i.slides.length, d = mi(s, `.${i.params.slideClass}, swiper-slide`), c = o ? i.virtual.slides.length : d.length;
  let u = [];
  const f = [], h = [];
  let m = t.slidesOffsetBefore;
  typeof m == "function" && (m = t.slidesOffsetBefore.call(i));
  let g = t.slidesOffsetAfter;
  typeof g == "function" && (g = t.slidesOffsetAfter.call(i));
  const v = i.snapGrid.length, p = i.slidesGrid.length, y = i.size - m - g;
  let b = t.spaceBetween, k = -m, T = 0, I = 0;
  if (typeof y > "u")
    return;
  typeof b == "string" && b.indexOf("%") >= 0 ? b = parseFloat(b.replace("%", "")) / 100 * y : typeof b == "string" && (b = parseFloat(b)), i.virtualSize = -b - m - g, d.forEach((A) => {
    r ? A.style.marginLeft = "" : A.style.marginRight = "", A.style.marginBottom = "", A.style.marginTop = "";
  }), t.centeredSlides && t.cssMode && (sr(n, "--swiper-centered-offset-before", ""), sr(n, "--swiper-centered-offset-after", ""));
  const x = t.grid && t.grid.rows > 1 && i.grid;
  x ? i.grid.initSlides(d) : i.grid && i.grid.unsetSlides();
  let E;
  const R = t.slidesPerView === "auto" && t.breakpoints && Object.keys(t.breakpoints).filter((A) => typeof t.breakpoints[A].slidesPerView < "u").length > 0;
  for (let A = 0; A < c; A += 1) {
    E = 0;
    const _ = d[A];
    if (!(_ && (x && i.grid.updateSlide(A, _, d), Ki(_, "display") === "none"))) {
      if (o && t.slidesPerView === "auto")
        t.virtual.slidesPerViewAutoSlideSize && (E = t.virtual.slidesPerViewAutoSlideSize), E && _ && (t.roundLengths && (E = Math.floor(E)), _.style[i.getDirectionLabel("width")] = `${E}px`);
      else if (t.slidesPerView === "auto") {
        R && (_.style[i.getDirectionLabel("width")] = "");
        const C = getComputedStyle(_), O = _.style.transform, V = _.style.webkitTransform;
        if (O && (_.style.transform = "none"), V && (_.style.webkitTransform = "none"), t.roundLengths)
          E = i.isHorizontal() ? qo(_, "width") : qo(_, "height");
        else {
          const j = e(C, "width"), X = e(C, "padding-left"), q = e(C, "padding-right"), z = e(C, "margin-left"), Q = e(C, "margin-right"), oe = C.getPropertyValue("box-sizing");
          if (oe && oe === "border-box")
            E = j + z + Q;
          else {
            const {
              clientWidth: Z,
              offsetWidth: te
            } = _;
            E = j + X + q + z + Q + (te - Z);
          }
        }
        O && (_.style.transform = O), V && (_.style.webkitTransform = V), t.roundLengths && (E = Math.floor(E));
      } else
        E = (y - (t.slidesPerView - 1) * b) / t.slidesPerView, t.roundLengths && (E = Math.floor(E)), _ && (_.style[i.getDirectionLabel("width")] = `${E}px`);
      _ && (_.swiperSlideSize = E), h.push(E), t.centeredSlides ? (k = k + E / 2 + T / 2 + b, T === 0 && A !== 0 && (k = k - y / 2 - b), A === 0 && (k = k - y / 2 - b), Math.abs(k) < 1 / 1e3 && (k = 0), t.roundLengths && (k = Math.floor(k)), I % t.slidesPerGroup === 0 && u.push(k), f.push(k)) : (t.roundLengths && (k = Math.floor(k)), (I - Math.min(i.params.slidesPerGroupSkip, I)) % i.params.slidesPerGroup === 0 && u.push(k), f.push(k), k = k + E + b), i.virtualSize += E + b, T = E, I += 1;
    }
  }
  if (i.virtualSize = Math.max(i.virtualSize, y) + g, r && a && (t.effect === "slide" || t.effect === "coverflow") && (n.style.width = `${i.virtualSize + b}px`), t.setWrapperSize && (n.style[i.getDirectionLabel("width")] = `${i.virtualSize + b}px`), x && i.grid.updateWrapperSize(E, u), !t.centeredSlides) {
    const A = [];
    for (let _ = 0; _ < u.length; _ += 1) {
      let C = u[_];
      t.roundLengths && (C = Math.floor(C)), u[_] <= i.virtualSize - y && A.push(C);
    }
    u = A, Math.floor(i.virtualSize - y) - Math.floor(u[u.length - 1]) > 1 && u.push(i.virtualSize - y);
  }
  if (o && t.loop) {
    const A = h[0] + b;
    if (t.slidesPerGroup > 1) {
      const _ = Math.ceil((i.virtual.slidesBefore + i.virtual.slidesAfter) / t.slidesPerGroup), C = A * t.slidesPerGroup;
      for (let O = 0; O < _; O += 1)
        u.push(u[u.length - 1] + C);
    }
    for (let _ = 0; _ < i.virtual.slidesBefore + i.virtual.slidesAfter; _ += 1)
      t.slidesPerGroup === 1 && u.push(u[u.length - 1] + A), f.push(f[f.length - 1] + A), i.virtualSize += A;
  }
  if (u.length === 0 && (u = [0]), b !== 0) {
    const A = i.isHorizontal() && r ? "marginLeft" : i.getDirectionLabel("marginRight");
    d.filter((_, C) => !t.cssMode || t.loop ? !0 : C !== d.length - 1).forEach((_) => {
      _.style[A] = `${b}px`;
    });
  }
  if (t.centeredSlides && t.centeredSlidesBounds) {
    let A = 0;
    h.forEach((C) => {
      A += C + (b || 0);
    }), A -= b;
    const _ = A > y ? A - y : 0;
    u = u.map((C) => C <= 0 ? -m : C > _ ? _ + g : C);
  }
  if (t.centerInsufficientSlides) {
    let A = 0;
    h.forEach((C) => {
      A += C + (b || 0);
    }), A -= b;
    const _ = (m || 0) + (g || 0);
    if (A + _ < y) {
      const C = (y - A - _) / 2;
      u.forEach((O, V) => {
        u[V] = O - C;
      }), f.forEach((O, V) => {
        f[V] = O + C;
      });
    }
  }
  if (Object.assign(i, {
    slides: d,
    snapGrid: u,
    slidesGrid: f,
    slidesSizesGrid: h
  }), t.centeredSlides && t.cssMode && !t.centeredSlidesBounds) {
    sr(n, "--swiper-centered-offset-before", `${-u[0]}px`), sr(n, "--swiper-centered-offset-after", `${i.size / 2 - h[h.length - 1] / 2}px`);
    const A = -i.snapGrid[0], _ = -i.slidesGrid[0];
    i.snapGrid = i.snapGrid.map((C) => C + A), i.slidesGrid = i.slidesGrid.map((C) => C + _);
  }
  if (c !== l && i.emit("slidesLengthChange"), u.length !== v && (i.params.watchOverflow && i.checkOverflow(), i.emit("snapGridLengthChange")), f.length !== p && i.emit("slidesGridLengthChange"), t.watchSlidesProgress && i.updateSlidesOffset(), i.emit("slidesUpdated"), !o && !t.cssMode && (t.effect === "slide" || t.effect === "fade")) {
    const A = `${t.containerModifierClass}backface-hidden`, _ = i.el.classList.contains(A);
    c <= t.maxBackfaceHiddenSlides ? _ || i.el.classList.add(A) : _ && i.el.classList.remove(A);
  }
}
function oA(i) {
  const e = this, t = [], n = e.virtual && e.params.virtual.enabled;
  let s = 0, r;
  typeof i == "number" ? e.setTransition(i) : i === !0 && e.setTransition(e.params.speed);
  const a = (o) => n ? e.slides[e.getSlideIndexByData(o)] : e.slides[o];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((o) => {
        t.push(o);
      });
    else
      for (r = 0; r < Math.ceil(e.params.slidesPerView); r += 1) {
        const o = e.activeIndex + r;
        if (o > e.slides.length && !n) break;
        t.push(a(o));
      }
  else
    t.push(a(e.activeIndex));
  for (r = 0; r < t.length; r += 1)
    if (typeof t[r] < "u") {
      const o = t[r].offsetHeight;
      s = o > s ? o : s;
    }
  (s || s === 0) && (e.wrapperEl.style.height = `${s}px`);
}
function lA() {
  const i = this, e = i.slides, t = i.isElement ? i.isHorizontal() ? i.wrapperEl.offsetLeft : i.wrapperEl.offsetTop : 0;
  for (let n = 0; n < e.length; n += 1)
    e[n].swiperSlideOffset = (i.isHorizontal() ? e[n].offsetLeft : e[n].offsetTop) - t - i.cssOverflowAdjustment();
}
const bu = (i, e, t) => {
  e && !i.classList.contains(t) ? i.classList.add(t) : !e && i.classList.contains(t) && i.classList.remove(t);
};
function dA(i = this && this.translate || 0) {
  const e = this, t = e.params, {
    slides: n,
    rtlTranslate: s,
    snapGrid: r
  } = e;
  if (n.length === 0) return;
  typeof n[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let a = -i;
  s && (a = i), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let o = t.spaceBetween;
  typeof o == "string" && o.indexOf("%") >= 0 ? o = parseFloat(o.replace("%", "")) / 100 * e.size : typeof o == "string" && (o = parseFloat(o));
  for (let l = 0; l < n.length; l += 1) {
    const d = n[l];
    let c = d.swiperSlideOffset;
    t.cssMode && t.centeredSlides && (c -= n[0].swiperSlideOffset);
    const u = (a + (t.centeredSlides ? e.minTranslate() : 0) - c) / (d.swiperSlideSize + o), f = (a - r[0] + (t.centeredSlides ? e.minTranslate() : 0) - c) / (d.swiperSlideSize + o), h = -(a - c), m = h + e.slidesSizesGrid[l], g = h >= 0 && h <= e.size - e.slidesSizesGrid[l], v = h >= 0 && h < e.size - 1 || m > 1 && m <= e.size || h <= 0 && m >= e.size;
    v && (e.visibleSlides.push(d), e.visibleSlidesIndexes.push(l)), bu(d, v, t.slideVisibleClass), bu(d, g, t.slideFullyVisibleClass), d.progress = s ? -u : u, d.originalProgress = s ? -f : f;
  }
}
function cA(i) {
  const e = this;
  if (typeof i > "u") {
    const c = e.rtlTranslate ? -1 : 1;
    i = e && e.translate && e.translate * c || 0;
  }
  const t = e.params, n = e.maxTranslate() - e.minTranslate();
  let {
    progress: s,
    isBeginning: r,
    isEnd: a,
    progressLoop: o
  } = e;
  const l = r, d = a;
  if (n === 0)
    s = 0, r = !0, a = !0;
  else {
    s = (i - e.minTranslate()) / n;
    const c = Math.abs(i - e.minTranslate()) < 1, u = Math.abs(i - e.maxTranslate()) < 1;
    r = c || s <= 0, a = u || s >= 1, c && (s = 0), u && (s = 1);
  }
  if (t.loop) {
    const c = e.getSlideIndexByData(0), u = e.getSlideIndexByData(e.slides.length - 1), f = e.slidesGrid[c], h = e.slidesGrid[u], m = e.slidesGrid[e.slidesGrid.length - 1], g = Math.abs(i);
    g >= f ? o = (g - f) / m : o = (g + m - h) / m, o > 1 && (o -= 1);
  }
  Object.assign(e, {
    progress: s,
    progressLoop: o,
    isBeginning: r,
    isEnd: a
  }), (t.watchSlidesProgress || t.centeredSlides && t.autoHeight) && e.updateSlidesProgress(i), r && !l && e.emit("reachBeginning toEdge"), a && !d && e.emit("reachEnd toEdge"), (l && !r || d && !a) && e.emit("fromEdge"), e.emit("progress", s);
}
const so = (i, e, t) => {
  e && !i.classList.contains(t) ? i.classList.add(t) : !e && i.classList.contains(t) && i.classList.remove(t);
};
function uA() {
  const i = this, {
    slides: e,
    params: t,
    slidesEl: n,
    activeIndex: s
  } = i, r = i.virtual && t.virtual.enabled, a = i.grid && t.grid && t.grid.rows > 1, o = (u) => mi(n, `.${t.slideClass}${u}, swiper-slide${u}`)[0];
  let l, d, c;
  if (r)
    if (t.loop) {
      let u = s - i.virtual.slidesBefore;
      u < 0 && (u = i.virtual.slides.length + u), u >= i.virtual.slides.length && (u -= i.virtual.slides.length), l = o(`[data-swiper-slide-index="${u}"]`);
    } else
      l = o(`[data-swiper-slide-index="${s}"]`);
  else
    a ? (l = e.find((u) => u.column === s), c = e.find((u) => u.column === s + 1), d = e.find((u) => u.column === s - 1)) : l = e[s];
  l && (a || (c = X2(l, `.${t.slideClass}, swiper-slide`)[0], t.loop && !c && (c = e[0]), d = Y2(l, `.${t.slideClass}, swiper-slide`)[0], t.loop && !d === 0 && (d = e[e.length - 1]))), e.forEach((u) => {
    so(u, u === l, t.slideActiveClass), so(u, u === c, t.slideNextClass), so(u, u === d, t.slidePrevClass);
  }), i.emitSlidesClasses();
}
const yr = (i, e) => {
  if (!i || i.destroyed || !i.params) return;
  const t = () => i.isElement ? "swiper-slide" : `.${i.params.slideClass}`, n = e.closest(t());
  if (n) {
    let s = n.querySelector(`.${i.params.lazyPreloaderClass}`);
    !s && i.isElement && (n.shadowRoot ? s = n.shadowRoot.querySelector(`.${i.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      n.shadowRoot && (s = n.shadowRoot.querySelector(`.${i.params.lazyPreloaderClass}`), s && s.remove());
    })), s && s.remove();
  }
}, ro = (i, e) => {
  if (!i.slides[e]) return;
  const t = i.slides[e].querySelector('[loading="lazy"]');
  t && t.removeAttribute("loading");
}, Yo = (i) => {
  if (!i || i.destroyed || !i.params) return;
  let e = i.params.lazyPreloadPrevNext;
  const t = i.slides.length;
  if (!t || !e || e < 0) return;
  e = Math.min(e, t);
  const n = i.params.slidesPerView === "auto" ? i.slidesPerViewDynamic() : Math.ceil(i.params.slidesPerView), s = i.activeIndex;
  if (i.params.grid && i.params.grid.rows > 1) {
    const a = s, o = [a - e];
    o.push(...Array.from({
      length: e
    }).map((l, d) => a + n + d)), i.slides.forEach((l, d) => {
      o.includes(l.column) && ro(i, d);
    });
    return;
  }
  const r = s + n - 1;
  if (i.params.rewind || i.params.loop)
    for (let a = s - e; a <= r + e; a += 1) {
      const o = (a % t + t) % t;
      (o < s || o > r) && ro(i, o);
    }
  else
    for (let a = Math.max(s - e, 0); a <= Math.min(r + e, t - 1); a += 1)
      a !== s && (a > r || a < s) && ro(i, a);
};
function fA(i) {
  const {
    slidesGrid: e,
    params: t
  } = i, n = i.rtlTranslate ? i.translate : -i.translate;
  let s;
  for (let r = 0; r < e.length; r += 1)
    typeof e[r + 1] < "u" ? n >= e[r] && n < e[r + 1] - (e[r + 1] - e[r]) / 2 ? s = r : n >= e[r] && n < e[r + 1] && (s = r + 1) : n >= e[r] && (s = r);
  return t.normalizeSlideIndex && (s < 0 || typeof s > "u") && (s = 0), s;
}
function hA(i) {
  const e = this, t = e.rtlTranslate ? e.translate : -e.translate, {
    snapGrid: n,
    params: s,
    activeIndex: r,
    realIndex: a,
    snapIndex: o
  } = e;
  let l = i, d;
  const c = (h) => {
    let m = h - e.virtual.slidesBefore;
    return m < 0 && (m = e.virtual.slides.length + m), m >= e.virtual.slides.length && (m -= e.virtual.slides.length), m;
  };
  if (typeof l > "u" && (l = fA(e)), n.indexOf(t) >= 0)
    d = n.indexOf(t);
  else {
    const h = Math.min(s.slidesPerGroupSkip, l);
    d = h + Math.floor((l - h) / s.slidesPerGroup);
  }
  if (d >= n.length && (d = n.length - 1), l === r && !e.params.loop) {
    d !== o && (e.snapIndex = d, e.emit("snapIndexChange"));
    return;
  }
  if (l === r && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = c(l);
    return;
  }
  const u = e.grid && s.grid && s.grid.rows > 1;
  let f;
  if (e.virtual && s.virtual.enabled && s.loop)
    f = c(l);
  else if (u) {
    const h = e.slides.find((g) => g.column === l);
    let m = parseInt(h.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(m) && (m = Math.max(e.slides.indexOf(h), 0)), f = Math.floor(m / s.grid.rows);
  } else if (e.slides[l]) {
    const h = e.slides[l].getAttribute("data-swiper-slide-index");
    h ? f = parseInt(h, 10) : f = l;
  } else
    f = l;
  Object.assign(e, {
    previousSnapIndex: o,
    snapIndex: d,
    previousRealIndex: a,
    realIndex: f,
    previousIndex: r,
    activeIndex: l
  }), e.initialized && Yo(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (a !== f && e.emit("realIndexChange"), e.emit("slideChange"));
}
function mA(i, e) {
  const t = this, n = t.params;
  let s = i.closest(`.${n.slideClass}, swiper-slide`);
  !s && t.isElement && e && e.length > 1 && e.includes(i) && [...e.slice(e.indexOf(i) + 1, e.length)].forEach((o) => {
    !s && o.matches && o.matches(`.${n.slideClass}, swiper-slide`) && (s = o);
  });
  let r = !1, a;
  if (s) {
    for (let o = 0; o < t.slides.length; o += 1)
      if (t.slides[o] === s) {
        r = !0, a = o;
        break;
      }
  }
  if (s && r)
    t.clickedSlide = s, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(s.getAttribute("data-swiper-slide-index"), 10) : t.clickedIndex = a;
  else {
    t.clickedSlide = void 0, t.clickedIndex = void 0;
    return;
  }
  n.slideToClickedSlide && t.clickedIndex !== void 0 && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
}
var pA = {
  updateSize: rA,
  updateSlides: aA,
  updateAutoHeight: oA,
  updateSlidesOffset: lA,
  updateSlidesProgress: dA,
  updateProgress: cA,
  updateSlidesClasses: uA,
  updateActiveIndex: hA,
  updateClickedSlide: mA
};
function gA(i = this.isHorizontal() ? "x" : "y") {
  const e = this, {
    params: t,
    rtlTranslate: n,
    translate: s,
    wrapperEl: r
  } = e;
  if (t.virtualTranslate)
    return n ? -s : s;
  if (t.cssMode)
    return s;
  let a = K2(r, i);
  return a += e.cssOverflowAdjustment(), n && (a = -a), a || 0;
}
function vA(i, e) {
  const t = this, {
    rtlTranslate: n,
    params: s,
    wrapperEl: r,
    progress: a
  } = t;
  let o = 0, l = 0;
  const d = 0;
  t.isHorizontal() ? o = n ? -i : i : l = i, s.roundLengths && (o = Math.floor(o), l = Math.floor(l)), t.previousTranslate = t.translate, t.translate = t.isHorizontal() ? o : l, s.cssMode ? r[t.isHorizontal() ? "scrollLeft" : "scrollTop"] = t.isHorizontal() ? -o : -l : s.virtualTranslate || (t.isHorizontal() ? o -= t.cssOverflowAdjustment() : l -= t.cssOverflowAdjustment(), r.style.transform = `translate3d(${o}px, ${l}px, ${d}px)`);
  let c;
  const u = t.maxTranslate() - t.minTranslate();
  u === 0 ? c = 0 : c = (i - t.minTranslate()) / u, c !== a && t.updateProgress(i), t.emit("setTranslate", t.translate, e);
}
function yA() {
  return -this.snapGrid[0];
}
function bA() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function SA(i = 0, e = this.params.speed, t = !0, n = !0, s) {
  const r = this, {
    params: a,
    wrapperEl: o
  } = r;
  if (r.animating && a.preventInteractionOnTransition)
    return !1;
  const l = r.minTranslate(), d = r.maxTranslate();
  let c;
  if (n && i > l ? c = l : n && i < d ? c = d : c = i, r.updateProgress(c), a.cssMode) {
    const u = r.isHorizontal();
    if (e === 0)
      o[u ? "scrollLeft" : "scrollTop"] = -c;
    else {
      if (!r.support.smoothScroll)
        return Nm({
          swiper: r,
          targetPosition: -c,
          side: u ? "left" : "top"
        }), !0;
      o.scrollTo({
        [u ? "left" : "top"]: -c,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (r.setTransition(0), r.setTranslate(c), t && (r.emit("beforeTransitionStart", e, s), r.emit("transitionEnd"))) : (r.setTransition(e), r.setTranslate(c), t && (r.emit("beforeTransitionStart", e, s), r.emit("transitionStart")), r.animating || (r.animating = !0, r.onTranslateToWrapperTransitionEnd || (r.onTranslateToWrapperTransitionEnd = function(f) {
    !r || r.destroyed || f.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.onTranslateToWrapperTransitionEnd = null, delete r.onTranslateToWrapperTransitionEnd, r.animating = !1, t && r.emit("transitionEnd"));
  }), r.wrapperEl.addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd))), !0;
}
var kA = {
  getTranslate: gA,
  setTranslate: vA,
  minTranslate: yA,
  maxTranslate: bA,
  translateTo: SA
};
function TA(i, e) {
  const t = this;
  t.params.cssMode || (t.wrapperEl.style.transitionDuration = `${i}ms`, t.wrapperEl.style.transitionDelay = i === 0 ? "0ms" : ""), t.emit("setTransition", i, e);
}
function Bm({
  swiper: i,
  runCallbacks: e,
  direction: t,
  step: n
}) {
  const {
    activeIndex: s,
    previousIndex: r
  } = i;
  let a = t;
  a || (s > r ? a = "next" : s < r ? a = "prev" : a = "reset"), i.emit(`transition${n}`), e && a === "reset" ? i.emit(`slideResetTransition${n}`) : e && s !== r && (i.emit(`slideChangeTransition${n}`), a === "next" ? i.emit(`slideNextTransition${n}`) : i.emit(`slidePrevTransition${n}`));
}
function EA(i = !0, e) {
  const t = this, {
    params: n
  } = t;
  n.cssMode || (n.autoHeight && t.updateAutoHeight(), Bm({
    swiper: t,
    runCallbacks: i,
    direction: e,
    step: "Start"
  }));
}
function xA(i = !0, e) {
  const t = this, {
    params: n
  } = t;
  t.animating = !1, !n.cssMode && (t.setTransition(0), Bm({
    swiper: t,
    runCallbacks: i,
    direction: e,
    step: "End"
  }));
}
var _A = {
  setTransition: TA,
  transitionStart: EA,
  transitionEnd: xA
};
function AA(i = 0, e, t = !0, n, s) {
  typeof i == "string" && (i = parseInt(i, 10));
  const r = this;
  let a = i;
  a < 0 && (a = 0);
  const {
    params: o,
    snapGrid: l,
    slidesGrid: d,
    previousIndex: c,
    activeIndex: u,
    rtlTranslate: f,
    wrapperEl: h,
    enabled: m
  } = r;
  if (!m && !n && !s || r.destroyed || r.animating && o.preventInteractionOnTransition)
    return !1;
  typeof e > "u" && (e = r.params.speed);
  const g = Math.min(r.params.slidesPerGroupSkip, a);
  let v = g + Math.floor((a - g) / r.params.slidesPerGroup);
  v >= l.length && (v = l.length - 1);
  const p = -l[v];
  if (o.normalizeSlideIndex)
    for (let x = 0; x < d.length; x += 1) {
      const E = -Math.floor(p * 100), R = Math.floor(d[x] * 100), A = Math.floor(d[x + 1] * 100);
      typeof d[x + 1] < "u" ? E >= R && E < A - (A - R) / 2 ? a = x : E >= R && E < A && (a = x + 1) : E >= R && (a = x);
    }
  if (r.initialized && a !== u && (!r.allowSlideNext && (f ? p > r.translate && p > r.minTranslate() : p < r.translate && p < r.minTranslate()) || !r.allowSlidePrev && p > r.translate && p > r.maxTranslate() && (u || 0) !== a))
    return !1;
  a !== (c || 0) && t && r.emit("beforeSlideChangeStart"), r.updateProgress(p);
  let y;
  a > u ? y = "next" : a < u ? y = "prev" : y = "reset";
  const b = r.virtual && r.params.virtual.enabled;
  if (!(b && s) && (f && -p === r.translate || !f && p === r.translate))
    return r.updateActiveIndex(a), o.autoHeight && r.updateAutoHeight(), r.updateSlidesClasses(), o.effect !== "slide" && r.setTranslate(p), y !== "reset" && (r.transitionStart(t, y), r.transitionEnd(t, y)), !1;
  if (o.cssMode) {
    const x = r.isHorizontal(), E = f ? p : -p;
    if (e === 0)
      b && (r.wrapperEl.style.scrollSnapType = "none", r._immediateVirtual = !0), b && !r._cssModeVirtualInitialSet && r.params.initialSlide > 0 ? (r._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        h[x ? "scrollLeft" : "scrollTop"] = E;
      })) : h[x ? "scrollLeft" : "scrollTop"] = E, b && requestAnimationFrame(() => {
        r.wrapperEl.style.scrollSnapType = "", r._immediateVirtual = !1;
      });
    else {
      if (!r.support.smoothScroll)
        return Nm({
          swiper: r,
          targetPosition: E,
          side: x ? "left" : "top"
        }), !0;
      h.scrollTo({
        [x ? "left" : "top"]: E,
        behavior: "smooth"
      });
    }
    return !0;
  }
  const I = $m().isSafari;
  return b && !s && I && r.isElement && r.virtual.update(!1, !1, a), r.setTransition(e), r.setTranslate(p), r.updateActiveIndex(a), r.updateSlidesClasses(), r.emit("beforeTransitionStart", e, n), r.transitionStart(t, y), e === 0 ? r.transitionEnd(t, y) : r.animating || (r.animating = !0, r.onSlideToWrapperTransitionEnd || (r.onSlideToWrapperTransitionEnd = function(E) {
    !r || r.destroyed || E.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onSlideToWrapperTransitionEnd), r.onSlideToWrapperTransitionEnd = null, delete r.onSlideToWrapperTransitionEnd, r.transitionEnd(t, y));
  }), r.wrapperEl.addEventListener("transitionend", r.onSlideToWrapperTransitionEnd)), !0;
}
function wA(i = 0, e, t = !0, n) {
  typeof i == "string" && (i = parseInt(i, 10));
  const s = this;
  if (s.destroyed) return;
  typeof e > "u" && (e = s.params.speed);
  const r = s.grid && s.params.grid && s.params.grid.rows > 1;
  let a = i;
  if (s.params.loop)
    if (s.virtual && s.params.virtual.enabled)
      a = a + s.virtual.slidesBefore;
    else {
      let o;
      if (r) {
        const g = a * s.params.grid.rows;
        o = s.slides.find((v) => v.getAttribute("data-swiper-slide-index") * 1 === g).column;
      } else
        o = s.getSlideIndexByData(a);
      const l = r ? Math.ceil(s.slides.length / s.params.grid.rows) : s.slides.length, {
        centeredSlides: d,
        slidesOffsetBefore: c,
        slidesOffsetAfter: u
      } = s.params, f = d || !!c || !!u;
      let h = s.params.slidesPerView;
      h === "auto" ? h = s.slidesPerViewDynamic() : (h = Math.ceil(parseFloat(s.params.slidesPerView, 10)), f && h % 2 === 0 && (h = h + 1));
      let m = l - o < h;
      if (f && (m = m || o < Math.ceil(h / 2)), n && f && s.params.slidesPerView !== "auto" && !r && (m = !1), m) {
        const g = f ? o < s.activeIndex ? "prev" : "next" : o - s.activeIndex - 1 < s.params.slidesPerView ? "next" : "prev";
        s.loopFix({
          direction: g,
          slideTo: !0,
          activeSlideIndex: g === "next" ? o + 1 : o - l + 1,
          slideRealIndex: g === "next" ? s.realIndex : void 0
        });
      }
      if (r) {
        const g = a * s.params.grid.rows;
        a = s.slides.find((v) => v.getAttribute("data-swiper-slide-index") * 1 === g).column;
      } else
        a = s.getSlideIndexByData(a);
    }
  return requestAnimationFrame(() => {
    s.slideTo(a, e, t, n);
  }), s;
}
function LA(i, e = !0, t) {
  const n = this, {
    enabled: s,
    params: r,
    animating: a
  } = n;
  if (!s || n.destroyed) return n;
  typeof i > "u" && (i = n.params.speed);
  let o = r.slidesPerGroup;
  r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (o = Math.max(n.slidesPerViewDynamic("current", !0), 1));
  const l = n.activeIndex < r.slidesPerGroupSkip ? 1 : o, d = n.virtual && r.virtual.enabled;
  if (r.loop) {
    if (a && !d && r.loopPreventsSliding) return !1;
    if (n.loopFix({
      direction: "next"
    }), n._clientLeft = n.wrapperEl.clientLeft, n.activeIndex === n.slides.length - 1 && r.cssMode)
      return requestAnimationFrame(() => {
        n.slideTo(n.activeIndex + l, i, e, t);
      }), !0;
  }
  return r.rewind && n.isEnd ? n.slideTo(0, i, e, t) : n.slideTo(n.activeIndex + l, i, e, t);
}
function IA(i, e = !0, t) {
  const n = this, {
    params: s,
    snapGrid: r,
    slidesGrid: a,
    rtlTranslate: o,
    enabled: l,
    animating: d
  } = n;
  if (!l || n.destroyed) return n;
  typeof i > "u" && (i = n.params.speed);
  const c = n.virtual && s.virtual.enabled;
  if (s.loop) {
    if (d && !c && s.loopPreventsSliding) return !1;
    n.loopFix({
      direction: "prev"
    }), n._clientLeft = n.wrapperEl.clientLeft;
  }
  const u = o ? n.translate : -n.translate;
  function f(y) {
    return y < 0 ? -Math.floor(Math.abs(y)) : Math.floor(y);
  }
  const h = f(u), m = r.map((y) => f(y)), g = s.freeMode && s.freeMode.enabled;
  let v = r[m.indexOf(h) - 1];
  if (typeof v > "u" && (s.cssMode || g)) {
    let y;
    r.forEach((b, k) => {
      h >= b && (y = k);
    }), typeof y < "u" && (v = g ? r[y] : r[y > 0 ? y - 1 : y]);
  }
  let p = 0;
  if (typeof v < "u" && (p = a.indexOf(v), p < 0 && (p = n.activeIndex - 1), s.slidesPerView === "auto" && s.slidesPerGroup === 1 && s.slidesPerGroupAuto && (p = p - n.slidesPerViewDynamic("previous", !0) + 1, p = Math.max(p, 0))), s.rewind && n.isBeginning) {
    const y = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
    return n.slideTo(y, i, e, t);
  } else if (s.loop && n.activeIndex === 0 && s.cssMode)
    return requestAnimationFrame(() => {
      n.slideTo(p, i, e, t);
    }), !0;
  return n.slideTo(p, i, e, t);
}
function CA(i, e = !0, t) {
  const n = this;
  if (!n.destroyed)
    return typeof i > "u" && (i = n.params.speed), n.slideTo(n.activeIndex, i, e, t);
}
function RA(i, e = !0, t, n = 0.5) {
  const s = this;
  if (s.destroyed) return;
  typeof i > "u" && (i = s.params.speed);
  let r = s.activeIndex;
  const a = Math.min(s.params.slidesPerGroupSkip, r), o = a + Math.floor((r - a) / s.params.slidesPerGroup), l = s.rtlTranslate ? s.translate : -s.translate;
  if (l >= s.snapGrid[o]) {
    const d = s.snapGrid[o], c = s.snapGrid[o + 1];
    l - d > (c - d) * n && (r += s.params.slidesPerGroup);
  } else {
    const d = s.snapGrid[o - 1], c = s.snapGrid[o];
    l - d <= (c - d) * n && (r -= s.params.slidesPerGroup);
  }
  return r = Math.max(r, 0), r = Math.min(r, s.slidesGrid.length - 1), s.slideTo(r, i, e, t);
}
function PA() {
  const i = this;
  if (i.destroyed) return;
  const {
    params: e,
    slidesEl: t
  } = i, n = e.slidesPerView === "auto" ? i.slidesPerViewDynamic() : e.slidesPerView;
  let s = i.getSlideIndexWhenGrid(i.clickedIndex), r;
  const a = i.isElement ? "swiper-slide" : `.${e.slideClass}`, o = i.grid && i.params.grid && i.params.grid.rows > 1;
  if (e.loop) {
    if (i.animating) return;
    r = parseInt(i.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? i.slideToLoop(r) : s > (o ? (i.slides.length - n) / 2 - (i.params.grid.rows - 1) : i.slides.length - n) ? (i.loopFix(), s = i.getSlideIndex(mi(t, `${a}[data-swiper-slide-index="${r}"]`)[0]), Dm(() => {
      i.slideTo(s);
    })) : i.slideTo(s);
  } else
    i.slideTo(s);
}
var DA = {
  slideTo: AA,
  slideToLoop: wA,
  slideNext: LA,
  slidePrev: IA,
  slideReset: CA,
  slideToClosest: RA,
  slideToClickedSlide: PA
};
function NA(i, e) {
  const t = this, {
    params: n,
    slidesEl: s
  } = t;
  if (!n.loop || t.virtual && t.params.virtual.enabled) return;
  const r = () => {
    mi(s, `.${n.slideClass}, swiper-slide`).forEach((m, g) => {
      m.setAttribute("data-swiper-slide-index", g);
    });
  }, a = () => {
    const h = mi(s, `.${n.slideBlankClass}`);
    h.forEach((m) => {
      m.remove();
    }), h.length > 0 && (t.recalcSlides(), t.updateSlides());
  }, o = t.grid && n.grid && n.grid.rows > 1;
  n.loopAddBlankSlides && (n.slidesPerGroup > 1 || o) && a();
  const l = n.slidesPerGroup * (o ? n.grid.rows : 1), d = t.slides.length % l !== 0, c = o && t.slides.length % n.grid.rows !== 0, u = (h) => {
    for (let m = 0; m < h; m += 1) {
      const g = t.isElement ? Ps("swiper-slide", [n.slideBlankClass]) : Ps("div", [n.slideClass, n.slideBlankClass]);
      t.slidesEl.append(g);
    }
  };
  if (d) {
    if (n.loopAddBlankSlides) {
      const h = l - t.slides.length % l;
      u(h), t.recalcSlides(), t.updateSlides();
    } else
      Kr("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    r();
  } else if (c) {
    if (n.loopAddBlankSlides) {
      const h = n.grid.rows - t.slides.length % n.grid.rows;
      u(h), t.recalcSlides(), t.updateSlides();
    } else
      Kr("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    r();
  } else
    r();
  const f = n.centeredSlides || !!n.slidesOffsetBefore || !!n.slidesOffsetAfter;
  t.loopFix({
    slideRealIndex: i,
    direction: f ? void 0 : "next",
    initial: e
  });
}
function MA({
  slideRealIndex: i,
  slideTo: e = !0,
  direction: t,
  setTranslate: n,
  activeSlideIndex: s,
  initial: r,
  byController: a,
  byMousewheel: o
} = {}) {
  const l = this;
  if (!l.params.loop) return;
  l.emit("beforeLoopFix");
  const {
    slides: d,
    allowSlidePrev: c,
    allowSlideNext: u,
    slidesEl: f,
    params: h
  } = l, {
    centeredSlides: m,
    slidesOffsetBefore: g,
    slidesOffsetAfter: v,
    initialSlide: p
  } = h, y = m || !!g || !!v;
  if (l.allowSlidePrev = !0, l.allowSlideNext = !0, l.virtual && h.virtual.enabled) {
    e && (!y && l.snapIndex === 0 ? l.slideTo(l.virtual.slides.length, 0, !1, !0) : y && l.snapIndex < h.slidesPerView ? l.slideTo(l.virtual.slides.length + l.snapIndex, 0, !1, !0) : l.snapIndex === l.snapGrid.length - 1 && l.slideTo(l.virtual.slidesBefore, 0, !1, !0)), l.allowSlidePrev = c, l.allowSlideNext = u, l.emit("loopFix");
    return;
  }
  let b = h.slidesPerView;
  b === "auto" ? b = l.slidesPerViewDynamic() : (b = Math.ceil(parseFloat(h.slidesPerView, 10)), y && b % 2 === 0 && (b = b + 1));
  const k = h.slidesPerGroupAuto ? b : h.slidesPerGroup;
  let T = y ? Math.max(k, Math.ceil(b / 2)) : k;
  T % k !== 0 && (T += k - T % k), T += h.loopAdditionalSlides, l.loopedSlides = T;
  const I = l.grid && h.grid && h.grid.rows > 1;
  d.length < b + T || l.params.effect === "cards" && d.length < b + T * 2 ? Kr("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : I && h.grid.fill === "row" && Kr("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const x = [], E = [], R = I ? Math.ceil(d.length / h.grid.rows) : d.length, A = r && R - p < b && !y;
  let _ = A ? p : l.activeIndex;
  typeof s > "u" ? s = l.getSlideIndex(d.find((z) => z.classList.contains(h.slideActiveClass))) : _ = s;
  const C = t === "next" || !t, O = t === "prev" || !t;
  let V = 0, j = 0;
  const q = (I ? d[s].column : s) + (y && typeof n > "u" ? -b / 2 + 0.5 : 0);
  if (q < T) {
    V = Math.max(T - q, k);
    for (let z = 0; z < T - q; z += 1) {
      const Q = z - Math.floor(z / R) * R;
      if (I) {
        const oe = R - Q - 1;
        for (let Z = d.length - 1; Z >= 0; Z -= 1)
          d[Z].column === oe && x.push(Z);
      } else
        x.push(R - Q - 1);
    }
  } else if (q + b > R - T) {
    j = Math.max(q - (R - T * 2), k), A && (j = Math.max(j, b - R + p + 1));
    for (let z = 0; z < j; z += 1) {
      const Q = z - Math.floor(z / R) * R;
      I ? d.forEach((oe, Z) => {
        oe.column === Q && E.push(Z);
      }) : E.push(Q);
    }
  }
  if (l.__preventObserver__ = !0, requestAnimationFrame(() => {
    l.__preventObserver__ = !1;
  }), l.params.effect === "cards" && d.length < b + T * 2 && (E.includes(s) && E.splice(E.indexOf(s), 1), x.includes(s) && x.splice(x.indexOf(s), 1)), O && x.forEach((z) => {
    d[z].swiperLoopMoveDOM = !0, f.prepend(d[z]), d[z].swiperLoopMoveDOM = !1;
  }), C && E.forEach((z) => {
    d[z].swiperLoopMoveDOM = !0, f.append(d[z]), d[z].swiperLoopMoveDOM = !1;
  }), l.recalcSlides(), h.slidesPerView === "auto" ? l.updateSlides() : I && (x.length > 0 && O || E.length > 0 && C) && l.slides.forEach((z, Q) => {
    l.grid.updateSlide(Q, z, l.slides);
  }), h.watchSlidesProgress && l.updateSlidesOffset(), e) {
    if (x.length > 0 && O) {
      if (typeof i > "u") {
        const z = l.slidesGrid[_], oe = l.slidesGrid[_ + V] - z;
        o ? l.setTranslate(l.translate - oe) : (l.slideTo(_ + Math.ceil(V), 0, !1, !0), n && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - oe, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - oe));
      } else if (n) {
        const z = I ? x.length / h.grid.rows : x.length;
        l.slideTo(l.activeIndex + z, 0, !1, !0), l.touchEventsData.currentTranslate = l.translate;
      }
    } else if (E.length > 0 && C)
      if (typeof i > "u") {
        const z = l.slidesGrid[_], oe = l.slidesGrid[_ - j] - z;
        o ? l.setTranslate(l.translate - oe) : (l.slideTo(_ - j, 0, !1, !0), n && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - oe, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - oe));
      } else {
        const z = I ? E.length / h.grid.rows : E.length;
        l.slideTo(l.activeIndex - z, 0, !1, !0);
      }
  }
  if (l.allowSlidePrev = c, l.allowSlideNext = u, l.controller && l.controller.control && !a) {
    const z = {
      slideRealIndex: i,
      direction: t,
      setTranslate: n,
      activeSlideIndex: s,
      byController: !0
    };
    Array.isArray(l.controller.control) ? l.controller.control.forEach((Q) => {
      !Q.destroyed && Q.params.loop && Q.loopFix({
        ...z,
        slideTo: Q.params.slidesPerView === h.slidesPerView ? e : !1
      });
    }) : l.controller.control instanceof l.constructor && l.controller.control.params.loop && l.controller.control.loopFix({
      ...z,
      slideTo: l.controller.control.params.slidesPerView === h.slidesPerView ? e : !1
    });
  }
  l.emit("loopFix");
}
function OA() {
  const i = this, {
    params: e,
    slidesEl: t
  } = i;
  if (!e.loop || !t || i.virtual && i.params.virtual.enabled) return;
  i.recalcSlides();
  const n = [];
  i.slides.forEach((s) => {
    const r = typeof s.swiperSlideIndex > "u" ? s.getAttribute("data-swiper-slide-index") * 1 : s.swiperSlideIndex;
    n[r] = s;
  }), i.slides.forEach((s) => {
    s.removeAttribute("data-swiper-slide-index");
  }), n.forEach((s) => {
    t.append(s);
  }), i.recalcSlides(), i.slideTo(i.realIndex, 0);
}
var FA = {
  loopCreate: NA,
  loopFix: MA,
  loopDestroy: OA
};
function $A(i) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
  const t = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), t.style.cursor = "move", t.style.cursor = i ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function BA() {
  const i = this;
  i.params.watchOverflow && i.isLocked || i.params.cssMode || (i.isElement && (i.__preventObserver__ = !0), i[i.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", i.isElement && requestAnimationFrame(() => {
    i.__preventObserver__ = !1;
  }));
}
var UA = {
  setGrabCursor: $A,
  unsetGrabCursor: BA
};
function VA(i, e = this) {
  function t(n) {
    if (!n || n === pi() || n === Lt()) return null;
    n.assignedSlot && (n = n.assignedSlot);
    const s = n.closest(i);
    return !s && !n.getRootNode ? null : s || t(n.getRootNode().host);
  }
  return t(e);
}
function Su(i, e, t) {
  const n = Lt(), {
    params: s
  } = i, r = s.edgeSwipeDetection, a = s.edgeSwipeThreshold;
  return r && (t <= a || t >= n.innerWidth - a) ? r === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
}
function GA(i) {
  const e = this, t = pi();
  let n = i;
  n.originalEvent && (n = n.originalEvent);
  const s = e.touchEventsData;
  if (n.type === "pointerdown") {
    if (s.pointerId !== null && s.pointerId !== n.pointerId)
      return;
    s.pointerId = n.pointerId;
  } else n.type === "touchstart" && n.targetTouches.length === 1 && (s.touchId = n.targetTouches[0].identifier);
  if (n.type === "touchstart") {
    Su(e, n, n.targetTouches[0].pageX);
    return;
  }
  const {
    params: r,
    touches: a,
    enabled: o
  } = e;
  if (!o || !r.simulateTouch && n.pointerType === "mouse" || e.animating && r.preventInteractionOnTransition)
    return;
  !e.animating && r.cssMode && r.loop && e.loopFix();
  let l = n.target;
  if (r.touchEventsTarget === "wrapper" && !q2(l, e.wrapperEl) || "which" in n && n.which === 3 || "button" in n && n.button > 0 || s.isTouched && s.isMoved) return;
  const d = !!r.noSwipingClass && r.noSwipingClass !== "", c = n.composedPath ? n.composedPath() : n.path;
  d && n.target && n.target.shadowRoot && c && (l = c[0]);
  const u = r.noSwipingSelector ? r.noSwipingSelector : `.${r.noSwipingClass}`, f = !!(n.target && n.target.shadowRoot);
  if (r.noSwiping && (f ? VA(u, l) : l.closest(u))) {
    e.allowClick = !0;
    return;
  }
  if (r.swipeHandler && !l.closest(r.swipeHandler))
    return;
  a.currentX = n.pageX, a.currentY = n.pageY;
  const h = a.currentX, m = a.currentY;
  if (!Su(e, n, h))
    return;
  Object.assign(s, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), a.startX = h, a.startY = m, s.touchStartTime = zr(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, r.threshold > 0 && (s.allowThresholdMove = !1);
  let g = !0;
  l.matches(s.focusableElements) && (g = !1, l.nodeName === "SELECT" && (s.isTouched = !1)), t.activeElement && t.activeElement.matches(s.focusableElements) && t.activeElement !== l && (n.pointerType === "mouse" || n.pointerType !== "mouse" && !l.matches(s.focusableElements)) && t.activeElement.blur();
  const v = g && e.allowTouchMove && r.touchStartPreventDefault;
  (r.touchStartForcePreventDefault || v) && !l.isContentEditable && n.preventDefault(), r.freeMode && r.freeMode.enabled && e.freeMode && e.animating && !r.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", n);
}
function HA(i) {
  const e = pi(), t = this, n = t.touchEventsData, {
    params: s,
    touches: r,
    rtlTranslate: a,
    enabled: o
  } = t;
  if (!o || !s.simulateTouch && i.pointerType === "mouse") return;
  let l = i;
  if (l.originalEvent && (l = l.originalEvent), l.type === "pointermove" && (n.touchId !== null || l.pointerId !== n.pointerId))
    return;
  let d;
  if (l.type === "touchmove") {
    if (d = [...l.changedTouches].find((T) => T.identifier === n.touchId), !d || d.identifier !== n.touchId) return;
  } else
    d = l;
  if (!n.isTouched) {
    n.startMoving && n.isScrolling && t.emit("touchMoveOpposite", l);
    return;
  }
  const c = d.pageX, u = d.pageY;
  if (l.preventedByNestedSwiper) {
    r.startX = c, r.startY = u;
    return;
  }
  if (!t.allowTouchMove) {
    l.target.matches(n.focusableElements) || (t.allowClick = !1), n.isTouched && (Object.assign(r, {
      startX: c,
      startY: u,
      currentX: c,
      currentY: u
    }), n.touchStartTime = zr());
    return;
  }
  if (s.touchReleaseOnEdges && !s.loop)
    if (t.isVertical()) {
      if (u < r.startY && t.translate <= t.maxTranslate() || u > r.startY && t.translate >= t.minTranslate()) {
        n.isTouched = !1, n.isMoved = !1;
        return;
      }
    } else {
      if (a && (c > r.startX && -t.translate <= t.maxTranslate() || c < r.startX && -t.translate >= t.minTranslate()))
        return;
      if (!a && (c < r.startX && t.translate <= t.maxTranslate() || c > r.startX && t.translate >= t.minTranslate()))
        return;
    }
  if (e.activeElement && e.activeElement.matches(n.focusableElements) && e.activeElement !== l.target && l.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && l.target === e.activeElement && l.target.matches(n.focusableElements)) {
    n.isMoved = !0, t.allowClick = !1;
    return;
  }
  n.allowTouchCallbacks && t.emit("touchMove", l), r.previousX = r.currentX, r.previousY = r.currentY, r.currentX = c, r.currentY = u;
  const f = r.currentX - r.startX, h = r.currentY - r.startY;
  if (t.params.threshold && Math.sqrt(f ** 2 + h ** 2) < t.params.threshold) return;
  if (typeof n.isScrolling > "u") {
    let T;
    t.isHorizontal() && r.currentY === r.startY || t.isVertical() && r.currentX === r.startX ? n.isScrolling = !1 : f * f + h * h >= 25 && (T = Math.atan2(Math.abs(h), Math.abs(f)) * 180 / Math.PI, n.isScrolling = t.isHorizontal() ? T > s.touchAngle : 90 - T > s.touchAngle);
  }
  if (n.isScrolling && t.emit("touchMoveOpposite", l), typeof n.startMoving > "u" && (r.currentX !== r.startX || r.currentY !== r.startY) && (n.startMoving = !0), n.isScrolling || l.type === "touchmove" && n.preventTouchMoveFromPointerMove) {
    n.isTouched = !1;
    return;
  }
  if (!n.startMoving)
    return;
  t.allowClick = !1, !s.cssMode && l.cancelable && l.preventDefault(), s.touchMoveStopPropagation && !s.nested && l.stopPropagation();
  let m = t.isHorizontal() ? f : h, g = t.isHorizontal() ? r.currentX - r.previousX : r.currentY - r.previousY;
  s.oneWayMovement && (m = Math.abs(m) * (a ? 1 : -1), g = Math.abs(g) * (a ? 1 : -1)), r.diff = m, m *= s.touchRatio, a && (m = -m, g = -g);
  const v = t.touchesDirection;
  t.swipeDirection = m > 0 ? "prev" : "next", t.touchesDirection = g > 0 ? "prev" : "next";
  const p = t.params.loop && !s.cssMode, y = t.touchesDirection === "next" && t.allowSlideNext || t.touchesDirection === "prev" && t.allowSlidePrev;
  if (!n.isMoved) {
    if (p && y && t.loopFix({
      direction: t.swipeDirection
    }), n.startTranslate = t.getTranslate(), t.setTransition(0), t.animating) {
      const T = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      t.wrapperEl.dispatchEvent(T);
    }
    n.allowMomentumBounce = !1, s.grabCursor && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!0), t.emit("sliderFirstMove", l);
  }
  if ((/* @__PURE__ */ new Date()).getTime(), s._loopSwapReset !== !1 && n.isMoved && n.allowThresholdMove && v !== t.touchesDirection && p && y && Math.abs(m) >= 1) {
    Object.assign(r, {
      startX: c,
      startY: u,
      currentX: c,
      currentY: u,
      startTranslate: n.currentTranslate
    }), n.loopSwapReset = !0, n.startTranslate = n.currentTranslate;
    return;
  }
  t.emit("sliderMove", l), n.isMoved = !0, n.currentTranslate = m + n.startTranslate;
  let b = !0, k = s.resistanceRatio;
  if (s.touchReleaseOnEdges && (k = 0), m > 0 ? (p && y && n.allowThresholdMove && n.currentTranslate > (s.centeredSlides ? t.minTranslate() - t.slidesSizesGrid[t.activeIndex + 1] - (s.slidesPerView !== "auto" && t.slides.length - s.slidesPerView >= 2 ? t.slidesSizesGrid[t.activeIndex + 1] + t.params.spaceBetween : 0) - t.params.spaceBetween : t.minTranslate()) && t.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), n.currentTranslate > t.minTranslate() && (b = !1, s.resistance && (n.currentTranslate = t.minTranslate() - 1 + (-t.minTranslate() + n.startTranslate + m) ** k))) : m < 0 && (p && y && n.allowThresholdMove && n.currentTranslate < (s.centeredSlides ? t.maxTranslate() + t.slidesSizesGrid[t.slidesSizesGrid.length - 1] + t.params.spaceBetween + (s.slidesPerView !== "auto" && t.slides.length - s.slidesPerView >= 2 ? t.slidesSizesGrid[t.slidesSizesGrid.length - 1] + t.params.spaceBetween : 0) : t.maxTranslate()) && t.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: t.slides.length - (s.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(parseFloat(s.slidesPerView, 10)))
  }), n.currentTranslate < t.maxTranslate() && (b = !1, s.resistance && (n.currentTranslate = t.maxTranslate() + 1 - (t.maxTranslate() - n.startTranslate - m) ** k))), b && (l.preventedByNestedSwiper = !0), !t.allowSlideNext && t.swipeDirection === "next" && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !t.allowSlidePrev && t.swipeDirection === "prev" && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), !t.allowSlidePrev && !t.allowSlideNext && (n.currentTranslate = n.startTranslate), s.threshold > 0)
    if (Math.abs(m) > s.threshold || n.allowThresholdMove) {
      if (!n.allowThresholdMove) {
        n.allowThresholdMove = !0, r.startX = r.currentX, r.startY = r.currentY, n.currentTranslate = n.startTranslate, r.diff = t.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY;
        return;
      }
    } else {
      n.currentTranslate = n.startTranslate;
      return;
    }
  !s.followFinger || s.cssMode || ((s.freeMode && s.freeMode.enabled && t.freeMode || s.watchSlidesProgress) && (t.updateActiveIndex(), t.updateSlidesClasses()), s.freeMode && s.freeMode.enabled && t.freeMode && t.freeMode.onTouchMove(), t.updateProgress(n.currentTranslate), t.setTranslate(n.currentTranslate));
}
function zA(i) {
  const e = this, t = e.touchEventsData;
  let n = i;
  n.originalEvent && (n = n.originalEvent);
  let s;
  if (n.type === "touchend" || n.type === "touchcancel") {
    if (s = [...n.changedTouches].find((T) => T.identifier === t.touchId), !s || s.identifier !== t.touchId) return;
  } else {
    if (t.touchId !== null || n.pointerId !== t.pointerId) return;
    s = n;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(n.type) && !(["pointercancel", "contextmenu"].includes(n.type) && (e.browser.isSafari || e.browser.isWebView)))
    return;
  t.pointerId = null, t.touchId = null;
  const {
    params: a,
    touches: o,
    rtlTranslate: l,
    slidesGrid: d,
    enabled: c
  } = e;
  if (!c || !a.simulateTouch && n.pointerType === "mouse") return;
  if (t.allowTouchCallbacks && e.emit("touchEnd", n), t.allowTouchCallbacks = !1, !t.isTouched) {
    t.isMoved && a.grabCursor && e.setGrabCursor(!1), t.isMoved = !1, t.startMoving = !1;
    return;
  }
  a.grabCursor && t.isMoved && t.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const u = zr(), f = u - t.touchStartTime;
  if (e.allowClick) {
    const T = n.path || n.composedPath && n.composedPath();
    e.updateClickedSlide(T && T[0] || n.target, T), e.emit("tap click", n), f < 300 && u - t.lastClickTime < 300 && e.emit("doubleTap doubleClick", n);
  }
  if (t.lastClickTime = zr(), Dm(() => {
    e.destroyed || (e.allowClick = !0);
  }), !t.isTouched || !t.isMoved || !e.swipeDirection || o.diff === 0 && !t.loopSwapReset || t.currentTranslate === t.startTranslate && !t.loopSwapReset) {
    t.isTouched = !1, t.isMoved = !1, t.startMoving = !1;
    return;
  }
  t.isTouched = !1, t.isMoved = !1, t.startMoving = !1;
  let h;
  if (a.followFinger ? h = l ? e.translate : -e.translate : h = -t.currentTranslate, a.cssMode)
    return;
  if (a.freeMode && a.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: h
    });
    return;
  }
  const m = h >= -e.maxTranslate() && !e.params.loop;
  let g = 0, v = e.slidesSizesGrid[0];
  for (let T = 0; T < d.length; T += T < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup) {
    const I = T < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
    typeof d[T + I] < "u" ? (m || h >= d[T] && h < d[T + I]) && (g = T, v = d[T + I] - d[T]) : (m || h >= d[T]) && (g = T, v = d[d.length - 1] - d[d.length - 2]);
  }
  let p = null, y = null;
  a.rewind && (e.isBeginning ? y = a.virtual && a.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (p = 0));
  const b = (h - d[g]) / v, k = g < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
  if (f > a.longSwipesMs) {
    if (!a.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (b >= a.longSwipesRatio ? e.slideTo(a.rewind && e.isEnd ? p : g + k) : e.slideTo(g)), e.swipeDirection === "prev" && (b > 1 - a.longSwipesRatio ? e.slideTo(g + k) : y !== null && b < 0 && Math.abs(b) > a.longSwipesRatio ? e.slideTo(y) : e.slideTo(g));
  } else {
    if (!a.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (n.target === e.navigation.nextEl || n.target === e.navigation.prevEl) ? n.target === e.navigation.nextEl ? e.slideTo(g + k) : e.slideTo(g) : (e.swipeDirection === "next" && e.slideTo(p !== null ? p : g + k), e.swipeDirection === "prev" && e.slideTo(y !== null ? y : g));
  }
}
function ku() {
  const i = this, {
    params: e,
    el: t
  } = i;
  if (t && t.offsetWidth === 0) return;
  e.breakpoints && i.setBreakpoint();
  const {
    allowSlideNext: n,
    allowSlidePrev: s,
    snapGrid: r
  } = i, a = i.virtual && i.params.virtual.enabled;
  i.allowSlideNext = !0, i.allowSlidePrev = !0, i.updateSize(), i.updateSlides(), i.updateSlidesClasses();
  const o = a && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && i.isEnd && !i.isBeginning && !i.params.centeredSlides && !o ? i.slideTo(i.slides.length - 1, 0, !1, !0) : i.params.loop && !a ? i.slideToLoop(i.realIndex, 0, !1, !0) : i.slideTo(i.activeIndex, 0, !1, !0), i.autoplay && i.autoplay.running && i.autoplay.paused && (clearTimeout(i.autoplay.resizeTimeout), i.autoplay.resizeTimeout = setTimeout(() => {
    i.autoplay && i.autoplay.running && i.autoplay.paused && i.autoplay.resume();
  }, 500)), i.allowSlidePrev = s, i.allowSlideNext = n, i.params.watchOverflow && r !== i.snapGrid && i.checkOverflow();
}
function KA(i) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && i.preventDefault(), e.params.preventClicksPropagation && e.animating && (i.stopPropagation(), i.stopImmediatePropagation())));
}
function jA() {
  const i = this, {
    wrapperEl: e,
    rtlTranslate: t,
    enabled: n
  } = i;
  if (!n) return;
  i.previousTranslate = i.translate, i.isHorizontal() ? i.translate = -e.scrollLeft : i.translate = -e.scrollTop, i.translate === 0 && (i.translate = 0), i.updateActiveIndex(), i.updateSlidesClasses();
  let s;
  const r = i.maxTranslate() - i.minTranslate();
  r === 0 ? s = 0 : s = (i.translate - i.minTranslate()) / r, s !== i.progress && i.updateProgress(t ? -i.translate : i.translate), i.emit("setTranslate", i.translate, !1);
}
function WA(i) {
  const e = this;
  yr(e, i.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
function qA() {
  const i = this;
  i.documentTouchHandlerProceeded || (i.documentTouchHandlerProceeded = !0, i.params.touchReleaseOnEdges && (i.el.style.touchAction = "auto"));
}
const Um = (i, e) => {
  const t = pi(), {
    params: n,
    el: s,
    wrapperEl: r,
    device: a
  } = i, o = !!n.nested, l = e === "on" ? "addEventListener" : "removeEventListener", d = e;
  !s || typeof s == "string" || (t[l]("touchstart", i.onDocumentTouchStart, {
    passive: !1,
    capture: o
  }), s[l]("touchstart", i.onTouchStart, {
    passive: !1
  }), s[l]("pointerdown", i.onTouchStart, {
    passive: !1
  }), t[l]("touchmove", i.onTouchMove, {
    passive: !1,
    capture: o
  }), t[l]("pointermove", i.onTouchMove, {
    passive: !1,
    capture: o
  }), t[l]("touchend", i.onTouchEnd, {
    passive: !0
  }), t[l]("pointerup", i.onTouchEnd, {
    passive: !0
  }), t[l]("pointercancel", i.onTouchEnd, {
    passive: !0
  }), t[l]("touchcancel", i.onTouchEnd, {
    passive: !0
  }), t[l]("pointerout", i.onTouchEnd, {
    passive: !0
  }), t[l]("pointerleave", i.onTouchEnd, {
    passive: !0
  }), t[l]("contextmenu", i.onTouchEnd, {
    passive: !0
  }), (n.preventClicks || n.preventClicksPropagation) && s[l]("click", i.onClick, !0), n.cssMode && r[l]("scroll", i.onScroll), n.updateOnWindowResize ? i[d](a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", ku, !0) : i[d]("observerUpdate", ku, !0), s[l]("load", i.onLoad, {
    capture: !0
  }));
};
function YA() {
  const i = this, {
    params: e
  } = i;
  i.onTouchStart = GA.bind(i), i.onTouchMove = HA.bind(i), i.onTouchEnd = zA.bind(i), i.onDocumentTouchStart = qA.bind(i), e.cssMode && (i.onScroll = jA.bind(i)), i.onClick = KA.bind(i), i.onLoad = WA.bind(i), Um(i, "on");
}
function XA() {
  Um(this, "off");
}
var ZA = {
  attachEvents: YA,
  detachEvents: XA
};
const Tu = (i, e) => i.grid && e.grid && e.grid.rows > 1;
function QA() {
  const i = this, {
    realIndex: e,
    initialized: t,
    params: n,
    el: s
  } = i, r = n.breakpoints;
  if (!r || r && Object.keys(r).length === 0) return;
  const a = pi(), o = n.breakpointsBase === "window" || !n.breakpointsBase ? n.breakpointsBase : "container", l = ["window", "container"].includes(n.breakpointsBase) || !n.breakpointsBase ? i.el : a.querySelector(n.breakpointsBase), d = i.getBreakpoint(r, o, l);
  if (!d || i.currentBreakpoint === d) return;
  const u = (d in r ? r[d] : void 0) || i.originalParams, f = Tu(i, n), h = Tu(i, u), m = i.params.grabCursor, g = u.grabCursor, v = n.enabled;
  f && !h ? (s.classList.remove(`${n.containerModifierClass}grid`, `${n.containerModifierClass}grid-column`), i.emitContainerClasses()) : !f && h && (s.classList.add(`${n.containerModifierClass}grid`), (u.grid.fill && u.grid.fill === "column" || !u.grid.fill && n.grid.fill === "column") && s.classList.add(`${n.containerModifierClass}grid-column`), i.emitContainerClasses()), m && !g ? i.unsetGrabCursor() : !m && g && i.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((I) => {
    if (typeof u[I] > "u") return;
    const x = n[I] && n[I].enabled, E = u[I] && u[I].enabled;
    x && !E && i[I].disable(), !x && E && i[I].enable();
  });
  const p = u.direction && u.direction !== n.direction, y = n.loop && (u.slidesPerView !== n.slidesPerView || p), b = n.loop;
  p && t && i.changeDirection(), Ft(i.params, u);
  const k = i.params.enabled, T = i.params.loop;
  Object.assign(i, {
    allowTouchMove: i.params.allowTouchMove,
    allowSlideNext: i.params.allowSlideNext,
    allowSlidePrev: i.params.allowSlidePrev
  }), v && !k ? i.disable() : !v && k && i.enable(), i.currentBreakpoint = d, i.emit("_beforeBreakpoint", u), t && (y ? (i.loopDestroy(), i.loopCreate(e), i.updateSlides()) : !b && T ? (i.loopCreate(e), i.updateSlides()) : b && !T && i.loopDestroy()), i.emit("breakpoint", u);
}
function JA(i, e = "window", t) {
  if (!i || e === "container" && !t) return;
  let n = !1;
  const s = Lt(), r = e === "window" ? s.innerHeight : t.clientHeight, a = Object.keys(i).map((o) => {
    if (typeof o == "string" && o.indexOf("@") === 0) {
      const l = parseFloat(o.substr(1));
      return {
        value: r * l,
        point: o
      };
    }
    return {
      value: o,
      point: o
    };
  });
  a.sort((o, l) => parseInt(o.value, 10) - parseInt(l.value, 10));
  for (let o = 0; o < a.length; o += 1) {
    const {
      point: l,
      value: d
    } = a[o];
    e === "window" ? s.matchMedia(`(min-width: ${d}px)`).matches && (n = l) : d <= t.clientWidth && (n = l);
  }
  return n || "max";
}
var ew = {
  setBreakpoint: QA,
  getBreakpoint: JA
};
function tw(i, e) {
  const t = [];
  return i.forEach((n) => {
    typeof n == "object" ? Object.keys(n).forEach((s) => {
      n[s] && t.push(e + s);
    }) : typeof n == "string" && t.push(e + n);
  }), t;
}
function iw() {
  const i = this, {
    classNames: e,
    params: t,
    rtl: n,
    el: s,
    device: r
  } = i, a = tw(["initialized", t.direction, {
    "free-mode": i.params.freeMode && t.freeMode.enabled
  }, {
    autoheight: t.autoHeight
  }, {
    rtl: n
  }, {
    grid: t.grid && t.grid.rows > 1
  }, {
    "grid-column": t.grid && t.grid.rows > 1 && t.grid.fill === "column"
  }, {
    android: r.android
  }, {
    ios: r.ios
  }, {
    "css-mode": t.cssMode
  }, {
    centered: t.cssMode && t.centeredSlides
  }, {
    "watch-progress": t.watchSlidesProgress
  }], t.containerModifierClass);
  e.push(...a), s.classList.add(...e), i.emitContainerClasses();
}
function nw() {
  const i = this, {
    el: e,
    classNames: t
  } = i;
  !e || typeof e == "string" || (e.classList.remove(...t), i.emitContainerClasses());
}
var sw = {
  addClasses: iw,
  removeClasses: nw
};
function rw() {
  const i = this, {
    isLocked: e,
    params: t
  } = i, {
    slidesOffsetBefore: n
  } = t;
  if (n) {
    const s = i.slides.length - 1, r = i.slidesGrid[s] + i.slidesSizesGrid[s] + n * 2;
    i.isLocked = i.size > r;
  } else
    i.isLocked = i.snapGrid.length === 1;
  t.allowSlideNext === !0 && (i.allowSlideNext = !i.isLocked), t.allowSlidePrev === !0 && (i.allowSlidePrev = !i.isLocked), e && e !== i.isLocked && (i.isEnd = !1), e !== i.isLocked && i.emit(i.isLocked ? "lock" : "unlock");
}
var aw = {
  checkOverflow: rw
}, Xo = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function ow(i, e) {
  return function(n = {}) {
    const s = Object.keys(n)[0], r = n[s];
    if (typeof r != "object" || r === null) {
      Ft(e, n);
      return;
    }
    if (i[s] === !0 && (i[s] = {
      enabled: !0
    }), s === "navigation" && i[s] && i[s].enabled && !i[s].prevEl && !i[s].nextEl && (i[s].auto = !0), ["pagination", "scrollbar"].indexOf(s) >= 0 && i[s] && i[s].enabled && !i[s].el && (i[s].auto = !0), !(s in i && "enabled" in r)) {
      Ft(e, n);
      return;
    }
    typeof i[s] == "object" && !("enabled" in i[s]) && (i[s].enabled = !0), i[s] || (i[s] = {
      enabled: !1
    }), Ft(e, n);
  };
}
const ao = {
  eventsEmitter: sA,
  update: pA,
  translate: kA,
  transition: _A,
  slide: DA,
  loop: FA,
  grabCursor: UA,
  events: ZA,
  breakpoints: ew,
  checkOverflow: aw,
  classes: sw
}, oo = {};
let Wl = class _i {
  constructor(...e) {
    let t, n;
    e.length === 1 && e[0].constructor && Object.prototype.toString.call(e[0]).slice(8, -1) === "Object" ? n = e[0] : [t, n] = e, n || (n = {}), n = Ft({}, n), t && !n.el && (n.el = t);
    const s = pi();
    if (n.el && typeof n.el == "string" && s.querySelectorAll(n.el).length > 1) {
      const l = [];
      return s.querySelectorAll(n.el).forEach((d) => {
        const c = Ft({}, n, {
          el: d
        });
        l.push(new _i(c));
      }), l;
    }
    const r = this;
    r.__swiper__ = !0, r.support = Om(), r.device = Fm({
      userAgent: n.userAgent
    }), r.browser = $m(), r.eventsListeners = {}, r.eventsAnyListeners = [], r.modules = [...r.__modules__], n.modules && Array.isArray(n.modules) && r.modules.push(...n.modules);
    const a = {};
    r.modules.forEach((l) => {
      l({
        params: n,
        swiper: r,
        extendParams: ow(n, a),
        on: r.on.bind(r),
        once: r.once.bind(r),
        off: r.off.bind(r),
        emit: r.emit.bind(r)
      });
    });
    const o = Ft({}, Xo, a);
    return r.params = Ft({}, o, oo, n), r.originalParams = Ft({}, r.params), r.passedParams = Ft({}, n), r.params && r.params.on && Object.keys(r.params.on).forEach((l) => {
      r.on(l, r.params.on[l]);
    }), r.params && r.params.onAny && r.onAny(r.params.onAny), Object.assign(r, {
      enabled: r.params.enabled,
      el: t,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return r.params.direction === "horizontal";
      },
      isVertical() {
        return r.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: r.params.allowSlideNext,
      allowSlidePrev: r.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: r.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: r.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), r.emit("_swiper"), r.params.init && r.init(), r;
  }
  getDirectionLabel(e) {
    return this.isHorizontal() ? e : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[e];
  }
  getSlideIndex(e) {
    const {
      slidesEl: t,
      params: n
    } = this, s = mi(t, `.${n.slideClass}, swiper-slide`), r = jr(s[0]);
    return jr(e) - r;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.find((t) => t.getAttribute("data-swiper-slide-index") * 1 === e));
  }
  getSlideIndexWhenGrid(e) {
    return this.grid && this.params.grid && this.params.grid.rows > 1 && (this.params.grid.fill === "column" ? e = Math.floor(e / this.params.grid.rows) : this.params.grid.fill === "row" && (e = e % Math.ceil(this.slides.length / this.params.grid.rows))), e;
  }
  recalcSlides() {
    const e = this, {
      slidesEl: t,
      params: n
    } = e;
    e.slides = mi(t, `.${n.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, t) {
    const n = this;
    e = Math.min(Math.max(e, 0), 1);
    const s = n.minTranslate(), a = (n.maxTranslate() - s) * e + s;
    n.translateTo(a, typeof t > "u" ? 0 : t), n.updateActiveIndex(), n.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const t = e.el.className.split(" ").filter((n) => n.indexOf("swiper") === 0 || n.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", t.join(" "));
  }
  getSlideClasses(e) {
    const t = this;
    return t.destroyed ? "" : e.className.split(" ").filter((n) => n.indexOf("swiper-slide") === 0 || n.indexOf(t.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const t = [];
    e.slides.forEach((n) => {
      const s = e.getSlideClasses(n);
      t.push({
        slideEl: n,
        classNames: s
      }), e.emit("_slideClass", n, s);
    }), e.emit("_slideClasses", t);
  }
  slidesPerViewDynamic(e = "current", t = !1) {
    const n = this, {
      params: s,
      slides: r,
      slidesGrid: a,
      slidesSizesGrid: o,
      size: l,
      activeIndex: d
    } = n;
    let c = 1;
    if (typeof s.slidesPerView == "number") return s.slidesPerView;
    if (s.centeredSlides) {
      let u = r[d] ? Math.ceil(r[d].swiperSlideSize) : 0, f;
      for (let h = d + 1; h < r.length; h += 1)
        r[h] && !f && (u += Math.ceil(r[h].swiperSlideSize), c += 1, u > l && (f = !0));
      for (let h = d - 1; h >= 0; h -= 1)
        r[h] && !f && (u += r[h].swiperSlideSize, c += 1, u > l && (f = !0));
    } else if (e === "current")
      for (let u = d + 1; u < r.length; u += 1)
        (t ? a[u] + o[u] - a[d] < l : a[u] - a[d] < l) && (c += 1);
    else
      for (let u = d - 1; u >= 0; u -= 1)
        a[d] - a[u] < l && (c += 1);
    return c;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const {
      snapGrid: t,
      params: n
    } = e;
    n.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((a) => {
      a.complete && yr(e, a);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function s() {
      const a = e.rtlTranslate ? e.translate * -1 : e.translate, o = Math.min(Math.max(a, e.maxTranslate()), e.minTranslate());
      e.setTranslate(o), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let r;
    if (n.freeMode && n.freeMode.enabled && !n.cssMode)
      s(), n.autoHeight && e.updateAutoHeight();
    else {
      if ((n.slidesPerView === "auto" || n.slidesPerView > 1) && e.isEnd && !n.centeredSlides) {
        const a = e.virtual && n.virtual.enabled ? e.virtual.slides : e.slides;
        r = e.slideTo(a.length - 1, 0, !1, !0);
      } else
        r = e.slideTo(e.activeIndex, 0, !1, !0);
      r || s();
    }
    n.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, t = !0) {
    const n = this, s = n.params.direction;
    return e || (e = s === "horizontal" ? "vertical" : "horizontal"), e === s || e !== "horizontal" && e !== "vertical" || (n.el.classList.remove(`${n.params.containerModifierClass}${s}`), n.el.classList.add(`${n.params.containerModifierClass}${e}`), n.emitContainerClasses(), n.params.direction = e, n.slides.forEach((r) => {
      e === "vertical" ? r.style.width = "" : r.style.height = "";
    }), n.emit("changeDirection"), t && n.update()), n;
  }
  changeLanguageDirection(e) {
    const t = this;
    t.rtl && e === "rtl" || !t.rtl && e === "ltr" || (t.rtl = e === "rtl", t.rtlTranslate = t.params.direction === "horizontal" && t.rtl, t.rtl ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), t.el.dir = "rtl") : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), t.el.dir = "ltr"), t.update());
  }
  mount(e) {
    const t = this;
    if (t.mounted) return !0;
    let n = e || t.params.el;
    if (typeof n == "string" && (n = document.querySelector(n)), !n)
      return !1;
    n.swiper = t, n.parentNode && n.parentNode.host && n.parentNode.host.nodeName === t.params.swiperElementNodeName.toUpperCase() && (t.isElement = !0);
    const s = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let a = n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(s()) : mi(n, s())[0];
    return !a && t.params.createElements && (a = Ps("div", t.params.wrapperClass), n.append(a), mi(n, `.${t.params.slideClass}`).forEach((o) => {
      a.append(o);
    })), Object.assign(t, {
      el: n,
      wrapperEl: a,
      slidesEl: t.isElement && !n.parentNode.host.slideSlots ? n.parentNode.host : a,
      hostEl: t.isElement ? n.parentNode.host : n,
      mounted: !0,
      // RTL
      rtl: n.dir.toLowerCase() === "rtl" || Ki(n, "direction") === "rtl",
      rtlTranslate: t.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || Ki(n, "direction") === "rtl"),
      wrongRTL: Ki(a, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const t = this;
    if (t.initialized || t.mount(e) === !1) return t;
    t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.loop && t.virtual && t.params.virtual.enabled ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.params.loop && t.loopCreate(void 0, !0), t.attachEvents();
    const s = [...t.el.querySelectorAll('[loading="lazy"]')];
    return t.isElement && s.push(...t.hostEl.querySelectorAll('[loading="lazy"]')), s.forEach((r) => {
      r.complete ? yr(t, r) : r.addEventListener("load", (a) => {
        yr(t, a.target);
      });
    }), Yo(t), t.initialized = !0, Yo(t), t.emit("init"), t.emit("afterInit"), t;
  }
  destroy(e = !0, t = !0) {
    const n = this, {
      params: s,
      el: r,
      wrapperEl: a,
      slides: o
    } = n;
    return typeof n.params > "u" || n.destroyed || (n.emit("beforeDestroy"), n.initialized = !1, n.detachEvents(), s.loop && n.loopDestroy(), t && (n.removeClasses(), r && typeof r != "string" && r.removeAttribute("style"), a && a.removeAttribute("style"), o && o.length && o.forEach((l) => {
      l.classList.remove(s.slideVisibleClass, s.slideFullyVisibleClass, s.slideActiveClass, s.slideNextClass, s.slidePrevClass), l.removeAttribute("style"), l.removeAttribute("data-swiper-slide-index");
    })), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((l) => {
      n.off(l);
    }), e !== !1 && (n.el && typeof n.el != "string" && (n.el.swiper = null), H2(n)), n.destroyed = !0), null;
  }
  static extendDefaults(e) {
    Ft(oo, e);
  }
  static get extendedDefaults() {
    return oo;
  }
  static get defaults() {
    return Xo;
  }
  static installModule(e) {
    _i.prototype.__modules__ || (_i.prototype.__modules__ = []);
    const t = _i.prototype.__modules__;
    typeof e == "function" && t.indexOf(e) < 0 && t.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((t) => _i.installModule(t)), _i) : (_i.installModule(e), _i);
  }
};
Object.keys(ao).forEach((i) => {
  Object.keys(ao[i]).forEach((e) => {
    Wl.prototype[e] = ao[i][e];
  });
});
Wl.use([iA, nA]);
const Vm = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function Tn(i) {
  return typeof i == "object" && i !== null && i.constructor && Object.prototype.toString.call(i).slice(8, -1) === "Object" && !i.__swiper__;
}
function Hn(i, e) {
  const t = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((n) => t.indexOf(n) < 0).forEach((n) => {
    typeof i[n] > "u" ? i[n] = e[n] : Tn(e[n]) && Tn(i[n]) && Object.keys(e[n]).length > 0 ? e[n].__swiper__ ? i[n] = e[n] : Hn(i[n], e[n]) : i[n] = e[n];
  });
}
function Gm(i = {}) {
  return i.navigation && typeof i.navigation.nextEl > "u" && typeof i.navigation.prevEl > "u";
}
function Hm(i = {}) {
  return i.pagination && typeof i.pagination.el > "u";
}
function zm(i = {}) {
  return i.scrollbar && typeof i.scrollbar.el > "u";
}
function Km(i = "") {
  const e = i.split(" ").map((n) => n.trim()).filter((n) => !!n), t = [];
  return e.forEach((n) => {
    t.indexOf(n) < 0 && t.push(n);
  }), t.join(" ");
}
function lw(i = "") {
  return i ? i.includes("swiper-wrapper") ? i : `swiper-wrapper ${i}` : "swiper-wrapper";
}
function dw({
  swiper: i,
  slides: e,
  passedParams: t,
  changedParams: n,
  nextEl: s,
  prevEl: r,
  scrollbarEl: a,
  paginationEl: o
}) {
  const l = n.filter((E) => E !== "children" && E !== "direction" && E !== "wrapperClass"), {
    params: d,
    pagination: c,
    navigation: u,
    scrollbar: f,
    virtual: h,
    thumbs: m
  } = i;
  let g, v, p, y, b, k, T, I;
  n.includes("thumbs") && t.thumbs && t.thumbs.swiper && !t.thumbs.swiper.destroyed && d.thumbs && (!d.thumbs.swiper || d.thumbs.swiper.destroyed) && (g = !0), n.includes("controller") && t.controller && t.controller.control && d.controller && !d.controller.control && (v = !0), n.includes("pagination") && t.pagination && (t.pagination.el || o) && (d.pagination || d.pagination === !1) && c && !c.el && (p = !0), n.includes("scrollbar") && t.scrollbar && (t.scrollbar.el || a) && (d.scrollbar || d.scrollbar === !1) && f && !f.el && (y = !0), n.includes("navigation") && t.navigation && (t.navigation.prevEl || r) && (t.navigation.nextEl || s) && (d.navigation || d.navigation === !1) && u && !u.prevEl && !u.nextEl && (b = !0);
  const x = (E) => {
    i[E] && (i[E].destroy(), E === "navigation" ? (i.isElement && (i[E].prevEl.remove(), i[E].nextEl.remove()), d[E].prevEl = void 0, d[E].nextEl = void 0, i[E].prevEl = void 0, i[E].nextEl = void 0) : (i.isElement && i[E].el.remove(), d[E].el = void 0, i[E].el = void 0));
  };
  n.includes("loop") && i.isElement && (d.loop && !t.loop ? k = !0 : !d.loop && t.loop ? T = !0 : I = !0), l.forEach((E) => {
    if (Tn(d[E]) && Tn(t[E]))
      Object.assign(d[E], t[E]), (E === "navigation" || E === "pagination" || E === "scrollbar") && "enabled" in t[E] && !t[E].enabled && x(E);
    else {
      const R = t[E];
      (R === !0 || R === !1) && (E === "navigation" || E === "pagination" || E === "scrollbar") ? R === !1 && x(E) : d[E] = t[E];
    }
  }), l.includes("controller") && !v && i.controller && i.controller.control && d.controller && d.controller.control && (i.controller.control = d.controller.control), n.includes("children") && e && h && d.virtual.enabled ? (h.slides = e, h.update(!0)) : n.includes("virtual") && h && d.virtual.enabled && (e && (h.slides = e), h.update(!0)), n.includes("children") && e && d.loop && (I = !0), g && m.init() && m.update(!0), v && (i.controller.control = d.controller.control), p && (i.isElement && (!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-pagination"), o.part.add("pagination"), i.el.appendChild(o)), o && (d.pagination.el = o), c.init(), c.render(), c.update()), y && (i.isElement && (!a || typeof a == "string") && (a = document.createElement("div"), a.classList.add("swiper-scrollbar"), a.part.add("scrollbar"), i.el.appendChild(a)), a && (d.scrollbar.el = a), f.init(), f.updateSize(), f.setTranslate()), b && (i.isElement && ((!s || typeof s == "string") && (s = document.createElement("div"), s.classList.add("swiper-button-next"), Ds(s, i.hostEl.constructor.nextButtonSvg), s.part.add("button-next"), i.el.appendChild(s)), (!r || typeof r == "string") && (r = document.createElement("div"), r.classList.add("swiper-button-prev"), Ds(r, i.hostEl.constructor.prevButtonSvg), r.part.add("button-prev"), i.el.appendChild(r))), s && (d.navigation.nextEl = s), r && (d.navigation.prevEl = r), u.init(), u.update()), n.includes("allowSlideNext") && (i.allowSlideNext = t.allowSlideNext), n.includes("allowSlidePrev") && (i.allowSlidePrev = t.allowSlidePrev), n.includes("direction") && i.changeDirection(t.direction, !1), (k || I) && i.loopDestroy(), (T || I) && i.loopCreate(), i.update();
}
function Eu(i = {}, e = !0) {
  const t = {
    on: {}
  }, n = {}, s = {};
  Hn(t, Xo), t._emitClasses = !0, t.init = !1;
  const r = {}, a = Vm.map((l) => l.replace(/_/, "")), o = Object.assign({}, i);
  return Object.keys(o).forEach((l) => {
    typeof i[l] > "u" || (a.indexOf(l) >= 0 ? Tn(i[l]) ? (t[l] = {}, s[l] = {}, Hn(t[l], i[l]), Hn(s[l], i[l])) : (t[l] = i[l], s[l] = i[l]) : l.search(/on[A-Z]/) === 0 && typeof i[l] == "function" ? e ? n[`${l[2].toLowerCase()}${l.substr(3)}`] = i[l] : t.on[`${l[2].toLowerCase()}${l.substr(3)}`] = i[l] : r[l] = i[l]);
  }), ["navigation", "pagination", "scrollbar"].forEach((l) => {
    t[l] === !0 && (t[l] = {}), t[l] === !1 && delete t[l];
  }), {
    params: t,
    passedParams: s,
    rest: r,
    events: n
  };
}
function cw({
  el: i,
  nextEl: e,
  prevEl: t,
  paginationEl: n,
  scrollbarEl: s,
  swiper: r
}, a) {
  Gm(a) && e && t && (r.params.navigation.nextEl = e, r.originalParams.navigation.nextEl = e, r.params.navigation.prevEl = t, r.originalParams.navigation.prevEl = t), Hm(a) && n && (r.params.pagination.el = n, r.originalParams.pagination.el = n), zm(a) && s && (r.params.scrollbar.el = s, r.originalParams.scrollbar.el = s), r.init(i);
}
function uw(i, e, t, n, s) {
  const r = [];
  if (!e) return r;
  const a = (l) => {
    r.indexOf(l) < 0 && r.push(l);
  };
  if (t && n) {
    const l = n.map(s), d = t.map(s);
    l.join("") !== d.join("") && a("children"), n.length !== t.length && a("children");
  }
  return Vm.filter((l) => l[0] === "_").map((l) => l.replace(/_/, "")).forEach((l) => {
    if (l in i && l in e)
      if (Tn(i[l]) && Tn(e[l])) {
        const d = Object.keys(i[l]), c = Object.keys(e[l]);
        d.length !== c.length ? a(l) : (d.forEach((u) => {
          i[l][u] !== e[l][u] && a(l);
        }), c.forEach((u) => {
          i[l][u] !== e[l][u] && a(l);
        }));
      } else i[l] !== e[l] && a(l);
  }), r;
}
const fw = (i) => {
  !i || i.destroyed || !i.params.virtual || i.params.virtual && !i.params.virtual.enabled || (i.updateSlides(), i.updateProgress(), i.updateSlidesClasses(), i.emit("_virtualUpdated"), i.parallax && i.params.parallax && i.params.parallax.enabled && i.parallax.setTranslate());
};
function lo(i = {}, e, t) {
  const n = [], s = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  }, r = (a, o) => {
    Array.isArray(a) && a.forEach((l) => {
      const d = typeof l.type == "symbol";
      o === "default" && (o = "container-end"), d && l.children ? r(l.children, o) : l.type && (l.type.name === "SwiperSlide" || l.type.name === "AsyncComponentWrapper") || l.componentOptions && l.componentOptions.tag === "SwiperSlide" ? n.push(l) : s[o] && s[o].push(l);
    });
  };
  return Object.keys(i).forEach((a) => {
    if (typeof i[a] != "function") return;
    const o = i[a]();
    r(o, a);
  }), t.value = e.value, e.value = n, {
    slides: n,
    slots: s
  };
}
function hw(i, e, t) {
  if (!t) return null;
  const n = (c) => {
    let u = c;
    return c < 0 ? u = e.length + c : u >= e.length && (u = u - e.length), u;
  }, s = i.value.isHorizontal() ? {
    [i.value.rtlTranslate ? "right" : "left"]: `${t.offset}px`
  } : {
    top: `${t.offset}px`
  }, {
    from: r,
    to: a
  } = t, o = i.value.params.loop ? -e.length : 0, l = i.value.params.loop ? e.length * 2 : e.length, d = [];
  for (let c = o; c < l; c += 1)
    c >= r && c <= a && d.length < e.length && d.push(e[n(c)]);
  return d.map((c) => {
    if (c.props || (c.props = {}), c.props.style || (c.props.style = {}), c.props.swiperRef = i, c.props.style = s, c.type)
      return $t(c.type, {
        ...c.props
      }, c.children);
    if (c.componentOptions)
      return $t(c.componentOptions.Ctor, {
        ...c.props
      }, c.componentOptions.children);
  });
}
const mw = {
  name: "Swiper",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    wrapperTag: {
      type: String,
      default: "div"
    },
    modules: {
      type: Array,
      default: void 0
    },
    init: {
      type: Boolean,
      default: void 0
    },
    direction: {
      type: String,
      default: void 0
    },
    oneWayMovement: {
      type: Boolean,
      default: void 0
    },
    swiperElementNodeName: {
      type: String,
      default: "SWIPER-CONTAINER"
    },
    touchEventsTarget: {
      type: String,
      default: void 0
    },
    initialSlide: {
      type: Number,
      default: void 0
    },
    speed: {
      type: Number,
      default: void 0
    },
    cssMode: {
      type: Boolean,
      default: void 0
    },
    updateOnWindowResize: {
      type: Boolean,
      default: void 0
    },
    resizeObserver: {
      type: Boolean,
      default: void 0
    },
    nested: {
      type: Boolean,
      default: void 0
    },
    focusableElements: {
      type: String,
      default: void 0
    },
    width: {
      type: Number,
      default: void 0
    },
    height: {
      type: Number,
      default: void 0
    },
    preventInteractionOnTransition: {
      type: Boolean,
      default: void 0
    },
    userAgent: {
      type: String,
      default: void 0
    },
    url: {
      type: String,
      default: void 0
    },
    edgeSwipeDetection: {
      type: [Boolean, String],
      default: void 0
    },
    edgeSwipeThreshold: {
      type: Number,
      default: void 0
    },
    autoHeight: {
      type: Boolean,
      default: void 0
    },
    setWrapperSize: {
      type: Boolean,
      default: void 0
    },
    virtualTranslate: {
      type: Boolean,
      default: void 0
    },
    effect: {
      type: String,
      default: void 0
    },
    breakpoints: {
      type: Object,
      default: void 0
    },
    breakpointsBase: {
      type: String,
      default: void 0
    },
    spaceBetween: {
      type: [Number, String],
      default: void 0
    },
    slidesPerView: {
      type: [Number, String],
      default: void 0
    },
    maxBackfaceHiddenSlides: {
      type: Number,
      default: void 0
    },
    slidesPerGroup: {
      type: Number,
      default: void 0
    },
    slidesPerGroupSkip: {
      type: Number,
      default: void 0
    },
    slidesPerGroupAuto: {
      type: Boolean,
      default: void 0
    },
    centeredSlides: {
      type: Boolean,
      default: void 0
    },
    centeredSlidesBounds: {
      type: Boolean,
      default: void 0
    },
    slidesOffsetBefore: {
      type: Number,
      default: void 0
    },
    slidesOffsetAfter: {
      type: Number,
      default: void 0
    },
    normalizeSlideIndex: {
      type: Boolean,
      default: void 0
    },
    centerInsufficientSlides: {
      type: Boolean,
      default: void 0
    },
    watchOverflow: {
      type: Boolean,
      default: void 0
    },
    roundLengths: {
      type: Boolean,
      default: void 0
    },
    touchRatio: {
      type: Number,
      default: void 0
    },
    touchAngle: {
      type: Number,
      default: void 0
    },
    simulateTouch: {
      type: Boolean,
      default: void 0
    },
    shortSwipes: {
      type: Boolean,
      default: void 0
    },
    longSwipes: {
      type: Boolean,
      default: void 0
    },
    longSwipesRatio: {
      type: Number,
      default: void 0
    },
    longSwipesMs: {
      type: Number,
      default: void 0
    },
    followFinger: {
      type: Boolean,
      default: void 0
    },
    allowTouchMove: {
      type: Boolean,
      default: void 0
    },
    threshold: {
      type: Number,
      default: void 0
    },
    touchMoveStopPropagation: {
      type: Boolean,
      default: void 0
    },
    touchStartPreventDefault: {
      type: Boolean,
      default: void 0
    },
    touchStartForcePreventDefault: {
      type: Boolean,
      default: void 0
    },
    touchReleaseOnEdges: {
      type: Boolean,
      default: void 0
    },
    uniqueNavElements: {
      type: Boolean,
      default: void 0
    },
    resistance: {
      type: Boolean,
      default: void 0
    },
    resistanceRatio: {
      type: Number,
      default: void 0
    },
    watchSlidesProgress: {
      type: Boolean,
      default: void 0
    },
    grabCursor: {
      type: Boolean,
      default: void 0
    },
    preventClicks: {
      type: Boolean,
      default: void 0
    },
    preventClicksPropagation: {
      type: Boolean,
      default: void 0
    },
    slideToClickedSlide: {
      type: Boolean,
      default: void 0
    },
    loop: {
      type: Boolean,
      default: void 0
    },
    loopedSlides: {
      type: Number,
      default: void 0
    },
    loopPreventsSliding: {
      type: Boolean,
      default: void 0
    },
    loopAdditionalSlides: {
      type: Number,
      default: void 0
    },
    loopAddBlankSlides: {
      type: Boolean,
      default: void 0
    },
    rewind: {
      type: Boolean,
      default: void 0
    },
    allowSlidePrev: {
      type: Boolean,
      default: void 0
    },
    allowSlideNext: {
      type: Boolean,
      default: void 0
    },
    swipeHandler: {
      type: Boolean,
      default: void 0
    },
    noSwiping: {
      type: Boolean,
      default: void 0
    },
    noSwipingClass: {
      type: String,
      default: void 0
    },
    noSwipingSelector: {
      type: String,
      default: void 0
    },
    passiveListeners: {
      type: Boolean,
      default: void 0
    },
    containerModifierClass: {
      type: String,
      default: void 0
    },
    slideClass: {
      type: String,
      default: void 0
    },
    slideActiveClass: {
      type: String,
      default: void 0
    },
    slideVisibleClass: {
      type: String,
      default: void 0
    },
    slideFullyVisibleClass: {
      type: String,
      default: void 0
    },
    slideBlankClass: {
      type: String,
      default: void 0
    },
    slideNextClass: {
      type: String,
      default: void 0
    },
    slidePrevClass: {
      type: String,
      default: void 0
    },
    wrapperClass: {
      type: String,
      default: void 0
    },
    lazyPreloaderClass: {
      type: String,
      default: void 0
    },
    lazyPreloadPrevNext: {
      type: Number,
      default: void 0
    },
    runCallbacksOnInit: {
      type: Boolean,
      default: void 0
    },
    observer: {
      type: Boolean,
      default: void 0
    },
    observeParents: {
      type: Boolean,
      default: void 0
    },
    observeSlideChildren: {
      type: Boolean,
      default: void 0
    },
    a11y: {
      type: [Boolean, Object],
      default: void 0
    },
    autoplay: {
      type: [Boolean, Object],
      default: void 0
    },
    controller: {
      type: Object,
      default: void 0
    },
    coverflowEffect: {
      type: Object,
      default: void 0
    },
    cubeEffect: {
      type: Object,
      default: void 0
    },
    fadeEffect: {
      type: Object,
      default: void 0
    },
    flipEffect: {
      type: Object,
      default: void 0
    },
    creativeEffect: {
      type: Object,
      default: void 0
    },
    cardsEffect: {
      type: Object,
      default: void 0
    },
    hashNavigation: {
      type: [Boolean, Object],
      default: void 0
    },
    history: {
      type: [Boolean, Object],
      default: void 0
    },
    keyboard: {
      type: [Boolean, Object],
      default: void 0
    },
    mousewheel: {
      type: [Boolean, Object],
      default: void 0
    },
    navigation: {
      type: [Boolean, Object],
      default: void 0
    },
    pagination: {
      type: [Boolean, Object],
      default: void 0
    },
    parallax: {
      type: [Boolean, Object],
      default: void 0
    },
    scrollbar: {
      type: [Boolean, Object],
      default: void 0
    },
    thumbs: {
      type: Object,
      default: void 0
    },
    virtual: {
      type: [Boolean, Object],
      default: void 0
    },
    zoom: {
      type: [Boolean, Object],
      default: void 0
    },
    grid: {
      type: [Object],
      default: void 0
    },
    freeMode: {
      type: [Boolean, Object],
      default: void 0
    },
    enabled: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["_beforeBreakpoint", "_containerClasses", "_slideClass", "_slideClasses", "_swiper", "_freeModeNoMomentumRelease", "_virtualUpdated", "activeIndexChange", "afterInit", "autoplay", "autoplayStart", "autoplayStop", "autoplayPause", "autoplayResume", "autoplayTimeLeft", "beforeDestroy", "beforeInit", "beforeLoopFix", "beforeResize", "beforeSlideChangeStart", "beforeTransitionStart", "breakpoint", "changeDirection", "click", "disable", "doubleTap", "doubleClick", "destroy", "enable", "fromEdge", "hashChange", "hashSet", "init", "keyPress", "lock", "loopFix", "momentumBounce", "navigationHide", "navigationShow", "navigationPrev", "navigationNext", "observerUpdate", "orientationchange", "paginationHide", "paginationRender", "paginationShow", "paginationUpdate", "progress", "reachBeginning", "reachEnd", "realIndexChange", "resize", "scroll", "scrollbarDragEnd", "scrollbarDragMove", "scrollbarDragStart", "setTransition", "setTranslate", "slidesUpdated", "slideChange", "slideChangeTransitionEnd", "slideChangeTransitionStart", "slideNextTransitionEnd", "slideNextTransitionStart", "slidePrevTransitionEnd", "slidePrevTransitionStart", "slideResetTransitionStart", "slideResetTransitionEnd", "sliderMove", "sliderFirstMove", "slidesLengthChange", "slidesGridLengthChange", "snapGridLengthChange", "snapIndexChange", "swiper", "tap", "toEdge", "touchEnd", "touchMove", "touchMoveOpposite", "touchStart", "transitionEnd", "transitionStart", "unlock", "update", "virtualUpdate", "zoomChange"],
  setup(i, {
    slots: e,
    emit: t
  }) {
    const {
      tag: n,
      wrapperTag: s
    } = i, r = ge("swiper"), a = ge(null), o = ge(!1), l = ge(!1), d = ge(null), c = ge(null), u = ge(null), f = {
      value: []
    }, h = {
      value: []
    }, m = ge(null), g = ge(null), v = ge(null), p = ge(null), {
      params: y,
      passedParams: b
    } = Eu(i, !1);
    lo(e, f, h), u.value = b, h.value = f.value;
    const k = () => {
      lo(e, f, h), o.value = !0;
    };
    y.onAny = (x, ...E) => {
      t(x, ...E);
    }, Object.assign(y.on, {
      _beforeBreakpoint: k,
      _containerClasses(x, E) {
        r.value = E;
      }
    });
    const T = {
      ...y
    };
    if (delete T.wrapperClass, c.value = new Wl(T), c.value.virtual && c.value.params.virtual.enabled) {
      c.value.virtual.slides = f.value;
      const x = {
        cache: !1,
        slides: f.value,
        renderExternal: (E) => {
          a.value = E;
        },
        renderExternalUpdate: !1
      };
      Hn(c.value.params.virtual, x), Hn(c.value.originalParams.virtual, x);
    }
    df(() => {
      !l.value && c.value && (c.value.emitSlidesClasses(), l.value = !0);
      const {
        passedParams: x
      } = Eu(i, !1), E = uw(x, u.value, f.value, h.value, (R) => R.props && R.props.key);
      u.value = x, (E.length || o.value) && c.value && !c.value.destroyed && dw({
        swiper: c.value,
        slides: f.value,
        passedParams: x,
        changedParams: E,
        nextEl: m.value,
        prevEl: g.value,
        scrollbarEl: p.value,
        paginationEl: v.value
      }), o.value = !1;
    }), hf("swiper", c), Dt(a, () => {
      Gt(() => {
        fw(c.value);
      });
    }), wt(() => {
      d.value && (cw({
        el: d.value,
        nextEl: m.value,
        prevEl: g.value,
        paginationEl: v.value,
        scrollbarEl: p.value,
        swiper: c.value
      }, y), t("swiper", c.value));
    }), Fs(() => {
      c.value && !c.value.destroyed && c.value.destroy(!0, !1);
    });
    function I(x) {
      return y.virtual ? hw(c, x, a.value) : (x.forEach((E, R) => {
        E.props || (E.props = {}), E.props.swiperRef = c, E.props.swiperSlideIndex = R;
      }), x);
    }
    return () => {
      const {
        slides: x,
        slots: E
      } = lo(e, f, h);
      return $t(n, {
        ref: d,
        class: Km(r.value)
      }, [E["container-start"], $t(s, {
        class: lw(y.wrapperClass)
      }, [E["wrapper-start"], I(x), E["wrapper-end"]]), Gm(i) && [$t("div", {
        ref: g,
        class: "swiper-button-prev"
      }), $t("div", {
        ref: m,
        class: "swiper-button-next"
      })], zm(i) && $t("div", {
        ref: p,
        class: "swiper-scrollbar"
      }), Hm(i) && $t("div", {
        ref: v,
        class: "swiper-pagination"
      }), E["container-end"]]);
    };
  }
}, pw = {
  name: "SwiperSlide",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    swiperRef: {
      type: Object,
      required: !1
    },
    swiperSlideIndex: {
      type: Number,
      default: void 0,
      required: !1
    },
    zoom: {
      type: Boolean,
      default: void 0,
      required: !1
    },
    lazy: {
      type: Boolean,
      default: !1,
      required: !1
    },
    virtualIndex: {
      type: [String, Number],
      default: void 0
    }
  },
  setup(i, {
    slots: e
  }) {
    let t = !1;
    const {
      swiperRef: n
    } = i, s = ge(null), r = ge("swiper-slide"), a = ge(!1);
    function o(c, u, f) {
      u === s.value && (r.value = f);
    }
    wt(() => {
      !n || !n.value || (n.value.on("_slideClass", o), t = !0);
    }), lf(() => {
      t || !n || !n.value || (n.value.on("_slideClass", o), t = !0);
    }), df(() => {
      !s.value || !n || !n.value || (typeof i.swiperSlideIndex < "u" && (s.value.swiperSlideIndex = i.swiperSlideIndex), n.value.destroyed && r.value !== "swiper-slide" && (r.value = "swiper-slide"));
    }), Fs(() => {
      !n || !n.value || n.value.off("_slideClass", o);
    });
    const l = le(() => ({
      isActive: r.value.indexOf("swiper-slide-active") >= 0,
      isVisible: r.value.indexOf("swiper-slide-visible") >= 0,
      isPrev: r.value.indexOf("swiper-slide-prev") >= 0,
      isNext: r.value.indexOf("swiper-slide-next") >= 0
    }));
    hf("swiperSlide", l);
    const d = () => {
      a.value = !0;
    };
    return () => $t(i.tag, {
      class: Km(`${r.value}`),
      ref: s,
      "data-swiper-slide-index": typeof i.virtualIndex > "u" && n && n.value && n.value.params.loop ? i.swiperSlideIndex : i.virtualIndex,
      onLoadCapture: d
    }, i.zoom ? $t("div", {
      class: "swiper-zoom-container",
      "data-swiper-zoom": typeof i.zoom == "number" ? i.zoom : void 0
    }, [e.default && e.default(l.value), i.lazy && !a.value && $t("div", {
      class: "swiper-lazy-preloader"
    })]) : [e.default && e.default(l.value), i.lazy && !a.value && $t("div", {
      class: "swiper-lazy-preloader"
    })]);
  }
};
function jm(i, e, t, n) {
  return i.params.createElements && Object.keys(n).forEach((s) => {
    if (!t[s] && t.auto === !0) {
      let r = mi(i.el, `.${n[s]}`)[0];
      r || (r = Ps("div", n[s]), r.className = n[s], i.el.append(r)), t[s] = r, e[s] = r;
    }
  }), t;
}
const gw = '<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>';
function vw({
  swiper: i,
  extendParams: e,
  on: t,
  emit: n
}) {
  e({
    navigation: {
      nextEl: null,
      prevEl: null,
      addIcons: !0,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), i.navigation = {
    nextEl: null,
    prevEl: null
  };
  function s(h) {
    let m;
    return h && typeof h == "string" && i.isElement && (m = i.el.querySelector(h) || i.hostEl.querySelector(h), m) ? m : (h && (typeof h == "string" && (m = [...document.querySelectorAll(h)]), i.params.uniqueNavElements && typeof h == "string" && m && m.length > 1 && i.el.querySelectorAll(h).length === 1 ? m = i.el.querySelector(h) : m && m.length === 1 && (m = m[0])), h && !m ? h : m);
  }
  function r(h, m) {
    const g = i.params.navigation;
    h = ut(h), h.forEach((v) => {
      v && (v.classList[m ? "add" : "remove"](...g.disabledClass.split(" ")), v.tagName === "BUTTON" && (v.disabled = m), i.params.watchOverflow && i.enabled && v.classList[i.isLocked ? "add" : "remove"](g.lockClass));
    });
  }
  function a() {
    const {
      nextEl: h,
      prevEl: m
    } = i.navigation;
    if (i.params.loop) {
      r(m, !1), r(h, !1);
      return;
    }
    r(m, i.isBeginning && !i.params.rewind), r(h, i.isEnd && !i.params.rewind);
  }
  function o(h) {
    h.preventDefault(), !(i.isBeginning && !i.params.loop && !i.params.rewind) && (i.slidePrev(), n("navigationPrev"));
  }
  function l(h) {
    h.preventDefault(), !(i.isEnd && !i.params.loop && !i.params.rewind) && (i.slideNext(), n("navigationNext"));
  }
  function d() {
    const h = i.params.navigation;
    if (i.params.navigation = jm(i, i.originalParams.navigation, i.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(h.nextEl || h.prevEl)) return;
    let m = s(h.nextEl), g = s(h.prevEl);
    Object.assign(i.navigation, {
      nextEl: m,
      prevEl: g
    }), m = ut(m), g = ut(g);
    const v = (p, y) => {
      if (p) {
        if (h.addIcons && p.matches(".swiper-button-next,.swiper-button-prev") && !p.querySelector("svg")) {
          const b = document.createElement("div");
          Ds(b, gw), p.appendChild(b.querySelector("svg")), b.remove();
        }
        p.addEventListener("click", y === "next" ? l : o);
      }
      !i.enabled && p && p.classList.add(...h.lockClass.split(" "));
    };
    m.forEach((p) => v(p, "next")), g.forEach((p) => v(p, "prev"));
  }
  function c() {
    let {
      nextEl: h,
      prevEl: m
    } = i.navigation;
    h = ut(h), m = ut(m);
    const g = (v, p) => {
      v.removeEventListener("click", p === "next" ? l : o), v.classList.remove(...i.params.navigation.disabledClass.split(" "));
    };
    h.forEach((v) => g(v, "next")), m.forEach((v) => g(v, "prev"));
  }
  t("init", () => {
    i.params.navigation.enabled === !1 ? f() : (d(), a());
  }), t("toEdge fromEdge lock unlock", () => {
    a();
  }), t("destroy", () => {
    c();
  }), t("enable disable", () => {
    let {
      nextEl: h,
      prevEl: m
    } = i.navigation;
    if (h = ut(h), m = ut(m), i.enabled) {
      a();
      return;
    }
    [...h, ...m].filter((g) => !!g).forEach((g) => g.classList.add(i.params.navigation.lockClass));
  }), t("click", (h, m) => {
    let {
      nextEl: g,
      prevEl: v
    } = i.navigation;
    g = ut(g), v = ut(v);
    const p = m.target;
    let y = v.includes(p) || g.includes(p);
    if (i.isElement && !y) {
      const b = m.path || m.composedPath && m.composedPath();
      b && (y = b.find((k) => g.includes(k) || v.includes(k)));
    }
    if (i.params.navigation.hideOnClick && !y) {
      if (i.pagination && i.params.pagination && i.params.pagination.clickable && (i.pagination.el === p || i.pagination.el.contains(p))) return;
      let b;
      g.length ? b = g[0].classList.contains(i.params.navigation.hiddenClass) : v.length && (b = v[0].classList.contains(i.params.navigation.hiddenClass)), n(b === !0 ? "navigationShow" : "navigationHide"), [...g, ...v].filter((k) => !!k).forEach((k) => k.classList.toggle(i.params.navigation.hiddenClass));
    }
  });
  const u = () => {
    i.el.classList.remove(...i.params.navigation.navigationDisabledClass.split(" ")), d(), a();
  }, f = () => {
    i.el.classList.add(...i.params.navigation.navigationDisabledClass.split(" ")), c();
  };
  Object.assign(i.navigation, {
    enable: u,
    disable: f,
    update: a,
    init: d,
    destroy: c
  });
}
function ts(i = "") {
  return `.${i.trim().replace(/([\.:!+\/()[\]])/g, "\\$1").replace(/ /g, ".")}`;
}
function yw({
  swiper: i,
  extendParams: e,
  on: t,
  emit: n
}) {
  const s = "swiper-pagination";
  e({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (p) => p,
      formatFractionTotal: (p) => p,
      bulletClass: `${s}-bullet`,
      bulletActiveClass: `${s}-bullet-active`,
      modifierClass: `${s}-`,
      currentClass: `${s}-current`,
      totalClass: `${s}-total`,
      hiddenClass: `${s}-hidden`,
      progressbarFillClass: `${s}-progressbar-fill`,
      progressbarOppositeClass: `${s}-progressbar-opposite`,
      clickableClass: `${s}-clickable`,
      lockClass: `${s}-lock`,
      horizontalClass: `${s}-horizontal`,
      verticalClass: `${s}-vertical`,
      paginationDisabledClass: `${s}-disabled`
    }
  }), i.pagination = {
    el: null,
    bullets: []
  };
  let r, a = 0;
  function o() {
    return !i.params.pagination.el || !i.pagination.el || Array.isArray(i.pagination.el) && i.pagination.el.length === 0;
  }
  function l(p, y) {
    const {
      bulletActiveClass: b
    } = i.params.pagination;
    p && (p = p[`${y === "prev" ? "previous" : "next"}ElementSibling`], p && (p.classList.add(`${b}-${y}`), p = p[`${y === "prev" ? "previous" : "next"}ElementSibling`], p && p.classList.add(`${b}-${y}-${y}`)));
  }
  function d(p, y, b) {
    if (p = p % b, y = y % b, y === p + 1)
      return "next";
    if (y === p - 1)
      return "previous";
  }
  function c(p) {
    const y = p.target.closest(ts(i.params.pagination.bulletClass));
    if (!y)
      return;
    p.preventDefault();
    const b = jr(y) * i.params.slidesPerGroup;
    if (i.params.loop) {
      if (i.realIndex === b) return;
      const k = d(i.realIndex, b, i.slides.length);
      k === "next" ? i.slideNext() : k === "previous" ? i.slidePrev() : i.slideToLoop(b);
    } else
      i.slideTo(b);
  }
  function u() {
    const p = i.rtl, y = i.params.pagination;
    if (o()) return;
    let b = i.pagination.el;
    b = ut(b);
    let k, T;
    const I = i.virtual && i.params.virtual.enabled ? i.virtual.slides.length : i.slides.length, x = i.params.loop ? Math.ceil(I / i.params.slidesPerGroup) : i.snapGrid.length;
    if (i.params.loop ? (T = i.previousRealIndex || 0, k = i.params.slidesPerGroup > 1 ? Math.floor(i.realIndex / i.params.slidesPerGroup) : i.realIndex) : typeof i.snapIndex < "u" ? (k = i.snapIndex, T = i.previousSnapIndex) : (T = i.previousIndex || 0, k = i.activeIndex || 0), y.type === "bullets" && i.pagination.bullets && i.pagination.bullets.length > 0) {
      const E = i.pagination.bullets;
      let R, A, _;
      if (y.dynamicBullets && (r = qo(E[0], i.isHorizontal() ? "width" : "height"), b.forEach((C) => {
        C.style[i.isHorizontal() ? "width" : "height"] = `${r * (y.dynamicMainBullets + 4)}px`;
      }), y.dynamicMainBullets > 1 && T !== void 0 && (a += k - (T || 0), a > y.dynamicMainBullets - 1 ? a = y.dynamicMainBullets - 1 : a < 0 && (a = 0)), R = Math.max(k - a, 0), A = R + (Math.min(E.length, y.dynamicMainBullets) - 1), _ = (A + R) / 2), E.forEach((C) => {
        const O = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((V) => `${y.bulletActiveClass}${V}`)].map((V) => typeof V == "string" && V.includes(" ") ? V.split(" ") : V).flat();
        C.classList.remove(...O);
      }), b.length > 1)
        E.forEach((C) => {
          const O = jr(C);
          O === k ? C.classList.add(...y.bulletActiveClass.split(" ")) : i.isElement && C.setAttribute("part", "bullet"), y.dynamicBullets && (O >= R && O <= A && C.classList.add(...`${y.bulletActiveClass}-main`.split(" ")), O === R && l(C, "prev"), O === A && l(C, "next"));
        });
      else {
        const C = E[k];
        if (C && C.classList.add(...y.bulletActiveClass.split(" ")), i.isElement && E.forEach((O, V) => {
          O.setAttribute("part", V === k ? "bullet-active" : "bullet");
        }), y.dynamicBullets) {
          const O = E[R], V = E[A];
          for (let j = R; j <= A; j += 1)
            E[j] && E[j].classList.add(...`${y.bulletActiveClass}-main`.split(" "));
          l(O, "prev"), l(V, "next");
        }
      }
      if (y.dynamicBullets) {
        const C = Math.min(E.length, y.dynamicMainBullets + 4), O = (r * C - r) / 2 - _ * r, V = p ? "right" : "left";
        E.forEach((j) => {
          j.style[i.isHorizontal() ? V : "top"] = `${O}px`;
        });
      }
    }
    b.forEach((E, R) => {
      if (y.type === "fraction" && (E.querySelectorAll(ts(y.currentClass)).forEach((A) => {
        A.textContent = y.formatFractionCurrent(k + 1);
      }), E.querySelectorAll(ts(y.totalClass)).forEach((A) => {
        A.textContent = y.formatFractionTotal(x);
      })), y.type === "progressbar") {
        let A;
        y.progressbarOpposite ? A = i.isHorizontal() ? "vertical" : "horizontal" : A = i.isHorizontal() ? "horizontal" : "vertical";
        const _ = (k + 1) / x;
        let C = 1, O = 1;
        A === "horizontal" ? C = _ : O = _, E.querySelectorAll(ts(y.progressbarFillClass)).forEach((V) => {
          V.style.transform = `translate3d(0,0,0) scaleX(${C}) scaleY(${O})`, V.style.transitionDuration = `${i.params.speed}ms`;
        });
      }
      y.type === "custom" && y.renderCustom ? (Ds(E, y.renderCustom(i, k + 1, x)), R === 0 && n("paginationRender", E)) : (R === 0 && n("paginationRender", E), n("paginationUpdate", E)), i.params.watchOverflow && i.enabled && E.classList[i.isLocked ? "add" : "remove"](y.lockClass);
    });
  }
  function f() {
    const p = i.params.pagination;
    if (o()) return;
    const y = i.virtual && i.params.virtual.enabled ? i.virtual.slides.length : i.grid && i.params.grid.rows > 1 ? i.slides.length / Math.ceil(i.params.grid.rows) : i.slides.length;
    let b = i.pagination.el;
    b = ut(b);
    let k = "";
    if (p.type === "bullets") {
      let T = i.params.loop ? Math.ceil(y / i.params.slidesPerGroup) : i.snapGrid.length;
      i.params.freeMode && i.params.freeMode.enabled && T > y && (T = y);
      for (let I = 0; I < T; I += 1)
        p.renderBullet ? k += p.renderBullet.call(i, I, p.bulletClass) : k += `<${p.bulletElement} ${i.isElement ? 'part="bullet"' : ""} class="${p.bulletClass}"></${p.bulletElement}>`;
    }
    p.type === "fraction" && (p.renderFraction ? k = p.renderFraction.call(i, p.currentClass, p.totalClass) : k = `<span class="${p.currentClass}"></span> / <span class="${p.totalClass}"></span>`), p.type === "progressbar" && (p.renderProgressbar ? k = p.renderProgressbar.call(i, p.progressbarFillClass) : k = `<span class="${p.progressbarFillClass}"></span>`), i.pagination.bullets = [], b.forEach((T) => {
      p.type !== "custom" && Ds(T, k || ""), p.type === "bullets" && i.pagination.bullets.push(...T.querySelectorAll(ts(p.bulletClass)));
    }), p.type !== "custom" && n("paginationRender", b[0]);
  }
  function h() {
    i.params.pagination = jm(i, i.originalParams.pagination, i.params.pagination, {
      el: "swiper-pagination"
    });
    const p = i.params.pagination;
    if (!p.el) return;
    let y;
    typeof p.el == "string" && i.isElement && (y = i.el.querySelector(p.el)), !y && typeof p.el == "string" && (y = [...document.querySelectorAll(p.el)]), y || (y = p.el), !(!y || y.length === 0) && (i.params.uniqueNavElements && typeof p.el == "string" && Array.isArray(y) && y.length > 1 && (y = [...i.el.querySelectorAll(p.el)], y.length > 1 && (y = y.find((b) => Mm(b, ".swiper")[0] === i.el))), Array.isArray(y) && y.length === 1 && (y = y[0]), Object.assign(i.pagination, {
      el: y
    }), y = ut(y), y.forEach((b) => {
      p.type === "bullets" && p.clickable && b.classList.add(...(p.clickableClass || "").split(" ")), b.classList.add(p.modifierClass + p.type), b.classList.add(i.isHorizontal() ? p.horizontalClass : p.verticalClass), p.type === "bullets" && p.dynamicBullets && (b.classList.add(`${p.modifierClass}${p.type}-dynamic`), a = 0, p.dynamicMainBullets < 1 && (p.dynamicMainBullets = 1)), p.type === "progressbar" && p.progressbarOpposite && b.classList.add(p.progressbarOppositeClass), p.clickable && b.addEventListener("click", c), i.enabled || b.classList.add(p.lockClass);
    }));
  }
  function m() {
    const p = i.params.pagination;
    if (o()) return;
    let y = i.pagination.el;
    y && (y = ut(y), y.forEach((b) => {
      b.classList.remove(p.hiddenClass), b.classList.remove(p.modifierClass + p.type), b.classList.remove(i.isHorizontal() ? p.horizontalClass : p.verticalClass), p.clickable && (b.classList.remove(...(p.clickableClass || "").split(" ")), b.removeEventListener("click", c));
    })), i.pagination.bullets && i.pagination.bullets.forEach((b) => b.classList.remove(...p.bulletActiveClass.split(" ")));
  }
  t("changeDirection", () => {
    if (!i.pagination || !i.pagination.el) return;
    const p = i.params.pagination;
    let {
      el: y
    } = i.pagination;
    y = ut(y), y.forEach((b) => {
      b.classList.remove(p.horizontalClass, p.verticalClass), b.classList.add(i.isHorizontal() ? p.horizontalClass : p.verticalClass);
    });
  }), t("init", () => {
    i.params.pagination.enabled === !1 ? v() : (h(), f(), u());
  }), t("activeIndexChange", () => {
    typeof i.snapIndex > "u" && u();
  }), t("snapIndexChange", () => {
    u();
  }), t("snapGridLengthChange", () => {
    f(), u();
  }), t("destroy", () => {
    m();
  }), t("enable disable", () => {
    let {
      el: p
    } = i.pagination;
    p && (p = ut(p), p.forEach((y) => y.classList[i.enabled ? "remove" : "add"](i.params.pagination.lockClass)));
  }), t("lock unlock", () => {
    u();
  }), t("click", (p, y) => {
    const b = y.target, k = ut(i.pagination.el);
    if (i.params.pagination.el && i.params.pagination.hideOnClick && k && k.length > 0 && !b.classList.contains(i.params.pagination.bulletClass)) {
      if (i.navigation && (i.navigation.nextEl && b === i.navigation.nextEl || i.navigation.prevEl && b === i.navigation.prevEl)) return;
      const T = k[0].classList.contains(i.params.pagination.hiddenClass);
      n(T === !0 ? "paginationShow" : "paginationHide"), k.forEach((I) => I.classList.toggle(i.params.pagination.hiddenClass));
    }
  });
  const g = () => {
    i.el.classList.remove(i.params.pagination.paginationDisabledClass);
    let {
      el: p
    } = i.pagination;
    p && (p = ut(p), p.forEach((y) => y.classList.remove(i.params.pagination.paginationDisabledClass))), h(), f(), u();
  }, v = () => {
    i.el.classList.add(i.params.pagination.paginationDisabledClass);
    let {
      el: p
    } = i.pagination;
    p && (p = ut(p), p.forEach((y) => y.classList.add(i.params.pagination.paginationDisabledClass))), m();
  };
  Object.assign(i.pagination, {
    enable: g,
    disable: v,
    render: f,
    update: u,
    init: h,
    destroy: m
  });
}
function bw({
  swiper: i,
  extendParams: e,
  on: t,
  emit: n,
  params: s
}) {
  i.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, e({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !1,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let r, a, o = s && s.autoplay ? s.autoplay.delay : 3e3, l = s && s.autoplay ? s.autoplay.delay : 3e3, d, c = (/* @__PURE__ */ new Date()).getTime(), u, f, h, m, g, v, p;
  function y(q) {
    !i || i.destroyed || !i.wrapperEl || q.target === i.wrapperEl && (i.wrapperEl.removeEventListener("transitionend", y), !(p || q.detail && q.detail.bySwiperTouchMove) && R());
  }
  const b = () => {
    if (i.destroyed || !i.autoplay.running) return;
    i.autoplay.paused ? u = !0 : u && (l = d, u = !1);
    const q = i.autoplay.paused ? d : c + l - (/* @__PURE__ */ new Date()).getTime();
    i.autoplay.timeLeft = q, n("autoplayTimeLeft", q, q / o), a = requestAnimationFrame(() => {
      b();
    });
  }, k = () => {
    let q;
    return i.virtual && i.params.virtual.enabled ? q = i.slides.find((Q) => Q.classList.contains("swiper-slide-active")) : q = i.slides[i.activeIndex], q ? parseInt(q.getAttribute("data-swiper-autoplay"), 10) : void 0;
  }, T = (q) => {
    if (i.destroyed || !i.autoplay.running) return;
    cancelAnimationFrame(a), b();
    let z = typeof q > "u" ? i.params.autoplay.delay : q;
    o = i.params.autoplay.delay, l = i.params.autoplay.delay;
    const Q = k();
    !Number.isNaN(Q) && Q > 0 && typeof q > "u" && (z = Q, o = Q, l = Q), d = z;
    const oe = i.params.speed, Z = () => {
      !i || i.destroyed || (i.params.autoplay.reverseDirection ? !i.isBeginning || i.params.loop || i.params.rewind ? (i.slidePrev(oe, !0, !0), n("autoplay")) : i.params.autoplay.stopOnLastSlide || (i.slideTo(i.slides.length - 1, oe, !0, !0), n("autoplay")) : !i.isEnd || i.params.loop || i.params.rewind ? (i.slideNext(oe, !0, !0), n("autoplay")) : i.params.autoplay.stopOnLastSlide || (i.slideTo(0, oe, !0, !0), n("autoplay")), i.params.cssMode && (c = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
        T();
      })));
    };
    return z > 0 ? (clearTimeout(r), r = setTimeout(() => {
      Z();
    }, z)) : requestAnimationFrame(() => {
      Z();
    }), z;
  }, I = () => {
    c = (/* @__PURE__ */ new Date()).getTime(), i.autoplay.running = !0, T(), n("autoplayStart");
  }, x = () => {
    i.autoplay.running = !1, clearTimeout(r), cancelAnimationFrame(a), n("autoplayStop");
  }, E = (q, z) => {
    if (i.destroyed || !i.autoplay.running) return;
    clearTimeout(r), q || (v = !0);
    const Q = () => {
      n("autoplayPause"), i.params.autoplay.waitForTransition ? i.wrapperEl.addEventListener("transitionend", y) : R();
    };
    if (i.autoplay.paused = !0, z) {
      g && (d = i.params.autoplay.delay), g = !1, Q();
      return;
    }
    d = (d || i.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - c), !(i.isEnd && d < 0 && !i.params.loop) && (d < 0 && (d = 0), Q());
  }, R = () => {
    i.isEnd && d < 0 && !i.params.loop || i.destroyed || !i.autoplay.running || (c = (/* @__PURE__ */ new Date()).getTime(), v ? (v = !1, T(d)) : T(), i.autoplay.paused = !1, n("autoplayResume"));
  }, A = () => {
    if (i.destroyed || !i.autoplay.running) return;
    const q = pi();
    q.visibilityState === "hidden" && (v = !0, E(!0)), q.visibilityState === "visible" && R();
  }, _ = (q) => {
    q.pointerType === "mouse" && (v = !0, p = !0, !(i.animating || i.autoplay.paused) && E(!0));
  }, C = (q) => {
    q.pointerType === "mouse" && (p = !1, i.autoplay.paused && R());
  }, O = () => {
    i.params.autoplay.pauseOnMouseEnter && (i.el.addEventListener("pointerenter", _), i.el.addEventListener("pointerleave", C));
  }, V = () => {
    i.el && typeof i.el != "string" && (i.el.removeEventListener("pointerenter", _), i.el.removeEventListener("pointerleave", C));
  }, j = () => {
    pi().addEventListener("visibilitychange", A);
  }, X = () => {
    pi().removeEventListener("visibilitychange", A);
  };
  t("init", () => {
    i.params.autoplay.enabled && (O(), j(), I());
  }), t("destroy", () => {
    V(), X(), i.autoplay.running && x();
  }), t("_freeModeStaticRelease", () => {
    (h || v) && R();
  }), t("_freeModeNoMomentumRelease", () => {
    i.params.autoplay.disableOnInteraction ? x() : E(!0, !0);
  }), t("beforeTransitionStart", (q, z, Q) => {
    i.destroyed || !i.autoplay.running || (Q || !i.params.autoplay.disableOnInteraction ? E(!0, !0) : x());
  }), t("sliderFirstMove", () => {
    if (!(i.destroyed || !i.autoplay.running)) {
      if (i.params.autoplay.disableOnInteraction) {
        x();
        return;
      }
      f = !0, h = !1, v = !1, m = setTimeout(() => {
        v = !0, h = !0, E(!0);
      }, 200);
    }
  }), t("touchEnd", () => {
    if (!(i.destroyed || !i.autoplay.running || !f)) {
      if (clearTimeout(m), clearTimeout(r), i.params.autoplay.disableOnInteraction) {
        h = !1, f = !1;
        return;
      }
      h && i.params.cssMode && R(), h = !1, f = !1;
    }
  }), t("slideChange", () => {
    i.destroyed || !i.autoplay.running || (g = !0);
  }), Object.assign(i.autoplay, {
    start: I,
    stop: x,
    pause: E,
    resume: R
  });
}
function Wm(i) {
  const {
    effect: e,
    swiper: t,
    on: n,
    setTranslate: s,
    setTransition: r,
    overwriteParams: a,
    perspective: o,
    recreateShadows: l,
    getEffectParams: d
  } = i;
  n("beforeInit", () => {
    if (t.params.effect !== e) return;
    t.classNames.push(`${t.params.containerModifierClass}${e}`), o && o() && t.classNames.push(`${t.params.containerModifierClass}3d`);
    const u = a ? a() : {};
    Object.assign(t.params, u), Object.assign(t.originalParams, u);
  }), n("setTranslate _virtualUpdated", () => {
    t.params.effect === e && s();
  }), n("setTransition", (u, f) => {
    t.params.effect === e && r(f);
  }), n("transitionEnd", () => {
    if (t.params.effect === e && l) {
      if (!d || !d().slideShadows) return;
      t.slides.forEach((u) => {
        u.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((f) => f.remove());
      }), l();
    }
  });
  let c;
  n("virtualUpdate", () => {
    t.params.effect === e && (t.slides.length || (c = !0), requestAnimationFrame(() => {
      c && t.slides && t.slides.length && (s(), c = !1);
    }));
  });
}
function qm(i, e) {
  const t = ba(e);
  return t !== e && (t.style.backfaceVisibility = "hidden", t.style["-webkit-backface-visibility"] = "hidden"), t;
}
function Ym({
  swiper: i,
  duration: e,
  transformElements: t,
  allSlides: n
}) {
  if (i.params.virtualTranslate && e !== 0) {
    let s = !1, r;
    r = t, r.forEach((a) => {
      Z2(a, () => {
        if (s || !i || i.destroyed) return;
        s = !0, i.animating = !1;
        const o = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        i.wrapperEl.dispatchEvent(o);
      });
    });
  }
}
function Sw({
  swiper: i,
  extendParams: e,
  on: t
}) {
  e({
    fadeEffect: {
      crossFade: !1
    }
  }), Wm({
    effect: "fade",
    swiper: i,
    on: t,
    setTranslate: () => {
      const {
        slides: r
      } = i, a = i.params.fadeEffect;
      for (let o = 0; o < r.length; o += 1) {
        const l = i.slides[o];
        let c = -l.swiperSlideOffset;
        i.params.virtualTranslate || (c -= i.translate);
        let u = 0;
        i.isHorizontal() || (u = c, c = 0);
        const f = i.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(l.progress), 0) : 1 + Math.min(Math.max(l.progress, -1), 0), h = qm(a, l);
        h.style.opacity = f, h.style.transform = `translate3d(${c}px, ${u}px, 0px)`;
      }
    },
    setTransition: (r) => {
      const a = i.slides.map((o) => ba(o));
      a.forEach((o) => {
        o.style.transitionDuration = `${r}ms`;
      }), Ym({
        swiper: i,
        duration: r,
        transformElements: a,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !i.params.cssMode
    })
  });
}
function kw(i, e, t) {
  const n = `swiper-slide-shadow${` swiper-slide-shadow-${i}`}`, s = ba(e);
  let r = s.querySelector(`.${n.split(" ").join(".")}`);
  return r || (r = Ps("div", n.split(" ")), s.append(r)), r;
}
function Tw({
  swiper: i,
  extendParams: e,
  on: t
}) {
  e({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: !1,
      progressMultiplier: 1,
      perspective: !0,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const n = (a) => typeof a == "string" ? a : `${a}px`;
  Wm({
    effect: "creative",
    swiper: i,
    on: t,
    setTranslate: () => {
      const {
        slides: a,
        wrapperEl: o,
        slidesSizesGrid: l
      } = i, d = i.params.creativeEffect, {
        progressMultiplier: c
      } = d, u = i.params.centeredSlides, f = Q2(i);
      if (u) {
        const h = l[0] / 2 - i.params.slidesOffsetBefore || 0;
        o.style.transform = `translateX(calc(50% - ${h}px))`;
      }
      for (let h = 0; h < a.length; h += 1) {
        const m = a[h], g = m.progress, v = Math.min(Math.max(m.progress, -d.limitProgress), d.limitProgress);
        let p = v;
        u || (p = Math.min(Math.max(m.originalProgress, -d.limitProgress), d.limitProgress));
        const y = m.swiperSlideOffset, b = [i.params.cssMode ? -y - i.translate : -y, 0, 0], k = [0, 0, 0];
        let T = !1;
        i.isHorizontal() || (b[1] = b[0], b[0] = 0);
        let I = {
          translate: [0, 0, 0],
          rotate: [0, 0, 0],
          scale: 1,
          opacity: 1
        };
        v < 0 ? (I = d.next, T = !0) : v > 0 && (I = d.prev, T = !0), b.forEach((O, V) => {
          b[V] = `calc(${O}px + (${n(I.translate[V])} * ${Math.abs(v * c)}))`;
        }), k.forEach((O, V) => {
          let j = I.rotate[V] * Math.abs(v * c);
          k[V] = j;
        }), m.style.zIndex = -Math.abs(Math.round(g)) + a.length;
        const x = b.join(", "), E = `rotateX(${f(k[0])}deg) rotateY(${f(k[1])}deg) rotateZ(${f(k[2])}deg)`, R = p < 0 ? `scale(${1 + (1 - I.scale) * p * c})` : `scale(${1 - (1 - I.scale) * p * c})`, A = p < 0 ? 1 + (1 - I.opacity) * p * c : 1 - (1 - I.opacity) * p * c, _ = `translate3d(${x}) ${E} ${R}`;
        if (T && I.shadow || !T) {
          let O = m.querySelector(".swiper-slide-shadow");
          if (!O && I.shadow && (O = kw("creative", m)), O) {
            const V = d.shadowPerProgress ? v * (1 / d.limitProgress) : v;
            O.style.opacity = Math.min(Math.max(Math.abs(V), 0), 1);
          }
        }
        const C = qm(d, m);
        C.style.transform = _, C.style.opacity = A, I.origin && (C.style.transformOrigin = I.origin);
      }
    },
    setTransition: (a) => {
      const o = i.slides.map((l) => ba(l));
      o.forEach((l) => {
        l.style.transitionDuration = `${a}ms`, l.querySelectorAll(".swiper-slide-shadow").forEach((d) => {
          d.style.transitionDuration = `${a}ms`;
        });
      }), Ym({
        swiper: i,
        duration: a,
        transformElements: o,
        allSlides: !0
      });
    },
    perspective: () => i.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !i.params.cssMode
    })
  });
}
const Ew = ["src", "alt"], xw = {
  key: 0,
  class: "block_container"
}, _w = { key: 0 }, Aw = ["media", "srcset"], ww = ["media", "srcset"], Lw = ["src", "alt"], Iw = { class: "block-container__content-wrapper" }, Cw = ["src"], Rw = { class: "block-container__buttons cta" }, Pw = ["href"], Dw = ["href"], Nw = {
  key: 1,
  class: "block_container"
}, Mw = { class: "block-container__content-wrapper" }, Ow = ["src"], Fw = { class: "block-container__buttons cta" }, $w = ["href"], Bw = ["href"], Uw = /* @__PURE__ */ Re({
  __name: "PoloclubSlider.ce",
  props: {
    sectionSettingsData: { type: String },
    blocksData: { type: String }
  },
  setup(i) {
    Nt((c) => ({
      "4ce4cf70": L(n).button_arrow_color,
      "44ca8685": L(n).arrow_color,
      b41ac3e4: L(n).bullet_color,
      d3235d0a: L(n)?.bullet_color
    }));
    const e = [Tw, bw, Sw, vw, yw], t = i, n = Ni(t.sectionSettingsData), s = Ni(t.blocksData), r = n.auto_rotate ? {
      delay: n.change_slides_speed * 1e3,
      disableOnInteraction: !1
    } : !1, a = (c) => {
      if (!c) return !1;
      const u = [c.desktop, c.tablet, c.mobile].filter(Boolean), f = /\.(jpe?g|png|gif|webp)(\?.*)?$/i;
      return u.some((h) => f.test(h));
    }, o = (c) => window.innerWidth >= F.desktopBreakpoint || window.innerWidth >= F.tabletBreakpoint ? c.desktop : c.mobile, l = (c) => {
      let u = !0;
      const f = c.customer?.isLogged === "true", h = c.customer_tags ? c.customer_tags.replace(/\s+/g, "").split(",") : [], m = c.customer?.tags || [];
      switch (c.show_for_logged) {
        case "logged":
          f || (u = !1);
          break;
        case "not_logged":
          f && (u = !1);
          break;
      }
      return f && h.length > 0 && u && (m.some((v) => h.includes(v)) || (u = !1)), u;
    }, d = le(() => s.filter((c) => l(c)));
    return (c, u) => d.value.length ? (P(), Ie(L(mw), {
      key: 0,
      class: Ke({ "mobile-full": L(n).mobile_layout === "full" }),
      navigation: d.value.length > 1 && L(n).navigation,
      pagination: d.value.length > 1 && L(n).pagination ? { clickable: !0 } : !1,
      modules: e,
      "slides-per-view": 1,
      "space-between": 0,
      autoplay: L(r),
      grabCursor: !0,
      centeredSlides: !0,
      loop: "",
      alt: L(n).accessibility_info
    }, {
      default: Xe(() => [
        L(n).bcorp_icon ? (P(), N("img", {
          key: 0,
          class: "bcorp-icon",
          src: L(n).bcorp_icon,
          alt: L(n).accessibility_info,
          loading: "lazy"
        }, null, 8, Ew)) : U("", !0),
        (P(!0), N(ve, null, pt(d.value, (f, h) => (P(), Ie(L(pw), {
          class: Ke({ "mobile-full": L(n).mobile_layout === "full" }),
          key: h
        }, {
          default: Xe(() => [
            f.block_type == "slide" ? (P(), N("div", xw, [
              f.image ? (P(), N(ve, { key: 0 }, [
                a(f.image) ? (P(), N("picture", _w, [
                  f.image.desktop ? (P(), N("source", {
                    key: 0,
                    media: `(width >= ${L(F).tabletBreakpoint}px)`,
                    srcset: f.image.desktop
                  }, null, 8, Aw)) : U("", !0),
                  f.image.tablet ? (P(), N("source", {
                    key: 1,
                    media: `(width >= ${L(F).mobileBreakpoint}px)`,
                    srcset: f.image.tablet
                  }, null, 8, ww)) : U("", !0),
                  w("img", {
                    class: "media-image",
                    src: f.image.mobile,
                    alt: f.image.altText,
                    loading: "lazy"
                  }, null, 8, Lw)
                ])) : U("", !0)
              ], 64)) : U("", !0),
              w("div", Iw, [
                f.floating_icon ? (P(), N("img", {
                  key: 0,
                  class: "floating-icon",
                  src: f.floating_icon,
                  alt: "Floating icon",
                  loading: "lazy"
                }, null, 8, Cw)) : U("", !0),
                f.pretitle ? (P(), N("div", {
                  key: 1,
                  class: "block-container__subtitle block-container__pretitle",
                  style: We({ color: f.pretitle_color, backgroundColor: f.pretitle_bg_color })
                }, ie(f.pretitle), 5)) : U("", !0),
                f.heading ? (P(), N("div", {
                  key: 2,
                  class: Ke(["block-container__title", f.heading_size]),
                  style: We({ color: f.heading_color })
                }, ie(f.heading), 7)) : U("", !0),
                f.subheading ? (P(), N("div", {
                  key: 3,
                  class: "block-container__subtitle",
                  style: We({ color: f.subheading_color, backgroundColor: f.subheading_bg_color })
                }, ie(f.subheading), 5)) : U("", !0),
                w("div", Rw, [
                  f.button_label ? (P(), N("a", {
                    key: 0,
                    href: f.link,
                    class: "btn btn--outline-secondary-img-banner max-width--btn",
                    style: We({
                      color: f.cta_1_color,
                      backgroundColor: f.cta_1_bg_color,
                      borderColor: f.cta_1_border_color
                    })
                  }, ie(f.button_label), 13, Pw)) : U("", !0),
                  f.second_button_label ? (P(), N("a", {
                    key: 1,
                    href: f.second_button_link,
                    class: "btn btn--outline-secondary-img-banner max-width--btn",
                    style: We({
                      color: f.cta_2_color,
                      backgroundColor: f.cta_2_bg_color,
                      borderColor: f.cta_2_border_color
                    })
                  }, ie(f.second_button_label), 13, Dw)) : U("", !0)
                ])
              ])
            ])) : f.block_type == "slide_video" ? (P(), N("div", Nw, [
              f.video ? (P(), Ie(U2, {
                key: 0,
                video: o(f.video)
              }, null, 8, ["video"])) : U("", !0),
              w("div", Mw, [
                f.floating_icon ? (P(), N("img", {
                  key: 0,
                  class: "floating-icon",
                  src: f.floating_icon,
                  alt: "Floating icon",
                  loading: "lazy"
                }, null, 8, Ow)) : U("", !0),
                f.pretitle ? (P(), N("div", {
                  key: 1,
                  class: "block-container__subtitle block-container__pretitle",
                  style: We({ color: f.pretitle_color, backgroundColor: f.pretitle_bg_color })
                }, ie(f.pretitle), 5)) : U("", !0),
                f.heading ? (P(), N("div", {
                  key: 2,
                  class: Ke(["block-container__title", f.heading_size]),
                  style: We({ color: f.heading_color })
                }, ie(f.heading), 7)) : U("", !0),
                f.subheading ? (P(), N("div", {
                  key: 3,
                  class: "block-container__subtitle",
                  style: We({ color: f.subheading_color, backgroundColor: f.subheading_bg_color })
                }, ie(f.subheading), 5)) : U("", !0),
                w("div", Fw, [
                  f.button_label ? (P(), N("a", {
                    key: 0,
                    href: f.link,
                    class: "btn btn--outline-secondary-img-banner max-width--btn",
                    style: We({
                      color: f.cta_1_color,
                      backgroundColor: f.cta_1_bg_color,
                      borderColor: f.cta_1_border_color
                    })
                  }, ie(f.button_label), 13, $w)) : U("", !0),
                  f.second_button_label ? (P(), N("a", {
                    key: 1,
                    href: f.second_button_link,
                    class: "btn btn--outline-secondary-img-banner max-width--btn",
                    style: We({
                      color: f.cta_2_color,
                      backgroundColor: f.cta_2_bg_color,
                      borderColor: f.cta_2_border_color
                    })
                  }, ie(f.second_button_label), 13, Bw)) : U("", !0)
                ])
              ])
            ])) : U("", !0)
          ]),
          _: 2
        }, 1032, ["class"]))), 128))
      ]),
      _: 1
    }, 8, ["class", "navigation", "pagination", "autoplay", "alt"])) : U("", !0);
  }
}), Vw = "*,*:before,*:after{box-sizing:border-box}p,:deep(p){margin:0;padding:0}h1,h2{margin:0}*{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.bcorp-icon{position:absolute;top:2rem;left:1rem;width:7rem;height:7rem}.swiper{position:relative;width:100dvw;height:calc(100dvh - 84px)}.swiper-wrapper{display:flex;transition-property:transform;transition-timing-function:ease-in-out;transition-duration:.3s;will-change:transform;box-sizing:content-box}.swiper-slide{flex-shrink:0;width:100%;height:calc(100dvh - 84px);box-sizing:border-box;display:flex;align-items:center;justify-content:center;-webkit-user-select:none;user-select:none}.swiper-button-prev,.swiper-button-next{position:absolute;top:50%;transform:translateY(-50%);z-index:2;width:40px;height:40px;border-radius:999px;display:flex;align-items:center;justify-content:center;cursor:pointer;background:var(--4ce4cf70);color:var(--44ca8685);border:none;outline:none;-webkit-appearance:none}.swiper-button-prev{left:10px}.swiper-button-prev svg{transform:rotate(180deg)}.swiper-button-next{right:10px}.swiper-button-prev:hover,.swiper-button-next:hover{background:#0009}.swiper-button-disabled{opacity:.35;cursor:default;pointer-events:none}.swiper-pagination{position:absolute;text-align:center;left:0;right:0;bottom:12px;z-index:20;display:flex;justify-content:center;gap:8px;pointer-events:none;align-items:center}.swiper-pagination-bullet{width:.6rem;height:.6rem;display:inline-block;border-radius:999px;background:var(--b41ac3e4);opacity:.5;transform:scale(1);transition:transform .18s ease,background .18s ease,opacity .18s ease;pointer-events:auto;cursor:pointer}.swiper-pagination-bullet-active{background:var(--d3235d0a);transform:scale(1.2);opacity:1;width:.7rem;height:.7rem}@media (max-width: 640px){.swiper-button-prev,.swiper-button-next{width:3.6rem;height:3.6rem;font-size:1.8rem}.swiper-pagination{bottom:.8rem}}.swiper-cursor-grab{cursor:grab}.swiper-cursor-grabbing{cursor:grabbing}.swiper-slide .media-image{height:100%;width:100%;object-fit:cover;object-position:top}.swiper-slide .block_container{width:100%;height:100%;position:relative}.swiper-slide .block-container__content-wrapper{position:absolute;bottom:0;left:50%;transform:translate(-50%,-25%);z-index:9;display:flex;flex-wrap:wrap;flex-direction:column;max-width:57rem;min-width:46rem}.swiper-slide .block-container__content-wrapper .floating-icon{max-width:50%;margin:0 auto;margin-bottom:1.5rem}.swiper-slide .block-container__content-wrapper .block-container__title{line-height:6rem;margin:1rem 0;text-align:center;font-family:var(--font-heading-family);font-weight:500;font-style:normal}.swiper-slide .block-container__content-wrapper .block-container__title.h0{font-size:7rem}.swiper-slide .block-container__content-wrapper .block-container__title.h1{font-size:6rem}.swiper-slide .block-container__content-wrapper .block-container__title.h2{font-size:5rem}.swiper-slide .block-container__content-wrapper .block-container__subtitle{font-size:1.8rem;line-height:3.6rem;margin:auto auto 1rem;text-align:center;font-family:var(--font-body-family);font-weight:400;font-style:normal;padding:0 .6rem}.swiper-slide .block-container__content-wrapper .block-container__pretitle{margin:1rem auto auto!important}.swiper-slide .block-container__content-wrapper .block-container__buttons{display:flex;justify-content:center;align-items:center;flex-direction:row;gap:2rem;padding-top:3rem}.swiper-slide .block-container__content-wrapper .block-container__buttons .btn{overflow:hidden;display:block;width:100%;padding:0 2rem;font-size:1.4rem;text-decoration:none;text-align:center!important;white-space:nowrap;text-overflow:ellipsis;border:.1rem solid;background:transparent;-webkit-user-select:none;user-select:none;max-width:calc(100% - 10rem);height:4.8rem;line-height:4.8rem;font-family:var(--font-body-family)}@media screen and (max-width: 749px){.swiper.mobile-full{height:calc(100dvh - 95px)}.swiper:not(.mobile-full){height:auto}.swiper-slide.mobile-full{height:calc(100dvh - 95px)}.swiper-slide:not(.mobile-full){height:auto}.swiper-slide .block-container__content-wrapper{transform:translate(-50%,-15%);width:100%}.swiper-slide .block-container__content-wrapper .floating-icon{max-width:20%;margin:0 auto;margin-bottom:.5rem}.swiper-slide .block-container__content-wrapper .block-container__title{font-size:4.8rem;line-height:4.8rem}.swiper-slide .block-container__content-wrapper .block-container__subtitle{font-size:1.6rem;line-height:3.2rem;margin:auto auto 1.5rem}.swiper-slide .block-container__content-wrapper .block-container__buttons{flex-direction:column;gap:15px;padding-top:1.5rem}.swiper-slide .block-container__content-wrapper .block-container__title.h0{font-size:5.4rem}.swiper-slide .block-container__content-wrapper .block-container__title.h1{font-size:4.8rem}.swiper-slide .block-container__content-wrapper .block-container__title.h2{font-size:3.4rem}.swiper-slide .block-container__content-wrapper{min-width:37rem}}", Gw = /* @__PURE__ */ Pe(Uw, [["styles", [Vw]]]), Hw = { class: "product-card" }, zw = { class: "product-image-container" }, Kw = ["media", "srcset"], jw = ["media", "srcset"], Ww = ["media", "srcset"], qw = ["media", "srcset"], Yw = ["src", "alt"], Xw = ["src", "alt"], Zw = { class: "product-card__information" }, Qw = { class: "product-title" }, Jw = {
  width: "16px",
  height: "16px",
  viewBox: "0 0 64 64",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linejoin": "round", "stroke-miterlimit": "2" }
}, e3 = { class: "product-colors" }, t3 = { class: "product-colors-flex" }, i3 = ["onClick", "src"], n3 = { class: "product-cart-icon-container" }, s3 = { key: 0 }, r3 = { key: 1 }, xu = 5, a3 = /* @__PURE__ */ Re({
  __name: "PoloclubProductCardLook.ce",
  props: {
    product: { type: null },
    sectionSettings: { type: null },
    changeProductByLocation: { type: null },
    showPrivateMsg: { type: Boolean },
    isLogged: { type: Boolean }
  },
  emits: ["click-product-image"],
  setup(i, { emit: e }) {
    const t = ge(i.product), n = ge("closed"), s = ge("closed"), r = ge(!1);
    ge([]);
    const a = e, { setProduct: o } = fa(), { handleAddToCart: l } = $s(), d = En(), c = () => {
      a("click-product-image"), yn.name === "product" ? (o(t.value.id), window.dispatchEvent(new CustomEvent("product:changed")), window.scrollTo({ top: 0, behavior: "smooth" }), i.changeProductByLocation && (window.location.href = `/products/${t.value.handle}`)) : window.location.href = `/products/${t.value.handle}`;
    }, u = le(() => he.color_private_msg_preview), f = le(() => {
      if (i.showPrivateMsg && !St.private_sale) {
        const b = t.value.variants?.nodes?.find(
          (k) => window.Shopify.country == "PL" ? !!k.privatePriceMetafieldPolonia?.value : !!k.privatePriceMetafield?.value
        );
        if (b) {
          const k = {
            amount: window.Shopify.country == "PL" ? b.privatePriceMetafieldPolonia?.value : b.privatePriceMetafield?.value,
            currencyCode: window.Shopify.currency.active
          };
          return Je.private_msg.replace("__price__", gn(k));
        }
      }
      return !1;
    }), h = (b) => {
      const k = document.querySelector(b);
      k && (k.classList.add("is-active"), document.body.style.overflow = "hidden", setTimeout(() => {
        k.classList.add("is-visible");
      }, 50));
    }, m = async (b) => {
      const k = await pl({ productIdentifier: b });
      k && (t.value = k);
    }, g = (b) => {
      n.value = "closed", m(b);
    }, v = async () => {
      t.value.variants.nodes.length > 1 ? s.value = "open" : (r.value = !0, await l(t.value, t.value.variants.nodes[0]), r.value = !1);
    }, p = le(() => t.value.variants.nodes[0]);
    Dt(() => i.product, (b) => {
      t.value = b;
    });
    const y = le(() => t.value?.media?.nodes ? t.value.media.nodes.filter(
      (b) => Object.values(b.image).some(
        (k) => typeof k == "string" && k.includes("_aire")
      )
    ) : []);
    return (b, k) => {
      const T = cf("PoloclubButton");
      return P(), N("div", Hw, [
        w("div", zw, [
          w("picture", { onClick: c }, [
            y.value.length ? (P(), N("source", {
              key: 0,
              media: `(width >= ${L(F).tabletBreakpoint}px)`,
              srcset: y.value[0].previewImage?.url
            }, null, 8, Kw)) : t.value.featuredImage?.desktop ? (P(), N("source", {
              key: 1,
              media: `(width >= ${L(F).tabletBreakpoint}px)`,
              srcset: t.value.featuredImage?.desktop
            }, null, 8, jw)) : U("", !0),
            y.value.length ? (P(), N("source", {
              key: 2,
              media: `(width >= ${L(F).mobileBreakpoint}px)`,
              srcset: y.value[0].previewImage?.url
            }, null, 8, Ww)) : t.value.featuredImage?.tablet ? (P(), N("source", {
              key: 3,
              media: `(width >= ${L(F).mobileBreakpoint}px)`,
              srcset: t.value.featuredImage?.tablet
            }, null, 8, qw)) : U("", !0),
            y.value.length ? (P(), N("img", {
              key: 4,
              class: "product-image",
              src: y.value[0].previewImage?.url,
              alt: t.value.featuredImage?.altText || "",
              loading: "lazy"
            }, null, 8, Yw)) : (P(), N("img", {
              key: 5,
              class: "product-image",
              src: t.value.featuredImage?.mobile,
              alt: t.value.featuredImage?.altText || "",
              loading: "lazy"
            }, null, 8, Xw))
          ]),
          de(gl, {
            class: "product-labels",
            type: "product-card",
            product: t.value,
            "is-logged": b.isLogged,
            variant: p.value
          }, null, 8, ["product", "is-logged", "variant"]),
          L(he).enable_wishlist ? (P(), Ie(ha, {
            key: 0,
            class: "wishlist-icon",
            type: "product-card",
            "product-id": t.value.id
          }, null, 8, ["product-id"])) : U("", !0)
        ]),
        w("div", Zw, [
          w("p", Qw, ie(t.value.title), 1),
          de(ya, {
            type: "product-card",
            variant: p.value,
            product: t.value,
            "is-highlited": p.value.highlightedPriceMetafield?.value
          }, null, 8, ["variant", "product", "is-highlited"]),
          f.value != !1 ? (P(), N("div", {
            key: 0,
            class: "product-price--private-price-msg",
            style: We({ color: u.value }),
            onClick: k[0] || (k[0] = oa((I) => h("#drawer-login"), ["prevent", "stop"]))
          }, [
            sn(ie(f.value) + " ", 1),
            (P(), N("svg", Jw, k[5] || (k[5] = [
              w("rect", {
                id: "Icons",
                x: "-576",
                y: "-64",
                width: "1280",
                height: "800",
                style: { fill: "none" }
              }, null, -1),
              w("g", {
                id: "Icons1",
                "serif:id": "Icons"
              }, [
                w("g", { id: "Strike" }),
                w("g", { id: "H1" }),
                w("g", { id: "H2" }),
                w("g", { id: "H3" }),
                w("g", { id: "list-ul" }),
                w("g", { id: "hamburger-1" }),
                w("g", { id: "hamburger-2" }),
                w("g", { id: "list-ol" }),
                w("g", { id: "list-task" }),
                w("g", { id: "trash" }),
                w("g", { id: "vertical-menu" }),
                w("g", { id: "horizontal-menu" }),
                w("g", { id: "sidebar-2" }),
                w("g", { id: "Pen" }),
                w("g", {
                  id: "Pen1",
                  "serif:id": "Pen"
                }),
                w("g", { id: "clock" }),
                w("g", { id: "external-link" }),
                w("g", { id: "hr" }),
                w("g", { id: "info" }, [
                  w("path", {
                    d: "M32.168,56.028c6.18,-0.06 12.297,-2.62 16.697,-6.967c5.224,-5.163 7.915,-12.803 6.977,-20.096c-1.609,-12.499 -11.883,-20.98 -23.828,-20.98c-9.075,0 -17.896,5.677 -21.764,13.909c-2.962,6.303 -2.968,13.911 0,20.225c3.841,8.174 12.517,13.821 21.61,13.909c0.103,0 0.205,0 0.308,0Zm-0.283,-4.004c-9.23,-0.089 -17.841,-7.227 -19.553,-16.378c-1.207,-6.452 1.071,-13.433 5.818,-18.015c5.543,-5.35 14.253,-7.142 21.496,-4.11c6.481,2.714 11.331,9.014 12.225,15.955c0.766,5.949 -1.369,12.185 -5.565,16.48c-3.68,3.767 -8.841,6.017 -14.163,6.068c-0.086,0 -0.172,0 -0.258,0Z",
                    style: { "fill-rule": "nonzero" }
                  }),
                  w("path", {
                    d: "M33.986,44.028l-3.907,0l0,-17.393l3.907,0l0,17.393Zm-4.148,-21.91c0,-0.601 0.19,-1.099 0.571,-1.495c0.38,-0.397 0.924,-0.595 1.632,-0.595c0.707,0 1.253,0.198 1.639,0.595c0.386,0.396 0.579,0.894 0.579,1.495c0,0.589 -0.193,1.079 -0.579,1.47c-0.386,0.392 -0.932,0.587 -1.639,0.587c-0.708,0 -1.252,-0.195 -1.632,-0.587c-0.381,-0.391 -0.571,-0.881 -0.571,-1.47Z",
                    style: { "fill-rule": "nonzero" }
                  })
                ]),
                w("g", { id: "warning" }),
                w("g", { id: "plus-circle" }),
                w("g", { id: "minus-circle" }),
                w("g", { id: "vue" }),
                w("g", { id: "cog" }),
                w("g", { id: "logo" }),
                w("g", { id: "radio-check" }),
                w("g", { id: "eye-slash" }),
                w("g", { id: "eye" }),
                w("g", { id: "toggle-off" }),
                w("g", { id: "shredder" }),
                w("g", {
                  id: "spinner--loading--dots-",
                  "serif:id": "spinner [loading, dots]"
                }),
                w("g", { id: "react" }),
                w("g", { id: "check-selected" }),
                w("g", { id: "turn-off" }),
                w("g", { id: "code-block" }),
                w("g", { id: "user" }),
                w("g", { id: "coffee-bean" }),
                w("g", { id: "coffee-beans" }, [
                  w("g", {
                    id: "coffee-bean1",
                    "serif:id": "coffee-bean"
                  })
                ]),
                w("g", { id: "coffee-bean-filled" }),
                w("g", { id: "coffee-beans-filled" }, [
                  w("g", {
                    id: "coffee-bean2",
                    "serif:id": "coffee-bean"
                  })
                ]),
                w("g", { id: "clipboard" }),
                w("g", { id: "clipboard-paste" }),
                w("g", { id: "clipboard-copy" }),
                w("g", { id: "Layer1" })
              ], -1)
            ])))
          ], 4)) : U("", !0),
          w("div", e3, [
            w("div", t3, [
              (P(!0), N(ve, null, pt(t.value.colorsMetafield?.references?.nodes, (I) => (P(), N("img", {
                key: I.id,
                onClick: (x) => m(I.id),
                class: Ke({ "selected-color": t.value.id === I.id }),
                src: L(Im)(I.images.nodes, "mobile") || L(zi)(I.images.nodes, "mobile")
              }, null, 10, i3))), 128))
            ]),
            (t.value.colorsMetafield?.references?.nodes?.length || 0) > xu ? (P(), N("span", {
              key: 0,
              onClick: k[1] || (k[1] = (I) => n.value = "open"),
              class: "hidden-colors-count"
            }, " +" + ie((t.value.colorsMetafield?.references?.nodes?.length || 0) - xu), 1)) : U("", !0)
          ]),
          de(Pi, {
            type: L(d) >= L(F).tabletBreakpoint ? "right" : "bottom",
            state: n.value,
            title: L(Je).selectAColor,
            onClose: k[3] || (k[3] = (I) => n.value = "closed")
          }, {
            default: Xe(() => [
              de(Vr, {
                product: t.value,
                display: "grid",
                "grid-columns": 3,
                onSelectColor: k[2] || (k[2] = (I) => g(I))
              }, null, 8, ["product"])
            ]),
            _: 1
          }, 8, ["type", "state", "title"]),
          de(Pi, {
            type: L(d) >= L(F).tabletBreakpoint ? "right" : "bottom",
            state: s.value,
            title: L(Je).selectASize,
            onClose: k[4] || (k[4] = (I) => s.value = "closed")
          }, {
            default: Xe(() => [
              de(Cm, {
                product: t.value,
                onSelectVariant: L(l)
              }, null, 8, ["product", "onSelectVariant"])
            ]),
            _: 1
          }, 8, ["type", "state", "title"]),
          w("div", n3, [
            r.value ? (P(), Ie(bi, {
              key: 0,
              theme: "dark",
              width: "20px"
            })) : (P(), Ie(T, {
              key: 1,
              class: "",
              type: "primary",
              theme: "light",
              onClick: v
            }, {
              default: Xe(() => [
                t.value.variants.nodes.length > 1 ? (P(), N("span", s3, ie(b.sectionSettings.translations.select_size), 1)) : (P(), N("span", r3, ie(b.sectionSettings.translations.add_to_cart), 1))
              ]),
              _: 1
            }))
          ])
        ])
      ]);
    };
  }
}), o3 = "[data-v-378a0d37],[data-v-378a0d37]:before,[data-v-378a0d37]:after{box-sizing:border-box}p[data-v-378a0d37],[data-v-378a0d37] p{margin:0;padding:0}h1[data-v-378a0d37],h2[data-v-378a0d37]{margin:0}[data-v-378a0d37]{--color-black: #1f262e;--color-gray: #999999;--color-gray-secondary: #979797;--color-gray-2: #d0d0d0;--color-gray-3: #f5f5f5;--color-border-gray: #e5e5e5;--color-border-black: #000;--color-border-hover: #666666;--page-horizontal-padding: 1.5rem;--color-red: #BF4C3A}.product-card[data-v-378a0d37]{display:flex;gap:.8rem;margin-bottom:3.6rem}.product-card .product-image-container[data-v-378a0d37]{position:relative}.product-card .product-image-container>picture[data-v-378a0d37]{display:flex;cursor:pointer;width:17.8rem}.product-card .product-image-container>picture .product-image[data-v-378a0d37]{width:100%;aspect-ratio:9/13.5}.product-card .product-card__information[data-v-378a0d37]{position:relative}.product-card .product-colors[data-v-378a0d37]{display:flex;align-items:center;gap:.7rem;margin-top:.8rem}.product-card .product-colors .product-colors-flex[data-v-378a0d37]{display:flex;align-items:center;gap:.5rem}.product-card .product-colors .product-colors-flex>img[data-v-378a0d37]{width:20px;aspect-ratio:1;border-radius:50%;border:1px solid var(--color-gray-2);padding:.1rem;cursor:pointer;object-fit:cover}.product-card .product-colors .product-colors-flex>img.selected-color[data-v-378a0d37]{border:1px solid var(--color-black)}.product-card .product-colors .product-colors-flex>img[data-v-378a0d37]:nth-child(n+6){display:none}.product-card .product-colors .hidden-colors-count[data-v-378a0d37]{font-size:14px;color:var(--color-gray);text-decoration:underline;cursor:pointer}.product-card .poloclub-spinner[data-v-378a0d37]{border:1px solid #fff}.product-card .prices-container[data-v-378a0d37]{gap:0 1.2rem}.product-card .product-labels[data-v-378a0d37]{position:absolute;bottom:8px;left:8px}.product-image-container:has(.product-cart-variants-selector):hover>.product-labels[data-v-378a0d37]{display:none}.product-card .wishlist-icon[data-v-378a0d37]{position:absolute;top:12px;right:12px}.product-image-container:hover>.product-cart-variants-selector[data-v-378a0d37]:has(.product-cart-variant-selector-item){display:flex;opacity:1}@starting-style{.product-image-container:hover>.product-cart-variants-selector[data-v-378a0d37]:has(.product-cart-variant-selector-item){opacity:0}}.product-cart-icon-container[data-v-378a0d37]{position:absolute;bottom:0;display:flex;justify-content:center;align-items:center;aspect-ratio:1;color:#fff;background-color:var(--color-black);height:5rem;width:100%;font-family:var(--font-body-family);font-size:1.4rem;line-height:5rem;text-align:center;cursor:pointer}.product-cart-variants-selector[data-v-378a0d37]{display:none;position:absolute;bottom:0;left:1rem;right:1rem;justify-content:space-between;align-items:center;gap:.5em;height:7%;min-height:48px;margin:0 0 1rem;background-color:#fff9;box-shadow:0 0 5px #0000001a;padding:.5em .7em;opacity:0;transition:opacity .3s ease-in-out,display .3s ease-in-out allow-discrete}.product-cart-variants-selector>div[data-v-378a0d37]:hover{background-color:#fff}.product-cart-variants-selector>div[data-v-378a0d37]{display:flex;justify-content:center;align-items:center;width:100%;height:100%;font-size:12px;color:#000;cursor:pointer}.product-title[data-v-378a0d37]{line-clamp:1;overflow:hidden;color:var(--color-black);font-size:1.4rem;line-height:1.8rem;margin:0;font-family:FreightDisp Pro;margin-bottom:.8rem}.product-price--private-price-msg[data-v-378a0d37]{margin:0;font-size:clamp(1.1rem,2.5vw,1.2rem);opacity:.8;cursor:pointer;display:flex;align-items:center;gap:.3rem}.product-price--private-price-msg svg[data-v-378a0d37]{fill:currentColor}.product-card .prices-container[data-v-378a0d37]{flex-wrap:wrap}@media (width >=768px){.product-title[data-v-378a0d37]{font-size:1.4rem}.product-card[data-v-378a0d37]{width:clamp(170px,100%,465px)}.product-card .product-labels[data-v-378a0d37]{bottom:15px;left:15px}.product-card .wishlist-icon[data-v-378a0d37]{top:15px;right:15px}}@media screen and (max-width: 989px){.product-card[data-v-378a0d37]{min-width:100%}}", l3 = /* @__PURE__ */ Pe(a3, [["styles", [o3]], ["__scopeId", "data-v-378a0d37"]]), d3 = { key: 0 }, c3 = { class: "collection-look__title" }, u3 = {
  key: 1,
  class: "collection-look"
}, f3 = { class: "collection-look--images" }, h3 = { class: "collection-look--images__second" }, m3 = { class: "look-img-wrapper" }, p3 = ["srcset", "src"], g3 = { class: "collection-look--products" }, v3 = { class: "sidebar--products sidebar-scroll-horizontal" }, y3 = {
  class: "sidebar--footer",
  style: { "margin-top": "2rem" }
}, b3 = { class: "footer--buyit" }, S3 = { class: "look-footer" }, k3 = { class: "look-btn-wrapper" }, T3 = {
  href: "/",
  class: "btn btn--secondary btn-look"
}, E3 = {
  href: "/cart",
  "data-drawer-trigger": "",
  "aria-controls": "drawer-cart",
  class: "btn btn-primary btn-look"
}, x3 = /* @__PURE__ */ Re({
  __name: "PoloclubProductLook.ce",
  props: {
    sectionSettingsData: { type: String },
    blockSettings: { type: String }
  },
  setup(i) {
    Nt((c) => ({
      "55ca5c0c": L(t).paddingTop,
      "6919f014": L(t).paddingBottom
    }));
    const e = i, t = Ni(e.sectionSettingsData), n = Ni(e.blockSettings), s = ge([]), r = le(() => t.blockType === "collection_look" ? t.collectionTitle : yn.name === "product" && t.blockType === "product_look" ? `${t.heading} - ${F.productView.product?.modelMetafield?.value}` : t.blockType === "last-viewed" ? "Last Viewed Products" : t.heading), a = async () => {
      if (t.blockType === "last-viewed") {
        const c = localStorage.getItem("last-viewed-products-pc");
        if (!c) return [];
        const u = JSON.parse(c);
        if (!Array.isArray(u) || !u.length) return [];
        const h = u.filter((m) => m !== F.productView.product?.id).slice(0, t.productsLimit);
        return await ms({ productIdentifiers: h });
      }
      if (t.blockType === "product_look") {
        let c;
        return n.length > 0 ? c = n.slice(0, t.productsLimit) : c = t.related_products.slice(0, t.productsLimit), await ms({ productIdentifiers: c });
      }
      if (t.blockType === "collection_look") {
        let c;
        return n.length > 0 ? c = n.slice(0, t.productsLimit) : c = t.related_products.slice(0, t.productsLimit), await ms({ productIdentifiers: c });
      }
      return [];
    }, o = le(
      () => s.value.filter(
        (c) => Array.isArray(c.tags) && c.tags.some((u) => u.toUpperCase() === "SELECCIÓN") && c.tags.some((u) => u.toUpperCase() === "STOCK")
      )
    );
    wt(async () => {
      s.value = await a(), await Gt();
    });
    const l = (c, u) => {
      if (!c || !c.variants?.nodes?.[0]) return null;
      const f = c.variants.nodes[0], h = t.collectionId || `${r.value}-${t.blockId}`;
      return {
        index: u + 1,
        item_id: `shopify_${F.localizationCountry}_${c.id}_${f.id}`,
        item_name: c.title,
        item_brand: c.vendor,
        item_category: c.productType,
        item_category2: c.categoryMetafield?.value,
        item_list_id: h,
        item_list_name: r.value,
        item_variant: f.title,
        product_id: c.id.toString(),
        product_loc: c.locMetafield?.value,
        product_sku: f.sku,
        product_ean: f.barcode,
        product_action: c.productActionMetafield?.value,
        product_color: c.filterColorMetafield?.value,
        product_img: c.featuredImage?.url,
        variant_id: f.id.toString(),
        location_id: c.locMetafield?.value,
        price: Number(f.price.amount),
        discount: f.compareAtPrice?.amount ? Number((f.compareAtPrice.amount - f.price.amount).toFixed(2)) : 0,
        quantity: 1
      };
    }, d = (c) => {
      const u = s.value.findIndex((h) => h.id === c.id), f = {
        event: "select_item",
        ecommerce: {
          item_list_id: t.collectionId || `${r.value}-${t.blockId}`,
          item_list_name: r.value,
          currency: F.currencyIsoCode,
          items: [
            l(c, u)
          ]
        }
      };
      Wo(f);
    };
    return (c, u) => {
      const f = cf("PoloclubButton");
      return P(), N(ve, null, [
        L(t).title && L(t).productLookImage ? (P(), N("div", d3, [
          w("h3", c3, ie(L(t).title), 1)
        ])) : U("", !0),
        L(t).productLookImage ? (P(), N("div", u3, [
          w("div", f3, [
            w("div", h3, [
              w("div", m3, [
                w("img", {
                  class: "look-img-wrapper__image",
                  srcset: L(t).productLookImage?.src || L(t).productLookImage,
                  src: L(t).productLookImage?.src || L(t).productLookImage,
                  sizes: "(min-width: 990px) 550px",
                  alt: "",
                  height: "1536",
                  width: "1024",
                  loading: "lazy"
                }, null, 8, p3)
              ])
            ])
          ]),
          w("div", g3, [
            w("div", v3, [
              (P(!0), N(ve, null, pt(o.value, (h, m) => (P(), Ie(l3, {
                key: h.id || m,
                "change-product-by-location": L(t).changeProductByLocation,
                product: h,
                onClick: (g) => d(h),
                "is-logged": JSON.parse(L(t)?.customer?.isLogged),
                "section-settings": L(t)
              }, null, 8, ["change-product-by-location", "product", "onClick", "is-logged", "section-settings"]))), 128))
            ]),
            w("div", y3, [
              w("div", b3, [
                w("div", S3, [
                  w("div", k3, [
                    de(f, {
                      class: "main-cnt__slider-btn secondary",
                      type: "primary",
                      theme: "light"
                    }, {
                      default: Xe(() => [
                        w("a", T3, ie(L(t).translations.continue_shopping), 1)
                      ]),
                      _: 1
                    }),
                    de(f, {
                      class: "main-cnt__slider-btn primary",
                      type: "primary",
                      theme: "light"
                    }, {
                      default: Xe(() => [
                        w("a", E3, ie(L(t).translations.view_cart), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ])) : U("", !0)
      ], 64);
    };
  }
}), _3 = ".collection-look__title[data-v-f1aa4c0b]{font-weight:400;font-size:3.2rem;line-height:3.4rem;letter-spacing:-.5px;margin:0;color:#000;pointer-events:none;padding:0 2.4rem;font-family:FreightDisp Pro}.collection-look[data-v-f1aa4c0b]{display:flex;gap:5.6rem;padding-top:var(--55ca5c0c);padding-bottom:var(--6919f014)}.collection-look--images[data-v-f1aa4c0b]{width:50%;flex-shrink:0;display:flex;gap:.8rem;height:68.8rem}.collection-look--images[data-v-f1aa4c0b]>:only-child{width:100%!important}.collection-look--products[data-v-f1aa4c0b]{width:50%}.collection-look--products .sidebar--footer[data-v-f1aa4c0b]{margin-top:2rem;width:100%;max-width:38.4rem}.collection-look--products .look-btn-wrapper[data-v-f1aa4c0b]{display:flex;gap:.8rem}.sidebar-scroll-horizontal[data-v-f1aa4c0b]{overflow-y:hidden;overflow-x:hidden;height:58.2rem}.sidebar--products[data-v-f1aa4c0b]{max-width:38.4rem;width:100%;overflow-y:scroll}.collection-look--images .look-img-wrapper[data-v-f1aa4c0b]{display:flex;height:100%}.collection-look--images__second img[data-v-f1aa4c0b]{display:flex;width:100%;height:100%;object-fit:contain;object-position:right}.collection-look .main-cnt__slider-btn[data-v-f1aa4c0b]{height:5rem;width:100%;font-family:var(--font-body-family);font-size:1.4rem;line-height:5rem;text-align:center;cursor:pointer;border:.1rem solid #1f262e}.collection-look .main-cnt__slider-btn.primary[data-v-f1aa4c0b]{background-color:#1f262e}.collection-look .main-cnt__slider-btn.primary a[data-v-f1aa4c0b]{color:#fff;text-decoration:none}.collection-look .main-cnt__slider-btn.primary[data-v-f1aa4c0b]:hover{opacity:.9}.collection-look .main-cnt__slider-btn.secondary[data-v-f1aa4c0b]{background-color:#fff}.collection-look .main-cnt__slider-btn.secondary a[data-v-f1aa4c0b]{color:#000;text-decoration:none}.collection-look .main-cnt__slider-btn.secondary[data-v-f1aa4c0b]:hover{background-color:#000}.collection-look .main-cnt__slider-btn.secondary:hover a[data-v-f1aa4c0b]{color:#fff}@media screen and (max-width: 989px){.collection-look[data-v-f1aa4c0b]{display:block;padding:0 1.5rem;padding-top:calc(var(--55ca5c0c) / 2);padding-bottom:calc(var(--6919f014) / 2)}.collection-look--images[data-v-f1aa4c0b]{display:block;width:100%;height:auto}.collection-look--products[data-v-f1aa4c0b]{margin-top:20px}.collection-look__sidebar[data-v-f1aa4c0b]{width:100%;display:flex;flex-direction:column;align-items:center}.sidebar-scroll-horizontal[data-v-f1aa4c0b]{display:flex;height:300px;overflow-y:hidden!important;overflow-x:scroll;overscroll-behavior-x:contain;scroll-snap-type:x proximity;gap:2.5rem}.card-wrapper.card-wrapper__look[data-v-f1aa4c0b]:not(:last-child){margin-right:5rem}.collection-look--products[data-v-f1aa4c0b]{width:100%!important}.sidebar--products[data-v-f1aa4c0b]{max-width:100%}}", A3 = /* @__PURE__ */ Pe(x3, [["styles", [_3]], ["__scopeId", "data-v-f1aa4c0b"]]), w3 = { class: "drawer-details-content" }, L3 = { class: "drawer-details-content__description" }, I3 = { class: "drawer-details-content__description--header" }, C3 = { class: "drawer-details-content__description--content" }, R3 = { key: 0 }, P3 = {
  key: 1,
  class: "drawer-sizes-content__guide"
}, D3 = { class: "drawer-sizes-content__guide--header" }, N3 = {
  key: 0,
  class: "drawer-sizes-content__guide--content"
}, M3 = {
  key: 1,
  class: "drawer-sizes-content__guide--content"
}, O3 = { class: "drawer-details-content__care" }, F3 = { class: "drawer-details-content__care--header" }, $3 = {
  key: 0,
  class: "icon-care__wrapper--text"
}, B3 = { class: "drawer-details-content__metafields" }, U3 = { class: "icon-care__wrapper" }, V3 = ["innerHTML"], G3 = ["innerHTML"], H3 = { class: "icon-care__wrapper--text" }, z3 = /* @__PURE__ */ Re({
  __name: "PoloclubDrawerDetails.ce",
  props: {
    sectionSettingsData: { type: String }
  },
  setup(i) {
    const e = i, t = En(), n = Ni(e.sectionSettingsData), s = le(() => {
      const a = F.productView.product?.careIconsMetafield?.value;
      try {
        return a ? JSON.parse(a) : [];
      } catch (o) {
        return console.error("Error parsing careIconsMetafield.value", o), [];
      }
    }), r = {
      "no-lavar": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.83 127.21" style="width: 40px; height: 25px;"><defs><style>.cls-no-lavar{fill:#1d1d1b;}</style></defs><g id="Capa_1-2"><path class="cls-no-lavar" d="m118.8,113.82H26.04l-12.55,12.55c-1.03,1.12-2.84,1.12-3.87,0-1.12-1.03-1.12-2.75,0-3.87l11.78-11.78L.08,25.45c-.34-1.46.52-2.92,1.98-3.27,1.55-.43,3.01.52,3.35,1.98,0,0,.95,3.7,2.41,9.46l7.31,7.39c1.72,1.72,4.04,2.66,6.53,2.66s4.81-.95,6.53-2.66c2.75-2.75,6.45-4.3,10.4-4.3,1.12,0,2.24.17,3.35.43L9.62,4.73c-1.12-1.12-1.12-2.84,0-3.95,1.03-1.03,2.84-1.03,3.87,0l42.81,42.9c2.15-.17,4.13-1.12,5.67-2.66,5.76-5.76,15.13-5.76,20.8,0,1.63,1.55,3.53,2.49,5.76,2.66L131.35.77c1.12-1.03,2.84-1.03,3.87,0,1.12,1.12,1.12,2.84,0,3.95l-32.41,32.41c4.81-1.2,10.06.17,13.84,3.87,1.72,1.72,4.04,2.66,6.53,2.66s4.73-.95,6.53-2.66l7.31-7.39c1.46-5.76,2.41-9.46,2.41-9.46.34-1.55,1.81-2.41,3.27-2.06,1.46.43,2.41,1.89,2.06,3.35l-21.32,85.28,11.78,11.78c1.12,1.12,1.12,2.84,0,3.87-1.03,1.12-2.75,1.12-3.87,0l-12.55-12.55ZM10.39,44.02c5.33,21.49,13.33,53.56,15.47,62.24l42.64-42.64-14.53-14.53c-3.35-.34-6.45-1.8-8.85-4.21-1.81-1.72-4.04-2.67-6.53-2.67s-4.81.95-6.53,2.67c-5.76,5.76-15.04,5.76-20.8,0l-.86-.86Zm21.15,64.3h81.76l-40.83-40.83-40.92,40.83Zm40.92-48.57l11.52-11.52c-1.81-.77-3.61-1.8-5.07-3.35-1.72-1.72-4.04-2.67-6.53-2.67s-4.73.95-6.45,2.67c-1.55,1.46-3.27,2.58-5.07,3.27l11.61,11.61Zm18.4-10.66l-14.53,14.53,42.55,42.64c2.15-8.6,10.14-40.75,15.56-62.24l-.86.86c-5.76,5.76-15.04,5.76-20.8,0-1.72-1.72-4.04-2.67-6.53-2.67s-4.81.95-6.53,2.67c-2.49,2.49-5.59,3.87-8.86,4.21Z"/></g></svg>',
      "lavar-30": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><path d="M12.24,31.66,6.63,9.21A.69.69,0,0,1,8,8.88l.61,2.41,1.86,1.87a2.29,2.29,0,0,0,1.66.68,2.33,2.33,0,0,0,1.66-.68,3.74,3.74,0,0,1,5.28,0,2.34,2.34,0,0,0,3.3,0,3.73,3.73,0,0,1,5.28,0,2.36,2.36,0,0,0,1.66.68A2.33,2.33,0,0,0,31,13.16a3.73,3.73,0,0,1,5.28,0,2.37,2.37,0,0,0,3.32,0l1.86-1.87L42,8.88a.68.68,0,0,1,.83-.52.74.74,0,0,1,.53.85L37.76,31.66Zm-3-17.73c1.52,6.11,3.9,15.65,4.08,16.33H36.67c.18-.68,2.56-10.22,4.08-16.33l-.21.22a3.74,3.74,0,0,1-5.29,0,2.29,2.29,0,0,0-1.66-.68,2.33,2.33,0,0,0-1.66.68,3.73,3.73,0,0,1-5.28,0,2.34,2.34,0,0,0-3.3,0,3.78,3.78,0,0,1-2.64,1.09,3.71,3.71,0,0,1-2.64-1.09,2.36,2.36,0,0,0-1.66-.68,2.31,2.31,0,0,0-1.66.68,3.74,3.74,0,0,1-5.29,0Zm8.6,4h6.27v1s-2.21,2.51-2.84,3.25a2.92,2.92,0,0,1,2.84,3,3.14,3.14,0,0,1-6.25.44H19.2A1.79,1.79,0,0,0,21,27.05a1.7,1.7,0,0,0,1.82-1.81c0-1.49-1.18-1.81-2.17-1.81H19.47V22.36s2.07-2.4,2.7-3.17H17.85ZM32.17,23v.13c0,2.57-.83,5.28-3.62,5.28S25,25.65,25,23.08V23c0-2.56.8-5.29,3.6-5.29S32.17,20.39,32.17,23ZM30.84,23a7.28,7.28,0,0,0-.44-2.71,2,2,0,0,0-1.85-1.39,2.06,2.06,0,0,0-1.86,1.39A7.55,7.55,0,0,0,26.26,23a7.41,7.41,0,0,0,.43,2.73,1.93,1.93,0,0,0,3.71,0A7.15,7.15,0,0,0,30.84,23Zm4.7-3.93a1.58,1.58,0,0,1-3.15,0,1.58,1.58,0,0,1,3.15,0Zm-1.1,0A.47.47,0,0,0,34,18.6a.48.48,0,0,0-.5.48.49.49,0,0,0,.5.5A.48.48,0,0,0,34.44,19.08Z"/><rect class="cls-1" width="50" height="40"/></g></g></svg>',
      "lavar-40": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><path d="M12.24,31.66,6.63,9.21A.69.69,0,0,1,8,8.88l.61,2.41,1.86,1.87a2.29,2.29,0,0,0,1.66.68,2.33,2.33,0,0,0,1.66-.68,3.74,3.74,0,0,1,5.28,0,2.34,2.34,0,0,0,3.3,0,3.73,3.73,0,0,1,5.28,0,2.36,2.36,0,0,0,1.66.68A2.33,2.33,0,0,0,31,13.16a3.73,3.73,0,0,1,5.28,0,2.37,2.37,0,0,0,3.32,0l1.86-1.87L42,8.88a.68.68,0,0,1,.83-.52.74.74,0,0,1,.53.85L37.76,31.66Zm-3-17.73c1.52,6.11,3.9,15.65,4.08,16.33H36.67c.18-.68,2.56-10.22,4.08-16.33l-.21.22a3.74,3.74,0,0,1-5.29,0,2.29,2.29,0,0,0-1.66-.68,2.33,2.33,0,0,0-1.66.68,3.73,3.73,0,0,1-5.28,0,2.34,2.34,0,0,0-3.3,0,3.78,3.78,0,0,1-2.64,1.09,3.71,3.71,0,0,1-2.64-1.09,2.36,2.36,0,0,0-1.66-.68,2.31,2.31,0,0,0-1.66.68,3.74,3.74,0,0,1-5.29,0ZM23.31,24.8H25v1.25H23.31v2.2H22v-2.2H17.65V25l4.11-7.1h1.55ZM22,20c-.72,1.26-2.36,4.15-2.75,4.82H22Zm10.37,3v.13c0,2.57-.83,5.28-3.62,5.28s-3.61-2.71-3.61-5.28V23c0-2.56.81-5.29,3.61-5.29S32.39,20.39,32.39,23ZM31.06,23a7.28,7.28,0,0,0-.44-2.71,1.93,1.93,0,0,0-3.71,0A7.28,7.28,0,0,0,26.47,23a7.15,7.15,0,0,0,.44,2.73,1.93,1.93,0,0,0,3.71,0A7.15,7.15,0,0,0,31.06,23Zm4.69-3.93a1.57,1.57,0,0,1-3.14,0,1.57,1.57,0,0,1,3.14,0Zm-1.09,0a.47.47,0,0,0-.48-.48.48.48,0,0,0-.5.48.49.49,0,1,0,1,0Z"/><rect class="cls-1" width="50" height="40"/></g></g></svg>',
      "lavar-mano": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><path d="M29.47,9.87a4.26,4.26,0,0,0,.59,1.53,11.89,11.89,0,0,1,1.31,3.78c0,.43.08.87.11,1.33a3.74,3.74,0,0,1,4.75.43,2.37,2.37,0,0,0,3.32,0l1.86-1.87L42,12.66a.68.68,0,0,1,.83-.52.74.74,0,0,1,.53.85L37.76,35.44H12.24L6.63,13A.69.69,0,0,1,8,12.66l.61,2.41,1.86,1.87a2.29,2.29,0,0,0,1.66.68,2.33,2.33,0,0,0,1.66-.68,3.74,3.74,0,0,1,5.28,0,.23.23,0,0,0,.11.11l.76-2.64a14.65,14.65,0,0,1,1.82-3.54,19.79,19.79,0,0,0,2-5l.27-.9a.52.52,0,0,1,1,.31l-.26.9a20.11,20.11,0,0,1-2.14,5.32,16.15,16.15,0,0,0-1.6,3c-.56,1.48-.91,3.3-1.28,4.39a11.69,11.69,0,0,0-.88,3.32A6.23,6.23,0,0,0,19.42,25a20.65,20.65,0,0,1,.9-6.05.54.54,0,0,1,.67-.33.49.49,0,0,1,.33.66A19.47,19.47,0,0,0,20.38,25c0,2.32.55,4.17,1.2,3.91A11.58,11.58,0,0,1,21,24.81,17.74,17.74,0,0,1,22.15,19a.56.56,0,0,1,.68-.33.5.5,0,0,1,.33.63A15.11,15.11,0,0,0,22,25.05c-.06,2.51.94,5.3,1.23,5.28s.43-.31.3-.66a15.51,15.51,0,0,1-.7-4.71,15.31,15.31,0,0,1,1.34-5.46.56.56,0,0,1,.69-.26.51.51,0,0,1,.25.7,12.2,12.2,0,0,0-.68,9.41c.78-.92,0-3.15.3-4.85a28.61,28.61,0,0,1,2.21-6.77c.57-1.07.87-1.44,1.42-1.13.89.45,1.26,1.83,1.26,3.64a13.4,13.4,0,0,1-.24,2.36c-.39,2.36.42,2,.62-.39,0-.53.13-1.16.24-1.79a17.34,17.34,0,0,0,.15-5.07A11.65,11.65,0,0,0,29,11.57a4.28,4.28,0,0,1-.61-1.74,1.37,1.37,0,0,1,.06-.42,26.58,26.58,0,0,1,1.77-4A.55.55,0,0,1,31,5.2a.57.57,0,0,1,.26.46.65.65,0,0,1-.06.26,13.88,13.88,0,0,0-1.7,3.82ZM9.25,17.71c1.52,6.11,3.9,15.65,4.08,16.33H36.67c.18-.68,2.56-10.22,4.08-16.33l-.21.22a3.74,3.74,0,0,1-5.29,0,2.29,2.29,0,0,0-1.66-.68,2.33,2.33,0,0,0-1.66.68,3.91,3.91,0,0,1-.45.39c-.05.72-.14,1.4-.22,1.92S31.06,21.51,31,22a9.73,9.73,0,0,1-.22,1.42c-.26,1.33-.9,2.08-1.55,1.94s-1-.65-1-1.79a10.34,10.34,0,0,1,.13-1.2,16.27,16.27,0,0,0,.26-2.09c0-.46-.06-2.14-.5-2.54-.17-.17-.63.81-.85,1.38a28.3,28.3,0,0,0-1.57,5.28c-.22,1.51.24,3-.11,4.66a1.67,1.67,0,0,1-1.29,1.37,1.19,1.19,0,0,1-1.13.9c-.59,0-1-.51-1.31-1.49a1.11,1.11,0,0,1-1.18-.17c-.59-.48-1-1.47-1.2-3.32-1.34-.26-1.66-3.58-1.69-4.06A9.05,9.05,0,0,1,18.57,19c0-.14.11-.31.17-.51a2.89,2.89,0,0,1-.67-.54,2.36,2.36,0,0,0-1.66-.68,2.31,2.31,0,0,0-1.66.68,3.74,3.74,0,0,1-5.29,0Z"/><rect class="cls-1" width="50" height="40"/></g></g></svg>',
      "no-lejia": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><path d="M43.71,11.87,31.55,17.15l3.23,5.62,8.93,3.88a.7.7,0,0,1,.37.92.71.71,0,0,1-.94.35L36,24.8,40.13,32H9.87L14,24.8,6.85,27.92a.71.71,0,0,1-.93-.35.7.7,0,0,1,.37-.92l8.93-3.88,3.23-5.62L6.29,11.87A.7.7,0,0,1,5.92,11a.72.72,0,0,1,.93-.37L19.15,16,25,5.8,30.85,16l12.29-5.37a.72.72,0,0,1,.94.37A.7.7,0,0,1,43.71,11.87Zm-9.91,12L25,20l-8.8,3.85c-1.94,3.36-3.54,6.11-3.91,6.75H37.71C37.34,30,35.74,27.22,33.8,23.86Zm-16.42-2,5.87-2.58-3.51-1.53C19,19.08,18.14,20.47,17.38,21.83Zm3.06-5.33,4.56,2,4.56-2C27.34,12.66,25.41,9.34,25,8.6,24.58,9.34,22.66,12.66,20.44,16.5Zm9.82,1.22-3.51,1.53,5.89,2.58C31.86,20.47,31.05,19.08,30.26,17.72Z"/><rect class="cls-1" width="50" height="40"/></g></g></svg>',
      "no-planchar": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}.cls-2{fill:#1d1d1b;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><rect class="cls-1" width="50" height="40"/><path class="cls-2" d="M31,28.24H20.56l-6.7,6.69a.69.69,0,0,1-1,0,.66.66,0,0,1,0-1l5.71-5.71H6.47v-.7A11.69,11.69,0,0,1,18.15,15.85h.44l-5.71-5.71a.69.69,0,0,1,1-1l6.7,6.69H31l6.41-6.41c-.43-1.73-.74-2.93-.78-3.17H12.66a.71.71,0,0,1-.7-.7.72.72,0,0,1,.7-.7h25l5.84,23.37H32.94L38.65,34a.69.69,0,0,1-1,1Zm-11-1.4,4.79-4.79L20,17.25H18.17A10.28,10.28,0,0,0,7.93,26.84Zm5.78-5.78,3.8-3.81H22ZM22,26.84h7.61L25.77,23Zm9.58-9.59-4.79,4.8,4.79,4.79h10.2l-2.41-9.59ZM37.78,11l-4.84,4.83h6C38.54,14.15,38.13,12.48,37.78,11Z"/></g></g></svg>',
      "no-secadora": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}.cls-2{fill:#1d1d1b;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><rect class="cls-1" width="50" height="40"/><path class="cls-2" d="M36.8,32.78H13.2L10,36a.7.7,0,0,1-1-1l3.21-3.22V8.23L9,5A.68.68,0,0,1,9,4a.71.71,0,0,1,1,0l3.22,3.21H36.78L40,4a.71.71,0,0,1,1,0,.68.68,0,0,1,0,1l-3.19,3.2V31.8L41,35a.7.7,0,0,1-1,1ZM17.2,13.2,13.63,9.63V30.37l3.57-3.56a10.39,10.39,0,0,1,0-13.61Zm1,14.59L14.6,31.38H35.4l-3.56-3.57A10.38,10.38,0,0,1,25,30.37,10.2,10.2,0,0,1,18.18,27.79Zm13.64-15.6,3.56-3.57H14.62l3.56,3.59a10.33,10.33,0,0,1,13.64,0Zm-13.64,2a9,9,0,0,0,0,11.62L24,20Zm1,12.61a9,9,0,0,0,11.66,0L25,21ZM25,19l5.82-5.82a8.89,8.89,0,0,0-11.64,0Zm6.81-4.84L26,20l5.82,5.84a8.95,8.95,0,0,0,0-11.66Zm1,12.65,3.57,3.57V9.61l-3.57,3.57a10.38,10.38,0,0,1,0,13.65Z"/></g></g></svg>',
      "no-seco": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}.cls-2{fill:#1d1d1b;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><rect class="cls-1" width="50" height="40"/><path class="cls-2" d="M33.54,29.53a12.8,12.8,0,0,1-17.07,0L13.1,32.9a.71.71,0,0,1-1,0,.69.69,0,0,1,0-1l3.37-3.37a12.8,12.8,0,0,1,0-17.07L12.12,8.1a.69.69,0,1,1,1-1l3.37,3.39a12.77,12.77,0,0,1,17.07,0l3.37-3.37a.69.69,0,0,1,1,0,.71.71,0,0,1,0,1l-3.37,3.37A12.88,12.88,0,0,1,37.79,20a12.71,12.71,0,0,1-3.29,8.53l3.4,3.37a.7.7,0,1,1-1,1Zm-17.07-2L24,20l-7.55-7.53a11.43,11.43,0,0,0,0,15.08Zm1-16.06L25,19l7.52-7.52a11.33,11.33,0,0,0-15.07,0Zm15.07,17L25,21l-7.55,7.55a11.39,11.39,0,0,0,15.07,0Zm1-16.06L26,20l7.53,7.55a11.34,11.34,0,0,0,0-15.08Z"/></g></g></svg>',
      "plancha-baja": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}.cls-2{fill:#1d1d1b;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><rect class="cls-1" width="50" height="40"/><path class="cls-2" d="M43.53,31.68H6.47V31A11.68,11.68,0,0,1,18.15,19.3H39L36.6,9.72H12.66a.7.7,0,0,1,0-1.4h25Zm-1.79-1.4L39.33,20.7H18.17A10.28,10.28,0,0,0,7.93,30.28Zm-14.4-4.79a1.56,1.56,0,1,1-3.11,0,1.56,1.56,0,0,1,3.11,0Z"/></g></g></svg>',
      "plancha-baja-sin-vapor": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}.cls-2{fill:#1d1d1b;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><rect class="cls-1" width="50" height="40"/><path class="cls-2" d="M26.55,19.8A1.55,1.55,0,1,1,25,18.25,1.56,1.56,0,0,1,26.55,19.8Z"/><path class="cls-2" d="M43.53,26H31.59l.72,2.82,5.23-1.71a.69.69,0,0,1,.87.46.71.71,0,0,1-.43.88l-5.34,1.73.83,3.28L38,34.92a.72.72,0,0,1,.43.9.67.67,0,0,1-.87.44l-3.68-1.21.35,1.47a.67.67,0,0,1-.5.83.47.47,0,0,1-.18,0,.68.68,0,0,1-.67-.52l-.57-2.3-6.52-2.12-6.52,2.12-.57,2.3a.7.7,0,0,1-.68.52.62.62,0,0,1-.18,0,.68.68,0,0,1-.5-.83l.35-1.47L14,36.26a.7.7,0,0,1-.9-.44.74.74,0,0,1,.46-.9l4.51-1.46.81-3.28-5.32-1.73A.71.71,0,1,1,14,27.11l5.23,1.71L20,26H6.47v-.7A11.77,11.77,0,0,1,9.9,17a11.65,11.65,0,0,1,8.25-3.41H39C37.8,8.86,36.71,4.49,36.6,4H12.66a.7.7,0,0,1,0-1.4h25Zm-1.79-1.4L39.33,15H18.17A10.28,10.28,0,0,0,7.93,24.6ZM23.51,31.69l-3.28-1.08L19.66,33Zm2.26-.75L31,29.26,30.14,26H21.39l-.81,3.26Zm5.53-.33L28,31.69,31.89,33Z"/></g></g></svg>',
      "plancha-media": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}.cls-2{fill:#1d1d1b;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><rect class="cls-1" width="50" height="40"/><path class="cls-2" d="M43.53,31.68H6.47V31A11.68,11.68,0,0,1,18.15,19.3H39L36.6,9.72H12.66a.7.7,0,0,1,0-1.4h25Zm-1.79-1.4L39.33,20.7H18.17A10.28,10.28,0,0,0,7.93,30.28Zm-18.4-4.79a1.56,1.56,0,1,1-1.56-1.55A1.56,1.56,0,0,1,23.34,25.49Zm8,0a1.55,1.55,0,1,1-1.55-1.55A1.56,1.56,0,0,1,31.3,25.49Z"/></g></g></svg>',
      "plancha-media-sin-vapor": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}.cls-2{fill:#1d1d1b;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><rect class="cls-1" width="50" height="40"/><path class="cls-2" d="M43.53,31.68H6.47V31A11.68,11.68,0,0,1,18.15,19.3H39L36.6,9.72H12.66a.7.7,0,0,1,0-1.4h25Zm-1.79-1.4L39.33,20.7H18.17A10.28,10.28,0,0,0,7.93,30.28Zm-18.4-4.79a1.56,1.56,0,1,1-1.56-1.55A1.56,1.56,0,0,1,23.34,25.49Zm8,0a1.55,1.55,0,1,1-1.55-1.55A1.56,1.56,0,0,1,31.3,25.49Z"/></g></g></svg>',
      secadora: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}.cls-2{fill:#1d1d1b;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><rect class="cls-1" width="50" height="40"/><path class="cls-2" d="M12.22,7.22H37.78V32.78H12.22Zm1.4,24.16H36.38V8.62H13.62ZM35.37,20A10.36,10.36,0,1,1,25,9.63,10.37,10.37,0,0,1,35.37,20ZM34,20a9,9,0,1,0-9,9A9,9,0,0,0,34,20Zm-7.42,0A1.55,1.55,0,1,1,25,18.4,1.56,1.56,0,0,1,26.55,20Z"/></g></g></svg>',
      seco: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}.cls-2{fill:#1d1d1b;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><rect class="cls-1" width="50" height="40"/><path class="cls-2" d="M12.22,20A12.78,12.78,0,1,1,25,32.78,12.78,12.78,0,0,1,12.22,20Zm1.4,0A11.38,11.38,0,1,0,25,8.62,11.39,11.39,0,0,0,13.62,20Z"/></g></g></svg>',
      "seco-sin-solve": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}.cls-2{fill:#1d1d1b;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><rect class="cls-1" width="50" height="40"/><path class="cls-2" d="M12.22,20A12.78,12.78,0,1,1,25,32.78,12.78,12.78,0,0,1,12.22,20Zm1.4,0A11.38,11.38,0,1,0,25,8.62,11.39,11.39,0,0,0,13.62,20ZM21,26.89H19.44l4.77-15.18h1.6l4.75,15.18H29s-1.34-4.59-1.38-4.77h-5.3C22.31,22.3,21,26.89,21,26.89Zm1.72-6h4.56c-.09-.29-2.1-7.27-2.26-7.81C24.87,13.63,22.81,20.59,22.72,20.9Z"/></g></g></svg>',
      "seco-sin-triclo": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}.cls-2{fill:#1d1d1b;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><rect class="cls-1" width="50" height="40"/><path class="cls-2" d="M12.22,20A12.78,12.78,0,1,1,25,32.78,12.78,12.78,0,0,1,12.22,20Zm1.4,0A11.38,11.38,0,1,0,25,8.62,11.39,11.39,0,0,0,13.62,20Zm8.71,7.59H20.86V12.41h4.62c2.85,0,4.75,1.44,4.75,4.26,0,3.11-2.39,4.1-5.34,4.1H22.33Zm0-8.07h2.58c2.23,0,3.88-.59,3.88-2.89,0-2-1.25-3-3.59-3H22.33Z"/></g></g></svg>',
      trapo: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40"><defs><style>.cls-1{fill:none;}.cls-2{fill:#1d1d1b;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><rect class="cls-1" width="50" height="40"/><path class="cls-2" d="M38.12,28c-2.69-4.74-1.9-8.71-1.06-12.91.63-3.19,1.29-6.49.47-10.26a.61.61,0,0,0-.33-.42.6.6,0,0,0-.54,0c-3.27,1.43-5.39.77-7.84,0-3.48-1.09-7.43-2.31-15.44,1.43a.63.63,0,0,0-.34.7c.74,3.4.13,6.35-.46,9.22-.87,4.17-1.76,8.49,1.76,13.82a.63.63,0,0,0,.52.28.66.66,0,0,0,.27-.06,24,24,0,0,1,6.43-2.11h0c-.17-.16-.31-.33-.49-.48a1,1,0,0,1-.26-.44l0-.22a25.76,25.76,0,0,0-5.69,1.89C12.2,23.77,13,20,13.8,16c.59-2.86,1.2-5.8.56-9.24,7.27-3.29,10.89-2.16,14.08-1.17,2.41.75,4.7,1.47,8,.24a24.38,24.38,0,0,1-.62,9C35,18.93,34.19,23.14,36.7,28a8,8,0,0,1-3.07.54,1.15,1.15,0,0,0,.06.17,8.13,8.13,0,0,1,.15.86,1.46,1.46,0,0,1,0,.22,9.61,9.61,0,0,0,4-.91.59.59,0,0,0,.34-.37A.61.61,0,0,0,38.12,28Z"/><path class="cls-2" d="M34.43,30.74a11.68,11.68,0,0,0,2.92,1.9.46.46,0,0,1,.16.15.49.49,0,0,1,0,.44.45.45,0,0,1-.59.19,21.75,21.75,0,0,1-3.05-2,1.48,1.48,0,0,1-.24-.26,3.59,3.59,0,0,1-.36-1.5,10,10,0,0,0-.79-3.23A14.6,14.6,0,0,0,30.11,23c-.36-.39-.71-.79-1-1.14-1.22-1.59-1.94-1.47-.6,0a12.77,12.77,0,0,1,1.23,1.54c.82,1.27,1.18,2.39.77,3.12-.25.46-.63.34-1.51-.15a23.77,23.77,0,0,1-4.6-3.73c-1-1.07-1.44-3-2.4-3.25a10.18,10.18,0,0,0,4.72,6.27.42.42,0,0,1,.15.59.46.46,0,0,1-.6.14,12.82,12.82,0,0,1-3.4-3.21,12.76,12.76,0,0,1-1.65-3.61.38.38,0,0,0-.51-.32c-.2.11.36,2.52,1.54,4.24a12.56,12.56,0,0,0,3.43,3.47.41.41,0,0,1,.06.59.47.47,0,0,1-.62.08,14.64,14.64,0,0,1-3.43-3.54,9.58,9.58,0,0,1-1.46-3.14c-.57.11-.12,1.65.93,3.27a16.44,16.44,0,0,0,3.27,3.61.41.41,0,0,1,.07.61.46.46,0,0,1-.62.08,17.34,17.34,0,0,1-3.36-3.82,5.39,5.39,0,0,0,.83,2.19,9.92,9.92,0,0,0,2.11,1.92c.76.59,1.82,1.7,2.89,2.48a13.69,13.69,0,0,0,2.48,1.4,16.73,16.73,0,0,1,3.9,2.75l.59.51a.42.42,0,0,1,0,.61.43.43,0,0,1-.61,0l-.59-.5a16.19,16.19,0,0,0-3.67-2.63,12.28,12.28,0,0,1-2.86-1.65c-1.26-1.07-2.37-2.08-3-2.57a7.42,7.42,0,0,1-2.06-2c-.2-.34-1.47-2.81-.66-3.59-.69-1.4-.86-2.26-.66-2.86a.91.91,0,0,1,.74-.66c-.23-.82-.17-1.36.24-1.63a1,1,0,0,1,1.2.12A1.37,1.37,0,0,1,23,19c1,1,1.35,2.25,2.18,3.2a23.68,23.68,0,0,0,3.49,3c.41.3,1.17.78,1.22.57.12-.47-.58-1.68-.8-2a13.47,13.47,0,0,0-1.13-1.35,6.34,6.34,0,0,1-.63-.78c-.5-.8-.46-1.34-.1-1.71s1.18-.15,2,.66a7.59,7.59,0,0,1,.8.89,13.11,13.11,0,0,0,1,1.14,14.71,14.71,0,0,1,2.36,3.49,9.46,9.46,0,0,1,.79,3.23,3.84,3.84,0,0,0,.28,1.33Z"/><path class="cls-2" d="M33.06,36.8a.53.53,0,0,1-.36-.13l-.59-.51-.45-.38a13.52,13.52,0,0,0-3.19-2.22,12.58,12.58,0,0,1-2.89-1.67L24.2,30.7c-.66-.58-1.23-1.08-1.62-1.38a7.4,7.4,0,0,1-2.1-2s-1.51-2.69-.7-3.67c-.65-1.34-.84-2.23-.63-2.88a1,1,0,0,1,.71-.71c-.21-.83-.1-1.36.33-1.64a1.11,1.11,0,0,1,1.29.07,1.51,1.51,0,0,1,1.58.43,7.74,7.74,0,0,1,1.26,1.8,8.19,8.19,0,0,0,.93,1.41,22.81,22.81,0,0,0,3.46,3,4.14,4.14,0,0,0,1,.59A4.31,4.31,0,0,0,29,23.82a14.64,14.64,0,0,0-1.12-1.33l-.11-.12a6.93,6.93,0,0,1-.54-.68c-.49-.79-.52-1.42-.08-1.87a.82.82,0,0,1,.59-.22,2.45,2.45,0,0,1,1.55.88,8,8,0,0,1,.81.9c.25.33.58.72,1,1.14A14.6,14.6,0,0,1,33.41,26a9.56,9.56,0,0,1,.8,3.23v0a3.66,3.66,0,0,0,.26,1.29l.06.09a12.18,12.18,0,0,0,2.86,1.85.54.54,0,0,1,.22.2.59.59,0,0,1,0,.55.57.57,0,0,1-.76.25l0,0a20,20,0,0,1-3-2,.91.91,0,0,1-.26-.29,3.56,3.56,0,0,1-.39-1.55v0a9.51,9.51,0,0,0-.78-3.15A14,14,0,0,0,30,23.05c-.39-.42-.73-.81-1-1.15A3.92,3.92,0,0,0,28,20.82a3.61,3.61,0,0,0,.67.92,12.28,12.28,0,0,1,1.25,1.55c.92,1.43,1.18,2.53.76,3.25a.61.61,0,0,1-.36.33c-.3.09-.67-.08-1.31-.43a23.53,23.53,0,0,1-4.63-3.76,7.76,7.76,0,0,1-1-1.55,4.4,4.4,0,0,0-1.12-1.55,10,10,0,0,0,4.6,5.93.56.56,0,0,1,.19.76.6.6,0,0,1-.77.19,12.89,12.89,0,0,1-3.45-3.25,13.21,13.21,0,0,1-1.66-3.65.31.31,0,0,0-.17-.24.2.2,0,0,0-.13,0,9.33,9.33,0,0,0,1.55,4.07,12.31,12.31,0,0,0,3.4,3.43.51.51,0,0,1,.21.38.54.54,0,0,1-.12.4.6.6,0,0,1-.79.1,14.86,14.86,0,0,1-3.47-3.57,10.11,10.11,0,0,1-1.43-3v0c-.15.36.19,1.53,1.13,3a16.25,16.25,0,0,0,3.24,3.59.53.53,0,0,1,.09.78.58.58,0,0,1-.8.09,17.74,17.74,0,0,1-3.08-3.37,6.74,6.74,0,0,0,.74,1.58,10.19,10.19,0,0,0,2.08,1.89c.31.25.68.58,1.07.94a22.89,22.89,0,0,0,1.81,1.54,13.33,13.33,0,0,0,2.46,1.38A15.13,15.13,0,0,1,32.52,35l.9.77a.53.53,0,0,1,.2.38.52.52,0,0,1-.13.41.57.57,0,0,1-.37.2ZM20.78,18.48a.84.84,0,0,0-.46.13c-.35.23-.41.7-.19,1.49l0,.13-.14,0a.77.77,0,0,0-.64.57c-.2.59,0,1.47.65,2.76l0,.08-.06.07c-.7.68.37,2.92.68,3.44a7.32,7.32,0,0,0,2,1.94c.39.3,1,.81,1.63,1.39l1.38,1.19a12,12,0,0,0,2.83,1.63,13.62,13.62,0,0,1,3.25,2.26l.45.38.59.51a.32.32,0,0,0,.23.07.31.31,0,0,0,.21-.11.33.33,0,0,0,.07-.23.28.28,0,0,0-.11-.21l-.9-.77a14.75,14.75,0,0,0-3.56-2.47,13.64,13.64,0,0,1-2.51-1.41,23.11,23.11,0,0,1-1.83-1.56c-.39-.35-.75-.68-1.05-.92a9.61,9.61,0,0,1-2.14-2,5.39,5.39,0,0,1-.86-2.26l0-.4.22.34A17,17,0,0,0,24,28.38a.33.33,0,0,0,.44-.06.27.27,0,0,0-.05-.43,16.26,16.26,0,0,1-3.29-3.64c-.9-1.38-1.37-2.7-1.15-3.22a.42.42,0,0,1,.3-.25l.12,0,0,.12A9.38,9.38,0,0,0,21.81,24a14.77,14.77,0,0,0,3.4,3.49.34.34,0,0,0,.45-.05.32.32,0,0,0,.08-.22.31.31,0,0,0-.11-.19,12.82,12.82,0,0,1-3.47-3.5,9.17,9.17,0,0,1-1.58-4.28.24.24,0,0,1,.09-.14.44.44,0,0,1,.39,0,.61.61,0,0,1,.31.4A12.61,12.61,0,0,0,23,23.07a12.52,12.52,0,0,0,3.36,3.17.34.34,0,0,0,.44-.1.3.3,0,0,0-.12-.42,10.27,10.27,0,0,1-4.77-6.33l-.06-.22.21.06c.63.19,1.05,1,1.49,1.78a9.09,9.09,0,0,0,1,1.51,23.72,23.72,0,0,0,4.57,3.7c.54.3.92.48,1.12.41a.4.4,0,0,0,.22-.21c.36-.63.1-1.66-.76-3a11.69,11.69,0,0,0-1.22-1.52c-.39-.43-.83-1-.75-1.23a.2.2,0,0,1,.15-.13c.31-.05.94.61,1.39,1.19.25.33.6.73,1,1.14a14.21,14.21,0,0,1,2.42,3.5,9.51,9.51,0,0,1,.8,3.23v0a3.5,3.5,0,0,0,.35,1.44,1.1,1.1,0,0,0,.2.23,21.78,21.78,0,0,0,3,2l0,0a.33.33,0,0,0,.42-.14.37.37,0,0,0,0-.31.43.43,0,0,0-.12-.11,11.4,11.4,0,0,1-3-1.94h0l-.06-.09a3.69,3.69,0,0,1-.3-1.39v0a9.36,9.36,0,0,0-.77-3.14,14,14,0,0,0-2.35-3.45c-.38-.42-.72-.82-1-1.15a6.87,6.87,0,0,0-.78-.88,2.28,2.28,0,0,0-1.39-.81h0a.53.53,0,0,0-.39.15c-.35.36-.32.86.11,1.56a6.14,6.14,0,0,0,.52.65l.1.11a11.74,11.74,0,0,1,1.14,1.36c.13.18,1,1.53.82,2.1a.2.2,0,0,1-.12.12c-.25.1-1-.41-1.3-.63a23.29,23.29,0,0,1-3.5-3,8.8,8.8,0,0,1-1-1.44,7.38,7.38,0,0,0-1.22-1.75,1.25,1.25,0,0,0-1.38-.35l-.07,0-.06-.05A.85.85,0,0,0,20.78,18.48Zm9,7.23h0Z"/></g></g></svg>'
    };
    return (a, o) => (P(), Ie(Pi, {
      type: L(t) >= L(F).tabletBreakpoint ? "right" : "bottom",
      state: L(Fe).drawers.details,
      title: L(n).title,
      height: L(t) > L(F).mobileBreakpoint ? "fit-content" : void 0,
      onClose: o[0] || (o[0] = (l) => L(Fe).drawers.details = "closed")
    }, {
      default: Xe(() => [
        w("div", w3, [
          w("div", L3, [
            w("p", I3, ie(L(n).description_header), 1),
            w("div", C3, [
              sn(ie(L(F).productView.product?.description) + " ", 1),
              L(F).productView.product?.locMetafield?.value ? (P(), N("p", R3, "Ref. " + ie(L(F).productView.product?.locMetafield?.value), 1)) : U("", !0),
              L(F).productView.product?.modelSizeMetafield ? (P(), N("div", P3, [
                w("p", D3, ie(L(n).size_and_cut), 1),
                L(F).productView.product?.modelSizeMetafield ? (P(), N("p", N3, ie(L(F).productView.product?.modelSizeMetafield?.value), 1)) : U("", !0),
                L(F).productView.product?.cutMetafield ? (P(), N("p", M3, ie(L(F).productView.product?.cutMetafield?.value), 1)) : U("", !0)
              ])) : U("", !0)
            ])
          ]),
          w("div", O3, [
            w("p", F3, ie(L(n).care_header), 1),
            L(F).productView.product?.compositionMetafield ? (P(), N("p", $3, ie(L(F).productView.product?.compositionMetafield?.value), 1)) : U("", !0),
            w("div", B3, [
              L(F).productView.product?.careIconsMetafield?.value ? (P(!0), N(ve, { key: 0 }, pt(s.value, (l, d) => (P(), N("div", { key: d }, [
                w("div", U3, [
                  w("div", {
                    class: "icon-care__wrapper--svg",
                    innerHTML: r[l]
                  }, null, 8, V3),
                  w("p", {
                    class: "icon-care__wrapper--text",
                    innerHTML: L(n).icons[l]
                  }, null, 8, G3)
                ])
              ]))), 128)) : U("", !0)
            ]),
            w("p", H3, ie(L(F).productView.product?.careInfoMetafield?.value), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["type", "state", "title", "height"]));
  }
}), K3 = ".drawer-details-content[data-v-6ab1b739]{margin-top:2rem}.drawer-details-content__description[data-v-6ab1b739]{margin-bottom:2.4rem;border-bottom:.1rem solid #E5E5E5;padding-bottom:1rem}.drawer-details-content__description--header[data-v-6ab1b739],.drawer-details-content__care--header[data-v-6ab1b739]{margin-bottom:1.6rem;font-family:var(--font-body-family);font-size:1.2rem;line-height:1rem;letter-spacing:.1rem;text-transform:uppercase;color:#000}.drawer-details-content__description--content p[data-v-6ab1b739]:not(.drawer-sizes-content__guide--header){font-family:var(--font-body-family);font-size:1.4rem;line-height:2rem;color:#666;margin:1.5rem 0}.drawer-details-content__metafields[data-v-6ab1b739]{max-height:43vh;overflow-y:scroll}.drawer-details-content__metafields[data-v-6ab1b739]::-webkit-scrollbar{height:.2rem;width:.2rem}.drawer-details-content__metafields[data-v-6ab1b739]::-webkit-scrollbar-track{background:none}.drawer-details-content__metafields[data-v-6ab1b739]::-webkit-scrollbar-thumb{background-color:#000;border-radius:5rem}.drawer-sizes-content__guide[data-v-6ab1b739]{margin-top:3rem;border-top:.1rem solid #E5E5E5}.drawer-sizes-content__guide--preview__header[data-v-6ab1b739]{margin-top:18px;font-size:1.2rem;line-height:1.8rem;color:#000}@media screen and (max-width: 749px){.drawer-sizes-content__guide[data-v-6ab1b739]{margin-top:2rem}}.drawer-sizes-content__guide--header[data-v-6ab1b739]{margin:2.3rem 0 1.6rem;font-family:var(--font-body-family);font-weight:400;font-size:1.2rem;line-height:1rem;text-transform:uppercase;letter-spacing:.1rem;color:#000}.drawer-sizes-content__guide--content[data-v-6ab1b739]{font-family:var(--font-body-family);font-size:1.4rem;line-height:2rem;color:#666}.icon-care__wrapper[data-v-6ab1b739]{display:flex;align-items:center;gap:1.6rem}.icon-care__wrapper--text[data-v-6ab1b739]{font-family:var(--font-body-family);font-size:1.4rem;line-height:2rem;color:#666;margin:1.5rem 0}.icon-care__wrapper--svg[data-v-6ab1b739]{width:4rem;min-width:4rem;display:flex;align-items:center}.icon-care__wrapper--svg.svg-clean[data-v-6ab1b739]{align-self:center}", j3 = /* @__PURE__ */ Pe(z3, [["styles", [K3]], ["__scopeId", "data-v-6ab1b739"]]);
if (yn.name === "product") {
  const { initializeNavigation: i } = fa();
  i(), await Zf();
  const e = /* @__PURE__ */ jn(u2);
  customElements.define("poloclub-product-view", e);
}
const W3 = /* @__PURE__ */ jn(P2), q3 = /* @__PURE__ */ jn(D2), Y3 = /* @__PURE__ */ jn(Gw), X3 = /* @__PURE__ */ jn(A3), Z3 = /* @__PURE__ */ jn(j3);
customElements.define("poloclub-product-slider", W3);
customElements.define("poloclub-main-wishlist", q3);
customElements.define("poloclub-slider", Y3);
customElements.define("poloclub-product-look", X3);
customElements.define("poloclub-drawer-details", Z3);
